export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /** The day, does not include a time. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>;
};

export interface ActIdMembership {
  __typename?: 'ActIdMembership';
  userId_: Scalars['String'];
  groupId_: Scalars['String'];
}

export interface ActiveCounselingsForCounselor {
  __typename?: 'ActiveCounselingsForCounselor';
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['BigInt']>;
}

/**
 * A condition to be used against `ActiveCounselingsForCounselor` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface ActiveCounselingsForCounselorCondition {
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `count` field. */
  count?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `ActiveCounselingsForCounselor` object types. All fields are combined with a logical ‘and.’ */
export interface ActiveCounselingsForCounselorFilter {
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `count` field. */
  count?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ActiveCounselingsForCounselorFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ActiveCounselingsForCounselorFilter>>;
  /** Negates the expression. */
  not?: Maybe<ActiveCounselingsForCounselorFilter>;
}

/** A connection to a list of `ActiveCounselingsForCounselor` values. */
export interface ActiveCounselingsForCounselorsConnection {
  __typename?: 'ActiveCounselingsForCounselorsConnection';
  /** A list of `ActiveCounselingsForCounselor` objects. */
  nodes: Array<ActiveCounselingsForCounselor>;
  /** A list of edges which contains the `ActiveCounselingsForCounselor` and cursor to aid in pagination. */
  edges: Array<ActiveCounselingsForCounselorsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveCounselingsForCounselor` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ActiveCounselingsForCounselor` edge in the connection. */
export interface ActiveCounselingsForCounselorsEdge {
  __typename?: 'ActiveCounselingsForCounselorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ActiveCounselingsForCounselor` at the end of the edge. */
  node: ActiveCounselingsForCounselor;
}

/** Methods to use when ordering `ActiveCounselingsForCounselor`. */
export enum ActiveCounselingsForCounselorsOrderBy {
  Natural = 'NATURAL',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CountAsc = 'COUNT_ASC',
  CountDesc = 'COUNT_DESC'
}

export interface ActiveTherapiesForTherapist {
  __typename?: 'ActiveTherapiesForTherapist';
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['BigInt']>;
  treatments?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `ActiveTherapiesForTherapist` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface ActiveTherapiesForTherapistCondition {
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `count` field. */
  count?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `treatments` field. */
  treatments?: Maybe<Scalars['String']>;
}

/** A filter to be used against `ActiveTherapiesForTherapist` object types. All fields are combined with a logical ‘and.’ */
export interface ActiveTherapiesForTherapistFilter {
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `count` field. */
  count?: Maybe<BigIntFilter>;
  /** Filter by the object’s `treatments` field. */
  treatments?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ActiveTherapiesForTherapistFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ActiveTherapiesForTherapistFilter>>;
  /** Negates the expression. */
  not?: Maybe<ActiveTherapiesForTherapistFilter>;
}

/** A connection to a list of `ActiveTherapiesForTherapist` values. */
export interface ActiveTherapiesForTherapistsConnection {
  __typename?: 'ActiveTherapiesForTherapistsConnection';
  /** A list of `ActiveTherapiesForTherapist` objects. */
  nodes: Array<ActiveTherapiesForTherapist>;
  /** A list of edges which contains the `ActiveTherapiesForTherapist` and cursor to aid in pagination. */
  edges: Array<ActiveTherapiesForTherapistsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveTherapiesForTherapist` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ActiveTherapiesForTherapist` edge in the connection. */
export interface ActiveTherapiesForTherapistsEdge {
  __typename?: 'ActiveTherapiesForTherapistsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ActiveTherapiesForTherapist` at the end of the edge. */
  node: ActiveTherapiesForTherapist;
}

/** Methods to use when ordering `ActiveTherapiesForTherapist`. */
export enum ActiveTherapiesForTherapistsOrderBy {
  Natural = 'NATURAL',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CountAsc = 'COUNT_ASC',
  CountDesc = 'COUNT_DESC',
  TreatmentsAsc = 'TREATMENTS_ASC',
  TreatmentsDesc = 'TREATMENTS_DESC'
}

export interface ActiveUser {
  __typename?: 'ActiveUser';
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedPassword?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  accesspathKind?: Maybe<Scalars['String']>;
  accesspathDetail?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
}

/**
 * A condition to be used against `ActiveUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface ActiveUserCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `systemRole` field. */
  systemRole?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unlockToken` field. */
  unlockToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `lockedAt` field. */
  lockedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `accesspathKind` field. */
  accesspathKind?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `accesspathDetail` field. */
  accesspathDetail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `confirmTrialInformation` field. */
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmPrivacyStatement` field. */
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmVoluntaryParticipation` field. */
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmOptionalSurveys` field. */
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmDiverseOptions` field. */
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmPersonalEmail` field. */
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmLegalAge` field. */
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmNoOtherConcurrentTreatment` field. */
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmNoFinancialCompensation` field. */
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmContactViaPhoneAndEmail` field. */
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmProcessingOfInformation` field. */
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `consentTrialInformation` field. */
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentPrivacyStatement` field. */
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentVoluntaryParticipation` field. */
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentOptionalSurveys` field. */
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentDiverseOptions` field. */
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentPersonalEmail` field. */
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentLegalAge` field. */
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentNoOtherConcurrentTreatment` field. */
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentNoFinancialCompensation` field. */
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentContactViaPhoneAndEmail` field. */
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentProcessingOfInformation` field. */
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excluded` field. */
  excluded?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSupporterAccount` field. */
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTesterAccount` field. */
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isCoordinatorAccount` field. */
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastLogin` field. */
  lastLogin?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<Scalars['Int']>;
}

/** A filter to be used against `ActiveUser` object types. All fields are combined with a logical ‘and.’ */
export interface ActiveUserFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<StringFilter>;
  /** Filter by the object’s `systemRole` field. */
  systemRole?: Maybe<StringFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<BooleanFilter>;
  /** Filter by the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<StringFilter>;
  /** Filter by the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<StringFilter>;
  /** Filter by the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<StringFilter>;
  /** Filter by the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<IntFilter>;
  /** Filter by the object’s `unlockToken` field. */
  unlockToken?: Maybe<StringFilter>;
  /** Filter by the object’s `lockedAt` field. */
  lockedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `accesspathKind` field. */
  accesspathKind?: Maybe<StringFilter>;
  /** Filter by the object’s `accesspathDetail` field. */
  accesspathDetail?: Maybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `confirmTrialInformation` field. */
  confirmTrialInformation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmPrivacyStatement` field. */
  confirmPrivacyStatement?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmVoluntaryParticipation` field. */
  confirmVoluntaryParticipation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmOptionalSurveys` field. */
  confirmOptionalSurveys?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmDiverseOptions` field. */
  confirmDiverseOptions?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmPersonalEmail` field. */
  confirmPersonalEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmLegalAge` field. */
  confirmLegalAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmNoOtherConcurrentTreatment` field. */
  confirmNoOtherConcurrentTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmNoFinancialCompensation` field. */
  confirmNoFinancialCompensation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmContactViaPhoneAndEmail` field. */
  confirmContactViaPhoneAndEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmProcessingOfInformation` field. */
  confirmProcessingOfInformation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `consentTrialInformation` field. */
  consentTrialInformation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentPrivacyStatement` field. */
  consentPrivacyStatement?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentVoluntaryParticipation` field. */
  consentVoluntaryParticipation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentOptionalSurveys` field. */
  consentOptionalSurveys?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentDiverseOptions` field. */
  consentDiverseOptions?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentPersonalEmail` field. */
  consentPersonalEmail?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentLegalAge` field. */
  consentLegalAge?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentNoOtherConcurrentTreatment` field. */
  consentNoOtherConcurrentTreatment?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentNoFinancialCompensation` field. */
  consentNoFinancialCompensation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentContactViaPhoneAndEmail` field. */
  consentContactViaPhoneAndEmail?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentProcessingOfInformation` field. */
  consentProcessingOfInformation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excluded` field. */
  excluded?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSupporterAccount` field. */
  isSupporterAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isTesterAccount` field. */
  isTesterAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: Maybe<StringFilter>;
  /** Filter by the object’s `isCoordinatorAccount` field. */
  isCoordinatorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ActiveUserFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ActiveUserFilter>>;
  /** Negates the expression. */
  not?: Maybe<ActiveUserFilter>;
}

/** An input for mutations affecting `ActiveUser` */
export interface ActiveUserInput {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedPassword?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  accesspathKind?: Maybe<Scalars['String']>;
  accesspathDetail?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
}

/** A connection to a list of `ActiveUser` values. */
export interface ActiveUsersConnection {
  __typename?: 'ActiveUsersConnection';
  /** A list of `ActiveUser` objects. */
  nodes: Array<ActiveUser>;
  /** A list of edges which contains the `ActiveUser` and cursor to aid in pagination. */
  edges: Array<ActiveUsersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveUser` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ActiveUser` edge in the connection. */
export interface ActiveUsersEdge {
  __typename?: 'ActiveUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ActiveUser` at the end of the edge. */
  node: ActiveUser;
}

/** Methods to use when ordering `ActiveUser`. */
export enum ActiveUsersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  SystemRoleAsc = 'SYSTEM_ROLE_ASC',
  SystemRoleDesc = 'SYSTEM_ROLE_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  AutoGeneratedSystemRoleAsc = 'AUTO_GENERATED_SYSTEM_ROLE_ASC',
  AutoGeneratedSystemRoleDesc = 'AUTO_GENERATED_SYSTEM_ROLE_DESC',
  ResetPasswordTokenAsc = 'RESET_PASSWORD_TOKEN_ASC',
  ResetPasswordTokenDesc = 'RESET_PASSWORD_TOKEN_DESC',
  ResetPasswordSentAtAsc = 'RESET_PASSWORD_SENT_AT_ASC',
  ResetPasswordSentAtDesc = 'RESET_PASSWORD_SENT_AT_DESC',
  ConfirmationTokenAsc = 'CONFIRMATION_TOKEN_ASC',
  ConfirmationTokenDesc = 'CONFIRMATION_TOKEN_DESC',
  ConfirmedAtAsc = 'CONFIRMED_AT_ASC',
  ConfirmedAtDesc = 'CONFIRMED_AT_DESC',
  ConfirmationSentAtAsc = 'CONFIRMATION_SENT_AT_ASC',
  ConfirmationSentAtDesc = 'CONFIRMATION_SENT_AT_DESC',
  UnconfirmedEmailAsc = 'UNCONFIRMED_EMAIL_ASC',
  UnconfirmedEmailDesc = 'UNCONFIRMED_EMAIL_DESC',
  FailedAttemptsAsc = 'FAILED_ATTEMPTS_ASC',
  FailedAttemptsDesc = 'FAILED_ATTEMPTS_DESC',
  UnlockTokenAsc = 'UNLOCK_TOKEN_ASC',
  UnlockTokenDesc = 'UNLOCK_TOKEN_DESC',
  LockedAtAsc = 'LOCKED_AT_ASC',
  LockedAtDesc = 'LOCKED_AT_DESC',
  IsPatientAccountAsc = 'IS_PATIENT_ACCOUNT_ASC',
  IsPatientAccountDesc = 'IS_PATIENT_ACCOUNT_DESC',
  IsTherapistAccountAsc = 'IS_THERAPIST_ACCOUNT_ASC',
  IsTherapistAccountDesc = 'IS_THERAPIST_ACCOUNT_DESC',
  IsSupervisorAccountAsc = 'IS_SUPERVISOR_ACCOUNT_ASC',
  IsSupervisorAccountDesc = 'IS_SUPERVISOR_ACCOUNT_DESC',
  IsInterviewerAccountAsc = 'IS_INTERVIEWER_ACCOUNT_ASC',
  IsInterviewerAccountDesc = 'IS_INTERVIEWER_ACCOUNT_DESC',
  AgreedToAntiSuicideContractAtAsc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_ASC',
  AgreedToAntiSuicideContractAtDesc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_DESC',
  AccesspathKindAsc = 'ACCESSPATH_KIND_ASC',
  AccesspathKindDesc = 'ACCESSPATH_KIND_DESC',
  AccesspathDetailAsc = 'ACCESSPATH_DETAIL_ASC',
  AccesspathDetailDesc = 'ACCESSPATH_DETAIL_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  ConfirmTrialInformationAsc = 'CONFIRM_TRIAL_INFORMATION_ASC',
  ConfirmTrialInformationDesc = 'CONFIRM_TRIAL_INFORMATION_DESC',
  ConfirmPrivacyStatementAsc = 'CONFIRM_PRIVACY_STATEMENT_ASC',
  ConfirmPrivacyStatementDesc = 'CONFIRM_PRIVACY_STATEMENT_DESC',
  ConfirmVoluntaryParticipationAsc = 'CONFIRM_VOLUNTARY_PARTICIPATION_ASC',
  ConfirmVoluntaryParticipationDesc = 'CONFIRM_VOLUNTARY_PARTICIPATION_DESC',
  ConfirmOptionalSurveysAsc = 'CONFIRM_OPTIONAL_SURVEYS_ASC',
  ConfirmOptionalSurveysDesc = 'CONFIRM_OPTIONAL_SURVEYS_DESC',
  ConfirmDiverseOptionsAsc = 'CONFIRM_DIVERSE_OPTIONS_ASC',
  ConfirmDiverseOptionsDesc = 'CONFIRM_DIVERSE_OPTIONS_DESC',
  ConfirmPersonalEmailAsc = 'CONFIRM_PERSONAL_EMAIL_ASC',
  ConfirmPersonalEmailDesc = 'CONFIRM_PERSONAL_EMAIL_DESC',
  ConfirmLegalAgeAsc = 'CONFIRM_LEGAL_AGE_ASC',
  ConfirmLegalAgeDesc = 'CONFIRM_LEGAL_AGE_DESC',
  ConfirmNoOtherConcurrentTreatmentAsc = 'CONFIRM_NO_OTHER_CONCURRENT_TREATMENT_ASC',
  ConfirmNoOtherConcurrentTreatmentDesc = 'CONFIRM_NO_OTHER_CONCURRENT_TREATMENT_DESC',
  ConfirmNoFinancialCompensationAsc = 'CONFIRM_NO_FINANCIAL_COMPENSATION_ASC',
  ConfirmNoFinancialCompensationDesc = 'CONFIRM_NO_FINANCIAL_COMPENSATION_DESC',
  ConfirmContactViaPhoneAndEmailAsc = 'CONFIRM_CONTACT_VIA_PHONE_AND_EMAIL_ASC',
  ConfirmContactViaPhoneAndEmailDesc = 'CONFIRM_CONTACT_VIA_PHONE_AND_EMAIL_DESC',
  ConfirmProcessingOfInformationAsc = 'CONFIRM_PROCESSING_OF_INFORMATION_ASC',
  ConfirmProcessingOfInformationDesc = 'CONFIRM_PROCESSING_OF_INFORMATION_DESC',
  ConsentTrialInformationAsc = 'CONSENT_TRIAL_INFORMATION_ASC',
  ConsentTrialInformationDesc = 'CONSENT_TRIAL_INFORMATION_DESC',
  ConsentPrivacyStatementAsc = 'CONSENT_PRIVACY_STATEMENT_ASC',
  ConsentPrivacyStatementDesc = 'CONSENT_PRIVACY_STATEMENT_DESC',
  ConsentVoluntaryParticipationAsc = 'CONSENT_VOLUNTARY_PARTICIPATION_ASC',
  ConsentVoluntaryParticipationDesc = 'CONSENT_VOLUNTARY_PARTICIPATION_DESC',
  ConsentOptionalSurveysAsc = 'CONSENT_OPTIONAL_SURVEYS_ASC',
  ConsentOptionalSurveysDesc = 'CONSENT_OPTIONAL_SURVEYS_DESC',
  ConsentDiverseOptionsAsc = 'CONSENT_DIVERSE_OPTIONS_ASC',
  ConsentDiverseOptionsDesc = 'CONSENT_DIVERSE_OPTIONS_DESC',
  ConsentPersonalEmailAsc = 'CONSENT_PERSONAL_EMAIL_ASC',
  ConsentPersonalEmailDesc = 'CONSENT_PERSONAL_EMAIL_DESC',
  ConsentLegalAgeAsc = 'CONSENT_LEGAL_AGE_ASC',
  ConsentLegalAgeDesc = 'CONSENT_LEGAL_AGE_DESC',
  ConsentNoOtherConcurrentTreatmentAsc = 'CONSENT_NO_OTHER_CONCURRENT_TREATMENT_ASC',
  ConsentNoOtherConcurrentTreatmentDesc = 'CONSENT_NO_OTHER_CONCURRENT_TREATMENT_DESC',
  ConsentNoFinancialCompensationAsc = 'CONSENT_NO_FINANCIAL_COMPENSATION_ASC',
  ConsentNoFinancialCompensationDesc = 'CONSENT_NO_FINANCIAL_COMPENSATION_DESC',
  ConsentContactViaPhoneAndEmailAsc = 'CONSENT_CONTACT_VIA_PHONE_AND_EMAIL_ASC',
  ConsentContactViaPhoneAndEmailDesc = 'CONSENT_CONTACT_VIA_PHONE_AND_EMAIL_DESC',
  ConsentProcessingOfInformationAsc = 'CONSENT_PROCESSING_OF_INFORMATION_ASC',
  ConsentProcessingOfInformationDesc = 'CONSENT_PROCESSING_OF_INFORMATION_DESC',
  ExcludedForLackOfEmailAsc = 'EXCLUDED_FOR_LACK_OF_EMAIL_ASC',
  ExcludedForLackOfEmailDesc = 'EXCLUDED_FOR_LACK_OF_EMAIL_DESC',
  ExcludedForLackOfInternetAccessAsc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_ASC',
  ExcludedForLackOfInternetAccessDesc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_DESC',
  ExcludedForMinorAgeAsc = 'EXCLUDED_FOR_MINOR_AGE_ASC',
  ExcludedForMinorAgeDesc = 'EXCLUDED_FOR_MINOR_AGE_DESC',
  ExcludedForUpcomingTreatmentAsc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_ASC',
  ExcludedForUpcomingTreatmentDesc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_DESC',
  ExcludedForBdiGte_45Asc = 'EXCLUDED_FOR_BDI_GTE_45_ASC',
  ExcludedForBdiGte_45Desc = 'EXCLUDED_FOR_BDI_GTE_45_DESC',
  ExcludedForNoTraumaOrBdiLte_13Asc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_ASC',
  ExcludedForNoTraumaOrBdiLte_13Desc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_DESC',
  ExcludedAsc = 'EXCLUDED_ASC',
  ExcludedDesc = 'EXCLUDED_DESC',
  ExcludedForMissingInterviewAsc = 'EXCLUDED_FOR_MISSING_INTERVIEW_ASC',
  ExcludedForMissingInterviewDesc = 'EXCLUDED_FOR_MISSING_INTERVIEW_DESC',
  ExcludedDuringInterviewAsc = 'EXCLUDED_DURING_INTERVIEW_ASC',
  ExcludedDuringInterviewDesc = 'EXCLUDED_DURING_INTERVIEW_DESC',
  IsSupporterAccountAsc = 'IS_SUPPORTER_ACCOUNT_ASC',
  IsSupporterAccountDesc = 'IS_SUPPORTER_ACCOUNT_DESC',
  IsTesterAccountAsc = 'IS_TESTER_ACCOUNT_ASC',
  IsTesterAccountDesc = 'IS_TESTER_ACCOUNT_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IsCoordinatorAccountAsc = 'IS_COORDINATOR_ACCOUNT_ASC',
  IsCoordinatorAccountDesc = 'IS_COORDINATOR_ACCOUNT_DESC',
  LastLoginAsc = 'LAST_LOGIN_ASC',
  LastLoginDesc = 'LAST_LOGIN_DESC',
  NrOfLoginsAsc = 'NR_OF_LOGINS_ASC',
  NrOfLoginsDesc = 'NR_OF_LOGINS_DESC'
}

export interface AdoptibleInterviewOffer {
  __typename?: 'AdoptibleInterviewOffer';
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRange>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `AdoptibleInterviewOffer` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface AdoptibleInterviewOfferCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `externalLink` field. */
  externalLink?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `AdoptibleInterviewOffer` object types. All fields are combined with a logical ‘and.’ */
export interface AdoptibleInterviewOfferFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `externalLink` field. */
  externalLink?: Maybe<StringFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AdoptibleInterviewOfferFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AdoptibleInterviewOfferFilter>>;
  /** Negates the expression. */
  not?: Maybe<AdoptibleInterviewOfferFilter>;
}

/** A connection to a list of `AdoptibleInterviewOffer` values. */
export interface AdoptibleInterviewOffersConnection {
  __typename?: 'AdoptibleInterviewOffersConnection';
  /** A list of `AdoptibleInterviewOffer` objects. */
  nodes: Array<AdoptibleInterviewOffer>;
  /** A list of edges which contains the `AdoptibleInterviewOffer` and cursor to aid in pagination. */
  edges: Array<AdoptibleInterviewOffersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdoptibleInterviewOffer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AdoptibleInterviewOffer` edge in the connection. */
export interface AdoptibleInterviewOffersEdge {
  __typename?: 'AdoptibleInterviewOffersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AdoptibleInterviewOffer` at the end of the edge. */
  node: AdoptibleInterviewOffer;
}

/** Methods to use when ordering `AdoptibleInterviewOffer`. */
export enum AdoptibleInterviewOffersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  ExternalLinkAsc = 'EXTERNAL_LINK_ASC',
  ExternalLinkDesc = 'EXTERNAL_LINK_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `adopt` mutation. */
export interface AdoptInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  offer: InterviewOfferInput;
}

/** All input for the `adoptInterviewOfferById` mutation. */
export interface AdoptInterviewOfferByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our `adoptInterviewOfferById` mutation. */
export interface AdoptInterviewOfferByIdPayload {
  __typename?: 'AdoptInterviewOfferByIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<AdoptInterviewOfferByIdRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `adoptInterviewOfferById` mutation. */
export interface AdoptInterviewOfferByIdRecord {
  __typename?: 'AdoptInterviewOfferByIdRecord';
  oldOffer?: Maybe<InterviewOffer>;
  offer?: Maybe<InterviewOffer>;
  affectedBooking?: Maybe<InterviewBooking>;
  newInterviewersInvolvement?: Maybe<Involvement>;
}

/** The output of our `adopt` mutation. */
export interface AdoptPayload {
  __typename?: 'AdoptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  updatedOffer?: Maybe<InterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `InterviewOffer`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `Interviewer` that is related to this `InterviewOffer`. */
  interviewerByInterviewerId?: Maybe<Interviewer>;
  /** An edge for our `InterviewOffer`. May be used by Relay 1. */
  interviewOfferEdge?: Maybe<InterviewOffersEdge>;
}


/** The output of our `adopt` mutation. */
export type AdoptPayloadInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
};

export interface AllLetter {
  __typename?: 'AllLetter';
  id?: Maybe<Scalars['UUID']>;
  senderId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  format?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `AllLetter` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface AllLetterCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `body` field. */
  body?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `format` field. */
  format?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `diagnosis` field. */
  diagnosis?: Maybe<Scalars['String']>;
}

/** A filter to be used against `AllLetter` object types. All fields are combined with a logical ‘and.’ */
export interface AllLetterFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `senderId` field. */
  senderId?: Maybe<UuidFilter>;
  /** Filter by the object’s `code` field. */
  code?: Maybe<StringFilter>;
  /** Filter by the object’s `body` field. */
  body?: Maybe<StringFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `format` field. */
  format?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `diagnosis` field. */
  diagnosis?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AllLetterFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AllLetterFilter>>;
  /** Negates the expression. */
  not?: Maybe<AllLetterFilter>;
}

/** A connection to a list of `AllLetter` values. */
export interface AllLettersConnection {
  __typename?: 'AllLettersConnection';
  /** A list of `AllLetter` objects. */
  nodes: Array<AllLetter>;
  /** A list of edges which contains the `AllLetter` and cursor to aid in pagination. */
  edges: Array<AllLettersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllLetter` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AllLetter` edge in the connection. */
export interface AllLettersEdge {
  __typename?: 'AllLettersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllLetter` at the end of the edge. */
  node: AllLetter;
}

/** Methods to use when ordering `AllLetter`. */
export enum AllLettersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  SenderIdAsc = 'SENDER_ID_ASC',
  SenderIdDesc = 'SENDER_ID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FormatAsc = 'FORMAT_ASC',
  FormatDesc = 'FORMAT_DESC',
  PatientAcceptedForCounselingAsc = 'PATIENT_ACCEPTED_FOR_COUNSELING_ASC',
  PatientAcceptedForCounselingDesc = 'PATIENT_ACCEPTED_FOR_COUNSELING_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  DiagnosisAsc = 'DIAGNOSIS_ASC',
  DiagnosisDesc = 'DIAGNOSIS_DESC'
}

export interface AllTaskStat {
  __typename?: 'AllTaskStat';
  countOfOpen?: Maybe<Scalars['BigInt']>;
  latestCreated?: Maybe<Scalars['Datetime']>;
  latestDue?: Maybe<Scalars['Datetime']>;
  countOfOverdue?: Maybe<Scalars['BigInt']>;
  groupId_?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  shortId?: Maybe<Scalars['BigInt']>;
}

/**
 * A condition to be used against `AllTaskStat` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface AllTaskStatCondition {
  /** Checks for equality with the object’s `countOfOpen` field. */
  countOfOpen?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `latestCreated` field. */
  latestCreated?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `latestDue` field. */
  latestDue?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `groupId_` field. */
  groupId_?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `AllTaskStat` object types. All fields are combined with a logical ‘and.’ */
export interface AllTaskStatFilter {
  /** Filter by the object’s `countOfOpen` field. */
  countOfOpen?: Maybe<BigIntFilter>;
  /** Filter by the object’s `latestCreated` field. */
  latestCreated?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `latestDue` field. */
  latestDue?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<BigIntFilter>;
  /** Filter by the object’s `groupId_` field. */
  groupId_?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AllTaskStatFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AllTaskStatFilter>>;
  /** Negates the expression. */
  not?: Maybe<AllTaskStatFilter>;
}

/** A connection to a list of `AllTaskStat` values. */
export interface AllTaskStatsConnection {
  __typename?: 'AllTaskStatsConnection';
  /** A list of `AllTaskStat` objects. */
  nodes: Array<AllTaskStat>;
  /** A list of edges which contains the `AllTaskStat` and cursor to aid in pagination. */
  edges: Array<AllTaskStatsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllTaskStat` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AllTaskStat` edge in the connection. */
export interface AllTaskStatsEdge {
  __typename?: 'AllTaskStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllTaskStat` at the end of the edge. */
  node: AllTaskStat;
}

/** Methods to use when ordering `AllTaskStat`. */
export enum AllTaskStatsOrderBy {
  Natural = 'NATURAL',
  CountOfOpenAsc = 'COUNT_OF_OPEN_ASC',
  CountOfOpenDesc = 'COUNT_OF_OPEN_DESC',
  LatestCreatedAsc = 'LATEST_CREATED_ASC',
  LatestCreatedDesc = 'LATEST_CREATED_DESC',
  LatestDueAsc = 'LATEST_DUE_ASC',
  LatestDueDesc = 'LATEST_DUE_DESC',
  CountOfOverdueAsc = 'COUNT_OF_OVERDUE_ASC',
  CountOfOverdueDesc = 'COUNT_OF_OVERDUE_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC'
}

export interface AvailableInterviewDate {
  __typename?: 'AvailableInterviewDate';
  id?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRange>;
  gender?: Maybe<Gender>;
}

/**
 * A condition to be used against `AvailableInterviewDate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface AvailableInterviewDateCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
}

/** A filter to be used against `AvailableInterviewDate` object types. All fields are combined with a logical ‘and.’ */
export interface AvailableInterviewDateFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AvailableInterviewDateFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AvailableInterviewDateFilter>>;
  /** Negates the expression. */
  not?: Maybe<AvailableInterviewDateFilter>;
}

/** A connection to a list of `AvailableInterviewDate` values. */
export interface AvailableInterviewDatesConnection {
  __typename?: 'AvailableInterviewDatesConnection';
  /** A list of `AvailableInterviewDate` objects. */
  nodes: Array<AvailableInterviewDate>;
  /** A list of edges which contains the `AvailableInterviewDate` and cursor to aid in pagination. */
  edges: Array<AvailableInterviewDatesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AvailableInterviewDate` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AvailableInterviewDate` edge in the connection. */
export interface AvailableInterviewDatesEdge {
  __typename?: 'AvailableInterviewDatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AvailableInterviewDate` at the end of the edge. */
  node: AvailableInterviewDate;
}

/** Methods to use when ordering `AvailableInterviewDate`. */
export enum AvailableInterviewDatesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC'
}

export interface AvailableInterviewOffer {
  __typename?: 'AvailableInterviewOffer';
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRange>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  isPost?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `AvailableInterviewOffer` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface AvailableInterviewOfferCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `externalLink` field. */
  externalLink?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `isPost` field. */
  isPost?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `AvailableInterviewOffer` object types. All fields are combined with a logical ‘and.’ */
export interface AvailableInterviewOfferFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `externalLink` field. */
  externalLink?: Maybe<StringFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `isPost` field. */
  isPost?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AvailableInterviewOfferFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AvailableInterviewOfferFilter>>;
  /** Negates the expression. */
  not?: Maybe<AvailableInterviewOfferFilter>;
}

/** An input for mutations affecting `AvailableInterviewOffer` */
export interface AvailableInterviewOfferInput {
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRangeInput>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  isPost?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `AvailableInterviewOffer` values. */
export interface AvailableInterviewOffersConnection {
  __typename?: 'AvailableInterviewOffersConnection';
  /** A list of `AvailableInterviewOffer` objects. */
  nodes: Array<AvailableInterviewOffer>;
  /** A list of edges which contains the `AvailableInterviewOffer` and cursor to aid in pagination. */
  edges: Array<AvailableInterviewOffersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AvailableInterviewOffer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `AvailableInterviewOffer` edge in the connection. */
export interface AvailableInterviewOffersEdge {
  __typename?: 'AvailableInterviewOffersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AvailableInterviewOffer` at the end of the edge. */
  node: AvailableInterviewOffer;
}

/** Methods to use when ordering `AvailableInterviewOffer`. */
export enum AvailableInterviewOffersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  ExternalLinkAsc = 'EXTERNAL_LINK_ASC',
  ExternalLinkDesc = 'EXTERNAL_LINK_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IsPostAsc = 'IS_POST_ASC',
  IsPostDesc = 'IS_POST_DESC'
}

export interface Bdi2 extends Node {
  __typename?: 'Bdi2';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  itemA: Scalars['Int'];
  itemB: Scalars['Int'];
  itemC: Scalars['Int'];
  itemD: Scalars['Int'];
  itemE: Scalars['Int'];
  itemF: Scalars['Int'];
  itemG: Scalars['Int'];
  itemH: Scalars['Int'];
  itemI: Scalars['Int'];
  itemJ: Scalars['Int'];
  itemK: Scalars['Int'];
  itemL: Scalars['Int'];
  itemM: Scalars['Int'];
  itemN: Scalars['Int'];
  itemO: Scalars['Int'];
  itemP: Scalars['Int'];
  itemQ: Scalars['Int'];
  itemR: Scalars['Int'];
  itemS: Scalars['Int'];
  itemT: Scalars['Int'];
  itemU: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Bdi2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Bdi2`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Bdi2` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Bdi2Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `itemA` field. */
  itemA?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemB` field. */
  itemB?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC` field. */
  itemC?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemD` field. */
  itemD?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemE` field. */
  itemE?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemF` field. */
  itemF?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemG` field. */
  itemG?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemH` field. */
  itemH?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemI` field. */
  itemI?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemJ` field. */
  itemJ?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemK` field. */
  itemK?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemL` field. */
  itemL?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemM` field. */
  itemM?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemN` field. */
  itemN?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemO` field. */
  itemO?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP` field. */
  itemP?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemQ` field. */
  itemQ?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemR` field. */
  itemR?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemS` field. */
  itemS?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemT` field. */
  itemT?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemU` field. */
  itemU?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Bdi2` object types. All fields are combined with a logical ‘and.’ */
export interface Bdi2Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `itemA` field. */
  itemA?: Maybe<IntFilter>;
  /** Filter by the object’s `itemB` field. */
  itemB?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC` field. */
  itemC?: Maybe<IntFilter>;
  /** Filter by the object’s `itemD` field. */
  itemD?: Maybe<IntFilter>;
  /** Filter by the object’s `itemE` field. */
  itemE?: Maybe<IntFilter>;
  /** Filter by the object’s `itemF` field. */
  itemF?: Maybe<IntFilter>;
  /** Filter by the object’s `itemG` field. */
  itemG?: Maybe<IntFilter>;
  /** Filter by the object’s `itemH` field. */
  itemH?: Maybe<IntFilter>;
  /** Filter by the object’s `itemI` field. */
  itemI?: Maybe<IntFilter>;
  /** Filter by the object’s `itemJ` field. */
  itemJ?: Maybe<IntFilter>;
  /** Filter by the object’s `itemK` field. */
  itemK?: Maybe<IntFilter>;
  /** Filter by the object’s `itemL` field. */
  itemL?: Maybe<IntFilter>;
  /** Filter by the object’s `itemM` field. */
  itemM?: Maybe<IntFilter>;
  /** Filter by the object’s `itemN` field. */
  itemN?: Maybe<IntFilter>;
  /** Filter by the object’s `itemO` field. */
  itemO?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP` field. */
  itemP?: Maybe<IntFilter>;
  /** Filter by the object’s `itemQ` field. */
  itemQ?: Maybe<IntFilter>;
  /** Filter by the object’s `itemR` field. */
  itemR?: Maybe<IntFilter>;
  /** Filter by the object’s `itemS` field. */
  itemS?: Maybe<IntFilter>;
  /** Filter by the object’s `itemT` field. */
  itemT?: Maybe<IntFilter>;
  /** Filter by the object’s `itemU` field. */
  itemU?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Bdi2Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Bdi2Filter>>;
  /** Negates the expression. */
  not?: Maybe<Bdi2Filter>;
}

/** An input for mutations affecting `Bdi2` */
export interface Bdi2Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  itemA: Scalars['Int'];
  itemB: Scalars['Int'];
  itemC: Scalars['Int'];
  itemD: Scalars['Int'];
  itemE: Scalars['Int'];
  itemF: Scalars['Int'];
  itemG: Scalars['Int'];
  itemH: Scalars['Int'];
  itemI: Scalars['Int'];
  itemJ: Scalars['Int'];
  itemK: Scalars['Int'];
  itemL: Scalars['Int'];
  itemM: Scalars['Int'];
  itemN: Scalars['Int'];
  itemO: Scalars['Int'];
  itemP: Scalars['Int'];
  itemQ: Scalars['Int'];
  itemR: Scalars['Int'];
  itemS: Scalars['Int'];
  itemT: Scalars['Int'];
  itemU: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Bdi2`. Fields that are set will be updated. */
export interface Bdi2Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  itemA?: Maybe<Scalars['Int']>;
  itemB?: Maybe<Scalars['Int']>;
  itemC?: Maybe<Scalars['Int']>;
  itemD?: Maybe<Scalars['Int']>;
  itemE?: Maybe<Scalars['Int']>;
  itemF?: Maybe<Scalars['Int']>;
  itemG?: Maybe<Scalars['Int']>;
  itemH?: Maybe<Scalars['Int']>;
  itemI?: Maybe<Scalars['Int']>;
  itemJ?: Maybe<Scalars['Int']>;
  itemK?: Maybe<Scalars['Int']>;
  itemL?: Maybe<Scalars['Int']>;
  itemM?: Maybe<Scalars['Int']>;
  itemN?: Maybe<Scalars['Int']>;
  itemO?: Maybe<Scalars['Int']>;
  itemP?: Maybe<Scalars['Int']>;
  itemQ?: Maybe<Scalars['Int']>;
  itemR?: Maybe<Scalars['Int']>;
  itemS?: Maybe<Scalars['Int']>;
  itemT?: Maybe<Scalars['Int']>;
  itemU?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Bdi2` values. */
export interface Bdi2SConnection {
  __typename?: 'Bdi2SConnection';
  /** A list of `Bdi2` objects. */
  nodes: Array<Bdi2>;
  /** A list of edges which contains the `Bdi2` and cursor to aid in pagination. */
  edges: Array<Bdi2SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Bdi2` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Bdi2` edge in the connection. */
export interface Bdi2SEdge {
  __typename?: 'Bdi2SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Bdi2` at the end of the edge. */
  node: Bdi2;
}

/** Methods to use when ordering `Bdi2`. */
export enum Bdi2SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  ItemAAsc = 'ITEM_A_ASC',
  ItemADesc = 'ITEM_A_DESC',
  ItemBAsc = 'ITEM_B_ASC',
  ItemBDesc = 'ITEM_B_DESC',
  ItemCAsc = 'ITEM_C_ASC',
  ItemCDesc = 'ITEM_C_DESC',
  ItemDAsc = 'ITEM_D_ASC',
  ItemDDesc = 'ITEM_D_DESC',
  ItemEAsc = 'ITEM_E_ASC',
  ItemEDesc = 'ITEM_E_DESC',
  ItemFAsc = 'ITEM_F_ASC',
  ItemFDesc = 'ITEM_F_DESC',
  ItemGAsc = 'ITEM_G_ASC',
  ItemGDesc = 'ITEM_G_DESC',
  ItemHAsc = 'ITEM_H_ASC',
  ItemHDesc = 'ITEM_H_DESC',
  ItemIAsc = 'ITEM_I_ASC',
  ItemIDesc = 'ITEM_I_DESC',
  ItemJAsc = 'ITEM_J_ASC',
  ItemJDesc = 'ITEM_J_DESC',
  ItemKAsc = 'ITEM_K_ASC',
  ItemKDesc = 'ITEM_K_DESC',
  ItemLAsc = 'ITEM_L_ASC',
  ItemLDesc = 'ITEM_L_DESC',
  ItemMAsc = 'ITEM_M_ASC',
  ItemMDesc = 'ITEM_M_DESC',
  ItemNAsc = 'ITEM_N_ASC',
  ItemNDesc = 'ITEM_N_DESC',
  ItemOAsc = 'ITEM_O_ASC',
  ItemODesc = 'ITEM_O_DESC',
  ItemPAsc = 'ITEM_P_ASC',
  ItemPDesc = 'ITEM_P_DESC',
  ItemQAsc = 'ITEM_Q_ASC',
  ItemQDesc = 'ITEM_Q_DESC',
  ItemRAsc = 'ITEM_R_ASC',
  ItemRDesc = 'ITEM_R_DESC',
  ItemSAsc = 'ITEM_S_ASC',
  ItemSDesc = 'ITEM_S_DESC',
  ItemTAsc = 'ITEM_T_ASC',
  ItemTDesc = 'ITEM_T_DESC',
  ItemUAsc = 'ITEM_U_ASC',
  ItemUDesc = 'ITEM_U_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}


/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export interface BigFloatFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['BigFloat']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['BigFloat']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['BigFloat']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['BigFloat']>;
}


/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export interface BigIntFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['BigInt']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['BigInt']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['BigInt']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['BigInt']>;
}

export interface BookedInterviewOffer {
  __typename?: 'BookedInterviewOffer';
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRange>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `BookedInterviewOffer` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface BookedInterviewOfferCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `externalLink` field. */
  externalLink?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `BookedInterviewOffer` object types. All fields are combined with a logical ‘and.’ */
export interface BookedInterviewOfferFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `externalLink` field. */
  externalLink?: Maybe<StringFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<BookedInterviewOfferFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<BookedInterviewOfferFilter>>;
  /** Negates the expression. */
  not?: Maybe<BookedInterviewOfferFilter>;
}

/** An input for mutations affecting `BookedInterviewOffer` */
export interface BookedInterviewOfferInput {
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRangeInput>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `BookedInterviewOffer` values. */
export interface BookedInterviewOffersConnection {
  __typename?: 'BookedInterviewOffersConnection';
  /** A list of `BookedInterviewOffer` objects. */
  nodes: Array<BookedInterviewOffer>;
  /** A list of edges which contains the `BookedInterviewOffer` and cursor to aid in pagination. */
  edges: Array<BookedInterviewOffersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BookedInterviewOffer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `BookedInterviewOffer` edge in the connection. */
export interface BookedInterviewOffersEdge {
  __typename?: 'BookedInterviewOffersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BookedInterviewOffer` at the end of the edge. */
  node: BookedInterviewOffer;
}

/** Methods to use when ordering `BookedInterviewOffer`. */
export enum BookedInterviewOffersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  ExternalLinkAsc = 'EXTERNAL_LINK_ASC',
  ExternalLinkDesc = 'EXTERNAL_LINK_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `book` mutation. */
export interface BookInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  offer: InterviewOfferInput;
  case_: CaseInput;
}

/** All input for the `bookInterview` mutation. */
export interface BookInterviewInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  offerId: Scalars['UUID'];
  caseId: Scalars['UUID'];
}

/** The output of our `bookInterview` mutation. */
export interface BookInterviewPayload {
  __typename?: 'BookInterviewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<BookInterviewRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `bookInterview` mutation. */
export interface BookInterviewRecord {
  __typename?: 'BookInterviewRecord';
  offer?: Maybe<InterviewOffer>;
  case_?: Maybe<Case>;
  booking?: Maybe<InterviewBooking>;
}

/** The output of our `book` mutation. */
export interface BookPayload {
  __typename?: 'BookPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  booking?: Maybe<InterviewBooking>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `InterviewBooking`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Involvement` that is related to this `InterviewBooking`. */
  involvementByCaseIdAndIntervieweeId?: Maybe<Involvement>;
  /** Reads a single `User` that is related to this `InterviewBooking`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewBooking`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `Interviewee` that is related to this `InterviewBooking`. */
  intervieweeByIntervieweeId?: Maybe<Interviewee>;
  /** An edge for our `InterviewBooking`. May be used by Relay 1. */
  interviewBookingEdge?: Maybe<InterviewBookingsEdge>;
}


/** The output of our `book` mutation. */
export type BookPayloadInterviewBookingEdgeArgs = {
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export interface BooleanFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Boolean']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['Boolean']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['Boolean']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['Boolean']>;
}

/** All input for the `cancelInterviewBookingById` mutation. */
export interface CancelInterviewBookingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our `cancelInterviewBookingById` mutation. */
export interface CancelInterviewBookingByIdPayload {
  __typename?: 'CancelInterviewBookingByIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<CancelInterviewBookingByIdRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `cancelInterviewBookingById` mutation. */
export interface CancelInterviewBookingByIdRecord {
  __typename?: 'CancelInterviewBookingByIdRecord';
  oldBooking?: Maybe<InterviewBooking>;
  booking?: Maybe<InterviewBooking>;
}

/** All input for the `cancelInterviewOfferById` mutation. */
export interface CancelInterviewOfferByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our `cancelInterviewOfferById` mutation. */
export interface CancelInterviewOfferByIdPayload {
  __typename?: 'CancelInterviewOfferByIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<CancelInterviewOfferByIdRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `cancelInterviewOfferById` mutation. */
export interface CancelInterviewOfferByIdRecord {
  __typename?: 'CancelInterviewOfferByIdRecord';
  oldOffer?: Maybe<InterviewOffer>;
  offer?: Maybe<InterviewOffer>;
}

export interface Case extends Node {
  __typename?: 'Case';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  diagnosis?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  isDropout: Scalars['Boolean'];
  askForPostIfDroppedOut: Scalars['Boolean'];
  stage?: Maybe<Scalars['String']>;
  excludeFromAnalysis?: Maybe<Scalars['Boolean']>;
  reasonForDropout?: Maybe<Scalars['String']>;
  reasonForExclusion?: Maybe<Scalars['String']>;
  shortId: Scalars['BigInt'];
  /** Reads a single `MyInvolvement` that is related to this `Case`. */
  myInvolvementById?: Maybe<MyInvolvement>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  interviewBookingsByCaseId: InterviewBookingsConnection;
  /** Reads and enables pagination through a set of `Involvement`. */
  involvementsByCaseId: InvolvementsConnection;
  /** Reads and enables pagination through a set of `CaseMessage`. */
  caseMessagesByCaseId: CaseMessagesConnection;
  /** Reads and enables pagination through a set of `Bdi2`. */
  bdi2SByCaseId: Bdi2SConnection;
  /** Reads and enables pagination through a set of `Eurohi`. */
  eurohisByCaseId: EurohisConnection;
  /** Reads and enables pagination through a set of `Gad2`. */
  gad2SByCaseId: Gad2SConnection;
  /** Reads and enables pagination through a set of `Gad7`. */
  gad7SByCaseId: Gad7SConnection;
  /** Reads and enables pagination through a set of `Inep`. */
  inepsByCaseId: InepsConnection;
  /** Reads and enables pagination through a set of `InterviewReport`. */
  interviewReportsByCaseId: InterviewReportsConnection;
  /** Reads and enables pagination through a set of `Lsa`. */
  lsasByCaseId: LsasConnection;
  /** Reads and enables pagination through a set of `Mspss`. */
  mspssesByCaseId: MspssesConnection;
  /** Reads and enables pagination through a set of `Pathev`. */
  pathevsByCaseId: PathevsConnection;
  /** Reads and enables pagination through a set of `Pcl5`. */
  pcl5SByCaseId: Pcl5SConnection;
  /** Reads and enables pagination through a set of `Phq15`. */
  phq15SByCaseId: Phq15SConnection;
  /** Reads and enables pagination through a set of `Phq9`. */
  phq9SByCaseId: Phq9SConnection;
  /** Reads and enables pagination through a set of `Pmb`. */
  pmbsByCaseId: PmbsConnection;
  /** Reads and enables pagination through a set of `Sewip`. */
  sewipsByCaseId: SewipsConnection;
  /** Reads and enables pagination through a set of `Taq`. */
  taqsByCaseId: TaqsConnection;
  /** Reads and enables pagination through a set of `Traumaliste`. */
  traumalistesByCaseId: TraumalistesConnection;
  /** Reads and enables pagination through a set of `Trgi`. */
  trgisByCaseId: TrgisConnection;
  /** Reads and enables pagination through a set of `Wai`. */
  waisByCaseId: WaisConnection;
  /** Reads and enables pagination through a set of `RandomizationTicket`. */
  randomizationTicketsByCaseId: RandomizationTicketsConnection;
  /** Reads and enables pagination through a set of `CbtActivity`. */
  cbtActivitiesByCaseId: CbtActivitiesConnection;
  /** Reads and enables pagination through a set of `CbtReframing`. */
  cbtReframingsByCaseId: CbtReframingsConnection;
  /** Reads and enables pagination through a set of `CbtThought`. */
  cbtThoughtsByCaseId: CbtThoughtsConnection;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsByCaseId: CommentsConnection;
  /** Reads and enables pagination through a set of `Demographic`. */
  demographicsByCaseId: DemographicsConnection;
  /** Reads and enables pagination through a set of `Disclosure`. */
  disclosuresByCaseId: DisclosuresConnection;
  /** Reads and enables pagination through a set of `Evaluation`. */
  evaluationsByCaseId: EvaluationsConnection;
  /** Reads and enables pagination through a set of `IptConflict`. */
  iptConflictsByCaseId: IptConflictsConnection;
  /** Reads and enables pagination through a set of `IptRelationship`. */
  iptRelationshipsByCaseId: IptRelationshipsConnection;
  /** Reads and enables pagination through a set of `IptSituation`. */
  iptSituationsByCaseId: IptSituationsConnection;
  /** Reads and enables pagination through a set of `Lec5`. */
  lec5SByCaseId: Lec5SConnection;
  /** Reads and enables pagination through a set of `Letter`. */
  lettersByCaseId: LettersConnection;
  /** Reads and enables pagination through a set of `Pg13`. */
  pg13SByCaseId: Pg13SConnection;
  /** Reads and enables pagination through a set of `CaseSuicideCall`. */
  caseSuicideCallsByCaseId: CaseSuicideCallsConnection;
  /** Reads and enables pagination through a set of `Scaling`. */
  scalingsByCaseId: ScalingsConnection;
  /** Reads and enables pagination through a set of `Sib`. */
  sibsByCaseId: SibsConnection;
  /** Reads and enables pagination through a set of `SuicideNote`. */
  suicideNotesByCaseId: SuicideNotesConnection;
  /** Reads and enables pagination through a set of `SuicideNote`. */
  suicideNotesByUserIdCreator: SuicideNotesConnection;
  /** Reads and enables pagination through a set of `Sbqr`. */
  sbqrsByCaseId: SbqrsConnection;
  /** Reads and enables pagination through a set of `Cdrisk10`. */
  cdrisk10SByCaseId: Cdrisk10SConnection;
  /** Reads and enables pagination through a set of `Traumalisteneu`. */
  traumalisteneusByCaseId: TraumalisteneusConnection;
  /** Reads and enables pagination through a set of `Itq`. */
  itqsByCaseId: ItqsConnection;
  /** Reads and enables pagination through a set of `Tgisrplus`. */
  tgisrplusesByCaseId: TgisrplusesConnection;
  /** Reads and enables pagination through a set of `Phq4`. */
  phq4SByCaseId: Phq4SConnection;
  /** Reads and enables pagination through a set of `CounselingQuestion`. */
  counselingQuestionsByCaseId: CounselingQuestionsConnection;
  /** Reads and enables pagination through a set of `ProcessingQueue`. */
  processingQueuesByCaseId: ProcessingQueuesConnection;
  /** Reads and enables pagination through a set of `CaseMember`. */
  caseMembersByCaseId: CaseMembersConnection;
  /** Reads and enables pagination through a set of `DueCandidateLink`. */
  dueCandidateLinksByCaseId: DueCandidateLinksConnection;
  /** Reads and enables pagination through a set of `DueTask`. */
  dueTasksByCaseId: DueTasksConnection;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  interviewCalendarsByCaseId: InterviewCalendarsConnection;
  /** Reads and enables pagination through a set of `MyDate`. */
  myDatesByCaseId: MyDatesConnection;
  /** Reads and enables pagination through a set of `MyHistoricIdentitylink`. */
  myHistoricIdentitylinksByCaseId: MyHistoricIdentitylinksConnection;
  /** Reads and enables pagination through a set of `MyTaskLog`. */
  myTaskLogsByCaseId: MyTaskLogsConnection;
  dueTaskStats?: Maybe<CasesDueTaskStatsRecord>;
  latestMessage?: Maybe<Scalars['Datetime']>;
  matches?: Maybe<Scalars['Float']>;
  me?: Maybe<CaseMember>;
  newMessages?: Maybe<Scalars['BigInt']>;
  newMessagesForMe?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `CaseMember`. */
  others: CaseMembersConnection;
  patient?: Maybe<CaseMember>;
}


export type CaseInterviewBookingsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};


export type CaseInvolvementsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
  condition?: Maybe<InvolvementCondition>;
  filter?: Maybe<InvolvementFilter>;
};


export type CaseCaseMessagesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
  condition?: Maybe<CaseMessageCondition>;
  filter?: Maybe<CaseMessageFilter>;
};


export type CaseBdi2SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
  condition?: Maybe<Bdi2Condition>;
  filter?: Maybe<Bdi2Filter>;
};


export type CaseEurohisByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EurohisOrderBy>>;
  condition?: Maybe<EurohiCondition>;
  filter?: Maybe<EurohiFilter>;
};


export type CaseGad2SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
  condition?: Maybe<Gad2Condition>;
  filter?: Maybe<Gad2Filter>;
};


export type CaseGad7SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
  condition?: Maybe<Gad7Condition>;
  filter?: Maybe<Gad7Filter>;
};


export type CaseInepsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InepsOrderBy>>;
  condition?: Maybe<InepCondition>;
  filter?: Maybe<InepFilter>;
};


export type CaseInterviewReportsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
  condition?: Maybe<InterviewReportCondition>;
  filter?: Maybe<InterviewReportFilter>;
};


export type CaseLsasByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LsasOrderBy>>;
  condition?: Maybe<LsaCondition>;
  filter?: Maybe<LsaFilter>;
};


export type CaseMspssesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MspssesOrderBy>>;
  condition?: Maybe<MspssCondition>;
  filter?: Maybe<MspssFilter>;
};


export type CasePathevsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PathevsOrderBy>>;
  condition?: Maybe<PathevCondition>;
  filter?: Maybe<PathevFilter>;
};


export type CasePcl5SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
  condition?: Maybe<Pcl5Condition>;
  filter?: Maybe<Pcl5Filter>;
};


export type CasePhq15SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
  condition?: Maybe<Phq15Condition>;
  filter?: Maybe<Phq15Filter>;
};


export type CasePhq9SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
  condition?: Maybe<Phq9Condition>;
  filter?: Maybe<Phq9Filter>;
};


export type CasePmbsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PmbsOrderBy>>;
  condition?: Maybe<PmbCondition>;
  filter?: Maybe<PmbFilter>;
};


export type CaseSewipsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SewipsOrderBy>>;
  condition?: Maybe<SewipCondition>;
  filter?: Maybe<SewipFilter>;
};


export type CaseTaqsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TaqsOrderBy>>;
  condition?: Maybe<TaqCondition>;
  filter?: Maybe<TaqFilter>;
};


export type CaseTraumalistesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
  condition?: Maybe<TraumalisteCondition>;
  filter?: Maybe<TraumalisteFilter>;
};


export type CaseTrgisByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TrgisOrderBy>>;
  condition?: Maybe<TrgiCondition>;
  filter?: Maybe<TrgiFilter>;
};


export type CaseWaisByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<WaisOrderBy>>;
  condition?: Maybe<WaiCondition>;
  filter?: Maybe<WaiFilter>;
};


export type CaseRandomizationTicketsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
  condition?: Maybe<RandomizationTicketCondition>;
  filter?: Maybe<RandomizationTicketFilter>;
};


export type CaseCbtActivitiesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
  condition?: Maybe<CbtActivityCondition>;
  filter?: Maybe<CbtActivityFilter>;
};


export type CaseCbtReframingsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
  condition?: Maybe<CbtReframingCondition>;
  filter?: Maybe<CbtReframingFilter>;
};


export type CaseCbtThoughtsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
  condition?: Maybe<CbtThoughtCondition>;
  filter?: Maybe<CbtThoughtFilter>;
};


export type CaseCommentsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CommentsOrderBy>>;
  condition?: Maybe<CommentCondition>;
  filter?: Maybe<CommentFilter>;
};


export type CaseDemographicsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
  condition?: Maybe<DemographicCondition>;
  filter?: Maybe<DemographicFilter>;
};


export type CaseDisclosuresByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
  condition?: Maybe<DisclosureCondition>;
  filter?: Maybe<DisclosureFilter>;
};


export type CaseEvaluationsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
  condition?: Maybe<EvaluationCondition>;
  filter?: Maybe<EvaluationFilter>;
};


export type CaseIptConflictsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
  condition?: Maybe<IptConflictCondition>;
  filter?: Maybe<IptConflictFilter>;
};


export type CaseIptRelationshipsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
  condition?: Maybe<IptRelationshipCondition>;
  filter?: Maybe<IptRelationshipFilter>;
};


export type CaseIptSituationsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
  condition?: Maybe<IptSituationCondition>;
  filter?: Maybe<IptSituationFilter>;
};


export type CaseLec5SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
  condition?: Maybe<Lec5Condition>;
  filter?: Maybe<Lec5Filter>;
};


export type CaseLettersByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LettersOrderBy>>;
  condition?: Maybe<LetterCondition>;
  filter?: Maybe<LetterFilter>;
};


export type CasePg13SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
  condition?: Maybe<Pg13Condition>;
  filter?: Maybe<Pg13Filter>;
};


export type CaseCaseSuicideCallsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
  condition?: Maybe<CaseSuicideCallCondition>;
  filter?: Maybe<CaseSuicideCallFilter>;
};


export type CaseScalingsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
  condition?: Maybe<ScalingCondition>;
  filter?: Maybe<ScalingFilter>;
};


export type CaseSibsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SibsOrderBy>>;
  condition?: Maybe<SibCondition>;
  filter?: Maybe<SibFilter>;
};


export type CaseSuicideNotesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
  condition?: Maybe<SuicideNoteCondition>;
  filter?: Maybe<SuicideNoteFilter>;
};


export type CaseSuicideNotesByUserIdCreatorArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
  condition?: Maybe<SuicideNoteCondition>;
  filter?: Maybe<SuicideNoteFilter>;
};


export type CaseSbqrsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
  condition?: Maybe<SbqrCondition>;
  filter?: Maybe<SbqrFilter>;
};


export type CaseCdrisk10SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
  condition?: Maybe<Cdrisk10Condition>;
  filter?: Maybe<Cdrisk10Filter>;
};


export type CaseTraumalisteneusByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
  condition?: Maybe<TraumalisteneuCondition>;
  filter?: Maybe<TraumalisteneuFilter>;
};


export type CaseItqsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ItqsOrderBy>>;
  condition?: Maybe<ItqCondition>;
  filter?: Maybe<ItqFilter>;
};


export type CaseTgisrplusesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
  condition?: Maybe<TgisrplusCondition>;
  filter?: Maybe<TgisrplusFilter>;
};


export type CasePhq4SByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
  condition?: Maybe<Phq4Condition>;
  filter?: Maybe<Phq4Filter>;
};


export type CaseCounselingQuestionsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
  condition?: Maybe<CounselingQuestionCondition>;
  filter?: Maybe<CounselingQuestionFilter>;
};


export type CaseProcessingQueuesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ProcessingQueuesOrderBy>>;
  condition?: Maybe<ProcessingQueueCondition>;
  filter?: Maybe<ProcessingQueueFilter>;
};


export type CaseCaseMembersByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMembersOrderBy>>;
  condition?: Maybe<CaseMemberCondition>;
  filter?: Maybe<CaseMemberFilter>;
};


export type CaseDueCandidateLinksByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueCandidateLinksOrderBy>>;
  condition?: Maybe<DueCandidateLinkCondition>;
  filter?: Maybe<DueCandidateLinkFilter>;
};


export type CaseDueTasksByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueTasksOrderBy>>;
  condition?: Maybe<DueTaskCondition>;
  filter?: Maybe<DueTaskFilter>;
};


export type CaseInterviewCalendarsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};


export type CaseMyDatesByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyDatesOrderBy>>;
  condition?: Maybe<MyDateCondition>;
  filter?: Maybe<MyDateFilter>;
};


export type CaseMyHistoricIdentitylinksByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyHistoricIdentitylinksOrderBy>>;
  condition?: Maybe<MyHistoricIdentitylinkCondition>;
  filter?: Maybe<MyHistoricIdentitylinkFilter>;
};


export type CaseMyTaskLogsByCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogsOrderBy>>;
  condition?: Maybe<MyTaskLogCondition>;
  filter?: Maybe<MyTaskLogFilter>;
};


export type CaseDueTaskStatsArgs = {
  group?: Maybe<Scalars['String']>;
};


export type CaseMatchesArgs = {
  term?: Maybe<Scalars['String']>;
};


export type CaseOthersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<CaseMemberFilter>;
};

/** A condition to be used against `Case` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface CaseCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `diagnosis` field. */
  diagnosis?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `emergencyContact` field. */
  emergencyContact?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isDropout` field. */
  isDropout?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `askForPostIfDroppedOut` field. */
  askForPostIfDroppedOut?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `excludeFromAnalysis` field. */
  excludeFromAnalysis?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonForDropout` field. */
  reasonForDropout?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `reasonForExclusion` field. */
  reasonForExclusion?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `latestMessage` field. */
  latestMessage?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `newMessages` field. */
  newMessages?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `newMessagesForMe` field. */
  newMessagesForMe?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `Case` object types. All fields are combined with a logical ‘and.’ */
export interface CaseFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `diagnosis` field. */
  diagnosis?: Maybe<StringFilter>;
  /** Filter by the object’s `emergencyContact` field. */
  emergencyContact?: Maybe<StringFilter>;
  /** Filter by the object’s `isDropout` field. */
  isDropout?: Maybe<BooleanFilter>;
  /** Filter by the object’s `askForPostIfDroppedOut` field. */
  askForPostIfDroppedOut?: Maybe<BooleanFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: Maybe<StringFilter>;
  /** Filter by the object’s `excludeFromAnalysis` field. */
  excludeFromAnalysis?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonForDropout` field. */
  reasonForDropout?: Maybe<StringFilter>;
  /** Filter by the object’s `reasonForExclusion` field. */
  reasonForExclusion?: Maybe<StringFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `latestMessage` field. */
  latestMessage?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `newMessages` field. */
  newMessages?: Maybe<BigIntFilter>;
  /** Filter by the object’s `newMessagesForMe` field. */
  newMessagesForMe?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CaseFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CaseFilter>>;
  /** Negates the expression. */
  not?: Maybe<CaseFilter>;
}

/** An input for mutations affecting `Case` */
export interface CaseInput {
  id?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  diagnosis?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  isDropout?: Maybe<Scalars['Boolean']>;
  askForPostIfDroppedOut?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Scalars['String']>;
  excludeFromAnalysis?: Maybe<Scalars['Boolean']>;
  reasonForDropout?: Maybe<Scalars['String']>;
  reasonForExclusion?: Maybe<Scalars['String']>;
}

export interface CaseMember {
  __typename?: 'CaseMember';
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  alias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Gender>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Case` that is related to this `CaseMember`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseMember`. */
  userByUserId?: Maybe<User>;
  /** Reads and enables pagination through a set of `CaseMessage`. */
  caseMessagesByCaseIdAndSenderId: CaseMessagesConnection;
  /** Reads and enables pagination through a set of `DueCandidateLink`. */
  dueCandidateLinksByUserIdAndCaseId: DueCandidateLinksConnection;
  /** Reads and enables pagination through a set of `MyHistoricIdentitylink`. */
  myHistoricIdentitylinksByUserIdAndCaseId: MyHistoricIdentitylinksConnection;
}


export type CaseMemberCaseMessagesByCaseIdAndSenderIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
  condition?: Maybe<CaseMessageCondition>;
  filter?: Maybe<CaseMessageFilter>;
};


export type CaseMemberDueCandidateLinksByUserIdAndCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueCandidateLinksOrderBy>>;
  condition?: Maybe<DueCandidateLinkCondition>;
  filter?: Maybe<DueCandidateLinkFilter>;
};


export type CaseMemberMyHistoricIdentitylinksByUserIdAndCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyHistoricIdentitylinksOrderBy>>;
  condition?: Maybe<MyHistoricIdentitylinkCondition>;
  filter?: Maybe<MyHistoricIdentitylinkFilter>;
};

/**
 * A condition to be used against `CaseMember` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CaseMemberCondition {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excluded` field. */
  excluded?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastLogin` field. */
  lastLogin?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isCounselingOnly` field. */
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `registeredForCounseling` field. */
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `CaseMember` object types. All fields are combined with a logical ‘and.’ */
export interface CaseMemberFilter {
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<BooleanFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excluded` field. */
  excluded?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: Maybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isCounselingOnly` field. */
  isCounselingOnly?: Maybe<BooleanFilter>;
  /** Filter by the object’s `registeredForCounseling` field. */
  registeredForCounseling?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CaseMemberFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CaseMemberFilter>>;
  /** Negates the expression. */
  not?: Maybe<CaseMemberFilter>;
}

export interface CaseMembers2 {
  __typename?: 'CaseMembers2';
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  alias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Gender>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `CaseMembers2` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface CaseMembers2Condition {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excluded` field. */
  excluded?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastLogin` field. */
  lastLogin?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `CaseMembers2` object types. All fields are combined with a logical ‘and.’ */
export interface CaseMembers2Filter {
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<BooleanFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excluded` field. */
  excluded?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: Maybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CaseMembers2Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CaseMembers2Filter>>;
  /** Negates the expression. */
  not?: Maybe<CaseMembers2Filter>;
}

/** A connection to a list of `CaseMembers2` values. */
export interface CaseMembers2SConnection {
  __typename?: 'CaseMembers2SConnection';
  /** A list of `CaseMembers2` objects. */
  nodes: Array<CaseMembers2>;
  /** A list of edges which contains the `CaseMembers2` and cursor to aid in pagination. */
  edges: Array<CaseMembers2SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseMembers2` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CaseMembers2` edge in the connection. */
export interface CaseMembers2SEdge {
  __typename?: 'CaseMembers2SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CaseMembers2` at the end of the edge. */
  node: CaseMembers2;
}

/** Methods to use when ordering `CaseMembers2`. */
export enum CaseMembers2SOrderBy {
  Natural = 'NATURAL',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  ActsAsTherapistAsc = 'ACTS_AS_THERAPIST_ASC',
  ActsAsTherapistDesc = 'ACTS_AS_THERAPIST_DESC',
  ActsAsSupervisorAsc = 'ACTS_AS_SUPERVISOR_ASC',
  ActsAsSupervisorDesc = 'ACTS_AS_SUPERVISOR_DESC',
  ActsAsPatientAsc = 'ACTS_AS_PATIENT_ASC',
  ActsAsPatientDesc = 'ACTS_AS_PATIENT_DESC',
  ActsAsInterviewerAsc = 'ACTS_AS_INTERVIEWER_ASC',
  ActsAsInterviewerDesc = 'ACTS_AS_INTERVIEWER_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  ExcludedForLackOfEmailAsc = 'EXCLUDED_FOR_LACK_OF_EMAIL_ASC',
  ExcludedForLackOfEmailDesc = 'EXCLUDED_FOR_LACK_OF_EMAIL_DESC',
  ExcludedForLackOfInternetAccessAsc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_ASC',
  ExcludedForLackOfInternetAccessDesc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_DESC',
  ExcludedForMinorAgeAsc = 'EXCLUDED_FOR_MINOR_AGE_ASC',
  ExcludedForMinorAgeDesc = 'EXCLUDED_FOR_MINOR_AGE_DESC',
  ExcludedForUpcomingTreatmentAsc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_ASC',
  ExcludedForUpcomingTreatmentDesc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_DESC',
  ExcludedForBdiGte_45Asc = 'EXCLUDED_FOR_BDI_GTE_45_ASC',
  ExcludedForBdiGte_45Desc = 'EXCLUDED_FOR_BDI_GTE_45_DESC',
  ExcludedForNoTraumaOrBdiLte_13Asc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_ASC',
  ExcludedForNoTraumaOrBdiLte_13Desc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_DESC',
  ExcludedAsc = 'EXCLUDED_ASC',
  ExcludedDesc = 'EXCLUDED_DESC',
  ExcludedForMissingInterviewAsc = 'EXCLUDED_FOR_MISSING_INTERVIEW_ASC',
  ExcludedForMissingInterviewDesc = 'EXCLUDED_FOR_MISSING_INTERVIEW_DESC',
  ExcludedDuringInterviewAsc = 'EXCLUDED_DURING_INTERVIEW_ASC',
  ExcludedDuringInterviewDesc = 'EXCLUDED_DURING_INTERVIEW_DESC',
  ActsAsSupporterAsc = 'ACTS_AS_SUPPORTER_ASC',
  ActsAsSupporterDesc = 'ACTS_AS_SUPPORTER_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  LastLoginAsc = 'LAST_LOGIN_ASC',
  LastLoginDesc = 'LAST_LOGIN_DESC',
  NrOfLoginsAsc = 'NR_OF_LOGINS_ASC',
  NrOfLoginsDesc = 'NR_OF_LOGINS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  AgreedToAntiSuicideContractAtAsc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_ASC',
  AgreedToAntiSuicideContractAtDesc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_DESC'
}

/** A connection to a list of `CaseMember` values. */
export interface CaseMembersConnection {
  __typename?: 'CaseMembersConnection';
  /** A list of `CaseMember` objects. */
  nodes: Array<CaseMember>;
  /** A list of edges which contains the `CaseMember` and cursor to aid in pagination. */
  edges: Array<CaseMembersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseMember` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CaseMember` edge in the connection. */
export interface CaseMembersEdge {
  __typename?: 'CaseMembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CaseMember` at the end of the edge. */
  node: CaseMember;
}

/** Methods to use when ordering `CaseMember`. */
export enum CaseMembersOrderBy {
  Natural = 'NATURAL',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  ActsAsTherapistAsc = 'ACTS_AS_THERAPIST_ASC',
  ActsAsTherapistDesc = 'ACTS_AS_THERAPIST_DESC',
  ActsAsSupervisorAsc = 'ACTS_AS_SUPERVISOR_ASC',
  ActsAsSupervisorDesc = 'ACTS_AS_SUPERVISOR_DESC',
  ActsAsPatientAsc = 'ACTS_AS_PATIENT_ASC',
  ActsAsPatientDesc = 'ACTS_AS_PATIENT_DESC',
  ActsAsInterviewerAsc = 'ACTS_AS_INTERVIEWER_ASC',
  ActsAsInterviewerDesc = 'ACTS_AS_INTERVIEWER_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  ExcludedForLackOfEmailAsc = 'EXCLUDED_FOR_LACK_OF_EMAIL_ASC',
  ExcludedForLackOfEmailDesc = 'EXCLUDED_FOR_LACK_OF_EMAIL_DESC',
  ExcludedForLackOfInternetAccessAsc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_ASC',
  ExcludedForLackOfInternetAccessDesc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_DESC',
  ExcludedForMinorAgeAsc = 'EXCLUDED_FOR_MINOR_AGE_ASC',
  ExcludedForMinorAgeDesc = 'EXCLUDED_FOR_MINOR_AGE_DESC',
  ExcludedForUpcomingTreatmentAsc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_ASC',
  ExcludedForUpcomingTreatmentDesc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_DESC',
  ExcludedForBdiGte_45Asc = 'EXCLUDED_FOR_BDI_GTE_45_ASC',
  ExcludedForBdiGte_45Desc = 'EXCLUDED_FOR_BDI_GTE_45_DESC',
  ExcludedForNoTraumaOrBdiLte_13Asc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_ASC',
  ExcludedForNoTraumaOrBdiLte_13Desc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_DESC',
  ExcludedAsc = 'EXCLUDED_ASC',
  ExcludedDesc = 'EXCLUDED_DESC',
  ExcludedForMissingInterviewAsc = 'EXCLUDED_FOR_MISSING_INTERVIEW_ASC',
  ExcludedForMissingInterviewDesc = 'EXCLUDED_FOR_MISSING_INTERVIEW_DESC',
  ExcludedDuringInterviewAsc = 'EXCLUDED_DURING_INTERVIEW_ASC',
  ExcludedDuringInterviewDesc = 'EXCLUDED_DURING_INTERVIEW_DESC',
  ActsAsSupporterAsc = 'ACTS_AS_SUPPORTER_ASC',
  ActsAsSupporterDesc = 'ACTS_AS_SUPPORTER_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  LastLoginAsc = 'LAST_LOGIN_ASC',
  LastLoginDesc = 'LAST_LOGIN_DESC',
  NrOfLoginsAsc = 'NR_OF_LOGINS_ASC',
  NrOfLoginsDesc = 'NR_OF_LOGINS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  AgreedToAntiSuicideContractAtAsc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_ASC',
  AgreedToAntiSuicideContractAtDesc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_DESC',
  ActsAsCounselorAsc = 'ACTS_AS_COUNSELOR_ASC',
  ActsAsCounselorDesc = 'ACTS_AS_COUNSELOR_DESC',
  IsCounselingOnlyAsc = 'IS_COUNSELING_ONLY_ASC',
  IsCounselingOnlyDesc = 'IS_COUNSELING_ONLY_DESC',
  RegisteredForCounselingAsc = 'REGISTERED_FOR_COUNSELING_ASC',
  RegisteredForCounselingDesc = 'REGISTERED_FOR_COUNSELING_DESC'
}

export interface CaseMessage extends Node {
  __typename?: 'CaseMessage';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  senderId?: Maybe<Scalars['UUID']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  toInterviewers: Scalars['Boolean'];
  toPatients: Scalars['Boolean'];
  toSupervisors: Scalars['Boolean'];
  toTherapists: Scalars['Boolean'];
  fromSystem: Scalars['Boolean'];
  toSupporters: Scalars['Boolean'];
  toCounselors?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Case` that is related to this `CaseMessage`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseMessage`. */
  userBySenderId?: Maybe<User>;
  /** Reads a single `CaseMember` that is related to this `CaseMessage`. */
  caseMemberByCaseIdAndSenderId?: Maybe<CaseMember>;
  isUnread?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `CaseMessage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CaseMessageCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `body` field. */
  body?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `sentAt` field. */
  sentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `toInterviewers` field. */
  toInterviewers?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `toPatients` field. */
  toPatients?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `toSupervisors` field. */
  toSupervisors?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `toTherapists` field. */
  toTherapists?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `fromSystem` field. */
  fromSystem?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `toSupporters` field. */
  toSupporters?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `toCounselors` field. */
  toCounselors?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isUnread` field. */
  isUnread?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `CaseMessage` object types. All fields are combined with a logical ‘and.’ */
export interface CaseMessageFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `senderId` field. */
  senderId?: Maybe<UuidFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: Maybe<StringFilter>;
  /** Filter by the object’s `body` field. */
  body?: Maybe<StringFilter>;
  /** Filter by the object’s `sentAt` field. */
  sentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `toInterviewers` field. */
  toInterviewers?: Maybe<BooleanFilter>;
  /** Filter by the object’s `toPatients` field. */
  toPatients?: Maybe<BooleanFilter>;
  /** Filter by the object’s `toSupervisors` field. */
  toSupervisors?: Maybe<BooleanFilter>;
  /** Filter by the object’s `toTherapists` field. */
  toTherapists?: Maybe<BooleanFilter>;
  /** Filter by the object’s `fromSystem` field. */
  fromSystem?: Maybe<BooleanFilter>;
  /** Filter by the object’s `toSupporters` field. */
  toSupporters?: Maybe<BooleanFilter>;
  /** Filter by the object’s `toCounselors` field. */
  toCounselors?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isUnread` field. */
  isUnread?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CaseMessageFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CaseMessageFilter>>;
  /** Negates the expression. */
  not?: Maybe<CaseMessageFilter>;
}

/** An input for mutations affecting `CaseMessage` */
export interface CaseMessageInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  senderId?: Maybe<Scalars['UUID']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  toInterviewers?: Maybe<Scalars['Boolean']>;
  toPatients?: Maybe<Scalars['Boolean']>;
  toSupervisors?: Maybe<Scalars['Boolean']>;
  toTherapists?: Maybe<Scalars['Boolean']>;
  fromSystem?: Maybe<Scalars['Boolean']>;
  toSupporters?: Maybe<Scalars['Boolean']>;
  toCounselors?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `CaseMessage`. Fields that are set will be updated. */
export interface CaseMessagePatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  senderId?: Maybe<Scalars['UUID']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  toInterviewers?: Maybe<Scalars['Boolean']>;
  toPatients?: Maybe<Scalars['Boolean']>;
  toSupervisors?: Maybe<Scalars['Boolean']>;
  toTherapists?: Maybe<Scalars['Boolean']>;
  fromSystem?: Maybe<Scalars['Boolean']>;
  toSupporters?: Maybe<Scalars['Boolean']>;
  toCounselors?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `CaseMessage` values. */
export interface CaseMessagesConnection {
  __typename?: 'CaseMessagesConnection';
  /** A list of `CaseMessage` objects. */
  nodes: Array<CaseMessage>;
  /** A list of edges which contains the `CaseMessage` and cursor to aid in pagination. */
  edges: Array<CaseMessagesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CaseMessage` edge in the connection. */
export interface CaseMessagesEdge {
  __typename?: 'CaseMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CaseMessage` at the end of the edge. */
  node: CaseMessage;
}

/** Methods to use when ordering `CaseMessage`. */
export enum CaseMessagesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SenderIdAsc = 'SENDER_ID_ASC',
  SenderIdDesc = 'SENDER_ID_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  SentAtAsc = 'SENT_AT_ASC',
  SentAtDesc = 'SENT_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ToInterviewersAsc = 'TO_INTERVIEWERS_ASC',
  ToInterviewersDesc = 'TO_INTERVIEWERS_DESC',
  ToPatientsAsc = 'TO_PATIENTS_ASC',
  ToPatientsDesc = 'TO_PATIENTS_DESC',
  ToSupervisorsAsc = 'TO_SUPERVISORS_ASC',
  ToSupervisorsDesc = 'TO_SUPERVISORS_DESC',
  ToTherapistsAsc = 'TO_THERAPISTS_ASC',
  ToTherapistsDesc = 'TO_THERAPISTS_DESC',
  FromSystemAsc = 'FROM_SYSTEM_ASC',
  FromSystemDesc = 'FROM_SYSTEM_DESC',
  ToSupportersAsc = 'TO_SUPPORTERS_ASC',
  ToSupportersDesc = 'TO_SUPPORTERS_DESC',
  ToCounselorsAsc = 'TO_COUNSELORS_ASC',
  ToCounselorsDesc = 'TO_COUNSELORS_DESC',
  IsUnreadAsc = 'IS_UNREAD_ASC',
  IsUnreadDesc = 'IS_UNREAD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `Case`. Fields that are set will be updated. */
export interface CasePatch {
  id?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  diagnosis?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  isDropout?: Maybe<Scalars['Boolean']>;
  askForPostIfDroppedOut?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Scalars['String']>;
  excludeFromAnalysis?: Maybe<Scalars['Boolean']>;
  reasonForDropout?: Maybe<Scalars['String']>;
  reasonForExclusion?: Maybe<Scalars['String']>;
}

/** A connection to a list of `Case` values. */
export interface CasesConnection {
  __typename?: 'CasesConnection';
  /** A list of `Case` objects. */
  nodes: Array<Case>;
  /** A list of edges which contains the `Case` and cursor to aid in pagination. */
  edges: Array<CasesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Case` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** The return type of our `dueTaskStats` query. */
export interface CasesDueTaskStatsRecord {
  __typename?: 'CasesDueTaskStatsRecord';
  countOfOpen?: Maybe<Scalars['BigInt']>;
  latestCreated?: Maybe<Scalars['Datetime']>;
  latestDue?: Maybe<Scalars['Datetime']>;
  countOfOverdue?: Maybe<Scalars['BigInt']>;
}

/** A `Case` edge in the connection. */
export interface CasesEdge {
  __typename?: 'CasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Case` at the end of the edge. */
  node: Case;
}

/** Methods to use when ordering `Case`. */
export enum CasesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  DiagnosisAsc = 'DIAGNOSIS_ASC',
  DiagnosisDesc = 'DIAGNOSIS_DESC',
  EmergencyContactAsc = 'EMERGENCY_CONTACT_ASC',
  EmergencyContactDesc = 'EMERGENCY_CONTACT_DESC',
  IsDropoutAsc = 'IS_DROPOUT_ASC',
  IsDropoutDesc = 'IS_DROPOUT_DESC',
  AskForPostIfDroppedOutAsc = 'ASK_FOR_POST_IF_DROPPED_OUT_ASC',
  AskForPostIfDroppedOutDesc = 'ASK_FOR_POST_IF_DROPPED_OUT_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  ExcludeFromAnalysisAsc = 'EXCLUDE_FROM_ANALYSIS_ASC',
  ExcludeFromAnalysisDesc = 'EXCLUDE_FROM_ANALYSIS_DESC',
  ReasonForDropoutAsc = 'REASON_FOR_DROPOUT_ASC',
  ReasonForDropoutDesc = 'REASON_FOR_DROPOUT_DESC',
  ReasonForExclusionAsc = 'REASON_FOR_EXCLUSION_ASC',
  ReasonForExclusionDesc = 'REASON_FOR_EXCLUSION_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  LatestMessageAsc = 'LATEST_MESSAGE_ASC',
  LatestMessageDesc = 'LATEST_MESSAGE_DESC',
  NewMessagesAsc = 'NEW_MESSAGES_ASC',
  NewMessagesDesc = 'NEW_MESSAGES_DESC',
  NewMessagesForMeAsc = 'NEW_MESSAGES_FOR_ME_ASC',
  NewMessagesForMeDesc = 'NEW_MESSAGES_FOR_ME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** This table is used to record suicidal calls for a case. */
export interface CaseSuicideCall extends Node {
  __typename?: 'CaseSuicideCall';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** ID of the suicidal call record. Will be set automatically */
  id: Scalars['UUID'];
  /** Case-ID for that the suicidal call record will be created */
  caseId: Scalars['UUID'];
  /** Generated timestamp, when the record was created */
  createdAt: Scalars['Datetime'];
  /** Date / Time, when the therapist / interviewer, ... initiated the suicidal call */
  callDate: Scalars['Datetime'];
  /** The suicide score of the current phq9 measurement */
  suicideScore: Scalars['BigFloat'];
  /** Flag, if the patient was reached during the phone call */
  patientReached: Scalars['Boolean'];
  /** empty, when patient not reached or any of the following: no risk, low, middle, moderate, high */
  riskOfSuicide?: Maybe<Scalars['String']>;
  /** Description of the phone-call */
  detailedDescription?: Maybe<Scalars['String']>;
  /** Flag, if the patient should get a follow up */
  followUpContact?: Maybe<Scalars['Boolean']>;
  followUpDate?: Maybe<Scalars['Datetime']>;
  /** additional description for the follow up */
  followUpDescription?: Maybe<Scalars['String']>;
  /** User-ID of the interviewer/therapist that initiated the phone call */
  userIdCaller: Scalars['UUID'];
  /** Flag, if the patient should be excluded from therapy */
  excludePatient: Scalars['Boolean'];
  /** Flag, if a coordinator should be informed */
  informCoordinator: Scalars['Boolean'];
  /** Datetime, when the coordinator was informed to initiate corresponding actions */
  coordinatorContactDate?: Maybe<Scalars['Datetime']>;
  /** User-ID of the coordinator, that was contacted */
  userIdCoordinator?: Maybe<Scalars['UUID']>;
  /** Reads a single `Case` that is related to this `CaseSuicideCall`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseSuicideCall`. */
  userByUserIdCaller?: Maybe<User>;
}

/**
 * A condition to be used against `CaseSuicideCall` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface CaseSuicideCallCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `callDate` field. */
  callDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `suicideScore` field. */
  suicideScore?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `patientReached` field. */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `riskOfSuicide` field. */
  riskOfSuicide?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `detailedDescription` field. */
  detailedDescription?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `followUpContact` field. */
  followUpContact?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `followUpDate` field. */
  followUpDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUpDescription` field. */
  followUpDescription?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `userIdCaller` field. */
  userIdCaller?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `excludePatient` field. */
  excludePatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `informCoordinator` field. */
  informCoordinator?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `coordinatorContactDate` field. */
  coordinatorContactDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userIdCoordinator` field. */
  userIdCoordinator?: Maybe<Scalars['UUID']>;
}

/** A filter to be used against `CaseSuicideCall` object types. All fields are combined with a logical ‘and.’ */
export interface CaseSuicideCallFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `callDate` field. */
  callDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `suicideScore` field. */
  suicideScore?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `patientReached` field. */
  patientReached?: Maybe<BooleanFilter>;
  /** Filter by the object’s `riskOfSuicide` field. */
  riskOfSuicide?: Maybe<StringFilter>;
  /** Filter by the object’s `detailedDescription` field. */
  detailedDescription?: Maybe<StringFilter>;
  /** Filter by the object’s `followUpContact` field. */
  followUpContact?: Maybe<BooleanFilter>;
  /** Filter by the object’s `followUpDate` field. */
  followUpDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUpDescription` field. */
  followUpDescription?: Maybe<StringFilter>;
  /** Filter by the object’s `userIdCaller` field. */
  userIdCaller?: Maybe<UuidFilter>;
  /** Filter by the object’s `excludePatient` field. */
  excludePatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `informCoordinator` field. */
  informCoordinator?: Maybe<BooleanFilter>;
  /** Filter by the object’s `coordinatorContactDate` field. */
  coordinatorContactDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `userIdCoordinator` field. */
  userIdCoordinator?: Maybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CaseSuicideCallFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CaseSuicideCallFilter>>;
  /** Negates the expression. */
  not?: Maybe<CaseSuicideCallFilter>;
}

/** An input for mutations affecting `CaseSuicideCall` */
export interface CaseSuicideCallInput {
  /** ID of the suicidal call record. Will be set automatically */
  id?: Maybe<Scalars['UUID']>;
  /** Case-ID for that the suicidal call record will be created */
  caseId: Scalars['UUID'];
  /** Generated timestamp, when the record was created */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Date / Time, when the therapist / interviewer, ... initiated the suicidal call */
  callDate: Scalars['Datetime'];
  /** The suicide score of the current phq9 measurement */
  suicideScore: Scalars['BigFloat'];
  /** Flag, if the patient was reached during the phone call */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** empty, when patient not reached or any of the following: no risk, low, middle, moderate, high */
  riskOfSuicide?: Maybe<Scalars['String']>;
  /** Description of the phone-call */
  detailedDescription?: Maybe<Scalars['String']>;
  /** Flag, if the patient should get a follow up */
  followUpContact?: Maybe<Scalars['Boolean']>;
  followUpDate?: Maybe<Scalars['Datetime']>;
  /** additional description for the follow up */
  followUpDescription?: Maybe<Scalars['String']>;
  /** User-ID of the interviewer/therapist that initiated the phone call */
  userIdCaller: Scalars['UUID'];
  /** Flag, if the patient should be excluded from therapy */
  excludePatient?: Maybe<Scalars['Boolean']>;
  /** Flag, if a coordinator should be informed */
  informCoordinator?: Maybe<Scalars['Boolean']>;
  /** Datetime, when the coordinator was informed to initiate corresponding actions */
  coordinatorContactDate?: Maybe<Scalars['Datetime']>;
  /** User-ID of the coordinator, that was contacted */
  userIdCoordinator?: Maybe<Scalars['UUID']>;
}

/** Represents an update to a `CaseSuicideCall`. Fields that are set will be updated. */
export interface CaseSuicideCallPatch {
  /** ID of the suicidal call record. Will be set automatically */
  id?: Maybe<Scalars['UUID']>;
  /** Case-ID for that the suicidal call record will be created */
  caseId?: Maybe<Scalars['UUID']>;
  /** Generated timestamp, when the record was created */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Date / Time, when the therapist / interviewer, ... initiated the suicidal call */
  callDate?: Maybe<Scalars['Datetime']>;
  /** The suicide score of the current phq9 measurement */
  suicideScore?: Maybe<Scalars['BigFloat']>;
  /** Flag, if the patient was reached during the phone call */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** empty, when patient not reached or any of the following: no risk, low, middle, moderate, high */
  riskOfSuicide?: Maybe<Scalars['String']>;
  /** Description of the phone-call */
  detailedDescription?: Maybe<Scalars['String']>;
  /** Flag, if the patient should get a follow up */
  followUpContact?: Maybe<Scalars['Boolean']>;
  followUpDate?: Maybe<Scalars['Datetime']>;
  /** additional description for the follow up */
  followUpDescription?: Maybe<Scalars['String']>;
  /** User-ID of the interviewer/therapist that initiated the phone call */
  userIdCaller?: Maybe<Scalars['UUID']>;
  /** Flag, if the patient should be excluded from therapy */
  excludePatient?: Maybe<Scalars['Boolean']>;
  /** Flag, if a coordinator should be informed */
  informCoordinator?: Maybe<Scalars['Boolean']>;
  /** Datetime, when the coordinator was informed to initiate corresponding actions */
  coordinatorContactDate?: Maybe<Scalars['Datetime']>;
  /** User-ID of the coordinator, that was contacted */
  userIdCoordinator?: Maybe<Scalars['UUID']>;
}

/** A connection to a list of `CaseSuicideCall` values. */
export interface CaseSuicideCallsConnection {
  __typename?: 'CaseSuicideCallsConnection';
  /** A list of `CaseSuicideCall` objects. */
  nodes: Array<CaseSuicideCall>;
  /** A list of edges which contains the `CaseSuicideCall` and cursor to aid in pagination. */
  edges: Array<CaseSuicideCallsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaseSuicideCall` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CaseSuicideCall` edge in the connection. */
export interface CaseSuicideCallsEdge {
  __typename?: 'CaseSuicideCallsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CaseSuicideCall` at the end of the edge. */
  node: CaseSuicideCall;
}

/** Methods to use when ordering `CaseSuicideCall`. */
export enum CaseSuicideCallsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CallDateAsc = 'CALL_DATE_ASC',
  CallDateDesc = 'CALL_DATE_DESC',
  SuicideScoreAsc = 'SUICIDE_SCORE_ASC',
  SuicideScoreDesc = 'SUICIDE_SCORE_DESC',
  PatientReachedAsc = 'PATIENT_REACHED_ASC',
  PatientReachedDesc = 'PATIENT_REACHED_DESC',
  RiskOfSuicideAsc = 'RISK_OF_SUICIDE_ASC',
  RiskOfSuicideDesc = 'RISK_OF_SUICIDE_DESC',
  DetailedDescriptionAsc = 'DETAILED_DESCRIPTION_ASC',
  DetailedDescriptionDesc = 'DETAILED_DESCRIPTION_DESC',
  FollowUpContactAsc = 'FOLLOW_UP_CONTACT_ASC',
  FollowUpContactDesc = 'FOLLOW_UP_CONTACT_DESC',
  FollowUpDateAsc = 'FOLLOW_UP_DATE_ASC',
  FollowUpDateDesc = 'FOLLOW_UP_DATE_DESC',
  FollowUpDescriptionAsc = 'FOLLOW_UP_DESCRIPTION_ASC',
  FollowUpDescriptionDesc = 'FOLLOW_UP_DESCRIPTION_DESC',
  UserIdCallerAsc = 'USER_ID_CALLER_ASC',
  UserIdCallerDesc = 'USER_ID_CALLER_DESC',
  ExcludePatientAsc = 'EXCLUDE_PATIENT_ASC',
  ExcludePatientDesc = 'EXCLUDE_PATIENT_DESC',
  InformCoordinatorAsc = 'INFORM_COORDINATOR_ASC',
  InformCoordinatorDesc = 'INFORM_COORDINATOR_DESC',
  CoordinatorContactDateAsc = 'COORDINATOR_CONTACT_DATE_ASC',
  CoordinatorContactDateDesc = 'COORDINATOR_CONTACT_DATE_DESC',
  UserIdCoordinatorAsc = 'USER_ID_COORDINATOR_ASC',
  UserIdCoordinatorDesc = 'USER_ID_COORDINATOR_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `CbtActivity` values. */
export interface CbtActivitiesConnection {
  __typename?: 'CbtActivitiesConnection';
  /** A list of `CbtActivity` objects. */
  nodes: Array<CbtActivity>;
  /** A list of edges which contains the `CbtActivity` and cursor to aid in pagination. */
  edges: Array<CbtActivitiesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CbtActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CbtActivity` edge in the connection. */
export interface CbtActivitiesEdge {
  __typename?: 'CbtActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CbtActivity` at the end of the edge. */
  node: CbtActivity;
}

/** Methods to use when ordering `CbtActivity`. */
export enum CbtActivitiesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  ActivityAsc = 'ACTIVITY_ASC',
  ActivityDesc = 'ACTIVITY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface CbtActivity extends Node {
  __typename?: 'CbtActivity';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  activity?: Maybe<Scalars['String']>;
  /** Reads a single `Case` that is related to this `CbtActivity`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtActivity`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `CbtActivity` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CbtActivityCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `activity` field. */
  activity?: Maybe<Scalars['String']>;
}

/** A filter to be used against `CbtActivity` object types. All fields are combined with a logical ‘and.’ */
export interface CbtActivityFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `activity` field. */
  activity?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CbtActivityFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CbtActivityFilter>>;
  /** Negates the expression. */
  not?: Maybe<CbtActivityFilter>;
}

/** An input for mutations affecting `CbtActivity` */
export interface CbtActivityInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  activity?: Maybe<Scalars['String']>;
}

/** Represents an update to a `CbtActivity`. Fields that are set will be updated. */
export interface CbtActivityPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  activity?: Maybe<Scalars['String']>;
}

export interface CbtReframing extends Node {
  __typename?: 'CbtReframing';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  negativeThought?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  healthyThought?: Maybe<Scalars['String']>;
  /** Reads a single `Case` that is related to this `CbtReframing`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtReframing`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `CbtReframing` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface CbtReframingCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `situation` field. */
  situation?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `negativeThought` field. */
  negativeThought?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `result` field. */
  result?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `healthyThought` field. */
  healthyThought?: Maybe<Scalars['String']>;
}

/** A filter to be used against `CbtReframing` object types. All fields are combined with a logical ‘and.’ */
export interface CbtReframingFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `situation` field. */
  situation?: Maybe<StringFilter>;
  /** Filter by the object’s `negativeThought` field. */
  negativeThought?: Maybe<StringFilter>;
  /** Filter by the object’s `result` field. */
  result?: Maybe<StringFilter>;
  /** Filter by the object’s `healthyThought` field. */
  healthyThought?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CbtReframingFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CbtReframingFilter>>;
  /** Negates the expression. */
  not?: Maybe<CbtReframingFilter>;
}

/** An input for mutations affecting `CbtReframing` */
export interface CbtReframingInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  negativeThought?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  healthyThought?: Maybe<Scalars['String']>;
}

/** Represents an update to a `CbtReframing`. Fields that are set will be updated. */
export interface CbtReframingPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  negativeThought?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  healthyThought?: Maybe<Scalars['String']>;
}

/** A connection to a list of `CbtReframing` values. */
export interface CbtReframingsConnection {
  __typename?: 'CbtReframingsConnection';
  /** A list of `CbtReframing` objects. */
  nodes: Array<CbtReframing>;
  /** A list of edges which contains the `CbtReframing` and cursor to aid in pagination. */
  edges: Array<CbtReframingsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CbtReframing` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CbtReframing` edge in the connection. */
export interface CbtReframingsEdge {
  __typename?: 'CbtReframingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CbtReframing` at the end of the edge. */
  node: CbtReframing;
}

/** Methods to use when ordering `CbtReframing`. */
export enum CbtReframingsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  SituationAsc = 'SITUATION_ASC',
  SituationDesc = 'SITUATION_DESC',
  NegativeThoughtAsc = 'NEGATIVE_THOUGHT_ASC',
  NegativeThoughtDesc = 'NEGATIVE_THOUGHT_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  HealthyThoughtAsc = 'HEALTHY_THOUGHT_ASC',
  HealthyThoughtDesc = 'HEALTHY_THOUGHT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface CbtThought extends Node {
  __typename?: 'CbtThought';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  automaticThought?: Maybe<Scalars['String']>;
  cognitiveBiases?: Maybe<Scalars['String']>;
  alternativeThought?: Maybe<Scalars['String']>;
  improvement?: Maybe<Scalars['String']>;
  /** Reads a single `Case` that is related to this `CbtThought`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtThought`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `CbtThought` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface CbtThoughtCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `situation` field. */
  situation?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `automaticThought` field. */
  automaticThought?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `cognitiveBiases` field. */
  cognitiveBiases?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alternativeThought` field. */
  alternativeThought?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `improvement` field. */
  improvement?: Maybe<Scalars['String']>;
}

/** A filter to be used against `CbtThought` object types. All fields are combined with a logical ‘and.’ */
export interface CbtThoughtFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `situation` field. */
  situation?: Maybe<StringFilter>;
  /** Filter by the object’s `automaticThought` field. */
  automaticThought?: Maybe<StringFilter>;
  /** Filter by the object’s `cognitiveBiases` field. */
  cognitiveBiases?: Maybe<StringFilter>;
  /** Filter by the object’s `alternativeThought` field. */
  alternativeThought?: Maybe<StringFilter>;
  /** Filter by the object’s `improvement` field. */
  improvement?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CbtThoughtFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CbtThoughtFilter>>;
  /** Negates the expression. */
  not?: Maybe<CbtThoughtFilter>;
}

/** An input for mutations affecting `CbtThought` */
export interface CbtThoughtInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  automaticThought?: Maybe<Scalars['String']>;
  cognitiveBiases?: Maybe<Scalars['String']>;
  alternativeThought?: Maybe<Scalars['String']>;
  improvement?: Maybe<Scalars['String']>;
}

/** Represents an update to a `CbtThought`. Fields that are set will be updated. */
export interface CbtThoughtPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  situation?: Maybe<Scalars['String']>;
  automaticThought?: Maybe<Scalars['String']>;
  cognitiveBiases?: Maybe<Scalars['String']>;
  alternativeThought?: Maybe<Scalars['String']>;
  improvement?: Maybe<Scalars['String']>;
}

/** A connection to a list of `CbtThought` values. */
export interface CbtThoughtsConnection {
  __typename?: 'CbtThoughtsConnection';
  /** A list of `CbtThought` objects. */
  nodes: Array<CbtThought>;
  /** A list of edges which contains the `CbtThought` and cursor to aid in pagination. */
  edges: Array<CbtThoughtsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CbtThought` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CbtThought` edge in the connection. */
export interface CbtThoughtsEdge {
  __typename?: 'CbtThoughtsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CbtThought` at the end of the edge. */
  node: CbtThought;
}

/** Methods to use when ordering `CbtThought`. */
export enum CbtThoughtsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  SituationAsc = 'SITUATION_ASC',
  SituationDesc = 'SITUATION_DESC',
  AutomaticThoughtAsc = 'AUTOMATIC_THOUGHT_ASC',
  AutomaticThoughtDesc = 'AUTOMATIC_THOUGHT_DESC',
  CognitiveBiasesAsc = 'COGNITIVE_BIASES_ASC',
  CognitiveBiasesDesc = 'COGNITIVE_BIASES_DESC',
  AlternativeThoughtAsc = 'ALTERNATIVE_THOUGHT_ASC',
  AlternativeThoughtDesc = 'ALTERNATIVE_THOUGHT_DESC',
  ImprovementAsc = 'IMPROVEMENT_ASC',
  ImprovementDesc = 'IMPROVEMENT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Cdrisk10 extends Node {
  __typename?: 'Cdrisk10';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  score: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Cdrisk10`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Cdrisk10`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Cdrisk10` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface Cdrisk10Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Cdrisk10` object types. All fields are combined with a logical ‘and.’ */
export interface Cdrisk10Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Cdrisk10Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Cdrisk10Filter>>;
  /** Negates the expression. */
  not?: Maybe<Cdrisk10Filter>;
}

/** An input for mutations affecting `Cdrisk10` */
export interface Cdrisk10Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  score: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Cdrisk10`. Fields that are set will be updated. */
export interface Cdrisk10Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Cdrisk10` values. */
export interface Cdrisk10SConnection {
  __typename?: 'Cdrisk10SConnection';
  /** A list of `Cdrisk10` objects. */
  nodes: Array<Cdrisk10>;
  /** A list of edges which contains the `Cdrisk10` and cursor to aid in pagination. */
  edges: Array<Cdrisk10SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Cdrisk10` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Cdrisk10` edge in the connection. */
export interface Cdrisk10SEdge {
  __typename?: 'Cdrisk10SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Cdrisk10` at the end of the edge. */
  node: Cdrisk10;
}

/** Methods to use when ordering `Cdrisk10`. */
export enum Cdrisk10SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `checkHashEmailExisting` mutation. */
export interface CheckHashEmailExistingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
}

/** The output of our `checkHashEmailExisting` mutation. */
export interface CheckHashEmailExistingPayload {
  __typename?: 'CheckHashEmailExistingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  boolean?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

export interface Comment extends Node {
  __typename?: 'Comment';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Comment`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Comment`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Comment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface CommentCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `body` field. */
  body?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Comment` object types. All fields are combined with a logical ‘and.’ */
export interface CommentFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `body` field. */
  body?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CommentFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CommentFilter>>;
  /** Negates the expression. */
  not?: Maybe<CommentFilter>;
}

/** An input for mutations affecting `Comment` */
export interface CommentInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Comment`. Fields that are set will be updated. */
export interface CommentPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Comment` values. */
export interface CommentsConnection {
  __typename?: 'CommentsConnection';
  /** A list of `Comment` objects. */
  nodes: Array<Comment>;
  /** A list of edges which contains the `Comment` and cursor to aid in pagination. */
  edges: Array<CommentsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Comment` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Comment` edge in the connection. */
export interface CommentsEdge {
  __typename?: 'CommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Comment` at the end of the edge. */
  node: Comment;
}

/** Methods to use when ordering `Comment`. */
export enum CommentsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface CoordinatorUser {
  __typename?: 'CoordinatorUser';
  id?: Maybe<Scalars['UUID']>;
  alias?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `CoordinatorUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface CoordinatorUserCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
}

/** A filter to be used against `CoordinatorUser` object types. All fields are combined with a logical ‘and.’ */
export interface CoordinatorUserFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CoordinatorUserFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CoordinatorUserFilter>>;
  /** Negates the expression. */
  not?: Maybe<CoordinatorUserFilter>;
}

/** An input for mutations affecting `CoordinatorUser` */
export interface CoordinatorUserInput {
  id?: Maybe<Scalars['UUID']>;
  alias?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
}

/** A connection to a list of `CoordinatorUser` values. */
export interface CoordinatorUsersConnection {
  __typename?: 'CoordinatorUsersConnection';
  /** A list of `CoordinatorUser` objects. */
  nodes: Array<CoordinatorUser>;
  /** A list of edges which contains the `CoordinatorUser` and cursor to aid in pagination. */
  edges: Array<CoordinatorUsersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoordinatorUser` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CoordinatorUser` edge in the connection. */
export interface CoordinatorUsersEdge {
  __typename?: 'CoordinatorUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CoordinatorUser` at the end of the edge. */
  node: CoordinatorUser;
}

/** Methods to use when ordering `CoordinatorUser`. */
export enum CoordinatorUsersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC'
}

export interface CounselingQuestion extends Node {
  __typename?: 'CounselingQuestion';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  step: Scalars['String'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  mainProblem: Scalars['String'];
  effectsOnDailyLife: Scalars['String'];
  expectedResult: Scalars['String'];
  solutionProgress: Scalars['String'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  contactDate?: Maybe<Scalars['Datetime']>;
  contactVia?: Maybe<Scalars['String']>;
  /** Reads a single `Case` that is related to this `CounselingQuestion`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CounselingQuestion`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `CounselingQuestion` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface CounselingQuestionCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `step` field. */
  step?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `mainProblem` field. */
  mainProblem?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `effectsOnDailyLife` field. */
  effectsOnDailyLife?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `expectedResult` field. */
  expectedResult?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `solutionProgress` field. */
  solutionProgress?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `contactDate` field. */
  contactDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `contactVia` field. */
  contactVia?: Maybe<Scalars['String']>;
}

/** A filter to be used against `CounselingQuestion` object types. All fields are combined with a logical ‘and.’ */
export interface CounselingQuestionFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `step` field. */
  step?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `mainProblem` field. */
  mainProblem?: Maybe<StringFilter>;
  /** Filter by the object’s `effectsOnDailyLife` field. */
  effectsOnDailyLife?: Maybe<StringFilter>;
  /** Filter by the object’s `expectedResult` field. */
  expectedResult?: Maybe<StringFilter>;
  /** Filter by the object’s `solutionProgress` field. */
  solutionProgress?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `contactDate` field. */
  contactDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `contactVia` field. */
  contactVia?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<CounselingQuestionFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<CounselingQuestionFilter>>;
  /** Negates the expression. */
  not?: Maybe<CounselingQuestionFilter>;
}

/** An input for mutations affecting `CounselingQuestion` */
export interface CounselingQuestionInput {
  id?: Maybe<Scalars['UUID']>;
  step?: Maybe<Scalars['String']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  mainProblem: Scalars['String'];
  effectsOnDailyLife: Scalars['String'];
  expectedResult: Scalars['String'];
  solutionProgress: Scalars['String'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  contactDate?: Maybe<Scalars['Datetime']>;
  contactVia?: Maybe<Scalars['String']>;
}

/** Represents an update to a `CounselingQuestion`. Fields that are set will be updated. */
export interface CounselingQuestionPatch {
  id?: Maybe<Scalars['UUID']>;
  step?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  mainProblem?: Maybe<Scalars['String']>;
  effectsOnDailyLife?: Maybe<Scalars['String']>;
  expectedResult?: Maybe<Scalars['String']>;
  solutionProgress?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  contactDate?: Maybe<Scalars['Datetime']>;
  contactVia?: Maybe<Scalars['String']>;
}

/** A connection to a list of `CounselingQuestion` values. */
export interface CounselingQuestionsConnection {
  __typename?: 'CounselingQuestionsConnection';
  /** A list of `CounselingQuestion` objects. */
  nodes: Array<CounselingQuestion>;
  /** A list of edges which contains the `CounselingQuestion` and cursor to aid in pagination. */
  edges: Array<CounselingQuestionsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CounselingQuestion` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `CounselingQuestion` edge in the connection. */
export interface CounselingQuestionsEdge {
  __typename?: 'CounselingQuestionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CounselingQuestion` at the end of the edge. */
  node: CounselingQuestion;
}

/** Methods to use when ordering `CounselingQuestion`. */
export enum CounselingQuestionsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  StepAsc = 'STEP_ASC',
  StepDesc = 'STEP_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  MainProblemAsc = 'MAIN_PROBLEM_ASC',
  MainProblemDesc = 'MAIN_PROBLEM_DESC',
  EffectsOnDailyLifeAsc = 'EFFECTS_ON_DAILY_LIFE_ASC',
  EffectsOnDailyLifeDesc = 'EFFECTS_ON_DAILY_LIFE_DESC',
  ExpectedResultAsc = 'EXPECTED_RESULT_ASC',
  ExpectedResultDesc = 'EXPECTED_RESULT_DESC',
  SolutionProgressAsc = 'SOLUTION_PROGRESS_ASC',
  SolutionProgressDesc = 'SOLUTION_PROGRESS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ContactDateAsc = 'CONTACT_DATE_ASC',
  ContactDateDesc = 'CONTACT_DATE_DESC',
  ContactViaAsc = 'CONTACT_VIA_ASC',
  ContactViaDesc = 'CONTACT_VIA_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the create `ActiveUser` mutation. */
export interface CreateActiveUserInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ActiveUser` to be created by this mutation. */
  activeUser: ActiveUserInput;
}

/** The output of our create `ActiveUser` mutation. */
export interface CreateActiveUserPayload {
  __typename?: 'CreateActiveUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ActiveUser` that was created by this mutation. */
  activeUser?: Maybe<ActiveUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `ActiveUser`. May be used by Relay 1. */
  activeUserEdge?: Maybe<ActiveUsersEdge>;
}


/** The output of our create `ActiveUser` mutation. */
export type CreateActiveUserPayloadActiveUserEdgeArgs = {
  orderBy?: Maybe<Array<ActiveUsersOrderBy>>;
};

/** All input for the create `AvailableInterviewOffer` mutation. */
export interface CreateAvailableInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `AvailableInterviewOffer` to be created by this mutation. */
  availableInterviewOffer: AvailableInterviewOfferInput;
}

/** The output of our create `AvailableInterviewOffer` mutation. */
export interface CreateAvailableInterviewOfferPayload {
  __typename?: 'CreateAvailableInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `AvailableInterviewOffer` that was created by this mutation. */
  availableInterviewOffer?: Maybe<AvailableInterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `AvailableInterviewOffer`. May be used by Relay 1. */
  availableInterviewOfferEdge?: Maybe<AvailableInterviewOffersEdge>;
}


/** The output of our create `AvailableInterviewOffer` mutation. */
export type CreateAvailableInterviewOfferPayloadAvailableInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<AvailableInterviewOffersOrderBy>>;
};

/** All input for the create `Bdi2` mutation. */
export interface CreateBdi2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Bdi2` to be created by this mutation. */
  bdi2: Bdi2Input;
}

/** The output of our create `Bdi2` mutation. */
export interface CreateBdi2Payload {
  __typename?: 'CreateBdi2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Bdi2` that was created by this mutation. */
  bdi2?: Maybe<Bdi2>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Bdi2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Bdi2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Bdi2`. May be used by Relay 1. */
  bdi2Edge?: Maybe<Bdi2SEdge>;
}


/** The output of our create `Bdi2` mutation. */
export type CreateBdi2PayloadBdi2EdgeArgs = {
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
};

/** All input for the create `BookedInterviewOffer` mutation. */
export interface CreateBookedInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BookedInterviewOffer` to be created by this mutation. */
  bookedInterviewOffer: BookedInterviewOfferInput;
}

/** The output of our create `BookedInterviewOffer` mutation. */
export interface CreateBookedInterviewOfferPayload {
  __typename?: 'CreateBookedInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `BookedInterviewOffer` that was created by this mutation. */
  bookedInterviewOffer?: Maybe<BookedInterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `BookedInterviewOffer`. May be used by Relay 1. */
  bookedInterviewOfferEdge?: Maybe<BookedInterviewOffersEdge>;
}


/** The output of our create `BookedInterviewOffer` mutation. */
export type CreateBookedInterviewOfferPayloadBookedInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<BookedInterviewOffersOrderBy>>;
};

/** All input for the create `Case` mutation. */
export interface CreateCaseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Case` to be created by this mutation. */
  case: CaseInput;
}

/** All input for the create `CaseMessage` mutation. */
export interface CreateCaseMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseMessage` to be created by this mutation. */
  caseMessage: CaseMessageInput;
}

/** The output of our create `CaseMessage` mutation. */
export interface CreateCaseMessagePayload {
  __typename?: 'CreateCaseMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseMessage` that was created by this mutation. */
  caseMessage?: Maybe<CaseMessage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseMessage`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseMessage`. */
  userBySenderId?: Maybe<User>;
  /** Reads a single `CaseMember` that is related to this `CaseMessage`. */
  caseMemberByCaseIdAndSenderId?: Maybe<CaseMember>;
  /** An edge for our `CaseMessage`. May be used by Relay 1. */
  caseMessageEdge?: Maybe<CaseMessagesEdge>;
}


/** The output of our create `CaseMessage` mutation. */
export type CreateCaseMessagePayloadCaseMessageEdgeArgs = {
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
};

/** The output of our create `Case` mutation. */
export interface CreateCasePayload {
  __typename?: 'CreateCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Case` that was created by this mutation. */
  case?: Maybe<Case>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `MyInvolvement` that is related to this `Case`. */
  myInvolvementById?: Maybe<MyInvolvement>;
  /** An edge for our `Case`. May be used by Relay 1. */
  caseEdge?: Maybe<CasesEdge>;
}


/** The output of our create `Case` mutation. */
export type CreateCasePayloadCaseEdgeArgs = {
  orderBy?: Maybe<Array<CasesOrderBy>>;
};

/** All input for the create `CaseSuicideCall` mutation. */
export interface CreateCaseSuicideCallInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseSuicideCall` to be created by this mutation. */
  caseSuicideCall: CaseSuicideCallInput;
}

/** The output of our create `CaseSuicideCall` mutation. */
export interface CreateCaseSuicideCallPayload {
  __typename?: 'CreateCaseSuicideCallPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseSuicideCall` that was created by this mutation. */
  caseSuicideCall?: Maybe<CaseSuicideCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseSuicideCall`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseSuicideCall`. */
  userByUserIdCaller?: Maybe<User>;
  /** An edge for our `CaseSuicideCall`. May be used by Relay 1. */
  caseSuicideCallEdge?: Maybe<CaseSuicideCallsEdge>;
}


/** The output of our create `CaseSuicideCall` mutation. */
export type CreateCaseSuicideCallPayloadCaseSuicideCallEdgeArgs = {
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
};

/** All input for the create `CbtActivity` mutation. */
export interface CreateCbtActivityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtActivity` to be created by this mutation. */
  cbtActivity: CbtActivityInput;
}

/** The output of our create `CbtActivity` mutation. */
export interface CreateCbtActivityPayload {
  __typename?: 'CreateCbtActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtActivity` that was created by this mutation. */
  cbtActivity?: Maybe<CbtActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtActivity`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtActivity`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtActivity`. May be used by Relay 1. */
  cbtActivityEdge?: Maybe<CbtActivitiesEdge>;
}


/** The output of our create `CbtActivity` mutation. */
export type CreateCbtActivityPayloadCbtActivityEdgeArgs = {
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
};

/** All input for the create `CbtReframing` mutation. */
export interface CreateCbtReframingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtReframing` to be created by this mutation. */
  cbtReframing: CbtReframingInput;
}

/** The output of our create `CbtReframing` mutation. */
export interface CreateCbtReframingPayload {
  __typename?: 'CreateCbtReframingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtReframing` that was created by this mutation. */
  cbtReframing?: Maybe<CbtReframing>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtReframing`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtReframing`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtReframing`. May be used by Relay 1. */
  cbtReframingEdge?: Maybe<CbtReframingsEdge>;
}


/** The output of our create `CbtReframing` mutation. */
export type CreateCbtReframingPayloadCbtReframingEdgeArgs = {
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
};

/** All input for the create `CbtThought` mutation. */
export interface CreateCbtThoughtInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtThought` to be created by this mutation. */
  cbtThought: CbtThoughtInput;
}

/** The output of our create `CbtThought` mutation. */
export interface CreateCbtThoughtPayload {
  __typename?: 'CreateCbtThoughtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtThought` that was created by this mutation. */
  cbtThought?: Maybe<CbtThought>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtThought`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtThought`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtThought`. May be used by Relay 1. */
  cbtThoughtEdge?: Maybe<CbtThoughtsEdge>;
}


/** The output of our create `CbtThought` mutation. */
export type CreateCbtThoughtPayloadCbtThoughtEdgeArgs = {
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
};

/** All input for the create `Cdrisk10` mutation. */
export interface CreateCdrisk10Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Cdrisk10` to be created by this mutation. */
  cdrisk10: Cdrisk10Input;
}

/** The output of our create `Cdrisk10` mutation. */
export interface CreateCdrisk10Payload {
  __typename?: 'CreateCdrisk10Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Cdrisk10` that was created by this mutation. */
  cdrisk10?: Maybe<Cdrisk10>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Cdrisk10`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Cdrisk10`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Cdrisk10`. May be used by Relay 1. */
  cdrisk10Edge?: Maybe<Cdrisk10SEdge>;
}


/** The output of our create `Cdrisk10` mutation. */
export type CreateCdrisk10PayloadCdrisk10EdgeArgs = {
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
};

/** All input for the create `Comment` mutation. */
export interface CreateCommentInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` to be created by this mutation. */
  comment: CommentInput;
}

/** The output of our create `Comment` mutation. */
export interface CreateCommentPayload {
  __typename?: 'CreateCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was created by this mutation. */
  comment?: Maybe<Comment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Comment`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Comment`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
}


/** The output of our create `Comment` mutation. */
export type CreateCommentPayloadCommentEdgeArgs = {
  orderBy?: Maybe<Array<CommentsOrderBy>>;
};

/** All input for the create `CoordinatorUser` mutation. */
export interface CreateCoordinatorUserInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CoordinatorUser` to be created by this mutation. */
  coordinatorUser: CoordinatorUserInput;
}

/** The output of our create `CoordinatorUser` mutation. */
export interface CreateCoordinatorUserPayload {
  __typename?: 'CreateCoordinatorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CoordinatorUser` that was created by this mutation. */
  coordinatorUser?: Maybe<CoordinatorUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `CoordinatorUser`. May be used by Relay 1. */
  coordinatorUserEdge?: Maybe<CoordinatorUsersEdge>;
}


/** The output of our create `CoordinatorUser` mutation. */
export type CreateCoordinatorUserPayloadCoordinatorUserEdgeArgs = {
  orderBy?: Maybe<Array<CoordinatorUsersOrderBy>>;
};

/** All input for the create `CounselingQuestion` mutation. */
export interface CreateCounselingQuestionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CounselingQuestion` to be created by this mutation. */
  counselingQuestion: CounselingQuestionInput;
}

/** The output of our create `CounselingQuestion` mutation. */
export interface CreateCounselingQuestionPayload {
  __typename?: 'CreateCounselingQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CounselingQuestion` that was created by this mutation. */
  counselingQuestion?: Maybe<CounselingQuestion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CounselingQuestion`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CounselingQuestion`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CounselingQuestion`. May be used by Relay 1. */
  counselingQuestionEdge?: Maybe<CounselingQuestionsEdge>;
}


/** The output of our create `CounselingQuestion` mutation. */
export type CreateCounselingQuestionPayloadCounselingQuestionEdgeArgs = {
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
};

/** All input for the create `Demographic` mutation. */
export interface CreateDemographicInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Demographic` to be created by this mutation. */
  demographic: DemographicInput;
}

/** The output of our create `Demographic` mutation. */
export interface CreateDemographicPayload {
  __typename?: 'CreateDemographicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Demographic` that was created by this mutation. */
  demographic?: Maybe<Demographic>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Demographic`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Demographic`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Demographic`. May be used by Relay 1. */
  demographicEdge?: Maybe<DemographicsEdge>;
}


/** The output of our create `Demographic` mutation. */
export type CreateDemographicPayloadDemographicEdgeArgs = {
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
};

/** All input for the create `Disclosure` mutation. */
export interface CreateDisclosureInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Disclosure` to be created by this mutation. */
  disclosure: DisclosureInput;
}

/** The output of our create `Disclosure` mutation. */
export interface CreateDisclosurePayload {
  __typename?: 'CreateDisclosurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Disclosure` that was created by this mutation. */
  disclosure?: Maybe<Disclosure>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Disclosure`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Disclosure`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Disclosure`. May be used by Relay 1. */
  disclosureEdge?: Maybe<DisclosuresEdge>;
}


/** The output of our create `Disclosure` mutation. */
export type CreateDisclosurePayloadDisclosureEdgeArgs = {
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
};

/** All input for the create `Eurohi` mutation. */
export interface CreateEurohiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Eurohi` to be created by this mutation. */
  eurohi: EurohiInput;
}

/** The output of our create `Eurohi` mutation. */
export interface CreateEurohiPayload {
  __typename?: 'CreateEurohiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Eurohi` that was created by this mutation. */
  eurohi?: Maybe<Eurohi>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Eurohi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Eurohi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Eurohi`. May be used by Relay 1. */
  eurohiEdge?: Maybe<EurohisEdge>;
}


/** The output of our create `Eurohi` mutation. */
export type CreateEurohiPayloadEurohiEdgeArgs = {
  orderBy?: Maybe<Array<EurohisOrderBy>>;
};

/** All input for the create `Evaluation` mutation. */
export interface CreateEvaluationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Evaluation` to be created by this mutation. */
  evaluation: EvaluationInput;
}

/** The output of our create `Evaluation` mutation. */
export interface CreateEvaluationPayload {
  __typename?: 'CreateEvaluationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Evaluation` that was created by this mutation. */
  evaluation?: Maybe<Evaluation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Evaluation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Evaluation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Evaluation`. May be used by Relay 1. */
  evaluationEdge?: Maybe<EvaluationsEdge>;
}


/** The output of our create `Evaluation` mutation. */
export type CreateEvaluationPayloadEvaluationEdgeArgs = {
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
};

/** All input for the create `FeedbackInterviewReport` mutation. */
export interface CreateFeedbackInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeedbackInterviewReport` to be created by this mutation. */
  feedbackInterviewReport: FeedbackInterviewReportInput;
}

/** The output of our create `FeedbackInterviewReport` mutation. */
export interface CreateFeedbackInterviewReportPayload {
  __typename?: 'CreateFeedbackInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeedbackInterviewReport` that was created by this mutation. */
  feedbackInterviewReport?: Maybe<FeedbackInterviewReport>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `FeedbackInterviewReport`. May be used by Relay 1. */
  feedbackInterviewReportEdge?: Maybe<FeedbackInterviewReportsEdge>;
}


/** The output of our create `FeedbackInterviewReport` mutation. */
export type CreateFeedbackInterviewReportPayloadFeedbackInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<FeedbackInterviewReportsOrderBy>>;
};

/** All input for the create `Gad2` mutation. */
export interface CreateGad2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad2` to be created by this mutation. */
  gad2: Gad2Input;
}

/** The output of our create `Gad2` mutation. */
export interface CreateGad2Payload {
  __typename?: 'CreateGad2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad2` that was created by this mutation. */
  gad2?: Maybe<Gad2>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad2`. May be used by Relay 1. */
  gad2Edge?: Maybe<Gad2SEdge>;
}


/** The output of our create `Gad2` mutation. */
export type CreateGad2PayloadGad2EdgeArgs = {
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
};

/** All input for the create `Gad7` mutation. */
export interface CreateGad7Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad7` to be created by this mutation. */
  gad7: Gad7Input;
}

/** The output of our create `Gad7` mutation. */
export interface CreateGad7Payload {
  __typename?: 'CreateGad7Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad7` that was created by this mutation. */
  gad7?: Maybe<Gad7>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad7`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad7`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad7`. May be used by Relay 1. */
  gad7Edge?: Maybe<Gad7SEdge>;
}


/** The output of our create `Gad7` mutation. */
export type CreateGad7PayloadGad7EdgeArgs = {
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
};

/** All input for the create `HashedEmail` mutation. */
export interface CreateHashedEmailInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HashedEmail` to be created by this mutation. */
  hashedEmail: HashedEmailInput;
}

/** The output of our create `HashedEmail` mutation. */
export interface CreateHashedEmailPayload {
  __typename?: 'CreateHashedEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HashedEmail` that was created by this mutation. */
  hashedEmail?: Maybe<HashedEmail>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `HashedEmail`. May be used by Relay 1. */
  hashedEmailEdge?: Maybe<HashedEmailsEdge>;
}


/** The output of our create `HashedEmail` mutation. */
export type CreateHashedEmailPayloadHashedEmailEdgeArgs = {
  orderBy?: Maybe<Array<HashedEmailsOrderBy>>;
};

/** All input for the create `Inep` mutation. */
export interface CreateInepInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Inep` to be created by this mutation. */
  inep: InepInput;
}

/** The output of our create `Inep` mutation. */
export interface CreateInepPayload {
  __typename?: 'CreateInepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Inep` that was created by this mutation. */
  inep?: Maybe<Inep>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Inep`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Inep`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Inep`. May be used by Relay 1. */
  inepEdge?: Maybe<InepsEdge>;
}


/** The output of our create `Inep` mutation. */
export type CreateInepPayloadInepEdgeArgs = {
  orderBy?: Maybe<Array<InepsOrderBy>>;
};

/** All input for the create `InterviewBooking` mutation. */
export interface CreateInterviewBookingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewBooking` to be created by this mutation. */
  interviewBooking: InterviewBookingInput;
}

/** The output of our create `InterviewBooking` mutation. */
export interface CreateInterviewBookingPayload {
  __typename?: 'CreateInterviewBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewBooking` that was created by this mutation. */
  interviewBooking?: Maybe<InterviewBooking>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `InterviewBooking`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Involvement` that is related to this `InterviewBooking`. */
  involvementByCaseIdAndIntervieweeId?: Maybe<Involvement>;
  /** Reads a single `User` that is related to this `InterviewBooking`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewBooking`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `Interviewee` that is related to this `InterviewBooking`. */
  intervieweeByIntervieweeId?: Maybe<Interviewee>;
  /** An edge for our `InterviewBooking`. May be used by Relay 1. */
  interviewBookingEdge?: Maybe<InterviewBookingsEdge>;
}


/** The output of our create `InterviewBooking` mutation. */
export type CreateInterviewBookingPayloadInterviewBookingEdgeArgs = {
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
};

/** All input for the create `Interviewee` mutation. */
export interface CreateIntervieweeInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewee` to be created by this mutation. */
  interviewee: IntervieweeInput;
}

/** The output of our create `Interviewee` mutation. */
export interface CreateIntervieweePayload {
  __typename?: 'CreateIntervieweePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewee` that was created by this mutation. */
  interviewee?: Maybe<Interviewee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewee`. May be used by Relay 1. */
  intervieweeEdge?: Maybe<IntervieweesEdge>;
}


/** The output of our create `Interviewee` mutation. */
export type CreateIntervieweePayloadIntervieweeEdgeArgs = {
  orderBy?: Maybe<Array<IntervieweesOrderBy>>;
};

/** All input for the create `Interviewer` mutation. */
export interface CreateInterviewerInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewer` to be created by this mutation. */
  interviewer: InterviewerInput;
}

/** The output of our create `Interviewer` mutation. */
export interface CreateInterviewerPayload {
  __typename?: 'CreateInterviewerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewer` that was created by this mutation. */
  interviewer?: Maybe<Interviewer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewer`. May be used by Relay 1. */
  interviewerEdge?: Maybe<InterviewersEdge>;
}


/** The output of our create `Interviewer` mutation. */
export type CreateInterviewerPayloadInterviewerEdgeArgs = {
  orderBy?: Maybe<Array<InterviewersOrderBy>>;
};

/** All input for the create `InterviewOffer` mutation. */
export interface CreateInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewOffer` to be created by this mutation. */
  interviewOffer: InterviewOfferInput;
}

/** The output of our create `InterviewOffer` mutation. */
export interface CreateInterviewOfferPayload {
  __typename?: 'CreateInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewOffer` that was created by this mutation. */
  interviewOffer?: Maybe<InterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `InterviewOffer`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `Interviewer` that is related to this `InterviewOffer`. */
  interviewerByInterviewerId?: Maybe<Interviewer>;
  /** An edge for our `InterviewOffer`. May be used by Relay 1. */
  interviewOfferEdge?: Maybe<InterviewOffersEdge>;
}


/** The output of our create `InterviewOffer` mutation. */
export type CreateInterviewOfferPayloadInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
};

/** All input for the create `InterviewReport` mutation. */
export interface CreateInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewReport` to be created by this mutation. */
  interviewReport: InterviewReportInput;
}

/** The output of our create `InterviewReport` mutation. */
export interface CreateInterviewReportPayload {
  __typename?: 'CreateInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewReport` that was created by this mutation. */
  interviewReport?: Maybe<InterviewReport>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingId?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingIdAndCaseId?: Maybe<InterviewBooking>;
  /** Reads a single `Case` that is related to this `InterviewReport`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `InterviewReport`. */
  userByInterviewerId?: Maybe<User>;
  /** An edge for our `InterviewReport`. May be used by Relay 1. */
  interviewReportEdge?: Maybe<InterviewReportsEdge>;
}


/** The output of our create `InterviewReport` mutation. */
export type CreateInterviewReportPayloadInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
};

/** All input for the create `Involvement` mutation. */
export interface CreateInvolvementInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Involvement` to be created by this mutation. */
  involvement: InvolvementInput;
}

/** The output of our create `Involvement` mutation. */
export interface CreateInvolvementPayload {
  __typename?: 'CreateInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Involvement` that was created by this mutation. */
  involvement?: Maybe<Involvement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Involvement`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Case` that is related to this `Involvement`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `Involvement`. May be used by Relay 1. */
  involvementEdge?: Maybe<InvolvementsEdge>;
}


/** The output of our create `Involvement` mutation. */
export type CreateInvolvementPayloadInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
};

/** All input for the create `InvolvementsInMyCase` mutation. */
export interface CreateInvolvementsInMyCaseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InvolvementsInMyCase` to be created by this mutation. */
  involvementsInMyCase: InvolvementsInMyCaseInput;
}

/** The output of our create `InvolvementsInMyCase` mutation. */
export interface CreateInvolvementsInMyCasePayload {
  __typename?: 'CreateInvolvementsInMyCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InvolvementsInMyCase` that was created by this mutation. */
  involvementsInMyCase?: Maybe<InvolvementsInMyCase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `InvolvementsInMyCase`. May be used by Relay 1. */
  involvementsInMyCaseEdge?: Maybe<InvolvementsInMyCasesEdge>;
}


/** The output of our create `InvolvementsInMyCase` mutation. */
export type CreateInvolvementsInMyCasePayloadInvolvementsInMyCaseEdgeArgs = {
  orderBy?: Maybe<Array<InvolvementsInMyCasesOrderBy>>;
};

/** All input for the create `IptConflict` mutation. */
export interface CreateIptConflictInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptConflict` to be created by this mutation. */
  iptConflict: IptConflictInput;
}

/** The output of our create `IptConflict` mutation. */
export interface CreateIptConflictPayload {
  __typename?: 'CreateIptConflictPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptConflict` that was created by this mutation. */
  iptConflict?: Maybe<IptConflict>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptConflict`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptConflict`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptConflict`. May be used by Relay 1. */
  iptConflictEdge?: Maybe<IptConflictsEdge>;
}


/** The output of our create `IptConflict` mutation. */
export type CreateIptConflictPayloadIptConflictEdgeArgs = {
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
};

/** All input for the create `IptRelationship` mutation. */
export interface CreateIptRelationshipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptRelationship` to be created by this mutation. */
  iptRelationship: IptRelationshipInput;
}

/** The output of our create `IptRelationship` mutation. */
export interface CreateIptRelationshipPayload {
  __typename?: 'CreateIptRelationshipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptRelationship` that was created by this mutation. */
  iptRelationship?: Maybe<IptRelationship>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptRelationship`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptRelationship`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptRelationship`. May be used by Relay 1. */
  iptRelationshipEdge?: Maybe<IptRelationshipsEdge>;
}


/** The output of our create `IptRelationship` mutation. */
export type CreateIptRelationshipPayloadIptRelationshipEdgeArgs = {
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
};

/** All input for the create `IptSituation` mutation. */
export interface CreateIptSituationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptSituation` to be created by this mutation. */
  iptSituation: IptSituationInput;
}

/** The output of our create `IptSituation` mutation. */
export interface CreateIptSituationPayload {
  __typename?: 'CreateIptSituationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptSituation` that was created by this mutation. */
  iptSituation?: Maybe<IptSituation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptSituation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptSituation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptSituation`. May be used by Relay 1. */
  iptSituationEdge?: Maybe<IptSituationsEdge>;
}


/** The output of our create `IptSituation` mutation. */
export type CreateIptSituationPayloadIptSituationEdgeArgs = {
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
};

/** All input for the create `Itq` mutation. */
export interface CreateItqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Itq` to be created by this mutation. */
  itq: ItqInput;
}

/** The output of our create `Itq` mutation. */
export interface CreateItqPayload {
  __typename?: 'CreateItqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Itq` that was created by this mutation. */
  itq?: Maybe<Itq>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Itq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Itq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Itq`. May be used by Relay 1. */
  itqEdge?: Maybe<ItqsEdge>;
}


/** The output of our create `Itq` mutation. */
export type CreateItqPayloadItqEdgeArgs = {
  orderBy?: Maybe<Array<ItqsOrderBy>>;
};

/** All input for the create `Lec5` mutation. */
export interface CreateLec5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lec5` to be created by this mutation. */
  lec5: Lec5Input;
}

/** The output of our create `Lec5` mutation. */
export interface CreateLec5Payload {
  __typename?: 'CreateLec5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lec5` that was created by this mutation. */
  lec5?: Maybe<Lec5>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lec5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lec5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lec5`. May be used by Relay 1. */
  lec5Edge?: Maybe<Lec5SEdge>;
}


/** The output of our create `Lec5` mutation. */
export type CreateLec5PayloadLec5EdgeArgs = {
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
};

/** All input for the create `Letter` mutation. */
export interface CreateLetterInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Letter` to be created by this mutation. */
  letter: LetterInput;
}

/** The output of our create `Letter` mutation. */
export interface CreateLetterPayload {
  __typename?: 'CreateLetterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Letter` that was created by this mutation. */
  letter?: Maybe<Letter>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Letter`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Letter`. */
  userBySenderId?: Maybe<User>;
  /** An edge for our `Letter`. May be used by Relay 1. */
  letterEdge?: Maybe<LettersEdge>;
}


/** The output of our create `Letter` mutation. */
export type CreateLetterPayloadLetterEdgeArgs = {
  orderBy?: Maybe<Array<LettersOrderBy>>;
};

/** All input for the create `LetterTemplate` mutation. */
export interface CreateLetterTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LetterTemplate` to be created by this mutation. */
  letterTemplate: LetterTemplateInput;
}

/** The output of our create `LetterTemplate` mutation. */
export interface CreateLetterTemplatePayload {
  __typename?: 'CreateLetterTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LetterTemplate` that was created by this mutation. */
  letterTemplate?: Maybe<LetterTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LetterTemplate`. */
  userByEditorId?: Maybe<User>;
  /** An edge for our `LetterTemplate`. May be used by Relay 1. */
  letterTemplateEdge?: Maybe<LetterTemplatesEdge>;
}


/** The output of our create `LetterTemplate` mutation. */
export type CreateLetterTemplatePayloadLetterTemplateEdgeArgs = {
  orderBy?: Maybe<Array<LetterTemplatesOrderBy>>;
};

/** All input for the create `LoginToken` mutation. */
export interface CreateLoginTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LoginToken` to be created by this mutation. */
  loginToken: LoginTokenInput;
}

/** The output of our create `LoginToken` mutation. */
export interface CreateLoginTokenPayload {
  __typename?: 'CreateLoginTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LoginToken` that was created by this mutation. */
  loginToken?: Maybe<LoginToken>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LoginToken`. */
  userByUserId?: Maybe<User>;
  /** An edge for our `LoginToken`. May be used by Relay 1. */
  loginTokenEdge?: Maybe<LoginTokensEdge>;
}


/** The output of our create `LoginToken` mutation. */
export type CreateLoginTokenPayloadLoginTokenEdgeArgs = {
  orderBy?: Maybe<Array<LoginTokensOrderBy>>;
};

/** All input for the create `Lsa` mutation. */
export interface CreateLsaInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lsa` to be created by this mutation. */
  lsa: LsaInput;
}

/** The output of our create `Lsa` mutation. */
export interface CreateLsaPayload {
  __typename?: 'CreateLsaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lsa` that was created by this mutation. */
  lsa?: Maybe<Lsa>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lsa`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lsa`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lsa`. May be used by Relay 1. */
  lsaEdge?: Maybe<LsasEdge>;
}


/** The output of our create `Lsa` mutation. */
export type CreateLsaPayloadLsaEdgeArgs = {
  orderBy?: Maybe<Array<LsasOrderBy>>;
};

/** All input for the create `Mspss` mutation. */
export interface CreateMspssInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Mspss` to be created by this mutation. */
  mspss: MspssInput;
}

/** The output of our create `Mspss` mutation. */
export interface CreateMspssPayload {
  __typename?: 'CreateMspssPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Mspss` that was created by this mutation. */
  mspss?: Maybe<Mspss>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Mspss`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Mspss`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Mspss`. May be used by Relay 1. */
  mspssEdge?: Maybe<MspssesEdge>;
}


/** The output of our create `Mspss` mutation. */
export type CreateMspssPayloadMspssEdgeArgs = {
  orderBy?: Maybe<Array<MspssesOrderBy>>;
};

/** All input for the create `MyAccount` mutation. */
export interface CreateMyAccountInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyAccount` to be created by this mutation. */
  myAccount: MyAccountInput;
}

/** The output of our create `MyAccount` mutation. */
export interface CreateMyAccountPayload {
  __typename?: 'CreateMyAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyAccount` that was created by this mutation. */
  myAccount?: Maybe<MyAccount>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyAccount`. May be used by Relay 1. */
  myAccountEdge?: Maybe<MyAccountsEdge>;
}


/** The output of our create `MyAccount` mutation. */
export type CreateMyAccountPayloadMyAccountEdgeArgs = {
  orderBy?: Maybe<Array<MyAccountsOrderBy>>;
};

/** All input for the create `MyCase` mutation. */
export interface CreateMyCaseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyCase` to be created by this mutation. */
  myCase: MyCaseInput;
}

/** The output of our create `MyCase` mutation. */
export interface CreateMyCasePayload {
  __typename?: 'CreateMyCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyCase` that was created by this mutation. */
  myCase?: Maybe<MyCase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyCase`. May be used by Relay 1. */
  myCaseEdge?: Maybe<MyCasesEdge>;
}


/** The output of our create `MyCase` mutation. */
export type CreateMyCasePayloadMyCaseEdgeArgs = {
  orderBy?: Maybe<Array<MyCasesOrderBy>>;
};

/** All input for the create `MyInterviewBooking` mutation. */
export interface CreateMyInterviewBookingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInterviewBooking` to be created by this mutation. */
  myInterviewBooking: MyInterviewBookingInput;
}

/** The output of our create `MyInterviewBooking` mutation. */
export interface CreateMyInterviewBookingPayload {
  __typename?: 'CreateMyInterviewBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInterviewBooking` that was created by this mutation. */
  myInterviewBooking?: Maybe<MyInterviewBooking>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyInterviewBooking`. May be used by Relay 1. */
  myInterviewBookingEdge?: Maybe<MyInterviewBookingsEdge>;
}


/** The output of our create `MyInterviewBooking` mutation. */
export type CreateMyInterviewBookingPayloadMyInterviewBookingEdgeArgs = {
  orderBy?: Maybe<Array<MyInterviewBookingsOrderBy>>;
};

/** All input for the create `MyInterviewOffer` mutation. */
export interface CreateMyInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInterviewOffer` to be created by this mutation. */
  myInterviewOffer: MyInterviewOfferInput;
}

/** The output of our create `MyInterviewOffer` mutation. */
export interface CreateMyInterviewOfferPayload {
  __typename?: 'CreateMyInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInterviewOffer` that was created by this mutation. */
  myInterviewOffer?: Maybe<MyInterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyInterviewOffer`. May be used by Relay 1. */
  myInterviewOfferEdge?: Maybe<MyInterviewOffersEdge>;
}


/** The output of our create `MyInterviewOffer` mutation. */
export type CreateMyInterviewOfferPayloadMyInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<MyInterviewOffersOrderBy>>;
};

/** All input for the create `MyInvolvement` mutation. */
export interface CreateMyInvolvementInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInvolvement` to be created by this mutation. */
  myInvolvement: MyInvolvementInput;
}

/** The output of our create `MyInvolvement` mutation. */
export interface CreateMyInvolvementPayload {
  __typename?: 'CreateMyInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInvolvement` that was created by this mutation. */
  myInvolvement?: Maybe<MyInvolvement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyInvolvement`. May be used by Relay 1. */
  myInvolvementEdge?: Maybe<MyInvolvementsEdge>;
}


/** The output of our create `MyInvolvement` mutation. */
export type CreateMyInvolvementPayloadMyInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<MyInvolvementsOrderBy>>;
};

/** All input for the create `Pathev` mutation. */
export interface CreatePathevInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pathev` to be created by this mutation. */
  pathev: PathevInput;
}

/** The output of our create `Pathev` mutation. */
export interface CreatePathevPayload {
  __typename?: 'CreatePathevPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pathev` that was created by this mutation. */
  pathev?: Maybe<Pathev>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pathev`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pathev`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pathev`. May be used by Relay 1. */
  pathevEdge?: Maybe<PathevsEdge>;
}


/** The output of our create `Pathev` mutation. */
export type CreatePathevPayloadPathevEdgeArgs = {
  orderBy?: Maybe<Array<PathevsOrderBy>>;
};

/** All input for the create `Pcl5` mutation. */
export interface CreatePcl5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pcl5` to be created by this mutation. */
  pcl5: Pcl5Input;
}

/** The output of our create `Pcl5` mutation. */
export interface CreatePcl5Payload {
  __typename?: 'CreatePcl5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pcl5` that was created by this mutation. */
  pcl5?: Maybe<Pcl5>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pcl5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pcl5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pcl5`. May be used by Relay 1. */
  pcl5Edge?: Maybe<Pcl5SEdge>;
}


/** The output of our create `Pcl5` mutation. */
export type CreatePcl5PayloadPcl5EdgeArgs = {
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
};

/** All input for the create `Pg13` mutation. */
export interface CreatePg13Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pg13` to be created by this mutation. */
  pg13: Pg13Input;
}

/** The output of our create `Pg13` mutation. */
export interface CreatePg13Payload {
  __typename?: 'CreatePg13Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pg13` that was created by this mutation. */
  pg13?: Maybe<Pg13>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pg13`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pg13`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pg13`. May be used by Relay 1. */
  pg13Edge?: Maybe<Pg13SEdge>;
}


/** The output of our create `Pg13` mutation. */
export type CreatePg13PayloadPg13EdgeArgs = {
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
};

/** All input for the create `Phq15` mutation. */
export interface CreatePhq15Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq15` to be created by this mutation. */
  phq15: Phq15Input;
}

/** The output of our create `Phq15` mutation. */
export interface CreatePhq15Payload {
  __typename?: 'CreatePhq15Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq15` that was created by this mutation. */
  phq15?: Maybe<Phq15>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq15`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq15`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq15`. May be used by Relay 1. */
  phq15Edge?: Maybe<Phq15SEdge>;
}


/** The output of our create `Phq15` mutation. */
export type CreatePhq15PayloadPhq15EdgeArgs = {
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
};

/** All input for the create `Phq4` mutation. */
export interface CreatePhq4Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq4` to be created by this mutation. */
  phq4: Phq4Input;
}

/** The output of our create `Phq4` mutation. */
export interface CreatePhq4Payload {
  __typename?: 'CreatePhq4Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq4` that was created by this mutation. */
  phq4?: Maybe<Phq4>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq4`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq4`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq4`. May be used by Relay 1. */
  phq4Edge?: Maybe<Phq4SEdge>;
}


/** The output of our create `Phq4` mutation. */
export type CreatePhq4PayloadPhq4EdgeArgs = {
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
};

/** All input for the create `Phq9` mutation. */
export interface CreatePhq9Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq9` to be created by this mutation. */
  phq9: Phq9Input;
}

/** The output of our create `Phq9` mutation. */
export interface CreatePhq9Payload {
  __typename?: 'CreatePhq9Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq9` that was created by this mutation. */
  phq9?: Maybe<Phq9>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq9`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq9`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq9`. May be used by Relay 1. */
  phq9Edge?: Maybe<Phq9SEdge>;
}


/** The output of our create `Phq9` mutation. */
export type CreatePhq9PayloadPhq9EdgeArgs = {
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
};

/** All input for the create `Pmb` mutation. */
export interface CreatePmbInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pmb` to be created by this mutation. */
  pmb: PmbInput;
}

/** The output of our create `Pmb` mutation. */
export interface CreatePmbPayload {
  __typename?: 'CreatePmbPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pmb` that was created by this mutation. */
  pmb?: Maybe<Pmb>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pmb`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pmb`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pmb`. May be used by Relay 1. */
  pmbEdge?: Maybe<PmbsEdge>;
}


/** The output of our create `Pmb` mutation. */
export type CreatePmbPayloadPmbEdgeArgs = {
  orderBy?: Maybe<Array<PmbsOrderBy>>;
};

/** All input for the create `ProcessingQueue` mutation. */
export interface CreateProcessingQueueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProcessingQueue` to be created by this mutation. */
  processingQueue: ProcessingQueueInput;
}

/** The output of our create `ProcessingQueue` mutation. */
export interface CreateProcessingQueuePayload {
  __typename?: 'CreateProcessingQueuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProcessingQueue` that was created by this mutation. */
  processingQueue?: Maybe<ProcessingQueue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `ProcessingQueue`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `ProcessingQueue`. May be used by Relay 1. */
  processingQueueEdge?: Maybe<ProcessingQueuesEdge>;
}


/** The output of our create `ProcessingQueue` mutation. */
export type CreateProcessingQueuePayloadProcessingQueueEdgeArgs = {
  orderBy?: Maybe<Array<ProcessingQueuesOrderBy>>;
};

/** All input for the create `QueueSetting` mutation. */
export interface CreateQueueSettingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `QueueSetting` to be created by this mutation. */
  queueSetting: QueueSettingInput;
}

/** The output of our create `QueueSetting` mutation. */
export interface CreateQueueSettingPayload {
  __typename?: 'CreateQueueSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `QueueSetting` that was created by this mutation. */
  queueSetting?: Maybe<QueueSetting>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `QueueSetting`. */
  userByUserIdEditor?: Maybe<User>;
  /** An edge for our `QueueSetting`. May be used by Relay 1. */
  queueSettingEdge?: Maybe<QueueSettingsEdge>;
}


/** The output of our create `QueueSetting` mutation. */
export type CreateQueueSettingPayloadQueueSettingEdgeArgs = {
  orderBy?: Maybe<Array<QueueSettingsOrderBy>>;
};

/** All input for the create `RandomizationTicket` mutation. */
export interface CreateRandomizationTicketInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `RandomizationTicket` to be created by this mutation. */
  randomizationTicket: RandomizationTicketInput;
}

/** The output of our create `RandomizationTicket` mutation. */
export interface CreateRandomizationTicketPayload {
  __typename?: 'CreateRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `RandomizationTicket` that was created by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
}


/** The output of our create `RandomizationTicket` mutation. */
export type CreateRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the create `Sbqr` mutation. */
export interface CreateSbqrInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sbqr` to be created by this mutation. */
  sbqr: SbqrInput;
}

/** The output of our create `Sbqr` mutation. */
export interface CreateSbqrPayload {
  __typename?: 'CreateSbqrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sbqr` that was created by this mutation. */
  sbqr?: Maybe<Sbqr>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sbqr`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sbqr`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sbqr`. May be used by Relay 1. */
  sbqrEdge?: Maybe<SbqrsEdge>;
}


/** The output of our create `Sbqr` mutation. */
export type CreateSbqrPayloadSbqrEdgeArgs = {
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
};

/** All input for the create `Scaling` mutation. */
export interface CreateScalingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Scaling` to be created by this mutation. */
  scaling: ScalingInput;
}

/** The output of our create `Scaling` mutation. */
export interface CreateScalingPayload {
  __typename?: 'CreateScalingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Scaling` that was created by this mutation. */
  scaling?: Maybe<Scaling>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Scaling`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Scaling`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Scaling`. May be used by Relay 1. */
  scalingEdge?: Maybe<ScalingsEdge>;
}


/** The output of our create `Scaling` mutation. */
export type CreateScalingPayloadScalingEdgeArgs = {
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
};

/** All input for the create `Sewip` mutation. */
export interface CreateSewipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sewip` to be created by this mutation. */
  sewip: SewipInput;
}

/** The output of our create `Sewip` mutation. */
export interface CreateSewipPayload {
  __typename?: 'CreateSewipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sewip` that was created by this mutation. */
  sewip?: Maybe<Sewip>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sewip`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sewip`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sewip`. May be used by Relay 1. */
  sewipEdge?: Maybe<SewipsEdge>;
}


/** The output of our create `Sewip` mutation. */
export type CreateSewipPayloadSewipEdgeArgs = {
  orderBy?: Maybe<Array<SewipsOrderBy>>;
};

/** All input for the create `Sib` mutation. */
export interface CreateSibInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sib` to be created by this mutation. */
  sib: SibInput;
}

/** The output of our create `Sib` mutation. */
export interface CreateSibPayload {
  __typename?: 'CreateSibPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sib` that was created by this mutation. */
  sib?: Maybe<Sib>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sib`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sib`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sib`. May be used by Relay 1. */
  sibEdge?: Maybe<SibsEdge>;
}


/** The output of our create `Sib` mutation. */
export type CreateSibPayloadSibEdgeArgs = {
  orderBy?: Maybe<Array<SibsOrderBy>>;
};

/** All input for the create `SuicideNote` mutation. */
export interface CreateSuicideNoteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `SuicideNote` to be created by this mutation. */
  suicideNote: SuicideNoteInput;
}

/** The output of our create `SuicideNote` mutation. */
export interface CreateSuicideNotePayload {
  __typename?: 'CreateSuicideNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `SuicideNote` that was created by this mutation. */
  suicideNote?: Maybe<SuicideNote>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByUserIdCreator?: Maybe<Case>;
  /** An edge for our `SuicideNote`. May be used by Relay 1. */
  suicideNoteEdge?: Maybe<SuicideNotesEdge>;
}


/** The output of our create `SuicideNote` mutation. */
export type CreateSuicideNotePayloadSuicideNoteEdgeArgs = {
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
};

/** All input for the create `Taq` mutation. */
export interface CreateTaqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Taq` to be created by this mutation. */
  taq: TaqInput;
}

/** The output of our create `Taq` mutation. */
export interface CreateTaqPayload {
  __typename?: 'CreateTaqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Taq` that was created by this mutation. */
  taq?: Maybe<Taq>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Taq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Taq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Taq`. May be used by Relay 1. */
  taqEdge?: Maybe<TaqsEdge>;
}


/** The output of our create `Taq` mutation. */
export type CreateTaqPayloadTaqEdgeArgs = {
  orderBy?: Maybe<Array<TaqsOrderBy>>;
};

/** All input for the create `Tgisrplus` mutation. */
export interface CreateTgisrplusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Tgisrplus` to be created by this mutation. */
  tgisrplus: TgisrplusInput;
}

/** The output of our create `Tgisrplus` mutation. */
export interface CreateTgisrplusPayload {
  __typename?: 'CreateTgisrplusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Tgisrplus` that was created by this mutation. */
  tgisrplus?: Maybe<Tgisrplus>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Tgisrplus`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Tgisrplus`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Tgisrplus`. May be used by Relay 1. */
  tgisrplusEdge?: Maybe<TgisrplusesEdge>;
}


/** The output of our create `Tgisrplus` mutation. */
export type CreateTgisrplusPayloadTgisrplusEdgeArgs = {
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
};

/** All input for the create `Traumaliste` mutation. */
export interface CreateTraumalisteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumaliste` to be created by this mutation. */
  traumaliste: TraumalisteInput;
}

/** All input for the create `Traumalisteneu` mutation. */
export interface CreateTraumalisteneuInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumalisteneu` to be created by this mutation. */
  traumalisteneu: TraumalisteneuInput;
}

/** The output of our create `Traumalisteneu` mutation. */
export interface CreateTraumalisteneuPayload {
  __typename?: 'CreateTraumalisteneuPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumalisteneu` that was created by this mutation. */
  traumalisteneu?: Maybe<Traumalisteneu>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumalisteneu`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumalisteneu`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumalisteneu`. May be used by Relay 1. */
  traumalisteneuEdge?: Maybe<TraumalisteneusEdge>;
}


/** The output of our create `Traumalisteneu` mutation. */
export type CreateTraumalisteneuPayloadTraumalisteneuEdgeArgs = {
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
};

/** The output of our create `Traumaliste` mutation. */
export interface CreateTraumalistePayload {
  __typename?: 'CreateTraumalistePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumaliste` that was created by this mutation. */
  traumaliste?: Maybe<Traumaliste>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumaliste`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumaliste`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumaliste`. May be used by Relay 1. */
  traumalisteEdge?: Maybe<TraumalistesEdge>;
}


/** The output of our create `Traumaliste` mutation. */
export type CreateTraumalistePayloadTraumalisteEdgeArgs = {
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
};

/** All input for the create `Trgi` mutation. */
export interface CreateTrgiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Trgi` to be created by this mutation. */
  trgi: TrgiInput;
}

/** The output of our create `Trgi` mutation. */
export interface CreateTrgiPayload {
  __typename?: 'CreateTrgiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Trgi` that was created by this mutation. */
  trgi?: Maybe<Trgi>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Trgi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Trgi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Trgi`. May be used by Relay 1. */
  trgiEdge?: Maybe<TrgisEdge>;
}


/** The output of our create `Trgi` mutation. */
export type CreateTrgiPayloadTrgiEdgeArgs = {
  orderBy?: Maybe<Array<TrgisOrderBy>>;
};

/** All input for the create `User` mutation. */
export interface CreateUserInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
}

/** The output of our create `User` mutation. */
export interface CreateUserPayload {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
}


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

/** All input for the create `Wai` mutation. */
export interface CreateWaiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Wai` to be created by this mutation. */
  wai: WaiInput;
}

/** The output of our create `Wai` mutation. */
export interface CreateWaiPayload {
  __typename?: 'CreateWaiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Wai` that was created by this mutation. */
  wai?: Maybe<Wai>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Wai`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Wai`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Wai`. May be used by Relay 1. */
  waiEdge?: Maybe<WaisEdge>;
}


/** The output of our create `Wai` mutation. */
export type CreateWaiPayloadWaiEdgeArgs = {
  orderBy?: Maybe<Array<WaisOrderBy>>;
};



/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export interface DateFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Date']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['Date']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['Date']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['Date']>;
}


/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export interface DatetimeFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Datetime']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['Datetime']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['Datetime']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['Datetime']>;
}

/** A range of `Datetime`. */
export interface DatetimeRange {
  __typename?: 'DatetimeRange';
  /** The starting bound of our range. */
  start?: Maybe<DatetimeRangeBound>;
  /** The ending bound of our range. */
  end?: Maybe<DatetimeRangeBound>;
}

/** The value at one end of a range. A range can either include this value, or not. */
export interface DatetimeRangeBound {
  __typename?: 'DatetimeRangeBound';
  /** The value at one end of our range. */
  value: Scalars['Datetime'];
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
}

/** The value at one end of a range. A range can either include this value, or not. */
export interface DatetimeRangeBoundInput {
  /** The value at one end of our range. */
  value: Scalars['Datetime'];
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
}

/** A filter to be used against DatetimeRange fields. All fields are combined with a logical ‘and.’ */
export interface DatetimeRangeFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<DatetimeRangeInput>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<DatetimeRangeInput>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<DatetimeRangeInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<DatetimeRangeInput>;
  /** Included in the specified list. */
  in?: Maybe<Array<DatetimeRangeInput>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<DatetimeRangeInput>>;
  /** Less than the specified value. */
  lessThan?: Maybe<DatetimeRangeInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<DatetimeRangeInput>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<DatetimeRangeInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<DatetimeRangeInput>;
  /** Contains the specified range. */
  contains?: Maybe<DatetimeRangeInput>;
  /** Contains the specified value. */
  containsElement?: Maybe<Scalars['Datetime']>;
  /** Contained by the specified range. */
  containedBy?: Maybe<DatetimeRangeInput>;
  /** Overlaps the specified range. */
  overlaps?: Maybe<DatetimeRangeInput>;
  /** Strictly left of the specified range. */
  strictlyLeftOf?: Maybe<DatetimeRangeInput>;
  /** Strictly right of the specified range. */
  strictlyRightOf?: Maybe<DatetimeRangeInput>;
  /** Does not extend right of the specified range. */
  notExtendsRightOf?: Maybe<DatetimeRangeInput>;
  /** Does not extend left of the specified range. */
  notExtendsLeftOf?: Maybe<DatetimeRangeInput>;
  /** Adjacent to the specified range. */
  adjacentTo?: Maybe<DatetimeRangeInput>;
}

/** A range of `Datetime`. */
export interface DatetimeRangeInput {
  /** The starting bound of our range. */
  start?: Maybe<DatetimeRangeBoundInput>;
  /** The ending bound of our range. */
  end?: Maybe<DatetimeRangeBoundInput>;
}

/** All input for the `deleteBdi2ById` mutation. */
export interface DeleteBdi2ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteBdi2` mutation. */
export interface DeleteBdi2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Bdi2` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Bdi2` mutation. */
export interface DeleteBdi2Payload {
  __typename?: 'DeleteBdi2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Bdi2` that was deleted by this mutation. */
  bdi2?: Maybe<Bdi2>;
  deletedBdi2Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Bdi2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Bdi2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Bdi2`. May be used by Relay 1. */
  bdi2Edge?: Maybe<Bdi2SEdge>;
}


/** The output of our delete `Bdi2` mutation. */
export type DeleteBdi2PayloadBdi2EdgeArgs = {
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
};

/** All input for the `deleteCaseById` mutation. */
export interface DeleteCaseByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCase` mutation. */
export interface DeleteCaseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Case` to be deleted. */
  nodeId: Scalars['ID'];
}

/** All input for the `deleteCaseMessageById` mutation. */
export interface DeleteCaseMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCaseMessage` mutation. */
export interface DeleteCaseMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CaseMessage` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CaseMessage` mutation. */
export interface DeleteCaseMessagePayload {
  __typename?: 'DeleteCaseMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseMessage` that was deleted by this mutation. */
  caseMessage?: Maybe<CaseMessage>;
  deletedCaseMessageId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseMessage`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseMessage`. */
  userBySenderId?: Maybe<User>;
  /** Reads a single `CaseMember` that is related to this `CaseMessage`. */
  caseMemberByCaseIdAndSenderId?: Maybe<CaseMember>;
  /** An edge for our `CaseMessage`. May be used by Relay 1. */
  caseMessageEdge?: Maybe<CaseMessagesEdge>;
}


/** The output of our delete `CaseMessage` mutation. */
export type DeleteCaseMessagePayloadCaseMessageEdgeArgs = {
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
};

/** The output of our delete `Case` mutation. */
export interface DeleteCasePayload {
  __typename?: 'DeleteCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Case` that was deleted by this mutation. */
  case?: Maybe<Case>;
  deletedCaseId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `MyInvolvement` that is related to this `Case`. */
  myInvolvementById?: Maybe<MyInvolvement>;
  /** An edge for our `Case`. May be used by Relay 1. */
  caseEdge?: Maybe<CasesEdge>;
}


/** The output of our delete `Case` mutation. */
export type DeleteCasePayloadCaseEdgeArgs = {
  orderBy?: Maybe<Array<CasesOrderBy>>;
};

/** All input for the `deleteCaseSuicideCallById` mutation. */
export interface DeleteCaseSuicideCallByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID of the suicidal call record. Will be set automatically */
  id: Scalars['UUID'];
}

/** All input for the `deleteCaseSuicideCall` mutation. */
export interface DeleteCaseSuicideCallInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CaseSuicideCall` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CaseSuicideCall` mutation. */
export interface DeleteCaseSuicideCallPayload {
  __typename?: 'DeleteCaseSuicideCallPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseSuicideCall` that was deleted by this mutation. */
  caseSuicideCall?: Maybe<CaseSuicideCall>;
  deletedCaseSuicideCallId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseSuicideCall`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseSuicideCall`. */
  userByUserIdCaller?: Maybe<User>;
  /** An edge for our `CaseSuicideCall`. May be used by Relay 1. */
  caseSuicideCallEdge?: Maybe<CaseSuicideCallsEdge>;
}


/** The output of our delete `CaseSuicideCall` mutation. */
export type DeleteCaseSuicideCallPayloadCaseSuicideCallEdgeArgs = {
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
};

/** All input for the `deleteCbtActivityById` mutation. */
export interface DeleteCbtActivityByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCbtActivity` mutation. */
export interface DeleteCbtActivityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtActivity` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CbtActivity` mutation. */
export interface DeleteCbtActivityPayload {
  __typename?: 'DeleteCbtActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtActivity` that was deleted by this mutation. */
  cbtActivity?: Maybe<CbtActivity>;
  deletedCbtActivityId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtActivity`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtActivity`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtActivity`. May be used by Relay 1. */
  cbtActivityEdge?: Maybe<CbtActivitiesEdge>;
}


/** The output of our delete `CbtActivity` mutation. */
export type DeleteCbtActivityPayloadCbtActivityEdgeArgs = {
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
};

/** All input for the `deleteCbtReframingById` mutation. */
export interface DeleteCbtReframingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCbtReframing` mutation. */
export interface DeleteCbtReframingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtReframing` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CbtReframing` mutation. */
export interface DeleteCbtReframingPayload {
  __typename?: 'DeleteCbtReframingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtReframing` that was deleted by this mutation. */
  cbtReframing?: Maybe<CbtReframing>;
  deletedCbtReframingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtReframing`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtReframing`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtReframing`. May be used by Relay 1. */
  cbtReframingEdge?: Maybe<CbtReframingsEdge>;
}


/** The output of our delete `CbtReframing` mutation. */
export type DeleteCbtReframingPayloadCbtReframingEdgeArgs = {
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
};

/** All input for the `deleteCbtThoughtById` mutation. */
export interface DeleteCbtThoughtByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCbtThought` mutation. */
export interface DeleteCbtThoughtInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtThought` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CbtThought` mutation. */
export interface DeleteCbtThoughtPayload {
  __typename?: 'DeleteCbtThoughtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtThought` that was deleted by this mutation. */
  cbtThought?: Maybe<CbtThought>;
  deletedCbtThoughtId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtThought`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtThought`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtThought`. May be used by Relay 1. */
  cbtThoughtEdge?: Maybe<CbtThoughtsEdge>;
}


/** The output of our delete `CbtThought` mutation. */
export type DeleteCbtThoughtPayloadCbtThoughtEdgeArgs = {
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
};

/** All input for the `deleteCdrisk10ById` mutation. */
export interface DeleteCdrisk10ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCdrisk10` mutation. */
export interface DeleteCdrisk10Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Cdrisk10` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Cdrisk10` mutation. */
export interface DeleteCdrisk10Payload {
  __typename?: 'DeleteCdrisk10Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Cdrisk10` that was deleted by this mutation. */
  cdrisk10?: Maybe<Cdrisk10>;
  deletedCdrisk10Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Cdrisk10`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Cdrisk10`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Cdrisk10`. May be used by Relay 1. */
  cdrisk10Edge?: Maybe<Cdrisk10SEdge>;
}


/** The output of our delete `Cdrisk10` mutation. */
export type DeleteCdrisk10PayloadCdrisk10EdgeArgs = {
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
};

/** All input for the `deleteCommentById` mutation. */
export interface DeleteCommentByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteComment` mutation. */
export interface DeleteCommentInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Comment` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Comment` mutation. */
export interface DeleteCommentPayload {
  __typename?: 'DeleteCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was deleted by this mutation. */
  comment?: Maybe<Comment>;
  deletedCommentId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Comment`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Comment`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
}


/** The output of our delete `Comment` mutation. */
export type DeleteCommentPayloadCommentEdgeArgs = {
  orderBy?: Maybe<Array<CommentsOrderBy>>;
};

/** All input for the `deleteCounselingQuestionById` mutation. */
export interface DeleteCounselingQuestionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteCounselingQuestion` mutation. */
export interface DeleteCounselingQuestionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CounselingQuestion` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `CounselingQuestion` mutation. */
export interface DeleteCounselingQuestionPayload {
  __typename?: 'DeleteCounselingQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CounselingQuestion` that was deleted by this mutation. */
  counselingQuestion?: Maybe<CounselingQuestion>;
  deletedCounselingQuestionId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CounselingQuestion`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CounselingQuestion`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CounselingQuestion`. May be used by Relay 1. */
  counselingQuestionEdge?: Maybe<CounselingQuestionsEdge>;
}


/** The output of our delete `CounselingQuestion` mutation. */
export type DeleteCounselingQuestionPayloadCounselingQuestionEdgeArgs = {
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
};

/** All input for the `deleteDemographicById` mutation. */
export interface DeleteDemographicByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteDemographic` mutation. */
export interface DeleteDemographicInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Demographic` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Demographic` mutation. */
export interface DeleteDemographicPayload {
  __typename?: 'DeleteDemographicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Demographic` that was deleted by this mutation. */
  demographic?: Maybe<Demographic>;
  deletedDemographicId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Demographic`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Demographic`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Demographic`. May be used by Relay 1. */
  demographicEdge?: Maybe<DemographicsEdge>;
}


/** The output of our delete `Demographic` mutation. */
export type DeleteDemographicPayloadDemographicEdgeArgs = {
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
};

/** All input for the `deleteDisclosureById` mutation. */
export interface DeleteDisclosureByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteDisclosure` mutation. */
export interface DeleteDisclosureInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Disclosure` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Disclosure` mutation. */
export interface DeleteDisclosurePayload {
  __typename?: 'DeleteDisclosurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Disclosure` that was deleted by this mutation. */
  disclosure?: Maybe<Disclosure>;
  deletedDisclosureId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Disclosure`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Disclosure`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Disclosure`. May be used by Relay 1. */
  disclosureEdge?: Maybe<DisclosuresEdge>;
}


/** The output of our delete `Disclosure` mutation. */
export type DeleteDisclosurePayloadDisclosureEdgeArgs = {
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
};

/** All input for the `deleteEurohiById` mutation. */
export interface DeleteEurohiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteEurohi` mutation. */
export interface DeleteEurohiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Eurohi` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Eurohi` mutation. */
export interface DeleteEurohiPayload {
  __typename?: 'DeleteEurohiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Eurohi` that was deleted by this mutation. */
  eurohi?: Maybe<Eurohi>;
  deletedEurohiId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Eurohi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Eurohi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Eurohi`. May be used by Relay 1. */
  eurohiEdge?: Maybe<EurohisEdge>;
}


/** The output of our delete `Eurohi` mutation. */
export type DeleteEurohiPayloadEurohiEdgeArgs = {
  orderBy?: Maybe<Array<EurohisOrderBy>>;
};

/** All input for the `deleteEvaluationById` mutation. */
export interface DeleteEvaluationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteEvaluation` mutation. */
export interface DeleteEvaluationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Evaluation` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Evaluation` mutation. */
export interface DeleteEvaluationPayload {
  __typename?: 'DeleteEvaluationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Evaluation` that was deleted by this mutation. */
  evaluation?: Maybe<Evaluation>;
  deletedEvaluationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Evaluation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Evaluation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Evaluation`. May be used by Relay 1. */
  evaluationEdge?: Maybe<EvaluationsEdge>;
}


/** The output of our delete `Evaluation` mutation. */
export type DeleteEvaluationPayloadEvaluationEdgeArgs = {
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
};

/** All input for the `deleteFeedbackInterviewReportById` mutation. */
export interface DeleteFeedbackInterviewReportByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteFeedbackInterviewReport` mutation. */
export interface DeleteFeedbackInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeedbackInterviewReport` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `FeedbackInterviewReport` mutation. */
export interface DeleteFeedbackInterviewReportPayload {
  __typename?: 'DeleteFeedbackInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeedbackInterviewReport` that was deleted by this mutation. */
  feedbackInterviewReport?: Maybe<FeedbackInterviewReport>;
  deletedFeedbackInterviewReportId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `FeedbackInterviewReport`. May be used by Relay 1. */
  feedbackInterviewReportEdge?: Maybe<FeedbackInterviewReportsEdge>;
}


/** The output of our delete `FeedbackInterviewReport` mutation. */
export type DeleteFeedbackInterviewReportPayloadFeedbackInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<FeedbackInterviewReportsOrderBy>>;
};

/** All input for the `deleteGad2ById` mutation. */
export interface DeleteGad2ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteGad2` mutation. */
export interface DeleteGad2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Gad2` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Gad2` mutation. */
export interface DeleteGad2Payload {
  __typename?: 'DeleteGad2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad2` that was deleted by this mutation. */
  gad2?: Maybe<Gad2>;
  deletedGad2Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad2`. May be used by Relay 1. */
  gad2Edge?: Maybe<Gad2SEdge>;
}


/** The output of our delete `Gad2` mutation. */
export type DeleteGad2PayloadGad2EdgeArgs = {
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
};

/** All input for the `deleteGad7ById` mutation. */
export interface DeleteGad7ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteGad7` mutation. */
export interface DeleteGad7Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Gad7` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Gad7` mutation. */
export interface DeleteGad7Payload {
  __typename?: 'DeleteGad7Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad7` that was deleted by this mutation. */
  gad7?: Maybe<Gad7>;
  deletedGad7Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad7`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad7`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad7`. May be used by Relay 1. */
  gad7Edge?: Maybe<Gad7SEdge>;
}


/** The output of our delete `Gad7` mutation. */
export type DeleteGad7PayloadGad7EdgeArgs = {
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
};

/** All input for the `deleteHashedEmailById` mutation. */
export interface DeleteHashedEmailByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteHashedEmail` mutation. */
export interface DeleteHashedEmailInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `HashedEmail` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `HashedEmail` mutation. */
export interface DeleteHashedEmailPayload {
  __typename?: 'DeleteHashedEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HashedEmail` that was deleted by this mutation. */
  hashedEmail?: Maybe<HashedEmail>;
  deletedHashedEmailId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `HashedEmail`. May be used by Relay 1. */
  hashedEmailEdge?: Maybe<HashedEmailsEdge>;
}


/** The output of our delete `HashedEmail` mutation. */
export type DeleteHashedEmailPayloadHashedEmailEdgeArgs = {
  orderBy?: Maybe<Array<HashedEmailsOrderBy>>;
};

/** All input for the `deleteInepById` mutation. */
export interface DeleteInepByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteInep` mutation. */
export interface DeleteInepInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Inep` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Inep` mutation. */
export interface DeleteInepPayload {
  __typename?: 'DeleteInepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Inep` that was deleted by this mutation. */
  inep?: Maybe<Inep>;
  deletedInepId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Inep`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Inep`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Inep`. May be used by Relay 1. */
  inepEdge?: Maybe<InepsEdge>;
}


/** The output of our delete `Inep` mutation. */
export type DeleteInepPayloadInepEdgeArgs = {
  orderBy?: Maybe<Array<InepsOrderBy>>;
};

/** All input for the `deleteInterviewBookingByIdAndCaseId` mutation. */
export interface DeleteInterviewBookingByIdAndCaseIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
}

/** All input for the `deleteInterviewBookingById` mutation. */
export interface DeleteInterviewBookingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteInterviewBooking` mutation. */
export interface DeleteInterviewBookingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewBooking` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `InterviewBooking` mutation. */
export interface DeleteInterviewBookingPayload {
  __typename?: 'DeleteInterviewBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewBooking` that was deleted by this mutation. */
  interviewBooking?: Maybe<InterviewBooking>;
  deletedInterviewBookingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `InterviewBooking`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Involvement` that is related to this `InterviewBooking`. */
  involvementByCaseIdAndIntervieweeId?: Maybe<Involvement>;
  /** Reads a single `User` that is related to this `InterviewBooking`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewBooking`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `Interviewee` that is related to this `InterviewBooking`. */
  intervieweeByIntervieweeId?: Maybe<Interviewee>;
  /** An edge for our `InterviewBooking`. May be used by Relay 1. */
  interviewBookingEdge?: Maybe<InterviewBookingsEdge>;
}


/** The output of our delete `InterviewBooking` mutation. */
export type DeleteInterviewBookingPayloadInterviewBookingEdgeArgs = {
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
};

/** All input for the `deleteIntervieweeById` mutation. */
export interface DeleteIntervieweeByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our delete `Interviewee` mutation. */
export interface DeleteIntervieweePayload {
  __typename?: 'DeleteIntervieweePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewee` that was deleted by this mutation. */
  interviewee?: Maybe<Interviewee>;
  deletedIntervieweeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewee`. May be used by Relay 1. */
  intervieweeEdge?: Maybe<IntervieweesEdge>;
}


/** The output of our delete `Interviewee` mutation. */
export type DeleteIntervieweePayloadIntervieweeEdgeArgs = {
  orderBy?: Maybe<Array<IntervieweesOrderBy>>;
};

/** All input for the `deleteInterviewerById` mutation. */
export interface DeleteInterviewerByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our delete `Interviewer` mutation. */
export interface DeleteInterviewerPayload {
  __typename?: 'DeleteInterviewerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewer` that was deleted by this mutation. */
  interviewer?: Maybe<Interviewer>;
  deletedInterviewerId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewer`. May be used by Relay 1. */
  interviewerEdge?: Maybe<InterviewersEdge>;
}


/** The output of our delete `Interviewer` mutation. */
export type DeleteInterviewerPayloadInterviewerEdgeArgs = {
  orderBy?: Maybe<Array<InterviewersOrderBy>>;
};

/** All input for the `deleteInterviewOfferById` mutation. */
export interface DeleteInterviewOfferByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteInterviewOffer` mutation. */
export interface DeleteInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewOffer` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `InterviewOffer` mutation. */
export interface DeleteInterviewOfferPayload {
  __typename?: 'DeleteInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewOffer` that was deleted by this mutation. */
  interviewOffer?: Maybe<InterviewOffer>;
  deletedInterviewOfferId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `InterviewOffer`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `Interviewer` that is related to this `InterviewOffer`. */
  interviewerByInterviewerId?: Maybe<Interviewer>;
  /** An edge for our `InterviewOffer`. May be used by Relay 1. */
  interviewOfferEdge?: Maybe<InterviewOffersEdge>;
}


/** The output of our delete `InterviewOffer` mutation. */
export type DeleteInterviewOfferPayloadInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
};

/** All input for the `deleteInterviewReportById` mutation. */
export interface DeleteInterviewReportByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteInterviewReport` mutation. */
export interface DeleteInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewReport` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `InterviewReport` mutation. */
export interface DeleteInterviewReportPayload {
  __typename?: 'DeleteInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewReport` that was deleted by this mutation. */
  interviewReport?: Maybe<InterviewReport>;
  deletedInterviewReportId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingId?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingIdAndCaseId?: Maybe<InterviewBooking>;
  /** Reads a single `Case` that is related to this `InterviewReport`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `InterviewReport`. */
  userByInterviewerId?: Maybe<User>;
  /** An edge for our `InterviewReport`. May be used by Relay 1. */
  interviewReportEdge?: Maybe<InterviewReportsEdge>;
}


/** The output of our delete `InterviewReport` mutation. */
export type DeleteInterviewReportPayloadInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
};

/** All input for the `deleteInvolvementById` mutation. */
export interface DeleteInvolvementByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteInvolvement` mutation. */
export interface DeleteInvolvementInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Involvement` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Involvement` mutation. */
export interface DeleteInvolvementPayload {
  __typename?: 'DeleteInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Involvement` that was deleted by this mutation. */
  involvement?: Maybe<Involvement>;
  deletedInvolvementId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Involvement`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Case` that is related to this `Involvement`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `Involvement`. May be used by Relay 1. */
  involvementEdge?: Maybe<InvolvementsEdge>;
}


/** The output of our delete `Involvement` mutation. */
export type DeleteInvolvementPayloadInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
};

/** All input for the `deleteIptConflictById` mutation. */
export interface DeleteIptConflictByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteIptConflict` mutation. */
export interface DeleteIptConflictInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptConflict` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `IptConflict` mutation. */
export interface DeleteIptConflictPayload {
  __typename?: 'DeleteIptConflictPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptConflict` that was deleted by this mutation. */
  iptConflict?: Maybe<IptConflict>;
  deletedIptConflictId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptConflict`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptConflict`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptConflict`. May be used by Relay 1. */
  iptConflictEdge?: Maybe<IptConflictsEdge>;
}


/** The output of our delete `IptConflict` mutation. */
export type DeleteIptConflictPayloadIptConflictEdgeArgs = {
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
};

/** All input for the `deleteIptRelationshipById` mutation. */
export interface DeleteIptRelationshipByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteIptRelationship` mutation. */
export interface DeleteIptRelationshipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptRelationship` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `IptRelationship` mutation. */
export interface DeleteIptRelationshipPayload {
  __typename?: 'DeleteIptRelationshipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptRelationship` that was deleted by this mutation. */
  iptRelationship?: Maybe<IptRelationship>;
  deletedIptRelationshipId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptRelationship`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptRelationship`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptRelationship`. May be used by Relay 1. */
  iptRelationshipEdge?: Maybe<IptRelationshipsEdge>;
}


/** The output of our delete `IptRelationship` mutation. */
export type DeleteIptRelationshipPayloadIptRelationshipEdgeArgs = {
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
};

/** All input for the `deleteIptSituationById` mutation. */
export interface DeleteIptSituationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteIptSituation` mutation. */
export interface DeleteIptSituationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptSituation` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `IptSituation` mutation. */
export interface DeleteIptSituationPayload {
  __typename?: 'DeleteIptSituationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptSituation` that was deleted by this mutation. */
  iptSituation?: Maybe<IptSituation>;
  deletedIptSituationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptSituation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptSituation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptSituation`. May be used by Relay 1. */
  iptSituationEdge?: Maybe<IptSituationsEdge>;
}


/** The output of our delete `IptSituation` mutation. */
export type DeleteIptSituationPayloadIptSituationEdgeArgs = {
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
};

/** All input for the `deleteItqById` mutation. */
export interface DeleteItqByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteItq` mutation. */
export interface DeleteItqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Itq` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Itq` mutation. */
export interface DeleteItqPayload {
  __typename?: 'DeleteItqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Itq` that was deleted by this mutation. */
  itq?: Maybe<Itq>;
  deletedItqId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Itq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Itq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Itq`. May be used by Relay 1. */
  itqEdge?: Maybe<ItqsEdge>;
}


/** The output of our delete `Itq` mutation. */
export type DeleteItqPayloadItqEdgeArgs = {
  orderBy?: Maybe<Array<ItqsOrderBy>>;
};

/** All input for the `deleteLec5ById` mutation. */
export interface DeleteLec5ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteLec5` mutation. */
export interface DeleteLec5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lec5` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Lec5` mutation. */
export interface DeleteLec5Payload {
  __typename?: 'DeleteLec5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lec5` that was deleted by this mutation. */
  lec5?: Maybe<Lec5>;
  deletedLec5Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lec5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lec5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lec5`. May be used by Relay 1. */
  lec5Edge?: Maybe<Lec5SEdge>;
}


/** The output of our delete `Lec5` mutation. */
export type DeleteLec5PayloadLec5EdgeArgs = {
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
};

/** All input for the `deleteLetterById` mutation. */
export interface DeleteLetterByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteLetter` mutation. */
export interface DeleteLetterInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Letter` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Letter` mutation. */
export interface DeleteLetterPayload {
  __typename?: 'DeleteLetterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Letter` that was deleted by this mutation. */
  letter?: Maybe<Letter>;
  deletedLetterId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Letter`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Letter`. */
  userBySenderId?: Maybe<User>;
  /** An edge for our `Letter`. May be used by Relay 1. */
  letterEdge?: Maybe<LettersEdge>;
}


/** The output of our delete `Letter` mutation. */
export type DeleteLetterPayloadLetterEdgeArgs = {
  orderBy?: Maybe<Array<LettersOrderBy>>;
};

/** All input for the `deleteLetterTemplateById` mutation. */
export interface DeleteLetterTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteLetterTemplate` mutation. */
export interface DeleteLetterTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LetterTemplate` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `LetterTemplate` mutation. */
export interface DeleteLetterTemplatePayload {
  __typename?: 'DeleteLetterTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LetterTemplate` that was deleted by this mutation. */
  letterTemplate?: Maybe<LetterTemplate>;
  deletedLetterTemplateId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LetterTemplate`. */
  userByEditorId?: Maybe<User>;
  /** An edge for our `LetterTemplate`. May be used by Relay 1. */
  letterTemplateEdge?: Maybe<LetterTemplatesEdge>;
}


/** The output of our delete `LetterTemplate` mutation. */
export type DeleteLetterTemplatePayloadLetterTemplateEdgeArgs = {
  orderBy?: Maybe<Array<LetterTemplatesOrderBy>>;
};

/** All input for the `deleteLoginTokenById` mutation. */
export interface DeleteLoginTokenByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteLoginToken` mutation. */
export interface DeleteLoginTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LoginToken` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `LoginToken` mutation. */
export interface DeleteLoginTokenPayload {
  __typename?: 'DeleteLoginTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LoginToken` that was deleted by this mutation. */
  loginToken?: Maybe<LoginToken>;
  deletedLoginTokenId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LoginToken`. */
  userByUserId?: Maybe<User>;
  /** An edge for our `LoginToken`. May be used by Relay 1. */
  loginTokenEdge?: Maybe<LoginTokensEdge>;
}


/** The output of our delete `LoginToken` mutation. */
export type DeleteLoginTokenPayloadLoginTokenEdgeArgs = {
  orderBy?: Maybe<Array<LoginTokensOrderBy>>;
};

/** All input for the `deleteLsaById` mutation. */
export interface DeleteLsaByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteLsa` mutation. */
export interface DeleteLsaInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lsa` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Lsa` mutation. */
export interface DeleteLsaPayload {
  __typename?: 'DeleteLsaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lsa` that was deleted by this mutation. */
  lsa?: Maybe<Lsa>;
  deletedLsaId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lsa`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lsa`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lsa`. May be used by Relay 1. */
  lsaEdge?: Maybe<LsasEdge>;
}


/** The output of our delete `Lsa` mutation. */
export type DeleteLsaPayloadLsaEdgeArgs = {
  orderBy?: Maybe<Array<LsasOrderBy>>;
};

/** All input for the `deleteMspssById` mutation. */
export interface DeleteMspssByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteMspss` mutation. */
export interface DeleteMspssInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Mspss` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Mspss` mutation. */
export interface DeleteMspssPayload {
  __typename?: 'DeleteMspssPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Mspss` that was deleted by this mutation. */
  mspss?: Maybe<Mspss>;
  deletedMspssId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Mspss`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Mspss`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Mspss`. May be used by Relay 1. */
  mspssEdge?: Maybe<MspssesEdge>;
}


/** The output of our delete `Mspss` mutation. */
export type DeleteMspssPayloadMspssEdgeArgs = {
  orderBy?: Maybe<Array<MspssesOrderBy>>;
};

/** All input for the `deleteMyInvolvementByCaseId` mutation. */
export interface DeleteMyInvolvementByCaseIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  caseId: Scalars['UUID'];
}

/** The output of our delete `MyInvolvement` mutation. */
export interface DeleteMyInvolvementPayload {
  __typename?: 'DeleteMyInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInvolvement` that was deleted by this mutation. */
  myInvolvement?: Maybe<MyInvolvement>;
  deletedMyInvolvementId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyInvolvement`. May be used by Relay 1. */
  myInvolvementEdge?: Maybe<MyInvolvementsEdge>;
}


/** The output of our delete `MyInvolvement` mutation. */
export type DeleteMyInvolvementPayloadMyInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<MyInvolvementsOrderBy>>;
};

/** All input for the `deletePathevById` mutation. */
export interface DeletePathevByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePathev` mutation. */
export interface DeletePathevInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pathev` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Pathev` mutation. */
export interface DeletePathevPayload {
  __typename?: 'DeletePathevPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pathev` that was deleted by this mutation. */
  pathev?: Maybe<Pathev>;
  deletedPathevId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pathev`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pathev`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pathev`. May be used by Relay 1. */
  pathevEdge?: Maybe<PathevsEdge>;
}


/** The output of our delete `Pathev` mutation. */
export type DeletePathevPayloadPathevEdgeArgs = {
  orderBy?: Maybe<Array<PathevsOrderBy>>;
};

/** All input for the `deletePcl5ById` mutation. */
export interface DeletePcl5ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePcl5` mutation. */
export interface DeletePcl5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pcl5` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Pcl5` mutation. */
export interface DeletePcl5Payload {
  __typename?: 'DeletePcl5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pcl5` that was deleted by this mutation. */
  pcl5?: Maybe<Pcl5>;
  deletedPcl5Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pcl5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pcl5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pcl5`. May be used by Relay 1. */
  pcl5Edge?: Maybe<Pcl5SEdge>;
}


/** The output of our delete `Pcl5` mutation. */
export type DeletePcl5PayloadPcl5EdgeArgs = {
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
};

/** All input for the `deletePg13ById` mutation. */
export interface DeletePg13ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePg13` mutation. */
export interface DeletePg13Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pg13` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Pg13` mutation. */
export interface DeletePg13Payload {
  __typename?: 'DeletePg13Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pg13` that was deleted by this mutation. */
  pg13?: Maybe<Pg13>;
  deletedPg13Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pg13`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pg13`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pg13`. May be used by Relay 1. */
  pg13Edge?: Maybe<Pg13SEdge>;
}


/** The output of our delete `Pg13` mutation. */
export type DeletePg13PayloadPg13EdgeArgs = {
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
};

/** All input for the `deletePhq15ById` mutation. */
export interface DeletePhq15ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePhq15` mutation. */
export interface DeletePhq15Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq15` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Phq15` mutation. */
export interface DeletePhq15Payload {
  __typename?: 'DeletePhq15Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq15` that was deleted by this mutation. */
  phq15?: Maybe<Phq15>;
  deletedPhq15Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq15`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq15`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq15`. May be used by Relay 1. */
  phq15Edge?: Maybe<Phq15SEdge>;
}


/** The output of our delete `Phq15` mutation. */
export type DeletePhq15PayloadPhq15EdgeArgs = {
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
};

/** All input for the `deletePhq4ById` mutation. */
export interface DeletePhq4ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePhq4` mutation. */
export interface DeletePhq4Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq4` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Phq4` mutation. */
export interface DeletePhq4Payload {
  __typename?: 'DeletePhq4Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq4` that was deleted by this mutation. */
  phq4?: Maybe<Phq4>;
  deletedPhq4Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq4`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq4`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq4`. May be used by Relay 1. */
  phq4Edge?: Maybe<Phq4SEdge>;
}


/** The output of our delete `Phq4` mutation. */
export type DeletePhq4PayloadPhq4EdgeArgs = {
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
};

/** All input for the `deletePhq9ById` mutation. */
export interface DeletePhq9ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePhq9` mutation. */
export interface DeletePhq9Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq9` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Phq9` mutation. */
export interface DeletePhq9Payload {
  __typename?: 'DeletePhq9Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq9` that was deleted by this mutation. */
  phq9?: Maybe<Phq9>;
  deletedPhq9Id?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq9`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq9`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq9`. May be used by Relay 1. */
  phq9Edge?: Maybe<Phq9SEdge>;
}


/** The output of our delete `Phq9` mutation. */
export type DeletePhq9PayloadPhq9EdgeArgs = {
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
};

/** All input for the `deletePmbById` mutation. */
export interface DeletePmbByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deletePmb` mutation. */
export interface DeletePmbInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pmb` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Pmb` mutation. */
export interface DeletePmbPayload {
  __typename?: 'DeletePmbPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pmb` that was deleted by this mutation. */
  pmb?: Maybe<Pmb>;
  deletedPmbId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pmb`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pmb`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pmb`. May be used by Relay 1. */
  pmbEdge?: Maybe<PmbsEdge>;
}


/** The output of our delete `Pmb` mutation. */
export type DeletePmbPayloadPmbEdgeArgs = {
  orderBy?: Maybe<Array<PmbsOrderBy>>;
};

/** All input for the `deleteProcessingQueueById` mutation. */
export interface DeleteProcessingQueueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteProcessingQueue` mutation. */
export interface DeleteProcessingQueueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProcessingQueue` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `ProcessingQueue` mutation. */
export interface DeleteProcessingQueuePayload {
  __typename?: 'DeleteProcessingQueuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProcessingQueue` that was deleted by this mutation. */
  processingQueue?: Maybe<ProcessingQueue>;
  deletedProcessingQueueId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `ProcessingQueue`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `ProcessingQueue`. May be used by Relay 1. */
  processingQueueEdge?: Maybe<ProcessingQueuesEdge>;
}


/** The output of our delete `ProcessingQueue` mutation. */
export type DeleteProcessingQueuePayloadProcessingQueueEdgeArgs = {
  orderBy?: Maybe<Array<ProcessingQueuesOrderBy>>;
};

/** All input for the `deleteQueueSettingById` mutation. */
export interface DeleteQueueSettingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteQueueSetting` mutation. */
export interface DeleteQueueSettingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `QueueSetting` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `QueueSetting` mutation. */
export interface DeleteQueueSettingPayload {
  __typename?: 'DeleteQueueSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `QueueSetting` that was deleted by this mutation. */
  queueSetting?: Maybe<QueueSetting>;
  deletedQueueSettingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `QueueSetting`. */
  userByUserIdEditor?: Maybe<User>;
  /** An edge for our `QueueSetting`. May be used by Relay 1. */
  queueSettingEdge?: Maybe<QueueSettingsEdge>;
}


/** The output of our delete `QueueSetting` mutation. */
export type DeleteQueueSettingPayloadQueueSettingEdgeArgs = {
  orderBy?: Maybe<Array<QueueSettingsOrderBy>>;
};

/** All input for the `deleteRandomizationTicketById` mutation. */
export interface DeleteRandomizationTicketByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteRandomizationTicket` mutation. */
export interface DeleteRandomizationTicketInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RandomizationTicket` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `RandomizationTicket` mutation. */
export interface DeleteRandomizationTicketPayload {
  __typename?: 'DeleteRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `RandomizationTicket` that was deleted by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  deletedRandomizationTicketId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
}


/** The output of our delete `RandomizationTicket` mutation. */
export type DeleteRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the `deleteSbqrById` mutation. */
export interface DeleteSbqrByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSbqr` mutation. */
export interface DeleteSbqrInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sbqr` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Sbqr` mutation. */
export interface DeleteSbqrPayload {
  __typename?: 'DeleteSbqrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sbqr` that was deleted by this mutation. */
  sbqr?: Maybe<Sbqr>;
  deletedSbqrId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sbqr`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sbqr`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sbqr`. May be used by Relay 1. */
  sbqrEdge?: Maybe<SbqrsEdge>;
}


/** The output of our delete `Sbqr` mutation. */
export type DeleteSbqrPayloadSbqrEdgeArgs = {
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
};

/** All input for the `deleteScalingById` mutation. */
export interface DeleteScalingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteScaling` mutation. */
export interface DeleteScalingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Scaling` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Scaling` mutation. */
export interface DeleteScalingPayload {
  __typename?: 'DeleteScalingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Scaling` that was deleted by this mutation. */
  scaling?: Maybe<Scaling>;
  deletedScalingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Scaling`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Scaling`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Scaling`. May be used by Relay 1. */
  scalingEdge?: Maybe<ScalingsEdge>;
}


/** The output of our delete `Scaling` mutation. */
export type DeleteScalingPayloadScalingEdgeArgs = {
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
};

/** All input for the `deleteSewipById` mutation. */
export interface DeleteSewipByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSewip` mutation. */
export interface DeleteSewipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sewip` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Sewip` mutation. */
export interface DeleteSewipPayload {
  __typename?: 'DeleteSewipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sewip` that was deleted by this mutation. */
  sewip?: Maybe<Sewip>;
  deletedSewipId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sewip`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sewip`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sewip`. May be used by Relay 1. */
  sewipEdge?: Maybe<SewipsEdge>;
}


/** The output of our delete `Sewip` mutation. */
export type DeleteSewipPayloadSewipEdgeArgs = {
  orderBy?: Maybe<Array<SewipsOrderBy>>;
};

/** All input for the `deleteSibById` mutation. */
export interface DeleteSibByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteSib` mutation. */
export interface DeleteSibInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sib` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Sib` mutation. */
export interface DeleteSibPayload {
  __typename?: 'DeleteSibPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sib` that was deleted by this mutation. */
  sib?: Maybe<Sib>;
  deletedSibId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sib`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sib`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sib`. May be used by Relay 1. */
  sibEdge?: Maybe<SibsEdge>;
}


/** The output of our delete `Sib` mutation. */
export type DeleteSibPayloadSibEdgeArgs = {
  orderBy?: Maybe<Array<SibsOrderBy>>;
};

/** All input for the `deleteSuicideNoteById` mutation. */
export interface DeleteSuicideNoteByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Primary key of suicide notes */
  id: Scalars['UUID'];
}

/** All input for the `deleteSuicideNote` mutation. */
export interface DeleteSuicideNoteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuicideNote` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `SuicideNote` mutation. */
export interface DeleteSuicideNotePayload {
  __typename?: 'DeleteSuicideNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `SuicideNote` that was deleted by this mutation. */
  suicideNote?: Maybe<SuicideNote>;
  deletedSuicideNoteId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByUserIdCreator?: Maybe<Case>;
  /** An edge for our `SuicideNote`. May be used by Relay 1. */
  suicideNoteEdge?: Maybe<SuicideNotesEdge>;
}


/** The output of our delete `SuicideNote` mutation. */
export type DeleteSuicideNotePayloadSuicideNoteEdgeArgs = {
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
};

/** All input for the `deleteTaqById` mutation. */
export interface DeleteTaqByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteTaq` mutation. */
export interface DeleteTaqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Taq` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Taq` mutation. */
export interface DeleteTaqPayload {
  __typename?: 'DeleteTaqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Taq` that was deleted by this mutation. */
  taq?: Maybe<Taq>;
  deletedTaqId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Taq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Taq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Taq`. May be used by Relay 1. */
  taqEdge?: Maybe<TaqsEdge>;
}


/** The output of our delete `Taq` mutation. */
export type DeleteTaqPayloadTaqEdgeArgs = {
  orderBy?: Maybe<Array<TaqsOrderBy>>;
};

/** All input for the `deleteTgisrplusById` mutation. */
export interface DeleteTgisrplusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteTgisrplus` mutation. */
export interface DeleteTgisrplusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Tgisrplus` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Tgisrplus` mutation. */
export interface DeleteTgisrplusPayload {
  __typename?: 'DeleteTgisrplusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Tgisrplus` that was deleted by this mutation. */
  tgisrplus?: Maybe<Tgisrplus>;
  deletedTgisrplusId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Tgisrplus`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Tgisrplus`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Tgisrplus`. May be used by Relay 1. */
  tgisrplusEdge?: Maybe<TgisrplusesEdge>;
}


/** The output of our delete `Tgisrplus` mutation. */
export type DeleteTgisrplusPayloadTgisrplusEdgeArgs = {
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
};

/** All input for the `deleteTraumalisteById` mutation. */
export interface DeleteTraumalisteByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteTraumaliste` mutation. */
export interface DeleteTraumalisteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Traumaliste` to be deleted. */
  nodeId: Scalars['ID'];
}

/** All input for the `deleteTraumalisteneuById` mutation. */
export interface DeleteTraumalisteneuByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteTraumalisteneu` mutation. */
export interface DeleteTraumalisteneuInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Traumalisteneu` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Traumalisteneu` mutation. */
export interface DeleteTraumalisteneuPayload {
  __typename?: 'DeleteTraumalisteneuPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumalisteneu` that was deleted by this mutation. */
  traumalisteneu?: Maybe<Traumalisteneu>;
  deletedTraumalisteneuId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumalisteneu`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumalisteneu`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumalisteneu`. May be used by Relay 1. */
  traumalisteneuEdge?: Maybe<TraumalisteneusEdge>;
}


/** The output of our delete `Traumalisteneu` mutation. */
export type DeleteTraumalisteneuPayloadTraumalisteneuEdgeArgs = {
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
};

/** The output of our delete `Traumaliste` mutation. */
export interface DeleteTraumalistePayload {
  __typename?: 'DeleteTraumalistePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumaliste` that was deleted by this mutation. */
  traumaliste?: Maybe<Traumaliste>;
  deletedTraumalisteId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumaliste`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumaliste`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumaliste`. May be used by Relay 1. */
  traumalisteEdge?: Maybe<TraumalistesEdge>;
}


/** The output of our delete `Traumaliste` mutation. */
export type DeleteTraumalistePayloadTraumalisteEdgeArgs = {
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
};

/** All input for the `deleteTrgiById` mutation. */
export interface DeleteTrgiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteTrgi` mutation. */
export interface DeleteTrgiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Trgi` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Trgi` mutation. */
export interface DeleteTrgiPayload {
  __typename?: 'DeleteTrgiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Trgi` that was deleted by this mutation. */
  trgi?: Maybe<Trgi>;
  deletedTrgiId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Trgi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Trgi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Trgi`. May be used by Relay 1. */
  trgiEdge?: Maybe<TrgisEdge>;
}


/** The output of our delete `Trgi` mutation. */
export type DeleteTrgiPayloadTrgiEdgeArgs = {
  orderBy?: Maybe<Array<TrgisOrderBy>>;
};

/** All input for the `deleteUserByEmail` mutation. */
export interface DeleteUserByEmailInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
}

/** All input for the `deleteUserById` mutation. */
export interface DeleteUserByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteUserByUsername` mutation. */
export interface DeleteUserByUsernameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
}

/** All input for the `deleteUser` mutation. */
export interface DeleteUserInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `User` mutation. */
export interface DeleteUserPayload {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  deletedUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
}


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteWaiById` mutation. */
export interface DeleteWaiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** All input for the `deleteWai` mutation. */
export interface DeleteWaiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Wai` to be deleted. */
  nodeId: Scalars['ID'];
}

/** The output of our delete `Wai` mutation. */
export interface DeleteWaiPayload {
  __typename?: 'DeleteWaiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Wai` that was deleted by this mutation. */
  wai?: Maybe<Wai>;
  deletedWaiId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Wai`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Wai`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Wai`. May be used by Relay 1. */
  waiEdge?: Maybe<WaisEdge>;
}


/** The output of our delete `Wai` mutation. */
export type DeleteWaiPayloadWaiEdgeArgs = {
  orderBy?: Maybe<Array<WaisOrderBy>>;
};

export interface Demographic extends Node {
  __typename?: 'Demographic';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  hasInternetAccess?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  age?: Maybe<Scalars['Int']>;
  gender?: Maybe<Gender>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  countryOfResidence?: Maybe<Scalars['String']>;
  kindOfResidence?: Maybe<Scalars['String']>;
  kindOfEmployment?: Maybe<Scalars['String']>;
  kindOfEducation?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  numberOfChildren?: Maybe<Scalars['Int']>;
  numberOfSiblings?: Maybe<Scalars['Int']>;
  pastTreatment?: Maybe<Scalars['Boolean']>;
  treatmentPlanned?: Maybe<Scalars['Boolean']>;
  treatmentPresent?: Maybe<Scalars['Boolean']>;
  treatmentProvider?: Maybe<Scalars['String']>;
  pastTreatmentTime?: Maybe<Scalars['String']>;
  pastTreatmentType?: Maybe<Scalars['String']>;
  flight?: Maybe<Scalars['Boolean']>;
  reasonOfFlight?: Maybe<Scalars['String']>;
  flightBeforeMonths?: Maybe<Scalars['Int']>;
  livingInRefugeeHostel?: Maybe<Scalars['Boolean']>;
  loss?: Maybe<Scalars['Boolean']>;
  numberOfLostRelatedPersons?: Maybe<Scalars['Int']>;
  monthsSinceLoss?: Maybe<Scalars['Int']>;
  ageAtLoss?: Maybe<Scalars['Int']>;
  relationToLostPerson?: Maybe<Scalars['String']>;
  ageOfLostPerson?: Maybe<Scalars['Int']>;
  causeOfDeath?: Maybe<Scalars['String']>;
  impactOnLifeOneYearLater?: Maybe<Scalars['String']>;
  currentImpactOnLife?: Maybe<Scalars['String']>;
  reliableInternetAtHome?: Maybe<Scalars['String']>;
  internetKnowledge?: Maybe<Scalars['String']>;
  internetDevice?: Maybe<Scalars['String']>;
  mostFrequentInternetActivity?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  pastTreatmentIlajnafsy?: Maybe<Scalars['Boolean']>;
  pastTreatmentGp?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychiatrist?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychotherapist?: Maybe<Scalars['Boolean']>;
  pastTreatmentCounseling?: Maybe<Scalars['Boolean']>;
  pastTreatmentSelfHelp?: Maybe<Scalars['Boolean']>;
  pastTreatmentInpatient?: Maybe<Scalars['Boolean']>;
  howFindUs?: Maybe<Scalars['Int']>;
  /** Reads a single `Case` that is related to this `Demographic`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Demographic`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Demographic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface DemographicCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasInternetAccess` field. */
  hasInternetAccess?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `age` field. */
  age?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `countryOfOrigin` field. */
  countryOfOrigin?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryOfResidence` field. */
  countryOfResidence?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `kindOfResidence` field. */
  kindOfResidence?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `kindOfEmployment` field. */
  kindOfEmployment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `kindOfEducation` field. */
  kindOfEducation?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `familyStatus` field. */
  familyStatus?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `numberOfChildren` field. */
  numberOfChildren?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `numberOfSiblings` field. */
  numberOfSiblings?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pastTreatment` field. */
  pastTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `treatmentPlanned` field. */
  treatmentPlanned?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `treatmentPresent` field. */
  treatmentPresent?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `treatmentProvider` field. */
  treatmentProvider?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `pastTreatmentTime` field. */
  pastTreatmentTime?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `pastTreatmentType` field. */
  pastTreatmentType?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `flight` field. */
  flight?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonOfFlight` field. */
  reasonOfFlight?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `flightBeforeMonths` field. */
  flightBeforeMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `livingInRefugeeHostel` field. */
  livingInRefugeeHostel?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `loss` field. */
  loss?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `numberOfLostRelatedPersons` field. */
  numberOfLostRelatedPersons?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `monthsSinceLoss` field. */
  monthsSinceLoss?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `ageAtLoss` field. */
  ageAtLoss?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `relationToLostPerson` field. */
  relationToLostPerson?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `ageOfLostPerson` field. */
  ageOfLostPerson?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `causeOfDeath` field. */
  causeOfDeath?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `impactOnLifeOneYearLater` field. */
  impactOnLifeOneYearLater?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `currentImpactOnLife` field. */
  currentImpactOnLife?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `reliableInternetAtHome` field. */
  reliableInternetAtHome?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `internetKnowledge` field. */
  internetKnowledge?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `internetDevice` field. */
  internetDevice?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `mostFrequentInternetActivity` field. */
  mostFrequentInternetActivity?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `pastTreatmentIlajnafsy` field. */
  pastTreatmentIlajnafsy?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentGp` field. */
  pastTreatmentGp?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentPsychiatrist` field. */
  pastTreatmentPsychiatrist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentPsychotherapist` field. */
  pastTreatmentPsychotherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentCounseling` field. */
  pastTreatmentCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentSelfHelp` field. */
  pastTreatmentSelfHelp?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pastTreatmentInpatient` field. */
  pastTreatmentInpatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `howFindUs` field. */
  howFindUs?: Maybe<Scalars['Int']>;
}

/** A filter to be used against `Demographic` object types. All fields are combined with a logical ‘and.’ */
export interface DemographicFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `hasInternetAccess` field. */
  hasInternetAccess?: Maybe<BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<BooleanFilter>;
  /** Filter by the object’s `age` field. */
  age?: Maybe<IntFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `countryOfOrigin` field. */
  countryOfOrigin?: Maybe<StringFilter>;
  /** Filter by the object’s `countryOfResidence` field. */
  countryOfResidence?: Maybe<StringFilter>;
  /** Filter by the object’s `kindOfResidence` field. */
  kindOfResidence?: Maybe<StringFilter>;
  /** Filter by the object’s `kindOfEmployment` field. */
  kindOfEmployment?: Maybe<StringFilter>;
  /** Filter by the object’s `kindOfEducation` field. */
  kindOfEducation?: Maybe<StringFilter>;
  /** Filter by the object’s `familyStatus` field. */
  familyStatus?: Maybe<StringFilter>;
  /** Filter by the object’s `numberOfChildren` field. */
  numberOfChildren?: Maybe<IntFilter>;
  /** Filter by the object’s `numberOfSiblings` field. */
  numberOfSiblings?: Maybe<IntFilter>;
  /** Filter by the object’s `pastTreatment` field. */
  pastTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `treatmentPlanned` field. */
  treatmentPlanned?: Maybe<BooleanFilter>;
  /** Filter by the object’s `treatmentPresent` field. */
  treatmentPresent?: Maybe<BooleanFilter>;
  /** Filter by the object’s `treatmentProvider` field. */
  treatmentProvider?: Maybe<StringFilter>;
  /** Filter by the object’s `pastTreatmentTime` field. */
  pastTreatmentTime?: Maybe<StringFilter>;
  /** Filter by the object’s `pastTreatmentType` field. */
  pastTreatmentType?: Maybe<StringFilter>;
  /** Filter by the object’s `flight` field. */
  flight?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonOfFlight` field. */
  reasonOfFlight?: Maybe<StringFilter>;
  /** Filter by the object’s `flightBeforeMonths` field. */
  flightBeforeMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `livingInRefugeeHostel` field. */
  livingInRefugeeHostel?: Maybe<BooleanFilter>;
  /** Filter by the object’s `loss` field. */
  loss?: Maybe<BooleanFilter>;
  /** Filter by the object’s `numberOfLostRelatedPersons` field. */
  numberOfLostRelatedPersons?: Maybe<IntFilter>;
  /** Filter by the object’s `monthsSinceLoss` field. */
  monthsSinceLoss?: Maybe<IntFilter>;
  /** Filter by the object’s `ageAtLoss` field. */
  ageAtLoss?: Maybe<IntFilter>;
  /** Filter by the object’s `relationToLostPerson` field. */
  relationToLostPerson?: Maybe<StringFilter>;
  /** Filter by the object’s `ageOfLostPerson` field. */
  ageOfLostPerson?: Maybe<IntFilter>;
  /** Filter by the object’s `causeOfDeath` field. */
  causeOfDeath?: Maybe<StringFilter>;
  /** Filter by the object’s `impactOnLifeOneYearLater` field. */
  impactOnLifeOneYearLater?: Maybe<StringFilter>;
  /** Filter by the object’s `currentImpactOnLife` field. */
  currentImpactOnLife?: Maybe<StringFilter>;
  /** Filter by the object’s `reliableInternetAtHome` field. */
  reliableInternetAtHome?: Maybe<StringFilter>;
  /** Filter by the object’s `internetKnowledge` field. */
  internetKnowledge?: Maybe<StringFilter>;
  /** Filter by the object’s `internetDevice` field. */
  internetDevice?: Maybe<StringFilter>;
  /** Filter by the object’s `mostFrequentInternetActivity` field. */
  mostFrequentInternetActivity?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `pastTreatmentIlajnafsy` field. */
  pastTreatmentIlajnafsy?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentGp` field. */
  pastTreatmentGp?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentPsychiatrist` field. */
  pastTreatmentPsychiatrist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentPsychotherapist` field. */
  pastTreatmentPsychotherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentCounseling` field. */
  pastTreatmentCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentSelfHelp` field. */
  pastTreatmentSelfHelp?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pastTreatmentInpatient` field. */
  pastTreatmentInpatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `howFindUs` field. */
  howFindUs?: Maybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<DemographicFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<DemographicFilter>>;
  /** Negates the expression. */
  not?: Maybe<DemographicFilter>;
}

/** An input for mutations affecting `Demographic` */
export interface DemographicInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  hasInternetAccess?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  age?: Maybe<Scalars['Int']>;
  gender?: Maybe<Gender>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  countryOfResidence?: Maybe<Scalars['String']>;
  kindOfResidence?: Maybe<Scalars['String']>;
  kindOfEmployment?: Maybe<Scalars['String']>;
  kindOfEducation?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  numberOfChildren?: Maybe<Scalars['Int']>;
  numberOfSiblings?: Maybe<Scalars['Int']>;
  pastTreatment?: Maybe<Scalars['Boolean']>;
  treatmentPlanned?: Maybe<Scalars['Boolean']>;
  treatmentPresent?: Maybe<Scalars['Boolean']>;
  treatmentProvider?: Maybe<Scalars['String']>;
  pastTreatmentTime?: Maybe<Scalars['String']>;
  pastTreatmentType?: Maybe<Scalars['String']>;
  flight?: Maybe<Scalars['Boolean']>;
  reasonOfFlight?: Maybe<Scalars['String']>;
  flightBeforeMonths?: Maybe<Scalars['Int']>;
  livingInRefugeeHostel?: Maybe<Scalars['Boolean']>;
  loss?: Maybe<Scalars['Boolean']>;
  numberOfLostRelatedPersons?: Maybe<Scalars['Int']>;
  monthsSinceLoss?: Maybe<Scalars['Int']>;
  ageAtLoss?: Maybe<Scalars['Int']>;
  relationToLostPerson?: Maybe<Scalars['String']>;
  ageOfLostPerson?: Maybe<Scalars['Int']>;
  causeOfDeath?: Maybe<Scalars['String']>;
  impactOnLifeOneYearLater?: Maybe<Scalars['String']>;
  currentImpactOnLife?: Maybe<Scalars['String']>;
  reliableInternetAtHome?: Maybe<Scalars['String']>;
  internetKnowledge?: Maybe<Scalars['String']>;
  internetDevice?: Maybe<Scalars['String']>;
  mostFrequentInternetActivity?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  pastTreatmentIlajnafsy?: Maybe<Scalars['Boolean']>;
  pastTreatmentGp?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychiatrist?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychotherapist?: Maybe<Scalars['Boolean']>;
  pastTreatmentCounseling?: Maybe<Scalars['Boolean']>;
  pastTreatmentSelfHelp?: Maybe<Scalars['Boolean']>;
  pastTreatmentInpatient?: Maybe<Scalars['Boolean']>;
  howFindUs?: Maybe<Scalars['Int']>;
}

/** Represents an update to a `Demographic`. Fields that are set will be updated. */
export interface DemographicPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  hasInternetAccess?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  age?: Maybe<Scalars['Int']>;
  gender?: Maybe<Gender>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  countryOfResidence?: Maybe<Scalars['String']>;
  kindOfResidence?: Maybe<Scalars['String']>;
  kindOfEmployment?: Maybe<Scalars['String']>;
  kindOfEducation?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<Scalars['String']>;
  numberOfChildren?: Maybe<Scalars['Int']>;
  numberOfSiblings?: Maybe<Scalars['Int']>;
  pastTreatment?: Maybe<Scalars['Boolean']>;
  treatmentPlanned?: Maybe<Scalars['Boolean']>;
  treatmentPresent?: Maybe<Scalars['Boolean']>;
  treatmentProvider?: Maybe<Scalars['String']>;
  pastTreatmentTime?: Maybe<Scalars['String']>;
  pastTreatmentType?: Maybe<Scalars['String']>;
  flight?: Maybe<Scalars['Boolean']>;
  reasonOfFlight?: Maybe<Scalars['String']>;
  flightBeforeMonths?: Maybe<Scalars['Int']>;
  livingInRefugeeHostel?: Maybe<Scalars['Boolean']>;
  loss?: Maybe<Scalars['Boolean']>;
  numberOfLostRelatedPersons?: Maybe<Scalars['Int']>;
  monthsSinceLoss?: Maybe<Scalars['Int']>;
  ageAtLoss?: Maybe<Scalars['Int']>;
  relationToLostPerson?: Maybe<Scalars['String']>;
  ageOfLostPerson?: Maybe<Scalars['Int']>;
  causeOfDeath?: Maybe<Scalars['String']>;
  impactOnLifeOneYearLater?: Maybe<Scalars['String']>;
  currentImpactOnLife?: Maybe<Scalars['String']>;
  reliableInternetAtHome?: Maybe<Scalars['String']>;
  internetKnowledge?: Maybe<Scalars['String']>;
  internetDevice?: Maybe<Scalars['String']>;
  mostFrequentInternetActivity?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  pastTreatmentIlajnafsy?: Maybe<Scalars['Boolean']>;
  pastTreatmentGp?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychiatrist?: Maybe<Scalars['Boolean']>;
  pastTreatmentPsychotherapist?: Maybe<Scalars['Boolean']>;
  pastTreatmentCounseling?: Maybe<Scalars['Boolean']>;
  pastTreatmentSelfHelp?: Maybe<Scalars['Boolean']>;
  pastTreatmentInpatient?: Maybe<Scalars['Boolean']>;
  howFindUs?: Maybe<Scalars['Int']>;
}

/** A connection to a list of `Demographic` values. */
export interface DemographicsConnection {
  __typename?: 'DemographicsConnection';
  /** A list of `Demographic` objects. */
  nodes: Array<Demographic>;
  /** A list of edges which contains the `Demographic` and cursor to aid in pagination. */
  edges: Array<DemographicsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Demographic` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Demographic` edge in the connection. */
export interface DemographicsEdge {
  __typename?: 'DemographicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Demographic` at the end of the edge. */
  node: Demographic;
}

/** Methods to use when ordering `Demographic`. */
export enum DemographicsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  HasInternetAccessAsc = 'HAS_INTERNET_ACCESS_ASC',
  HasInternetAccessDesc = 'HAS_INTERNET_ACCESS_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  AgeAsc = 'AGE_ASC',
  AgeDesc = 'AGE_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  CountryOfOriginAsc = 'COUNTRY_OF_ORIGIN_ASC',
  CountryOfOriginDesc = 'COUNTRY_OF_ORIGIN_DESC',
  CountryOfResidenceAsc = 'COUNTRY_OF_RESIDENCE_ASC',
  CountryOfResidenceDesc = 'COUNTRY_OF_RESIDENCE_DESC',
  KindOfResidenceAsc = 'KIND_OF_RESIDENCE_ASC',
  KindOfResidenceDesc = 'KIND_OF_RESIDENCE_DESC',
  KindOfEmploymentAsc = 'KIND_OF_EMPLOYMENT_ASC',
  KindOfEmploymentDesc = 'KIND_OF_EMPLOYMENT_DESC',
  KindOfEducationAsc = 'KIND_OF_EDUCATION_ASC',
  KindOfEducationDesc = 'KIND_OF_EDUCATION_DESC',
  FamilyStatusAsc = 'FAMILY_STATUS_ASC',
  FamilyStatusDesc = 'FAMILY_STATUS_DESC',
  NumberOfChildrenAsc = 'NUMBER_OF_CHILDREN_ASC',
  NumberOfChildrenDesc = 'NUMBER_OF_CHILDREN_DESC',
  NumberOfSiblingsAsc = 'NUMBER_OF_SIBLINGS_ASC',
  NumberOfSiblingsDesc = 'NUMBER_OF_SIBLINGS_DESC',
  PastTreatmentAsc = 'PAST_TREATMENT_ASC',
  PastTreatmentDesc = 'PAST_TREATMENT_DESC',
  TreatmentPlannedAsc = 'TREATMENT_PLANNED_ASC',
  TreatmentPlannedDesc = 'TREATMENT_PLANNED_DESC',
  TreatmentPresentAsc = 'TREATMENT_PRESENT_ASC',
  TreatmentPresentDesc = 'TREATMENT_PRESENT_DESC',
  TreatmentProviderAsc = 'TREATMENT_PROVIDER_ASC',
  TreatmentProviderDesc = 'TREATMENT_PROVIDER_DESC',
  PastTreatmentTimeAsc = 'PAST_TREATMENT_TIME_ASC',
  PastTreatmentTimeDesc = 'PAST_TREATMENT_TIME_DESC',
  PastTreatmentTypeAsc = 'PAST_TREATMENT_TYPE_ASC',
  PastTreatmentTypeDesc = 'PAST_TREATMENT_TYPE_DESC',
  FlightAsc = 'FLIGHT_ASC',
  FlightDesc = 'FLIGHT_DESC',
  ReasonOfFlightAsc = 'REASON_OF_FLIGHT_ASC',
  ReasonOfFlightDesc = 'REASON_OF_FLIGHT_DESC',
  FlightBeforeMonthsAsc = 'FLIGHT_BEFORE_MONTHS_ASC',
  FlightBeforeMonthsDesc = 'FLIGHT_BEFORE_MONTHS_DESC',
  LivingInRefugeeHostelAsc = 'LIVING_IN_REFUGEE_HOSTEL_ASC',
  LivingInRefugeeHostelDesc = 'LIVING_IN_REFUGEE_HOSTEL_DESC',
  LossAsc = 'LOSS_ASC',
  LossDesc = 'LOSS_DESC',
  NumberOfLostRelatedPersonsAsc = 'NUMBER_OF_LOST_RELATED_PERSONS_ASC',
  NumberOfLostRelatedPersonsDesc = 'NUMBER_OF_LOST_RELATED_PERSONS_DESC',
  MonthsSinceLossAsc = 'MONTHS_SINCE_LOSS_ASC',
  MonthsSinceLossDesc = 'MONTHS_SINCE_LOSS_DESC',
  AgeAtLossAsc = 'AGE_AT_LOSS_ASC',
  AgeAtLossDesc = 'AGE_AT_LOSS_DESC',
  RelationToLostPersonAsc = 'RELATION_TO_LOST_PERSON_ASC',
  RelationToLostPersonDesc = 'RELATION_TO_LOST_PERSON_DESC',
  AgeOfLostPersonAsc = 'AGE_OF_LOST_PERSON_ASC',
  AgeOfLostPersonDesc = 'AGE_OF_LOST_PERSON_DESC',
  CauseOfDeathAsc = 'CAUSE_OF_DEATH_ASC',
  CauseOfDeathDesc = 'CAUSE_OF_DEATH_DESC',
  ImpactOnLifeOneYearLaterAsc = 'IMPACT_ON_LIFE_ONE_YEAR_LATER_ASC',
  ImpactOnLifeOneYearLaterDesc = 'IMPACT_ON_LIFE_ONE_YEAR_LATER_DESC',
  CurrentImpactOnLifeAsc = 'CURRENT_IMPACT_ON_LIFE_ASC',
  CurrentImpactOnLifeDesc = 'CURRENT_IMPACT_ON_LIFE_DESC',
  ReliableInternetAtHomeAsc = 'RELIABLE_INTERNET_AT_HOME_ASC',
  ReliableInternetAtHomeDesc = 'RELIABLE_INTERNET_AT_HOME_DESC',
  InternetKnowledgeAsc = 'INTERNET_KNOWLEDGE_ASC',
  InternetKnowledgeDesc = 'INTERNET_KNOWLEDGE_DESC',
  InternetDeviceAsc = 'INTERNET_DEVICE_ASC',
  InternetDeviceDesc = 'INTERNET_DEVICE_DESC',
  MostFrequentInternetActivityAsc = 'MOST_FREQUENT_INTERNET_ACTIVITY_ASC',
  MostFrequentInternetActivityDesc = 'MOST_FREQUENT_INTERNET_ACTIVITY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PastTreatmentIlajnafsyAsc = 'PAST_TREATMENT_ILAJNAFSY_ASC',
  PastTreatmentIlajnafsyDesc = 'PAST_TREATMENT_ILAJNAFSY_DESC',
  PastTreatmentGpAsc = 'PAST_TREATMENT_GP_ASC',
  PastTreatmentGpDesc = 'PAST_TREATMENT_GP_DESC',
  PastTreatmentPsychiatristAsc = 'PAST_TREATMENT_PSYCHIATRIST_ASC',
  PastTreatmentPsychiatristDesc = 'PAST_TREATMENT_PSYCHIATRIST_DESC',
  PastTreatmentPsychotherapistAsc = 'PAST_TREATMENT_PSYCHOTHERAPIST_ASC',
  PastTreatmentPsychotherapistDesc = 'PAST_TREATMENT_PSYCHOTHERAPIST_DESC',
  PastTreatmentCounselingAsc = 'PAST_TREATMENT_COUNSELING_ASC',
  PastTreatmentCounselingDesc = 'PAST_TREATMENT_COUNSELING_DESC',
  PastTreatmentSelfHelpAsc = 'PAST_TREATMENT_SELF_HELP_ASC',
  PastTreatmentSelfHelpDesc = 'PAST_TREATMENT_SELF_HELP_DESC',
  PastTreatmentInpatientAsc = 'PAST_TREATMENT_INPATIENT_ASC',
  PastTreatmentInpatientDesc = 'PAST_TREATMENT_INPATIENT_DESC',
  HowFindUsAsc = 'HOW_FIND_US_ASC',
  HowFindUsDesc = 'HOW_FIND_US_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Disclosure extends Node {
  __typename?: 'Disclosure';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  disclosureItem?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  traumaType?: Maybe<Scalars['String']>;
  item1: Scalars['Boolean'];
  item2: Scalars['Boolean'];
  item3: Scalars['Boolean'];
  item4: Scalars['Boolean'];
  item5: Scalars['Boolean'];
  item6: Scalars['Boolean'];
  item7: Scalars['Boolean'];
  descriptionOfItem7?: Maybe<Scalars['String']>;
  /** Reads a single `Case` that is related to this `Disclosure`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Disclosure`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Disclosure` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface DisclosureCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `disclosureItem` field. */
  disclosureItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `traumaType` field. */
  traumaType?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `descriptionOfItem7` field. */
  descriptionOfItem7?: Maybe<Scalars['String']>;
}

/** A filter to be used against `Disclosure` object types. All fields are combined with a logical ‘and.’ */
export interface DisclosureFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `disclosureItem` field. */
  disclosureItem?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `traumaType` field. */
  traumaType?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `descriptionOfItem7` field. */
  descriptionOfItem7?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<DisclosureFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<DisclosureFilter>>;
  /** Negates the expression. */
  not?: Maybe<DisclosureFilter>;
}

/** An input for mutations affecting `Disclosure` */
export interface DisclosureInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  disclosureItem?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  traumaType?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Boolean']>;
  item2?: Maybe<Scalars['Boolean']>;
  item3?: Maybe<Scalars['Boolean']>;
  item4?: Maybe<Scalars['Boolean']>;
  item5?: Maybe<Scalars['Boolean']>;
  item6?: Maybe<Scalars['Boolean']>;
  item7?: Maybe<Scalars['Boolean']>;
  descriptionOfItem7?: Maybe<Scalars['String']>;
}

/** Represents an update to a `Disclosure`. Fields that are set will be updated. */
export interface DisclosurePatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  disclosureItem?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  traumaType?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Boolean']>;
  item2?: Maybe<Scalars['Boolean']>;
  item3?: Maybe<Scalars['Boolean']>;
  item4?: Maybe<Scalars['Boolean']>;
  item5?: Maybe<Scalars['Boolean']>;
  item6?: Maybe<Scalars['Boolean']>;
  item7?: Maybe<Scalars['Boolean']>;
  descriptionOfItem7?: Maybe<Scalars['String']>;
}

/** A connection to a list of `Disclosure` values. */
export interface DisclosuresConnection {
  __typename?: 'DisclosuresConnection';
  /** A list of `Disclosure` objects. */
  nodes: Array<Disclosure>;
  /** A list of edges which contains the `Disclosure` and cursor to aid in pagination. */
  edges: Array<DisclosuresEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Disclosure` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Disclosure` edge in the connection. */
export interface DisclosuresEdge {
  __typename?: 'DisclosuresEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Disclosure` at the end of the edge. */
  node: Disclosure;
}

/** Methods to use when ordering `Disclosure`. */
export enum DisclosuresOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  DisclosureItemAsc = 'DISCLOSURE_ITEM_ASC',
  DisclosureItemDesc = 'DISCLOSURE_ITEM_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  TraumaTypeAsc = 'TRAUMA_TYPE_ASC',
  TraumaTypeDesc = 'TRAUMA_TYPE_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  DescriptionOfItem7Asc = 'DESCRIPTION_OF_ITEM7_ASC',
  DescriptionOfItem7Desc = 'DESCRIPTION_OF_ITEM7_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `dropMultipleInterviewersAndFixMemberships` mutation. */
export interface DropMultipleInterviewersAndFixMembershipsInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** The output of our `dropMultipleInterviewersAndFixMemberships` mutation. */
export interface DropMultipleInterviewersAndFixMembershipsPayload {
  __typename?: 'DropMultipleInterviewersAndFixMembershipsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<DropMultipleInterviewersAndFixMembershipsRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `dropMultipleInterviewersAndFixMemberships` mutation. */
export interface DropMultipleInterviewersAndFixMembershipsRecord {
  __typename?: 'DropMultipleInterviewersAndFixMembershipsRecord';
  droppedInterviewers?: Maybe<Scalars['BigInt']>;
  fixedMemberships?: Maybe<Scalars['BigInt']>;
}

/** All input for the `dropMultipleInterviewers` mutation. */
export interface DropMultipleInterviewersInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** The output of our `dropMultipleInterviewers` mutation. */
export interface DropMultipleInterviewersPayload {
  __typename?: 'DropMultipleInterviewersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<DropMultipleInterviewersRecord>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `dropMultipleInterviewers` mutation. */
export interface DropMultipleInterviewersRecord {
  __typename?: 'DropMultipleInterviewersRecord';
  id?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  hasAnotherStaffRole?: Maybe<Scalars['Boolean']>;
  nthInterviewer?: Maybe<Scalars['BigInt']>;
  nthLastInterviewer?: Maybe<Scalars['BigInt']>;
}

export interface DueCandidateLink {
  __typename?: 'DueCandidateLink';
  processInstanceId?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  taskId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
  /** Reads a single `CaseMember` that is related to this `DueCandidateLink`. */
  caseMember?: Maybe<CaseMember>;
  /** Reads a single `Case` that is related to this `DueCandidateLink`. */
  case?: Maybe<Case>;
  /** Reads a single `MyProcessLog` that is related to this `DueCandidateLink`. */
  process?: Maybe<MyProcessLog>;
  /** Reads a single `DueTask` that is related to this `DueCandidateLink`. */
  task?: Maybe<DueTask>;
}

/**
 * A condition to be used against `DueCandidateLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface DueCandidateLinkCondition {
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
}

/** A filter to be used against `DueCandidateLink` object types. All fields are combined with a logical ‘and.’ */
export interface DueCandidateLinkFilter {
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: Maybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<DueCandidateLinkFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<DueCandidateLinkFilter>>;
  /** Negates the expression. */
  not?: Maybe<DueCandidateLinkFilter>;
}

/** A connection to a list of `DueCandidateLink` values. */
export interface DueCandidateLinksConnection {
  __typename?: 'DueCandidateLinksConnection';
  /** A list of `DueCandidateLink` objects. */
  nodes: Array<DueCandidateLink>;
  /** A list of edges which contains the `DueCandidateLink` and cursor to aid in pagination. */
  edges: Array<DueCandidateLinksEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DueCandidateLink` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `DueCandidateLink` edge in the connection. */
export interface DueCandidateLinksEdge {
  __typename?: 'DueCandidateLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DueCandidateLink` at the end of the edge. */
  node: DueCandidateLink;
}

/** Methods to use when ordering `DueCandidateLink`. */
export enum DueCandidateLinksOrderBy {
  Natural = 'NATURAL',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export interface DueTask extends Node {
  __typename?: 'DueTask';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Case` that is related to this `DueTask`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `MyProcessLog` that is related to this `DueTask`. */
  myProcessLogByProcessInstanceId?: Maybe<MyProcessLog>;
  /** Reads and enables pagination through a set of `DueCandidateLink`. */
  dueCandidateLinksByTaskId: DueCandidateLinksConnection;
  amICandidating?: Maybe<Scalars['Boolean']>;
}


export type DueTaskDueCandidateLinksByTaskIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueCandidateLinksOrderBy>>;
  condition?: Maybe<DueCandidateLinkCondition>;
  filter?: Maybe<DueCandidateLinkFilter>;
};

/** A condition to be used against `DueTask` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface DueTaskCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `amICandidating` field. */
  amICandidating?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `DueTask` object types. All fields are combined with a logical ‘and.’ */
export interface DueTaskFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `amICandidating` field. */
  amICandidating?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<DueTaskFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<DueTaskFilter>>;
  /** Negates the expression. */
  not?: Maybe<DueTaskFilter>;
}

/** A connection to a list of `DueTask` values. */
export interface DueTasksConnection {
  __typename?: 'DueTasksConnection';
  /** A list of `DueTask` objects. */
  nodes: Array<DueTask>;
  /** A list of edges which contains the `DueTask` and cursor to aid in pagination. */
  edges: Array<DueTasksEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DueTask` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `DueTask` edge in the connection. */
export interface DueTasksEdge {
  __typename?: 'DueTasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DueTask` at the end of the edge. */
  node: DueTask;
}

/** Methods to use when ordering `DueTask`. */
export enum DueTasksOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Eurohi extends Node {
  __typename?: 'Eurohi';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Eurohi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Eurohi`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Eurohi` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface EurohiCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Eurohi` object types. All fields are combined with a logical ‘and.’ */
export interface EurohiFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<EurohiFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<EurohiFilter>>;
  /** Negates the expression. */
  not?: Maybe<EurohiFilter>;
}

/** An input for mutations affecting `Eurohi` */
export interface EurohiInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Eurohi`. Fields that are set will be updated. */
export interface EurohiPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Eurohi` values. */
export interface EurohisConnection {
  __typename?: 'EurohisConnection';
  /** A list of `Eurohi` objects. */
  nodes: Array<Eurohi>;
  /** A list of edges which contains the `Eurohi` and cursor to aid in pagination. */
  edges: Array<EurohisEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Eurohi` you could get from the connection. */
  totalCount: Scalars['Int'];
}

export interface EurohisCounselingStatistic {
  __typename?: 'EurohisCounselingStatistic';
  shortId?: Maybe<Scalars['BigInt']>;
  caseId?: Maybe<Scalars['UUID']>;
  scoreP1?: Maybe<Scalars['Int']>;
  timeP1?: Maybe<Scalars['Datetime']>;
  scoreP5?: Maybe<Scalars['Int']>;
  timeP5?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `EurohisCounselingStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface EurohisCounselingStatisticCondition {
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scoreP1` field. */
  scoreP1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `timeP1` field. */
  timeP1?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `scoreP5` field. */
  scoreP5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `timeP5` field. */
  timeP5?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `EurohisCounselingStatistic` object types. All fields are combined with a logical ‘and.’ */
export interface EurohisCounselingStatisticFilter {
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `scoreP1` field. */
  scoreP1?: Maybe<IntFilter>;
  /** Filter by the object’s `timeP1` field. */
  timeP1?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `scoreP5` field. */
  scoreP5?: Maybe<IntFilter>;
  /** Filter by the object’s `timeP5` field. */
  timeP5?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<EurohisCounselingStatisticFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<EurohisCounselingStatisticFilter>>;
  /** Negates the expression. */
  not?: Maybe<EurohisCounselingStatisticFilter>;
}

/** A connection to a list of `EurohisCounselingStatistic` values. */
export interface EurohisCounselingStatisticsConnection {
  __typename?: 'EurohisCounselingStatisticsConnection';
  /** A list of `EurohisCounselingStatistic` objects. */
  nodes: Array<EurohisCounselingStatistic>;
  /** A list of edges which contains the `EurohisCounselingStatistic` and cursor to aid in pagination. */
  edges: Array<EurohisCounselingStatisticsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EurohisCounselingStatistic` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `EurohisCounselingStatistic` edge in the connection. */
export interface EurohisCounselingStatisticsEdge {
  __typename?: 'EurohisCounselingStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EurohisCounselingStatistic` at the end of the edge. */
  node: EurohisCounselingStatistic;
}

/** Methods to use when ordering `EurohisCounselingStatistic`. */
export enum EurohisCounselingStatisticsOrderBy {
  Natural = 'NATURAL',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  ScoreP1Asc = 'SCORE_P1_ASC',
  ScoreP1Desc = 'SCORE_P1_DESC',
  TimeP1Asc = 'TIME_P1_ASC',
  TimeP1Desc = 'TIME_P1_DESC',
  ScoreP5Asc = 'SCORE_P5_ASC',
  ScoreP5Desc = 'SCORE_P5_DESC',
  TimeP5Asc = 'TIME_P5_ASC',
  TimeP5Desc = 'TIME_P5_DESC'
}

/** A `Eurohi` edge in the connection. */
export interface EurohisEdge {
  __typename?: 'EurohisEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Eurohi` at the end of the edge. */
  node: Eurohi;
}

/** Methods to use when ordering `Eurohi`. */
export enum EurohisOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Evaluation extends Node {
  __typename?: 'Evaluation';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Evaluation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Evaluation`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Evaluation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface EvaluationCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Evaluation` object types. All fields are combined with a logical ‘and.’ */
export interface EvaluationFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<EvaluationFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<EvaluationFilter>>;
  /** Negates the expression. */
  not?: Maybe<EvaluationFilter>;
}

/** An input for mutations affecting `Evaluation` */
export interface EvaluationInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Evaluation`. Fields that are set will be updated. */
export interface EvaluationPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Evaluation` values. */
export interface EvaluationsConnection {
  __typename?: 'EvaluationsConnection';
  /** A list of `Evaluation` objects. */
  nodes: Array<Evaluation>;
  /** A list of edges which contains the `Evaluation` and cursor to aid in pagination. */
  edges: Array<EvaluationsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Evaluation` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Evaluation` edge in the connection. */
export interface EvaluationsEdge {
  __typename?: 'EvaluationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Evaluation` at the end of the edge. */
  node: Evaluation;
}

/** Methods to use when ordering `Evaluation`. */
export enum EvaluationsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface FeedbackInterviewReport extends Node {
  __typename?: 'FeedbackInterviewReport';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  bookingId?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
  howDidYouHear?: Maybe<Scalars['String']>;
  generalChanges?: Maybe<Scalars['String']>;
  changesForTheWorse?: Maybe<Scalars['String']>;
  causesOfChanges?: Maybe<Scalars['String']>;
  hinderingOrUnnecessaryParts?: Maybe<Scalars['String']>;
  difficultButHelpfulParts?: Maybe<Scalars['String']>;
  neglectedParts?: Maybe<Scalars['String']>;
  motivatingParts?: Maybe<Scalars['String']>;
  tendencyToRecommendTheProgram?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `FeedbackInterviewReport` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface FeedbackInterviewReportCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bookingId` field. */
  bookingId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientReached` field. */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `contactVia` field. */
  contactVia?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAlias` field. */
  patientAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasMedication` field. */
  hasMedication?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `medicationName` field. */
  medicationName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hadPreviousIlajnafsyTreatment` field. */
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `typeOfPreviousIlajnafsyTreatment` field. */
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `finishedPreviousIlajnafsyTreatmentWeaksAgo` field. */
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  /** Checks for equality with the object’s `suicidalityC1` field. */
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC2` field. */
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC3` field. */
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC4` field. */
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC5` field. */
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC6` field. */
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalitySuicideRisk` field. */
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `suicidalityNoSuicideContract` field. */
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityNotes` field. */
  suicidalityNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `traumaDescription` field. */
  traumaDescription?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `ptsdChecked` field. */
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB1` field. */
  ptsdB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB2` field. */
  ptsdB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB3` field. */
  ptsdB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB4` field. */
  ptsdB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB5` field. */
  ptsdB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdBFulfilled` field. */
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdC1` field. */
  ptsdC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdC2` field. */
  ptsdC2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdCFulfilled` field. */
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD1` field. */
  ptsdD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD2` field. */
  ptsdD2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD3` field. */
  ptsdD3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD4` field. */
  ptsdD4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD5` field. */
  ptsdD5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD6` field. */
  ptsdD6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD7` field. */
  ptsdD7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdDFulfilled` field. */
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE1` field. */
  ptsdE1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE2` field. */
  ptsdE2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE3` field. */
  ptsdE3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE4` field. */
  ptsdE4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE5` field. */
  ptsdE5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE6` field. */
  ptsdE6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdEFulfilled` field. */
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdFFulfilled` field. */
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdGFulfilled` field. */
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdHFulfilled` field. */
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdTotalFulfilled` field. */
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdNotes` field. */
  ptsdNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `cmdeA1` field. */
  cmdeA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA2` field. */
  cmdeA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA3` field. */
  cmdeA3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA4` field. */
  cmdeA4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA5` field. */
  cmdeA5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA6` field. */
  cmdeA6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA7` field. */
  cmdeA7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA8` field. */
  cmdeA8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA9` field. */
  cmdeA9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeAFulfilled` field. */
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeBFulfilled` field. */
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeCFulfilled` field. */
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeMdeTotalFulfilled` field. */
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeActualEpisodeStartsWeeks` field. */
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeActualEpisodeStartsMonths` field. */
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeLastEpisodeBeforeMonths` field. */
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeLastEpisodeBeforeYears` field. */
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeNumberOfEpisodes` field. */
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeNotes` field. */
  cmdeNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `dysthymiaAFulfilled` field. */
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB1` field. */
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB2` field. */
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB3` field. */
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB4` field. */
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB5` field. */
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB6` field. */
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaBFulfilled` field. */
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaCFulfilled` field. */
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaEFulfilled` field. */
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaFFulfilled` field. */
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaGFulfilled` field. */
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaHFulfilled` field. */
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaTotalFulfilled` field. */
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaNotes` field. */
  dysthymiaNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblemStatusAccepted` field. */
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblemStatusRejected` field. */
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonsForCounseling` field. */
  reasonsForCounseling?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `accessibilityTime` field. */
  accessibilityTime?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `additionalComments` field. */
  additionalComments?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientNeedsToRegisterAgain` field. */
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonsForFutureRegistration` field. */
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `stateIfOtherReasons` field. */
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hra1` field. */
  hra1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra2` field. */
  hra2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra3` field. */
  hra3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra4` field. */
  hra4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra5` field. */
  hra5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra6` field. */
  hra6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `audit1` field. */
  audit1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit2` field. */
  audit2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit3` field. */
  audit3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit4` field. */
  audit4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit5` field. */
  audit5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit6` field. */
  audit6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit7` field. */
  audit7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit8` field. */
  audit8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit9` field. */
  audit9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit10` field. */
  audit10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `dast1` field. */
  dast1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast2` field. */
  dast2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast3` field. */
  dast3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast4` field. */
  dast4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast5` field. */
  dast5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast6` field. */
  dast6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast7` field. */
  dast7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast8` field. */
  dast8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast9` field. */
  dast9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast10` field. */
  dast10?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA1` field. */
  pmdeA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA2` field. */
  pmdeA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA3` field. */
  pmdeA3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA4` field. */
  pmdeA4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA5` field. */
  pmdeA5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA6` field. */
  pmdeA6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA7` field. */
  pmdeA7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA8` field. */
  pmdeA8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA9` field. */
  pmdeA9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeAFulfilled` field. */
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeBFulfilled` field. */
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeCFulfilled` field. */
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeTotalFulfilled` field. */
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeActualEpisodeStartsWeeks` field. */
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pmdeActualEpisodeStartsMonths` field. */
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pmdeNumberOfEpisodes` field. */
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmanA1` field. */
  cmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanA2` field. */
  cmanA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB1` field. */
  cmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB2` field. */
  cmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB3` field. */
  cmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB4` field. */
  cmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB5` field. */
  cmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB6` field. */
  cmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB7` field. */
  cmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanC1` field. */
  cmanC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanD1` field. */
  cmanD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanFulfilled` field. */
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanA1` field. */
  chmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB1` field. */
  chmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB2` field. */
  chmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB3` field. */
  chmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB4` field. */
  chmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB5` field. */
  chmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB6` field. */
  chmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB7` field. */
  chmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanC` field. */
  chmanC?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanD` field. */
  chmanD?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanE` field. */
  chmanE?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanF` field. */
  chmanF?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanFulfilled` field. */
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanA1` field. */
  pmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanA2` field. */
  pmanA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB1` field. */
  pmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB2` field. */
  pmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB3` field. */
  pmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB4` field. */
  pmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB5` field. */
  pmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB6` field. */
  pmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB7` field. */
  pmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanC1` field. */
  pmanC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanD1` field. */
  pmanD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanFulfilled` field. */
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanA1` field. */
  phmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB1` field. */
  phmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB2` field. */
  phmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB3` field. */
  phmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB4` field. */
  phmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB5` field. */
  phmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB6` field. */
  phmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB7` field. */
  phmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanC` field. */
  phmanC?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanD` field. */
  phmanD?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanE` field. */
  phmanE?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanF` field. */
  phmanF?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanFulfilled` field. */
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB1` field. */
  psychB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB2` field. */
  psychB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB3` field. */
  psychB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB4` field. */
  psychB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB5` field. */
  psychB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB6` field. */
  psychB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB7` field. */
  psychB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB8` field. */
  psychB8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB9` field. */
  psychB9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB10` field. */
  psychB10?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB11` field. */
  psychB11?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB12` field. */
  psychB12?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB13` field. */
  psychB13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB14` field. */
  psychB14?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB15` field. */
  psychB15?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB16` field. */
  psychB16?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB17` field. */
  psychB17?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB18` field. */
  psychB18?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB19` field. */
  psychB19?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `rejectionOtherReasons` field. */
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hraTotalFulfilled` field. */
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `auditTotalScore` field. */
  auditTotalScore?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `auditTotalFulfilled` field. */
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeNotes` field. */
  pmdeNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `dastTotalFulfilled` field. */
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanBFulfilled` field. */
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanBFulfilled` field. */
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanBFulfilled` field. */
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanBFulfilled` field. */
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychTotalFulfilled` field. */
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientReasoningForCounseling` field. */
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientFutureRegistration` field. */
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientReasonsFutureRegistration` field. */
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `howDidYouHear` field. */
  howDidYouHear?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `generalChanges` field. */
  generalChanges?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `changesForTheWorse` field. */
  changesForTheWorse?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `causesOfChanges` field. */
  causesOfChanges?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hinderingOrUnnecessaryParts` field. */
  hinderingOrUnnecessaryParts?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `difficultButHelpfulParts` field. */
  difficultButHelpfulParts?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `neglectedParts` field. */
  neglectedParts?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `motivatingParts` field. */
  motivatingParts?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tendencyToRecommendTheProgram` field. */
  tendencyToRecommendTheProgram?: Maybe<Scalars['String']>;
}

/** A filter to be used against `FeedbackInterviewReport` object types. All fields are combined with a logical ‘and.’ */
export interface FeedbackInterviewReportFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `bookingId` field. */
  bookingId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `patientReached` field. */
  patientReached?: Maybe<BooleanFilter>;
  /** Filter by the object’s `contactVia` field. */
  contactVia?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAlias` field. */
  patientAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `hasMedication` field. */
  hasMedication?: Maybe<BooleanFilter>;
  /** Filter by the object’s `medicationName` field. */
  medicationName?: Maybe<StringFilter>;
  /** Filter by the object’s `hadPreviousIlajnafsyTreatment` field. */
  hadPreviousIlajnafsyTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `typeOfPreviousIlajnafsyTreatment` field. */
  typeOfPreviousIlajnafsyTreatment?: Maybe<StringFilter>;
  /** Filter by the object’s `finishedPreviousIlajnafsyTreatmentWeaksAgo` field. */
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<DateFilter>;
  /** Filter by the object’s `suicidalityC1` field. */
  suicidalityC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC2` field. */
  suicidalityC2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC3` field. */
  suicidalityC3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC4` field. */
  suicidalityC4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC5` field. */
  suicidalityC5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC6` field. */
  suicidalityC6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalitySuicideRisk` field. */
  suicidalitySuicideRisk?: Maybe<StringFilter>;
  /** Filter by the object’s `suicidalityNoSuicideContract` field. */
  suicidalityNoSuicideContract?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityNotes` field. */
  suicidalityNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `traumaDescription` field. */
  traumaDescription?: Maybe<StringFilter>;
  /** Filter by the object’s `ptsdChecked` field. */
  ptsdChecked?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB1` field. */
  ptsdB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB2` field. */
  ptsdB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB3` field. */
  ptsdB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB4` field. */
  ptsdB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB5` field. */
  ptsdB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdBFulfilled` field. */
  ptsdBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdC1` field. */
  ptsdC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdC2` field. */
  ptsdC2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdCFulfilled` field. */
  ptsdCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD1` field. */
  ptsdD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD2` field. */
  ptsdD2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD3` field. */
  ptsdD3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD4` field. */
  ptsdD4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD5` field. */
  ptsdD5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD6` field. */
  ptsdD6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD7` field. */
  ptsdD7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdDFulfilled` field. */
  ptsdDFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE1` field. */
  ptsdE1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE2` field. */
  ptsdE2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE3` field. */
  ptsdE3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE4` field. */
  ptsdE4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE5` field. */
  ptsdE5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE6` field. */
  ptsdE6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdEFulfilled` field. */
  ptsdEFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdFFulfilled` field. */
  ptsdFFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdGFulfilled` field. */
  ptsdGFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdHFulfilled` field. */
  ptsdHFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdTotalFulfilled` field. */
  ptsdTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdNotes` field. */
  ptsdNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `cmdeA1` field. */
  cmdeA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA2` field. */
  cmdeA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA3` field. */
  cmdeA3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA4` field. */
  cmdeA4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA5` field. */
  cmdeA5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA6` field. */
  cmdeA6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA7` field. */
  cmdeA7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA8` field. */
  cmdeA8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA9` field. */
  cmdeA9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeAFulfilled` field. */
  cmdeAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeBFulfilled` field. */
  cmdeBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeCFulfilled` field. */
  cmdeCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeMdeTotalFulfilled` field. */
  cmdeMdeTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeActualEpisodeStartsWeeks` field. */
  cmdeActualEpisodeStartsWeeks?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeActualEpisodeStartsMonths` field. */
  cmdeActualEpisodeStartsMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeLastEpisodeBeforeMonths` field. */
  cmdeLastEpisodeBeforeMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeLastEpisodeBeforeYears` field. */
  cmdeLastEpisodeBeforeYears?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeNumberOfEpisodes` field. */
  cmdeNumberOfEpisodes?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeNotes` field. */
  cmdeNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `dysthymiaAFulfilled` field. */
  dysthymiaAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB1` field. */
  dysthymiaB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB2` field. */
  dysthymiaB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB3` field. */
  dysthymiaB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB4` field. */
  dysthymiaB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB5` field. */
  dysthymiaB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB6` field. */
  dysthymiaB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaBFulfilled` field. */
  dysthymiaBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaCFulfilled` field. */
  dysthymiaCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaEFulfilled` field. */
  dysthymiaEFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaFFulfilled` field. */
  dysthymiaFFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaGFulfilled` field. */
  dysthymiaGFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaHFulfilled` field. */
  dysthymiaHFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaTotalFulfilled` field. */
  dysthymiaTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaNotes` field. */
  dysthymiaNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblemStatusAccepted` field. */
  primaryProblemStatusAccepted?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblemStatusRejected` field. */
  primaryProblemStatusRejected?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonsForCounseling` field. */
  reasonsForCounseling?: Maybe<StringFilter>;
  /** Filter by the object’s `accessibilityTime` field. */
  accessibilityTime?: Maybe<StringFilter>;
  /** Filter by the object’s `additionalComments` field. */
  additionalComments?: Maybe<StringFilter>;
  /** Filter by the object’s `patientNeedsToRegisterAgain` field. */
  patientNeedsToRegisterAgain?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonsForFutureRegistration` field. */
  reasonsForFutureRegistration?: Maybe<StringFilter>;
  /** Filter by the object’s `stateIfOtherReasons` field. */
  stateIfOtherReasons?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `hra1` field. */
  hra1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra2` field. */
  hra2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra3` field. */
  hra3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra4` field. */
  hra4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra5` field. */
  hra5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra6` field. */
  hra6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `audit1` field. */
  audit1?: Maybe<IntFilter>;
  /** Filter by the object’s `audit2` field. */
  audit2?: Maybe<IntFilter>;
  /** Filter by the object’s `audit3` field. */
  audit3?: Maybe<IntFilter>;
  /** Filter by the object’s `audit4` field. */
  audit4?: Maybe<IntFilter>;
  /** Filter by the object’s `audit5` field. */
  audit5?: Maybe<IntFilter>;
  /** Filter by the object’s `audit6` field. */
  audit6?: Maybe<IntFilter>;
  /** Filter by the object’s `audit7` field. */
  audit7?: Maybe<IntFilter>;
  /** Filter by the object’s `audit8` field. */
  audit8?: Maybe<IntFilter>;
  /** Filter by the object’s `audit9` field. */
  audit9?: Maybe<IntFilter>;
  /** Filter by the object’s `audit10` field. */
  audit10?: Maybe<IntFilter>;
  /** Filter by the object’s `dast1` field. */
  dast1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast2` field. */
  dast2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast3` field. */
  dast3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast4` field. */
  dast4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast5` field. */
  dast5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast6` field. */
  dast6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast7` field. */
  dast7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast8` field. */
  dast8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast9` field. */
  dast9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast10` field. */
  dast10?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA1` field. */
  pmdeA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA2` field. */
  pmdeA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA3` field. */
  pmdeA3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA4` field. */
  pmdeA4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA5` field. */
  pmdeA5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA6` field. */
  pmdeA6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA7` field. */
  pmdeA7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA8` field. */
  pmdeA8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA9` field. */
  pmdeA9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeAFulfilled` field. */
  pmdeAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeBFulfilled` field. */
  pmdeBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeCFulfilled` field. */
  pmdeCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeTotalFulfilled` field. */
  pmdeTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeActualEpisodeStartsWeeks` field. */
  pmdeActualEpisodeStartsWeeks?: Maybe<IntFilter>;
  /** Filter by the object’s `pmdeActualEpisodeStartsMonths` field. */
  pmdeActualEpisodeStartsMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `pmdeNumberOfEpisodes` field. */
  pmdeNumberOfEpisodes?: Maybe<IntFilter>;
  /** Filter by the object’s `cmanA1` field. */
  cmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanA2` field. */
  cmanA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB1` field. */
  cmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB2` field. */
  cmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB3` field. */
  cmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB4` field. */
  cmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB5` field. */
  cmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB6` field. */
  cmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB7` field. */
  cmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanC1` field. */
  cmanC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanD1` field. */
  cmanD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanFulfilled` field. */
  cmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanA1` field. */
  chmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB1` field. */
  chmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB2` field. */
  chmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB3` field. */
  chmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB4` field. */
  chmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB5` field. */
  chmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB6` field. */
  chmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB7` field. */
  chmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanC` field. */
  chmanC?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanD` field. */
  chmanD?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanE` field. */
  chmanE?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanF` field. */
  chmanF?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanFulfilled` field. */
  chmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanA1` field. */
  pmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanA2` field. */
  pmanA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB1` field. */
  pmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB2` field. */
  pmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB3` field. */
  pmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB4` field. */
  pmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB5` field. */
  pmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB6` field. */
  pmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB7` field. */
  pmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanC1` field. */
  pmanC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanD1` field. */
  pmanD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanFulfilled` field. */
  pmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanA1` field. */
  phmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB1` field. */
  phmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB2` field. */
  phmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB3` field. */
  phmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB4` field. */
  phmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB5` field. */
  phmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB6` field. */
  phmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB7` field. */
  phmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanC` field. */
  phmanC?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanD` field. */
  phmanD?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanE` field. */
  phmanE?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanF` field. */
  phmanF?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanFulfilled` field. */
  phmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB1` field. */
  psychB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB2` field. */
  psychB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB3` field. */
  psychB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB4` field. */
  psychB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB5` field. */
  psychB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB6` field. */
  psychB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB7` field. */
  psychB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB8` field. */
  psychB8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB9` field. */
  psychB9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB10` field. */
  psychB10?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB11` field. */
  psychB11?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB12` field. */
  psychB12?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB13` field. */
  psychB13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB14` field. */
  psychB14?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB15` field. */
  psychB15?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB16` field. */
  psychB16?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB17` field. */
  psychB17?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB18` field. */
  psychB18?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB19` field. */
  psychB19?: Maybe<BooleanFilter>;
  /** Filter by the object’s `rejectionOtherReasons` field. */
  rejectionOtherReasons?: Maybe<StringFilter>;
  /** Filter by the object’s `hraTotalFulfilled` field. */
  hraTotalFulfilled?: Maybe<StringFilter>;
  /** Filter by the object’s `auditTotalScore` field. */
  auditTotalScore?: Maybe<IntFilter>;
  /** Filter by the object’s `auditTotalFulfilled` field. */
  auditTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeNotes` field. */
  pmdeNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `dastTotalFulfilled` field. */
  dastTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanBFulfilled` field. */
  cmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanBFulfilled` field. */
  chmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanBFulfilled` field. */
  pmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanBFulfilled` field. */
  phmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychTotalFulfilled` field. */
  psychTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientReasoningForCounseling` field. */
  patientReasoningForCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientFutureRegistration` field. */
  patientFutureRegistration?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientReasonsFutureRegistration` field. */
  patientReasonsFutureRegistration?: Maybe<BooleanFilter>;
  /** Filter by the object’s `howDidYouHear` field. */
  howDidYouHear?: Maybe<StringFilter>;
  /** Filter by the object’s `generalChanges` field. */
  generalChanges?: Maybe<StringFilter>;
  /** Filter by the object’s `changesForTheWorse` field. */
  changesForTheWorse?: Maybe<StringFilter>;
  /** Filter by the object’s `causesOfChanges` field. */
  causesOfChanges?: Maybe<StringFilter>;
  /** Filter by the object’s `hinderingOrUnnecessaryParts` field. */
  hinderingOrUnnecessaryParts?: Maybe<StringFilter>;
  /** Filter by the object’s `difficultButHelpfulParts` field. */
  difficultButHelpfulParts?: Maybe<StringFilter>;
  /** Filter by the object’s `neglectedParts` field. */
  neglectedParts?: Maybe<StringFilter>;
  /** Filter by the object’s `motivatingParts` field. */
  motivatingParts?: Maybe<StringFilter>;
  /** Filter by the object’s `tendencyToRecommendTheProgram` field. */
  tendencyToRecommendTheProgram?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<FeedbackInterviewReportFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<FeedbackInterviewReportFilter>>;
  /** Negates the expression. */
  not?: Maybe<FeedbackInterviewReportFilter>;
}

/** An input for mutations affecting `FeedbackInterviewReport` */
export interface FeedbackInterviewReportInput {
  id?: Maybe<Scalars['UUID']>;
  bookingId?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
  howDidYouHear?: Maybe<Scalars['String']>;
  generalChanges?: Maybe<Scalars['String']>;
  changesForTheWorse?: Maybe<Scalars['String']>;
  causesOfChanges?: Maybe<Scalars['String']>;
  hinderingOrUnnecessaryParts?: Maybe<Scalars['String']>;
  difficultButHelpfulParts?: Maybe<Scalars['String']>;
  neglectedParts?: Maybe<Scalars['String']>;
  motivatingParts?: Maybe<Scalars['String']>;
  tendencyToRecommendTheProgram?: Maybe<Scalars['String']>;
}

/** Represents an update to a `FeedbackInterviewReport`. Fields that are set will be updated. */
export interface FeedbackInterviewReportPatch {
  id?: Maybe<Scalars['UUID']>;
  bookingId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
  howDidYouHear?: Maybe<Scalars['String']>;
  generalChanges?: Maybe<Scalars['String']>;
  changesForTheWorse?: Maybe<Scalars['String']>;
  causesOfChanges?: Maybe<Scalars['String']>;
  hinderingOrUnnecessaryParts?: Maybe<Scalars['String']>;
  difficultButHelpfulParts?: Maybe<Scalars['String']>;
  neglectedParts?: Maybe<Scalars['String']>;
  motivatingParts?: Maybe<Scalars['String']>;
  tendencyToRecommendTheProgram?: Maybe<Scalars['String']>;
}

/** A connection to a list of `FeedbackInterviewReport` values. */
export interface FeedbackInterviewReportsConnection {
  __typename?: 'FeedbackInterviewReportsConnection';
  /** A list of `FeedbackInterviewReport` objects. */
  nodes: Array<FeedbackInterviewReport>;
  /** A list of edges which contains the `FeedbackInterviewReport` and cursor to aid in pagination. */
  edges: Array<FeedbackInterviewReportsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeedbackInterviewReport` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `FeedbackInterviewReport` edge in the connection. */
export interface FeedbackInterviewReportsEdge {
  __typename?: 'FeedbackInterviewReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FeedbackInterviewReport` at the end of the edge. */
  node: FeedbackInterviewReport;
}

/** Methods to use when ordering `FeedbackInterviewReport`. */
export enum FeedbackInterviewReportsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  PatientReachedAsc = 'PATIENT_REACHED_ASC',
  PatientReachedDesc = 'PATIENT_REACHED_DESC',
  ContactViaAsc = 'CONTACT_VIA_ASC',
  ContactViaDesc = 'CONTACT_VIA_DESC',
  PatientAliasAsc = 'PATIENT_ALIAS_ASC',
  PatientAliasDesc = 'PATIENT_ALIAS_DESC',
  HasMedicationAsc = 'HAS_MEDICATION_ASC',
  HasMedicationDesc = 'HAS_MEDICATION_DESC',
  MedicationNameAsc = 'MEDICATION_NAME_ASC',
  MedicationNameDesc = 'MEDICATION_NAME_DESC',
  HadPreviousIlajnafsyTreatmentAsc = 'HAD_PREVIOUS_ILAJNAFSY_TREATMENT_ASC',
  HadPreviousIlajnafsyTreatmentDesc = 'HAD_PREVIOUS_ILAJNAFSY_TREATMENT_DESC',
  TypeOfPreviousIlajnafsyTreatmentAsc = 'TYPE_OF_PREVIOUS_ILAJNAFSY_TREATMENT_ASC',
  TypeOfPreviousIlajnafsyTreatmentDesc = 'TYPE_OF_PREVIOUS_ILAJNAFSY_TREATMENT_DESC',
  FinishedPreviousIlajnafsyTreatmentWeaksAgoAsc = 'FINISHED_PREVIOUS_ILAJNAFSY_TREATMENT_WEAKS_AGO_ASC',
  FinishedPreviousIlajnafsyTreatmentWeaksAgoDesc = 'FINISHED_PREVIOUS_ILAJNAFSY_TREATMENT_WEAKS_AGO_DESC',
  SuicidalityC1Asc = 'SUICIDALITY_C1_ASC',
  SuicidalityC1Desc = 'SUICIDALITY_C1_DESC',
  SuicidalityC2Asc = 'SUICIDALITY_C2_ASC',
  SuicidalityC2Desc = 'SUICIDALITY_C2_DESC',
  SuicidalityC3Asc = 'SUICIDALITY_C3_ASC',
  SuicidalityC3Desc = 'SUICIDALITY_C3_DESC',
  SuicidalityC4Asc = 'SUICIDALITY_C4_ASC',
  SuicidalityC4Desc = 'SUICIDALITY_C4_DESC',
  SuicidalityC5Asc = 'SUICIDALITY_C5_ASC',
  SuicidalityC5Desc = 'SUICIDALITY_C5_DESC',
  SuicidalityC6Asc = 'SUICIDALITY_C6_ASC',
  SuicidalityC6Desc = 'SUICIDALITY_C6_DESC',
  SuicidalitySuicideRiskAsc = 'SUICIDALITY_SUICIDE_RISK_ASC',
  SuicidalitySuicideRiskDesc = 'SUICIDALITY_SUICIDE_RISK_DESC',
  SuicidalityNoSuicideContractAsc = 'SUICIDALITY_NO_SUICIDE_CONTRACT_ASC',
  SuicidalityNoSuicideContractDesc = 'SUICIDALITY_NO_SUICIDE_CONTRACT_DESC',
  SuicidalityNotesAsc = 'SUICIDALITY_NOTES_ASC',
  SuicidalityNotesDesc = 'SUICIDALITY_NOTES_DESC',
  TraumaDescriptionAsc = 'TRAUMA_DESCRIPTION_ASC',
  TraumaDescriptionDesc = 'TRAUMA_DESCRIPTION_DESC',
  PtsdCheckedAsc = 'PTSD_CHECKED_ASC',
  PtsdCheckedDesc = 'PTSD_CHECKED_DESC',
  PtsdB1Asc = 'PTSD_B1_ASC',
  PtsdB1Desc = 'PTSD_B1_DESC',
  PtsdB2Asc = 'PTSD_B2_ASC',
  PtsdB2Desc = 'PTSD_B2_DESC',
  PtsdB3Asc = 'PTSD_B3_ASC',
  PtsdB3Desc = 'PTSD_B3_DESC',
  PtsdB4Asc = 'PTSD_B4_ASC',
  PtsdB4Desc = 'PTSD_B4_DESC',
  PtsdB5Asc = 'PTSD_B5_ASC',
  PtsdB5Desc = 'PTSD_B5_DESC',
  PtsdBFulfilledAsc = 'PTSD_B_FULFILLED_ASC',
  PtsdBFulfilledDesc = 'PTSD_B_FULFILLED_DESC',
  PtsdC1Asc = 'PTSD_C1_ASC',
  PtsdC1Desc = 'PTSD_C1_DESC',
  PtsdC2Asc = 'PTSD_C2_ASC',
  PtsdC2Desc = 'PTSD_C2_DESC',
  PtsdCFulfilledAsc = 'PTSD_C_FULFILLED_ASC',
  PtsdCFulfilledDesc = 'PTSD_C_FULFILLED_DESC',
  PtsdD1Asc = 'PTSD_D1_ASC',
  PtsdD1Desc = 'PTSD_D1_DESC',
  PtsdD2Asc = 'PTSD_D2_ASC',
  PtsdD2Desc = 'PTSD_D2_DESC',
  PtsdD3Asc = 'PTSD_D3_ASC',
  PtsdD3Desc = 'PTSD_D3_DESC',
  PtsdD4Asc = 'PTSD_D4_ASC',
  PtsdD4Desc = 'PTSD_D4_DESC',
  PtsdD5Asc = 'PTSD_D5_ASC',
  PtsdD5Desc = 'PTSD_D5_DESC',
  PtsdD6Asc = 'PTSD_D6_ASC',
  PtsdD6Desc = 'PTSD_D6_DESC',
  PtsdD7Asc = 'PTSD_D7_ASC',
  PtsdD7Desc = 'PTSD_D7_DESC',
  PtsdDFulfilledAsc = 'PTSD_D_FULFILLED_ASC',
  PtsdDFulfilledDesc = 'PTSD_D_FULFILLED_DESC',
  PtsdE1Asc = 'PTSD_E1_ASC',
  PtsdE1Desc = 'PTSD_E1_DESC',
  PtsdE2Asc = 'PTSD_E2_ASC',
  PtsdE2Desc = 'PTSD_E2_DESC',
  PtsdE3Asc = 'PTSD_E3_ASC',
  PtsdE3Desc = 'PTSD_E3_DESC',
  PtsdE4Asc = 'PTSD_E4_ASC',
  PtsdE4Desc = 'PTSD_E4_DESC',
  PtsdE5Asc = 'PTSD_E5_ASC',
  PtsdE5Desc = 'PTSD_E5_DESC',
  PtsdE6Asc = 'PTSD_E6_ASC',
  PtsdE6Desc = 'PTSD_E6_DESC',
  PtsdEFulfilledAsc = 'PTSD_E_FULFILLED_ASC',
  PtsdEFulfilledDesc = 'PTSD_E_FULFILLED_DESC',
  PtsdFFulfilledAsc = 'PTSD_F_FULFILLED_ASC',
  PtsdFFulfilledDesc = 'PTSD_F_FULFILLED_DESC',
  PtsdGFulfilledAsc = 'PTSD_G_FULFILLED_ASC',
  PtsdGFulfilledDesc = 'PTSD_G_FULFILLED_DESC',
  PtsdHFulfilledAsc = 'PTSD_H_FULFILLED_ASC',
  PtsdHFulfilledDesc = 'PTSD_H_FULFILLED_DESC',
  PtsdTotalFulfilledAsc = 'PTSD_TOTAL_FULFILLED_ASC',
  PtsdTotalFulfilledDesc = 'PTSD_TOTAL_FULFILLED_DESC',
  PtsdNotesAsc = 'PTSD_NOTES_ASC',
  PtsdNotesDesc = 'PTSD_NOTES_DESC',
  CmdeA1Asc = 'CMDE_A1_ASC',
  CmdeA1Desc = 'CMDE_A1_DESC',
  CmdeA2Asc = 'CMDE_A2_ASC',
  CmdeA2Desc = 'CMDE_A2_DESC',
  CmdeA3Asc = 'CMDE_A3_ASC',
  CmdeA3Desc = 'CMDE_A3_DESC',
  CmdeA4Asc = 'CMDE_A4_ASC',
  CmdeA4Desc = 'CMDE_A4_DESC',
  CmdeA5Asc = 'CMDE_A5_ASC',
  CmdeA5Desc = 'CMDE_A5_DESC',
  CmdeA6Asc = 'CMDE_A6_ASC',
  CmdeA6Desc = 'CMDE_A6_DESC',
  CmdeA7Asc = 'CMDE_A7_ASC',
  CmdeA7Desc = 'CMDE_A7_DESC',
  CmdeA8Asc = 'CMDE_A8_ASC',
  CmdeA8Desc = 'CMDE_A8_DESC',
  CmdeA9Asc = 'CMDE_A9_ASC',
  CmdeA9Desc = 'CMDE_A9_DESC',
  CmdeAFulfilledAsc = 'CMDE_A_FULFILLED_ASC',
  CmdeAFulfilledDesc = 'CMDE_A_FULFILLED_DESC',
  CmdeBFulfilledAsc = 'CMDE_B_FULFILLED_ASC',
  CmdeBFulfilledDesc = 'CMDE_B_FULFILLED_DESC',
  CmdeCFulfilledAsc = 'CMDE_C_FULFILLED_ASC',
  CmdeCFulfilledDesc = 'CMDE_C_FULFILLED_DESC',
  CmdeMdeTotalFulfilledAsc = 'CMDE_MDE_TOTAL_FULFILLED_ASC',
  CmdeMdeTotalFulfilledDesc = 'CMDE_MDE_TOTAL_FULFILLED_DESC',
  CmdeActualEpisodeStartsWeeksAsc = 'CMDE_ACTUAL_EPISODE_STARTS_WEEKS_ASC',
  CmdeActualEpisodeStartsWeeksDesc = 'CMDE_ACTUAL_EPISODE_STARTS_WEEKS_DESC',
  CmdeActualEpisodeStartsMonthsAsc = 'CMDE_ACTUAL_EPISODE_STARTS_MONTHS_ASC',
  CmdeActualEpisodeStartsMonthsDesc = 'CMDE_ACTUAL_EPISODE_STARTS_MONTHS_DESC',
  CmdeLastEpisodeBeforeMonthsAsc = 'CMDE_LAST_EPISODE_BEFORE_MONTHS_ASC',
  CmdeLastEpisodeBeforeMonthsDesc = 'CMDE_LAST_EPISODE_BEFORE_MONTHS_DESC',
  CmdeLastEpisodeBeforeYearsAsc = 'CMDE_LAST_EPISODE_BEFORE_YEARS_ASC',
  CmdeLastEpisodeBeforeYearsDesc = 'CMDE_LAST_EPISODE_BEFORE_YEARS_DESC',
  CmdeNumberOfEpisodesAsc = 'CMDE_NUMBER_OF_EPISODES_ASC',
  CmdeNumberOfEpisodesDesc = 'CMDE_NUMBER_OF_EPISODES_DESC',
  CmdeNotesAsc = 'CMDE_NOTES_ASC',
  CmdeNotesDesc = 'CMDE_NOTES_DESC',
  DysthymiaAFulfilledAsc = 'DYSTHYMIA_A_FULFILLED_ASC',
  DysthymiaAFulfilledDesc = 'DYSTHYMIA_A_FULFILLED_DESC',
  DysthymiaB1Asc = 'DYSTHYMIA_B1_ASC',
  DysthymiaB1Desc = 'DYSTHYMIA_B1_DESC',
  DysthymiaB2Asc = 'DYSTHYMIA_B2_ASC',
  DysthymiaB2Desc = 'DYSTHYMIA_B2_DESC',
  DysthymiaB3Asc = 'DYSTHYMIA_B3_ASC',
  DysthymiaB3Desc = 'DYSTHYMIA_B3_DESC',
  DysthymiaB4Asc = 'DYSTHYMIA_B4_ASC',
  DysthymiaB4Desc = 'DYSTHYMIA_B4_DESC',
  DysthymiaB5Asc = 'DYSTHYMIA_B5_ASC',
  DysthymiaB5Desc = 'DYSTHYMIA_B5_DESC',
  DysthymiaB6Asc = 'DYSTHYMIA_B6_ASC',
  DysthymiaB6Desc = 'DYSTHYMIA_B6_DESC',
  DysthymiaBFulfilledAsc = 'DYSTHYMIA_B_FULFILLED_ASC',
  DysthymiaBFulfilledDesc = 'DYSTHYMIA_B_FULFILLED_DESC',
  DysthymiaCFulfilledAsc = 'DYSTHYMIA_C_FULFILLED_ASC',
  DysthymiaCFulfilledDesc = 'DYSTHYMIA_C_FULFILLED_DESC',
  DysthymiaEFulfilledAsc = 'DYSTHYMIA_E_FULFILLED_ASC',
  DysthymiaEFulfilledDesc = 'DYSTHYMIA_E_FULFILLED_DESC',
  DysthymiaFFulfilledAsc = 'DYSTHYMIA_F_FULFILLED_ASC',
  DysthymiaFFulfilledDesc = 'DYSTHYMIA_F_FULFILLED_DESC',
  DysthymiaGFulfilledAsc = 'DYSTHYMIA_G_FULFILLED_ASC',
  DysthymiaGFulfilledDesc = 'DYSTHYMIA_G_FULFILLED_DESC',
  DysthymiaHFulfilledAsc = 'DYSTHYMIA_H_FULFILLED_ASC',
  DysthymiaHFulfilledDesc = 'DYSTHYMIA_H_FULFILLED_DESC',
  DysthymiaTotalFulfilledAsc = 'DYSTHYMIA_TOTAL_FULFILLED_ASC',
  DysthymiaTotalFulfilledDesc = 'DYSTHYMIA_TOTAL_FULFILLED_DESC',
  DysthymiaNotesAsc = 'DYSTHYMIA_NOTES_ASC',
  DysthymiaNotesDesc = 'DYSTHYMIA_NOTES_DESC',
  PrimaryProblemAsc = 'PRIMARY_PROBLEM_ASC',
  PrimaryProblemDesc = 'PRIMARY_PROBLEM_DESC',
  PrimaryProblemStatusAcceptedAsc = 'PRIMARY_PROBLEM_STATUS_ACCEPTED_ASC',
  PrimaryProblemStatusAcceptedDesc = 'PRIMARY_PROBLEM_STATUS_ACCEPTED_DESC',
  PrimaryProblemStatusRejectedAsc = 'PRIMARY_PROBLEM_STATUS_REJECTED_ASC',
  PrimaryProblemStatusRejectedDesc = 'PRIMARY_PROBLEM_STATUS_REJECTED_DESC',
  PatientAcceptedForCounselingAsc = 'PATIENT_ACCEPTED_FOR_COUNSELING_ASC',
  PatientAcceptedForCounselingDesc = 'PATIENT_ACCEPTED_FOR_COUNSELING_DESC',
  ReasonsForCounselingAsc = 'REASONS_FOR_COUNSELING_ASC',
  ReasonsForCounselingDesc = 'REASONS_FOR_COUNSELING_DESC',
  AccessibilityTimeAsc = 'ACCESSIBILITY_TIME_ASC',
  AccessibilityTimeDesc = 'ACCESSIBILITY_TIME_DESC',
  AdditionalCommentsAsc = 'ADDITIONAL_COMMENTS_ASC',
  AdditionalCommentsDesc = 'ADDITIONAL_COMMENTS_DESC',
  PatientNeedsToRegisterAgainAsc = 'PATIENT_NEEDS_TO_REGISTER_AGAIN_ASC',
  PatientNeedsToRegisterAgainDesc = 'PATIENT_NEEDS_TO_REGISTER_AGAIN_DESC',
  ReasonsForFutureRegistrationAsc = 'REASONS_FOR_FUTURE_REGISTRATION_ASC',
  ReasonsForFutureRegistrationDesc = 'REASONS_FOR_FUTURE_REGISTRATION_DESC',
  StateIfOtherReasonsAsc = 'STATE_IF_OTHER_REASONS_ASC',
  StateIfOtherReasonsDesc = 'STATE_IF_OTHER_REASONS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  Hra_1Asc = 'HRA_1_ASC',
  Hra_1Desc = 'HRA_1_DESC',
  Hra_2Asc = 'HRA_2_ASC',
  Hra_2Desc = 'HRA_2_DESC',
  Hra_3Asc = 'HRA_3_ASC',
  Hra_3Desc = 'HRA_3_DESC',
  Hra_4Asc = 'HRA_4_ASC',
  Hra_4Desc = 'HRA_4_DESC',
  Hra_5Asc = 'HRA_5_ASC',
  Hra_5Desc = 'HRA_5_DESC',
  Hra_6Asc = 'HRA_6_ASC',
  Hra_6Desc = 'HRA_6_DESC',
  Audit_1Asc = 'AUDIT_1_ASC',
  Audit_1Desc = 'AUDIT_1_DESC',
  Audit_2Asc = 'AUDIT_2_ASC',
  Audit_2Desc = 'AUDIT_2_DESC',
  Audit_3Asc = 'AUDIT_3_ASC',
  Audit_3Desc = 'AUDIT_3_DESC',
  Audit_4Asc = 'AUDIT_4_ASC',
  Audit_4Desc = 'AUDIT_4_DESC',
  Audit_5Asc = 'AUDIT_5_ASC',
  Audit_5Desc = 'AUDIT_5_DESC',
  Audit_6Asc = 'AUDIT_6_ASC',
  Audit_6Desc = 'AUDIT_6_DESC',
  Audit_7Asc = 'AUDIT_7_ASC',
  Audit_7Desc = 'AUDIT_7_DESC',
  Audit_8Asc = 'AUDIT_8_ASC',
  Audit_8Desc = 'AUDIT_8_DESC',
  Audit_9Asc = 'AUDIT_9_ASC',
  Audit_9Desc = 'AUDIT_9_DESC',
  Audit_10Asc = 'AUDIT_10_ASC',
  Audit_10Desc = 'AUDIT_10_DESC',
  Dast_1Asc = 'DAST_1_ASC',
  Dast_1Desc = 'DAST_1_DESC',
  Dast_2Asc = 'DAST_2_ASC',
  Dast_2Desc = 'DAST_2_DESC',
  Dast_3Asc = 'DAST_3_ASC',
  Dast_3Desc = 'DAST_3_DESC',
  Dast_4Asc = 'DAST_4_ASC',
  Dast_4Desc = 'DAST_4_DESC',
  Dast_5Asc = 'DAST_5_ASC',
  Dast_5Desc = 'DAST_5_DESC',
  Dast_6Asc = 'DAST_6_ASC',
  Dast_6Desc = 'DAST_6_DESC',
  Dast_7Asc = 'DAST_7_ASC',
  Dast_7Desc = 'DAST_7_DESC',
  Dast_8Asc = 'DAST_8_ASC',
  Dast_8Desc = 'DAST_8_DESC',
  Dast_9Asc = 'DAST_9_ASC',
  Dast_9Desc = 'DAST_9_DESC',
  Dast_10Asc = 'DAST_10_ASC',
  Dast_10Desc = 'DAST_10_DESC',
  PmdeA1Asc = 'PMDE_A1_ASC',
  PmdeA1Desc = 'PMDE_A1_DESC',
  PmdeA2Asc = 'PMDE_A2_ASC',
  PmdeA2Desc = 'PMDE_A2_DESC',
  PmdeA3Asc = 'PMDE_A3_ASC',
  PmdeA3Desc = 'PMDE_A3_DESC',
  PmdeA4Asc = 'PMDE_A4_ASC',
  PmdeA4Desc = 'PMDE_A4_DESC',
  PmdeA5Asc = 'PMDE_A5_ASC',
  PmdeA5Desc = 'PMDE_A5_DESC',
  PmdeA6Asc = 'PMDE_A6_ASC',
  PmdeA6Desc = 'PMDE_A6_DESC',
  PmdeA7Asc = 'PMDE_A7_ASC',
  PmdeA7Desc = 'PMDE_A7_DESC',
  PmdeA8Asc = 'PMDE_A8_ASC',
  PmdeA8Desc = 'PMDE_A8_DESC',
  PmdeA9Asc = 'PMDE_A9_ASC',
  PmdeA9Desc = 'PMDE_A9_DESC',
  PmdeAFulfilledAsc = 'PMDE_A_FULFILLED_ASC',
  PmdeAFulfilledDesc = 'PMDE_A_FULFILLED_DESC',
  PmdeBFulfilledAsc = 'PMDE_B_FULFILLED_ASC',
  PmdeBFulfilledDesc = 'PMDE_B_FULFILLED_DESC',
  PmdeCFulfilledAsc = 'PMDE_C_FULFILLED_ASC',
  PmdeCFulfilledDesc = 'PMDE_C_FULFILLED_DESC',
  PmdeTotalFulfilledAsc = 'PMDE_TOTAL_FULFILLED_ASC',
  PmdeTotalFulfilledDesc = 'PMDE_TOTAL_FULFILLED_DESC',
  PmdeActualEpisodeStartsWeeksAsc = 'PMDE_ACTUAL_EPISODE_STARTS_WEEKS_ASC',
  PmdeActualEpisodeStartsWeeksDesc = 'PMDE_ACTUAL_EPISODE_STARTS_WEEKS_DESC',
  PmdeActualEpisodeStartsMonthsAsc = 'PMDE_ACTUAL_EPISODE_STARTS_MONTHS_ASC',
  PmdeActualEpisodeStartsMonthsDesc = 'PMDE_ACTUAL_EPISODE_STARTS_MONTHS_DESC',
  PmdeNumberOfEpisodesAsc = 'PMDE_NUMBER_OF_EPISODES_ASC',
  PmdeNumberOfEpisodesDesc = 'PMDE_NUMBER_OF_EPISODES_DESC',
  CmanA1Asc = 'CMAN_A1_ASC',
  CmanA1Desc = 'CMAN_A1_DESC',
  CmanA2Asc = 'CMAN_A2_ASC',
  CmanA2Desc = 'CMAN_A2_DESC',
  CmanB1Asc = 'CMAN_B1_ASC',
  CmanB1Desc = 'CMAN_B1_DESC',
  CmanB2Asc = 'CMAN_B2_ASC',
  CmanB2Desc = 'CMAN_B2_DESC',
  CmanB3Asc = 'CMAN_B3_ASC',
  CmanB3Desc = 'CMAN_B3_DESC',
  CmanB4Asc = 'CMAN_B4_ASC',
  CmanB4Desc = 'CMAN_B4_DESC',
  CmanB5Asc = 'CMAN_B5_ASC',
  CmanB5Desc = 'CMAN_B5_DESC',
  CmanB6Asc = 'CMAN_B6_ASC',
  CmanB6Desc = 'CMAN_B6_DESC',
  CmanB7Asc = 'CMAN_B7_ASC',
  CmanB7Desc = 'CMAN_B7_DESC',
  CmanC1Asc = 'CMAN_C1_ASC',
  CmanC1Desc = 'CMAN_C1_DESC',
  CmanD1Asc = 'CMAN_D1_ASC',
  CmanD1Desc = 'CMAN_D1_DESC',
  CmanFulfilledAsc = 'CMAN_FULFILLED_ASC',
  CmanFulfilledDesc = 'CMAN_FULFILLED_DESC',
  ChmanA1Asc = 'CHMAN_A1_ASC',
  ChmanA1Desc = 'CHMAN_A1_DESC',
  ChmanB1Asc = 'CHMAN_B1_ASC',
  ChmanB1Desc = 'CHMAN_B1_DESC',
  ChmanB2Asc = 'CHMAN_B2_ASC',
  ChmanB2Desc = 'CHMAN_B2_DESC',
  ChmanB3Asc = 'CHMAN_B3_ASC',
  ChmanB3Desc = 'CHMAN_B3_DESC',
  ChmanB4Asc = 'CHMAN_B4_ASC',
  ChmanB4Desc = 'CHMAN_B4_DESC',
  ChmanB5Asc = 'CHMAN_B5_ASC',
  ChmanB5Desc = 'CHMAN_B5_DESC',
  ChmanB6Asc = 'CHMAN_B6_ASC',
  ChmanB6Desc = 'CHMAN_B6_DESC',
  ChmanB7Asc = 'CHMAN_B7_ASC',
  ChmanB7Desc = 'CHMAN_B7_DESC',
  ChmanCAsc = 'CHMAN_C_ASC',
  ChmanCDesc = 'CHMAN_C_DESC',
  ChmanDAsc = 'CHMAN_D_ASC',
  ChmanDDesc = 'CHMAN_D_DESC',
  ChmanEAsc = 'CHMAN_E_ASC',
  ChmanEDesc = 'CHMAN_E_DESC',
  ChmanFAsc = 'CHMAN_F_ASC',
  ChmanFDesc = 'CHMAN_F_DESC',
  ChmanFulfilledAsc = 'CHMAN_FULFILLED_ASC',
  ChmanFulfilledDesc = 'CHMAN_FULFILLED_DESC',
  PmanA1Asc = 'PMAN_A1_ASC',
  PmanA1Desc = 'PMAN_A1_DESC',
  PmanA2Asc = 'PMAN_A2_ASC',
  PmanA2Desc = 'PMAN_A2_DESC',
  PmanB1Asc = 'PMAN_B1_ASC',
  PmanB1Desc = 'PMAN_B1_DESC',
  PmanB2Asc = 'PMAN_B2_ASC',
  PmanB2Desc = 'PMAN_B2_DESC',
  PmanB3Asc = 'PMAN_B3_ASC',
  PmanB3Desc = 'PMAN_B3_DESC',
  PmanB4Asc = 'PMAN_B4_ASC',
  PmanB4Desc = 'PMAN_B4_DESC',
  PmanB5Asc = 'PMAN_B5_ASC',
  PmanB5Desc = 'PMAN_B5_DESC',
  PmanB6Asc = 'PMAN_B6_ASC',
  PmanB6Desc = 'PMAN_B6_DESC',
  PmanB7Asc = 'PMAN_B7_ASC',
  PmanB7Desc = 'PMAN_B7_DESC',
  PmanC1Asc = 'PMAN_C1_ASC',
  PmanC1Desc = 'PMAN_C1_DESC',
  PmanD1Asc = 'PMAN_D1_ASC',
  PmanD1Desc = 'PMAN_D1_DESC',
  PmanFulfilledAsc = 'PMAN_FULFILLED_ASC',
  PmanFulfilledDesc = 'PMAN_FULFILLED_DESC',
  PhmanA1Asc = 'PHMAN_A1_ASC',
  PhmanA1Desc = 'PHMAN_A1_DESC',
  PhmanB1Asc = 'PHMAN_B1_ASC',
  PhmanB1Desc = 'PHMAN_B1_DESC',
  PhmanB2Asc = 'PHMAN_B2_ASC',
  PhmanB2Desc = 'PHMAN_B2_DESC',
  PhmanB3Asc = 'PHMAN_B3_ASC',
  PhmanB3Desc = 'PHMAN_B3_DESC',
  PhmanB4Asc = 'PHMAN_B4_ASC',
  PhmanB4Desc = 'PHMAN_B4_DESC',
  PhmanB5Asc = 'PHMAN_B5_ASC',
  PhmanB5Desc = 'PHMAN_B5_DESC',
  PhmanB6Asc = 'PHMAN_B6_ASC',
  PhmanB6Desc = 'PHMAN_B6_DESC',
  PhmanB7Asc = 'PHMAN_B7_ASC',
  PhmanB7Desc = 'PHMAN_B7_DESC',
  PhmanCAsc = 'PHMAN_C_ASC',
  PhmanCDesc = 'PHMAN_C_DESC',
  PhmanDAsc = 'PHMAN_D_ASC',
  PhmanDDesc = 'PHMAN_D_DESC',
  PhmanEAsc = 'PHMAN_E_ASC',
  PhmanEDesc = 'PHMAN_E_DESC',
  PhmanFAsc = 'PHMAN_F_ASC',
  PhmanFDesc = 'PHMAN_F_DESC',
  PhmanFulfilledAsc = 'PHMAN_FULFILLED_ASC',
  PhmanFulfilledDesc = 'PHMAN_FULFILLED_DESC',
  PsychB1Asc = 'PSYCH_B1_ASC',
  PsychB1Desc = 'PSYCH_B1_DESC',
  PsychB2Asc = 'PSYCH_B2_ASC',
  PsychB2Desc = 'PSYCH_B2_DESC',
  PsychB3Asc = 'PSYCH_B3_ASC',
  PsychB3Desc = 'PSYCH_B3_DESC',
  PsychB4Asc = 'PSYCH_B4_ASC',
  PsychB4Desc = 'PSYCH_B4_DESC',
  PsychB5Asc = 'PSYCH_B5_ASC',
  PsychB5Desc = 'PSYCH_B5_DESC',
  PsychB6Asc = 'PSYCH_B6_ASC',
  PsychB6Desc = 'PSYCH_B6_DESC',
  PsychB7Asc = 'PSYCH_B7_ASC',
  PsychB7Desc = 'PSYCH_B7_DESC',
  PsychB8Asc = 'PSYCH_B8_ASC',
  PsychB8Desc = 'PSYCH_B8_DESC',
  PsychB9Asc = 'PSYCH_B9_ASC',
  PsychB9Desc = 'PSYCH_B9_DESC',
  PsychB10Asc = 'PSYCH_B10_ASC',
  PsychB10Desc = 'PSYCH_B10_DESC',
  PsychB11Asc = 'PSYCH_B11_ASC',
  PsychB11Desc = 'PSYCH_B11_DESC',
  PsychB12Asc = 'PSYCH_B12_ASC',
  PsychB12Desc = 'PSYCH_B12_DESC',
  PsychB13Asc = 'PSYCH_B13_ASC',
  PsychB13Desc = 'PSYCH_B13_DESC',
  PsychB14Asc = 'PSYCH_B14_ASC',
  PsychB14Desc = 'PSYCH_B14_DESC',
  PsychB15Asc = 'PSYCH_B15_ASC',
  PsychB15Desc = 'PSYCH_B15_DESC',
  PsychB16Asc = 'PSYCH_B16_ASC',
  PsychB16Desc = 'PSYCH_B16_DESC',
  PsychB17Asc = 'PSYCH_B17_ASC',
  PsychB17Desc = 'PSYCH_B17_DESC',
  PsychB18Asc = 'PSYCH_B18_ASC',
  PsychB18Desc = 'PSYCH_B18_DESC',
  PsychB19Asc = 'PSYCH_B19_ASC',
  PsychB19Desc = 'PSYCH_B19_DESC',
  RejectionOtherReasonsAsc = 'REJECTION_OTHER_REASONS_ASC',
  RejectionOtherReasonsDesc = 'REJECTION_OTHER_REASONS_DESC',
  HraTotalFulfilledAsc = 'HRA_TOTAL_FULFILLED_ASC',
  HraTotalFulfilledDesc = 'HRA_TOTAL_FULFILLED_DESC',
  AuditTotalScoreAsc = 'AUDIT_TOTAL_SCORE_ASC',
  AuditTotalScoreDesc = 'AUDIT_TOTAL_SCORE_DESC',
  AuditTotalFulfilledAsc = 'AUDIT_TOTAL_FULFILLED_ASC',
  AuditTotalFulfilledDesc = 'AUDIT_TOTAL_FULFILLED_DESC',
  PmdeNotesAsc = 'PMDE_NOTES_ASC',
  PmdeNotesDesc = 'PMDE_NOTES_DESC',
  DastTotalFulfilledAsc = 'DAST_TOTAL_FULFILLED_ASC',
  DastTotalFulfilledDesc = 'DAST_TOTAL_FULFILLED_DESC',
  CmanBFulfilledAsc = 'CMAN_B_FULFILLED_ASC',
  CmanBFulfilledDesc = 'CMAN_B_FULFILLED_DESC',
  ChmanBFulfilledAsc = 'CHMAN_B_FULFILLED_ASC',
  ChmanBFulfilledDesc = 'CHMAN_B_FULFILLED_DESC',
  PmanBFulfilledAsc = 'PMAN_B_FULFILLED_ASC',
  PmanBFulfilledDesc = 'PMAN_B_FULFILLED_DESC',
  PhmanBFulfilledAsc = 'PHMAN_B_FULFILLED_ASC',
  PhmanBFulfilledDesc = 'PHMAN_B_FULFILLED_DESC',
  PsychTotalFulfilledAsc = 'PSYCH_TOTAL_FULFILLED_ASC',
  PsychTotalFulfilledDesc = 'PSYCH_TOTAL_FULFILLED_DESC',
  PatientAcceptedAsc = 'PATIENT_ACCEPTED_ASC',
  PatientAcceptedDesc = 'PATIENT_ACCEPTED_DESC',
  PatientReasoningForCounselingAsc = 'PATIENT_REASONING_FOR_COUNSELING_ASC',
  PatientReasoningForCounselingDesc = 'PATIENT_REASONING_FOR_COUNSELING_DESC',
  PatientFutureRegistrationAsc = 'PATIENT_FUTURE_REGISTRATION_ASC',
  PatientFutureRegistrationDesc = 'PATIENT_FUTURE_REGISTRATION_DESC',
  PatientReasonsFutureRegistrationAsc = 'PATIENT_REASONS_FUTURE_REGISTRATION_ASC',
  PatientReasonsFutureRegistrationDesc = 'PATIENT_REASONS_FUTURE_REGISTRATION_DESC',
  HowDidYouHearAsc = 'HOW_DID_YOU_HEAR_ASC',
  HowDidYouHearDesc = 'HOW_DID_YOU_HEAR_DESC',
  GeneralChangesAsc = 'GENERAL_CHANGES_ASC',
  GeneralChangesDesc = 'GENERAL_CHANGES_DESC',
  ChangesForTheWorseAsc = 'CHANGES_FOR_THE_WORSE_ASC',
  ChangesForTheWorseDesc = 'CHANGES_FOR_THE_WORSE_DESC',
  CausesOfChangesAsc = 'CAUSES_OF_CHANGES_ASC',
  CausesOfChangesDesc = 'CAUSES_OF_CHANGES_DESC',
  HinderingOrUnnecessaryPartsAsc = 'HINDERING_OR_UNNECESSARY_PARTS_ASC',
  HinderingOrUnnecessaryPartsDesc = 'HINDERING_OR_UNNECESSARY_PARTS_DESC',
  DifficultButHelpfulPartsAsc = 'DIFFICULT_BUT_HELPFUL_PARTS_ASC',
  DifficultButHelpfulPartsDesc = 'DIFFICULT_BUT_HELPFUL_PARTS_DESC',
  NeglectedPartsAsc = 'NEGLECTED_PARTS_ASC',
  NeglectedPartsDesc = 'NEGLECTED_PARTS_DESC',
  MotivatingPartsAsc = 'MOTIVATING_PARTS_ASC',
  MotivatingPartsDesc = 'MOTIVATING_PARTS_DESC',
  TendencyToRecommendTheProgramAsc = 'TENDENCY_TO_RECOMMEND_THE_PROGRAM_ASC',
  TendencyToRecommendTheProgramDesc = 'TENDENCY_TO_RECOMMEND_THE_PROGRAM_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `fixCamundaMemberships` mutation. */
export interface FixCamundaMembershipsInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** The output of our `fixCamundaMemberships` mutation. */
export interface FixCamundaMembershipsPayload {
  __typename?: 'FixCamundaMembershipsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  actIdMemberships?: Maybe<Array<ActIdMembership>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export interface FloatFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Float']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['Float']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['Float']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['Float']>;
}

export interface Gad2 extends Node {
  __typename?: 'Gad2';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Gad2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad2`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Gad2` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Gad2Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Gad2` object types. All fields are combined with a logical ‘and.’ */
export interface Gad2Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Gad2Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Gad2Filter>>;
  /** Negates the expression. */
  not?: Maybe<Gad2Filter>;
}

/** An input for mutations affecting `Gad2` */
export interface Gad2Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Gad2`. Fields that are set will be updated. */
export interface Gad2Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Gad2` values. */
export interface Gad2SConnection {
  __typename?: 'Gad2SConnection';
  /** A list of `Gad2` objects. */
  nodes: Array<Gad2>;
  /** A list of edges which contains the `Gad2` and cursor to aid in pagination. */
  edges: Array<Gad2SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Gad2` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Gad2` edge in the connection. */
export interface Gad2SEdge {
  __typename?: 'Gad2SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Gad2` at the end of the edge. */
  node: Gad2;
}

/** Methods to use when ordering `Gad2`. */
export enum Gad2SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Gad7 extends Node {
  __typename?: 'Gad7';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  itemSeverity: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Gad7`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad7`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Gad7` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Gad7Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemSeverity` field. */
  itemSeverity?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Gad7` object types. All fields are combined with a logical ‘and.’ */
export interface Gad7Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `itemSeverity` field. */
  itemSeverity?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Gad7Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Gad7Filter>>;
  /** Negates the expression. */
  not?: Maybe<Gad7Filter>;
}

/** An input for mutations affecting `Gad7` */
export interface Gad7Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  itemSeverity: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Gad7`. Fields that are set will be updated. */
export interface Gad7Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  itemSeverity?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Gad7` values. */
export interface Gad7SConnection {
  __typename?: 'Gad7SConnection';
  /** A list of `Gad7` objects. */
  nodes: Array<Gad7>;
  /** A list of edges which contains the `Gad7` and cursor to aid in pagination. */
  edges: Array<Gad7SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Gad7` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Gad7` edge in the connection. */
export interface Gad7SEdge {
  __typename?: 'Gad7SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Gad7` at the end of the edge. */
  node: Gad7;
}

/** Methods to use when ordering `Gad7`. */
export enum Gad7SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  ItemSeverityAsc = 'ITEM_SEVERITY_ASC',
  ItemSeverityDesc = 'ITEM_SEVERITY_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Diverse = 'DIVERSE'
}

/** A filter to be used against Gender fields. All fields are combined with a logical ‘and.’ */
export interface GenderFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Gender>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Gender>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Gender>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Gender>;
  /** Included in the specified list. */
  in?: Maybe<Array<Gender>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Gender>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Gender>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Gender>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Gender>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Gender>;
}

export interface HashedEmail extends Node {
  __typename?: 'HashedEmail';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  hashedEmail?: Maybe<Scalars['String']>;
  validTill: Scalars['Datetime'];
  createdAt: Scalars['Datetime'];
}

/**
 * A condition to be used against `HashedEmail` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface HashedEmailCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `hashedEmail` field. */
  hashedEmail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `validTill` field. */
  validTill?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `HashedEmail` object types. All fields are combined with a logical ‘and.’ */
export interface HashedEmailFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `hashedEmail` field. */
  hashedEmail?: Maybe<StringFilter>;
  /** Filter by the object’s `validTill` field. */
  validTill?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<HashedEmailFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<HashedEmailFilter>>;
  /** Negates the expression. */
  not?: Maybe<HashedEmailFilter>;
}

/** An input for mutations affecting `HashedEmail` */
export interface HashedEmailInput {
  id?: Maybe<Scalars['UUID']>;
  hashedEmail?: Maybe<Scalars['String']>;
  validTill: Scalars['Datetime'];
  createdAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `HashedEmail`. Fields that are set will be updated. */
export interface HashedEmailPatch {
  id?: Maybe<Scalars['UUID']>;
  hashedEmail?: Maybe<Scalars['String']>;
  validTill?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `HashedEmail` values. */
export interface HashedEmailsConnection {
  __typename?: 'HashedEmailsConnection';
  /** A list of `HashedEmail` objects. */
  nodes: Array<HashedEmail>;
  /** A list of edges which contains the `HashedEmail` and cursor to aid in pagination. */
  edges: Array<HashedEmailsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HashedEmail` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `HashedEmail` edge in the connection. */
export interface HashedEmailsEdge {
  __typename?: 'HashedEmailsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `HashedEmail` at the end of the edge. */
  node: HashedEmail;
}

/** Methods to use when ordering `HashedEmail`. */
export enum HashedEmailsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  HashedEmailAsc = 'HASHED_EMAIL_ASC',
  HashedEmailDesc = 'HASHED_EMAIL_DESC',
  ValidTillAsc = 'VALID_TILL_ASC',
  ValidTillDesc = 'VALID_TILL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Inep extends Node {
  __typename?: 'Inep';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  hasPartner: Scalars['Boolean'];
  item1Agreement: Scalars['Int'];
  item1Attribution: Scalars['Int'];
  item2Agreement: Scalars['Int'];
  item2Attribution: Scalars['Int'];
  item3Agreement: Scalars['Int'];
  item3Attribution: Scalars['Int'];
  item4Agreement?: Maybe<Scalars['Int']>;
  item4Attribution?: Maybe<Scalars['Int']>;
  item5Agreement: Scalars['Int'];
  item5Attribution: Scalars['Int'];
  item6Agreement: Scalars['Int'];
  item6Attribution: Scalars['Int'];
  item7Agreement: Scalars['Int'];
  item7Attribution?: Maybe<Scalars['Int']>;
  item8Agreement: Scalars['Int'];
  item8Attribution?: Maybe<Scalars['Int']>;
  item9Agreement: Scalars['Int'];
  item9Attribution?: Maybe<Scalars['Int']>;
  item10Agreement: Scalars['Int'];
  item10Attribution?: Maybe<Scalars['Int']>;
  item11Agreement: Scalars['Int'];
  item11Attribution?: Maybe<Scalars['Int']>;
  item12Agreement?: Maybe<Scalars['Int']>;
  item12Attribution?: Maybe<Scalars['Int']>;
  item13Agreement: Scalars['Int'];
  item13Attribution?: Maybe<Scalars['Int']>;
  item14Agreement: Scalars['Int'];
  item14Attribution?: Maybe<Scalars['Int']>;
  item15Agreement: Scalars['Int'];
  item15Attribution?: Maybe<Scalars['Int']>;
  scoreNegative?: Maybe<Scalars['Int']>;
  scorePositive?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Inep`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Inep`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Inep` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface InepCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasPartner` field. */
  hasPartner?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item1Agreement` field. */
  item1Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item1Attribution` field. */
  item1Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2Agreement` field. */
  item2Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2Attribution` field. */
  item2Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3Agreement` field. */
  item3Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3Attribution` field. */
  item3Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4Agreement` field. */
  item4Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4Attribution` field. */
  item4Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5Agreement` field. */
  item5Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5Attribution` field. */
  item5Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6Agreement` field. */
  item6Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6Attribution` field. */
  item6Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7Agreement` field. */
  item7Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7Attribution` field. */
  item7Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8Agreement` field. */
  item8Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8Attribution` field. */
  item8Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9Agreement` field. */
  item9Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9Attribution` field. */
  item9Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10Agreement` field. */
  item10Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10Attribution` field. */
  item10Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11Agreement` field. */
  item11Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11Attribution` field. */
  item11Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12Agreement` field. */
  item12Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12Attribution` field. */
  item12Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13Agreement` field. */
  item13Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13Attribution` field. */
  item13Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14Agreement` field. */
  item14Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14Attribution` field. */
  item14Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15Agreement` field. */
  item15Agreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15Attribution` field. */
  item15Attribution?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreNegative` field. */
  scoreNegative?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scorePositive` field. */
  scorePositive?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Inep` object types. All fields are combined with a logical ‘and.’ */
export interface InepFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `hasPartner` field. */
  hasPartner?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item1Agreement` field. */
  item1Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item1Attribution` field. */
  item1Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item2Agreement` field. */
  item2Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item2Attribution` field. */
  item2Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item3Agreement` field. */
  item3Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item3Attribution` field. */
  item3Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item4Agreement` field. */
  item4Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item4Attribution` field. */
  item4Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item5Agreement` field. */
  item5Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item5Attribution` field. */
  item5Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item6Agreement` field. */
  item6Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item6Attribution` field. */
  item6Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item7Agreement` field. */
  item7Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item7Attribution` field. */
  item7Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item8Agreement` field. */
  item8Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item8Attribution` field. */
  item8Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item9Agreement` field. */
  item9Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item9Attribution` field. */
  item9Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item10Agreement` field. */
  item10Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item10Attribution` field. */
  item10Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item11Agreement` field. */
  item11Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item11Attribution` field. */
  item11Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item12Agreement` field. */
  item12Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item12Attribution` field. */
  item12Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item13Agreement` field. */
  item13Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item13Attribution` field. */
  item13Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item14Agreement` field. */
  item14Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item14Attribution` field. */
  item14Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `item15Agreement` field. */
  item15Agreement?: Maybe<IntFilter>;
  /** Filter by the object’s `item15Attribution` field. */
  item15Attribution?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreNegative` field. */
  scoreNegative?: Maybe<IntFilter>;
  /** Filter by the object’s `scorePositive` field. */
  scorePositive?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InepFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InepFilter>>;
  /** Negates the expression. */
  not?: Maybe<InepFilter>;
}

/** An input for mutations affecting `Inep` */
export interface InepInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  hasPartner: Scalars['Boolean'];
  item1Agreement: Scalars['Int'];
  item1Attribution: Scalars['Int'];
  item2Agreement: Scalars['Int'];
  item2Attribution: Scalars['Int'];
  item3Agreement: Scalars['Int'];
  item3Attribution: Scalars['Int'];
  item4Agreement?: Maybe<Scalars['Int']>;
  item4Attribution?: Maybe<Scalars['Int']>;
  item5Agreement: Scalars['Int'];
  item5Attribution: Scalars['Int'];
  item6Agreement: Scalars['Int'];
  item6Attribution: Scalars['Int'];
  item7Agreement: Scalars['Int'];
  item7Attribution?: Maybe<Scalars['Int']>;
  item8Agreement: Scalars['Int'];
  item8Attribution?: Maybe<Scalars['Int']>;
  item9Agreement: Scalars['Int'];
  item9Attribution?: Maybe<Scalars['Int']>;
  item10Agreement: Scalars['Int'];
  item10Attribution?: Maybe<Scalars['Int']>;
  item11Agreement: Scalars['Int'];
  item11Attribution?: Maybe<Scalars['Int']>;
  item12Agreement?: Maybe<Scalars['Int']>;
  item12Attribution?: Maybe<Scalars['Int']>;
  item13Agreement: Scalars['Int'];
  item13Attribution?: Maybe<Scalars['Int']>;
  item14Agreement: Scalars['Int'];
  item14Attribution?: Maybe<Scalars['Int']>;
  item15Agreement: Scalars['Int'];
  item15Attribution?: Maybe<Scalars['Int']>;
  scoreNegative?: Maybe<Scalars['Int']>;
  scorePositive?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Inep`. Fields that are set will be updated. */
export interface InepPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  hasPartner?: Maybe<Scalars['Boolean']>;
  item1Agreement?: Maybe<Scalars['Int']>;
  item1Attribution?: Maybe<Scalars['Int']>;
  item2Agreement?: Maybe<Scalars['Int']>;
  item2Attribution?: Maybe<Scalars['Int']>;
  item3Agreement?: Maybe<Scalars['Int']>;
  item3Attribution?: Maybe<Scalars['Int']>;
  item4Agreement?: Maybe<Scalars['Int']>;
  item4Attribution?: Maybe<Scalars['Int']>;
  item5Agreement?: Maybe<Scalars['Int']>;
  item5Attribution?: Maybe<Scalars['Int']>;
  item6Agreement?: Maybe<Scalars['Int']>;
  item6Attribution?: Maybe<Scalars['Int']>;
  item7Agreement?: Maybe<Scalars['Int']>;
  item7Attribution?: Maybe<Scalars['Int']>;
  item8Agreement?: Maybe<Scalars['Int']>;
  item8Attribution?: Maybe<Scalars['Int']>;
  item9Agreement?: Maybe<Scalars['Int']>;
  item9Attribution?: Maybe<Scalars['Int']>;
  item10Agreement?: Maybe<Scalars['Int']>;
  item10Attribution?: Maybe<Scalars['Int']>;
  item11Agreement?: Maybe<Scalars['Int']>;
  item11Attribution?: Maybe<Scalars['Int']>;
  item12Agreement?: Maybe<Scalars['Int']>;
  item12Attribution?: Maybe<Scalars['Int']>;
  item13Agreement?: Maybe<Scalars['Int']>;
  item13Attribution?: Maybe<Scalars['Int']>;
  item14Agreement?: Maybe<Scalars['Int']>;
  item14Attribution?: Maybe<Scalars['Int']>;
  item15Agreement?: Maybe<Scalars['Int']>;
  item15Attribution?: Maybe<Scalars['Int']>;
  scoreNegative?: Maybe<Scalars['Int']>;
  scorePositive?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Inep` values. */
export interface InepsConnection {
  __typename?: 'InepsConnection';
  /** A list of `Inep` objects. */
  nodes: Array<Inep>;
  /** A list of edges which contains the `Inep` and cursor to aid in pagination. */
  edges: Array<InepsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Inep` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Inep` edge in the connection. */
export interface InepsEdge {
  __typename?: 'InepsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Inep` at the end of the edge. */
  node: Inep;
}

/** Methods to use when ordering `Inep`. */
export enum InepsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  HasPartnerAsc = 'HAS_PARTNER_ASC',
  HasPartnerDesc = 'HAS_PARTNER_DESC',
  Item_1AgreementAsc = 'ITEM_1_AGREEMENT_ASC',
  Item_1AgreementDesc = 'ITEM_1_AGREEMENT_DESC',
  Item_1AttributionAsc = 'ITEM_1_ATTRIBUTION_ASC',
  Item_1AttributionDesc = 'ITEM_1_ATTRIBUTION_DESC',
  Item_2AgreementAsc = 'ITEM_2_AGREEMENT_ASC',
  Item_2AgreementDesc = 'ITEM_2_AGREEMENT_DESC',
  Item_2AttributionAsc = 'ITEM_2_ATTRIBUTION_ASC',
  Item_2AttributionDesc = 'ITEM_2_ATTRIBUTION_DESC',
  Item_3AgreementAsc = 'ITEM_3_AGREEMENT_ASC',
  Item_3AgreementDesc = 'ITEM_3_AGREEMENT_DESC',
  Item_3AttributionAsc = 'ITEM_3_ATTRIBUTION_ASC',
  Item_3AttributionDesc = 'ITEM_3_ATTRIBUTION_DESC',
  Item_4AgreementAsc = 'ITEM_4_AGREEMENT_ASC',
  Item_4AgreementDesc = 'ITEM_4_AGREEMENT_DESC',
  Item_4AttributionAsc = 'ITEM_4_ATTRIBUTION_ASC',
  Item_4AttributionDesc = 'ITEM_4_ATTRIBUTION_DESC',
  Item_5AgreementAsc = 'ITEM_5_AGREEMENT_ASC',
  Item_5AgreementDesc = 'ITEM_5_AGREEMENT_DESC',
  Item_5AttributionAsc = 'ITEM_5_ATTRIBUTION_ASC',
  Item_5AttributionDesc = 'ITEM_5_ATTRIBUTION_DESC',
  Item_6AgreementAsc = 'ITEM_6_AGREEMENT_ASC',
  Item_6AgreementDesc = 'ITEM_6_AGREEMENT_DESC',
  Item_6AttributionAsc = 'ITEM_6_ATTRIBUTION_ASC',
  Item_6AttributionDesc = 'ITEM_6_ATTRIBUTION_DESC',
  Item_7AgreementAsc = 'ITEM_7_AGREEMENT_ASC',
  Item_7AgreementDesc = 'ITEM_7_AGREEMENT_DESC',
  Item_7AttributionAsc = 'ITEM_7_ATTRIBUTION_ASC',
  Item_7AttributionDesc = 'ITEM_7_ATTRIBUTION_DESC',
  Item_8AgreementAsc = 'ITEM_8_AGREEMENT_ASC',
  Item_8AgreementDesc = 'ITEM_8_AGREEMENT_DESC',
  Item_8AttributionAsc = 'ITEM_8_ATTRIBUTION_ASC',
  Item_8AttributionDesc = 'ITEM_8_ATTRIBUTION_DESC',
  Item_9AgreementAsc = 'ITEM_9_AGREEMENT_ASC',
  Item_9AgreementDesc = 'ITEM_9_AGREEMENT_DESC',
  Item_9AttributionAsc = 'ITEM_9_ATTRIBUTION_ASC',
  Item_9AttributionDesc = 'ITEM_9_ATTRIBUTION_DESC',
  Item_10AgreementAsc = 'ITEM_10_AGREEMENT_ASC',
  Item_10AgreementDesc = 'ITEM_10_AGREEMENT_DESC',
  Item_10AttributionAsc = 'ITEM_10_ATTRIBUTION_ASC',
  Item_10AttributionDesc = 'ITEM_10_ATTRIBUTION_DESC',
  Item_11AgreementAsc = 'ITEM_11_AGREEMENT_ASC',
  Item_11AgreementDesc = 'ITEM_11_AGREEMENT_DESC',
  Item_11AttributionAsc = 'ITEM_11_ATTRIBUTION_ASC',
  Item_11AttributionDesc = 'ITEM_11_ATTRIBUTION_DESC',
  Item_12AgreementAsc = 'ITEM_12_AGREEMENT_ASC',
  Item_12AgreementDesc = 'ITEM_12_AGREEMENT_DESC',
  Item_12AttributionAsc = 'ITEM_12_ATTRIBUTION_ASC',
  Item_12AttributionDesc = 'ITEM_12_ATTRIBUTION_DESC',
  Item_13AgreementAsc = 'ITEM_13_AGREEMENT_ASC',
  Item_13AgreementDesc = 'ITEM_13_AGREEMENT_DESC',
  Item_13AttributionAsc = 'ITEM_13_ATTRIBUTION_ASC',
  Item_13AttributionDesc = 'ITEM_13_ATTRIBUTION_DESC',
  Item_14AgreementAsc = 'ITEM_14_AGREEMENT_ASC',
  Item_14AgreementDesc = 'ITEM_14_AGREEMENT_DESC',
  Item_14AttributionAsc = 'ITEM_14_ATTRIBUTION_ASC',
  Item_14AttributionDesc = 'ITEM_14_ATTRIBUTION_DESC',
  Item_15AgreementAsc = 'ITEM_15_AGREEMENT_ASC',
  Item_15AgreementDesc = 'ITEM_15_AGREEMENT_DESC',
  Item_15AttributionAsc = 'ITEM_15_ATTRIBUTION_ASC',
  Item_15AttributionDesc = 'ITEM_15_ATTRIBUTION_DESC',
  ScoreNegativeAsc = 'SCORE_NEGATIVE_ASC',
  ScoreNegativeDesc = 'SCORE_NEGATIVE_DESC',
  ScorePositiveAsc = 'SCORE_POSITIVE_ASC',
  ScorePositiveDesc = 'SCORE_POSITIVE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export interface IntervalInput {
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
}

export interface InterviewAndCallCalendar {
  __typename?: 'InterviewAndCallCalendar';
  offerId?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  interviewerUsername?: Maybe<Scalars['String']>;
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  timeSlot?: Maybe<DatetimeRange>;
  isPast?: Maybe<Scalars['Boolean']>;
  isPresent?: Maybe<Scalars['Boolean']>;
  isInFuture?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['Datetime']>;
  endsAt?: Maybe<Scalars['Datetime']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  bookingId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  intervieweeUsername?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  bookedAt?: Maybe<Scalars['Datetime']>;
  reportId?: Maybe<Scalars['UUID']>;
  accepted?: Maybe<Scalars['Boolean']>;
  isPost?: Maybe<Scalars['Boolean']>;
  counseling?: Maybe<Scalars['Boolean']>;
  isSuicideCall?: Maybe<Scalars['Boolean']>;
  isFollowupCall?: Maybe<Scalars['Boolean']>;
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `InterviewAndCallCalendar` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface InterviewAndCallCalendarCondition {
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `isPast` field. */
  isPast?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPresent` field. */
  isPresent?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInFuture` field. */
  isInFuture?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingId` field. */
  bookingId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bookedAt` field. */
  bookedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPost` field. */
  isPost?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `counseling` field. */
  counseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSuicideCall` field. */
  isSuicideCall?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isFollowupCall` field. */
  isFollowupCall?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `InterviewAndCallCalendar` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewAndCallCalendarFilter {
  /** Filter by the object’s `offerId` field. */
  offerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `isPast` field. */
  isPast?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPresent` field. */
  isPresent?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInFuture` field. */
  isInFuture?: Maybe<BooleanFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingId` field. */
  bookingId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `bookedAt` field. */
  bookedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: Maybe<UuidFilter>;
  /** Filter by the object’s `accepted` field. */
  accepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPost` field. */
  isPost?: Maybe<BooleanFilter>;
  /** Filter by the object’s `counseling` field. */
  counseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSuicideCall` field. */
  isSuicideCall?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isFollowupCall` field. */
  isFollowupCall?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewAndCallCalendarFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewAndCallCalendarFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewAndCallCalendarFilter>;
}

/** A connection to a list of `InterviewAndCallCalendar` values. */
export interface InterviewAndCallCalendarsConnection {
  __typename?: 'InterviewAndCallCalendarsConnection';
  /** A list of `InterviewAndCallCalendar` objects. */
  nodes: Array<InterviewAndCallCalendar>;
  /** A list of edges which contains the `InterviewAndCallCalendar` and cursor to aid in pagination. */
  edges: Array<InterviewAndCallCalendarsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewAndCallCalendar` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewAndCallCalendar` edge in the connection. */
export interface InterviewAndCallCalendarsEdge {
  __typename?: 'InterviewAndCallCalendarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewAndCallCalendar` at the end of the edge. */
  node: InterviewAndCallCalendar;
}

/** Methods to use when ordering `InterviewAndCallCalendar`. */
export enum InterviewAndCallCalendarsOrderBy {
  Natural = 'NATURAL',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  InterviewerUsernameAsc = 'INTERVIEWER_USERNAME_ASC',
  InterviewerUsernameDesc = 'INTERVIEWER_USERNAME_DESC',
  OfferIsCanceledAsc = 'OFFER_IS_CANCELED_ASC',
  OfferIsCanceledDesc = 'OFFER_IS_CANCELED_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  IsPastAsc = 'IS_PAST_ASC',
  IsPastDesc = 'IS_PAST_DESC',
  IsPresentAsc = 'IS_PRESENT_ASC',
  IsPresentDesc = 'IS_PRESENT_DESC',
  IsInFutureAsc = 'IS_IN_FUTURE_ASC',
  IsInFutureDesc = 'IS_IN_FUTURE_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  IntervieweeUsernameAsc = 'INTERVIEWEE_USERNAME_ASC',
  IntervieweeUsernameDesc = 'INTERVIEWEE_USERNAME_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  BookedAtAsc = 'BOOKED_AT_ASC',
  BookedAtDesc = 'BOOKED_AT_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  AcceptedAsc = 'ACCEPTED_ASC',
  AcceptedDesc = 'ACCEPTED_DESC',
  IsPostAsc = 'IS_POST_ASC',
  IsPostDesc = 'IS_POST_DESC',
  CounselingAsc = 'COUNSELING_ASC',
  CounselingDesc = 'COUNSELING_DESC',
  IsSuicideCallAsc = 'IS_SUICIDE_CALL_ASC',
  IsSuicideCallDesc = 'IS_SUICIDE_CALL_DESC',
  IsFollowupCallAsc = 'IS_FOLLOWUP_CALL_ASC',
  IsFollowupCallDesc = 'IS_FOLLOWUP_CALL_DESC',
  BookingIsCanceledAsc = 'BOOKING_IS_CANCELED_ASC',
  BookingIsCanceledDesc = 'BOOKING_IS_CANCELED_DESC',
  BookingCanceledAtAsc = 'BOOKING_CANCELED_AT_ASC',
  BookingCanceledAtDesc = 'BOOKING_CANCELED_AT_DESC'
}

export interface InterviewBooking extends Node {
  __typename?: 'InterviewBooking';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  canceled: Scalars['Boolean'];
  canceledAt?: Maybe<Scalars['Datetime']>;
  caseId: Scalars['UUID'];
  intervieweeId: Scalars['UUID'];
  offerId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `InterviewBooking`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Involvement` that is related to this `InterviewBooking`. */
  involvementByCaseIdAndIntervieweeId?: Maybe<Involvement>;
  /** Reads a single `User` that is related to this `InterviewBooking`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewBooking`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `Interviewee` that is related to this `InterviewBooking`. */
  intervieweeByIntervieweeId?: Maybe<Interviewee>;
  /** Reads and enables pagination through a set of `InterviewReport`. */
  interviewReportsByBookingId: InterviewReportsConnection;
  /** Reads and enables pagination through a set of `InterviewReport`. */
  interviewReportsByBookingIdAndCaseId: InterviewReportsConnection;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  interviewCalendarsByBookingId: InterviewCalendarsConnection;
}


export type InterviewBookingInterviewReportsByBookingIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
  condition?: Maybe<InterviewReportCondition>;
  filter?: Maybe<InterviewReportFilter>;
};


export type InterviewBookingInterviewReportsByBookingIdAndCaseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
  condition?: Maybe<InterviewReportCondition>;
  filter?: Maybe<InterviewReportFilter>;
};


export type InterviewBookingInterviewCalendarsByBookingIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};

/**
 * A condition to be used against `InterviewBooking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface InterviewBookingCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `InterviewBooking` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewBookingFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `offerId` field. */
  offerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewBookingFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewBookingFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewBookingFilter>;
}

/** An input for mutations affecting `InterviewBooking` */
export interface InterviewBookingInput {
  id?: Maybe<Scalars['UUID']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  caseId: Scalars['UUID'];
  intervieweeId: Scalars['UUID'];
  offerId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `InterviewBooking`. Fields that are set will be updated. */
export interface InterviewBookingPatch {
  id?: Maybe<Scalars['UUID']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  offerId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `InterviewBooking` values. */
export interface InterviewBookingsConnection {
  __typename?: 'InterviewBookingsConnection';
  /** A list of `InterviewBooking` objects. */
  nodes: Array<InterviewBooking>;
  /** A list of edges which contains the `InterviewBooking` and cursor to aid in pagination. */
  edges: Array<InterviewBookingsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewBooking` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewBooking` edge in the connection. */
export interface InterviewBookingsEdge {
  __typename?: 'InterviewBookingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewBooking` at the end of the edge. */
  node: InterviewBooking;
}

/** Methods to use when ordering `InterviewBooking`. */
export enum InterviewBookingsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface InterviewCalendar {
  __typename?: 'InterviewCalendar';
  offerId?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  interviewerUsername?: Maybe<Scalars['String']>;
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  timeSlot?: Maybe<DatetimeRange>;
  isPast?: Maybe<Scalars['Boolean']>;
  isPresent?: Maybe<Scalars['Boolean']>;
  isInFuture?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['Datetime']>;
  endsAt?: Maybe<Scalars['Datetime']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  bookingId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  intervieweeUsername?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  bookedAt?: Maybe<Scalars['Datetime']>;
  reportId?: Maybe<Scalars['UUID']>;
  accepted?: Maybe<Scalars['Boolean']>;
  isPost?: Maybe<Scalars['Boolean']>;
  counseling?: Maybe<Scalars['Boolean']>;
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
  primaryProblem?: Maybe<Scalars['String']>;
  offerCanceledAt?: Maybe<Scalars['Datetime']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  countinterrupted?: Maybe<Scalars['BigInt']>;
  canceledAfterMinutes?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewCalendar`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewCalendar`. */
  interviewBookingByBookingId?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewReport` that is related to this `InterviewCalendar`. */
  interviewReportByReportId?: Maybe<InterviewReport>;
  /** Reads a single `User` that is related to this `InterviewCalendar`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `User` that is related to this `InterviewCalendar`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `Case` that is related to this `InterviewCalendar`. */
  caseByCaseId?: Maybe<Case>;
}

export interface InterviewCalendarAccountable {
  __typename?: 'InterviewCalendarAccountable';
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  shortId?: Maybe<Scalars['BigInt']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  caseName?: Maybe<Scalars['String']>;
  interviewStart?: Maybe<Scalars['Datetime']>;
  interviewEnd?: Maybe<Scalars['Datetime']>;
  bookingCanceled?: Maybe<Scalars['Boolean']>;
  offerCanceled?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `InterviewCalendarAccountable` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface InterviewCalendarAccountableCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseName` field. */
  caseName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `interviewStart` field. */
  interviewStart?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `interviewEnd` field. */
  interviewEnd?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `bookingCanceled` field. */
  bookingCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `offerCanceled` field. */
  offerCanceled?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `InterviewCalendarAccountable` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewCalendarAccountableFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseName` field. */
  caseName?: Maybe<StringFilter>;
  /** Filter by the object’s `interviewStart` field. */
  interviewStart?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `interviewEnd` field. */
  interviewEnd?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `bookingCanceled` field. */
  bookingCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `offerCanceled` field. */
  offerCanceled?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewCalendarAccountableFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewCalendarAccountableFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewCalendarAccountableFilter>;
}

/** A connection to a list of `InterviewCalendarAccountable` values. */
export interface InterviewCalendarAccountablesConnection {
  __typename?: 'InterviewCalendarAccountablesConnection';
  /** A list of `InterviewCalendarAccountable` objects. */
  nodes: Array<InterviewCalendarAccountable>;
  /** A list of edges which contains the `InterviewCalendarAccountable` and cursor to aid in pagination. */
  edges: Array<InterviewCalendarAccountablesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewCalendarAccountable` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewCalendarAccountable` edge in the connection. */
export interface InterviewCalendarAccountablesEdge {
  __typename?: 'InterviewCalendarAccountablesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewCalendarAccountable` at the end of the edge. */
  node: InterviewCalendarAccountable;
}

/** Methods to use when ordering `InterviewCalendarAccountable`. */
export enum InterviewCalendarAccountablesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  CaseNameAsc = 'CASE_NAME_ASC',
  CaseNameDesc = 'CASE_NAME_DESC',
  InterviewStartAsc = 'INTERVIEW_START_ASC',
  InterviewStartDesc = 'INTERVIEW_START_DESC',
  InterviewEndAsc = 'INTERVIEW_END_ASC',
  InterviewEndDesc = 'INTERVIEW_END_DESC',
  BookingCanceledAsc = 'BOOKING_CANCELED_ASC',
  BookingCanceledDesc = 'BOOKING_CANCELED_DESC',
  OfferCanceledAsc = 'OFFER_CANCELED_ASC',
  OfferCanceledDesc = 'OFFER_CANCELED_DESC'
}

/**
 * A condition to be used against `InterviewCalendar` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface InterviewCalendarCondition {
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `isPast` field. */
  isPast?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPresent` field. */
  isPresent?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInFuture` field. */
  isInFuture?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingId` field. */
  bookingId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bookedAt` field. */
  bookedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPost` field. */
  isPost?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `counseling` field. */
  counseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `offerCanceledAt` field. */
  offerCanceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `countinterrupted` field. */
  countinterrupted?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `canceledAfterMinutes` field. */
  canceledAfterMinutes?: Maybe<Scalars['BigFloat']>;
}

/** A filter to be used against `InterviewCalendar` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewCalendarFilter {
  /** Filter by the object’s `offerId` field. */
  offerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `isPast` field. */
  isPast?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPresent` field. */
  isPresent?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInFuture` field. */
  isInFuture?: Maybe<BooleanFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingId` field. */
  bookingId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `bookedAt` field. */
  bookedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: Maybe<UuidFilter>;
  /** Filter by the object’s `accepted` field. */
  accepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPost` field. */
  isPost?: Maybe<BooleanFilter>;
  /** Filter by the object’s `counseling` field. */
  counseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<StringFilter>;
  /** Filter by the object’s `offerCanceledAt` field. */
  offerCanceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `countinterrupted` field. */
  countinterrupted?: Maybe<BigIntFilter>;
  /** Filter by the object’s `canceledAfterMinutes` field. */
  canceledAfterMinutes?: Maybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewCalendarFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewCalendarFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewCalendarFilter>;
}

export interface InterviewCalendarNew {
  __typename?: 'InterviewCalendarNew';
  offerId?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  interviewerUsername?: Maybe<Scalars['String']>;
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  timeSlot?: Maybe<DatetimeRange>;
  isPast?: Maybe<Scalars['Boolean']>;
  isPresent?: Maybe<Scalars['Boolean']>;
  isInFuture?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['Datetime']>;
  endsAt?: Maybe<Scalars['Datetime']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  bookingId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  intervieweeUsername?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  bookedAt?: Maybe<Scalars['Datetime']>;
  reportId?: Maybe<Scalars['UUID']>;
  accepted?: Maybe<Scalars['Boolean']>;
  isPost?: Maybe<Scalars['Boolean']>;
  counseling?: Maybe<Scalars['Boolean']>;
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `InterviewCalendarNew` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface InterviewCalendarNewCondition {
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `isPast` field. */
  isPast?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPresent` field. */
  isPresent?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInFuture` field. */
  isInFuture?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingId` field. */
  bookingId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bookedAt` field. */
  bookedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isPost` field. */
  isPost?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `counseling` field. */
  counseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `InterviewCalendarNew` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewCalendarNewFilter {
  /** Filter by the object’s `offerId` field. */
  offerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerUsername` field. */
  interviewerUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `offerIsCanceled` field. */
  offerIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `isPast` field. */
  isPast?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPresent` field. */
  isPresent?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInFuture` field. */
  isInFuture?: Maybe<BooleanFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingId` field. */
  bookingId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeUsername` field. */
  intervieweeUsername?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `bookedAt` field. */
  bookedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: Maybe<UuidFilter>;
  /** Filter by the object’s `accepted` field. */
  accepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPost` field. */
  isPost?: Maybe<BooleanFilter>;
  /** Filter by the object’s `counseling` field. */
  counseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingIsCanceled` field. */
  bookingIsCanceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `bookingCanceledAt` field. */
  bookingCanceledAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewCalendarNewFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewCalendarNewFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewCalendarNewFilter>;
}

/** A connection to a list of `InterviewCalendarNew` values. */
export interface InterviewCalendarNewsConnection {
  __typename?: 'InterviewCalendarNewsConnection';
  /** A list of `InterviewCalendarNew` objects. */
  nodes: Array<InterviewCalendarNew>;
  /** A list of edges which contains the `InterviewCalendarNew` and cursor to aid in pagination. */
  edges: Array<InterviewCalendarNewsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewCalendarNew` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewCalendarNew` edge in the connection. */
export interface InterviewCalendarNewsEdge {
  __typename?: 'InterviewCalendarNewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewCalendarNew` at the end of the edge. */
  node: InterviewCalendarNew;
}

/** Methods to use when ordering `InterviewCalendarNew`. */
export enum InterviewCalendarNewsOrderBy {
  Natural = 'NATURAL',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  InterviewerUsernameAsc = 'INTERVIEWER_USERNAME_ASC',
  InterviewerUsernameDesc = 'INTERVIEWER_USERNAME_DESC',
  OfferIsCanceledAsc = 'OFFER_IS_CANCELED_ASC',
  OfferIsCanceledDesc = 'OFFER_IS_CANCELED_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  IsPastAsc = 'IS_PAST_ASC',
  IsPastDesc = 'IS_PAST_DESC',
  IsPresentAsc = 'IS_PRESENT_ASC',
  IsPresentDesc = 'IS_PRESENT_DESC',
  IsInFutureAsc = 'IS_IN_FUTURE_ASC',
  IsInFutureDesc = 'IS_IN_FUTURE_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  IntervieweeUsernameAsc = 'INTERVIEWEE_USERNAME_ASC',
  IntervieweeUsernameDesc = 'INTERVIEWEE_USERNAME_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  BookedAtAsc = 'BOOKED_AT_ASC',
  BookedAtDesc = 'BOOKED_AT_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  AcceptedAsc = 'ACCEPTED_ASC',
  AcceptedDesc = 'ACCEPTED_DESC',
  IsPostAsc = 'IS_POST_ASC',
  IsPostDesc = 'IS_POST_DESC',
  CounselingAsc = 'COUNSELING_ASC',
  CounselingDesc = 'COUNSELING_DESC',
  BookingIsCanceledAsc = 'BOOKING_IS_CANCELED_ASC',
  BookingIsCanceledDesc = 'BOOKING_IS_CANCELED_DESC',
  BookingCanceledAtAsc = 'BOOKING_CANCELED_AT_ASC',
  BookingCanceledAtDesc = 'BOOKING_CANCELED_AT_DESC'
}

/** A connection to a list of `InterviewCalendar` values. */
export interface InterviewCalendarsConnection {
  __typename?: 'InterviewCalendarsConnection';
  /** A list of `InterviewCalendar` objects. */
  nodes: Array<InterviewCalendar>;
  /** A list of edges which contains the `InterviewCalendar` and cursor to aid in pagination. */
  edges: Array<InterviewCalendarsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewCalendar` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewCalendar` edge in the connection. */
export interface InterviewCalendarsEdge {
  __typename?: 'InterviewCalendarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewCalendar` at the end of the edge. */
  node: InterviewCalendar;
}

/** Methods to use when ordering `InterviewCalendar`. */
export enum InterviewCalendarsOrderBy {
  Natural = 'NATURAL',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  InterviewerUsernameAsc = 'INTERVIEWER_USERNAME_ASC',
  InterviewerUsernameDesc = 'INTERVIEWER_USERNAME_DESC',
  OfferIsCanceledAsc = 'OFFER_IS_CANCELED_ASC',
  OfferIsCanceledDesc = 'OFFER_IS_CANCELED_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  IsPastAsc = 'IS_PAST_ASC',
  IsPastDesc = 'IS_PAST_DESC',
  IsPresentAsc = 'IS_PRESENT_ASC',
  IsPresentDesc = 'IS_PRESENT_DESC',
  IsInFutureAsc = 'IS_IN_FUTURE_ASC',
  IsInFutureDesc = 'IS_IN_FUTURE_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  IntervieweeUsernameAsc = 'INTERVIEWEE_USERNAME_ASC',
  IntervieweeUsernameDesc = 'INTERVIEWEE_USERNAME_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  BookedAtAsc = 'BOOKED_AT_ASC',
  BookedAtDesc = 'BOOKED_AT_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  AcceptedAsc = 'ACCEPTED_ASC',
  AcceptedDesc = 'ACCEPTED_DESC',
  IsPostAsc = 'IS_POST_ASC',
  IsPostDesc = 'IS_POST_DESC',
  CounselingAsc = 'COUNSELING_ASC',
  CounselingDesc = 'COUNSELING_DESC',
  BookingIsCanceledAsc = 'BOOKING_IS_CANCELED_ASC',
  BookingIsCanceledDesc = 'BOOKING_IS_CANCELED_DESC',
  BookingCanceledAtAsc = 'BOOKING_CANCELED_AT_ASC',
  BookingCanceledAtDesc = 'BOOKING_CANCELED_AT_DESC',
  PrimaryProblemAsc = 'PRIMARY_PROBLEM_ASC',
  PrimaryProblemDesc = 'PRIMARY_PROBLEM_DESC',
  OfferCanceledAtAsc = 'OFFER_CANCELED_AT_ASC',
  OfferCanceledAtDesc = 'OFFER_CANCELED_AT_DESC',
  PatientAcceptedAsc = 'PATIENT_ACCEPTED_ASC',
  PatientAcceptedDesc = 'PATIENT_ACCEPTED_DESC',
  CountinterruptedAsc = 'COUNTINTERRUPTED_ASC',
  CountinterruptedDesc = 'COUNTINTERRUPTED_DESC',
  CanceledAfterMinutesAsc = 'CANCELED_AFTER_MINUTES_ASC',
  CanceledAfterMinutesDesc = 'CANCELED_AFTER_MINUTES_DESC'
}

export interface Interviewee {
  __typename?: 'Interviewee';
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  interviewBookingsByIntervieweeId: InterviewBookingsConnection;
}


export type IntervieweeInterviewBookingsByIntervieweeIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};

/**
 * A condition to be used against `Interviewee` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface IntervieweeCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
}

/** A filter to be used against `Interviewee` object types. All fields are combined with a logical ‘and.’ */
export interface IntervieweeFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<IntervieweeFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<IntervieweeFilter>>;
  /** Negates the expression. */
  not?: Maybe<IntervieweeFilter>;
}

/** An input for mutations affecting `Interviewee` */
export interface IntervieweeInput {
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
}

/** Represents an update to a `Interviewee`. Fields that are set will be updated. */
export interface IntervieweePatch {
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
}

/** A connection to a list of `Interviewee` values. */
export interface IntervieweesConnection {
  __typename?: 'IntervieweesConnection';
  /** A list of `Interviewee` objects. */
  nodes: Array<Interviewee>;
  /** A list of edges which contains the `Interviewee` and cursor to aid in pagination. */
  edges: Array<IntervieweesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Interviewee` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Interviewee` edge in the connection. */
export interface IntervieweesEdge {
  __typename?: 'IntervieweesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Interviewee` at the end of the edge. */
  node: Interviewee;
}

/** Methods to use when ordering `Interviewee`. */
export enum IntervieweesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC'
}

export interface Interviewer {
  __typename?: 'Interviewer';
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  /** Reads and enables pagination through a set of `InterviewOffer`. */
  interviewOffersByInterviewerId: InterviewOffersConnection;
}


export type InterviewerInterviewOffersByInterviewerIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
  condition?: Maybe<InterviewOfferCondition>;
  filter?: Maybe<InterviewOfferFilter>;
};

/**
 * A condition to be used against `Interviewer` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface InterviewerCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
}

/** A filter to be used against `Interviewer` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewerFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewerFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewerFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewerFilter>;
}

/** An input for mutations affecting `Interviewer` */
export interface InterviewerInput {
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
}

/** Represents an update to a `Interviewer`. Fields that are set will be updated. */
export interface InterviewerPatch {
  id?: Maybe<Scalars['UUID']>;
  username?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
}

/** A connection to a list of `Interviewer` values. */
export interface InterviewersConnection {
  __typename?: 'InterviewersConnection';
  /** A list of `Interviewer` objects. */
  nodes: Array<Interviewer>;
  /** A list of edges which contains the `Interviewer` and cursor to aid in pagination. */
  edges: Array<InterviewersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Interviewer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Interviewer` edge in the connection. */
export interface InterviewersEdge {
  __typename?: 'InterviewersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Interviewer` at the end of the edge. */
  node: Interviewer;
}

/** Methods to use when ordering `Interviewer`. */
export enum InterviewersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC'
}

export interface InterviewOffer extends Node {
  __typename?: 'InterviewOffer';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  interviewerId: Scalars['UUID'];
  timeSlot: DatetimeRange;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled: Scalars['Boolean'];
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  isPost?: Maybe<Scalars['Boolean']>;
  /** Reads a single `User` that is related to this `InterviewOffer`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `Interviewer` that is related to this `InterviewOffer`. */
  interviewerByInterviewerId?: Maybe<Interviewer>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  interviewBookingsByOfferId: InterviewBookingsConnection;
  /** Reads a single `InterviewCalendar` that is related to this `InterviewOffer`. */
  interviewCalendarByOfferId?: Maybe<InterviewCalendar>;
  /**
   * Reads and enables pagination through a set of `InterviewCalendar`.
   * @deprecated Please use interviewCalendarByOfferId instead
   */
  interviewCalendarsByOfferId: InterviewCalendarsConnection;
  past?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  soon?: Maybe<Scalars['Boolean']>;
  upcoming?: Maybe<Scalars['Boolean']>;
}


export type InterviewOfferInterviewBookingsByOfferIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};


export type InterviewOfferInterviewCalendarsByOfferIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};


export type InterviewOfferSoonArgs = {
  beginsIn?: Maybe<IntervalInput>;
};

/**
 * A condition to be used against `InterviewOffer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface InterviewOfferCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `externalLink` field. */
  externalLink?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `isPost` field. */
  isPost?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `InterviewOffer` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewOfferFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `externalLink` field. */
  externalLink?: Maybe<StringFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `isPost` field. */
  isPost?: Maybe<BooleanFilter>;
  /** Filter by the object’s `past` field. */
  past?: Maybe<BooleanFilter>;
  /** Filter by the object’s `present` field. */
  present?: Maybe<BooleanFilter>;
  /** Filter by the object’s `soon` field. */
  soon?: Maybe<BooleanFilter>;
  /** Filter by the object’s `upcoming` field. */
  upcoming?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewOfferFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewOfferFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewOfferFilter>;
}

/** An input for mutations affecting `InterviewOffer` */
export interface InterviewOfferInput {
  id?: Maybe<Scalars['UUID']>;
  interviewerId: Scalars['UUID'];
  timeSlot: DatetimeRangeInput;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  isPost?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `InterviewOffer`. Fields that are set will be updated. */
export interface InterviewOfferPatch {
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRangeInput>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  isPost?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `InterviewOffer` values. */
export interface InterviewOffersConnection {
  __typename?: 'InterviewOffersConnection';
  /** A list of `InterviewOffer` objects. */
  nodes: Array<InterviewOffer>;
  /** A list of edges which contains the `InterviewOffer` and cursor to aid in pagination. */
  edges: Array<InterviewOffersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewOffer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewOffer` edge in the connection. */
export interface InterviewOffersEdge {
  __typename?: 'InterviewOffersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewOffer` at the end of the edge. */
  node: InterviewOffer;
}

/** Methods to use when ordering `InterviewOffer`. */
export enum InterviewOffersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  ExternalLinkAsc = 'EXTERNAL_LINK_ASC',
  ExternalLinkDesc = 'EXTERNAL_LINK_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IsPostAsc = 'IS_POST_ASC',
  IsPostDesc = 'IS_POST_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface InterviewReport extends Node {
  __typename?: 'InterviewReport';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  bookingId?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingId?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingIdAndCaseId?: Maybe<InterviewBooking>;
  /** Reads a single `Case` that is related to this `InterviewReport`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `InterviewReport`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  interviewCalendarsByReportId: InterviewCalendarsConnection;
}


export type InterviewReportInterviewCalendarsByReportIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};

/**
 * A condition to be used against `InterviewReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface InterviewReportCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bookingId` field. */
  bookingId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientReached` field. */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `contactVia` field. */
  contactVia?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAlias` field. */
  patientAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasMedication` field. */
  hasMedication?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `medicationName` field. */
  medicationName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hadPreviousIlajnafsyTreatment` field. */
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `typeOfPreviousIlajnafsyTreatment` field. */
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `finishedPreviousIlajnafsyTreatmentWeaksAgo` field. */
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  /** Checks for equality with the object’s `suicidalityC1` field. */
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC2` field. */
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC3` field. */
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC4` field. */
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC5` field. */
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityC6` field. */
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalitySuicideRisk` field. */
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `suicidalityNoSuicideContract` field. */
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suicidalityNotes` field. */
  suicidalityNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `traumaDescription` field. */
  traumaDescription?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `ptsdChecked` field. */
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB1` field. */
  ptsdB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB2` field. */
  ptsdB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB3` field. */
  ptsdB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB4` field. */
  ptsdB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdB5` field. */
  ptsdB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdBFulfilled` field. */
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdC1` field. */
  ptsdC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdC2` field. */
  ptsdC2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdCFulfilled` field. */
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD1` field. */
  ptsdD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD2` field. */
  ptsdD2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD3` field. */
  ptsdD3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD4` field. */
  ptsdD4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD5` field. */
  ptsdD5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD6` field. */
  ptsdD6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdD7` field. */
  ptsdD7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdDFulfilled` field. */
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE1` field. */
  ptsdE1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE2` field. */
  ptsdE2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE3` field. */
  ptsdE3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE4` field. */
  ptsdE4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE5` field. */
  ptsdE5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdE6` field. */
  ptsdE6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdEFulfilled` field. */
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdFFulfilled` field. */
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdGFulfilled` field. */
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdHFulfilled` field. */
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdTotalFulfilled` field. */
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `ptsdNotes` field. */
  ptsdNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `cmdeA1` field. */
  cmdeA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA2` field. */
  cmdeA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA3` field. */
  cmdeA3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA4` field. */
  cmdeA4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA5` field. */
  cmdeA5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA6` field. */
  cmdeA6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA7` field. */
  cmdeA7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA8` field. */
  cmdeA8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeA9` field. */
  cmdeA9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeAFulfilled` field. */
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeBFulfilled` field. */
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeCFulfilled` field. */
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeMdeTotalFulfilled` field. */
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmdeActualEpisodeStartsWeeks` field. */
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeActualEpisodeStartsMonths` field. */
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeLastEpisodeBeforeMonths` field. */
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeLastEpisodeBeforeYears` field. */
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeNumberOfEpisodes` field. */
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmdeNotes` field. */
  cmdeNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `dysthymiaAFulfilled` field. */
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB1` field. */
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB2` field. */
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB3` field. */
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB4` field. */
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB5` field. */
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaB6` field. */
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaBFulfilled` field. */
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaCFulfilled` field. */
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaEFulfilled` field. */
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaFFulfilled` field. */
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaGFulfilled` field. */
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaHFulfilled` field. */
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaTotalFulfilled` field. */
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dysthymiaNotes` field. */
  dysthymiaNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblemStatusAccepted` field. */
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `primaryProblemStatusRejected` field. */
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonsForCounseling` field. */
  reasonsForCounseling?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `accessibilityTime` field. */
  accessibilityTime?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `additionalComments` field. */
  additionalComments?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientNeedsToRegisterAgain` field. */
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reasonsForFutureRegistration` field. */
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `stateIfOtherReasons` field. */
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hra1` field. */
  hra1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra2` field. */
  hra2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra3` field. */
  hra3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra4` field. */
  hra4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra5` field. */
  hra5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hra6` field. */
  hra6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `audit1` field. */
  audit1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit2` field. */
  audit2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit3` field. */
  audit3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit4` field. */
  audit4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit5` field. */
  audit5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit6` field. */
  audit6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit7` field. */
  audit7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit8` field. */
  audit8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit9` field. */
  audit9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `audit10` field. */
  audit10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `dast1` field. */
  dast1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast2` field. */
  dast2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast3` field. */
  dast3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast4` field. */
  dast4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast5` field. */
  dast5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast6` field. */
  dast6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast7` field. */
  dast7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast8` field. */
  dast8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast9` field. */
  dast9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `dast10` field. */
  dast10?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA1` field. */
  pmdeA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA2` field. */
  pmdeA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA3` field. */
  pmdeA3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA4` field. */
  pmdeA4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA5` field. */
  pmdeA5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA6` field. */
  pmdeA6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA7` field. */
  pmdeA7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA8` field. */
  pmdeA8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeA9` field. */
  pmdeA9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeAFulfilled` field. */
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeBFulfilled` field. */
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeCFulfilled` field. */
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeTotalFulfilled` field. */
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeActualEpisodeStartsWeeks` field. */
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pmdeActualEpisodeStartsMonths` field. */
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pmdeNumberOfEpisodes` field. */
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cmanA1` field. */
  cmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanA2` field. */
  cmanA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB1` field. */
  cmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB2` field. */
  cmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB3` field. */
  cmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB4` field. */
  cmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB5` field. */
  cmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB6` field. */
  cmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanB7` field. */
  cmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanC1` field. */
  cmanC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanD1` field. */
  cmanD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanFulfilled` field. */
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanA1` field. */
  chmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB1` field. */
  chmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB2` field. */
  chmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB3` field. */
  chmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB4` field. */
  chmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB5` field. */
  chmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB6` field. */
  chmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanB7` field. */
  chmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanC` field. */
  chmanC?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanD` field. */
  chmanD?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanE` field. */
  chmanE?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanF` field. */
  chmanF?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanFulfilled` field. */
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanA1` field. */
  pmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanA2` field. */
  pmanA2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB1` field. */
  pmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB2` field. */
  pmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB3` field. */
  pmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB4` field. */
  pmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB5` field. */
  pmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB6` field. */
  pmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanB7` field. */
  pmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanC1` field. */
  pmanC1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanD1` field. */
  pmanD1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanFulfilled` field. */
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanA1` field. */
  phmanA1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB1` field. */
  phmanB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB2` field. */
  phmanB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB3` field. */
  phmanB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB4` field. */
  phmanB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB5` field. */
  phmanB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB6` field. */
  phmanB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanB7` field. */
  phmanB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanC` field. */
  phmanC?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanD` field. */
  phmanD?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanE` field. */
  phmanE?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanF` field. */
  phmanF?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanFulfilled` field. */
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB1` field. */
  psychB1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB2` field. */
  psychB2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB3` field. */
  psychB3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB4` field. */
  psychB4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB5` field. */
  psychB5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB6` field. */
  psychB6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB7` field. */
  psychB7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB8` field. */
  psychB8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB9` field. */
  psychB9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB10` field. */
  psychB10?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB11` field. */
  psychB11?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB12` field. */
  psychB12?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB13` field. */
  psychB13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB14` field. */
  psychB14?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB15` field. */
  psychB15?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB16` field. */
  psychB16?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB17` field. */
  psychB17?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB18` field. */
  psychB18?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychB19` field. */
  psychB19?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `rejectionOtherReasons` field. */
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hraTotalFulfilled` field. */
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `auditTotalScore` field. */
  auditTotalScore?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `auditTotalFulfilled` field. */
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmdeNotes` field. */
  pmdeNotes?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `dastTotalFulfilled` field. */
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cmanBFulfilled` field. */
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chmanBFulfilled` field. */
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pmanBFulfilled` field. */
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phmanBFulfilled` field. */
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `psychTotalFulfilled` field. */
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientReasoningForCounseling` field. */
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientFutureRegistration` field. */
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientReasonsFutureRegistration` field. */
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `InterviewReport` object types. All fields are combined with a logical ‘and.’ */
export interface InterviewReportFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `bookingId` field. */
  bookingId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `patientReached` field. */
  patientReached?: Maybe<BooleanFilter>;
  /** Filter by the object’s `contactVia` field. */
  contactVia?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAlias` field. */
  patientAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `hasMedication` field. */
  hasMedication?: Maybe<BooleanFilter>;
  /** Filter by the object’s `medicationName` field. */
  medicationName?: Maybe<StringFilter>;
  /** Filter by the object’s `hadPreviousIlajnafsyTreatment` field. */
  hadPreviousIlajnafsyTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `typeOfPreviousIlajnafsyTreatment` field. */
  typeOfPreviousIlajnafsyTreatment?: Maybe<StringFilter>;
  /** Filter by the object’s `finishedPreviousIlajnafsyTreatmentWeaksAgo` field. */
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<DateFilter>;
  /** Filter by the object’s `suicidalityC1` field. */
  suicidalityC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC2` field. */
  suicidalityC2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC3` field. */
  suicidalityC3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC4` field. */
  suicidalityC4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC5` field. */
  suicidalityC5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityC6` field. */
  suicidalityC6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalitySuicideRisk` field. */
  suicidalitySuicideRisk?: Maybe<StringFilter>;
  /** Filter by the object’s `suicidalityNoSuicideContract` field. */
  suicidalityNoSuicideContract?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suicidalityNotes` field. */
  suicidalityNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `traumaDescription` field. */
  traumaDescription?: Maybe<StringFilter>;
  /** Filter by the object’s `ptsdChecked` field. */
  ptsdChecked?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB1` field. */
  ptsdB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB2` field. */
  ptsdB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB3` field. */
  ptsdB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB4` field. */
  ptsdB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdB5` field. */
  ptsdB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdBFulfilled` field. */
  ptsdBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdC1` field. */
  ptsdC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdC2` field. */
  ptsdC2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdCFulfilled` field. */
  ptsdCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD1` field. */
  ptsdD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD2` field. */
  ptsdD2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD3` field. */
  ptsdD3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD4` field. */
  ptsdD4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD5` field. */
  ptsdD5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD6` field. */
  ptsdD6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdD7` field. */
  ptsdD7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdDFulfilled` field. */
  ptsdDFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE1` field. */
  ptsdE1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE2` field. */
  ptsdE2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE3` field. */
  ptsdE3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE4` field. */
  ptsdE4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE5` field. */
  ptsdE5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdE6` field. */
  ptsdE6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdEFulfilled` field. */
  ptsdEFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdFFulfilled` field. */
  ptsdFFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdGFulfilled` field. */
  ptsdGFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdHFulfilled` field. */
  ptsdHFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdTotalFulfilled` field. */
  ptsdTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `ptsdNotes` field. */
  ptsdNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `cmdeA1` field. */
  cmdeA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA2` field. */
  cmdeA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA3` field. */
  cmdeA3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA4` field. */
  cmdeA4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA5` field. */
  cmdeA5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA6` field. */
  cmdeA6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA7` field. */
  cmdeA7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA8` field. */
  cmdeA8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeA9` field. */
  cmdeA9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeAFulfilled` field. */
  cmdeAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeBFulfilled` field. */
  cmdeBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeCFulfilled` field. */
  cmdeCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeMdeTotalFulfilled` field. */
  cmdeMdeTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmdeActualEpisodeStartsWeeks` field. */
  cmdeActualEpisodeStartsWeeks?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeActualEpisodeStartsMonths` field. */
  cmdeActualEpisodeStartsMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeLastEpisodeBeforeMonths` field. */
  cmdeLastEpisodeBeforeMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeLastEpisodeBeforeYears` field. */
  cmdeLastEpisodeBeforeYears?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeNumberOfEpisodes` field. */
  cmdeNumberOfEpisodes?: Maybe<IntFilter>;
  /** Filter by the object’s `cmdeNotes` field. */
  cmdeNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `dysthymiaAFulfilled` field. */
  dysthymiaAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB1` field. */
  dysthymiaB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB2` field. */
  dysthymiaB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB3` field. */
  dysthymiaB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB4` field. */
  dysthymiaB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB5` field. */
  dysthymiaB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaB6` field. */
  dysthymiaB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaBFulfilled` field. */
  dysthymiaBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaCFulfilled` field. */
  dysthymiaCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaEFulfilled` field. */
  dysthymiaEFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaFFulfilled` field. */
  dysthymiaFFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaGFulfilled` field. */
  dysthymiaGFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaHFulfilled` field. */
  dysthymiaHFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaTotalFulfilled` field. */
  dysthymiaTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dysthymiaNotes` field. */
  dysthymiaNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblem` field. */
  primaryProblem?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblemStatusAccepted` field. */
  primaryProblemStatusAccepted?: Maybe<StringFilter>;
  /** Filter by the object’s `primaryProblemStatusRejected` field. */
  primaryProblemStatusRejected?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAcceptedForCounseling` field. */
  patientAcceptedForCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonsForCounseling` field. */
  reasonsForCounseling?: Maybe<StringFilter>;
  /** Filter by the object’s `accessibilityTime` field. */
  accessibilityTime?: Maybe<StringFilter>;
  /** Filter by the object’s `additionalComments` field. */
  additionalComments?: Maybe<StringFilter>;
  /** Filter by the object’s `patientNeedsToRegisterAgain` field. */
  patientNeedsToRegisterAgain?: Maybe<BooleanFilter>;
  /** Filter by the object’s `reasonsForFutureRegistration` field. */
  reasonsForFutureRegistration?: Maybe<StringFilter>;
  /** Filter by the object’s `stateIfOtherReasons` field. */
  stateIfOtherReasons?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `hra1` field. */
  hra1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra2` field. */
  hra2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra3` field. */
  hra3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra4` field. */
  hra4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra5` field. */
  hra5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `hra6` field. */
  hra6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `audit1` field. */
  audit1?: Maybe<IntFilter>;
  /** Filter by the object’s `audit2` field. */
  audit2?: Maybe<IntFilter>;
  /** Filter by the object’s `audit3` field. */
  audit3?: Maybe<IntFilter>;
  /** Filter by the object’s `audit4` field. */
  audit4?: Maybe<IntFilter>;
  /** Filter by the object’s `audit5` field. */
  audit5?: Maybe<IntFilter>;
  /** Filter by the object’s `audit6` field. */
  audit6?: Maybe<IntFilter>;
  /** Filter by the object’s `audit7` field. */
  audit7?: Maybe<IntFilter>;
  /** Filter by the object’s `audit8` field. */
  audit8?: Maybe<IntFilter>;
  /** Filter by the object’s `audit9` field. */
  audit9?: Maybe<IntFilter>;
  /** Filter by the object’s `audit10` field. */
  audit10?: Maybe<IntFilter>;
  /** Filter by the object’s `dast1` field. */
  dast1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast2` field. */
  dast2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast3` field. */
  dast3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast4` field. */
  dast4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast5` field. */
  dast5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast6` field. */
  dast6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast7` field. */
  dast7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast8` field. */
  dast8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast9` field. */
  dast9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `dast10` field. */
  dast10?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA1` field. */
  pmdeA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA2` field. */
  pmdeA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA3` field. */
  pmdeA3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA4` field. */
  pmdeA4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA5` field. */
  pmdeA5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA6` field. */
  pmdeA6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA7` field. */
  pmdeA7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA8` field. */
  pmdeA8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeA9` field. */
  pmdeA9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeAFulfilled` field. */
  pmdeAFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeBFulfilled` field. */
  pmdeBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeCFulfilled` field. */
  pmdeCFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeTotalFulfilled` field. */
  pmdeTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeActualEpisodeStartsWeeks` field. */
  pmdeActualEpisodeStartsWeeks?: Maybe<IntFilter>;
  /** Filter by the object’s `pmdeActualEpisodeStartsMonths` field. */
  pmdeActualEpisodeStartsMonths?: Maybe<IntFilter>;
  /** Filter by the object’s `pmdeNumberOfEpisodes` field. */
  pmdeNumberOfEpisodes?: Maybe<IntFilter>;
  /** Filter by the object’s `cmanA1` field. */
  cmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanA2` field. */
  cmanA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB1` field. */
  cmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB2` field. */
  cmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB3` field. */
  cmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB4` field. */
  cmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB5` field. */
  cmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB6` field. */
  cmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanB7` field. */
  cmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanC1` field. */
  cmanC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanD1` field. */
  cmanD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanFulfilled` field. */
  cmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanA1` field. */
  chmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB1` field. */
  chmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB2` field. */
  chmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB3` field. */
  chmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB4` field. */
  chmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB5` field. */
  chmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB6` field. */
  chmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanB7` field. */
  chmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanC` field. */
  chmanC?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanD` field. */
  chmanD?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanE` field. */
  chmanE?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanF` field. */
  chmanF?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanFulfilled` field. */
  chmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanA1` field. */
  pmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanA2` field. */
  pmanA2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB1` field. */
  pmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB2` field. */
  pmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB3` field. */
  pmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB4` field. */
  pmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB5` field. */
  pmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB6` field. */
  pmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanB7` field. */
  pmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanC1` field. */
  pmanC1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanD1` field. */
  pmanD1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanFulfilled` field. */
  pmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanA1` field. */
  phmanA1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB1` field. */
  phmanB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB2` field. */
  phmanB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB3` field. */
  phmanB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB4` field. */
  phmanB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB5` field. */
  phmanB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB6` field. */
  phmanB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanB7` field. */
  phmanB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanC` field. */
  phmanC?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanD` field. */
  phmanD?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanE` field. */
  phmanE?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanF` field. */
  phmanF?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanFulfilled` field. */
  phmanFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB1` field. */
  psychB1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB2` field. */
  psychB2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB3` field. */
  psychB3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB4` field. */
  psychB4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB5` field. */
  psychB5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB6` field. */
  psychB6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB7` field. */
  psychB7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB8` field. */
  psychB8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB9` field. */
  psychB9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB10` field. */
  psychB10?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB11` field. */
  psychB11?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB12` field. */
  psychB12?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB13` field. */
  psychB13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB14` field. */
  psychB14?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB15` field. */
  psychB15?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB16` field. */
  psychB16?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB17` field. */
  psychB17?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB18` field. */
  psychB18?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychB19` field. */
  psychB19?: Maybe<BooleanFilter>;
  /** Filter by the object’s `rejectionOtherReasons` field. */
  rejectionOtherReasons?: Maybe<StringFilter>;
  /** Filter by the object’s `hraTotalFulfilled` field. */
  hraTotalFulfilled?: Maybe<StringFilter>;
  /** Filter by the object’s `auditTotalScore` field. */
  auditTotalScore?: Maybe<IntFilter>;
  /** Filter by the object’s `auditTotalFulfilled` field. */
  auditTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmdeNotes` field. */
  pmdeNotes?: Maybe<StringFilter>;
  /** Filter by the object’s `dastTotalFulfilled` field. */
  dastTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `cmanBFulfilled` field. */
  cmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `chmanBFulfilled` field. */
  chmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `pmanBFulfilled` field. */
  pmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phmanBFulfilled` field. */
  phmanBFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `psychTotalFulfilled` field. */
  psychTotalFulfilled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientAccepted` field. */
  patientAccepted?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientReasoningForCounseling` field. */
  patientReasoningForCounseling?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientFutureRegistration` field. */
  patientFutureRegistration?: Maybe<BooleanFilter>;
  /** Filter by the object’s `patientReasonsFutureRegistration` field. */
  patientReasonsFutureRegistration?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InterviewReportFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InterviewReportFilter>>;
  /** Negates the expression. */
  not?: Maybe<InterviewReportFilter>;
}

/** An input for mutations affecting `InterviewReport` */
export interface InterviewReportInput {
  id?: Maybe<Scalars['UUID']>;
  bookingId?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `InterviewReport`. Fields that are set will be updated. */
export interface InterviewReportPatch {
  id?: Maybe<Scalars['UUID']>;
  bookingId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  patientReached?: Maybe<Scalars['Boolean']>;
  contactVia?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  hasMedication?: Maybe<Scalars['Boolean']>;
  medicationName?: Maybe<Scalars['String']>;
  hadPreviousIlajnafsyTreatment?: Maybe<Scalars['Boolean']>;
  typeOfPreviousIlajnafsyTreatment?: Maybe<Scalars['String']>;
  finishedPreviousIlajnafsyTreatmentWeaksAgo?: Maybe<Scalars['Date']>;
  suicidalityC1?: Maybe<Scalars['Boolean']>;
  suicidalityC2?: Maybe<Scalars['Boolean']>;
  suicidalityC3?: Maybe<Scalars['Boolean']>;
  suicidalityC4?: Maybe<Scalars['Boolean']>;
  suicidalityC5?: Maybe<Scalars['Boolean']>;
  suicidalityC6?: Maybe<Scalars['Boolean']>;
  suicidalitySuicideRisk?: Maybe<Scalars['String']>;
  suicidalityNoSuicideContract?: Maybe<Scalars['Boolean']>;
  suicidalityNotes?: Maybe<Scalars['String']>;
  traumaDescription?: Maybe<Scalars['String']>;
  ptsdChecked?: Maybe<Scalars['Boolean']>;
  ptsdB1?: Maybe<Scalars['Boolean']>;
  ptsdB2?: Maybe<Scalars['Boolean']>;
  ptsdB3?: Maybe<Scalars['Boolean']>;
  ptsdB4?: Maybe<Scalars['Boolean']>;
  ptsdB5?: Maybe<Scalars['Boolean']>;
  ptsdBFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdC1?: Maybe<Scalars['Boolean']>;
  ptsdC2?: Maybe<Scalars['Boolean']>;
  ptsdCFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdD1?: Maybe<Scalars['Boolean']>;
  ptsdD2?: Maybe<Scalars['Boolean']>;
  ptsdD3?: Maybe<Scalars['Boolean']>;
  ptsdD4?: Maybe<Scalars['Boolean']>;
  ptsdD5?: Maybe<Scalars['Boolean']>;
  ptsdD6?: Maybe<Scalars['Boolean']>;
  ptsdD7?: Maybe<Scalars['Boolean']>;
  ptsdDFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdE1?: Maybe<Scalars['Boolean']>;
  ptsdE2?: Maybe<Scalars['Boolean']>;
  ptsdE3?: Maybe<Scalars['Boolean']>;
  ptsdE4?: Maybe<Scalars['Boolean']>;
  ptsdE5?: Maybe<Scalars['Boolean']>;
  ptsdE6?: Maybe<Scalars['Boolean']>;
  ptsdEFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdFFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdGFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdHFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdTotalFulfilled?: Maybe<Scalars['Boolean']>;
  ptsdNotes?: Maybe<Scalars['String']>;
  cmdeA1?: Maybe<Scalars['Boolean']>;
  cmdeA2?: Maybe<Scalars['Boolean']>;
  cmdeA3?: Maybe<Scalars['Boolean']>;
  cmdeA4?: Maybe<Scalars['Boolean']>;
  cmdeA5?: Maybe<Scalars['Boolean']>;
  cmdeA6?: Maybe<Scalars['Boolean']>;
  cmdeA7?: Maybe<Scalars['Boolean']>;
  cmdeA8?: Maybe<Scalars['Boolean']>;
  cmdeA9?: Maybe<Scalars['Boolean']>;
  cmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeMdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  cmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeMonths?: Maybe<Scalars['Int']>;
  cmdeLastEpisodeBeforeYears?: Maybe<Scalars['Int']>;
  cmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmdeNotes?: Maybe<Scalars['String']>;
  dysthymiaAFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaB1?: Maybe<Scalars['Boolean']>;
  dysthymiaB2?: Maybe<Scalars['Boolean']>;
  dysthymiaB3?: Maybe<Scalars['Boolean']>;
  dysthymiaB4?: Maybe<Scalars['Boolean']>;
  dysthymiaB5?: Maybe<Scalars['Boolean']>;
  dysthymiaB6?: Maybe<Scalars['Boolean']>;
  dysthymiaBFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaCFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaEFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaFFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaGFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaHFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaTotalFulfilled?: Maybe<Scalars['Boolean']>;
  dysthymiaNotes?: Maybe<Scalars['String']>;
  primaryProblem?: Maybe<Scalars['String']>;
  primaryProblemStatusAccepted?: Maybe<Scalars['String']>;
  primaryProblemStatusRejected?: Maybe<Scalars['String']>;
  patientAcceptedForCounseling?: Maybe<Scalars['Boolean']>;
  reasonsForCounseling?: Maybe<Scalars['String']>;
  accessibilityTime?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  patientNeedsToRegisterAgain?: Maybe<Scalars['Boolean']>;
  reasonsForFutureRegistration?: Maybe<Scalars['String']>;
  stateIfOtherReasons?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  hra1?: Maybe<Scalars['Boolean']>;
  hra2?: Maybe<Scalars['Boolean']>;
  hra3?: Maybe<Scalars['Boolean']>;
  hra4?: Maybe<Scalars['Boolean']>;
  hra5?: Maybe<Scalars['Boolean']>;
  hra6?: Maybe<Scalars['Boolean']>;
  audit1?: Maybe<Scalars['Int']>;
  audit2?: Maybe<Scalars['Int']>;
  audit3?: Maybe<Scalars['Int']>;
  audit4?: Maybe<Scalars['Int']>;
  audit5?: Maybe<Scalars['Int']>;
  audit6?: Maybe<Scalars['Int']>;
  audit7?: Maybe<Scalars['Int']>;
  audit8?: Maybe<Scalars['Int']>;
  audit9?: Maybe<Scalars['Int']>;
  audit10?: Maybe<Scalars['Int']>;
  dast1?: Maybe<Scalars['Boolean']>;
  dast2?: Maybe<Scalars['Boolean']>;
  dast3?: Maybe<Scalars['Boolean']>;
  dast4?: Maybe<Scalars['Boolean']>;
  dast5?: Maybe<Scalars['Boolean']>;
  dast6?: Maybe<Scalars['Boolean']>;
  dast7?: Maybe<Scalars['Boolean']>;
  dast8?: Maybe<Scalars['Boolean']>;
  dast9?: Maybe<Scalars['Boolean']>;
  dast10?: Maybe<Scalars['Boolean']>;
  pmdeA1?: Maybe<Scalars['Boolean']>;
  pmdeA2?: Maybe<Scalars['Boolean']>;
  pmdeA3?: Maybe<Scalars['Boolean']>;
  pmdeA4?: Maybe<Scalars['Boolean']>;
  pmdeA5?: Maybe<Scalars['Boolean']>;
  pmdeA6?: Maybe<Scalars['Boolean']>;
  pmdeA7?: Maybe<Scalars['Boolean']>;
  pmdeA8?: Maybe<Scalars['Boolean']>;
  pmdeA9?: Maybe<Scalars['Boolean']>;
  pmdeAFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeBFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeCFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeActualEpisodeStartsWeeks?: Maybe<Scalars['Int']>;
  pmdeActualEpisodeStartsMonths?: Maybe<Scalars['Int']>;
  pmdeNumberOfEpisodes?: Maybe<Scalars['Int']>;
  cmanA1?: Maybe<Scalars['Boolean']>;
  cmanA2?: Maybe<Scalars['Boolean']>;
  cmanB1?: Maybe<Scalars['Boolean']>;
  cmanB2?: Maybe<Scalars['Boolean']>;
  cmanB3?: Maybe<Scalars['Boolean']>;
  cmanB4?: Maybe<Scalars['Boolean']>;
  cmanB5?: Maybe<Scalars['Boolean']>;
  cmanB6?: Maybe<Scalars['Boolean']>;
  cmanB7?: Maybe<Scalars['Boolean']>;
  cmanC1?: Maybe<Scalars['Boolean']>;
  cmanD1?: Maybe<Scalars['Boolean']>;
  cmanFulfilled?: Maybe<Scalars['Boolean']>;
  chmanA1?: Maybe<Scalars['Boolean']>;
  chmanB1?: Maybe<Scalars['Boolean']>;
  chmanB2?: Maybe<Scalars['Boolean']>;
  chmanB3?: Maybe<Scalars['Boolean']>;
  chmanB4?: Maybe<Scalars['Boolean']>;
  chmanB5?: Maybe<Scalars['Boolean']>;
  chmanB6?: Maybe<Scalars['Boolean']>;
  chmanB7?: Maybe<Scalars['Boolean']>;
  chmanC?: Maybe<Scalars['Boolean']>;
  chmanD?: Maybe<Scalars['Boolean']>;
  chmanE?: Maybe<Scalars['Boolean']>;
  chmanF?: Maybe<Scalars['Boolean']>;
  chmanFulfilled?: Maybe<Scalars['Boolean']>;
  pmanA1?: Maybe<Scalars['Boolean']>;
  pmanA2?: Maybe<Scalars['Boolean']>;
  pmanB1?: Maybe<Scalars['Boolean']>;
  pmanB2?: Maybe<Scalars['Boolean']>;
  pmanB3?: Maybe<Scalars['Boolean']>;
  pmanB4?: Maybe<Scalars['Boolean']>;
  pmanB5?: Maybe<Scalars['Boolean']>;
  pmanB6?: Maybe<Scalars['Boolean']>;
  pmanB7?: Maybe<Scalars['Boolean']>;
  pmanC1?: Maybe<Scalars['Boolean']>;
  pmanD1?: Maybe<Scalars['Boolean']>;
  pmanFulfilled?: Maybe<Scalars['Boolean']>;
  phmanA1?: Maybe<Scalars['Boolean']>;
  phmanB1?: Maybe<Scalars['Boolean']>;
  phmanB2?: Maybe<Scalars['Boolean']>;
  phmanB3?: Maybe<Scalars['Boolean']>;
  phmanB4?: Maybe<Scalars['Boolean']>;
  phmanB5?: Maybe<Scalars['Boolean']>;
  phmanB6?: Maybe<Scalars['Boolean']>;
  phmanB7?: Maybe<Scalars['Boolean']>;
  phmanC?: Maybe<Scalars['Boolean']>;
  phmanD?: Maybe<Scalars['Boolean']>;
  phmanE?: Maybe<Scalars['Boolean']>;
  phmanF?: Maybe<Scalars['Boolean']>;
  phmanFulfilled?: Maybe<Scalars['Boolean']>;
  psychB1?: Maybe<Scalars['Boolean']>;
  psychB2?: Maybe<Scalars['Boolean']>;
  psychB3?: Maybe<Scalars['Boolean']>;
  psychB4?: Maybe<Scalars['Boolean']>;
  psychB5?: Maybe<Scalars['Boolean']>;
  psychB6?: Maybe<Scalars['Boolean']>;
  psychB7?: Maybe<Scalars['Boolean']>;
  psychB8?: Maybe<Scalars['Boolean']>;
  psychB9?: Maybe<Scalars['Boolean']>;
  psychB10?: Maybe<Scalars['Boolean']>;
  psychB11?: Maybe<Scalars['Boolean']>;
  psychB12?: Maybe<Scalars['Boolean']>;
  psychB13?: Maybe<Scalars['Boolean']>;
  psychB14?: Maybe<Scalars['Boolean']>;
  psychB15?: Maybe<Scalars['Boolean']>;
  psychB16?: Maybe<Scalars['Boolean']>;
  psychB17?: Maybe<Scalars['Boolean']>;
  psychB18?: Maybe<Scalars['Boolean']>;
  psychB19?: Maybe<Scalars['Boolean']>;
  rejectionOtherReasons?: Maybe<Scalars['String']>;
  hraTotalFulfilled?: Maybe<Scalars['String']>;
  auditTotalScore?: Maybe<Scalars['Int']>;
  auditTotalFulfilled?: Maybe<Scalars['Boolean']>;
  pmdeNotes?: Maybe<Scalars['String']>;
  dastTotalFulfilled?: Maybe<Scalars['Boolean']>;
  cmanBFulfilled?: Maybe<Scalars['Boolean']>;
  chmanBFulfilled?: Maybe<Scalars['Boolean']>;
  pmanBFulfilled?: Maybe<Scalars['Boolean']>;
  phmanBFulfilled?: Maybe<Scalars['Boolean']>;
  psychTotalFulfilled?: Maybe<Scalars['Boolean']>;
  patientAccepted?: Maybe<Scalars['Boolean']>;
  patientReasoningForCounseling?: Maybe<Scalars['Boolean']>;
  patientFutureRegistration?: Maybe<Scalars['Boolean']>;
  patientReasonsFutureRegistration?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `InterviewReport` values. */
export interface InterviewReportsConnection {
  __typename?: 'InterviewReportsConnection';
  /** A list of `InterviewReport` objects. */
  nodes: Array<InterviewReport>;
  /** A list of edges which contains the `InterviewReport` and cursor to aid in pagination. */
  edges: Array<InterviewReportsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InterviewReport` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InterviewReport` edge in the connection. */
export interface InterviewReportsEdge {
  __typename?: 'InterviewReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InterviewReport` at the end of the edge. */
  node: InterviewReport;
}

/** Methods to use when ordering `InterviewReport`. */
export enum InterviewReportsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  PatientReachedAsc = 'PATIENT_REACHED_ASC',
  PatientReachedDesc = 'PATIENT_REACHED_DESC',
  ContactViaAsc = 'CONTACT_VIA_ASC',
  ContactViaDesc = 'CONTACT_VIA_DESC',
  PatientAliasAsc = 'PATIENT_ALIAS_ASC',
  PatientAliasDesc = 'PATIENT_ALIAS_DESC',
  HasMedicationAsc = 'HAS_MEDICATION_ASC',
  HasMedicationDesc = 'HAS_MEDICATION_DESC',
  MedicationNameAsc = 'MEDICATION_NAME_ASC',
  MedicationNameDesc = 'MEDICATION_NAME_DESC',
  HadPreviousIlajnafsyTreatmentAsc = 'HAD_PREVIOUS_ILAJNAFSY_TREATMENT_ASC',
  HadPreviousIlajnafsyTreatmentDesc = 'HAD_PREVIOUS_ILAJNAFSY_TREATMENT_DESC',
  TypeOfPreviousIlajnafsyTreatmentAsc = 'TYPE_OF_PREVIOUS_ILAJNAFSY_TREATMENT_ASC',
  TypeOfPreviousIlajnafsyTreatmentDesc = 'TYPE_OF_PREVIOUS_ILAJNAFSY_TREATMENT_DESC',
  FinishedPreviousIlajnafsyTreatmentWeaksAgoAsc = 'FINISHED_PREVIOUS_ILAJNAFSY_TREATMENT_WEAKS_AGO_ASC',
  FinishedPreviousIlajnafsyTreatmentWeaksAgoDesc = 'FINISHED_PREVIOUS_ILAJNAFSY_TREATMENT_WEAKS_AGO_DESC',
  SuicidalityC1Asc = 'SUICIDALITY_C1_ASC',
  SuicidalityC1Desc = 'SUICIDALITY_C1_DESC',
  SuicidalityC2Asc = 'SUICIDALITY_C2_ASC',
  SuicidalityC2Desc = 'SUICIDALITY_C2_DESC',
  SuicidalityC3Asc = 'SUICIDALITY_C3_ASC',
  SuicidalityC3Desc = 'SUICIDALITY_C3_DESC',
  SuicidalityC4Asc = 'SUICIDALITY_C4_ASC',
  SuicidalityC4Desc = 'SUICIDALITY_C4_DESC',
  SuicidalityC5Asc = 'SUICIDALITY_C5_ASC',
  SuicidalityC5Desc = 'SUICIDALITY_C5_DESC',
  SuicidalityC6Asc = 'SUICIDALITY_C6_ASC',
  SuicidalityC6Desc = 'SUICIDALITY_C6_DESC',
  SuicidalitySuicideRiskAsc = 'SUICIDALITY_SUICIDE_RISK_ASC',
  SuicidalitySuicideRiskDesc = 'SUICIDALITY_SUICIDE_RISK_DESC',
  SuicidalityNoSuicideContractAsc = 'SUICIDALITY_NO_SUICIDE_CONTRACT_ASC',
  SuicidalityNoSuicideContractDesc = 'SUICIDALITY_NO_SUICIDE_CONTRACT_DESC',
  SuicidalityNotesAsc = 'SUICIDALITY_NOTES_ASC',
  SuicidalityNotesDesc = 'SUICIDALITY_NOTES_DESC',
  TraumaDescriptionAsc = 'TRAUMA_DESCRIPTION_ASC',
  TraumaDescriptionDesc = 'TRAUMA_DESCRIPTION_DESC',
  PtsdCheckedAsc = 'PTSD_CHECKED_ASC',
  PtsdCheckedDesc = 'PTSD_CHECKED_DESC',
  PtsdB1Asc = 'PTSD_B1_ASC',
  PtsdB1Desc = 'PTSD_B1_DESC',
  PtsdB2Asc = 'PTSD_B2_ASC',
  PtsdB2Desc = 'PTSD_B2_DESC',
  PtsdB3Asc = 'PTSD_B3_ASC',
  PtsdB3Desc = 'PTSD_B3_DESC',
  PtsdB4Asc = 'PTSD_B4_ASC',
  PtsdB4Desc = 'PTSD_B4_DESC',
  PtsdB5Asc = 'PTSD_B5_ASC',
  PtsdB5Desc = 'PTSD_B5_DESC',
  PtsdBFulfilledAsc = 'PTSD_B_FULFILLED_ASC',
  PtsdBFulfilledDesc = 'PTSD_B_FULFILLED_DESC',
  PtsdC1Asc = 'PTSD_C1_ASC',
  PtsdC1Desc = 'PTSD_C1_DESC',
  PtsdC2Asc = 'PTSD_C2_ASC',
  PtsdC2Desc = 'PTSD_C2_DESC',
  PtsdCFulfilledAsc = 'PTSD_C_FULFILLED_ASC',
  PtsdCFulfilledDesc = 'PTSD_C_FULFILLED_DESC',
  PtsdD1Asc = 'PTSD_D1_ASC',
  PtsdD1Desc = 'PTSD_D1_DESC',
  PtsdD2Asc = 'PTSD_D2_ASC',
  PtsdD2Desc = 'PTSD_D2_DESC',
  PtsdD3Asc = 'PTSD_D3_ASC',
  PtsdD3Desc = 'PTSD_D3_DESC',
  PtsdD4Asc = 'PTSD_D4_ASC',
  PtsdD4Desc = 'PTSD_D4_DESC',
  PtsdD5Asc = 'PTSD_D5_ASC',
  PtsdD5Desc = 'PTSD_D5_DESC',
  PtsdD6Asc = 'PTSD_D6_ASC',
  PtsdD6Desc = 'PTSD_D6_DESC',
  PtsdD7Asc = 'PTSD_D7_ASC',
  PtsdD7Desc = 'PTSD_D7_DESC',
  PtsdDFulfilledAsc = 'PTSD_D_FULFILLED_ASC',
  PtsdDFulfilledDesc = 'PTSD_D_FULFILLED_DESC',
  PtsdE1Asc = 'PTSD_E1_ASC',
  PtsdE1Desc = 'PTSD_E1_DESC',
  PtsdE2Asc = 'PTSD_E2_ASC',
  PtsdE2Desc = 'PTSD_E2_DESC',
  PtsdE3Asc = 'PTSD_E3_ASC',
  PtsdE3Desc = 'PTSD_E3_DESC',
  PtsdE4Asc = 'PTSD_E4_ASC',
  PtsdE4Desc = 'PTSD_E4_DESC',
  PtsdE5Asc = 'PTSD_E5_ASC',
  PtsdE5Desc = 'PTSD_E5_DESC',
  PtsdE6Asc = 'PTSD_E6_ASC',
  PtsdE6Desc = 'PTSD_E6_DESC',
  PtsdEFulfilledAsc = 'PTSD_E_FULFILLED_ASC',
  PtsdEFulfilledDesc = 'PTSD_E_FULFILLED_DESC',
  PtsdFFulfilledAsc = 'PTSD_F_FULFILLED_ASC',
  PtsdFFulfilledDesc = 'PTSD_F_FULFILLED_DESC',
  PtsdGFulfilledAsc = 'PTSD_G_FULFILLED_ASC',
  PtsdGFulfilledDesc = 'PTSD_G_FULFILLED_DESC',
  PtsdHFulfilledAsc = 'PTSD_H_FULFILLED_ASC',
  PtsdHFulfilledDesc = 'PTSD_H_FULFILLED_DESC',
  PtsdTotalFulfilledAsc = 'PTSD_TOTAL_FULFILLED_ASC',
  PtsdTotalFulfilledDesc = 'PTSD_TOTAL_FULFILLED_DESC',
  PtsdNotesAsc = 'PTSD_NOTES_ASC',
  PtsdNotesDesc = 'PTSD_NOTES_DESC',
  CmdeA1Asc = 'CMDE_A1_ASC',
  CmdeA1Desc = 'CMDE_A1_DESC',
  CmdeA2Asc = 'CMDE_A2_ASC',
  CmdeA2Desc = 'CMDE_A2_DESC',
  CmdeA3Asc = 'CMDE_A3_ASC',
  CmdeA3Desc = 'CMDE_A3_DESC',
  CmdeA4Asc = 'CMDE_A4_ASC',
  CmdeA4Desc = 'CMDE_A4_DESC',
  CmdeA5Asc = 'CMDE_A5_ASC',
  CmdeA5Desc = 'CMDE_A5_DESC',
  CmdeA6Asc = 'CMDE_A6_ASC',
  CmdeA6Desc = 'CMDE_A6_DESC',
  CmdeA7Asc = 'CMDE_A7_ASC',
  CmdeA7Desc = 'CMDE_A7_DESC',
  CmdeA8Asc = 'CMDE_A8_ASC',
  CmdeA8Desc = 'CMDE_A8_DESC',
  CmdeA9Asc = 'CMDE_A9_ASC',
  CmdeA9Desc = 'CMDE_A9_DESC',
  CmdeAFulfilledAsc = 'CMDE_A_FULFILLED_ASC',
  CmdeAFulfilledDesc = 'CMDE_A_FULFILLED_DESC',
  CmdeBFulfilledAsc = 'CMDE_B_FULFILLED_ASC',
  CmdeBFulfilledDesc = 'CMDE_B_FULFILLED_DESC',
  CmdeCFulfilledAsc = 'CMDE_C_FULFILLED_ASC',
  CmdeCFulfilledDesc = 'CMDE_C_FULFILLED_DESC',
  CmdeMdeTotalFulfilledAsc = 'CMDE_MDE_TOTAL_FULFILLED_ASC',
  CmdeMdeTotalFulfilledDesc = 'CMDE_MDE_TOTAL_FULFILLED_DESC',
  CmdeActualEpisodeStartsWeeksAsc = 'CMDE_ACTUAL_EPISODE_STARTS_WEEKS_ASC',
  CmdeActualEpisodeStartsWeeksDesc = 'CMDE_ACTUAL_EPISODE_STARTS_WEEKS_DESC',
  CmdeActualEpisodeStartsMonthsAsc = 'CMDE_ACTUAL_EPISODE_STARTS_MONTHS_ASC',
  CmdeActualEpisodeStartsMonthsDesc = 'CMDE_ACTUAL_EPISODE_STARTS_MONTHS_DESC',
  CmdeLastEpisodeBeforeMonthsAsc = 'CMDE_LAST_EPISODE_BEFORE_MONTHS_ASC',
  CmdeLastEpisodeBeforeMonthsDesc = 'CMDE_LAST_EPISODE_BEFORE_MONTHS_DESC',
  CmdeLastEpisodeBeforeYearsAsc = 'CMDE_LAST_EPISODE_BEFORE_YEARS_ASC',
  CmdeLastEpisodeBeforeYearsDesc = 'CMDE_LAST_EPISODE_BEFORE_YEARS_DESC',
  CmdeNumberOfEpisodesAsc = 'CMDE_NUMBER_OF_EPISODES_ASC',
  CmdeNumberOfEpisodesDesc = 'CMDE_NUMBER_OF_EPISODES_DESC',
  CmdeNotesAsc = 'CMDE_NOTES_ASC',
  CmdeNotesDesc = 'CMDE_NOTES_DESC',
  DysthymiaAFulfilledAsc = 'DYSTHYMIA_A_FULFILLED_ASC',
  DysthymiaAFulfilledDesc = 'DYSTHYMIA_A_FULFILLED_DESC',
  DysthymiaB1Asc = 'DYSTHYMIA_B1_ASC',
  DysthymiaB1Desc = 'DYSTHYMIA_B1_DESC',
  DysthymiaB2Asc = 'DYSTHYMIA_B2_ASC',
  DysthymiaB2Desc = 'DYSTHYMIA_B2_DESC',
  DysthymiaB3Asc = 'DYSTHYMIA_B3_ASC',
  DysthymiaB3Desc = 'DYSTHYMIA_B3_DESC',
  DysthymiaB4Asc = 'DYSTHYMIA_B4_ASC',
  DysthymiaB4Desc = 'DYSTHYMIA_B4_DESC',
  DysthymiaB5Asc = 'DYSTHYMIA_B5_ASC',
  DysthymiaB5Desc = 'DYSTHYMIA_B5_DESC',
  DysthymiaB6Asc = 'DYSTHYMIA_B6_ASC',
  DysthymiaB6Desc = 'DYSTHYMIA_B6_DESC',
  DysthymiaBFulfilledAsc = 'DYSTHYMIA_B_FULFILLED_ASC',
  DysthymiaBFulfilledDesc = 'DYSTHYMIA_B_FULFILLED_DESC',
  DysthymiaCFulfilledAsc = 'DYSTHYMIA_C_FULFILLED_ASC',
  DysthymiaCFulfilledDesc = 'DYSTHYMIA_C_FULFILLED_DESC',
  DysthymiaEFulfilledAsc = 'DYSTHYMIA_E_FULFILLED_ASC',
  DysthymiaEFulfilledDesc = 'DYSTHYMIA_E_FULFILLED_DESC',
  DysthymiaFFulfilledAsc = 'DYSTHYMIA_F_FULFILLED_ASC',
  DysthymiaFFulfilledDesc = 'DYSTHYMIA_F_FULFILLED_DESC',
  DysthymiaGFulfilledAsc = 'DYSTHYMIA_G_FULFILLED_ASC',
  DysthymiaGFulfilledDesc = 'DYSTHYMIA_G_FULFILLED_DESC',
  DysthymiaHFulfilledAsc = 'DYSTHYMIA_H_FULFILLED_ASC',
  DysthymiaHFulfilledDesc = 'DYSTHYMIA_H_FULFILLED_DESC',
  DysthymiaTotalFulfilledAsc = 'DYSTHYMIA_TOTAL_FULFILLED_ASC',
  DysthymiaTotalFulfilledDesc = 'DYSTHYMIA_TOTAL_FULFILLED_DESC',
  DysthymiaNotesAsc = 'DYSTHYMIA_NOTES_ASC',
  DysthymiaNotesDesc = 'DYSTHYMIA_NOTES_DESC',
  PrimaryProblemAsc = 'PRIMARY_PROBLEM_ASC',
  PrimaryProblemDesc = 'PRIMARY_PROBLEM_DESC',
  PrimaryProblemStatusAcceptedAsc = 'PRIMARY_PROBLEM_STATUS_ACCEPTED_ASC',
  PrimaryProblemStatusAcceptedDesc = 'PRIMARY_PROBLEM_STATUS_ACCEPTED_DESC',
  PrimaryProblemStatusRejectedAsc = 'PRIMARY_PROBLEM_STATUS_REJECTED_ASC',
  PrimaryProblemStatusRejectedDesc = 'PRIMARY_PROBLEM_STATUS_REJECTED_DESC',
  PatientAcceptedForCounselingAsc = 'PATIENT_ACCEPTED_FOR_COUNSELING_ASC',
  PatientAcceptedForCounselingDesc = 'PATIENT_ACCEPTED_FOR_COUNSELING_DESC',
  ReasonsForCounselingAsc = 'REASONS_FOR_COUNSELING_ASC',
  ReasonsForCounselingDesc = 'REASONS_FOR_COUNSELING_DESC',
  AccessibilityTimeAsc = 'ACCESSIBILITY_TIME_ASC',
  AccessibilityTimeDesc = 'ACCESSIBILITY_TIME_DESC',
  AdditionalCommentsAsc = 'ADDITIONAL_COMMENTS_ASC',
  AdditionalCommentsDesc = 'ADDITIONAL_COMMENTS_DESC',
  PatientNeedsToRegisterAgainAsc = 'PATIENT_NEEDS_TO_REGISTER_AGAIN_ASC',
  PatientNeedsToRegisterAgainDesc = 'PATIENT_NEEDS_TO_REGISTER_AGAIN_DESC',
  ReasonsForFutureRegistrationAsc = 'REASONS_FOR_FUTURE_REGISTRATION_ASC',
  ReasonsForFutureRegistrationDesc = 'REASONS_FOR_FUTURE_REGISTRATION_DESC',
  StateIfOtherReasonsAsc = 'STATE_IF_OTHER_REASONS_ASC',
  StateIfOtherReasonsDesc = 'STATE_IF_OTHER_REASONS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  Hra_1Asc = 'HRA_1_ASC',
  Hra_1Desc = 'HRA_1_DESC',
  Hra_2Asc = 'HRA_2_ASC',
  Hra_2Desc = 'HRA_2_DESC',
  Hra_3Asc = 'HRA_3_ASC',
  Hra_3Desc = 'HRA_3_DESC',
  Hra_4Asc = 'HRA_4_ASC',
  Hra_4Desc = 'HRA_4_DESC',
  Hra_5Asc = 'HRA_5_ASC',
  Hra_5Desc = 'HRA_5_DESC',
  Hra_6Asc = 'HRA_6_ASC',
  Hra_6Desc = 'HRA_6_DESC',
  Audit_1Asc = 'AUDIT_1_ASC',
  Audit_1Desc = 'AUDIT_1_DESC',
  Audit_2Asc = 'AUDIT_2_ASC',
  Audit_2Desc = 'AUDIT_2_DESC',
  Audit_3Asc = 'AUDIT_3_ASC',
  Audit_3Desc = 'AUDIT_3_DESC',
  Audit_4Asc = 'AUDIT_4_ASC',
  Audit_4Desc = 'AUDIT_4_DESC',
  Audit_5Asc = 'AUDIT_5_ASC',
  Audit_5Desc = 'AUDIT_5_DESC',
  Audit_6Asc = 'AUDIT_6_ASC',
  Audit_6Desc = 'AUDIT_6_DESC',
  Audit_7Asc = 'AUDIT_7_ASC',
  Audit_7Desc = 'AUDIT_7_DESC',
  Audit_8Asc = 'AUDIT_8_ASC',
  Audit_8Desc = 'AUDIT_8_DESC',
  Audit_9Asc = 'AUDIT_9_ASC',
  Audit_9Desc = 'AUDIT_9_DESC',
  Audit_10Asc = 'AUDIT_10_ASC',
  Audit_10Desc = 'AUDIT_10_DESC',
  Dast_1Asc = 'DAST_1_ASC',
  Dast_1Desc = 'DAST_1_DESC',
  Dast_2Asc = 'DAST_2_ASC',
  Dast_2Desc = 'DAST_2_DESC',
  Dast_3Asc = 'DAST_3_ASC',
  Dast_3Desc = 'DAST_3_DESC',
  Dast_4Asc = 'DAST_4_ASC',
  Dast_4Desc = 'DAST_4_DESC',
  Dast_5Asc = 'DAST_5_ASC',
  Dast_5Desc = 'DAST_5_DESC',
  Dast_6Asc = 'DAST_6_ASC',
  Dast_6Desc = 'DAST_6_DESC',
  Dast_7Asc = 'DAST_7_ASC',
  Dast_7Desc = 'DAST_7_DESC',
  Dast_8Asc = 'DAST_8_ASC',
  Dast_8Desc = 'DAST_8_DESC',
  Dast_9Asc = 'DAST_9_ASC',
  Dast_9Desc = 'DAST_9_DESC',
  Dast_10Asc = 'DAST_10_ASC',
  Dast_10Desc = 'DAST_10_DESC',
  PmdeA1Asc = 'PMDE_A1_ASC',
  PmdeA1Desc = 'PMDE_A1_DESC',
  PmdeA2Asc = 'PMDE_A2_ASC',
  PmdeA2Desc = 'PMDE_A2_DESC',
  PmdeA3Asc = 'PMDE_A3_ASC',
  PmdeA3Desc = 'PMDE_A3_DESC',
  PmdeA4Asc = 'PMDE_A4_ASC',
  PmdeA4Desc = 'PMDE_A4_DESC',
  PmdeA5Asc = 'PMDE_A5_ASC',
  PmdeA5Desc = 'PMDE_A5_DESC',
  PmdeA6Asc = 'PMDE_A6_ASC',
  PmdeA6Desc = 'PMDE_A6_DESC',
  PmdeA7Asc = 'PMDE_A7_ASC',
  PmdeA7Desc = 'PMDE_A7_DESC',
  PmdeA8Asc = 'PMDE_A8_ASC',
  PmdeA8Desc = 'PMDE_A8_DESC',
  PmdeA9Asc = 'PMDE_A9_ASC',
  PmdeA9Desc = 'PMDE_A9_DESC',
  PmdeAFulfilledAsc = 'PMDE_A_FULFILLED_ASC',
  PmdeAFulfilledDesc = 'PMDE_A_FULFILLED_DESC',
  PmdeBFulfilledAsc = 'PMDE_B_FULFILLED_ASC',
  PmdeBFulfilledDesc = 'PMDE_B_FULFILLED_DESC',
  PmdeCFulfilledAsc = 'PMDE_C_FULFILLED_ASC',
  PmdeCFulfilledDesc = 'PMDE_C_FULFILLED_DESC',
  PmdeTotalFulfilledAsc = 'PMDE_TOTAL_FULFILLED_ASC',
  PmdeTotalFulfilledDesc = 'PMDE_TOTAL_FULFILLED_DESC',
  PmdeActualEpisodeStartsWeeksAsc = 'PMDE_ACTUAL_EPISODE_STARTS_WEEKS_ASC',
  PmdeActualEpisodeStartsWeeksDesc = 'PMDE_ACTUAL_EPISODE_STARTS_WEEKS_DESC',
  PmdeActualEpisodeStartsMonthsAsc = 'PMDE_ACTUAL_EPISODE_STARTS_MONTHS_ASC',
  PmdeActualEpisodeStartsMonthsDesc = 'PMDE_ACTUAL_EPISODE_STARTS_MONTHS_DESC',
  PmdeNumberOfEpisodesAsc = 'PMDE_NUMBER_OF_EPISODES_ASC',
  PmdeNumberOfEpisodesDesc = 'PMDE_NUMBER_OF_EPISODES_DESC',
  CmanA1Asc = 'CMAN_A1_ASC',
  CmanA1Desc = 'CMAN_A1_DESC',
  CmanA2Asc = 'CMAN_A2_ASC',
  CmanA2Desc = 'CMAN_A2_DESC',
  CmanB1Asc = 'CMAN_B1_ASC',
  CmanB1Desc = 'CMAN_B1_DESC',
  CmanB2Asc = 'CMAN_B2_ASC',
  CmanB2Desc = 'CMAN_B2_DESC',
  CmanB3Asc = 'CMAN_B3_ASC',
  CmanB3Desc = 'CMAN_B3_DESC',
  CmanB4Asc = 'CMAN_B4_ASC',
  CmanB4Desc = 'CMAN_B4_DESC',
  CmanB5Asc = 'CMAN_B5_ASC',
  CmanB5Desc = 'CMAN_B5_DESC',
  CmanB6Asc = 'CMAN_B6_ASC',
  CmanB6Desc = 'CMAN_B6_DESC',
  CmanB7Asc = 'CMAN_B7_ASC',
  CmanB7Desc = 'CMAN_B7_DESC',
  CmanC1Asc = 'CMAN_C1_ASC',
  CmanC1Desc = 'CMAN_C1_DESC',
  CmanD1Asc = 'CMAN_D1_ASC',
  CmanD1Desc = 'CMAN_D1_DESC',
  CmanFulfilledAsc = 'CMAN_FULFILLED_ASC',
  CmanFulfilledDesc = 'CMAN_FULFILLED_DESC',
  ChmanA1Asc = 'CHMAN_A1_ASC',
  ChmanA1Desc = 'CHMAN_A1_DESC',
  ChmanB1Asc = 'CHMAN_B1_ASC',
  ChmanB1Desc = 'CHMAN_B1_DESC',
  ChmanB2Asc = 'CHMAN_B2_ASC',
  ChmanB2Desc = 'CHMAN_B2_DESC',
  ChmanB3Asc = 'CHMAN_B3_ASC',
  ChmanB3Desc = 'CHMAN_B3_DESC',
  ChmanB4Asc = 'CHMAN_B4_ASC',
  ChmanB4Desc = 'CHMAN_B4_DESC',
  ChmanB5Asc = 'CHMAN_B5_ASC',
  ChmanB5Desc = 'CHMAN_B5_DESC',
  ChmanB6Asc = 'CHMAN_B6_ASC',
  ChmanB6Desc = 'CHMAN_B6_DESC',
  ChmanB7Asc = 'CHMAN_B7_ASC',
  ChmanB7Desc = 'CHMAN_B7_DESC',
  ChmanCAsc = 'CHMAN_C_ASC',
  ChmanCDesc = 'CHMAN_C_DESC',
  ChmanDAsc = 'CHMAN_D_ASC',
  ChmanDDesc = 'CHMAN_D_DESC',
  ChmanEAsc = 'CHMAN_E_ASC',
  ChmanEDesc = 'CHMAN_E_DESC',
  ChmanFAsc = 'CHMAN_F_ASC',
  ChmanFDesc = 'CHMAN_F_DESC',
  ChmanFulfilledAsc = 'CHMAN_FULFILLED_ASC',
  ChmanFulfilledDesc = 'CHMAN_FULFILLED_DESC',
  PmanA1Asc = 'PMAN_A1_ASC',
  PmanA1Desc = 'PMAN_A1_DESC',
  PmanA2Asc = 'PMAN_A2_ASC',
  PmanA2Desc = 'PMAN_A2_DESC',
  PmanB1Asc = 'PMAN_B1_ASC',
  PmanB1Desc = 'PMAN_B1_DESC',
  PmanB2Asc = 'PMAN_B2_ASC',
  PmanB2Desc = 'PMAN_B2_DESC',
  PmanB3Asc = 'PMAN_B3_ASC',
  PmanB3Desc = 'PMAN_B3_DESC',
  PmanB4Asc = 'PMAN_B4_ASC',
  PmanB4Desc = 'PMAN_B4_DESC',
  PmanB5Asc = 'PMAN_B5_ASC',
  PmanB5Desc = 'PMAN_B5_DESC',
  PmanB6Asc = 'PMAN_B6_ASC',
  PmanB6Desc = 'PMAN_B6_DESC',
  PmanB7Asc = 'PMAN_B7_ASC',
  PmanB7Desc = 'PMAN_B7_DESC',
  PmanC1Asc = 'PMAN_C1_ASC',
  PmanC1Desc = 'PMAN_C1_DESC',
  PmanD1Asc = 'PMAN_D1_ASC',
  PmanD1Desc = 'PMAN_D1_DESC',
  PmanFulfilledAsc = 'PMAN_FULFILLED_ASC',
  PmanFulfilledDesc = 'PMAN_FULFILLED_DESC',
  PhmanA1Asc = 'PHMAN_A1_ASC',
  PhmanA1Desc = 'PHMAN_A1_DESC',
  PhmanB1Asc = 'PHMAN_B1_ASC',
  PhmanB1Desc = 'PHMAN_B1_DESC',
  PhmanB2Asc = 'PHMAN_B2_ASC',
  PhmanB2Desc = 'PHMAN_B2_DESC',
  PhmanB3Asc = 'PHMAN_B3_ASC',
  PhmanB3Desc = 'PHMAN_B3_DESC',
  PhmanB4Asc = 'PHMAN_B4_ASC',
  PhmanB4Desc = 'PHMAN_B4_DESC',
  PhmanB5Asc = 'PHMAN_B5_ASC',
  PhmanB5Desc = 'PHMAN_B5_DESC',
  PhmanB6Asc = 'PHMAN_B6_ASC',
  PhmanB6Desc = 'PHMAN_B6_DESC',
  PhmanB7Asc = 'PHMAN_B7_ASC',
  PhmanB7Desc = 'PHMAN_B7_DESC',
  PhmanCAsc = 'PHMAN_C_ASC',
  PhmanCDesc = 'PHMAN_C_DESC',
  PhmanDAsc = 'PHMAN_D_ASC',
  PhmanDDesc = 'PHMAN_D_DESC',
  PhmanEAsc = 'PHMAN_E_ASC',
  PhmanEDesc = 'PHMAN_E_DESC',
  PhmanFAsc = 'PHMAN_F_ASC',
  PhmanFDesc = 'PHMAN_F_DESC',
  PhmanFulfilledAsc = 'PHMAN_FULFILLED_ASC',
  PhmanFulfilledDesc = 'PHMAN_FULFILLED_DESC',
  PsychB1Asc = 'PSYCH_B1_ASC',
  PsychB1Desc = 'PSYCH_B1_DESC',
  PsychB2Asc = 'PSYCH_B2_ASC',
  PsychB2Desc = 'PSYCH_B2_DESC',
  PsychB3Asc = 'PSYCH_B3_ASC',
  PsychB3Desc = 'PSYCH_B3_DESC',
  PsychB4Asc = 'PSYCH_B4_ASC',
  PsychB4Desc = 'PSYCH_B4_DESC',
  PsychB5Asc = 'PSYCH_B5_ASC',
  PsychB5Desc = 'PSYCH_B5_DESC',
  PsychB6Asc = 'PSYCH_B6_ASC',
  PsychB6Desc = 'PSYCH_B6_DESC',
  PsychB7Asc = 'PSYCH_B7_ASC',
  PsychB7Desc = 'PSYCH_B7_DESC',
  PsychB8Asc = 'PSYCH_B8_ASC',
  PsychB8Desc = 'PSYCH_B8_DESC',
  PsychB9Asc = 'PSYCH_B9_ASC',
  PsychB9Desc = 'PSYCH_B9_DESC',
  PsychB10Asc = 'PSYCH_B10_ASC',
  PsychB10Desc = 'PSYCH_B10_DESC',
  PsychB11Asc = 'PSYCH_B11_ASC',
  PsychB11Desc = 'PSYCH_B11_DESC',
  PsychB12Asc = 'PSYCH_B12_ASC',
  PsychB12Desc = 'PSYCH_B12_DESC',
  PsychB13Asc = 'PSYCH_B13_ASC',
  PsychB13Desc = 'PSYCH_B13_DESC',
  PsychB14Asc = 'PSYCH_B14_ASC',
  PsychB14Desc = 'PSYCH_B14_DESC',
  PsychB15Asc = 'PSYCH_B15_ASC',
  PsychB15Desc = 'PSYCH_B15_DESC',
  PsychB16Asc = 'PSYCH_B16_ASC',
  PsychB16Desc = 'PSYCH_B16_DESC',
  PsychB17Asc = 'PSYCH_B17_ASC',
  PsychB17Desc = 'PSYCH_B17_DESC',
  PsychB18Asc = 'PSYCH_B18_ASC',
  PsychB18Desc = 'PSYCH_B18_DESC',
  PsychB19Asc = 'PSYCH_B19_ASC',
  PsychB19Desc = 'PSYCH_B19_DESC',
  RejectionOtherReasonsAsc = 'REJECTION_OTHER_REASONS_ASC',
  RejectionOtherReasonsDesc = 'REJECTION_OTHER_REASONS_DESC',
  HraTotalFulfilledAsc = 'HRA_TOTAL_FULFILLED_ASC',
  HraTotalFulfilledDesc = 'HRA_TOTAL_FULFILLED_DESC',
  AuditTotalScoreAsc = 'AUDIT_TOTAL_SCORE_ASC',
  AuditTotalScoreDesc = 'AUDIT_TOTAL_SCORE_DESC',
  AuditTotalFulfilledAsc = 'AUDIT_TOTAL_FULFILLED_ASC',
  AuditTotalFulfilledDesc = 'AUDIT_TOTAL_FULFILLED_DESC',
  PmdeNotesAsc = 'PMDE_NOTES_ASC',
  PmdeNotesDesc = 'PMDE_NOTES_DESC',
  DastTotalFulfilledAsc = 'DAST_TOTAL_FULFILLED_ASC',
  DastTotalFulfilledDesc = 'DAST_TOTAL_FULFILLED_DESC',
  CmanBFulfilledAsc = 'CMAN_B_FULFILLED_ASC',
  CmanBFulfilledDesc = 'CMAN_B_FULFILLED_DESC',
  ChmanBFulfilledAsc = 'CHMAN_B_FULFILLED_ASC',
  ChmanBFulfilledDesc = 'CHMAN_B_FULFILLED_DESC',
  PmanBFulfilledAsc = 'PMAN_B_FULFILLED_ASC',
  PmanBFulfilledDesc = 'PMAN_B_FULFILLED_DESC',
  PhmanBFulfilledAsc = 'PHMAN_B_FULFILLED_ASC',
  PhmanBFulfilledDesc = 'PHMAN_B_FULFILLED_DESC',
  PsychTotalFulfilledAsc = 'PSYCH_TOTAL_FULFILLED_ASC',
  PsychTotalFulfilledDesc = 'PSYCH_TOTAL_FULFILLED_DESC',
  PatientAcceptedAsc = 'PATIENT_ACCEPTED_ASC',
  PatientAcceptedDesc = 'PATIENT_ACCEPTED_DESC',
  PatientReasoningForCounselingAsc = 'PATIENT_REASONING_FOR_COUNSELING_ASC',
  PatientReasoningForCounselingDesc = 'PATIENT_REASONING_FOR_COUNSELING_DESC',
  PatientFutureRegistrationAsc = 'PATIENT_FUTURE_REGISTRATION_ASC',
  PatientFutureRegistrationDesc = 'PATIENT_FUTURE_REGISTRATION_DESC',
  PatientReasonsFutureRegistrationAsc = 'PATIENT_REASONS_FUTURE_REGISTRATION_ASC',
  PatientReasonsFutureRegistrationDesc = 'PATIENT_REASONS_FUTURE_REGISTRATION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export interface IntFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Int']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['Int']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['Int']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['Int']>;
}

export interface Invoice {
  __typename?: 'Invoice';
  userId?: Maybe<Scalars['UUID']>;
  dateOfItem?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  invoiceType?: Maybe<Scalars['String']>;
}

/** A condition to be used against `Invoice` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface InvoiceCondition {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dateOfItem` field. */
  dateOfItem?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invoiceType` field. */
  invoiceType?: Maybe<Scalars['String']>;
}

/** A filter to be used against `Invoice` object types. All fields are combined with a logical ‘and.’ */
export interface InvoiceFilter {
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `dateOfItem` field. */
  dateOfItem?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `invoiceType` field. */
  invoiceType?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InvoiceFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InvoiceFilter>>;
  /** Negates the expression. */
  not?: Maybe<InvoiceFilter>;
}

/** A connection to a list of `Invoice` values. */
export interface InvoicesConnection {
  __typename?: 'InvoicesConnection';
  /** A list of `Invoice` objects. */
  nodes: Array<Invoice>;
  /** A list of edges which contains the `Invoice` and cursor to aid in pagination. */
  edges: Array<InvoicesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invoice` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Invoice` edge in the connection. */
export interface InvoicesEdge {
  __typename?: 'InvoicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Invoice` at the end of the edge. */
  node: Invoice;
}

/** Methods to use when ordering `Invoice`. */
export enum InvoicesOrderBy {
  Natural = 'NATURAL',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  DateOfItemAsc = 'DATE_OF_ITEM_ASC',
  DateOfItemDesc = 'DATE_OF_ITEM_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  InvoiceTypeAsc = 'INVOICE_TYPE_ASC',
  InvoiceTypeDesc = 'INVOICE_TYPE_DESC'
}

export interface Involvement extends Node {
  __typename?: 'Involvement';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  userId: Scalars['UUID'];
  caseId: Scalars['UUID'];
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist: Scalars['Boolean'];
  actsAsSupervisor: Scalars['Boolean'];
  actsAsPatient: Scalars['Boolean'];
  actsAsInterviewer: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  actsAsSupporter: Scalars['Boolean'];
  newMessagesAfter: Scalars['Datetime'];
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
  /** Reads a single `User` that is related to this `Involvement`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Case` that is related to this `Involvement`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  interviewBookingsByCaseIdAndIntervieweeId: InterviewBookingsConnection;
}


export type InvolvementInterviewBookingsByCaseIdAndIntervieweeIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};

/**
 * A condition to be used against `Involvement` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface InvolvementCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userAlias` field. */
  userAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseAlias` field. */
  caseAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `Involvement` object types. All fields are combined with a logical ‘and.’ */
export interface InvolvementFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `userAlias` field. */
  userAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `caseAlias` field. */
  caseAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<BooleanFilter>;
  /** Filter by the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InvolvementFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InvolvementFilter>>;
  /** Negates the expression. */
  not?: Maybe<InvolvementFilter>;
}

/** An input for mutations affecting `Involvement` */
export interface InvolvementInput {
  id?: Maybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  caseId: Scalars['UUID'];
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `Involvement`. Fields that are set will be updated. */
export interface InvolvementPatch {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `Involvement` values. */
export interface InvolvementsConnection {
  __typename?: 'InvolvementsConnection';
  /** A list of `Involvement` objects. */
  nodes: Array<Involvement>;
  /** A list of edges which contains the `Involvement` and cursor to aid in pagination. */
  edges: Array<InvolvementsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Involvement` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Involvement` edge in the connection. */
export interface InvolvementsEdge {
  __typename?: 'InvolvementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Involvement` at the end of the edge. */
  node: Involvement;
}

export interface InvolvementsInMyCase {
  __typename?: 'InvolvementsInMyCase';
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `InvolvementsInMyCase` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface InvolvementsInMyCaseCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userAlias` field. */
  userAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseAlias` field. */
  caseAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `InvolvementsInMyCase` object types. All fields are combined with a logical ‘and.’ */
export interface InvolvementsInMyCaseFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `userAlias` field. */
  userAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `caseAlias` field. */
  caseAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<BooleanFilter>;
  /** Filter by the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<InvolvementsInMyCaseFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<InvolvementsInMyCaseFilter>>;
  /** Negates the expression. */
  not?: Maybe<InvolvementsInMyCaseFilter>;
}

/** An input for mutations affecting `InvolvementsInMyCase` */
export interface InvolvementsInMyCaseInput {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `InvolvementsInMyCase` values. */
export interface InvolvementsInMyCasesConnection {
  __typename?: 'InvolvementsInMyCasesConnection';
  /** A list of `InvolvementsInMyCase` objects. */
  nodes: Array<InvolvementsInMyCase>;
  /** A list of edges which contains the `InvolvementsInMyCase` and cursor to aid in pagination. */
  edges: Array<InvolvementsInMyCasesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InvolvementsInMyCase` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `InvolvementsInMyCase` edge in the connection. */
export interface InvolvementsInMyCasesEdge {
  __typename?: 'InvolvementsInMyCasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InvolvementsInMyCase` at the end of the edge. */
  node: InvolvementsInMyCase;
}

/** Methods to use when ordering `InvolvementsInMyCase`. */
export enum InvolvementsInMyCasesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  UserAliasAsc = 'USER_ALIAS_ASC',
  UserAliasDesc = 'USER_ALIAS_DESC',
  CaseAliasAsc = 'CASE_ALIAS_ASC',
  CaseAliasDesc = 'CASE_ALIAS_DESC',
  ActsAsTherapistAsc = 'ACTS_AS_THERAPIST_ASC',
  ActsAsTherapistDesc = 'ACTS_AS_THERAPIST_DESC',
  ActsAsSupervisorAsc = 'ACTS_AS_SUPERVISOR_ASC',
  ActsAsSupervisorDesc = 'ACTS_AS_SUPERVISOR_DESC',
  ActsAsPatientAsc = 'ACTS_AS_PATIENT_ASC',
  ActsAsPatientDesc = 'ACTS_AS_PATIENT_DESC',
  ActsAsInterviewerAsc = 'ACTS_AS_INTERVIEWER_ASC',
  ActsAsInterviewerDesc = 'ACTS_AS_INTERVIEWER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ActsAsSupporterAsc = 'ACTS_AS_SUPPORTER_ASC',
  ActsAsSupporterDesc = 'ACTS_AS_SUPPORTER_DESC',
  NewMessagesAfterAsc = 'NEW_MESSAGES_AFTER_ASC',
  NewMessagesAfterDesc = 'NEW_MESSAGES_AFTER_DESC',
  ActsAsCounselorAsc = 'ACTS_AS_COUNSELOR_ASC',
  ActsAsCounselorDesc = 'ACTS_AS_COUNSELOR_DESC'
}

/** Methods to use when ordering `Involvement`. */
export enum InvolvementsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  UserAliasAsc = 'USER_ALIAS_ASC',
  UserAliasDesc = 'USER_ALIAS_DESC',
  CaseAliasAsc = 'CASE_ALIAS_ASC',
  CaseAliasDesc = 'CASE_ALIAS_DESC',
  ActsAsTherapistAsc = 'ACTS_AS_THERAPIST_ASC',
  ActsAsTherapistDesc = 'ACTS_AS_THERAPIST_DESC',
  ActsAsSupervisorAsc = 'ACTS_AS_SUPERVISOR_ASC',
  ActsAsSupervisorDesc = 'ACTS_AS_SUPERVISOR_DESC',
  ActsAsPatientAsc = 'ACTS_AS_PATIENT_ASC',
  ActsAsPatientDesc = 'ACTS_AS_PATIENT_DESC',
  ActsAsInterviewerAsc = 'ACTS_AS_INTERVIEWER_ASC',
  ActsAsInterviewerDesc = 'ACTS_AS_INTERVIEWER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ActsAsSupporterAsc = 'ACTS_AS_SUPPORTER_ASC',
  ActsAsSupporterDesc = 'ACTS_AS_SUPPORTER_DESC',
  NewMessagesAfterAsc = 'NEW_MESSAGES_AFTER_ASC',
  NewMessagesAfterDesc = 'NEW_MESSAGES_AFTER_DESC',
  FavoriteMessageAsc = 'FAVORITE_MESSAGE_ASC',
  FavoriteMessageDesc = 'FAVORITE_MESSAGE_DESC',
  ActsAsCounselorAsc = 'ACTS_AS_COUNSELOR_ASC',
  ActsAsCounselorDesc = 'ACTS_AS_COUNSELOR_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface IptConflict extends Node {
  __typename?: 'IptConflict';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  conflict?: Maybe<Scalars['String']>;
  needOrAim?: Maybe<Scalars['String']>;
  importanceOfNeedOrAim?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Case` that is related to this `IptConflict`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptConflict`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `IptConflict` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface IptConflictCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `conflict` field. */
  conflict?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `needOrAim` field. */
  needOrAim?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `importanceOfNeedOrAim` field. */
  importanceOfNeedOrAim?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `IptConflict` object types. All fields are combined with a logical ‘and.’ */
export interface IptConflictFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `conflict` field. */
  conflict?: Maybe<StringFilter>;
  /** Filter by the object’s `needOrAim` field. */
  needOrAim?: Maybe<StringFilter>;
  /** Filter by the object’s `importanceOfNeedOrAim` field. */
  importanceOfNeedOrAim?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<IptConflictFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<IptConflictFilter>>;
  /** Negates the expression. */
  not?: Maybe<IptConflictFilter>;
}

/** An input for mutations affecting `IptConflict` */
export interface IptConflictInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  conflict?: Maybe<Scalars['String']>;
  needOrAim?: Maybe<Scalars['String']>;
  importanceOfNeedOrAim?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `IptConflict`. Fields that are set will be updated. */
export interface IptConflictPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  conflict?: Maybe<Scalars['String']>;
  needOrAim?: Maybe<Scalars['String']>;
  importanceOfNeedOrAim?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `IptConflict` values. */
export interface IptConflictsConnection {
  __typename?: 'IptConflictsConnection';
  /** A list of `IptConflict` objects. */
  nodes: Array<IptConflict>;
  /** A list of edges which contains the `IptConflict` and cursor to aid in pagination. */
  edges: Array<IptConflictsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IptConflict` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `IptConflict` edge in the connection. */
export interface IptConflictsEdge {
  __typename?: 'IptConflictsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IptConflict` at the end of the edge. */
  node: IptConflict;
}

/** Methods to use when ordering `IptConflict`. */
export enum IptConflictsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  ConflictAsc = 'CONFLICT_ASC',
  ConflictDesc = 'CONFLICT_DESC',
  NeedOrAimAsc = 'NEED_OR_AIM_ASC',
  NeedOrAimDesc = 'NEED_OR_AIM_DESC',
  ImportanceOfNeedOrAimAsc = 'IMPORTANCE_OF_NEED_OR_AIM_ASC',
  ImportanceOfNeedOrAimDesc = 'IMPORTANCE_OF_NEED_OR_AIM_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface IptRelationship extends Node {
  __typename?: 'IptRelationship';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  needOrExpectation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Case` that is related to this `IptRelationship`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptRelationship`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `IptRelationship` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface IptRelationshipCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `needOrExpectation` field. */
  needOrExpectation?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `barrier` field. */
  barrier?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `IptRelationship` object types. All fields are combined with a logical ‘and.’ */
export interface IptRelationshipFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `needOrExpectation` field. */
  needOrExpectation?: Maybe<StringFilter>;
  /** Filter by the object’s `barrier` field. */
  barrier?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<IptRelationshipFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<IptRelationshipFilter>>;
  /** Negates the expression. */
  not?: Maybe<IptRelationshipFilter>;
}

/** An input for mutations affecting `IptRelationship` */
export interface IptRelationshipInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  needOrExpectation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `IptRelationship`. Fields that are set will be updated. */
export interface IptRelationshipPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  needOrExpectation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `IptRelationship` values. */
export interface IptRelationshipsConnection {
  __typename?: 'IptRelationshipsConnection';
  /** A list of `IptRelationship` objects. */
  nodes: Array<IptRelationship>;
  /** A list of edges which contains the `IptRelationship` and cursor to aid in pagination. */
  edges: Array<IptRelationshipsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IptRelationship` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `IptRelationship` edge in the connection. */
export interface IptRelationshipsEdge {
  __typename?: 'IptRelationshipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IptRelationship` at the end of the edge. */
  node: IptRelationship;
}

/** Methods to use when ordering `IptRelationship`. */
export enum IptRelationshipsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  NeedOrExpectationAsc = 'NEED_OR_EXPECTATION_ASC',
  NeedOrExpectationDesc = 'NEED_OR_EXPECTATION_DESC',
  BarrierAsc = 'BARRIER_ASC',
  BarrierDesc = 'BARRIER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface IptSituation extends Node {
  __typename?: 'IptSituation';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  situation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  alternativeStrategy?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Case` that is related to this `IptSituation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptSituation`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `IptSituation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface IptSituationCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `situation` field. */
  situation?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `barrier` field. */
  barrier?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alternativeStrategy` field. */
  alternativeStrategy?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `result` field. */
  result?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `IptSituation` object types. All fields are combined with a logical ‘and.’ */
export interface IptSituationFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `situation` field. */
  situation?: Maybe<StringFilter>;
  /** Filter by the object’s `barrier` field. */
  barrier?: Maybe<StringFilter>;
  /** Filter by the object’s `alternativeStrategy` field. */
  alternativeStrategy?: Maybe<StringFilter>;
  /** Filter by the object’s `result` field. */
  result?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<IptSituationFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<IptSituationFilter>>;
  /** Negates the expression. */
  not?: Maybe<IptSituationFilter>;
}

/** An input for mutations affecting `IptSituation` */
export interface IptSituationInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  situation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  alternativeStrategy?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `IptSituation`. Fields that are set will be updated. */
export interface IptSituationPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  situation?: Maybe<Scalars['String']>;
  barrier?: Maybe<Scalars['String']>;
  alternativeStrategy?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `IptSituation` values. */
export interface IptSituationsConnection {
  __typename?: 'IptSituationsConnection';
  /** A list of `IptSituation` objects. */
  nodes: Array<IptSituation>;
  /** A list of edges which contains the `IptSituation` and cursor to aid in pagination. */
  edges: Array<IptSituationsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IptSituation` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `IptSituation` edge in the connection. */
export interface IptSituationsEdge {
  __typename?: 'IptSituationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IptSituation` at the end of the edge. */
  node: IptSituation;
}

/** Methods to use when ordering `IptSituation`. */
export enum IptSituationsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  SituationAsc = 'SITUATION_ASC',
  SituationDesc = 'SITUATION_DESC',
  BarrierAsc = 'BARRIER_ASC',
  BarrierDesc = 'BARRIER_DESC',
  AlternativeStrategyAsc = 'ALTERNATIVE_STRATEGY_ASC',
  AlternativeStrategyDesc = 'ALTERNATIVE_STRATEGY_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Itq extends Node {
  __typename?: 'Itq';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  itemP1: Scalars['Int'];
  itemP2: Scalars['Int'];
  itemP3: Scalars['Int'];
  itemP4: Scalars['Int'];
  itemP5: Scalars['Int'];
  itemP6: Scalars['Int'];
  itemP7: Scalars['Int'];
  itemP8: Scalars['Int'];
  itemP9: Scalars['Int'];
  itemC1: Scalars['Int'];
  itemC2: Scalars['Int'];
  itemC3: Scalars['Int'];
  itemC4: Scalars['Int'];
  itemC5: Scalars['Int'];
  itemC6: Scalars['Int'];
  itemC7: Scalars['Int'];
  itemC8: Scalars['Int'];
  itemC9: Scalars['Int'];
  scoreReexperience: Scalars['Int'];
  scoreAvoidance: Scalars['Int'];
  scoreThreat: Scalars['Int'];
  scoreAffdys: Scalars['Int'];
  scoreNegative: Scalars['Int'];
  scoreDisturbances: Scalars['Int'];
  scorePtsd: Scalars['Int'];
  scoreDso: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Itq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Itq`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Itq` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface ItqCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `itemP1` field. */
  itemP1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP2` field. */
  itemP2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP3` field. */
  itemP3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP4` field. */
  itemP4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP5` field. */
  itemP5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP6` field. */
  itemP6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP7` field. */
  itemP7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP8` field. */
  itemP8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemP9` field. */
  itemP9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC1` field. */
  itemC1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC2` field. */
  itemC2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC3` field. */
  itemC3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC4` field. */
  itemC4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC5` field. */
  itemC5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC6` field. */
  itemC6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC7` field. */
  itemC7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC8` field. */
  itemC8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemC9` field. */
  itemC9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreReexperience` field. */
  scoreReexperience?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreAvoidance` field. */
  scoreAvoidance?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreThreat` field. */
  scoreThreat?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreAffdys` field. */
  scoreAffdys?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreNegative` field. */
  scoreNegative?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreDisturbances` field. */
  scoreDisturbances?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scorePtsd` field. */
  scorePtsd?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreDso` field. */
  scoreDso?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Itq` object types. All fields are combined with a logical ‘and.’ */
export interface ItqFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `itemP1` field. */
  itemP1?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP2` field. */
  itemP2?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP3` field. */
  itemP3?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP4` field. */
  itemP4?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP5` field. */
  itemP5?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP6` field. */
  itemP6?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP7` field. */
  itemP7?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP8` field. */
  itemP8?: Maybe<IntFilter>;
  /** Filter by the object’s `itemP9` field. */
  itemP9?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC1` field. */
  itemC1?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC2` field. */
  itemC2?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC3` field. */
  itemC3?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC4` field. */
  itemC4?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC5` field. */
  itemC5?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC6` field. */
  itemC6?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC7` field. */
  itemC7?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC8` field. */
  itemC8?: Maybe<IntFilter>;
  /** Filter by the object’s `itemC9` field. */
  itemC9?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreReexperience` field. */
  scoreReexperience?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreAvoidance` field. */
  scoreAvoidance?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreThreat` field. */
  scoreThreat?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreAffdys` field. */
  scoreAffdys?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreNegative` field. */
  scoreNegative?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreDisturbances` field. */
  scoreDisturbances?: Maybe<IntFilter>;
  /** Filter by the object’s `scorePtsd` field. */
  scorePtsd?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreDso` field. */
  scoreDso?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ItqFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ItqFilter>>;
  /** Negates the expression. */
  not?: Maybe<ItqFilter>;
}

/** An input for mutations affecting `Itq` */
export interface ItqInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  itemP1: Scalars['Int'];
  itemP2: Scalars['Int'];
  itemP3: Scalars['Int'];
  itemP4: Scalars['Int'];
  itemP5: Scalars['Int'];
  itemP6: Scalars['Int'];
  itemP7: Scalars['Int'];
  itemP8: Scalars['Int'];
  itemP9: Scalars['Int'];
  itemC1: Scalars['Int'];
  itemC2: Scalars['Int'];
  itemC3: Scalars['Int'];
  itemC4: Scalars['Int'];
  itemC5: Scalars['Int'];
  itemC6: Scalars['Int'];
  itemC7: Scalars['Int'];
  itemC8: Scalars['Int'];
  itemC9: Scalars['Int'];
  scoreReexperience: Scalars['Int'];
  scoreAvoidance: Scalars['Int'];
  scoreThreat: Scalars['Int'];
  scoreAffdys: Scalars['Int'];
  scoreNegative: Scalars['Int'];
  scoreDisturbances: Scalars['Int'];
  scorePtsd: Scalars['Int'];
  scoreDso: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Itq`. Fields that are set will be updated. */
export interface ItqPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  itemP1?: Maybe<Scalars['Int']>;
  itemP2?: Maybe<Scalars['Int']>;
  itemP3?: Maybe<Scalars['Int']>;
  itemP4?: Maybe<Scalars['Int']>;
  itemP5?: Maybe<Scalars['Int']>;
  itemP6?: Maybe<Scalars['Int']>;
  itemP7?: Maybe<Scalars['Int']>;
  itemP8?: Maybe<Scalars['Int']>;
  itemP9?: Maybe<Scalars['Int']>;
  itemC1?: Maybe<Scalars['Int']>;
  itemC2?: Maybe<Scalars['Int']>;
  itemC3?: Maybe<Scalars['Int']>;
  itemC4?: Maybe<Scalars['Int']>;
  itemC5?: Maybe<Scalars['Int']>;
  itemC6?: Maybe<Scalars['Int']>;
  itemC7?: Maybe<Scalars['Int']>;
  itemC8?: Maybe<Scalars['Int']>;
  itemC9?: Maybe<Scalars['Int']>;
  scoreReexperience?: Maybe<Scalars['Int']>;
  scoreAvoidance?: Maybe<Scalars['Int']>;
  scoreThreat?: Maybe<Scalars['Int']>;
  scoreAffdys?: Maybe<Scalars['Int']>;
  scoreNegative?: Maybe<Scalars['Int']>;
  scoreDisturbances?: Maybe<Scalars['Int']>;
  scorePtsd?: Maybe<Scalars['Int']>;
  scoreDso?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Itq` values. */
export interface ItqsConnection {
  __typename?: 'ItqsConnection';
  /** A list of `Itq` objects. */
  nodes: Array<Itq>;
  /** A list of edges which contains the `Itq` and cursor to aid in pagination. */
  edges: Array<ItqsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Itq` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Itq` edge in the connection. */
export interface ItqsEdge {
  __typename?: 'ItqsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Itq` at the end of the edge. */
  node: Itq;
}

/** Methods to use when ordering `Itq`. */
export enum ItqsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  ItemP1Asc = 'ITEM_P1_ASC',
  ItemP1Desc = 'ITEM_P1_DESC',
  ItemP2Asc = 'ITEM_P2_ASC',
  ItemP2Desc = 'ITEM_P2_DESC',
  ItemP3Asc = 'ITEM_P3_ASC',
  ItemP3Desc = 'ITEM_P3_DESC',
  ItemP4Asc = 'ITEM_P4_ASC',
  ItemP4Desc = 'ITEM_P4_DESC',
  ItemP5Asc = 'ITEM_P5_ASC',
  ItemP5Desc = 'ITEM_P5_DESC',
  ItemP6Asc = 'ITEM_P6_ASC',
  ItemP6Desc = 'ITEM_P6_DESC',
  ItemP7Asc = 'ITEM_P7_ASC',
  ItemP7Desc = 'ITEM_P7_DESC',
  ItemP8Asc = 'ITEM_P8_ASC',
  ItemP8Desc = 'ITEM_P8_DESC',
  ItemP9Asc = 'ITEM_P9_ASC',
  ItemP9Desc = 'ITEM_P9_DESC',
  ItemC1Asc = 'ITEM_C1_ASC',
  ItemC1Desc = 'ITEM_C1_DESC',
  ItemC2Asc = 'ITEM_C2_ASC',
  ItemC2Desc = 'ITEM_C2_DESC',
  ItemC3Asc = 'ITEM_C3_ASC',
  ItemC3Desc = 'ITEM_C3_DESC',
  ItemC4Asc = 'ITEM_C4_ASC',
  ItemC4Desc = 'ITEM_C4_DESC',
  ItemC5Asc = 'ITEM_C5_ASC',
  ItemC5Desc = 'ITEM_C5_DESC',
  ItemC6Asc = 'ITEM_C6_ASC',
  ItemC6Desc = 'ITEM_C6_DESC',
  ItemC7Asc = 'ITEM_C7_ASC',
  ItemC7Desc = 'ITEM_C7_DESC',
  ItemC8Asc = 'ITEM_C8_ASC',
  ItemC8Desc = 'ITEM_C8_DESC',
  ItemC9Asc = 'ITEM_C9_ASC',
  ItemC9Desc = 'ITEM_C9_DESC',
  ScoreReexperienceAsc = 'SCORE_REEXPERIENCE_ASC',
  ScoreReexperienceDesc = 'SCORE_REEXPERIENCE_DESC',
  ScoreAvoidanceAsc = 'SCORE_AVOIDANCE_ASC',
  ScoreAvoidanceDesc = 'SCORE_AVOIDANCE_DESC',
  ScoreThreatAsc = 'SCORE_THREAT_ASC',
  ScoreThreatDesc = 'SCORE_THREAT_DESC',
  ScoreAffdysAsc = 'SCORE_AFFDYS_ASC',
  ScoreAffdysDesc = 'SCORE_AFFDYS_DESC',
  ScoreNegativeAsc = 'SCORE_NEGATIVE_ASC',
  ScoreNegativeDesc = 'SCORE_NEGATIVE_DESC',
  ScoreDisturbancesAsc = 'SCORE_DISTURBANCES_ASC',
  ScoreDisturbancesDesc = 'SCORE_DISTURBANCES_DESC',
  ScorePtsdAsc = 'SCORE_PTSD_ASC',
  ScorePtsdDesc = 'SCORE_PTSD_DESC',
  ScoreDsoAsc = 'SCORE_DSO_ASC',
  ScoreDsoDesc = 'SCORE_DSO_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}


/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export interface JsonFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['JSON']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['JSON']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['JSON']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: Maybe<Scalars['JSON']>;
  /** Contains the specified key. */
  containsKey?: Maybe<Scalars['String']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: Maybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: Maybe<Array<Scalars['String']>>;
  /** Contained by the specified JSON. */
  containedBy?: Maybe<Scalars['JSON']>;
}

export interface Lec5 extends Node {
  __typename?: 'Lec5';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  worstEvent: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  timeSinceItHappened: Scalars['Int'];
  toWhomItHappened?: Maybe<Scalars['Int']>;
  dangerOfDeath: Scalars['Int'];
  seriousInjury: Scalars['Int'];
  sexualViolence: Scalars['Boolean'];
  closePersons: Scalars['Int'];
  numberOfComparableEvents: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  itqTimeSinceItHappened: Scalars['Int'];
  timeSelection: Scalars['Int'];
  /** Reads a single `Case` that is related to this `Lec5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lec5`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Lec5` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Lec5Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `worstEvent` field. */
  worstEvent?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `timeSinceItHappened` field. */
  timeSinceItHappened?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `toWhomItHappened` field. */
  toWhomItHappened?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `dangerOfDeath` field. */
  dangerOfDeath?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `seriousInjury` field. */
  seriousInjury?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sexualViolence` field. */
  sexualViolence?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `closePersons` field. */
  closePersons?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `numberOfComparableEvents` field. */
  numberOfComparableEvents?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `itqTimeSinceItHappened` field. */
  itqTimeSinceItHappened?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `timeSelection` field. */
  timeSelection?: Maybe<Scalars['Int']>;
}

/** A filter to be used against `Lec5` object types. All fields are combined with a logical ‘and.’ */
export interface Lec5Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `worstEvent` field. */
  worstEvent?: Maybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `timeSinceItHappened` field. */
  timeSinceItHappened?: Maybe<IntFilter>;
  /** Filter by the object’s `toWhomItHappened` field. */
  toWhomItHappened?: Maybe<IntFilter>;
  /** Filter by the object’s `dangerOfDeath` field. */
  dangerOfDeath?: Maybe<IntFilter>;
  /** Filter by the object’s `seriousInjury` field. */
  seriousInjury?: Maybe<IntFilter>;
  /** Filter by the object’s `sexualViolence` field. */
  sexualViolence?: Maybe<BooleanFilter>;
  /** Filter by the object’s `closePersons` field. */
  closePersons?: Maybe<IntFilter>;
  /** Filter by the object’s `numberOfComparableEvents` field. */
  numberOfComparableEvents?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `itqTimeSinceItHappened` field. */
  itqTimeSinceItHappened?: Maybe<IntFilter>;
  /** Filter by the object’s `timeSelection` field. */
  timeSelection?: Maybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Lec5Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Lec5Filter>>;
  /** Negates the expression. */
  not?: Maybe<Lec5Filter>;
}

/** An input for mutations affecting `Lec5` */
export interface Lec5Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  worstEvent: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  timeSinceItHappened: Scalars['Int'];
  toWhomItHappened?: Maybe<Scalars['Int']>;
  dangerOfDeath: Scalars['Int'];
  seriousInjury: Scalars['Int'];
  sexualViolence: Scalars['Boolean'];
  closePersons: Scalars['Int'];
  numberOfComparableEvents: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  itqTimeSinceItHappened?: Maybe<Scalars['Int']>;
  timeSelection?: Maybe<Scalars['Int']>;
}

/** Represents an update to a `Lec5`. Fields that are set will be updated. */
export interface Lec5Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  worstEvent?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  timeSinceItHappened?: Maybe<Scalars['Int']>;
  toWhomItHappened?: Maybe<Scalars['Int']>;
  dangerOfDeath?: Maybe<Scalars['Int']>;
  seriousInjury?: Maybe<Scalars['Int']>;
  sexualViolence?: Maybe<Scalars['Boolean']>;
  closePersons?: Maybe<Scalars['Int']>;
  numberOfComparableEvents?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  itqTimeSinceItHappened?: Maybe<Scalars['Int']>;
  timeSelection?: Maybe<Scalars['Int']>;
}

/** A connection to a list of `Lec5` values. */
export interface Lec5SConnection {
  __typename?: 'Lec5SConnection';
  /** A list of `Lec5` objects. */
  nodes: Array<Lec5>;
  /** A list of edges which contains the `Lec5` and cursor to aid in pagination. */
  edges: Array<Lec5SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lec5` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Lec5` edge in the connection. */
export interface Lec5SEdge {
  __typename?: 'Lec5SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Lec5` at the end of the edge. */
  node: Lec5;
}

/** Methods to use when ordering `Lec5`. */
export enum Lec5SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  WorstEventAsc = 'WORST_EVENT_ASC',
  WorstEventDesc = 'WORST_EVENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  TimeSinceItHappenedAsc = 'TIME_SINCE_IT_HAPPENED_ASC',
  TimeSinceItHappenedDesc = 'TIME_SINCE_IT_HAPPENED_DESC',
  ToWhomItHappenedAsc = 'TO_WHOM_IT_HAPPENED_ASC',
  ToWhomItHappenedDesc = 'TO_WHOM_IT_HAPPENED_DESC',
  DangerOfDeathAsc = 'DANGER_OF_DEATH_ASC',
  DangerOfDeathDesc = 'DANGER_OF_DEATH_DESC',
  SeriousInjuryAsc = 'SERIOUS_INJURY_ASC',
  SeriousInjuryDesc = 'SERIOUS_INJURY_DESC',
  SexualViolenceAsc = 'SEXUAL_VIOLENCE_ASC',
  SexualViolenceDesc = 'SEXUAL_VIOLENCE_DESC',
  ClosePersonsAsc = 'CLOSE_PERSONS_ASC',
  ClosePersonsDesc = 'CLOSE_PERSONS_DESC',
  NumberOfComparableEventsAsc = 'NUMBER_OF_COMPARABLE_EVENTS_ASC',
  NumberOfComparableEventsDesc = 'NUMBER_OF_COMPARABLE_EVENTS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ItqTimeSinceItHappenedAsc = 'ITQ_TIME_SINCE_IT_HAPPENED_ASC',
  ItqTimeSinceItHappenedDesc = 'ITQ_TIME_SINCE_IT_HAPPENED_DESC',
  TimeSelectionAsc = 'TIME_SELECTION_ASC',
  TimeSelectionDesc = 'TIME_SELECTION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Letter extends Node {
  __typename?: 'Letter';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  senderId: Scalars['UUID'];
  code: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  format: Scalars['String'];
  /** Reads a single `Case` that is related to this `Letter`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Letter`. */
  userBySenderId?: Maybe<User>;
}

/** A condition to be used against `Letter` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface LetterCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `body` field. */
  body?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `publishedAt` field. */
  publishedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `format` field. */
  format?: Maybe<Scalars['String']>;
}

/** A filter to be used against `Letter` object types. All fields are combined with a logical ‘and.’ */
export interface LetterFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `senderId` field. */
  senderId?: Maybe<UuidFilter>;
  /** Filter by the object’s `code` field. */
  code?: Maybe<StringFilter>;
  /** Filter by the object’s `body` field. */
  body?: Maybe<StringFilter>;
  /** Filter by the object’s `publishedAt` field. */
  publishedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `format` field. */
  format?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<LetterFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<LetterFilter>>;
  /** Negates the expression. */
  not?: Maybe<LetterFilter>;
}

export interface LetterinfoByUser {
  __typename?: 'LetterinfoByUser';
  startdate?: Maybe<Scalars['Datetime']>;
  enddate?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  patientName?: Maybe<Scalars['String']>;
  patientAlias?: Maybe<Scalars['String']>;
  therapistId?: Maybe<Scalars['UUID']>;
  therapistName?: Maybe<Scalars['String']>;
  therapistAlias?: Maybe<Scalars['String']>;
  monat?: Maybe<Scalars['Float']>;
  jahr?: Maybe<Scalars['Float']>;
  hastakenplace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledByTherapist?: Maybe<Scalars['Boolean']>;
  canceledShortTerm?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `LetterinfoByUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface LetterinfoByUserCondition {
  /** Checks for equality with the object’s `startdate` field. */
  startdate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `enddate` field. */
  enddate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `patientName` field. */
  patientName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAlias` field. */
  patientAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `therapistId` field. */
  therapistId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `therapistName` field. */
  therapistName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `therapistAlias` field. */
  therapistAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `monat` field. */
  monat?: Maybe<Scalars['Float']>;
  /** Checks for equality with the object’s `jahr` field. */
  jahr?: Maybe<Scalars['Float']>;
  /** Checks for equality with the object’s `hastakenplace` field. */
  hastakenplace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledByTherapist` field. */
  canceledByTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledShortTerm` field. */
  canceledShortTerm?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `LetterinfoByUser` object types. All fields are combined with a logical ‘and.’ */
export interface LetterinfoByUserFilter {
  /** Filter by the object’s `startdate` field. */
  startdate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `enddate` field. */
  enddate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `code` field. */
  code?: Maybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: Maybe<StringFilter>;
  /** Filter by the object’s `patientId` field. */
  patientId?: Maybe<UuidFilter>;
  /** Filter by the object’s `patientName` field. */
  patientName?: Maybe<StringFilter>;
  /** Filter by the object’s `patientAlias` field. */
  patientAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `therapistId` field. */
  therapistId?: Maybe<UuidFilter>;
  /** Filter by the object’s `therapistName` field. */
  therapistName?: Maybe<StringFilter>;
  /** Filter by the object’s `therapistAlias` field. */
  therapistAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `monat` field. */
  monat?: Maybe<FloatFilter>;
  /** Filter by the object’s `jahr` field. */
  jahr?: Maybe<FloatFilter>;
  /** Filter by the object’s `hastakenplace` field. */
  hastakenplace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledByTherapist` field. */
  canceledByTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledShortTerm` field. */
  canceledShortTerm?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<LetterinfoByUserFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<LetterinfoByUserFilter>>;
  /** Negates the expression. */
  not?: Maybe<LetterinfoByUserFilter>;
}

/** A connection to a list of `LetterinfoByUser` values. */
export interface LetterinfoByUsersConnection {
  __typename?: 'LetterinfoByUsersConnection';
  /** A list of `LetterinfoByUser` objects. */
  nodes: Array<LetterinfoByUser>;
  /** A list of edges which contains the `LetterinfoByUser` and cursor to aid in pagination. */
  edges: Array<LetterinfoByUsersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LetterinfoByUser` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `LetterinfoByUser` edge in the connection. */
export interface LetterinfoByUsersEdge {
  __typename?: 'LetterinfoByUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LetterinfoByUser` at the end of the edge. */
  node: LetterinfoByUser;
}

/** Methods to use when ordering `LetterinfoByUser`. */
export enum LetterinfoByUsersOrderBy {
  Natural = 'NATURAL',
  StartdateAsc = 'STARTDATE_ASC',
  StartdateDesc = 'STARTDATE_DESC',
  EnddateAsc = 'ENDDATE_ASC',
  EnddateDesc = 'ENDDATE_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PatientNameAsc = 'PATIENT_NAME_ASC',
  PatientNameDesc = 'PATIENT_NAME_DESC',
  PatientAliasAsc = 'PATIENT_ALIAS_ASC',
  PatientAliasDesc = 'PATIENT_ALIAS_DESC',
  TherapistIdAsc = 'THERAPIST_ID_ASC',
  TherapistIdDesc = 'THERAPIST_ID_DESC',
  TherapistNameAsc = 'THERAPIST_NAME_ASC',
  TherapistNameDesc = 'THERAPIST_NAME_DESC',
  TherapistAliasAsc = 'THERAPIST_ALIAS_ASC',
  TherapistAliasDesc = 'THERAPIST_ALIAS_DESC',
  MonatAsc = 'MONAT_ASC',
  MonatDesc = 'MONAT_DESC',
  JahrAsc = 'JAHR_ASC',
  JahrDesc = 'JAHR_DESC',
  HastakenplaceAsc = 'HASTAKENPLACE_ASC',
  HastakenplaceDesc = 'HASTAKENPLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledByTherapistAsc = 'CANCELED_BY_THERAPIST_ASC',
  CanceledByTherapistDesc = 'CANCELED_BY_THERAPIST_DESC',
  CanceledShortTermAsc = 'CANCELED_SHORT_TERM_ASC',
  CanceledShortTermDesc = 'CANCELED_SHORT_TERM_DESC'
}

/** An input for mutations affecting `Letter` */
export interface LetterInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  senderId: Scalars['UUID'];
  code: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  format?: Maybe<Scalars['String']>;
}

/** Represents an update to a `Letter`. Fields that are set will be updated. */
export interface LetterPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  senderId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  format?: Maybe<Scalars['String']>;
}

/** A connection to a list of `Letter` values. */
export interface LettersConnection {
  __typename?: 'LettersConnection';
  /** A list of `Letter` objects. */
  nodes: Array<Letter>;
  /** A list of edges which contains the `Letter` and cursor to aid in pagination. */
  edges: Array<LettersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Letter` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Letter` edge in the connection. */
export interface LettersEdge {
  __typename?: 'LettersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Letter` at the end of the edge. */
  node: Letter;
}

/** Methods to use when ordering `Letter`. */
export enum LettersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SenderIdAsc = 'SENDER_ID_ASC',
  SenderIdDesc = 'SENDER_ID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  FormatAsc = 'FORMAT_ASC',
  FormatDesc = 'FORMAT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface LetterTemplate extends Node {
  __typename?: 'LetterTemplate';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  editorId?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  content: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  treatmentCode?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  genderOfReader?: Maybe<Gender>;
  genderOfWriter?: Maybe<Gender>;
  type?: Maybe<TemplateType>;
  subject?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `LetterTemplate`. */
  userByEditorId?: Maybe<User>;
}

/**
 * A condition to be used against `LetterTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface LetterTemplateCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `editorId` field. */
  editorId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `content` field. */
  content?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `treatmentCode` field. */
  treatmentCode?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `languageCode` field. */
  languageCode?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `genderOfReader` field. */
  genderOfReader?: Maybe<Gender>;
  /** Checks for equality with the object’s `genderOfWriter` field. */
  genderOfWriter?: Maybe<Gender>;
  /** Checks for equality with the object’s `type` field. */
  type?: Maybe<TemplateType>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
}

/** A filter to be used against `LetterTemplate` object types. All fields are combined with a logical ‘and.’ */
export interface LetterTemplateFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `editorId` field. */
  editorId?: Maybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `content` field. */
  content?: Maybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `treatmentCode` field. */
  treatmentCode?: Maybe<StringFilter>;
  /** Filter by the object’s `languageCode` field. */
  languageCode?: Maybe<StringFilter>;
  /** Filter by the object’s `genderOfReader` field. */
  genderOfReader?: Maybe<GenderFilter>;
  /** Filter by the object’s `genderOfWriter` field. */
  genderOfWriter?: Maybe<GenderFilter>;
  /** Filter by the object’s `type` field. */
  type?: Maybe<TemplateTypeFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: Maybe<StringFilter>;
  /** Filter by the object’s `code` field. */
  code?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<LetterTemplateFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<LetterTemplateFilter>>;
  /** Negates the expression. */
  not?: Maybe<LetterTemplateFilter>;
}

/** An input for mutations affecting `LetterTemplate` */
export interface LetterTemplateInput {
  id?: Maybe<Scalars['UUID']>;
  editorId?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  content: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  treatmentCode?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  genderOfReader?: Maybe<Gender>;
  genderOfWriter?: Maybe<Gender>;
  type?: Maybe<TemplateType>;
  subject?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
}

/** Represents an update to a `LetterTemplate`. Fields that are set will be updated. */
export interface LetterTemplatePatch {
  id?: Maybe<Scalars['UUID']>;
  editorId?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  treatmentCode?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  genderOfReader?: Maybe<Gender>;
  genderOfWriter?: Maybe<Gender>;
  type?: Maybe<TemplateType>;
  subject?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
}

/** A connection to a list of `LetterTemplate` values. */
export interface LetterTemplatesConnection {
  __typename?: 'LetterTemplatesConnection';
  /** A list of `LetterTemplate` objects. */
  nodes: Array<LetterTemplate>;
  /** A list of edges which contains the `LetterTemplate` and cursor to aid in pagination. */
  edges: Array<LetterTemplatesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LetterTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `LetterTemplate` edge in the connection. */
export interface LetterTemplatesEdge {
  __typename?: 'LetterTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LetterTemplate` at the end of the edge. */
  node: LetterTemplate;
}

/** Methods to use when ordering `LetterTemplate`. */
export enum LetterTemplatesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  EditorIdAsc = 'EDITOR_ID_ASC',
  EditorIdDesc = 'EDITOR_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  TreatmentCodeAsc = 'TREATMENT_CODE_ASC',
  TreatmentCodeDesc = 'TREATMENT_CODE_DESC',
  LanguageCodeAsc = 'LANGUAGE_CODE_ASC',
  LanguageCodeDesc = 'LANGUAGE_CODE_DESC',
  GenderOfReaderAsc = 'GENDER_OF_READER_ASC',
  GenderOfReaderDesc = 'GENDER_OF_READER_DESC',
  GenderOfWriterAsc = 'GENDER_OF_WRITER_ASC',
  GenderOfWriterDesc = 'GENDER_OF_WRITER_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `lockSemaphore` mutation. */
export interface LockSemaphoreInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  lockKey?: Maybe<Scalars['String']>;
}

/** The output of our `lockSemaphore` mutation. */
export interface LockSemaphorePayload {
  __typename?: 'LockSemaphorePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  boolean?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

export interface LoginToken extends Node {
  __typename?: 'LoginToken';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  userId?: Maybe<Scalars['UUID']>;
  expirationDate?: Maybe<Scalars['Datetime']>;
  notBefore?: Maybe<Scalars['Datetime']>;
  otherPayload?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `LoginToken`. */
  userByUserId?: Maybe<User>;
}

/**
 * A condition to be used against `LoginToken` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface LoginTokenCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `expirationDate` field. */
  expirationDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `notBefore` field. */
  notBefore?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `otherPayload` field. */
  otherPayload?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `LoginToken` object types. All fields are combined with a logical ‘and.’ */
export interface LoginTokenFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `expirationDate` field. */
  expirationDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `notBefore` field. */
  notBefore?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `otherPayload` field. */
  otherPayload?: Maybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<LoginTokenFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<LoginTokenFilter>>;
  /** Negates the expression. */
  not?: Maybe<LoginTokenFilter>;
}

/** An input for mutations affecting `LoginToken` */
export interface LoginTokenInput {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  expirationDate?: Maybe<Scalars['Datetime']>;
  notBefore?: Maybe<Scalars['Datetime']>;
  otherPayload?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `LoginToken`. Fields that are set will be updated. */
export interface LoginTokenPatch {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  expirationDate?: Maybe<Scalars['Datetime']>;
  notBefore?: Maybe<Scalars['Datetime']>;
  otherPayload?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `LoginToken` values. */
export interface LoginTokensConnection {
  __typename?: 'LoginTokensConnection';
  /** A list of `LoginToken` objects. */
  nodes: Array<LoginToken>;
  /** A list of edges which contains the `LoginToken` and cursor to aid in pagination. */
  edges: Array<LoginTokensEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LoginToken` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `LoginToken` edge in the connection. */
export interface LoginTokensEdge {
  __typename?: 'LoginTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LoginToken` at the end of the edge. */
  node: LoginToken;
}

/** Methods to use when ordering `LoginToken`. */
export enum LoginTokensOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  NotBeforeAsc = 'NOT_BEFORE_ASC',
  NotBeforeDesc = 'NOT_BEFORE_DESC',
  OtherPayloadAsc = 'OTHER_PAYLOAD_ASC',
  OtherPayloadDesc = 'OTHER_PAYLOAD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Lsa extends Node {
  __typename?: 'Lsa';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1A: Scalars['Int'];
  item1B?: Maybe<Scalars['Int']>;
  item2A: Scalars['Int'];
  item2B?: Maybe<Scalars['Int']>;
  item3A: Scalars['Int'];
  item3B?: Maybe<Scalars['Int']>;
  item4A: Scalars['Int'];
  item4B?: Maybe<Scalars['Int']>;
  item5A: Scalars['Int'];
  item5B?: Maybe<Scalars['Int']>;
  item6A: Scalars['Int'];
  item6B?: Maybe<Scalars['Int']>;
  item7A: Scalars['Int'];
  item7B?: Maybe<Scalars['Int']>;
  item8A: Scalars['Int'];
  item8B?: Maybe<Scalars['Int']>;
  item9A: Scalars['Int'];
  item9B?: Maybe<Scalars['Int']>;
  item10A: Scalars['Int'];
  item10B?: Maybe<Scalars['Int']>;
  item11A: Scalars['Int'];
  item11B?: Maybe<Scalars['Int']>;
  item12A: Scalars['Int'];
  item12B?: Maybe<Scalars['Int']>;
  item13A: Scalars['Int'];
  item13B?: Maybe<Scalars['Int']>;
  item14A: Scalars['Int'];
  item14B?: Maybe<Scalars['Int']>;
  item15A: Scalars['Int'];
  item15B?: Maybe<Scalars['Int']>;
  item16A: Scalars['Int'];
  item16B?: Maybe<Scalars['Int']>;
  item17A: Scalars['Int'];
  item17B?: Maybe<Scalars['Int']>;
  item18A: Scalars['Int'];
  item18B?: Maybe<Scalars['Int']>;
  item19A: Scalars['Int'];
  item19B?: Maybe<Scalars['Int']>;
  item20A: Scalars['Int'];
  item20B?: Maybe<Scalars['Int']>;
  item21A: Scalars['Int'];
  item21B?: Maybe<Scalars['Int']>;
  item22A: Scalars['Int'];
  item22B?: Maybe<Scalars['Int']>;
  item23A: Scalars['Int'];
  item23B?: Maybe<Scalars['Int']>;
  item24A: Scalars['Int'];
  item24B?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Lsa`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lsa`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Lsa` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface LsaCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1A` field. */
  item1A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item1B` field. */
  item1B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2A` field. */
  item2A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2B` field. */
  item2B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3A` field. */
  item3A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3B` field. */
  item3B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4A` field. */
  item4A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4B` field. */
  item4B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5A` field. */
  item5A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5B` field. */
  item5B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6A` field. */
  item6A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6B` field. */
  item6B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7A` field. */
  item7A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7B` field. */
  item7B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8A` field. */
  item8A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8B` field. */
  item8B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9A` field. */
  item9A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9B` field. */
  item9B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10A` field. */
  item10A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10B` field. */
  item10B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11A` field. */
  item11A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11B` field. */
  item11B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12A` field. */
  item12A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12B` field. */
  item12B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13A` field. */
  item13A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13B` field. */
  item13B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14A` field. */
  item14A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14B` field. */
  item14B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15A` field. */
  item15A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15B` field. */
  item15B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16A` field. */
  item16A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16B` field. */
  item16B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17A` field. */
  item17A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17B` field. */
  item17B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18A` field. */
  item18A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18B` field. */
  item18B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19A` field. */
  item19A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19B` field. */
  item19B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20A` field. */
  item20A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20B` field. */
  item20B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21A` field. */
  item21A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21B` field. */
  item21B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item22A` field. */
  item22A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item22B` field. */
  item22B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item23A` field. */
  item23A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item23B` field. */
  item23B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item24A` field. */
  item24A?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item24B` field. */
  item24B?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Lsa` object types. All fields are combined with a logical ‘and.’ */
export interface LsaFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1A` field. */
  item1A?: Maybe<IntFilter>;
  /** Filter by the object’s `item1B` field. */
  item1B?: Maybe<IntFilter>;
  /** Filter by the object’s `item2A` field. */
  item2A?: Maybe<IntFilter>;
  /** Filter by the object’s `item2B` field. */
  item2B?: Maybe<IntFilter>;
  /** Filter by the object’s `item3A` field. */
  item3A?: Maybe<IntFilter>;
  /** Filter by the object’s `item3B` field. */
  item3B?: Maybe<IntFilter>;
  /** Filter by the object’s `item4A` field. */
  item4A?: Maybe<IntFilter>;
  /** Filter by the object’s `item4B` field. */
  item4B?: Maybe<IntFilter>;
  /** Filter by the object’s `item5A` field. */
  item5A?: Maybe<IntFilter>;
  /** Filter by the object’s `item5B` field. */
  item5B?: Maybe<IntFilter>;
  /** Filter by the object’s `item6A` field. */
  item6A?: Maybe<IntFilter>;
  /** Filter by the object’s `item6B` field. */
  item6B?: Maybe<IntFilter>;
  /** Filter by the object’s `item7A` field. */
  item7A?: Maybe<IntFilter>;
  /** Filter by the object’s `item7B` field. */
  item7B?: Maybe<IntFilter>;
  /** Filter by the object’s `item8A` field. */
  item8A?: Maybe<IntFilter>;
  /** Filter by the object’s `item8B` field. */
  item8B?: Maybe<IntFilter>;
  /** Filter by the object’s `item9A` field. */
  item9A?: Maybe<IntFilter>;
  /** Filter by the object’s `item9B` field. */
  item9B?: Maybe<IntFilter>;
  /** Filter by the object’s `item10A` field. */
  item10A?: Maybe<IntFilter>;
  /** Filter by the object’s `item10B` field. */
  item10B?: Maybe<IntFilter>;
  /** Filter by the object’s `item11A` field. */
  item11A?: Maybe<IntFilter>;
  /** Filter by the object’s `item11B` field. */
  item11B?: Maybe<IntFilter>;
  /** Filter by the object’s `item12A` field. */
  item12A?: Maybe<IntFilter>;
  /** Filter by the object’s `item12B` field. */
  item12B?: Maybe<IntFilter>;
  /** Filter by the object’s `item13A` field. */
  item13A?: Maybe<IntFilter>;
  /** Filter by the object’s `item13B` field. */
  item13B?: Maybe<IntFilter>;
  /** Filter by the object’s `item14A` field. */
  item14A?: Maybe<IntFilter>;
  /** Filter by the object’s `item14B` field. */
  item14B?: Maybe<IntFilter>;
  /** Filter by the object’s `item15A` field. */
  item15A?: Maybe<IntFilter>;
  /** Filter by the object’s `item15B` field. */
  item15B?: Maybe<IntFilter>;
  /** Filter by the object’s `item16A` field. */
  item16A?: Maybe<IntFilter>;
  /** Filter by the object’s `item16B` field. */
  item16B?: Maybe<IntFilter>;
  /** Filter by the object’s `item17A` field. */
  item17A?: Maybe<IntFilter>;
  /** Filter by the object’s `item17B` field. */
  item17B?: Maybe<IntFilter>;
  /** Filter by the object’s `item18A` field. */
  item18A?: Maybe<IntFilter>;
  /** Filter by the object’s `item18B` field. */
  item18B?: Maybe<IntFilter>;
  /** Filter by the object’s `item19A` field. */
  item19A?: Maybe<IntFilter>;
  /** Filter by the object’s `item19B` field. */
  item19B?: Maybe<IntFilter>;
  /** Filter by the object’s `item20A` field. */
  item20A?: Maybe<IntFilter>;
  /** Filter by the object’s `item20B` field. */
  item20B?: Maybe<IntFilter>;
  /** Filter by the object’s `item21A` field. */
  item21A?: Maybe<IntFilter>;
  /** Filter by the object’s `item21B` field. */
  item21B?: Maybe<IntFilter>;
  /** Filter by the object’s `item22A` field. */
  item22A?: Maybe<IntFilter>;
  /** Filter by the object’s `item22B` field. */
  item22B?: Maybe<IntFilter>;
  /** Filter by the object’s `item23A` field. */
  item23A?: Maybe<IntFilter>;
  /** Filter by the object’s `item23B` field. */
  item23B?: Maybe<IntFilter>;
  /** Filter by the object’s `item24A` field. */
  item24A?: Maybe<IntFilter>;
  /** Filter by the object’s `item24B` field. */
  item24B?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<LsaFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<LsaFilter>>;
  /** Negates the expression. */
  not?: Maybe<LsaFilter>;
}

/** An input for mutations affecting `Lsa` */
export interface LsaInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1A: Scalars['Int'];
  item1B?: Maybe<Scalars['Int']>;
  item2A: Scalars['Int'];
  item2B?: Maybe<Scalars['Int']>;
  item3A: Scalars['Int'];
  item3B?: Maybe<Scalars['Int']>;
  item4A: Scalars['Int'];
  item4B?: Maybe<Scalars['Int']>;
  item5A: Scalars['Int'];
  item5B?: Maybe<Scalars['Int']>;
  item6A: Scalars['Int'];
  item6B?: Maybe<Scalars['Int']>;
  item7A: Scalars['Int'];
  item7B?: Maybe<Scalars['Int']>;
  item8A: Scalars['Int'];
  item8B?: Maybe<Scalars['Int']>;
  item9A: Scalars['Int'];
  item9B?: Maybe<Scalars['Int']>;
  item10A: Scalars['Int'];
  item10B?: Maybe<Scalars['Int']>;
  item11A: Scalars['Int'];
  item11B?: Maybe<Scalars['Int']>;
  item12A: Scalars['Int'];
  item12B?: Maybe<Scalars['Int']>;
  item13A: Scalars['Int'];
  item13B?: Maybe<Scalars['Int']>;
  item14A: Scalars['Int'];
  item14B?: Maybe<Scalars['Int']>;
  item15A: Scalars['Int'];
  item15B?: Maybe<Scalars['Int']>;
  item16A: Scalars['Int'];
  item16B?: Maybe<Scalars['Int']>;
  item17A: Scalars['Int'];
  item17B?: Maybe<Scalars['Int']>;
  item18A: Scalars['Int'];
  item18B?: Maybe<Scalars['Int']>;
  item19A: Scalars['Int'];
  item19B?: Maybe<Scalars['Int']>;
  item20A: Scalars['Int'];
  item20B?: Maybe<Scalars['Int']>;
  item21A: Scalars['Int'];
  item21B?: Maybe<Scalars['Int']>;
  item22A: Scalars['Int'];
  item22B?: Maybe<Scalars['Int']>;
  item23A: Scalars['Int'];
  item23B?: Maybe<Scalars['Int']>;
  item24A: Scalars['Int'];
  item24B?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Lsa`. Fields that are set will be updated. */
export interface LsaPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1A?: Maybe<Scalars['Int']>;
  item1B?: Maybe<Scalars['Int']>;
  item2A?: Maybe<Scalars['Int']>;
  item2B?: Maybe<Scalars['Int']>;
  item3A?: Maybe<Scalars['Int']>;
  item3B?: Maybe<Scalars['Int']>;
  item4A?: Maybe<Scalars['Int']>;
  item4B?: Maybe<Scalars['Int']>;
  item5A?: Maybe<Scalars['Int']>;
  item5B?: Maybe<Scalars['Int']>;
  item6A?: Maybe<Scalars['Int']>;
  item6B?: Maybe<Scalars['Int']>;
  item7A?: Maybe<Scalars['Int']>;
  item7B?: Maybe<Scalars['Int']>;
  item8A?: Maybe<Scalars['Int']>;
  item8B?: Maybe<Scalars['Int']>;
  item9A?: Maybe<Scalars['Int']>;
  item9B?: Maybe<Scalars['Int']>;
  item10A?: Maybe<Scalars['Int']>;
  item10B?: Maybe<Scalars['Int']>;
  item11A?: Maybe<Scalars['Int']>;
  item11B?: Maybe<Scalars['Int']>;
  item12A?: Maybe<Scalars['Int']>;
  item12B?: Maybe<Scalars['Int']>;
  item13A?: Maybe<Scalars['Int']>;
  item13B?: Maybe<Scalars['Int']>;
  item14A?: Maybe<Scalars['Int']>;
  item14B?: Maybe<Scalars['Int']>;
  item15A?: Maybe<Scalars['Int']>;
  item15B?: Maybe<Scalars['Int']>;
  item16A?: Maybe<Scalars['Int']>;
  item16B?: Maybe<Scalars['Int']>;
  item17A?: Maybe<Scalars['Int']>;
  item17B?: Maybe<Scalars['Int']>;
  item18A?: Maybe<Scalars['Int']>;
  item18B?: Maybe<Scalars['Int']>;
  item19A?: Maybe<Scalars['Int']>;
  item19B?: Maybe<Scalars['Int']>;
  item20A?: Maybe<Scalars['Int']>;
  item20B?: Maybe<Scalars['Int']>;
  item21A?: Maybe<Scalars['Int']>;
  item21B?: Maybe<Scalars['Int']>;
  item22A?: Maybe<Scalars['Int']>;
  item22B?: Maybe<Scalars['Int']>;
  item23A?: Maybe<Scalars['Int']>;
  item23B?: Maybe<Scalars['Int']>;
  item24A?: Maybe<Scalars['Int']>;
  item24B?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Lsa` values. */
export interface LsasConnection {
  __typename?: 'LsasConnection';
  /** A list of `Lsa` objects. */
  nodes: Array<Lsa>;
  /** A list of edges which contains the `Lsa` and cursor to aid in pagination. */
  edges: Array<LsasEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lsa` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Lsa` edge in the connection. */
export interface LsasEdge {
  __typename?: 'LsasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Lsa` at the end of the edge. */
  node: Lsa;
}

/** Methods to use when ordering `Lsa`. */
export enum LsasOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1AAsc = 'ITEM_1_A_ASC',
  Item_1ADesc = 'ITEM_1_A_DESC',
  Item_1BAsc = 'ITEM_1_B_ASC',
  Item_1BDesc = 'ITEM_1_B_DESC',
  Item_2AAsc = 'ITEM_2_A_ASC',
  Item_2ADesc = 'ITEM_2_A_DESC',
  Item_2BAsc = 'ITEM_2_B_ASC',
  Item_2BDesc = 'ITEM_2_B_DESC',
  Item_3AAsc = 'ITEM_3_A_ASC',
  Item_3ADesc = 'ITEM_3_A_DESC',
  Item_3BAsc = 'ITEM_3_B_ASC',
  Item_3BDesc = 'ITEM_3_B_DESC',
  Item_4AAsc = 'ITEM_4_A_ASC',
  Item_4ADesc = 'ITEM_4_A_DESC',
  Item_4BAsc = 'ITEM_4_B_ASC',
  Item_4BDesc = 'ITEM_4_B_DESC',
  Item_5AAsc = 'ITEM_5_A_ASC',
  Item_5ADesc = 'ITEM_5_A_DESC',
  Item_5BAsc = 'ITEM_5_B_ASC',
  Item_5BDesc = 'ITEM_5_B_DESC',
  Item_6AAsc = 'ITEM_6_A_ASC',
  Item_6ADesc = 'ITEM_6_A_DESC',
  Item_6BAsc = 'ITEM_6_B_ASC',
  Item_6BDesc = 'ITEM_6_B_DESC',
  Item_7AAsc = 'ITEM_7_A_ASC',
  Item_7ADesc = 'ITEM_7_A_DESC',
  Item_7BAsc = 'ITEM_7_B_ASC',
  Item_7BDesc = 'ITEM_7_B_DESC',
  Item_8AAsc = 'ITEM_8_A_ASC',
  Item_8ADesc = 'ITEM_8_A_DESC',
  Item_8BAsc = 'ITEM_8_B_ASC',
  Item_8BDesc = 'ITEM_8_B_DESC',
  Item_9AAsc = 'ITEM_9_A_ASC',
  Item_9ADesc = 'ITEM_9_A_DESC',
  Item_9BAsc = 'ITEM_9_B_ASC',
  Item_9BDesc = 'ITEM_9_B_DESC',
  Item_10AAsc = 'ITEM_10_A_ASC',
  Item_10ADesc = 'ITEM_10_A_DESC',
  Item_10BAsc = 'ITEM_10_B_ASC',
  Item_10BDesc = 'ITEM_10_B_DESC',
  Item_11AAsc = 'ITEM_11_A_ASC',
  Item_11ADesc = 'ITEM_11_A_DESC',
  Item_11BAsc = 'ITEM_11_B_ASC',
  Item_11BDesc = 'ITEM_11_B_DESC',
  Item_12AAsc = 'ITEM_12_A_ASC',
  Item_12ADesc = 'ITEM_12_A_DESC',
  Item_12BAsc = 'ITEM_12_B_ASC',
  Item_12BDesc = 'ITEM_12_B_DESC',
  Item_13AAsc = 'ITEM_13_A_ASC',
  Item_13ADesc = 'ITEM_13_A_DESC',
  Item_13BAsc = 'ITEM_13_B_ASC',
  Item_13BDesc = 'ITEM_13_B_DESC',
  Item_14AAsc = 'ITEM_14_A_ASC',
  Item_14ADesc = 'ITEM_14_A_DESC',
  Item_14BAsc = 'ITEM_14_B_ASC',
  Item_14BDesc = 'ITEM_14_B_DESC',
  Item_15AAsc = 'ITEM_15_A_ASC',
  Item_15ADesc = 'ITEM_15_A_DESC',
  Item_15BAsc = 'ITEM_15_B_ASC',
  Item_15BDesc = 'ITEM_15_B_DESC',
  Item_16AAsc = 'ITEM_16_A_ASC',
  Item_16ADesc = 'ITEM_16_A_DESC',
  Item_16BAsc = 'ITEM_16_B_ASC',
  Item_16BDesc = 'ITEM_16_B_DESC',
  Item_17AAsc = 'ITEM_17_A_ASC',
  Item_17ADesc = 'ITEM_17_A_DESC',
  Item_17BAsc = 'ITEM_17_B_ASC',
  Item_17BDesc = 'ITEM_17_B_DESC',
  Item_18AAsc = 'ITEM_18_A_ASC',
  Item_18ADesc = 'ITEM_18_A_DESC',
  Item_18BAsc = 'ITEM_18_B_ASC',
  Item_18BDesc = 'ITEM_18_B_DESC',
  Item_19AAsc = 'ITEM_19_A_ASC',
  Item_19ADesc = 'ITEM_19_A_DESC',
  Item_19BAsc = 'ITEM_19_B_ASC',
  Item_19BDesc = 'ITEM_19_B_DESC',
  Item_20AAsc = 'ITEM_20_A_ASC',
  Item_20ADesc = 'ITEM_20_A_DESC',
  Item_20BAsc = 'ITEM_20_B_ASC',
  Item_20BDesc = 'ITEM_20_B_DESC',
  Item_21AAsc = 'ITEM_21_A_ASC',
  Item_21ADesc = 'ITEM_21_A_DESC',
  Item_21BAsc = 'ITEM_21_B_ASC',
  Item_21BDesc = 'ITEM_21_B_DESC',
  Item_22AAsc = 'ITEM_22_A_ASC',
  Item_22ADesc = 'ITEM_22_A_DESC',
  Item_22BAsc = 'ITEM_22_B_ASC',
  Item_22BDesc = 'ITEM_22_B_DESC',
  Item_23AAsc = 'ITEM_23_A_ASC',
  Item_23ADesc = 'ITEM_23_A_DESC',
  Item_23BAsc = 'ITEM_23_B_ASC',
  Item_23BDesc = 'ITEM_23_B_DESC',
  Item_24AAsc = 'ITEM_24_A_ASC',
  Item_24ADesc = 'ITEM_24_A_DESC',
  Item_24BAsc = 'ITEM_24_B_ASC',
  Item_24BDesc = 'ITEM_24_B_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Mspss extends Node {
  __typename?: 'Mspss';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  score?: Maybe<Scalars['BigFloat']>;
  significantOtherScore?: Maybe<Scalars['BigFloat']>;
  familyScore?: Maybe<Scalars['BigFloat']>;
  friendsScore?: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Mspss`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Mspss`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Mspss` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface MspssCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `significantOtherScore` field. */
  significantOtherScore?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `familyScore` field. */
  familyScore?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `friendsScore` field. */
  friendsScore?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Mspss` values. */
export interface MspssesConnection {
  __typename?: 'MspssesConnection';
  /** A list of `Mspss` objects. */
  nodes: Array<Mspss>;
  /** A list of edges which contains the `Mspss` and cursor to aid in pagination. */
  edges: Array<MspssesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Mspss` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Mspss` edge in the connection. */
export interface MspssesEdge {
  __typename?: 'MspssesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Mspss` at the end of the edge. */
  node: Mspss;
}

/** Methods to use when ordering `Mspss`. */
export enum MspssesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  SignificantOtherScoreAsc = 'SIGNIFICANT_OTHER_SCORE_ASC',
  SignificantOtherScoreDesc = 'SIGNIFICANT_OTHER_SCORE_DESC',
  FamilyScoreAsc = 'FAMILY_SCORE_ASC',
  FamilyScoreDesc = 'FAMILY_SCORE_DESC',
  FriendsScoreAsc = 'FRIENDS_SCORE_ASC',
  FriendsScoreDesc = 'FRIENDS_SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against `Mspss` object types. All fields are combined with a logical ‘and.’ */
export interface MspssFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `significantOtherScore` field. */
  significantOtherScore?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `familyScore` field. */
  familyScore?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `friendsScore` field. */
  friendsScore?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MspssFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MspssFilter>>;
  /** Negates the expression. */
  not?: Maybe<MspssFilter>;
}

/** An input for mutations affecting `Mspss` */
export interface MspssInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  score?: Maybe<Scalars['BigFloat']>;
  significantOtherScore?: Maybe<Scalars['BigFloat']>;
  familyScore?: Maybe<Scalars['BigFloat']>;
  friendsScore?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Mspss`. Fields that are set will be updated. */
export interface MspssPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['BigFloat']>;
  significantOtherScore?: Maybe<Scalars['BigFloat']>;
  familyScore?: Maybe<Scalars['BigFloat']>;
  friendsScore?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** The root mutation type which contains root level fields which mutate data. */
export interface Mutation {
  __typename?: 'Mutation';
  /** Creates a single `ActiveUser`. */
  createActiveUser?: Maybe<CreateActiveUserPayload>;
  /** Creates a single `AvailableInterviewOffer`. */
  createAvailableInterviewOffer?: Maybe<CreateAvailableInterviewOfferPayload>;
  /** Creates a single `Bdi2`. */
  createBdi2?: Maybe<CreateBdi2Payload>;
  /** Creates a single `BookedInterviewOffer`. */
  createBookedInterviewOffer?: Maybe<CreateBookedInterviewOfferPayload>;
  /** Creates a single `CaseMessage`. */
  createCaseMessage?: Maybe<CreateCaseMessagePayload>;
  /** Creates a single `CaseSuicideCall`. */
  createCaseSuicideCall?: Maybe<CreateCaseSuicideCallPayload>;
  /** Creates a single `Case`. */
  createCase?: Maybe<CreateCasePayload>;
  /** Creates a single `CbtActivity`. */
  createCbtActivity?: Maybe<CreateCbtActivityPayload>;
  /** Creates a single `CbtReframing`. */
  createCbtReframing?: Maybe<CreateCbtReframingPayload>;
  /** Creates a single `CbtThought`. */
  createCbtThought?: Maybe<CreateCbtThoughtPayload>;
  /** Creates a single `Cdrisk10`. */
  createCdrisk10?: Maybe<CreateCdrisk10Payload>;
  /** Creates a single `Comment`. */
  createComment?: Maybe<CreateCommentPayload>;
  /** Creates a single `CoordinatorUser`. */
  createCoordinatorUser?: Maybe<CreateCoordinatorUserPayload>;
  /** Creates a single `CounselingQuestion`. */
  createCounselingQuestion?: Maybe<CreateCounselingQuestionPayload>;
  /** Creates a single `Demographic`. */
  createDemographic?: Maybe<CreateDemographicPayload>;
  /** Creates a single `Disclosure`. */
  createDisclosure?: Maybe<CreateDisclosurePayload>;
  /** Creates a single `Eurohi`. */
  createEurohi?: Maybe<CreateEurohiPayload>;
  /** Creates a single `Evaluation`. */
  createEvaluation?: Maybe<CreateEvaluationPayload>;
  /** Creates a single `FeedbackInterviewReport`. */
  createFeedbackInterviewReport?: Maybe<CreateFeedbackInterviewReportPayload>;
  /** Creates a single `Gad2`. */
  createGad2?: Maybe<CreateGad2Payload>;
  /** Creates a single `Gad7`. */
  createGad7?: Maybe<CreateGad7Payload>;
  /** Creates a single `HashedEmail`. */
  createHashedEmail?: Maybe<CreateHashedEmailPayload>;
  /** Creates a single `Inep`. */
  createInep?: Maybe<CreateInepPayload>;
  /** Creates a single `InterviewBooking`. */
  createInterviewBooking?: Maybe<CreateInterviewBookingPayload>;
  /** Creates a single `InterviewOffer`. */
  createInterviewOffer?: Maybe<CreateInterviewOfferPayload>;
  /** Creates a single `InterviewReport`. */
  createInterviewReport?: Maybe<CreateInterviewReportPayload>;
  /** Creates a single `Interviewee`. */
  createInterviewee?: Maybe<CreateIntervieweePayload>;
  /** Creates a single `Interviewer`. */
  createInterviewer?: Maybe<CreateInterviewerPayload>;
  /** Creates a single `Involvement`. */
  createInvolvement?: Maybe<CreateInvolvementPayload>;
  /** Creates a single `InvolvementsInMyCase`. */
  createInvolvementsInMyCase?: Maybe<CreateInvolvementsInMyCasePayload>;
  /** Creates a single `IptConflict`. */
  createIptConflict?: Maybe<CreateIptConflictPayload>;
  /** Creates a single `IptRelationship`. */
  createIptRelationship?: Maybe<CreateIptRelationshipPayload>;
  /** Creates a single `IptSituation`. */
  createIptSituation?: Maybe<CreateIptSituationPayload>;
  /** Creates a single `Itq`. */
  createItq?: Maybe<CreateItqPayload>;
  /** Creates a single `Lec5`. */
  createLec5?: Maybe<CreateLec5Payload>;
  /** Creates a single `LetterTemplate`. */
  createLetterTemplate?: Maybe<CreateLetterTemplatePayload>;
  /** Creates a single `Letter`. */
  createLetter?: Maybe<CreateLetterPayload>;
  /** Creates a single `LoginToken`. */
  createLoginToken?: Maybe<CreateLoginTokenPayload>;
  /** Creates a single `Lsa`. */
  createLsa?: Maybe<CreateLsaPayload>;
  /** Creates a single `Mspss`. */
  createMspss?: Maybe<CreateMspssPayload>;
  /** Creates a single `MyAccount`. */
  createMyAccount?: Maybe<CreateMyAccountPayload>;
  /** Creates a single `MyCase`. */
  createMyCase?: Maybe<CreateMyCasePayload>;
  /** Creates a single `MyInterviewBooking`. */
  createMyInterviewBooking?: Maybe<CreateMyInterviewBookingPayload>;
  /** Creates a single `MyInterviewOffer`. */
  createMyInterviewOffer?: Maybe<CreateMyInterviewOfferPayload>;
  /** Creates a single `MyInvolvement`. */
  createMyInvolvement?: Maybe<CreateMyInvolvementPayload>;
  /** Creates a single `Pathev`. */
  createPathev?: Maybe<CreatePathevPayload>;
  /** Creates a single `Pcl5`. */
  createPcl5?: Maybe<CreatePcl5Payload>;
  /** Creates a single `Pg13`. */
  createPg13?: Maybe<CreatePg13Payload>;
  /** Creates a single `Phq15`. */
  createPhq15?: Maybe<CreatePhq15Payload>;
  /** Creates a single `Phq4`. */
  createPhq4?: Maybe<CreatePhq4Payload>;
  /** Creates a single `Phq9`. */
  createPhq9?: Maybe<CreatePhq9Payload>;
  /** Creates a single `Pmb`. */
  createPmb?: Maybe<CreatePmbPayload>;
  /** Creates a single `ProcessingQueue`. */
  createProcessingQueue?: Maybe<CreateProcessingQueuePayload>;
  /** Creates a single `QueueSetting`. */
  createQueueSetting?: Maybe<CreateQueueSettingPayload>;
  /** Creates a single `RandomizationTicket`. */
  createRandomizationTicket?: Maybe<CreateRandomizationTicketPayload>;
  /** Creates a single `Sbqr`. */
  createSbqr?: Maybe<CreateSbqrPayload>;
  /** Creates a single `Scaling`. */
  createScaling?: Maybe<CreateScalingPayload>;
  /** Creates a single `Sewip`. */
  createSewip?: Maybe<CreateSewipPayload>;
  /** Creates a single `Sib`. */
  createSib?: Maybe<CreateSibPayload>;
  /** Creates a single `SuicideNote`. */
  createSuicideNote?: Maybe<CreateSuicideNotePayload>;
  /** Creates a single `Taq`. */
  createTaq?: Maybe<CreateTaqPayload>;
  /** Creates a single `Tgisrplus`. */
  createTgisrplus?: Maybe<CreateTgisrplusPayload>;
  /** Creates a single `Traumaliste`. */
  createTraumaliste?: Maybe<CreateTraumalistePayload>;
  /** Creates a single `Traumalisteneu`. */
  createTraumalisteneu?: Maybe<CreateTraumalisteneuPayload>;
  /** Creates a single `Trgi`. */
  createTrgi?: Maybe<CreateTrgiPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `Wai`. */
  createWai?: Maybe<CreateWaiPayload>;
  /** Updates a single `Bdi2` using its globally unique id and a patch. */
  updateBdi2?: Maybe<UpdateBdi2Payload>;
  /** Updates a single `Bdi2` using a unique key and a patch. */
  updateBdi2ById?: Maybe<UpdateBdi2Payload>;
  /** Updates a single `CaseMessage` using its globally unique id and a patch. */
  updateCaseMessage?: Maybe<UpdateCaseMessagePayload>;
  /** Updates a single `CaseMessage` using a unique key and a patch. */
  updateCaseMessageById?: Maybe<UpdateCaseMessagePayload>;
  /** Updates a single `CaseSuicideCall` using its globally unique id and a patch. */
  updateCaseSuicideCall?: Maybe<UpdateCaseSuicideCallPayload>;
  /** Updates a single `CaseSuicideCall` using a unique key and a patch. */
  updateCaseSuicideCallById?: Maybe<UpdateCaseSuicideCallPayload>;
  /** Updates a single `Case` using its globally unique id and a patch. */
  updateCase?: Maybe<UpdateCasePayload>;
  /** Updates a single `Case` using a unique key and a patch. */
  updateCaseById?: Maybe<UpdateCasePayload>;
  /** Updates a single `CbtActivity` using its globally unique id and a patch. */
  updateCbtActivity?: Maybe<UpdateCbtActivityPayload>;
  /** Updates a single `CbtActivity` using a unique key and a patch. */
  updateCbtActivityById?: Maybe<UpdateCbtActivityPayload>;
  /** Updates a single `CbtReframing` using its globally unique id and a patch. */
  updateCbtReframing?: Maybe<UpdateCbtReframingPayload>;
  /** Updates a single `CbtReframing` using a unique key and a patch. */
  updateCbtReframingById?: Maybe<UpdateCbtReframingPayload>;
  /** Updates a single `CbtThought` using its globally unique id and a patch. */
  updateCbtThought?: Maybe<UpdateCbtThoughtPayload>;
  /** Updates a single `CbtThought` using a unique key and a patch. */
  updateCbtThoughtById?: Maybe<UpdateCbtThoughtPayload>;
  /** Updates a single `Cdrisk10` using its globally unique id and a patch. */
  updateCdrisk10?: Maybe<UpdateCdrisk10Payload>;
  /** Updates a single `Cdrisk10` using a unique key and a patch. */
  updateCdrisk10ById?: Maybe<UpdateCdrisk10Payload>;
  /** Updates a single `Comment` using its globally unique id and a patch. */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** Updates a single `Comment` using a unique key and a patch. */
  updateCommentById?: Maybe<UpdateCommentPayload>;
  /** Updates a single `CounselingQuestion` using its globally unique id and a patch. */
  updateCounselingQuestion?: Maybe<UpdateCounselingQuestionPayload>;
  /** Updates a single `CounselingQuestion` using a unique key and a patch. */
  updateCounselingQuestionById?: Maybe<UpdateCounselingQuestionPayload>;
  /** Updates a single `Demographic` using its globally unique id and a patch. */
  updateDemographic?: Maybe<UpdateDemographicPayload>;
  /** Updates a single `Demographic` using a unique key and a patch. */
  updateDemographicById?: Maybe<UpdateDemographicPayload>;
  /** Updates a single `Disclosure` using its globally unique id and a patch. */
  updateDisclosure?: Maybe<UpdateDisclosurePayload>;
  /** Updates a single `Disclosure` using a unique key and a patch. */
  updateDisclosureById?: Maybe<UpdateDisclosurePayload>;
  /** Updates a single `Eurohi` using its globally unique id and a patch. */
  updateEurohi?: Maybe<UpdateEurohiPayload>;
  /** Updates a single `Eurohi` using a unique key and a patch. */
  updateEurohiById?: Maybe<UpdateEurohiPayload>;
  /** Updates a single `Evaluation` using its globally unique id and a patch. */
  updateEvaluation?: Maybe<UpdateEvaluationPayload>;
  /** Updates a single `Evaluation` using a unique key and a patch. */
  updateEvaluationById?: Maybe<UpdateEvaluationPayload>;
  /** Updates a single `FeedbackInterviewReport` using its globally unique id and a patch. */
  updateFeedbackInterviewReport?: Maybe<UpdateFeedbackInterviewReportPayload>;
  /** Updates a single `FeedbackInterviewReport` using a unique key and a patch. */
  updateFeedbackInterviewReportById?: Maybe<UpdateFeedbackInterviewReportPayload>;
  /** Updates a single `Gad2` using its globally unique id and a patch. */
  updateGad2?: Maybe<UpdateGad2Payload>;
  /** Updates a single `Gad2` using a unique key and a patch. */
  updateGad2ById?: Maybe<UpdateGad2Payload>;
  /** Updates a single `Gad7` using its globally unique id and a patch. */
  updateGad7?: Maybe<UpdateGad7Payload>;
  /** Updates a single `Gad7` using a unique key and a patch. */
  updateGad7ById?: Maybe<UpdateGad7Payload>;
  /** Updates a single `HashedEmail` using its globally unique id and a patch. */
  updateHashedEmail?: Maybe<UpdateHashedEmailPayload>;
  /** Updates a single `HashedEmail` using a unique key and a patch. */
  updateHashedEmailById?: Maybe<UpdateHashedEmailPayload>;
  /** Updates a single `Inep` using its globally unique id and a patch. */
  updateInep?: Maybe<UpdateInepPayload>;
  /** Updates a single `Inep` using a unique key and a patch. */
  updateInepById?: Maybe<UpdateInepPayload>;
  /** Updates a single `InterviewBooking` using its globally unique id and a patch. */
  updateInterviewBooking?: Maybe<UpdateInterviewBookingPayload>;
  /** Updates a single `InterviewBooking` using a unique key and a patch. */
  updateInterviewBookingById?: Maybe<UpdateInterviewBookingPayload>;
  /** Updates a single `InterviewBooking` using a unique key and a patch. */
  updateInterviewBookingByIdAndCaseId?: Maybe<UpdateInterviewBookingPayload>;
  /** Updates a single `InterviewOffer` using its globally unique id and a patch. */
  updateInterviewOffer?: Maybe<UpdateInterviewOfferPayload>;
  /** Updates a single `InterviewOffer` using a unique key and a patch. */
  updateInterviewOfferById?: Maybe<UpdateInterviewOfferPayload>;
  /** Updates a single `InterviewReport` using its globally unique id and a patch. */
  updateInterviewReport?: Maybe<UpdateInterviewReportPayload>;
  /** Updates a single `InterviewReport` using a unique key and a patch. */
  updateInterviewReportById?: Maybe<UpdateInterviewReportPayload>;
  /** Updates a single `Interviewee` using a unique key and a patch. */
  updateIntervieweeById?: Maybe<UpdateIntervieweePayload>;
  /** Updates a single `Interviewer` using a unique key and a patch. */
  updateInterviewerById?: Maybe<UpdateInterviewerPayload>;
  /** Updates a single `Involvement` using its globally unique id and a patch. */
  updateInvolvement?: Maybe<UpdateInvolvementPayload>;
  /** Updates a single `Involvement` using a unique key and a patch. */
  updateInvolvementById?: Maybe<UpdateInvolvementPayload>;
  /** Updates a single `IptConflict` using its globally unique id and a patch. */
  updateIptConflict?: Maybe<UpdateIptConflictPayload>;
  /** Updates a single `IptConflict` using a unique key and a patch. */
  updateIptConflictById?: Maybe<UpdateIptConflictPayload>;
  /** Updates a single `IptRelationship` using its globally unique id and a patch. */
  updateIptRelationship?: Maybe<UpdateIptRelationshipPayload>;
  /** Updates a single `IptRelationship` using a unique key and a patch. */
  updateIptRelationshipById?: Maybe<UpdateIptRelationshipPayload>;
  /** Updates a single `IptSituation` using its globally unique id and a patch. */
  updateIptSituation?: Maybe<UpdateIptSituationPayload>;
  /** Updates a single `IptSituation` using a unique key and a patch. */
  updateIptSituationById?: Maybe<UpdateIptSituationPayload>;
  /** Updates a single `Itq` using its globally unique id and a patch. */
  updateItq?: Maybe<UpdateItqPayload>;
  /** Updates a single `Itq` using a unique key and a patch. */
  updateItqById?: Maybe<UpdateItqPayload>;
  /** Updates a single `Lec5` using its globally unique id and a patch. */
  updateLec5?: Maybe<UpdateLec5Payload>;
  /** Updates a single `Lec5` using a unique key and a patch. */
  updateLec5ById?: Maybe<UpdateLec5Payload>;
  /** Updates a single `LetterTemplate` using its globally unique id and a patch. */
  updateLetterTemplate?: Maybe<UpdateLetterTemplatePayload>;
  /** Updates a single `LetterTemplate` using a unique key and a patch. */
  updateLetterTemplateById?: Maybe<UpdateLetterTemplatePayload>;
  /** Updates a single `Letter` using its globally unique id and a patch. */
  updateLetter?: Maybe<UpdateLetterPayload>;
  /** Updates a single `Letter` using a unique key and a patch. */
  updateLetterById?: Maybe<UpdateLetterPayload>;
  /** Updates a single `LoginToken` using its globally unique id and a patch. */
  updateLoginToken?: Maybe<UpdateLoginTokenPayload>;
  /** Updates a single `LoginToken` using a unique key and a patch. */
  updateLoginTokenById?: Maybe<UpdateLoginTokenPayload>;
  /** Updates a single `Lsa` using its globally unique id and a patch. */
  updateLsa?: Maybe<UpdateLsaPayload>;
  /** Updates a single `Lsa` using a unique key and a patch. */
  updateLsaById?: Maybe<UpdateLsaPayload>;
  /** Updates a single `Mspss` using its globally unique id and a patch. */
  updateMspss?: Maybe<UpdateMspssPayload>;
  /** Updates a single `Mspss` using a unique key and a patch. */
  updateMspssById?: Maybe<UpdateMspssPayload>;
  /** Updates a single `MyInvolvement` using a unique key and a patch. */
  updateMyInvolvementByCaseId?: Maybe<UpdateMyInvolvementPayload>;
  /** Updates a single `Pathev` using its globally unique id and a patch. */
  updatePathev?: Maybe<UpdatePathevPayload>;
  /** Updates a single `Pathev` using a unique key and a patch. */
  updatePathevById?: Maybe<UpdatePathevPayload>;
  /** Updates a single `Pcl5` using its globally unique id and a patch. */
  updatePcl5?: Maybe<UpdatePcl5Payload>;
  /** Updates a single `Pcl5` using a unique key and a patch. */
  updatePcl5ById?: Maybe<UpdatePcl5Payload>;
  /** Updates a single `Pg13` using its globally unique id and a patch. */
  updatePg13?: Maybe<UpdatePg13Payload>;
  /** Updates a single `Pg13` using a unique key and a patch. */
  updatePg13ById?: Maybe<UpdatePg13Payload>;
  /** Updates a single `Phq15` using its globally unique id and a patch. */
  updatePhq15?: Maybe<UpdatePhq15Payload>;
  /** Updates a single `Phq15` using a unique key and a patch. */
  updatePhq15ById?: Maybe<UpdatePhq15Payload>;
  /** Updates a single `Phq4` using its globally unique id and a patch. */
  updatePhq4?: Maybe<UpdatePhq4Payload>;
  /** Updates a single `Phq4` using a unique key and a patch. */
  updatePhq4ById?: Maybe<UpdatePhq4Payload>;
  /** Updates a single `Phq9` using its globally unique id and a patch. */
  updatePhq9?: Maybe<UpdatePhq9Payload>;
  /** Updates a single `Phq9` using a unique key and a patch. */
  updatePhq9ById?: Maybe<UpdatePhq9Payload>;
  /** Updates a single `Pmb` using its globally unique id and a patch. */
  updatePmb?: Maybe<UpdatePmbPayload>;
  /** Updates a single `Pmb` using a unique key and a patch. */
  updatePmbById?: Maybe<UpdatePmbPayload>;
  /** Updates a single `ProcessingQueue` using its globally unique id and a patch. */
  updateProcessingQueue?: Maybe<UpdateProcessingQueuePayload>;
  /** Updates a single `ProcessingQueue` using a unique key and a patch. */
  updateProcessingQueueById?: Maybe<UpdateProcessingQueuePayload>;
  /** Updates a single `QueueSetting` using its globally unique id and a patch. */
  updateQueueSetting?: Maybe<UpdateQueueSettingPayload>;
  /** Updates a single `QueueSetting` using a unique key and a patch. */
  updateQueueSettingById?: Maybe<UpdateQueueSettingPayload>;
  /** Updates a single `RandomizationTicket` using its globally unique id and a patch. */
  updateRandomizationTicket?: Maybe<UpdateRandomizationTicketPayload>;
  /** Updates a single `RandomizationTicket` using a unique key and a patch. */
  updateRandomizationTicketById?: Maybe<UpdateRandomizationTicketPayload>;
  /** Updates a single `Sbqr` using its globally unique id and a patch. */
  updateSbqr?: Maybe<UpdateSbqrPayload>;
  /** Updates a single `Sbqr` using a unique key and a patch. */
  updateSbqrById?: Maybe<UpdateSbqrPayload>;
  /** Updates a single `Scaling` using its globally unique id and a patch. */
  updateScaling?: Maybe<UpdateScalingPayload>;
  /** Updates a single `Scaling` using a unique key and a patch. */
  updateScalingById?: Maybe<UpdateScalingPayload>;
  /** Updates a single `Sewip` using its globally unique id and a patch. */
  updateSewip?: Maybe<UpdateSewipPayload>;
  /** Updates a single `Sewip` using a unique key and a patch. */
  updateSewipById?: Maybe<UpdateSewipPayload>;
  /** Updates a single `Sib` using its globally unique id and a patch. */
  updateSib?: Maybe<UpdateSibPayload>;
  /** Updates a single `Sib` using a unique key and a patch. */
  updateSibById?: Maybe<UpdateSibPayload>;
  /** Updates a single `SuicideNote` using its globally unique id and a patch. */
  updateSuicideNote?: Maybe<UpdateSuicideNotePayload>;
  /** Updates a single `SuicideNote` using a unique key and a patch. */
  updateSuicideNoteById?: Maybe<UpdateSuicideNotePayload>;
  /** Updates a single `Taq` using its globally unique id and a patch. */
  updateTaq?: Maybe<UpdateTaqPayload>;
  /** Updates a single `Taq` using a unique key and a patch. */
  updateTaqById?: Maybe<UpdateTaqPayload>;
  /** Updates a single `Tgisrplus` using its globally unique id and a patch. */
  updateTgisrplus?: Maybe<UpdateTgisrplusPayload>;
  /** Updates a single `Tgisrplus` using a unique key and a patch. */
  updateTgisrplusById?: Maybe<UpdateTgisrplusPayload>;
  /** Updates a single `Traumaliste` using its globally unique id and a patch. */
  updateTraumaliste?: Maybe<UpdateTraumalistePayload>;
  /** Updates a single `Traumaliste` using a unique key and a patch. */
  updateTraumalisteById?: Maybe<UpdateTraumalistePayload>;
  /** Updates a single `Traumalisteneu` using its globally unique id and a patch. */
  updateTraumalisteneu?: Maybe<UpdateTraumalisteneuPayload>;
  /** Updates a single `Traumalisteneu` using a unique key and a patch. */
  updateTraumalisteneuById?: Maybe<UpdateTraumalisteneuPayload>;
  /** Updates a single `Trgi` using its globally unique id and a patch. */
  updateTrgi?: Maybe<UpdateTrgiPayload>;
  /** Updates a single `Trgi` using a unique key and a patch. */
  updateTrgiById?: Maybe<UpdateTrgiPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByUsername?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByEmail?: Maybe<UpdateUserPayload>;
  /** Updates a single `Wai` using its globally unique id and a patch. */
  updateWai?: Maybe<UpdateWaiPayload>;
  /** Updates a single `Wai` using a unique key and a patch. */
  updateWaiById?: Maybe<UpdateWaiPayload>;
  /** Deletes a single `Bdi2` using its globally unique id. */
  deleteBdi2?: Maybe<DeleteBdi2Payload>;
  /** Deletes a single `Bdi2` using a unique key. */
  deleteBdi2ById?: Maybe<DeleteBdi2Payload>;
  /** Deletes a single `CaseMessage` using its globally unique id. */
  deleteCaseMessage?: Maybe<DeleteCaseMessagePayload>;
  /** Deletes a single `CaseMessage` using a unique key. */
  deleteCaseMessageById?: Maybe<DeleteCaseMessagePayload>;
  /** Deletes a single `CaseSuicideCall` using its globally unique id. */
  deleteCaseSuicideCall?: Maybe<DeleteCaseSuicideCallPayload>;
  /** Deletes a single `CaseSuicideCall` using a unique key. */
  deleteCaseSuicideCallById?: Maybe<DeleteCaseSuicideCallPayload>;
  /** Deletes a single `Case` using its globally unique id. */
  deleteCase?: Maybe<DeleteCasePayload>;
  /** Deletes a single `Case` using a unique key. */
  deleteCaseById?: Maybe<DeleteCasePayload>;
  /** Deletes a single `CbtActivity` using its globally unique id. */
  deleteCbtActivity?: Maybe<DeleteCbtActivityPayload>;
  /** Deletes a single `CbtActivity` using a unique key. */
  deleteCbtActivityById?: Maybe<DeleteCbtActivityPayload>;
  /** Deletes a single `CbtReframing` using its globally unique id. */
  deleteCbtReframing?: Maybe<DeleteCbtReframingPayload>;
  /** Deletes a single `CbtReframing` using a unique key. */
  deleteCbtReframingById?: Maybe<DeleteCbtReframingPayload>;
  /** Deletes a single `CbtThought` using its globally unique id. */
  deleteCbtThought?: Maybe<DeleteCbtThoughtPayload>;
  /** Deletes a single `CbtThought` using a unique key. */
  deleteCbtThoughtById?: Maybe<DeleteCbtThoughtPayload>;
  /** Deletes a single `Cdrisk10` using its globally unique id. */
  deleteCdrisk10?: Maybe<DeleteCdrisk10Payload>;
  /** Deletes a single `Cdrisk10` using a unique key. */
  deleteCdrisk10ById?: Maybe<DeleteCdrisk10Payload>;
  /** Deletes a single `Comment` using its globally unique id. */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** Deletes a single `Comment` using a unique key. */
  deleteCommentById?: Maybe<DeleteCommentPayload>;
  /** Deletes a single `CounselingQuestion` using its globally unique id. */
  deleteCounselingQuestion?: Maybe<DeleteCounselingQuestionPayload>;
  /** Deletes a single `CounselingQuestion` using a unique key. */
  deleteCounselingQuestionById?: Maybe<DeleteCounselingQuestionPayload>;
  /** Deletes a single `Demographic` using its globally unique id. */
  deleteDemographic?: Maybe<DeleteDemographicPayload>;
  /** Deletes a single `Demographic` using a unique key. */
  deleteDemographicById?: Maybe<DeleteDemographicPayload>;
  /** Deletes a single `Disclosure` using its globally unique id. */
  deleteDisclosure?: Maybe<DeleteDisclosurePayload>;
  /** Deletes a single `Disclosure` using a unique key. */
  deleteDisclosureById?: Maybe<DeleteDisclosurePayload>;
  /** Deletes a single `Eurohi` using its globally unique id. */
  deleteEurohi?: Maybe<DeleteEurohiPayload>;
  /** Deletes a single `Eurohi` using a unique key. */
  deleteEurohiById?: Maybe<DeleteEurohiPayload>;
  /** Deletes a single `Evaluation` using its globally unique id. */
  deleteEvaluation?: Maybe<DeleteEvaluationPayload>;
  /** Deletes a single `Evaluation` using a unique key. */
  deleteEvaluationById?: Maybe<DeleteEvaluationPayload>;
  /** Deletes a single `FeedbackInterviewReport` using its globally unique id. */
  deleteFeedbackInterviewReport?: Maybe<DeleteFeedbackInterviewReportPayload>;
  /** Deletes a single `FeedbackInterviewReport` using a unique key. */
  deleteFeedbackInterviewReportById?: Maybe<DeleteFeedbackInterviewReportPayload>;
  /** Deletes a single `Gad2` using its globally unique id. */
  deleteGad2?: Maybe<DeleteGad2Payload>;
  /** Deletes a single `Gad2` using a unique key. */
  deleteGad2ById?: Maybe<DeleteGad2Payload>;
  /** Deletes a single `Gad7` using its globally unique id. */
  deleteGad7?: Maybe<DeleteGad7Payload>;
  /** Deletes a single `Gad7` using a unique key. */
  deleteGad7ById?: Maybe<DeleteGad7Payload>;
  /** Deletes a single `HashedEmail` using its globally unique id. */
  deleteHashedEmail?: Maybe<DeleteHashedEmailPayload>;
  /** Deletes a single `HashedEmail` using a unique key. */
  deleteHashedEmailById?: Maybe<DeleteHashedEmailPayload>;
  /** Deletes a single `Inep` using its globally unique id. */
  deleteInep?: Maybe<DeleteInepPayload>;
  /** Deletes a single `Inep` using a unique key. */
  deleteInepById?: Maybe<DeleteInepPayload>;
  /** Deletes a single `InterviewBooking` using its globally unique id. */
  deleteInterviewBooking?: Maybe<DeleteInterviewBookingPayload>;
  /** Deletes a single `InterviewBooking` using a unique key. */
  deleteInterviewBookingById?: Maybe<DeleteInterviewBookingPayload>;
  /** Deletes a single `InterviewBooking` using a unique key. */
  deleteInterviewBookingByIdAndCaseId?: Maybe<DeleteInterviewBookingPayload>;
  /** Deletes a single `InterviewOffer` using its globally unique id. */
  deleteInterviewOffer?: Maybe<DeleteInterviewOfferPayload>;
  /** Deletes a single `InterviewOffer` using a unique key. */
  deleteInterviewOfferById?: Maybe<DeleteInterviewOfferPayload>;
  /** Deletes a single `InterviewReport` using its globally unique id. */
  deleteInterviewReport?: Maybe<DeleteInterviewReportPayload>;
  /** Deletes a single `InterviewReport` using a unique key. */
  deleteInterviewReportById?: Maybe<DeleteInterviewReportPayload>;
  /** Deletes a single `Interviewee` using a unique key. */
  deleteIntervieweeById?: Maybe<DeleteIntervieweePayload>;
  /** Deletes a single `Interviewer` using a unique key. */
  deleteInterviewerById?: Maybe<DeleteInterviewerPayload>;
  /** Deletes a single `Involvement` using its globally unique id. */
  deleteInvolvement?: Maybe<DeleteInvolvementPayload>;
  /** Deletes a single `Involvement` using a unique key. */
  deleteInvolvementById?: Maybe<DeleteInvolvementPayload>;
  /** Deletes a single `IptConflict` using its globally unique id. */
  deleteIptConflict?: Maybe<DeleteIptConflictPayload>;
  /** Deletes a single `IptConflict` using a unique key. */
  deleteIptConflictById?: Maybe<DeleteIptConflictPayload>;
  /** Deletes a single `IptRelationship` using its globally unique id. */
  deleteIptRelationship?: Maybe<DeleteIptRelationshipPayload>;
  /** Deletes a single `IptRelationship` using a unique key. */
  deleteIptRelationshipById?: Maybe<DeleteIptRelationshipPayload>;
  /** Deletes a single `IptSituation` using its globally unique id. */
  deleteIptSituation?: Maybe<DeleteIptSituationPayload>;
  /** Deletes a single `IptSituation` using a unique key. */
  deleteIptSituationById?: Maybe<DeleteIptSituationPayload>;
  /** Deletes a single `Itq` using its globally unique id. */
  deleteItq?: Maybe<DeleteItqPayload>;
  /** Deletes a single `Itq` using a unique key. */
  deleteItqById?: Maybe<DeleteItqPayload>;
  /** Deletes a single `Lec5` using its globally unique id. */
  deleteLec5?: Maybe<DeleteLec5Payload>;
  /** Deletes a single `Lec5` using a unique key. */
  deleteLec5ById?: Maybe<DeleteLec5Payload>;
  /** Deletes a single `LetterTemplate` using its globally unique id. */
  deleteLetterTemplate?: Maybe<DeleteLetterTemplatePayload>;
  /** Deletes a single `LetterTemplate` using a unique key. */
  deleteLetterTemplateById?: Maybe<DeleteLetterTemplatePayload>;
  /** Deletes a single `Letter` using its globally unique id. */
  deleteLetter?: Maybe<DeleteLetterPayload>;
  /** Deletes a single `Letter` using a unique key. */
  deleteLetterById?: Maybe<DeleteLetterPayload>;
  /** Deletes a single `LoginToken` using its globally unique id. */
  deleteLoginToken?: Maybe<DeleteLoginTokenPayload>;
  /** Deletes a single `LoginToken` using a unique key. */
  deleteLoginTokenById?: Maybe<DeleteLoginTokenPayload>;
  /** Deletes a single `Lsa` using its globally unique id. */
  deleteLsa?: Maybe<DeleteLsaPayload>;
  /** Deletes a single `Lsa` using a unique key. */
  deleteLsaById?: Maybe<DeleteLsaPayload>;
  /** Deletes a single `Mspss` using its globally unique id. */
  deleteMspss?: Maybe<DeleteMspssPayload>;
  /** Deletes a single `Mspss` using a unique key. */
  deleteMspssById?: Maybe<DeleteMspssPayload>;
  /** Deletes a single `MyInvolvement` using a unique key. */
  deleteMyInvolvementByCaseId?: Maybe<DeleteMyInvolvementPayload>;
  /** Deletes a single `Pathev` using its globally unique id. */
  deletePathev?: Maybe<DeletePathevPayload>;
  /** Deletes a single `Pathev` using a unique key. */
  deletePathevById?: Maybe<DeletePathevPayload>;
  /** Deletes a single `Pcl5` using its globally unique id. */
  deletePcl5?: Maybe<DeletePcl5Payload>;
  /** Deletes a single `Pcl5` using a unique key. */
  deletePcl5ById?: Maybe<DeletePcl5Payload>;
  /** Deletes a single `Pg13` using its globally unique id. */
  deletePg13?: Maybe<DeletePg13Payload>;
  /** Deletes a single `Pg13` using a unique key. */
  deletePg13ById?: Maybe<DeletePg13Payload>;
  /** Deletes a single `Phq15` using its globally unique id. */
  deletePhq15?: Maybe<DeletePhq15Payload>;
  /** Deletes a single `Phq15` using a unique key. */
  deletePhq15ById?: Maybe<DeletePhq15Payload>;
  /** Deletes a single `Phq4` using its globally unique id. */
  deletePhq4?: Maybe<DeletePhq4Payload>;
  /** Deletes a single `Phq4` using a unique key. */
  deletePhq4ById?: Maybe<DeletePhq4Payload>;
  /** Deletes a single `Phq9` using its globally unique id. */
  deletePhq9?: Maybe<DeletePhq9Payload>;
  /** Deletes a single `Phq9` using a unique key. */
  deletePhq9ById?: Maybe<DeletePhq9Payload>;
  /** Deletes a single `Pmb` using its globally unique id. */
  deletePmb?: Maybe<DeletePmbPayload>;
  /** Deletes a single `Pmb` using a unique key. */
  deletePmbById?: Maybe<DeletePmbPayload>;
  /** Deletes a single `ProcessingQueue` using its globally unique id. */
  deleteProcessingQueue?: Maybe<DeleteProcessingQueuePayload>;
  /** Deletes a single `ProcessingQueue` using a unique key. */
  deleteProcessingQueueById?: Maybe<DeleteProcessingQueuePayload>;
  /** Deletes a single `QueueSetting` using its globally unique id. */
  deleteQueueSetting?: Maybe<DeleteQueueSettingPayload>;
  /** Deletes a single `QueueSetting` using a unique key. */
  deleteQueueSettingById?: Maybe<DeleteQueueSettingPayload>;
  /** Deletes a single `RandomizationTicket` using its globally unique id. */
  deleteRandomizationTicket?: Maybe<DeleteRandomizationTicketPayload>;
  /** Deletes a single `RandomizationTicket` using a unique key. */
  deleteRandomizationTicketById?: Maybe<DeleteRandomizationTicketPayload>;
  /** Deletes a single `Sbqr` using its globally unique id. */
  deleteSbqr?: Maybe<DeleteSbqrPayload>;
  /** Deletes a single `Sbqr` using a unique key. */
  deleteSbqrById?: Maybe<DeleteSbqrPayload>;
  /** Deletes a single `Scaling` using its globally unique id. */
  deleteScaling?: Maybe<DeleteScalingPayload>;
  /** Deletes a single `Scaling` using a unique key. */
  deleteScalingById?: Maybe<DeleteScalingPayload>;
  /** Deletes a single `Sewip` using its globally unique id. */
  deleteSewip?: Maybe<DeleteSewipPayload>;
  /** Deletes a single `Sewip` using a unique key. */
  deleteSewipById?: Maybe<DeleteSewipPayload>;
  /** Deletes a single `Sib` using its globally unique id. */
  deleteSib?: Maybe<DeleteSibPayload>;
  /** Deletes a single `Sib` using a unique key. */
  deleteSibById?: Maybe<DeleteSibPayload>;
  /** Deletes a single `SuicideNote` using its globally unique id. */
  deleteSuicideNote?: Maybe<DeleteSuicideNotePayload>;
  /** Deletes a single `SuicideNote` using a unique key. */
  deleteSuicideNoteById?: Maybe<DeleteSuicideNotePayload>;
  /** Deletes a single `Taq` using its globally unique id. */
  deleteTaq?: Maybe<DeleteTaqPayload>;
  /** Deletes a single `Taq` using a unique key. */
  deleteTaqById?: Maybe<DeleteTaqPayload>;
  /** Deletes a single `Tgisrplus` using its globally unique id. */
  deleteTgisrplus?: Maybe<DeleteTgisrplusPayload>;
  /** Deletes a single `Tgisrplus` using a unique key. */
  deleteTgisrplusById?: Maybe<DeleteTgisrplusPayload>;
  /** Deletes a single `Traumaliste` using its globally unique id. */
  deleteTraumaliste?: Maybe<DeleteTraumalistePayload>;
  /** Deletes a single `Traumaliste` using a unique key. */
  deleteTraumalisteById?: Maybe<DeleteTraumalistePayload>;
  /** Deletes a single `Traumalisteneu` using its globally unique id. */
  deleteTraumalisteneu?: Maybe<DeleteTraumalisteneuPayload>;
  /** Deletes a single `Traumalisteneu` using a unique key. */
  deleteTraumalisteneuById?: Maybe<DeleteTraumalisteneuPayload>;
  /** Deletes a single `Trgi` using its globally unique id. */
  deleteTrgi?: Maybe<DeleteTrgiPayload>;
  /** Deletes a single `Trgi` using a unique key. */
  deleteTrgiById?: Maybe<DeleteTrgiPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserById?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByUsername?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByEmail?: Maybe<DeleteUserPayload>;
  /** Deletes a single `Wai` using its globally unique id. */
  deleteWai?: Maybe<DeleteWaiPayload>;
  /** Deletes a single `Wai` using a unique key. */
  deleteWaiById?: Maybe<DeleteWaiPayload>;
  adopt?: Maybe<AdoptPayload>;
  book?: Maybe<BookPayload>;
  checkHashEmailExisting?: Maybe<CheckHashEmailExistingPayload>;
  dropMultipleInterviewers?: Maybe<DropMultipleInterviewersPayload>;
  dropMultipleInterviewersAndFixMemberships?: Maybe<DropMultipleInterviewersAndFixMembershipsPayload>;
  fixCamundaMemberships?: Maybe<FixCamundaMembershipsPayload>;
  lockSemaphore?: Maybe<LockSemaphorePayload>;
  myMessagesFun?: Maybe<MyMessagesFunPayload>;
  randomize?: Maybe<RandomizePayload>;
  randomizeUsingCaseId?: Maybe<RandomizeUsingCaseIdPayload>;
  unlockSemaphore?: Maybe<UnlockSemaphorePayload>;
  adoptInterviewOfferById?: Maybe<AdoptInterviewOfferByIdPayload>;
  bookInterview?: Maybe<BookInterviewPayload>;
  cancelInterviewBookingById?: Maybe<CancelInterviewBookingByIdPayload>;
  cancelInterviewOfferById?: Maybe<CancelInterviewOfferByIdPayload>;
  uncancelInterviewOfferById?: Maybe<UncancelInterviewOfferByIdPayload>;
}


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActiveUserArgs = {
  input: CreateActiveUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAvailableInterviewOfferArgs = {
  input: CreateAvailableInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBdi2Args = {
  input: CreateBdi2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBookedInterviewOfferArgs = {
  input: CreateBookedInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseMessageArgs = {
  input: CreateCaseMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseSuicideCallArgs = {
  input: CreateCaseSuicideCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaseArgs = {
  input: CreateCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCbtActivityArgs = {
  input: CreateCbtActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCbtReframingArgs = {
  input: CreateCbtReframingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCbtThoughtArgs = {
  input: CreateCbtThoughtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCdrisk10Args = {
  input: CreateCdrisk10Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoordinatorUserArgs = {
  input: CreateCoordinatorUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCounselingQuestionArgs = {
  input: CreateCounselingQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDemographicArgs = {
  input: CreateDemographicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDisclosureArgs = {
  input: CreateDisclosureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEurohiArgs = {
  input: CreateEurohiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEvaluationArgs = {
  input: CreateEvaluationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeedbackInterviewReportArgs = {
  input: CreateFeedbackInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGad2Args = {
  input: CreateGad2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGad7Args = {
  input: CreateGad7Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHashedEmailArgs = {
  input: CreateHashedEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInepArgs = {
  input: CreateInepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInterviewBookingArgs = {
  input: CreateInterviewBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInterviewOfferArgs = {
  input: CreateInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInterviewReportArgs = {
  input: CreateInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntervieweeArgs = {
  input: CreateIntervieweeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInterviewerArgs = {
  input: CreateInterviewerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvolvementArgs = {
  input: CreateInvolvementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvolvementsInMyCaseArgs = {
  input: CreateInvolvementsInMyCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIptConflictArgs = {
  input: CreateIptConflictInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIptRelationshipArgs = {
  input: CreateIptRelationshipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIptSituationArgs = {
  input: CreateIptSituationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItqArgs = {
  input: CreateItqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLec5Args = {
  input: CreateLec5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLetterTemplateArgs = {
  input: CreateLetterTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLetterArgs = {
  input: CreateLetterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLoginTokenArgs = {
  input: CreateLoginTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLsaArgs = {
  input: CreateLsaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMspssArgs = {
  input: CreateMspssInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMyAccountArgs = {
  input: CreateMyAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMyCaseArgs = {
  input: CreateMyCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMyInterviewBookingArgs = {
  input: CreateMyInterviewBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMyInterviewOfferArgs = {
  input: CreateMyInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMyInvolvementArgs = {
  input: CreateMyInvolvementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePathevArgs = {
  input: CreatePathevInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePcl5Args = {
  input: CreatePcl5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePg13Args = {
  input: CreatePg13Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePhq15Args = {
  input: CreatePhq15Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePhq4Args = {
  input: CreatePhq4Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePhq9Args = {
  input: CreatePhq9Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePmbArgs = {
  input: CreatePmbInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessingQueueArgs = {
  input: CreateProcessingQueueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateQueueSettingArgs = {
  input: CreateQueueSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRandomizationTicketArgs = {
  input: CreateRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSbqrArgs = {
  input: CreateSbqrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScalingArgs = {
  input: CreateScalingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSewipArgs = {
  input: CreateSewipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSibArgs = {
  input: CreateSibInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuicideNoteArgs = {
  input: CreateSuicideNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaqArgs = {
  input: CreateTaqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTgisrplusArgs = {
  input: CreateTgisrplusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTraumalisteArgs = {
  input: CreateTraumalisteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTraumalisteneuArgs = {
  input: CreateTraumalisteneuInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrgiArgs = {
  input: CreateTrgiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWaiArgs = {
  input: CreateWaiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBdi2Args = {
  input: UpdateBdi2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBdi2ByIdArgs = {
  input: UpdateBdi2ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseMessageArgs = {
  input: UpdateCaseMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseMessageByIdArgs = {
  input: UpdateCaseMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseSuicideCallArgs = {
  input: UpdateCaseSuicideCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseSuicideCallByIdArgs = {
  input: UpdateCaseSuicideCallByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseArgs = {
  input: UpdateCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaseByIdArgs = {
  input: UpdateCaseByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtActivityArgs = {
  input: UpdateCbtActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtActivityByIdArgs = {
  input: UpdateCbtActivityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtReframingArgs = {
  input: UpdateCbtReframingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtReframingByIdArgs = {
  input: UpdateCbtReframingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtThoughtArgs = {
  input: UpdateCbtThoughtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCbtThoughtByIdArgs = {
  input: UpdateCbtThoughtByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCdrisk10Args = {
  input: UpdateCdrisk10Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCdrisk10ByIdArgs = {
  input: UpdateCdrisk10ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentByIdArgs = {
  input: UpdateCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCounselingQuestionArgs = {
  input: UpdateCounselingQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCounselingQuestionByIdArgs = {
  input: UpdateCounselingQuestionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDemographicArgs = {
  input: UpdateDemographicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDemographicByIdArgs = {
  input: UpdateDemographicByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDisclosureArgs = {
  input: UpdateDisclosureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDisclosureByIdArgs = {
  input: UpdateDisclosureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEurohiArgs = {
  input: UpdateEurohiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEurohiByIdArgs = {
  input: UpdateEurohiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaluationArgs = {
  input: UpdateEvaluationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaluationByIdArgs = {
  input: UpdateEvaluationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeedbackInterviewReportArgs = {
  input: UpdateFeedbackInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeedbackInterviewReportByIdArgs = {
  input: UpdateFeedbackInterviewReportByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGad2Args = {
  input: UpdateGad2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGad2ByIdArgs = {
  input: UpdateGad2ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGad7Args = {
  input: UpdateGad7Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGad7ByIdArgs = {
  input: UpdateGad7ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHashedEmailArgs = {
  input: UpdateHashedEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHashedEmailByIdArgs = {
  input: UpdateHashedEmailByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInepArgs = {
  input: UpdateInepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInepByIdArgs = {
  input: UpdateInepByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewBookingArgs = {
  input: UpdateInterviewBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewBookingByIdArgs = {
  input: UpdateInterviewBookingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewBookingByIdAndCaseIdArgs = {
  input: UpdateInterviewBookingByIdAndCaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewOfferArgs = {
  input: UpdateInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewOfferByIdArgs = {
  input: UpdateInterviewOfferByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewReportArgs = {
  input: UpdateInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewReportByIdArgs = {
  input: UpdateInterviewReportByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntervieweeByIdArgs = {
  input: UpdateIntervieweeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInterviewerByIdArgs = {
  input: UpdateInterviewerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvolvementArgs = {
  input: UpdateInvolvementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvolvementByIdArgs = {
  input: UpdateInvolvementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptConflictArgs = {
  input: UpdateIptConflictInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptConflictByIdArgs = {
  input: UpdateIptConflictByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptRelationshipArgs = {
  input: UpdateIptRelationshipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptRelationshipByIdArgs = {
  input: UpdateIptRelationshipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptSituationArgs = {
  input: UpdateIptSituationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIptSituationByIdArgs = {
  input: UpdateIptSituationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItqArgs = {
  input: UpdateItqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItqByIdArgs = {
  input: UpdateItqByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLec5Args = {
  input: UpdateLec5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLec5ByIdArgs = {
  input: UpdateLec5ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLetterTemplateArgs = {
  input: UpdateLetterTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLetterTemplateByIdArgs = {
  input: UpdateLetterTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLetterArgs = {
  input: UpdateLetterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLetterByIdArgs = {
  input: UpdateLetterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLoginTokenArgs = {
  input: UpdateLoginTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLoginTokenByIdArgs = {
  input: UpdateLoginTokenByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLsaArgs = {
  input: UpdateLsaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLsaByIdArgs = {
  input: UpdateLsaByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMspssArgs = {
  input: UpdateMspssInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMspssByIdArgs = {
  input: UpdateMspssByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMyInvolvementByCaseIdArgs = {
  input: UpdateMyInvolvementByCaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePathevArgs = {
  input: UpdatePathevInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePathevByIdArgs = {
  input: UpdatePathevByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePcl5Args = {
  input: UpdatePcl5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePcl5ByIdArgs = {
  input: UpdatePcl5ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePg13Args = {
  input: UpdatePg13Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePg13ByIdArgs = {
  input: UpdatePg13ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq15Args = {
  input: UpdatePhq15Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq15ByIdArgs = {
  input: UpdatePhq15ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq4Args = {
  input: UpdatePhq4Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq4ByIdArgs = {
  input: UpdatePhq4ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq9Args = {
  input: UpdatePhq9Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhq9ByIdArgs = {
  input: UpdatePhq9ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePmbArgs = {
  input: UpdatePmbInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePmbByIdArgs = {
  input: UpdatePmbByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcessingQueueArgs = {
  input: UpdateProcessingQueueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcessingQueueByIdArgs = {
  input: UpdateProcessingQueueByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQueueSettingArgs = {
  input: UpdateQueueSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQueueSettingByIdArgs = {
  input: UpdateQueueSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRandomizationTicketArgs = {
  input: UpdateRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRandomizationTicketByIdArgs = {
  input: UpdateRandomizationTicketByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSbqrArgs = {
  input: UpdateSbqrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSbqrByIdArgs = {
  input: UpdateSbqrByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScalingArgs = {
  input: UpdateScalingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScalingByIdArgs = {
  input: UpdateScalingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSewipArgs = {
  input: UpdateSewipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSewipByIdArgs = {
  input: UpdateSewipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSibArgs = {
  input: UpdateSibInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSibByIdArgs = {
  input: UpdateSibByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuicideNoteArgs = {
  input: UpdateSuicideNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuicideNoteByIdArgs = {
  input: UpdateSuicideNoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaqArgs = {
  input: UpdateTaqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaqByIdArgs = {
  input: UpdateTaqByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTgisrplusArgs = {
  input: UpdateTgisrplusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTgisrplusByIdArgs = {
  input: UpdateTgisrplusByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraumalisteArgs = {
  input: UpdateTraumalisteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraumalisteByIdArgs = {
  input: UpdateTraumalisteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraumalisteneuArgs = {
  input: UpdateTraumalisteneuInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTraumalisteneuByIdArgs = {
  input: UpdateTraumalisteneuByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrgiArgs = {
  input: UpdateTrgiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrgiByIdArgs = {
  input: UpdateTrgiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByUsernameArgs = {
  input: UpdateUserByUsernameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByEmailArgs = {
  input: UpdateUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaiArgs = {
  input: UpdateWaiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaiByIdArgs = {
  input: UpdateWaiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBdi2Args = {
  input: DeleteBdi2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBdi2ByIdArgs = {
  input: DeleteBdi2ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseMessageArgs = {
  input: DeleteCaseMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseMessageByIdArgs = {
  input: DeleteCaseMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseSuicideCallArgs = {
  input: DeleteCaseSuicideCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseSuicideCallByIdArgs = {
  input: DeleteCaseSuicideCallByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseArgs = {
  input: DeleteCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaseByIdArgs = {
  input: DeleteCaseByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtActivityArgs = {
  input: DeleteCbtActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtActivityByIdArgs = {
  input: DeleteCbtActivityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtReframingArgs = {
  input: DeleteCbtReframingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtReframingByIdArgs = {
  input: DeleteCbtReframingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtThoughtArgs = {
  input: DeleteCbtThoughtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCbtThoughtByIdArgs = {
  input: DeleteCbtThoughtByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCdrisk10Args = {
  input: DeleteCdrisk10Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCdrisk10ByIdArgs = {
  input: DeleteCdrisk10ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentByIdArgs = {
  input: DeleteCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCounselingQuestionArgs = {
  input: DeleteCounselingQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCounselingQuestionByIdArgs = {
  input: DeleteCounselingQuestionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDemographicArgs = {
  input: DeleteDemographicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDemographicByIdArgs = {
  input: DeleteDemographicByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDisclosureArgs = {
  input: DeleteDisclosureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDisclosureByIdArgs = {
  input: DeleteDisclosureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEurohiArgs = {
  input: DeleteEurohiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEurohiByIdArgs = {
  input: DeleteEurohiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaluationArgs = {
  input: DeleteEvaluationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaluationByIdArgs = {
  input: DeleteEvaluationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedbackInterviewReportArgs = {
  input: DeleteFeedbackInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedbackInterviewReportByIdArgs = {
  input: DeleteFeedbackInterviewReportByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGad2Args = {
  input: DeleteGad2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGad2ByIdArgs = {
  input: DeleteGad2ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGad7Args = {
  input: DeleteGad7Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGad7ByIdArgs = {
  input: DeleteGad7ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHashedEmailArgs = {
  input: DeleteHashedEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHashedEmailByIdArgs = {
  input: DeleteHashedEmailByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInepArgs = {
  input: DeleteInepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInepByIdArgs = {
  input: DeleteInepByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewBookingArgs = {
  input: DeleteInterviewBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewBookingByIdArgs = {
  input: DeleteInterviewBookingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewBookingByIdAndCaseIdArgs = {
  input: DeleteInterviewBookingByIdAndCaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewOfferArgs = {
  input: DeleteInterviewOfferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewOfferByIdArgs = {
  input: DeleteInterviewOfferByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewReportArgs = {
  input: DeleteInterviewReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewReportByIdArgs = {
  input: DeleteInterviewReportByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntervieweeByIdArgs = {
  input: DeleteIntervieweeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInterviewerByIdArgs = {
  input: DeleteInterviewerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvolvementArgs = {
  input: DeleteInvolvementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvolvementByIdArgs = {
  input: DeleteInvolvementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptConflictArgs = {
  input: DeleteIptConflictInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptConflictByIdArgs = {
  input: DeleteIptConflictByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptRelationshipArgs = {
  input: DeleteIptRelationshipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptRelationshipByIdArgs = {
  input: DeleteIptRelationshipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptSituationArgs = {
  input: DeleteIptSituationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIptSituationByIdArgs = {
  input: DeleteIptSituationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteItqArgs = {
  input: DeleteItqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteItqByIdArgs = {
  input: DeleteItqByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLec5Args = {
  input: DeleteLec5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLec5ByIdArgs = {
  input: DeleteLec5ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLetterTemplateArgs = {
  input: DeleteLetterTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLetterTemplateByIdArgs = {
  input: DeleteLetterTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLetterArgs = {
  input: DeleteLetterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLetterByIdArgs = {
  input: DeleteLetterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLoginTokenArgs = {
  input: DeleteLoginTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLoginTokenByIdArgs = {
  input: DeleteLoginTokenByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLsaArgs = {
  input: DeleteLsaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLsaByIdArgs = {
  input: DeleteLsaByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMspssArgs = {
  input: DeleteMspssInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMspssByIdArgs = {
  input: DeleteMspssByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMyInvolvementByCaseIdArgs = {
  input: DeleteMyInvolvementByCaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePathevArgs = {
  input: DeletePathevInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePathevByIdArgs = {
  input: DeletePathevByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePcl5Args = {
  input: DeletePcl5Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePcl5ByIdArgs = {
  input: DeletePcl5ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePg13Args = {
  input: DeletePg13Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePg13ByIdArgs = {
  input: DeletePg13ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq15Args = {
  input: DeletePhq15Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq15ByIdArgs = {
  input: DeletePhq15ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq4Args = {
  input: DeletePhq4Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq4ByIdArgs = {
  input: DeletePhq4ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq9Args = {
  input: DeletePhq9Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhq9ByIdArgs = {
  input: DeletePhq9ByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePmbArgs = {
  input: DeletePmbInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePmbByIdArgs = {
  input: DeletePmbByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcessingQueueArgs = {
  input: DeleteProcessingQueueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcessingQueueByIdArgs = {
  input: DeleteProcessingQueueByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQueueSettingArgs = {
  input: DeleteQueueSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQueueSettingByIdArgs = {
  input: DeleteQueueSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRandomizationTicketArgs = {
  input: DeleteRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRandomizationTicketByIdArgs = {
  input: DeleteRandomizationTicketByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSbqrArgs = {
  input: DeleteSbqrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSbqrByIdArgs = {
  input: DeleteSbqrByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScalingArgs = {
  input: DeleteScalingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScalingByIdArgs = {
  input: DeleteScalingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSewipArgs = {
  input: DeleteSewipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSewipByIdArgs = {
  input: DeleteSewipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSibArgs = {
  input: DeleteSibInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSibByIdArgs = {
  input: DeleteSibByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuicideNoteArgs = {
  input: DeleteSuicideNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuicideNoteByIdArgs = {
  input: DeleteSuicideNoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaqArgs = {
  input: DeleteTaqInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaqByIdArgs = {
  input: DeleteTaqByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTgisrplusArgs = {
  input: DeleteTgisrplusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTgisrplusByIdArgs = {
  input: DeleteTgisrplusByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTraumalisteArgs = {
  input: DeleteTraumalisteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTraumalisteByIdArgs = {
  input: DeleteTraumalisteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTraumalisteneuArgs = {
  input: DeleteTraumalisteneuInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTraumalisteneuByIdArgs = {
  input: DeleteTraumalisteneuByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrgiArgs = {
  input: DeleteTrgiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrgiByIdArgs = {
  input: DeleteTrgiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByUsernameArgs = {
  input: DeleteUserByUsernameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByEmailArgs = {
  input: DeleteUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaiArgs = {
  input: DeleteWaiInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaiByIdArgs = {
  input: DeleteWaiByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdoptArgs = {
  input: AdoptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBookArgs = {
  input: BookInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckHashEmailExistingArgs = {
  input: CheckHashEmailExistingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDropMultipleInterviewersArgs = {
  input: DropMultipleInterviewersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDropMultipleInterviewersAndFixMembershipsArgs = {
  input: DropMultipleInterviewersAndFixMembershipsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFixCamundaMembershipsArgs = {
  input: FixCamundaMembershipsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLockSemaphoreArgs = {
  input: LockSemaphoreInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMyMessagesFunArgs = {
  input: MyMessagesFunInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRandomizeArgs = {
  input: RandomizeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRandomizeUsingCaseIdArgs = {
  input: RandomizeUsingCaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnlockSemaphoreArgs = {
  input: UnlockSemaphoreInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdoptInterviewOfferByIdArgs = {
  input: AdoptInterviewOfferByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBookInterviewArgs = {
  input: BookInterviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelInterviewBookingByIdArgs = {
  input: CancelInterviewBookingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelInterviewOfferByIdArgs = {
  input: CancelInterviewOfferByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUncancelInterviewOfferByIdArgs = {
  input: UncancelInterviewOfferByIdInput;
};

export interface MyAccount {
  __typename?: 'MyAccount';
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedPassword?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `MyAccount` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MyAccountCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `systemRole` field. */
  systemRole?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unlockToken` field. */
  unlockToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `lockedAt` field. */
  lockedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `MyAccount` object types. All fields are combined with a logical ‘and.’ */
export interface MyAccountFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<StringFilter>;
  /** Filter by the object’s `systemRole` field. */
  systemRole?: Maybe<StringFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<BooleanFilter>;
  /** Filter by the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<StringFilter>;
  /** Filter by the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<StringFilter>;
  /** Filter by the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<StringFilter>;
  /** Filter by the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<IntFilter>;
  /** Filter by the object’s `unlockToken` field. */
  unlockToken?: Maybe<StringFilter>;
  /** Filter by the object’s `lockedAt` field. */
  lockedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyAccountFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyAccountFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyAccountFilter>;
}

/** An input for mutations affecting `MyAccount` */
export interface MyAccountInput {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedPassword?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `MyAccount` values. */
export interface MyAccountsConnection {
  __typename?: 'MyAccountsConnection';
  /** A list of `MyAccount` objects. */
  nodes: Array<MyAccount>;
  /** A list of edges which contains the `MyAccount` and cursor to aid in pagination. */
  edges: Array<MyAccountsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyAccount` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyAccount` edge in the connection. */
export interface MyAccountsEdge {
  __typename?: 'MyAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyAccount` at the end of the edge. */
  node: MyAccount;
}

/** Methods to use when ordering `MyAccount`. */
export enum MyAccountsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  SystemRoleAsc = 'SYSTEM_ROLE_ASC',
  SystemRoleDesc = 'SYSTEM_ROLE_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  AutoGeneratedSystemRoleAsc = 'AUTO_GENERATED_SYSTEM_ROLE_ASC',
  AutoGeneratedSystemRoleDesc = 'AUTO_GENERATED_SYSTEM_ROLE_DESC',
  ResetPasswordTokenAsc = 'RESET_PASSWORD_TOKEN_ASC',
  ResetPasswordTokenDesc = 'RESET_PASSWORD_TOKEN_DESC',
  ResetPasswordSentAtAsc = 'RESET_PASSWORD_SENT_AT_ASC',
  ResetPasswordSentAtDesc = 'RESET_PASSWORD_SENT_AT_DESC',
  ConfirmationTokenAsc = 'CONFIRMATION_TOKEN_ASC',
  ConfirmationTokenDesc = 'CONFIRMATION_TOKEN_DESC',
  ConfirmedAtAsc = 'CONFIRMED_AT_ASC',
  ConfirmedAtDesc = 'CONFIRMED_AT_DESC',
  ConfirmationSentAtAsc = 'CONFIRMATION_SENT_AT_ASC',
  ConfirmationSentAtDesc = 'CONFIRMATION_SENT_AT_DESC',
  UnconfirmedEmailAsc = 'UNCONFIRMED_EMAIL_ASC',
  UnconfirmedEmailDesc = 'UNCONFIRMED_EMAIL_DESC',
  FailedAttemptsAsc = 'FAILED_ATTEMPTS_ASC',
  FailedAttemptsDesc = 'FAILED_ATTEMPTS_DESC',
  UnlockTokenAsc = 'UNLOCK_TOKEN_ASC',
  UnlockTokenDesc = 'UNLOCK_TOKEN_DESC',
  LockedAtAsc = 'LOCKED_AT_ASC',
  LockedAtDesc = 'LOCKED_AT_DESC',
  IsPatientAccountAsc = 'IS_PATIENT_ACCOUNT_ASC',
  IsPatientAccountDesc = 'IS_PATIENT_ACCOUNT_DESC',
  IsTherapistAccountAsc = 'IS_THERAPIST_ACCOUNT_ASC',
  IsTherapistAccountDesc = 'IS_THERAPIST_ACCOUNT_DESC',
  IsSupervisorAccountAsc = 'IS_SUPERVISOR_ACCOUNT_ASC',
  IsSupervisorAccountDesc = 'IS_SUPERVISOR_ACCOUNT_DESC',
  IsInterviewerAccountAsc = 'IS_INTERVIEWER_ACCOUNT_ASC',
  IsInterviewerAccountDesc = 'IS_INTERVIEWER_ACCOUNT_DESC'
}

export interface MyCase {
  __typename?: 'MyCase';
  id?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A condition to be used against `MyCase` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface MyCaseCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `MyCase` object types. All fields are combined with a logical ‘and.’ */
export interface MyCaseFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyCaseFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyCaseFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyCaseFilter>;
}

/** An input for mutations affecting `MyCase` */
export interface MyCaseInput {
  id?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `MyCase` values. */
export interface MyCasesConnection {
  __typename?: 'MyCasesConnection';
  /** A list of `MyCase` objects. */
  nodes: Array<MyCase>;
  /** A list of edges which contains the `MyCase` and cursor to aid in pagination. */
  edges: Array<MyCasesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyCase` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyCase` edge in the connection. */
export interface MyCasesEdge {
  __typename?: 'MyCasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyCase` at the end of the edge. */
  node: MyCase;
}

/** Methods to use when ordering `MyCase`. */
export enum MyCasesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export interface MyCasesOverview {
  __typename?: 'MyCasesOverview';
  shortId?: Maybe<Scalars['BigInt']>;
  caseId?: Maybe<Scalars['UUID']>;
  therapists?: Maybe<Scalars['String']>;
  interviewers?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  stage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  treatment?: Maybe<Scalars['String']>;
  suicideItem?: Maybe<Scalars['Int']>;
  item9CreatedAt?: Maybe<Scalars['Datetime']>;
  patientTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  nextTime?: Maybe<Scalars['Datetime']>;
  therapistTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  countOfOverdue?: Maybe<Scalars['BigInt']>;
}

export interface MyCasesOverview2 {
  __typename?: 'MyCasesOverview2';
  shortId?: Maybe<Scalars['BigInt']>;
  caseId?: Maybe<Scalars['UUID']>;
  therapists?: Maybe<Scalars['String']>;
  interviewers?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  stage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  treatment?: Maybe<Scalars['String']>;
  suicideItem?: Maybe<Scalars['Int']>;
  item9CreatedAt?: Maybe<Scalars['Datetime']>;
  patientTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  nextTime?: Maybe<Scalars['Datetime']>;
  therapistTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  countOfOverdue?: Maybe<Scalars['BigInt']>;
}

/**
 * A condition to be used against `MyCasesOverview2` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyCasesOverview2Condition {
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `therapists` field. */
  therapists?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `interviewers` field. */
  interviewers?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patient` field. */
  patient?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `treatment` field. */
  treatment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `suicideItem` field. */
  suicideItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9CreatedAt` field. */
  item9CreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `patientTaskCreatedAt` field. */
  patientTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nextTime` field. */
  nextTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `therapistTaskCreatedAt` field. */
  therapistTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `MyCasesOverview2` object types. All fields are combined with a logical ‘and.’ */
export interface MyCasesOverview2Filter {
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `therapists` field. */
  therapists?: Maybe<StringFilter>;
  /** Filter by the object’s `interviewers` field. */
  interviewers?: Maybe<StringFilter>;
  /** Filter by the object’s `patient` field. */
  patient?: Maybe<StringFilter>;
  /** Filter by the object’s `patientId` field. */
  patientId?: Maybe<UuidFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `treatment` field. */
  treatment?: Maybe<StringFilter>;
  /** Filter by the object’s `suicideItem` field. */
  suicideItem?: Maybe<IntFilter>;
  /** Filter by the object’s `item9CreatedAt` field. */
  item9CreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `patientTaskCreatedAt` field. */
  patientTaskCreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nextTime` field. */
  nextTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `therapistTaskCreatedAt` field. */
  therapistTaskCreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyCasesOverview2Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyCasesOverview2Filter>>;
  /** Negates the expression. */
  not?: Maybe<MyCasesOverview2Filter>;
}

/** A connection to a list of `MyCasesOverview2` values. */
export interface MyCasesOverview2SConnection {
  __typename?: 'MyCasesOverview2SConnection';
  /** A list of `MyCasesOverview2` objects. */
  nodes: Array<MyCasesOverview2>;
  /** A list of edges which contains the `MyCasesOverview2` and cursor to aid in pagination. */
  edges: Array<MyCasesOverview2SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyCasesOverview2` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyCasesOverview2` edge in the connection. */
export interface MyCasesOverview2SEdge {
  __typename?: 'MyCasesOverview2SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyCasesOverview2` at the end of the edge. */
  node: MyCasesOverview2;
}

/** Methods to use when ordering `MyCasesOverview2`. */
export enum MyCasesOverview2SOrderBy {
  Natural = 'NATURAL',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  TherapistsAsc = 'THERAPISTS_ASC',
  TherapistsDesc = 'THERAPISTS_DESC',
  InterviewersAsc = 'INTERVIEWERS_ASC',
  InterviewersDesc = 'INTERVIEWERS_DESC',
  PatientAsc = 'PATIENT_ASC',
  PatientDesc = 'PATIENT_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  TreatmentAsc = 'TREATMENT_ASC',
  TreatmentDesc = 'TREATMENT_DESC',
  SuicideItemAsc = 'SUICIDE_ITEM_ASC',
  SuicideItemDesc = 'SUICIDE_ITEM_DESC',
  Item_9CreatedAtAsc = 'ITEM_9_CREATED_AT_ASC',
  Item_9CreatedAtDesc = 'ITEM_9_CREATED_AT_DESC',
  PatientTaskCreatedAtAsc = 'PATIENT_TASK_CREATED_AT_ASC',
  PatientTaskCreatedAtDesc = 'PATIENT_TASK_CREATED_AT_DESC',
  NextTimeAsc = 'NEXT_TIME_ASC',
  NextTimeDesc = 'NEXT_TIME_DESC',
  TherapistTaskCreatedAtAsc = 'THERAPIST_TASK_CREATED_AT_ASC',
  TherapistTaskCreatedAtDesc = 'THERAPIST_TASK_CREATED_AT_DESC',
  CountOfOverdueAsc = 'COUNT_OF_OVERDUE_ASC',
  CountOfOverdueDesc = 'COUNT_OF_OVERDUE_DESC'
}

/**
 * A condition to be used against `MyCasesOverview` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyCasesOverviewCondition {
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `therapists` field. */
  therapists?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `interviewers` field. */
  interviewers?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patient` field. */
  patient?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `treatment` field. */
  treatment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `suicideItem` field. */
  suicideItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9CreatedAt` field. */
  item9CreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `patientTaskCreatedAt` field. */
  patientTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nextTime` field. */
  nextTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `therapistTaskCreatedAt` field. */
  therapistTaskCreatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `MyCasesOverview` object types. All fields are combined with a logical ‘and.’ */
export interface MyCasesOverviewFilter {
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `therapists` field. */
  therapists?: Maybe<StringFilter>;
  /** Filter by the object’s `interviewers` field. */
  interviewers?: Maybe<StringFilter>;
  /** Filter by the object’s `patient` field. */
  patient?: Maybe<StringFilter>;
  /** Filter by the object’s `patientId` field. */
  patientId?: Maybe<UuidFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: Maybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `treatment` field. */
  treatment?: Maybe<StringFilter>;
  /** Filter by the object’s `suicideItem` field. */
  suicideItem?: Maybe<IntFilter>;
  /** Filter by the object’s `item9CreatedAt` field. */
  item9CreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `patientTaskCreatedAt` field. */
  patientTaskCreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nextTime` field. */
  nextTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `therapistTaskCreatedAt` field. */
  therapistTaskCreatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `countOfOverdue` field. */
  countOfOverdue?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyCasesOverviewFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyCasesOverviewFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyCasesOverviewFilter>;
}

/** A connection to a list of `MyCasesOverview` values. */
export interface MyCasesOverviewsConnection {
  __typename?: 'MyCasesOverviewsConnection';
  /** A list of `MyCasesOverview` objects. */
  nodes: Array<MyCasesOverview>;
  /** A list of edges which contains the `MyCasesOverview` and cursor to aid in pagination. */
  edges: Array<MyCasesOverviewsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyCasesOverview` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyCasesOverview` edge in the connection. */
export interface MyCasesOverviewsEdge {
  __typename?: 'MyCasesOverviewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyCasesOverview` at the end of the edge. */
  node: MyCasesOverview;
}

/** Methods to use when ordering `MyCasesOverview`. */
export enum MyCasesOverviewsOrderBy {
  Natural = 'NATURAL',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  TherapistsAsc = 'THERAPISTS_ASC',
  TherapistsDesc = 'THERAPISTS_DESC',
  InterviewersAsc = 'INTERVIEWERS_ASC',
  InterviewersDesc = 'INTERVIEWERS_DESC',
  PatientAsc = 'PATIENT_ASC',
  PatientDesc = 'PATIENT_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  TreatmentAsc = 'TREATMENT_ASC',
  TreatmentDesc = 'TREATMENT_DESC',
  SuicideItemAsc = 'SUICIDE_ITEM_ASC',
  SuicideItemDesc = 'SUICIDE_ITEM_DESC',
  Item_9CreatedAtAsc = 'ITEM_9_CREATED_AT_ASC',
  Item_9CreatedAtDesc = 'ITEM_9_CREATED_AT_DESC',
  PatientTaskCreatedAtAsc = 'PATIENT_TASK_CREATED_AT_ASC',
  PatientTaskCreatedAtDesc = 'PATIENT_TASK_CREATED_AT_DESC',
  NextTimeAsc = 'NEXT_TIME_ASC',
  NextTimeDesc = 'NEXT_TIME_DESC',
  TherapistTaskCreatedAtAsc = 'THERAPIST_TASK_CREATED_AT_ASC',
  TherapistTaskCreatedAtDesc = 'THERAPIST_TASK_CREATED_AT_DESC',
  CountOfOverdueAsc = 'COUNT_OF_OVERDUE_ASC',
  CountOfOverdueDesc = 'COUNT_OF_OVERDUE_DESC'
}

export interface MyDate {
  __typename?: 'MyDate';
  id?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Case` that is related to this `MyDate`. */
  caseByCaseId?: Maybe<Case>;
}

/** A condition to be used against `MyDate` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface MyDateCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `MyDate` object types. All fields are combined with a logical ‘and.’ */
export interface MyDateFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyDateFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyDateFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyDateFilter>;
}

/** A connection to a list of `MyDate` values. */
export interface MyDatesConnection {
  __typename?: 'MyDatesConnection';
  /** A list of `MyDate` objects. */
  nodes: Array<MyDate>;
  /** A list of edges which contains the `MyDate` and cursor to aid in pagination. */
  edges: Array<MyDatesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyDate` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyDate` edge in the connection. */
export interface MyDatesEdge {
  __typename?: 'MyDatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyDate` at the end of the edge. */
  node: MyDate;
}

/** Methods to use when ordering `MyDate`. */
export enum MyDatesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export interface MyDueTask {
  __typename?: 'MyDueTask';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Datetime']>;
  due?: Maybe<Scalars['Datetime']>;
  followUp?: Maybe<Scalars['Datetime']>;
  delegationState?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  parentTaskId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  caseExecutionId?: Maybe<Scalars['String']>;
  caseDefinitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  taskIsSuspended?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  businessKey?: Maybe<Scalars['String']>;
  processIsSuspended?: Maybe<Scalars['Int']>;
  formFields?: Maybe<Scalars['JSON']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseId?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `MyDueTask` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MyDueTaskCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `created` field. */
  created?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUp` field. */
  followUp?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `delegationState` field. */
  delegationState?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionId` field. */
  executionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskIsSuspended` field. */
  taskIsSuspended?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processIsSuspended` field. */
  processIsSuspended?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `formFields` field. */
  formFields?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `roles` field. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
}

/** A filter to be used against `MyDueTask` object types. All fields are combined with a logical ‘and.’ */
export interface MyDueTaskFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `owner` field. */
  owner?: Maybe<StringFilter>;
  /** Filter by the object’s `created` field. */
  created?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUp` field. */
  followUp?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `delegationState` field. */
  delegationState?: Maybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `executionId` field. */
  executionId?: Maybe<StringFilter>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: Maybe<IntFilter>;
  /** Filter by the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `taskIsSuspended` field. */
  taskIsSuspended?: Maybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<IntFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processIsSuspended` field. */
  processIsSuspended?: Maybe<IntFilter>;
  /** Filter by the object’s `formFields` field. */
  formFields?: Maybe<JsonFilter>;
  /** Filter by the object’s `roles` field. */
  roles?: Maybe<StringListFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyDueTaskFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyDueTaskFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyDueTaskFilter>;
}

/** A connection to a list of `MyDueTask` values. */
export interface MyDueTasksConnection {
  __typename?: 'MyDueTasksConnection';
  /** A list of `MyDueTask` objects. */
  nodes: Array<MyDueTask>;
  /** A list of edges which contains the `MyDueTask` and cursor to aid in pagination. */
  edges: Array<MyDueTasksEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyDueTask` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyDueTask` edge in the connection. */
export interface MyDueTasksEdge {
  __typename?: 'MyDueTasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyDueTask` at the end of the edge. */
  node: MyDueTask;
}

/** Methods to use when ordering `MyDueTask`. */
export enum MyDueTasksOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  FollowUpAsc = 'FOLLOW_UP_ASC',
  FollowUpDesc = 'FOLLOW_UP_DESC',
  DelegationStateAsc = 'DELEGATION_STATE_ASC',
  DelegationStateDesc = 'DELEGATION_STATE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExecutionIdAsc = 'EXECUTION_ID_ASC',
  ExecutionIdDesc = 'EXECUTION_ID_DESC',
  ParentTaskIdAsc = 'PARENT_TASK_ID_ASC',
  ParentTaskIdDesc = 'PARENT_TASK_ID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProcessDefinitionIdAsc = 'PROCESS_DEFINITION_ID_ASC',
  ProcessDefinitionIdDesc = 'PROCESS_DEFINITION_ID_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseExecutionIdAsc = 'CASE_EXECUTION_ID_ASC',
  CaseExecutionIdDesc = 'CASE_EXECUTION_ID_DESC',
  CaseDefinitionIdAsc = 'CASE_DEFINITION_ID_ASC',
  CaseDefinitionIdDesc = 'CASE_DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  TaskIsSuspendedAsc = 'TASK_IS_SUSPENDED_ASC',
  TaskIsSuspendedDesc = 'TASK_IS_SUSPENDED_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ProcessDefinitionKeyAsc = 'PROCESS_DEFINITION_KEY_ASC',
  ProcessDefinitionKeyDesc = 'PROCESS_DEFINITION_KEY_DESC',
  ProcessDefinitionVersionAsc = 'PROCESS_DEFINITION_VERSION_ASC',
  ProcessDefinitionVersionDesc = 'PROCESS_DEFINITION_VERSION_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  ProcessIsSuspendedAsc = 'PROCESS_IS_SUSPENDED_ASC',
  ProcessIsSuspendedDesc = 'PROCESS_IS_SUSPENDED_DESC',
  FormFieldsAsc = 'FORM_FIELDS_ASC',
  FormFieldsDesc = 'FORM_FIELDS_DESC',
  RolesAsc = 'ROLES_ASC',
  RolesDesc = 'ROLES_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC'
}

export interface MyGateway {
  __typename?: 'MyGateway';
  id?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  firstTokenAt?: Maybe<Scalars['Datetime']>;
  lastTokenAt?: Maybe<Scalars['Datetime']>;
  numberOfTokens?: Maybe<Scalars['BigInt']>;
  endTime?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `MyGateway` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MyGatewayCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityId` field. */
  activityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstTokenAt` field. */
  firstTokenAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `lastTokenAt` field. */
  lastTokenAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `numberOfTokens` field. */
  numberOfTokens?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `MyGateway` object types. All fields are combined with a logical ‘and.’ */
export interface MyGatewayFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `activityId` field. */
  activityId?: Maybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: Maybe<StringFilter>;
  /** Filter by the object’s `firstTokenAt` field. */
  firstTokenAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `lastTokenAt` field. */
  lastTokenAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `numberOfTokens` field. */
  numberOfTokens?: Maybe<BigIntFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyGatewayFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyGatewayFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyGatewayFilter>;
}

/** A connection to a list of `MyGateway` values. */
export interface MyGatewaysConnection {
  __typename?: 'MyGatewaysConnection';
  /** A list of `MyGateway` objects. */
  nodes: Array<MyGateway>;
  /** A list of edges which contains the `MyGateway` and cursor to aid in pagination. */
  edges: Array<MyGatewaysEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyGateway` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyGateway` edge in the connection. */
export interface MyGatewaysEdge {
  __typename?: 'MyGatewaysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyGateway` at the end of the edge. */
  node: MyGateway;
}

/** Methods to use when ordering `MyGateway`. */
export enum MyGatewaysOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  ActivityIdAsc = 'ACTIVITY_ID_ASC',
  ActivityIdDesc = 'ACTIVITY_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  FirstTokenAtAsc = 'FIRST_TOKEN_AT_ASC',
  FirstTokenAtDesc = 'FIRST_TOKEN_AT_DESC',
  LastTokenAtAsc = 'LAST_TOKEN_AT_ASC',
  LastTokenAtDesc = 'LAST_TOKEN_AT_DESC',
  NumberOfTokensAsc = 'NUMBER_OF_TOKENS_ASC',
  NumberOfTokensDesc = 'NUMBER_OF_TOKENS_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC'
}

export interface MyHistoricIdentitylink {
  __typename?: 'MyHistoricIdentitylink';
  processInstanceId?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  taskId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  /** Reads a single `CaseMember` that is related to this `MyHistoricIdentitylink`. */
  caseMember?: Maybe<CaseMember>;
  /** Reads a single `Case` that is related to this `MyHistoricIdentitylink`. */
  case?: Maybe<Case>;
  /** Reads a single `MyProcessLog` that is related to this `MyHistoricIdentitylink`. */
  process?: Maybe<MyProcessLog>;
  /** Reads a single `MyTaskLog` that is related to this `MyHistoricIdentitylink`. */
  task?: Maybe<MyTaskLog>;
}

/**
 * A condition to be used against `MyHistoricIdentitylink` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface MyHistoricIdentitylinkCondition {
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: Maybe<Scalars['String']>;
}

/** A filter to be used against `MyHistoricIdentitylink` object types. All fields are combined with a logical ‘and.’ */
export interface MyHistoricIdentitylinkFilter {
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: Maybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyHistoricIdentitylinkFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyHistoricIdentitylinkFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyHistoricIdentitylinkFilter>;
}

/** A connection to a list of `MyHistoricIdentitylink` values. */
export interface MyHistoricIdentitylinksConnection {
  __typename?: 'MyHistoricIdentitylinksConnection';
  /** A list of `MyHistoricIdentitylink` objects. */
  nodes: Array<MyHistoricIdentitylink>;
  /** A list of edges which contains the `MyHistoricIdentitylink` and cursor to aid in pagination. */
  edges: Array<MyHistoricIdentitylinksEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyHistoricIdentitylink` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyHistoricIdentitylink` edge in the connection. */
export interface MyHistoricIdentitylinksEdge {
  __typename?: 'MyHistoricIdentitylinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyHistoricIdentitylink` at the end of the edge. */
  node: MyHistoricIdentitylink;
}

/** Methods to use when ordering `MyHistoricIdentitylink`. */
export enum MyHistoricIdentitylinksOrderBy {
  Natural = 'NATURAL',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export interface MyInterviewBooking {
  __typename?: 'MyInterviewBooking';
  id?: Maybe<Scalars['UUID']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  offerId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `MyInterviewBooking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyInterviewBookingCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `MyInterviewBooking` object types. All fields are combined with a logical ‘and.’ */
export interface MyInterviewBookingFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `intervieweeId` field. */
  intervieweeId?: Maybe<UuidFilter>;
  /** Filter by the object’s `offerId` field. */
  offerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyInterviewBookingFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyInterviewBookingFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyInterviewBookingFilter>;
}

/** An input for mutations affecting `MyInterviewBooking` */
export interface MyInterviewBookingInput {
  id?: Maybe<Scalars['UUID']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['UUID']>;
  intervieweeId?: Maybe<Scalars['UUID']>;
  offerId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `MyInterviewBooking` values. */
export interface MyInterviewBookingsConnection {
  __typename?: 'MyInterviewBookingsConnection';
  /** A list of `MyInterviewBooking` objects. */
  nodes: Array<MyInterviewBooking>;
  /** A list of edges which contains the `MyInterviewBooking` and cursor to aid in pagination. */
  edges: Array<MyInterviewBookingsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyInterviewBooking` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyInterviewBooking` edge in the connection. */
export interface MyInterviewBookingsEdge {
  __typename?: 'MyInterviewBookingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyInterviewBooking` at the end of the edge. */
  node: MyInterviewBooking;
}

/** Methods to use when ordering `MyInterviewBooking`. */
export enum MyInterviewBookingsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  IntervieweeIdAsc = 'INTERVIEWEE_ID_ASC',
  IntervieweeIdDesc = 'INTERVIEWEE_ID_DESC',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export interface MyInterviewOffer {
  __typename?: 'MyInterviewOffer';
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRange>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/**
 * A condition to be used against `MyInterviewOffer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyInterviewOfferCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interviewerId` field. */
  interviewerId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `externalLink` field. */
  externalLink?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceled` field. */
  canceled?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canceledAt` field. */
  canceledAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `MyInterviewOffer` object types. All fields are combined with a logical ‘and.’ */
export interface MyInterviewOfferFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `interviewerId` field. */
  interviewerId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeSlot` field. */
  timeSlot?: Maybe<DatetimeRangeFilter>;
  /** Filter by the object’s `externalLink` field. */
  externalLink?: Maybe<StringFilter>;
  /** Filter by the object’s `hasTakenPlace` field. */
  hasTakenPlace?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceled` field. */
  canceled?: Maybe<BooleanFilter>;
  /** Filter by the object’s `canceledAt` field. */
  canceledAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyInterviewOfferFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyInterviewOfferFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyInterviewOfferFilter>;
}

/** An input for mutations affecting `MyInterviewOffer` */
export interface MyInterviewOfferInput {
  id?: Maybe<Scalars['UUID']>;
  interviewerId?: Maybe<Scalars['UUID']>;
  timeSlot?: Maybe<DatetimeRangeInput>;
  externalLink?: Maybe<Scalars['String']>;
  hasTakenPlace?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `MyInterviewOffer` values. */
export interface MyInterviewOffersConnection {
  __typename?: 'MyInterviewOffersConnection';
  /** A list of `MyInterviewOffer` objects. */
  nodes: Array<MyInterviewOffer>;
  /** A list of edges which contains the `MyInterviewOffer` and cursor to aid in pagination. */
  edges: Array<MyInterviewOffersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyInterviewOffer` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyInterviewOffer` edge in the connection. */
export interface MyInterviewOffersEdge {
  __typename?: 'MyInterviewOffersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyInterviewOffer` at the end of the edge. */
  node: MyInterviewOffer;
}

/** Methods to use when ordering `MyInterviewOffer`. */
export enum MyInterviewOffersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InterviewerIdAsc = 'INTERVIEWER_ID_ASC',
  InterviewerIdDesc = 'INTERVIEWER_ID_DESC',
  TimeSlotAsc = 'TIME_SLOT_ASC',
  TimeSlotDesc = 'TIME_SLOT_DESC',
  ExternalLinkAsc = 'EXTERNAL_LINK_ASC',
  ExternalLinkDesc = 'EXTERNAL_LINK_DESC',
  HasTakenPlaceAsc = 'HAS_TAKEN_PLACE_ASC',
  HasTakenPlaceDesc = 'HAS_TAKEN_PLACE_DESC',
  CanceledAsc = 'CANCELED_ASC',
  CanceledDesc = 'CANCELED_DESC',
  CanceledAtAsc = 'CANCELED_AT_ASC',
  CanceledAtDesc = 'CANCELED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export interface MyInvolvement {
  __typename?: 'MyInvolvement';
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Case` that is related to this `MyInvolvement`. */
  caseById?: Maybe<Case>;
  /**
   * Reads and enables pagination through a set of `Case`.
   * @deprecated Please use caseById instead
   */
  casesById: CasesConnection;
}


export type MyInvolvementCasesByIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CasesOrderBy>>;
  condition?: Maybe<CaseCondition>;
  filter?: Maybe<CaseFilter>;
};

/**
 * A condition to be used against `MyInvolvement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyInvolvementCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userAlias` field. */
  userAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseAlias` field. */
  caseAlias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `MyInvolvement` object types. All fields are combined with a logical ‘and.’ */
export interface MyInvolvementFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `userAlias` field. */
  userAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `caseAlias` field. */
  caseAlias?: Maybe<StringFilter>;
  /** Filter by the object’s `actsAsTherapist` field. */
  actsAsTherapist?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsSupervisor` field. */
  actsAsSupervisor?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsPatient` field. */
  actsAsPatient?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsInterviewer` field. */
  actsAsInterviewer?: Maybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `actsAsSupporter` field. */
  actsAsSupporter?: Maybe<BooleanFilter>;
  /** Filter by the object’s `newMessagesAfter` field. */
  newMessagesAfter?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actsAsCounselor` field. */
  actsAsCounselor?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyInvolvementFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyInvolvementFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyInvolvementFilter>;
}

/** An input for mutations affecting `MyInvolvement` */
export interface MyInvolvementInput {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `MyInvolvement`. Fields that are set will be updated. */
export interface MyInvolvementPatch {
  id?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  userAlias?: Maybe<Scalars['String']>;
  caseAlias?: Maybe<Scalars['String']>;
  actsAsTherapist?: Maybe<Scalars['Boolean']>;
  actsAsSupervisor?: Maybe<Scalars['Boolean']>;
  actsAsPatient?: Maybe<Scalars['Boolean']>;
  actsAsInterviewer?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  actsAsSupporter?: Maybe<Scalars['Boolean']>;
  newMessagesAfter?: Maybe<Scalars['Datetime']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
  actsAsCounselor?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `MyInvolvement` values. */
export interface MyInvolvementsConnection {
  __typename?: 'MyInvolvementsConnection';
  /** A list of `MyInvolvement` objects. */
  nodes: Array<MyInvolvement>;
  /** A list of edges which contains the `MyInvolvement` and cursor to aid in pagination. */
  edges: Array<MyInvolvementsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyInvolvement` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyInvolvement` edge in the connection. */
export interface MyInvolvementsEdge {
  __typename?: 'MyInvolvementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyInvolvement` at the end of the edge. */
  node: MyInvolvement;
}

/** Methods to use when ordering `MyInvolvement`. */
export enum MyInvolvementsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  UserAliasAsc = 'USER_ALIAS_ASC',
  UserAliasDesc = 'USER_ALIAS_DESC',
  CaseAliasAsc = 'CASE_ALIAS_ASC',
  CaseAliasDesc = 'CASE_ALIAS_DESC',
  ActsAsTherapistAsc = 'ACTS_AS_THERAPIST_ASC',
  ActsAsTherapistDesc = 'ACTS_AS_THERAPIST_DESC',
  ActsAsSupervisorAsc = 'ACTS_AS_SUPERVISOR_ASC',
  ActsAsSupervisorDesc = 'ACTS_AS_SUPERVISOR_DESC',
  ActsAsPatientAsc = 'ACTS_AS_PATIENT_ASC',
  ActsAsPatientDesc = 'ACTS_AS_PATIENT_DESC',
  ActsAsInterviewerAsc = 'ACTS_AS_INTERVIEWER_ASC',
  ActsAsInterviewerDesc = 'ACTS_AS_INTERVIEWER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ActsAsSupporterAsc = 'ACTS_AS_SUPPORTER_ASC',
  ActsAsSupporterDesc = 'ACTS_AS_SUPPORTER_DESC',
  NewMessagesAfterAsc = 'NEW_MESSAGES_AFTER_ASC',
  NewMessagesAfterDesc = 'NEW_MESSAGES_AFTER_DESC',
  FavoriteMessageAsc = 'FAVORITE_MESSAGE_ASC',
  FavoriteMessageDesc = 'FAVORITE_MESSAGE_DESC',
  ActsAsCounselorAsc = 'ACTS_AS_COUNSELOR_ASC',
  ActsAsCounselorDesc = 'ACTS_AS_COUNSELOR_DESC'
}

export interface MyMessage {
  __typename?: 'MyMessage';
  id?: Maybe<Scalars['UUID']>;
  shortId?: Maybe<Scalars['BigInt']>;
  messagecount?: Maybe<Scalars['BigInt']>;
  lastSentDate?: Maybe<Scalars['Datetime']>;
  title?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
}

/**
 * A condition to be used against `MyMessage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MyMessageCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `messagecount` field. */
  messagecount?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lastSentDate` field. */
  lastSentDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `MyMessage` object types. All fields are combined with a logical ‘and.’ */
export interface MyMessageFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `messagecount` field. */
  messagecount?: Maybe<BigIntFilter>;
  /** Filter by the object’s `lastSentDate` field. */
  lastSentDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: Maybe<StringFilter>;
  /** Filter by the object’s `favoriteMessage` field. */
  favoriteMessage?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyMessageFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyMessageFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyMessageFilter>;
}

/** A connection to a list of `MyMessage` values. */
export interface MyMessagesConnection {
  __typename?: 'MyMessagesConnection';
  /** A list of `MyMessage` objects. */
  nodes: Array<MyMessage>;
  /** A list of edges which contains the `MyMessage` and cursor to aid in pagination. */
  edges: Array<MyMessagesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyMessage` edge in the connection. */
export interface MyMessagesEdge {
  __typename?: 'MyMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyMessage` at the end of the edge. */
  node: MyMessage;
}

/** All input for the `myMessagesFun` mutation. */
export interface MyMessagesFunInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
}

/** The output of our `myMessagesFun` mutation. */
export interface MyMessagesFunPayload {
  __typename?: 'MyMessagesFunPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<MyMessagesFunRecord>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `myMessagesFun` mutation. */
export interface MyMessagesFunRecord {
  __typename?: 'MyMessagesFunRecord';
  id?: Maybe<Scalars['UUID']>;
  shortId?: Maybe<Scalars['BigInt']>;
  messagecount?: Maybe<Scalars['BigInt']>;
  lastSentDate?: Maybe<Scalars['Datetime']>;
  title?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  favoriteMessage?: Maybe<Scalars['Boolean']>;
}

/** Methods to use when ordering `MyMessage`. */
export enum MyMessagesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  MessagecountAsc = 'MESSAGECOUNT_ASC',
  MessagecountDesc = 'MESSAGECOUNT_DESC',
  LastSentDateAsc = 'LAST_SENT_DATE_ASC',
  LastSentDateDesc = 'LAST_SENT_DATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  FavoriteMessageAsc = 'FAVORITE_MESSAGE_ASC',
  FavoriteMessageDesc = 'FAVORITE_MESSAGE_DESC'
}

export interface MyProcessLog {
  __typename?: 'MyProcessLog';
  id?: Maybe<Scalars['String']>;
  rootInstanceId?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  definitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  definitionKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  versionTag?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['String']>;
  startActivityId?: Maybe<Scalars['String']>;
  endActivityId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  removalTime?: Maybe<Scalars['Datetime']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
  superInstanceId?: Maybe<Scalars['String']>;
  startUserId?: Maybe<Scalars['String']>;
  superCaseInstanceId?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `DueCandidateLink`. */
  dueCandidateLinksByProcessInstanceId: DueCandidateLinksConnection;
  /** Reads and enables pagination through a set of `DueTask`. */
  dueTasksByProcessInstanceId: DueTasksConnection;
  /** Reads and enables pagination through a set of `MyHistoricIdentitylink`. */
  myHistoricIdentitylinksByProcessInstanceId: MyHistoricIdentitylinksConnection;
  /** Reads and enables pagination through a set of `MyTaskLog`. */
  myTaskLogsByProcessInstanceId: MyTaskLogsConnection;
}


export type MyProcessLogDueCandidateLinksByProcessInstanceIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueCandidateLinksOrderBy>>;
  condition?: Maybe<DueCandidateLinkCondition>;
  filter?: Maybe<DueCandidateLinkFilter>;
};


export type MyProcessLogDueTasksByProcessInstanceIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueTasksOrderBy>>;
  condition?: Maybe<DueTaskCondition>;
  filter?: Maybe<DueTaskFilter>;
};


export type MyProcessLogMyHistoricIdentitylinksByProcessInstanceIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyHistoricIdentitylinksOrderBy>>;
  condition?: Maybe<MyHistoricIdentitylinkCondition>;
  filter?: Maybe<MyHistoricIdentitylinkFilter>;
};


export type MyProcessLogMyTaskLogsByProcessInstanceIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogsOrderBy>>;
  condition?: Maybe<MyTaskLogCondition>;
  filter?: Maybe<MyTaskLogFilter>;
};

/**
 * A condition to be used against `MyProcessLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyProcessLogCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `rootInstanceId` field. */
  rootInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `definitionKey` field. */
  definitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `version` field. */
  version?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `versionTag` field. */
  versionTag?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startActivityId` field. */
  startActivityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `endActivityId` field. */
  endActivityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `removalTime` field. */
  removalTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `state` field. */
  state?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `superInstanceId` field. */
  superInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startUserId` field. */
  startUserId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `superCaseInstanceId` field. */
  superCaseInstanceId?: Maybe<Scalars['String']>;
}

/** A filter to be used against `MyProcessLog` object types. All fields are combined with a logical ‘and.’ */
export interface MyProcessLogFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `rootInstanceId` field. */
  rootInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `definitionKey` field. */
  definitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `version` field. */
  version?: Maybe<IntFilter>;
  /** Filter by the object’s `versionTag` field. */
  versionTag?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Filter by the object’s `startActivityId` field. */
  startActivityId?: Maybe<StringFilter>;
  /** Filter by the object’s `endActivityId` field. */
  endActivityId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `removalTime` field. */
  removalTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Filter by the object’s `state` field. */
  state?: Maybe<StringFilter>;
  /** Filter by the object’s `superInstanceId` field. */
  superInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `startUserId` field. */
  startUserId?: Maybe<StringFilter>;
  /** Filter by the object’s `superCaseInstanceId` field. */
  superCaseInstanceId?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyProcessLogFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyProcessLogFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyProcessLogFilter>;
}

/** A connection to a list of `MyProcessLog` values. */
export interface MyProcessLogsConnection {
  __typename?: 'MyProcessLogsConnection';
  /** A list of `MyProcessLog` objects. */
  nodes: Array<MyProcessLog>;
  /** A list of edges which contains the `MyProcessLog` and cursor to aid in pagination. */
  edges: Array<MyProcessLogsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyProcessLog` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyProcessLog` edge in the connection. */
export interface MyProcessLogsEdge {
  __typename?: 'MyProcessLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyProcessLog` at the end of the edge. */
  node: MyProcessLog;
}

/** Methods to use when ordering `MyProcessLog`. */
export enum MyProcessLogsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  RootInstanceIdAsc = 'ROOT_INSTANCE_ID_ASC',
  RootInstanceIdDesc = 'ROOT_INSTANCE_ID_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  DefinitionIdAsc = 'DEFINITION_ID_ASC',
  DefinitionIdDesc = 'DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  DefinitionKeyAsc = 'DEFINITION_KEY_ASC',
  DefinitionKeyDesc = 'DEFINITION_KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC',
  VersionTagAsc = 'VERSION_TAG_ASC',
  VersionTagDesc = 'VERSION_TAG_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  StartActivityIdAsc = 'START_ACTIVITY_ID_ASC',
  StartActivityIdDesc = 'START_ACTIVITY_ID_DESC',
  EndActivityIdAsc = 'END_ACTIVITY_ID_ASC',
  EndActivityIdDesc = 'END_ACTIVITY_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  RemovalTimeAsc = 'REMOVAL_TIME_ASC',
  RemovalTimeDesc = 'REMOVAL_TIME_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  SuperInstanceIdAsc = 'SUPER_INSTANCE_ID_ASC',
  SuperInstanceIdDesc = 'SUPER_INSTANCE_ID_DESC',
  StartUserIdAsc = 'START_USER_ID_ASC',
  StartUserIdDesc = 'START_USER_ID_DESC',
  SuperCaseInstanceIdAsc = 'SUPER_CASE_INSTANCE_ID_ASC',
  SuperCaseInstanceIdDesc = 'SUPER_CASE_INSTANCE_ID_DESC'
}

export interface MyRunningProcess {
  __typename?: 'MyRunningProcess';
  id?: Maybe<Scalars['String']>;
  rev?: Maybe<Scalars['Int']>;
  rootInstanceId?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  definitionId?: Maybe<Scalars['String']>;
  superExecution?: Maybe<Scalars['String']>;
  superCaseExecution?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  currentActivityId?: Maybe<Scalars['String']>;
  activityInstanceId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConcurrent?: Maybe<Scalars['Boolean']>;
  isScope?: Maybe<Scalars['Boolean']>;
  isEventScope?: Maybe<Scalars['Boolean']>;
  suspensionState?: Maybe<Scalars['Int']>;
  cachedEntState?: Maybe<Scalars['Int']>;
  sequenceCounter?: Maybe<Scalars['BigInt']>;
  tenantId?: Maybe<Scalars['String']>;
  definitionKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  versionTag?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['String']>;
  pendingTimers?: Maybe<Scalars['JSON']>;
  eventSubscriptions?: Maybe<Scalars['JSON']>;
  waitingGateways?: Maybe<Scalars['JSON']>;
  superInstanceId?: Maybe<Scalars['String']>;
  startUserId?: Maybe<Scalars['String']>;
  superCaseInstanceId?: Maybe<Scalars['String']>;
  startActivityId?: Maybe<Scalars['String']>;
  endActivityId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  removalTime?: Maybe<Scalars['Datetime']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `MyRunningProcess` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyRunningProcessCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `rev` field. */
  rev?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `rootInstanceId` field. */
  rootInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `superExecution` field. */
  superExecution?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `superCaseExecution` field. */
  superCaseExecution?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `currentActivityId` field. */
  currentActivityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isConcurrent` field. */
  isConcurrent?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isScope` field. */
  isScope?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isEventScope` field. */
  isEventScope?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `suspensionState` field. */
  suspensionState?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cachedEntState` field. */
  cachedEntState?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sequenceCounter` field. */
  sequenceCounter?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `definitionKey` field. */
  definitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `version` field. */
  version?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `versionTag` field. */
  versionTag?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `pendingTimers` field. */
  pendingTimers?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `eventSubscriptions` field. */
  eventSubscriptions?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `waitingGateways` field. */
  waitingGateways?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `superInstanceId` field. */
  superInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startUserId` field. */
  startUserId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `superCaseInstanceId` field. */
  superCaseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startActivityId` field. */
  startActivityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `endActivityId` field. */
  endActivityId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `removalTime` field. */
  removalTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `state` field. */
  state?: Maybe<Scalars['String']>;
}

/** A connection to a list of `MyRunningProcess` values. */
export interface MyRunningProcessesConnection {
  __typename?: 'MyRunningProcessesConnection';
  /** A list of `MyRunningProcess` objects. */
  nodes: Array<MyRunningProcess>;
  /** A list of edges which contains the `MyRunningProcess` and cursor to aid in pagination. */
  edges: Array<MyRunningProcessesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyRunningProcess` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyRunningProcess` edge in the connection. */
export interface MyRunningProcessesEdge {
  __typename?: 'MyRunningProcessesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyRunningProcess` at the end of the edge. */
  node: MyRunningProcess;
}

/** Methods to use when ordering `MyRunningProcess`. */
export enum MyRunningProcessesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  RevAsc = 'REV_ASC',
  RevDesc = 'REV_DESC',
  RootInstanceIdAsc = 'ROOT_INSTANCE_ID_ASC',
  RootInstanceIdDesc = 'ROOT_INSTANCE_ID_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  DefinitionIdAsc = 'DEFINITION_ID_ASC',
  DefinitionIdDesc = 'DEFINITION_ID_DESC',
  SuperExecutionAsc = 'SUPER_EXECUTION_ASC',
  SuperExecutionDesc = 'SUPER_EXECUTION_DESC',
  SuperCaseExecutionAsc = 'SUPER_CASE_EXECUTION_ASC',
  SuperCaseExecutionDesc = 'SUPER_CASE_EXECUTION_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  CurrentActivityIdAsc = 'CURRENT_ACTIVITY_ID_ASC',
  CurrentActivityIdDesc = 'CURRENT_ACTIVITY_ID_DESC',
  ActivityInstanceIdAsc = 'ACTIVITY_INSTANCE_ID_ASC',
  ActivityInstanceIdDesc = 'ACTIVITY_INSTANCE_ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  IsConcurrentAsc = 'IS_CONCURRENT_ASC',
  IsConcurrentDesc = 'IS_CONCURRENT_DESC',
  IsScopeAsc = 'IS_SCOPE_ASC',
  IsScopeDesc = 'IS_SCOPE_DESC',
  IsEventScopeAsc = 'IS_EVENT_SCOPE_ASC',
  IsEventScopeDesc = 'IS_EVENT_SCOPE_DESC',
  SuspensionStateAsc = 'SUSPENSION_STATE_ASC',
  SuspensionStateDesc = 'SUSPENSION_STATE_DESC',
  CachedEntStateAsc = 'CACHED_ENT_STATE_ASC',
  CachedEntStateDesc = 'CACHED_ENT_STATE_DESC',
  SequenceCounterAsc = 'SEQUENCE_COUNTER_ASC',
  SequenceCounterDesc = 'SEQUENCE_COUNTER_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  DefinitionKeyAsc = 'DEFINITION_KEY_ASC',
  DefinitionKeyDesc = 'DEFINITION_KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC',
  VersionTagAsc = 'VERSION_TAG_ASC',
  VersionTagDesc = 'VERSION_TAG_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  PendingTimersAsc = 'PENDING_TIMERS_ASC',
  PendingTimersDesc = 'PENDING_TIMERS_DESC',
  EventSubscriptionsAsc = 'EVENT_SUBSCRIPTIONS_ASC',
  EventSubscriptionsDesc = 'EVENT_SUBSCRIPTIONS_DESC',
  WaitingGatewaysAsc = 'WAITING_GATEWAYS_ASC',
  WaitingGatewaysDesc = 'WAITING_GATEWAYS_DESC',
  SuperInstanceIdAsc = 'SUPER_INSTANCE_ID_ASC',
  SuperInstanceIdDesc = 'SUPER_INSTANCE_ID_DESC',
  StartUserIdAsc = 'START_USER_ID_ASC',
  StartUserIdDesc = 'START_USER_ID_DESC',
  SuperCaseInstanceIdAsc = 'SUPER_CASE_INSTANCE_ID_ASC',
  SuperCaseInstanceIdDesc = 'SUPER_CASE_INSTANCE_ID_DESC',
  StartActivityIdAsc = 'START_ACTIVITY_ID_ASC',
  StartActivityIdDesc = 'START_ACTIVITY_ID_DESC',
  EndActivityIdAsc = 'END_ACTIVITY_ID_ASC',
  EndActivityIdDesc = 'END_ACTIVITY_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  RemovalTimeAsc = 'REMOVAL_TIME_ASC',
  RemovalTimeDesc = 'REMOVAL_TIME_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC'
}

/** A filter to be used against `MyRunningProcess` object types. All fields are combined with a logical ‘and.’ */
export interface MyRunningProcessFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `rev` field. */
  rev?: Maybe<IntFilter>;
  /** Filter by the object’s `rootInstanceId` field. */
  rootInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `superExecution` field. */
  superExecution?: Maybe<StringFilter>;
  /** Filter by the object’s `superCaseExecution` field. */
  superCaseExecution?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `currentActivityId` field. */
  currentActivityId?: Maybe<StringFilter>;
  /** Filter by the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isConcurrent` field. */
  isConcurrent?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isScope` field. */
  isScope?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isEventScope` field. */
  isEventScope?: Maybe<BooleanFilter>;
  /** Filter by the object’s `suspensionState` field. */
  suspensionState?: Maybe<IntFilter>;
  /** Filter by the object’s `cachedEntState` field. */
  cachedEntState?: Maybe<IntFilter>;
  /** Filter by the object’s `sequenceCounter` field. */
  sequenceCounter?: Maybe<BigIntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `definitionKey` field. */
  definitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `version` field. */
  version?: Maybe<IntFilter>;
  /** Filter by the object’s `versionTag` field. */
  versionTag?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Filter by the object’s `superInstanceId` field. */
  superInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `startUserId` field. */
  startUserId?: Maybe<StringFilter>;
  /** Filter by the object’s `superCaseInstanceId` field. */
  superCaseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `startActivityId` field. */
  startActivityId?: Maybe<StringFilter>;
  /** Filter by the object’s `endActivityId` field. */
  endActivityId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `removalTime` field. */
  removalTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Filter by the object’s `state` field. */
  state?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyRunningProcessFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyRunningProcessFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyRunningProcessFilter>;
}

export interface MyTaskLog extends Node {
  __typename?: 'MyTaskLog';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['Datetime']>;
  followUp?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  parentTaskId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  caseExecutionId?: Maybe<Scalars['String']>;
  caseDefinitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  businessKey?: Maybe<Scalars['String']>;
  formFields?: Maybe<Scalars['JSON']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseId?: Maybe<Scalars['UUID']>;
  caseDefinitionKey?: Maybe<Scalars['String']>;
  activityInstanceId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
  localVariables?: Maybe<Scalars['JSON']>;
  /** Reads a single `Case` that is related to this `MyTaskLog`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `MyProcessLog` that is related to this `MyTaskLog`. */
  myProcessLogByProcessInstanceId?: Maybe<MyProcessLog>;
  /** Reads and enables pagination through a set of `MyHistoricIdentitylink`. */
  myHistoricIdentitylinksByTaskId: MyHistoricIdentitylinksConnection;
  amICandidating?: Maybe<Scalars['Boolean']>;
  isPatientTask?: Maybe<Scalars['Boolean']>;
}


export type MyTaskLogMyHistoricIdentitylinksByTaskIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyHistoricIdentitylinksOrderBy>>;
  condition?: Maybe<MyHistoricIdentitylinkCondition>;
  filter?: Maybe<MyHistoricIdentitylinkFilter>;
};

/**
 * A condition to be used against `MyTaskLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface MyTaskLogCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUp` field. */
  followUp?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionId` field. */
  executionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `formFields` field. */
  formFields?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `roles` field. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `localVariables` field. */
  localVariables?: Maybe<Scalars['JSON']>;
}

/** A filter to be used against `MyTaskLog` object types. All fields are combined with a logical ‘and.’ */
export interface MyTaskLogFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `owner` field. */
  owner?: Maybe<StringFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUp` field. */
  followUp?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `executionId` field. */
  executionId?: Maybe<StringFilter>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: Maybe<IntFilter>;
  /** Filter by the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<IntFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `formFields` field. */
  formFields?: Maybe<JsonFilter>;
  /** Filter by the object’s `roles` field. */
  roles?: Maybe<StringListFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Filter by the object’s `localVariables` field. */
  localVariables?: Maybe<JsonFilter>;
  /** Filter by the object’s `amICandidating` field. */
  amICandidating?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isPatientTask` field. */
  isPatientTask?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyTaskLogFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyTaskLogFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyTaskLogFilter>;
}

export interface MyTaskLogOpt {
  __typename?: 'MyTaskLogOpt';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['Datetime']>;
  followUp?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  parentTaskId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  caseExecutionId?: Maybe<Scalars['String']>;
  caseDefinitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  businessKey?: Maybe<Scalars['String']>;
  formFields?: Maybe<Scalars['JSON']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseId?: Maybe<Scalars['String']>;
  caseDefinitionKey?: Maybe<Scalars['String']>;
  activityInstanceId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
}

export interface MyTaskLogOpt3 {
  __typename?: 'MyTaskLogOpt3';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['Datetime']>;
  followUp?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  parentTaskId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  caseExecutionId?: Maybe<Scalars['String']>;
  caseDefinitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  businessKey?: Maybe<Scalars['String']>;
  formFields?: Maybe<Scalars['JSON']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseId?: Maybe<Scalars['UUID']>;
  caseDefinitionKey?: Maybe<Scalars['String']>;
  activityInstanceId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
  localVariables?: Maybe<Scalars['JSON']>;
}

/**
 * A condition to be used against `MyTaskLogOpt3` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyTaskLogOpt3Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUp` field. */
  followUp?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionId` field. */
  executionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `formFields` field. */
  formFields?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `roles` field. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `localVariables` field. */
  localVariables?: Maybe<Scalars['JSON']>;
}

/** A filter to be used against `MyTaskLogOpt3` object types. All fields are combined with a logical ‘and.’ */
export interface MyTaskLogOpt3Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `owner` field. */
  owner?: Maybe<StringFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUp` field. */
  followUp?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `executionId` field. */
  executionId?: Maybe<StringFilter>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: Maybe<IntFilter>;
  /** Filter by the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<IntFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `formFields` field. */
  formFields?: Maybe<JsonFilter>;
  /** Filter by the object’s `roles` field. */
  roles?: Maybe<StringListFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Filter by the object’s `localVariables` field. */
  localVariables?: Maybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyTaskLogOpt3Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyTaskLogOpt3Filter>>;
  /** Negates the expression. */
  not?: Maybe<MyTaskLogOpt3Filter>;
}

/** A connection to a list of `MyTaskLogOpt3` values. */
export interface MyTaskLogOpt3SConnection {
  __typename?: 'MyTaskLogOpt3SConnection';
  /** A list of `MyTaskLogOpt3` objects. */
  nodes: Array<MyTaskLogOpt3>;
  /** A list of edges which contains the `MyTaskLogOpt3` and cursor to aid in pagination. */
  edges: Array<MyTaskLogOpt3SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyTaskLogOpt3` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyTaskLogOpt3` edge in the connection. */
export interface MyTaskLogOpt3SEdge {
  __typename?: 'MyTaskLogOpt3SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyTaskLogOpt3` at the end of the edge. */
  node: MyTaskLogOpt3;
}

/** Methods to use when ordering `MyTaskLogOpt3`. */
export enum MyTaskLogOpt3SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  FollowUpAsc = 'FOLLOW_UP_ASC',
  FollowUpDesc = 'FOLLOW_UP_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExecutionIdAsc = 'EXECUTION_ID_ASC',
  ExecutionIdDesc = 'EXECUTION_ID_DESC',
  ParentTaskIdAsc = 'PARENT_TASK_ID_ASC',
  ParentTaskIdDesc = 'PARENT_TASK_ID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProcessDefinitionIdAsc = 'PROCESS_DEFINITION_ID_ASC',
  ProcessDefinitionIdDesc = 'PROCESS_DEFINITION_ID_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseExecutionIdAsc = 'CASE_EXECUTION_ID_ASC',
  CaseExecutionIdDesc = 'CASE_EXECUTION_ID_DESC',
  CaseDefinitionIdAsc = 'CASE_DEFINITION_ID_ASC',
  CaseDefinitionIdDesc = 'CASE_DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ProcessDefinitionKeyAsc = 'PROCESS_DEFINITION_KEY_ASC',
  ProcessDefinitionKeyDesc = 'PROCESS_DEFINITION_KEY_DESC',
  ProcessDefinitionVersionAsc = 'PROCESS_DEFINITION_VERSION_ASC',
  ProcessDefinitionVersionDesc = 'PROCESS_DEFINITION_VERSION_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  FormFieldsAsc = 'FORM_FIELDS_ASC',
  FormFieldsDesc = 'FORM_FIELDS_DESC',
  RolesAsc = 'ROLES_ASC',
  RolesDesc = 'ROLES_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CaseDefinitionKeyAsc = 'CASE_DEFINITION_KEY_ASC',
  CaseDefinitionKeyDesc = 'CASE_DEFINITION_KEY_DESC',
  ActivityInstanceIdAsc = 'ACTIVITY_INSTANCE_ID_ASC',
  ActivityInstanceIdDesc = 'ACTIVITY_INSTANCE_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  LocalVariablesAsc = 'LOCAL_VARIABLES_ASC',
  LocalVariablesDesc = 'LOCAL_VARIABLES_DESC'
}

export interface MyTaskLogOpt4 {
  __typename?: 'MyTaskLogOpt4';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  due?: Maybe<Scalars['Datetime']>;
  followUp?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['String']>;
  parentTaskId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  caseExecutionId?: Maybe<Scalars['String']>;
  caseDefinitionId?: Maybe<Scalars['String']>;
  caseInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  businessKey?: Maybe<Scalars['String']>;
  formFields?: Maybe<Scalars['JSON']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseDefinitionKey?: Maybe<Scalars['String']>;
  activityInstanceId?: Maybe<Scalars['String']>;
  deleteReason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Datetime']>;
  endTime?: Maybe<Scalars['Datetime']>;
  duration?: Maybe<Scalars['BigInt']>;
  localVariables?: Maybe<Scalars['JSON']>;
}

/**
 * A condition to be used against `MyTaskLogOpt4` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyTaskLogOpt4Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUp` field. */
  followUp?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionId` field. */
  executionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `formFields` field. */
  formFields?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `roles` field. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `localVariables` field. */
  localVariables?: Maybe<Scalars['JSON']>;
}

/** A filter to be used against `MyTaskLogOpt4` object types. All fields are combined with a logical ‘and.’ */
export interface MyTaskLogOpt4Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `owner` field. */
  owner?: Maybe<StringFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUp` field. */
  followUp?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `executionId` field. */
  executionId?: Maybe<StringFilter>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: Maybe<IntFilter>;
  /** Filter by the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<IntFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `formFields` field. */
  formFields?: Maybe<JsonFilter>;
  /** Filter by the object’s `roles` field. */
  roles?: Maybe<StringListFilter>;
  /** Filter by the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Filter by the object’s `localVariables` field. */
  localVariables?: Maybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyTaskLogOpt4Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyTaskLogOpt4Filter>>;
  /** Negates the expression. */
  not?: Maybe<MyTaskLogOpt4Filter>;
}

/** A connection to a list of `MyTaskLogOpt4` values. */
export interface MyTaskLogOpt4SConnection {
  __typename?: 'MyTaskLogOpt4SConnection';
  /** A list of `MyTaskLogOpt4` objects. */
  nodes: Array<MyTaskLogOpt4>;
  /** A list of edges which contains the `MyTaskLogOpt4` and cursor to aid in pagination. */
  edges: Array<MyTaskLogOpt4SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyTaskLogOpt4` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyTaskLogOpt4` edge in the connection. */
export interface MyTaskLogOpt4SEdge {
  __typename?: 'MyTaskLogOpt4SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyTaskLogOpt4` at the end of the edge. */
  node: MyTaskLogOpt4;
}

/** Methods to use when ordering `MyTaskLogOpt4`. */
export enum MyTaskLogOpt4SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  FollowUpAsc = 'FOLLOW_UP_ASC',
  FollowUpDesc = 'FOLLOW_UP_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExecutionIdAsc = 'EXECUTION_ID_ASC',
  ExecutionIdDesc = 'EXECUTION_ID_DESC',
  ParentTaskIdAsc = 'PARENT_TASK_ID_ASC',
  ParentTaskIdDesc = 'PARENT_TASK_ID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProcessDefinitionIdAsc = 'PROCESS_DEFINITION_ID_ASC',
  ProcessDefinitionIdDesc = 'PROCESS_DEFINITION_ID_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseExecutionIdAsc = 'CASE_EXECUTION_ID_ASC',
  CaseExecutionIdDesc = 'CASE_EXECUTION_ID_DESC',
  CaseDefinitionIdAsc = 'CASE_DEFINITION_ID_ASC',
  CaseDefinitionIdDesc = 'CASE_DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ProcessDefinitionKeyAsc = 'PROCESS_DEFINITION_KEY_ASC',
  ProcessDefinitionKeyDesc = 'PROCESS_DEFINITION_KEY_DESC',
  ProcessDefinitionVersionAsc = 'PROCESS_DEFINITION_VERSION_ASC',
  ProcessDefinitionVersionDesc = 'PROCESS_DEFINITION_VERSION_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  FormFieldsAsc = 'FORM_FIELDS_ASC',
  FormFieldsDesc = 'FORM_FIELDS_DESC',
  RolesAsc = 'ROLES_ASC',
  RolesDesc = 'ROLES_DESC',
  CaseDefinitionKeyAsc = 'CASE_DEFINITION_KEY_ASC',
  CaseDefinitionKeyDesc = 'CASE_DEFINITION_KEY_DESC',
  ActivityInstanceIdAsc = 'ACTIVITY_INSTANCE_ID_ASC',
  ActivityInstanceIdDesc = 'ACTIVITY_INSTANCE_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  LocalVariablesAsc = 'LOCAL_VARIABLES_ASC',
  LocalVariablesDesc = 'LOCAL_VARIABLES_DESC'
}

/**
 * A condition to be used against `MyTaskLogOpt` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface MyTaskLogOptCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `assignee` field. */
  assignee?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `owner` field. */
  owner?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `due` field. */
  due?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `followUp` field. */
  followUp?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionId` field. */
  executionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `businessKey` field. */
  businessKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `formFields` field. */
  formFields?: Maybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `roles` field. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteReason` field. */
  deleteReason?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: Maybe<Scalars['BigInt']>;
}

/** A filter to be used against `MyTaskLogOpt` object types. All fields are combined with a logical ‘and.’ */
export interface MyTaskLogOptFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: Maybe<StringFilter>;
  /** Filter by the object’s `assignee` field. */
  assignee?: Maybe<StringFilter>;
  /** Filter by the object’s `owner` field. */
  owner?: Maybe<StringFilter>;
  /** Filter by the object’s `due` field. */
  due?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `followUp` field. */
  followUp?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: Maybe<StringFilter>;
  /** Filter by the object’s `executionId` field. */
  executionId?: Maybe<StringFilter>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: Maybe<StringFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: Maybe<IntFilter>;
  /** Filter by the object’s `processDefinitionId` field. */
  processDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseExecutionId` field. */
  caseExecutionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionId` field. */
  caseDefinitionId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseInstanceId` field. */
  caseInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskDefinitionKey` field. */
  taskDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionKey` field. */
  processDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `processDefinitionVersion` field. */
  processDefinitionVersion?: Maybe<IntFilter>;
  /** Filter by the object’s `businessKey` field. */
  businessKey?: Maybe<StringFilter>;
  /** Filter by the object’s `formFields` field. */
  formFields?: Maybe<JsonFilter>;
  /** Filter by the object’s `roles` field. */
  roles?: Maybe<StringListFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Filter by the object’s `caseDefinitionKey` field. */
  caseDefinitionKey?: Maybe<StringFilter>;
  /** Filter by the object’s `activityInstanceId` field. */
  activityInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `deleteReason` field. */
  deleteReason?: Maybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: Maybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<MyTaskLogOptFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<MyTaskLogOptFilter>>;
  /** Negates the expression. */
  not?: Maybe<MyTaskLogOptFilter>;
}

/** A connection to a list of `MyTaskLogOpt` values. */
export interface MyTaskLogOptsConnection {
  __typename?: 'MyTaskLogOptsConnection';
  /** A list of `MyTaskLogOpt` objects. */
  nodes: Array<MyTaskLogOpt>;
  /** A list of edges which contains the `MyTaskLogOpt` and cursor to aid in pagination. */
  edges: Array<MyTaskLogOptsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyTaskLogOpt` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyTaskLogOpt` edge in the connection. */
export interface MyTaskLogOptsEdge {
  __typename?: 'MyTaskLogOptsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyTaskLogOpt` at the end of the edge. */
  node: MyTaskLogOpt;
}

/** Methods to use when ordering `MyTaskLogOpt`. */
export enum MyTaskLogOptsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  FollowUpAsc = 'FOLLOW_UP_ASC',
  FollowUpDesc = 'FOLLOW_UP_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExecutionIdAsc = 'EXECUTION_ID_ASC',
  ExecutionIdDesc = 'EXECUTION_ID_DESC',
  ParentTaskIdAsc = 'PARENT_TASK_ID_ASC',
  ParentTaskIdDesc = 'PARENT_TASK_ID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProcessDefinitionIdAsc = 'PROCESS_DEFINITION_ID_ASC',
  ProcessDefinitionIdDesc = 'PROCESS_DEFINITION_ID_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseExecutionIdAsc = 'CASE_EXECUTION_ID_ASC',
  CaseExecutionIdDesc = 'CASE_EXECUTION_ID_DESC',
  CaseDefinitionIdAsc = 'CASE_DEFINITION_ID_ASC',
  CaseDefinitionIdDesc = 'CASE_DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ProcessDefinitionKeyAsc = 'PROCESS_DEFINITION_KEY_ASC',
  ProcessDefinitionKeyDesc = 'PROCESS_DEFINITION_KEY_DESC',
  ProcessDefinitionVersionAsc = 'PROCESS_DEFINITION_VERSION_ASC',
  ProcessDefinitionVersionDesc = 'PROCESS_DEFINITION_VERSION_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  FormFieldsAsc = 'FORM_FIELDS_ASC',
  FormFieldsDesc = 'FORM_FIELDS_DESC',
  RolesAsc = 'ROLES_ASC',
  RolesDesc = 'ROLES_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CaseDefinitionKeyAsc = 'CASE_DEFINITION_KEY_ASC',
  CaseDefinitionKeyDesc = 'CASE_DEFINITION_KEY_DESC',
  ActivityInstanceIdAsc = 'ACTIVITY_INSTANCE_ID_ASC',
  ActivityInstanceIdDesc = 'ACTIVITY_INSTANCE_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC'
}

/** A connection to a list of `MyTaskLog` values. */
export interface MyTaskLogsConnection {
  __typename?: 'MyTaskLogsConnection';
  /** A list of `MyTaskLog` objects. */
  nodes: Array<MyTaskLog>;
  /** A list of edges which contains the `MyTaskLog` and cursor to aid in pagination. */
  edges: Array<MyTaskLogsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MyTaskLog` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `MyTaskLog` edge in the connection. */
export interface MyTaskLogsEdge {
  __typename?: 'MyTaskLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MyTaskLog` at the end of the edge. */
  node: MyTaskLog;
}

/** Methods to use when ordering `MyTaskLog`. */
export enum MyTaskLogsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  AssigneeAsc = 'ASSIGNEE_ASC',
  AssigneeDesc = 'ASSIGNEE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  DueAsc = 'DUE_ASC',
  DueDesc = 'DUE_DESC',
  FollowUpAsc = 'FOLLOW_UP_ASC',
  FollowUpDesc = 'FOLLOW_UP_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExecutionIdAsc = 'EXECUTION_ID_ASC',
  ExecutionIdDesc = 'EXECUTION_ID_DESC',
  ParentTaskIdAsc = 'PARENT_TASK_ID_ASC',
  ParentTaskIdDesc = 'PARENT_TASK_ID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProcessDefinitionIdAsc = 'PROCESS_DEFINITION_ID_ASC',
  ProcessDefinitionIdDesc = 'PROCESS_DEFINITION_ID_DESC',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  CaseExecutionIdAsc = 'CASE_EXECUTION_ID_ASC',
  CaseExecutionIdDesc = 'CASE_EXECUTION_ID_DESC',
  CaseDefinitionIdAsc = 'CASE_DEFINITION_ID_ASC',
  CaseDefinitionIdDesc = 'CASE_DEFINITION_ID_DESC',
  CaseInstanceIdAsc = 'CASE_INSTANCE_ID_ASC',
  CaseInstanceIdDesc = 'CASE_INSTANCE_ID_DESC',
  TaskDefinitionKeyAsc = 'TASK_DEFINITION_KEY_ASC',
  TaskDefinitionKeyDesc = 'TASK_DEFINITION_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ProcessDefinitionKeyAsc = 'PROCESS_DEFINITION_KEY_ASC',
  ProcessDefinitionKeyDesc = 'PROCESS_DEFINITION_KEY_DESC',
  ProcessDefinitionVersionAsc = 'PROCESS_DEFINITION_VERSION_ASC',
  ProcessDefinitionVersionDesc = 'PROCESS_DEFINITION_VERSION_DESC',
  BusinessKeyAsc = 'BUSINESS_KEY_ASC',
  BusinessKeyDesc = 'BUSINESS_KEY_DESC',
  FormFieldsAsc = 'FORM_FIELDS_ASC',
  FormFieldsDesc = 'FORM_FIELDS_DESC',
  RolesAsc = 'ROLES_ASC',
  RolesDesc = 'ROLES_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CaseDefinitionKeyAsc = 'CASE_DEFINITION_KEY_ASC',
  CaseDefinitionKeyDesc = 'CASE_DEFINITION_KEY_DESC',
  ActivityInstanceIdAsc = 'ACTIVITY_INSTANCE_ID_ASC',
  ActivityInstanceIdDesc = 'ACTIVITY_INSTANCE_ID_DESC',
  DeleteReasonAsc = 'DELETE_REASON_ASC',
  DeleteReasonDesc = 'DELETE_REASON_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  LocalVariablesAsc = 'LOCAL_VARIABLES_ASC',
  LocalVariablesDesc = 'LOCAL_VARIABLES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export interface PageInfo {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
}

export interface Pathev extends Node {
  __typename?: 'Pathev';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  scoreHope?: Maybe<Scalars['BigFloat']>;
  scoreFearOfChange?: Maybe<Scalars['BigFloat']>;
  scoreFit?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `Case` that is related to this `Pathev`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pathev`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Pathev` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface PathevCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `scoreHope` field. */
  scoreHope?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreFearOfChange` field. */
  scoreFearOfChange?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreFit` field. */
  scoreFit?: Maybe<Scalars['BigFloat']>;
}

/** A filter to be used against `Pathev` object types. All fields are combined with a logical ‘and.’ */
export interface PathevFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `scoreHope` field. */
  scoreHope?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreFearOfChange` field. */
  scoreFearOfChange?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreFit` field. */
  scoreFit?: Maybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<PathevFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<PathevFilter>>;
  /** Negates the expression. */
  not?: Maybe<PathevFilter>;
}

/** An input for mutations affecting `Pathev` */
export interface PathevInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  scoreHope?: Maybe<Scalars['BigFloat']>;
  scoreFearOfChange?: Maybe<Scalars['BigFloat']>;
  scoreFit?: Maybe<Scalars['BigFloat']>;
}

/** Represents an update to a `Pathev`. Fields that are set will be updated. */
export interface PathevPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  scoreHope?: Maybe<Scalars['BigFloat']>;
  scoreFearOfChange?: Maybe<Scalars['BigFloat']>;
  scoreFit?: Maybe<Scalars['BigFloat']>;
}

/** A connection to a list of `Pathev` values. */
export interface PathevsConnection {
  __typename?: 'PathevsConnection';
  /** A list of `Pathev` objects. */
  nodes: Array<Pathev>;
  /** A list of edges which contains the `Pathev` and cursor to aid in pagination. */
  edges: Array<PathevsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pathev` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Pathev` edge in the connection. */
export interface PathevsEdge {
  __typename?: 'PathevsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pathev` at the end of the edge. */
  node: Pathev;
}

/** Methods to use when ordering `Pathev`. */
export enum PathevsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ScoreHopeAsc = 'SCORE_HOPE_ASC',
  ScoreHopeDesc = 'SCORE_HOPE_DESC',
  ScoreFearOfChangeAsc = 'SCORE_FEAR_OF_CHANGE_ASC',
  ScoreFearOfChangeDesc = 'SCORE_FEAR_OF_CHANGE_DESC',
  ScoreFitAsc = 'SCORE_FIT_ASC',
  ScoreFitDesc = 'SCORE_FIT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Pcl5 extends Node {
  __typename?: 'Pcl5';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  durationItem: Scalars['Int'];
  severityItem: Scalars['Int'];
  scoreClusterB?: Maybe<Scalars['Int']>;
  scoreClusterC?: Maybe<Scalars['Int']>;
  scoreClusterD?: Maybe<Scalars['Int']>;
  scoreClusterE?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Pcl5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pcl5`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Pcl5` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Pcl5Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `durationItem` field. */
  durationItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `severityItem` field. */
  severityItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreClusterB` field. */
  scoreClusterB?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreClusterC` field. */
  scoreClusterC?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreClusterD` field. */
  scoreClusterD?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreClusterE` field. */
  scoreClusterE?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Pcl5` object types. All fields are combined with a logical ‘and.’ */
export interface Pcl5Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<IntFilter>;
  /** Filter by the object’s `durationItem` field. */
  durationItem?: Maybe<IntFilter>;
  /** Filter by the object’s `severityItem` field. */
  severityItem?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreClusterB` field. */
  scoreClusterB?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreClusterC` field. */
  scoreClusterC?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreClusterD` field. */
  scoreClusterD?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreClusterE` field. */
  scoreClusterE?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Pcl5Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Pcl5Filter>>;
  /** Negates the expression. */
  not?: Maybe<Pcl5Filter>;
}

/** An input for mutations affecting `Pcl5` */
export interface Pcl5Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  durationItem: Scalars['Int'];
  severityItem: Scalars['Int'];
  scoreClusterB?: Maybe<Scalars['Int']>;
  scoreClusterC?: Maybe<Scalars['Int']>;
  scoreClusterD?: Maybe<Scalars['Int']>;
  scoreClusterE?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Pcl5`. Fields that are set will be updated. */
export interface Pcl5Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  durationItem?: Maybe<Scalars['Int']>;
  severityItem?: Maybe<Scalars['Int']>;
  scoreClusterB?: Maybe<Scalars['Int']>;
  scoreClusterC?: Maybe<Scalars['Int']>;
  scoreClusterD?: Maybe<Scalars['Int']>;
  scoreClusterE?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Pcl5` values. */
export interface Pcl5SConnection {
  __typename?: 'Pcl5SConnection';
  /** A list of `Pcl5` objects. */
  nodes: Array<Pcl5>;
  /** A list of edges which contains the `Pcl5` and cursor to aid in pagination. */
  edges: Array<Pcl5SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pcl5` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Pcl5` edge in the connection. */
export interface Pcl5SEdge {
  __typename?: 'Pcl5SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pcl5` at the end of the edge. */
  node: Pcl5;
}

/** Methods to use when ordering `Pcl5`. */
export enum Pcl5SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  DurationItemAsc = 'DURATION_ITEM_ASC',
  DurationItemDesc = 'DURATION_ITEM_DESC',
  SeverityItemAsc = 'SEVERITY_ITEM_ASC',
  SeverityItemDesc = 'SEVERITY_ITEM_DESC',
  ScoreClusterBAsc = 'SCORE_CLUSTER_B_ASC',
  ScoreClusterBDesc = 'SCORE_CLUSTER_B_DESC',
  ScoreClusterCAsc = 'SCORE_CLUSTER_C_ASC',
  ScoreClusterCDesc = 'SCORE_CLUSTER_C_DESC',
  ScoreClusterDAsc = 'SCORE_CLUSTER_D_ASC',
  ScoreClusterDDesc = 'SCORE_CLUSTER_D_DESC',
  ScoreClusterEAsc = 'SCORE_CLUSTER_E_ASC',
  ScoreClusterEDesc = 'SCORE_CLUSTER_E_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Pg13 extends Node {
  __typename?: 'Pg13';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Boolean'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Pg13`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pg13`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Pg13` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Pg13Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Pg13` object types. All fields are combined with a logical ‘and.’ */
export interface Pg13Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Pg13Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Pg13Filter>>;
  /** Negates the expression. */
  not?: Maybe<Pg13Filter>;
}

/** An input for mutations affecting `Pg13` */
export interface Pg13Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Boolean'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Pg13`. Fields that are set will be updated. */
export interface Pg13Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Boolean']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Pg13` values. */
export interface Pg13SConnection {
  __typename?: 'Pg13SConnection';
  /** A list of `Pg13` objects. */
  nodes: Array<Pg13>;
  /** A list of edges which contains the `Pg13` and cursor to aid in pagination. */
  edges: Array<Pg13SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pg13` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Pg13` edge in the connection. */
export interface Pg13SEdge {
  __typename?: 'Pg13SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pg13` at the end of the edge. */
  node: Pg13;
}

/** Methods to use when ordering `Pg13`. */
export enum Pg13SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Phq15 extends Node {
  __typename?: 'Phq15';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  severityItem: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Phq15`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq15`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Phq15` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Phq15Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `severityItem` field. */
  severityItem?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Phq15` object types. All fields are combined with a logical ‘and.’ */
export interface Phq15Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `severityItem` field. */
  severityItem?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Phq15Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Phq15Filter>>;
  /** Negates the expression. */
  not?: Maybe<Phq15Filter>;
}

/** An input for mutations affecting `Phq15` */
export interface Phq15Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  severityItem: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Phq15`. Fields that are set will be updated. */
export interface Phq15Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  severityItem?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Phq15` values. */
export interface Phq15SConnection {
  __typename?: 'Phq15SConnection';
  /** A list of `Phq15` objects. */
  nodes: Array<Phq15>;
  /** A list of edges which contains the `Phq15` and cursor to aid in pagination. */
  edges: Array<Phq15SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Phq15` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Phq15` edge in the connection. */
export interface Phq15SEdge {
  __typename?: 'Phq15SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Phq15` at the end of the edge. */
  node: Phq15;
}

/** Methods to use when ordering `Phq15`. */
export enum Phq15SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  SeverityItemAsc = 'SEVERITY_ITEM_ASC',
  SeverityItemDesc = 'SEVERITY_ITEM_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Phq4 extends Node {
  __typename?: 'Phq4';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  scoreDepression?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Phq4`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq4`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Phq4` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Phq4Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreDepression` field. */
  scoreDepression?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreFear` field. */
  scoreFear?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Phq4` object types. All fields are combined with a logical ‘and.’ */
export interface Phq4Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreDepression` field. */
  scoreDepression?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreFear` field. */
  scoreFear?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Phq4Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Phq4Filter>>;
  /** Negates the expression. */
  not?: Maybe<Phq4Filter>;
}

/** An input for mutations affecting `Phq4` */
export interface Phq4Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  scoreDepression?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Phq4`. Fields that are set will be updated. */
export interface Phq4Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  scoreDepression?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Phq4` values. */
export interface Phq4SConnection {
  __typename?: 'Phq4SConnection';
  /** A list of `Phq4` objects. */
  nodes: Array<Phq4>;
  /** A list of edges which contains the `Phq4` and cursor to aid in pagination. */
  edges: Array<Phq4SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Phq4` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Phq4` edge in the connection. */
export interface Phq4SEdge {
  __typename?: 'Phq4SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Phq4` at the end of the edge. */
  node: Phq4;
}

/** Methods to use when ordering `Phq4`. */
export enum Phq4SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  ScoreDepressionAsc = 'SCORE_DEPRESSION_ASC',
  ScoreDepressionDesc = 'SCORE_DEPRESSION_DESC',
  ScoreFearAsc = 'SCORE_FEAR_ASC',
  ScoreFearDesc = 'SCORE_FEAR_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Phq9 extends Node {
  __typename?: 'Phq9';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  itemSeverity?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Phq9`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq9`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Phq9` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface Phq9Condition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `itemSeverity` field. */
  itemSeverity?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Phq9` object types. All fields are combined with a logical ‘and.’ */
export interface Phq9Filter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `itemSeverity` field. */
  itemSeverity?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<Phq9Filter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<Phq9Filter>>;
  /** Negates the expression. */
  not?: Maybe<Phq9Filter>;
}

/** An input for mutations affecting `Phq9` */
export interface Phq9Input {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  itemSeverity?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Phq9`. Fields that are set will be updated. */
export interface Phq9Patch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  itemSeverity?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Phq9` values. */
export interface Phq9SConnection {
  __typename?: 'Phq9SConnection';
  /** A list of `Phq9` objects. */
  nodes: Array<Phq9>;
  /** A list of edges which contains the `Phq9` and cursor to aid in pagination. */
  edges: Array<Phq9SEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Phq9` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Phq9` edge in the connection. */
export interface Phq9SEdge {
  __typename?: 'Phq9SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Phq9` at the end of the edge. */
  node: Phq9;
}

/** Methods to use when ordering `Phq9`. */
export enum Phq9SOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  ItemSeverityAsc = 'ITEM_SEVERITY_ASC',
  ItemSeverityDesc = 'ITEM_SEVERITY_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Pmb extends Node {
  __typename?: 'Pmb';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  scoreThreatOfHarm?: Maybe<Scalars['Int']>;
  scoreSelfWorthAndJudgement?: Maybe<Scalars['Int']>;
  scoreTrustworthinessOfOthers?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Pmb`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pmb`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Pmb` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface PmbCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreThreatOfHarm` field. */
  scoreThreatOfHarm?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreSelfWorthAndJudgement` field. */
  scoreSelfWorthAndJudgement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreTrustworthinessOfOthers` field. */
  scoreTrustworthinessOfOthers?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Pmb` object types. All fields are combined with a logical ‘and.’ */
export interface PmbFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreThreatOfHarm` field. */
  scoreThreatOfHarm?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreSelfWorthAndJudgement` field. */
  scoreSelfWorthAndJudgement?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreTrustworthinessOfOthers` field. */
  scoreTrustworthinessOfOthers?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<PmbFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<PmbFilter>>;
  /** Negates the expression. */
  not?: Maybe<PmbFilter>;
}

/** An input for mutations affecting `Pmb` */
export interface PmbInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  scoreThreatOfHarm?: Maybe<Scalars['Int']>;
  scoreSelfWorthAndJudgement?: Maybe<Scalars['Int']>;
  scoreTrustworthinessOfOthers?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Pmb`. Fields that are set will be updated. */
export interface PmbPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  scoreThreatOfHarm?: Maybe<Scalars['Int']>;
  scoreSelfWorthAndJudgement?: Maybe<Scalars['Int']>;
  scoreTrustworthinessOfOthers?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Pmb` values. */
export interface PmbsConnection {
  __typename?: 'PmbsConnection';
  /** A list of `Pmb` objects. */
  nodes: Array<Pmb>;
  /** A list of edges which contains the `Pmb` and cursor to aid in pagination. */
  edges: Array<PmbsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pmb` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Pmb` edge in the connection. */
export interface PmbsEdge {
  __typename?: 'PmbsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pmb` at the end of the edge. */
  node: Pmb;
}

/** Methods to use when ordering `Pmb`. */
export enum PmbsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  ScoreThreatOfHarmAsc = 'SCORE_THREAT_OF_HARM_ASC',
  ScoreThreatOfHarmDesc = 'SCORE_THREAT_OF_HARM_DESC',
  ScoreSelfWorthAndJudgementAsc = 'SCORE_SELF_WORTH_AND_JUDGEMENT_ASC',
  ScoreSelfWorthAndJudgementDesc = 'SCORE_SELF_WORTH_AND_JUDGEMENT_DESC',
  ScoreTrustworthinessOfOthersAsc = 'SCORE_TRUSTWORTHINESS_OF_OTHERS_ASC',
  ScoreTrustworthinessOfOthersDesc = 'SCORE_TRUSTWORTHINESS_OF_OTHERS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `ProcessesByCaseWithActivity` values. */
export interface ProcessesByCaseWithActivitiesConnection {
  __typename?: 'ProcessesByCaseWithActivitiesConnection';
  /** A list of `ProcessesByCaseWithActivity` objects. */
  nodes: Array<ProcessesByCaseWithActivity>;
  /** A list of edges which contains the `ProcessesByCaseWithActivity` and cursor to aid in pagination. */
  edges: Array<ProcessesByCaseWithActivitiesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessesByCaseWithActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProcessesByCaseWithActivity` edge in the connection. */
export interface ProcessesByCaseWithActivitiesEdge {
  __typename?: 'ProcessesByCaseWithActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessesByCaseWithActivity` at the end of the edge. */
  node: ProcessesByCaseWithActivity;
}

/** Methods to use when ordering `ProcessesByCaseWithActivity`. */
export enum ProcessesByCaseWithActivitiesOrderBy {
  Natural = 'NATURAL',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  ProcessNameAsc = 'PROCESS_NAME_ASC',
  ProcessNameDesc = 'PROCESS_NAME_DESC',
  ProcessIsActiveAsc = 'PROCESS_IS_ACTIVE_ASC',
  ProcessIsActiveDesc = 'PROCESS_IS_ACTIVE_DESC',
  OpenActivitiesAsc = 'OPEN_ACTIVITIES_ASC',
  OpenActivitiesDesc = 'OPEN_ACTIVITIES_DESC',
  OpenActivityIdsAsc = 'OPEN_ACTIVITY_IDS_ASC',
  OpenActivityIdsDesc = 'OPEN_ACTIVITY_IDS_DESC',
  ProcInstIdAsc = 'PROC_INST_ID_ASC',
  ProcInstIdDesc = 'PROC_INST_ID_DESC'
}

export interface ProcessesByCaseWithActivity {
  __typename?: 'ProcessesByCaseWithActivity';
  shortId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
  processName?: Maybe<Scalars['String']>;
  processIsActive?: Maybe<Scalars['Boolean']>;
  openActivities?: Maybe<Array<Maybe<Scalars['String']>>>;
  openActivityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  procInstId_?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `ProcessesByCaseWithActivity` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export interface ProcessesByCaseWithActivityCondition {
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `title` field. */
  title?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processName` field. */
  processName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processIsActive` field. */
  processIsActive?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `openActivities` field. */
  openActivities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `openActivityIds` field. */
  openActivityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `procInstId_` field. */
  procInstId_?: Maybe<Scalars['String']>;
}

/** A filter to be used against `ProcessesByCaseWithActivity` object types. All fields are combined with a logical ‘and.’ */
export interface ProcessesByCaseWithActivityFilter {
  /** Filter by the object’s `shortId` field. */
  shortId?: Maybe<BigIntFilter>;
  /** Filter by the object’s `title` field. */
  title?: Maybe<StringFilter>;
  /** Filter by the object’s `processName` field. */
  processName?: Maybe<StringFilter>;
  /** Filter by the object’s `processIsActive` field. */
  processIsActive?: Maybe<BooleanFilter>;
  /** Filter by the object’s `openActivities` field. */
  openActivities?: Maybe<StringListFilter>;
  /** Filter by the object’s `openActivityIds` field. */
  openActivityIds?: Maybe<StringListFilter>;
  /** Filter by the object’s `procInstId_` field. */
  procInstId_?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ProcessesByCaseWithActivityFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ProcessesByCaseWithActivityFilter>>;
  /** Negates the expression. */
  not?: Maybe<ProcessesByCaseWithActivityFilter>;
}

export interface ProcessingQueue extends Node {
  __typename?: 'ProcessingQueue';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  waitlistType: Scalars['String'];
  queueType: Scalars['String'];
  caseId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `ProcessingQueue`. */
  caseByCaseId?: Maybe<Case>;
}

/**
 * A condition to be used against `ProcessingQueue` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface ProcessingQueueCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `waitlistType` field. */
  waitlistType?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `queueType` field. */
  queueType?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `ProcessingQueue` object types. All fields are combined with a logical ‘and.’ */
export interface ProcessingQueueFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `waitlistType` field. */
  waitlistType?: Maybe<StringFilter>;
  /** Filter by the object’s `queueType` field. */
  queueType?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ProcessingQueueFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ProcessingQueueFilter>>;
  /** Negates the expression. */
  not?: Maybe<ProcessingQueueFilter>;
}

/** An input for mutations affecting `ProcessingQueue` */
export interface ProcessingQueueInput {
  id?: Maybe<Scalars['UUID']>;
  waitlistType?: Maybe<Scalars['String']>;
  queueType?: Maybe<Scalars['String']>;
  caseId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `ProcessingQueue`. Fields that are set will be updated. */
export interface ProcessingQueuePatch {
  id?: Maybe<Scalars['UUID']>;
  waitlistType?: Maybe<Scalars['String']>;
  queueType?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `ProcessingQueue` values. */
export interface ProcessingQueuesConnection {
  __typename?: 'ProcessingQueuesConnection';
  /** A list of `ProcessingQueue` objects. */
  nodes: Array<ProcessingQueue>;
  /** A list of edges which contains the `ProcessingQueue` and cursor to aid in pagination. */
  edges: Array<ProcessingQueuesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessingQueue` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProcessingQueue` edge in the connection. */
export interface ProcessingQueuesEdge {
  __typename?: 'ProcessingQueuesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessingQueue` at the end of the edge. */
  node: ProcessingQueue;
}

/** Methods to use when ordering `ProcessingQueue`. */
export enum ProcessingQueuesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  WaitlistTypeAsc = 'WAITLIST_TYPE_ASC',
  WaitlistTypeDesc = 'WAITLIST_TYPE_DESC',
  QueueTypeAsc = 'QUEUE_TYPE_ASC',
  QueueTypeDesc = 'QUEUE_TYPE_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface ProcessLog {
  __typename?: 'ProcessLog';
  processInstanceId?: Maybe<Scalars['String']>;
  processKey?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  endedAt?: Maybe<Scalars['Datetime']>;
  caseId?: Maybe<Scalars['String']>;
}

/**
 * A condition to be used against `ProcessLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface ProcessLogCondition {
  /** Checks for equality with the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `processKey` field. */
  processKey?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `taskName` field. */
  taskName?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `endedAt` field. */
  endedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['String']>;
}

/** A filter to be used against `ProcessLog` object types. All fields are combined with a logical ‘and.’ */
export interface ProcessLogFilter {
  /** Filter by the object’s `processInstanceId` field. */
  processInstanceId?: Maybe<StringFilter>;
  /** Filter by the object’s `processKey` field. */
  processKey?: Maybe<StringFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: Maybe<StringFilter>;
  /** Filter by the object’s `taskName` field. */
  taskName?: Maybe<StringFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `endedAt` field. */
  endedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ProcessLogFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ProcessLogFilter>>;
  /** Negates the expression. */
  not?: Maybe<ProcessLogFilter>;
}

/** A connection to a list of `ProcessLog` values. */
export interface ProcessLogsConnection {
  __typename?: 'ProcessLogsConnection';
  /** A list of `ProcessLog` objects. */
  nodes: Array<ProcessLog>;
  /** A list of edges which contains the `ProcessLog` and cursor to aid in pagination. */
  edges: Array<ProcessLogsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessLog` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `ProcessLog` edge in the connection. */
export interface ProcessLogsEdge {
  __typename?: 'ProcessLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessLog` at the end of the edge. */
  node: ProcessLog;
}

/** Methods to use when ordering `ProcessLog`. */
export enum ProcessLogsOrderBy {
  Natural = 'NATURAL',
  ProcessInstanceIdAsc = 'PROCESS_INSTANCE_ID_ASC',
  ProcessInstanceIdDesc = 'PROCESS_INSTANCE_ID_DESC',
  ProcessKeyAsc = 'PROCESS_KEY_ASC',
  ProcessKeyDesc = 'PROCESS_KEY_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  TaskNameAsc = 'TASK_NAME_ASC',
  TaskNameDesc = 'TASK_NAME_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  EndedAtAsc = 'ENDED_AT_ASC',
  EndedAtDesc = 'ENDED_AT_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export interface Query extends Node {
  __typename?: 'Query';
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** Reads and enables pagination through a set of `ActiveCounselingsForCounselor`. */
  allActiveCounselingsForCounselors?: Maybe<ActiveCounselingsForCounselorsConnection>;
  /** Reads and enables pagination through a set of `ActiveTherapiesForTherapist`. */
  allActiveTherapiesForTherapists?: Maybe<ActiveTherapiesForTherapistsConnection>;
  /** Reads and enables pagination through a set of `ActiveUser`. */
  allActiveUsers?: Maybe<ActiveUsersConnection>;
  /** Reads and enables pagination through a set of `AdoptibleInterviewOffer`. */
  allAdoptibleInterviewOffers?: Maybe<AdoptibleInterviewOffersConnection>;
  /** Reads and enables pagination through a set of `AllLetter`. */
  allAllLetters?: Maybe<AllLettersConnection>;
  /** Reads and enables pagination through a set of `AllTaskStat`. */
  allAllTaskStats?: Maybe<AllTaskStatsConnection>;
  /** Reads and enables pagination through a set of `AvailableInterviewDate`. */
  allAvailableInterviewDates?: Maybe<AvailableInterviewDatesConnection>;
  /** Reads and enables pagination through a set of `AvailableInterviewOffer`. */
  allAvailableInterviewOffers?: Maybe<AvailableInterviewOffersConnection>;
  /** Reads and enables pagination through a set of `Bdi2`. */
  allBdi2S?: Maybe<Bdi2SConnection>;
  /** Reads and enables pagination through a set of `BookedInterviewOffer`. */
  allBookedInterviewOffers?: Maybe<BookedInterviewOffersConnection>;
  /** Reads and enables pagination through a set of `CaseMember`. */
  allCaseMembers?: Maybe<CaseMembersConnection>;
  /** Reads and enables pagination through a set of `CaseMembers2`. */
  allCaseMembers2S?: Maybe<CaseMembers2SConnection>;
  /** Reads and enables pagination through a set of `CaseMessage`. */
  allCaseMessages?: Maybe<CaseMessagesConnection>;
  /** Reads and enables pagination through a set of `CaseSuicideCall`. */
  allCaseSuicideCalls?: Maybe<CaseSuicideCallsConnection>;
  /** Reads and enables pagination through a set of `Case`. */
  allCases?: Maybe<CasesConnection>;
  /** Reads and enables pagination through a set of `CbtActivity`. */
  allCbtActivities?: Maybe<CbtActivitiesConnection>;
  /** Reads and enables pagination through a set of `CbtReframing`. */
  allCbtReframings?: Maybe<CbtReframingsConnection>;
  /** Reads and enables pagination through a set of `CbtThought`. */
  allCbtThoughts?: Maybe<CbtThoughtsConnection>;
  /** Reads and enables pagination through a set of `Cdrisk10`. */
  allCdrisk10S?: Maybe<Cdrisk10SConnection>;
  /** Reads and enables pagination through a set of `Comment`. */
  allComments?: Maybe<CommentsConnection>;
  /** Reads and enables pagination through a set of `CoordinatorUser`. */
  allCoordinatorUsers?: Maybe<CoordinatorUsersConnection>;
  /** Reads and enables pagination through a set of `CounselingQuestion`. */
  allCounselingQuestions?: Maybe<CounselingQuestionsConnection>;
  /** Reads and enables pagination through a set of `Demographic`. */
  allDemographics?: Maybe<DemographicsConnection>;
  /** Reads and enables pagination through a set of `Disclosure`. */
  allDisclosures?: Maybe<DisclosuresConnection>;
  /** Reads and enables pagination through a set of `DueCandidateLink`. */
  allDueCandidateLinks?: Maybe<DueCandidateLinksConnection>;
  /** Reads and enables pagination through a set of `DueTask`. */
  allDueTasks?: Maybe<DueTasksConnection>;
  /** Reads and enables pagination through a set of `Eurohi`. */
  allEurohis?: Maybe<EurohisConnection>;
  /** Reads and enables pagination through a set of `EurohisCounselingStatistic`. */
  allEurohisCounselingStatistics?: Maybe<EurohisCounselingStatisticsConnection>;
  /** Reads and enables pagination through a set of `Evaluation`. */
  allEvaluations?: Maybe<EvaluationsConnection>;
  /** Reads and enables pagination through a set of `FeedbackInterviewReport`. */
  allFeedbackInterviewReports?: Maybe<FeedbackInterviewReportsConnection>;
  /** Reads and enables pagination through a set of `Gad2`. */
  allGad2S?: Maybe<Gad2SConnection>;
  /** Reads and enables pagination through a set of `Gad7`. */
  allGad7S?: Maybe<Gad7SConnection>;
  /** Reads and enables pagination through a set of `HashedEmail`. */
  allHashedEmails?: Maybe<HashedEmailsConnection>;
  /** Reads and enables pagination through a set of `Inep`. */
  allIneps?: Maybe<InepsConnection>;
  /** Reads and enables pagination through a set of `InterviewAndCallCalendar`. */
  allInterviewAndCallCalendars?: Maybe<InterviewAndCallCalendarsConnection>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  allInterviewBookings?: Maybe<InterviewBookingsConnection>;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  allInterviewCalendars?: Maybe<InterviewCalendarsConnection>;
  /** Reads and enables pagination through a set of `InterviewCalendarAccountable`. */
  allInterviewCalendarAccountables?: Maybe<InterviewCalendarAccountablesConnection>;
  /** Reads and enables pagination through a set of `InterviewCalendarNew`. */
  allInterviewCalendarNews?: Maybe<InterviewCalendarNewsConnection>;
  /** Reads and enables pagination through a set of `InterviewOffer`. */
  allInterviewOffers?: Maybe<InterviewOffersConnection>;
  /** Reads and enables pagination through a set of `InterviewReport`. */
  allInterviewReports?: Maybe<InterviewReportsConnection>;
  /** Reads and enables pagination through a set of `Interviewee`. */
  allInterviewees?: Maybe<IntervieweesConnection>;
  /** Reads and enables pagination through a set of `Interviewer`. */
  allInterviewers?: Maybe<InterviewersConnection>;
  /** Reads and enables pagination through a set of `Invoice`. */
  allInvoices?: Maybe<InvoicesConnection>;
  /** Reads and enables pagination through a set of `Involvement`. */
  allInvolvements?: Maybe<InvolvementsConnection>;
  /** Reads and enables pagination through a set of `InvolvementsInMyCase`. */
  allInvolvementsInMyCases?: Maybe<InvolvementsInMyCasesConnection>;
  /** Reads and enables pagination through a set of `IptConflict`. */
  allIptConflicts?: Maybe<IptConflictsConnection>;
  /** Reads and enables pagination through a set of `IptRelationship`. */
  allIptRelationships?: Maybe<IptRelationshipsConnection>;
  /** Reads and enables pagination through a set of `IptSituation`. */
  allIptSituations?: Maybe<IptSituationsConnection>;
  /** Reads and enables pagination through a set of `Itq`. */
  allItqs?: Maybe<ItqsConnection>;
  /** Reads and enables pagination through a set of `Lec5`. */
  allLec5S?: Maybe<Lec5SConnection>;
  /** Reads and enables pagination through a set of `LetterTemplate`. */
  allLetterTemplates?: Maybe<LetterTemplatesConnection>;
  /** Reads and enables pagination through a set of `LetterinfoByUser`. */
  allLetterinfoByUsers?: Maybe<LetterinfoByUsersConnection>;
  /** Reads and enables pagination through a set of `Letter`. */
  allLetters?: Maybe<LettersConnection>;
  /** Reads and enables pagination through a set of `LoginToken`. */
  allLoginTokens?: Maybe<LoginTokensConnection>;
  /** Reads and enables pagination through a set of `Lsa`. */
  allLsas?: Maybe<LsasConnection>;
  /** Reads and enables pagination through a set of `Mspss`. */
  allMspsses?: Maybe<MspssesConnection>;
  /** Reads and enables pagination through a set of `MyAccount`. */
  allMyAccounts?: Maybe<MyAccountsConnection>;
  /** Reads and enables pagination through a set of `MyCase`. */
  allMyCases?: Maybe<MyCasesConnection>;
  /** Reads and enables pagination through a set of `MyCasesOverview`. */
  allMyCasesOverviews?: Maybe<MyCasesOverviewsConnection>;
  /** Reads and enables pagination through a set of `MyCasesOverview2`. */
  allMyCasesOverview2S?: Maybe<MyCasesOverview2SConnection>;
  /** Reads and enables pagination through a set of `MyDate`. */
  allMyDates?: Maybe<MyDatesConnection>;
  /** Reads and enables pagination through a set of `MyDueTask`. */
  allMyDueTasks?: Maybe<MyDueTasksConnection>;
  /** Reads and enables pagination through a set of `MyGateway`. */
  allMyGateways?: Maybe<MyGatewaysConnection>;
  /** Reads and enables pagination through a set of `MyHistoricIdentitylink`. */
  allMyHistoricIdentitylinks?: Maybe<MyHistoricIdentitylinksConnection>;
  /** Reads and enables pagination through a set of `MyInterviewBooking`. */
  allMyInterviewBookings?: Maybe<MyInterviewBookingsConnection>;
  /** Reads and enables pagination through a set of `MyInterviewOffer`. */
  allMyInterviewOffers?: Maybe<MyInterviewOffersConnection>;
  /** Reads and enables pagination through a set of `MyInvolvement`. */
  allMyInvolvements?: Maybe<MyInvolvementsConnection>;
  /** Reads and enables pagination through a set of `MyMessage`. */
  allMyMessages?: Maybe<MyMessagesConnection>;
  /** Reads and enables pagination through a set of `MyProcessLog`. */
  allMyProcessLogs?: Maybe<MyProcessLogsConnection>;
  /** Reads and enables pagination through a set of `MyRunningProcess`. */
  allMyRunningProcesses?: Maybe<MyRunningProcessesConnection>;
  /** Reads and enables pagination through a set of `MyTaskLog`. */
  allMyTaskLogs?: Maybe<MyTaskLogsConnection>;
  /** Reads and enables pagination through a set of `MyTaskLogOpt`. */
  allMyTaskLogOpts?: Maybe<MyTaskLogOptsConnection>;
  /** Reads and enables pagination through a set of `MyTaskLogOpt3`. */
  allMyTaskLogOpt3S?: Maybe<MyTaskLogOpt3SConnection>;
  /** Reads and enables pagination through a set of `MyTaskLogOpt4`. */
  allMyTaskLogOpt4S?: Maybe<MyTaskLogOpt4SConnection>;
  /** Reads and enables pagination through a set of `Pathev`. */
  allPathevs?: Maybe<PathevsConnection>;
  /** Reads and enables pagination through a set of `Pcl5`. */
  allPcl5S?: Maybe<Pcl5SConnection>;
  /** Reads and enables pagination through a set of `Pg13`. */
  allPg13S?: Maybe<Pg13SConnection>;
  /** Reads and enables pagination through a set of `Phq15`. */
  allPhq15S?: Maybe<Phq15SConnection>;
  /** Reads and enables pagination through a set of `Phq4`. */
  allPhq4S?: Maybe<Phq4SConnection>;
  /** Reads and enables pagination through a set of `Phq9`. */
  allPhq9S?: Maybe<Phq9SConnection>;
  /** Reads and enables pagination through a set of `Pmb`. */
  allPmbs?: Maybe<PmbsConnection>;
  /** Reads and enables pagination through a set of `ProcessLog`. */
  allProcessLogs?: Maybe<ProcessLogsConnection>;
  /** Reads and enables pagination through a set of `ProcessesByCaseWithActivity`. */
  allProcessesByCaseWithActivities?: Maybe<ProcessesByCaseWithActivitiesConnection>;
  /** Reads and enables pagination through a set of `ProcessingQueue`. */
  allProcessingQueues?: Maybe<ProcessingQueuesConnection>;
  /** Reads and enables pagination through a set of `QueueSetting`. */
  allQueueSettings?: Maybe<QueueSettingsConnection>;
  /** Reads and enables pagination through a set of `RandomizationTicket`. */
  allRandomizationTickets?: Maybe<RandomizationTicketsConnection>;
  /** Reads and enables pagination through a set of `Sbqr`. */
  allSbqrs?: Maybe<SbqrsConnection>;
  /** Reads and enables pagination through a set of `Scaling`. */
  allScalings?: Maybe<ScalingsConnection>;
  /** Reads and enables pagination through a set of `Sewip`. */
  allSewips?: Maybe<SewipsConnection>;
  /** Reads and enables pagination through a set of `Sib`. */
  allSibs?: Maybe<SibsConnection>;
  /** Reads and enables pagination through a set of `SuicideNote`. */
  allSuicideNotes?: Maybe<SuicideNotesConnection>;
  /** Reads and enables pagination through a set of `Taq`. */
  allTaqs?: Maybe<TaqsConnection>;
  /** Reads and enables pagination through a set of `Tgisrplus`. */
  allTgisrpluses?: Maybe<TgisrplusesConnection>;
  /** Reads and enables pagination through a set of `Traumaliste`. */
  allTraumalistes?: Maybe<TraumalistesConnection>;
  /** Reads and enables pagination through a set of `Traumalisteneu`. */
  allTraumalisteneus?: Maybe<TraumalisteneusConnection>;
  /** Reads and enables pagination through a set of `Trgi`. */
  allTrgis?: Maybe<TrgisConnection>;
  /** Reads and enables pagination through a set of `User`. */
  allUsers?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `Wai`. */
  allWais?: Maybe<WaisConnection>;
  bdi2ById?: Maybe<Bdi2>;
  caseMemberByUserIdAndCaseId?: Maybe<CaseMember>;
  caseMessageById?: Maybe<CaseMessage>;
  caseSuicideCallById?: Maybe<CaseSuicideCall>;
  caseById?: Maybe<Case>;
  cbtActivityById?: Maybe<CbtActivity>;
  cbtReframingById?: Maybe<CbtReframing>;
  cbtThoughtById?: Maybe<CbtThought>;
  cdrisk10ById?: Maybe<Cdrisk10>;
  commentById?: Maybe<Comment>;
  counselingQuestionById?: Maybe<CounselingQuestion>;
  demographicById?: Maybe<Demographic>;
  disclosureById?: Maybe<Disclosure>;
  dueTaskById?: Maybe<DueTask>;
  eurohiById?: Maybe<Eurohi>;
  evaluationById?: Maybe<Evaluation>;
  feedbackInterviewReportById?: Maybe<FeedbackInterviewReport>;
  gad2ById?: Maybe<Gad2>;
  gad7ById?: Maybe<Gad7>;
  hashedEmailById?: Maybe<HashedEmail>;
  inepById?: Maybe<Inep>;
  interviewBookingById?: Maybe<InterviewBooking>;
  interviewBookingByIdAndCaseId?: Maybe<InterviewBooking>;
  interviewCalendarByOfferId?: Maybe<InterviewCalendar>;
  interviewOfferById?: Maybe<InterviewOffer>;
  interviewReportById?: Maybe<InterviewReport>;
  intervieweeById?: Maybe<Interviewee>;
  interviewerById?: Maybe<Interviewer>;
  involvementById?: Maybe<Involvement>;
  iptConflictById?: Maybe<IptConflict>;
  iptRelationshipById?: Maybe<IptRelationship>;
  iptSituationById?: Maybe<IptSituation>;
  itqById?: Maybe<Itq>;
  lec5ById?: Maybe<Lec5>;
  letterTemplateById?: Maybe<LetterTemplate>;
  letterById?: Maybe<Letter>;
  loginTokenById?: Maybe<LoginToken>;
  lsaById?: Maybe<Lsa>;
  mspssById?: Maybe<Mspss>;
  myDateById?: Maybe<MyDate>;
  myDateByCaseIdAndName?: Maybe<MyDate>;
  myInvolvementByCaseId?: Maybe<MyInvolvement>;
  myTaskLogById?: Maybe<MyTaskLog>;
  pathevById?: Maybe<Pathev>;
  pcl5ById?: Maybe<Pcl5>;
  pg13ById?: Maybe<Pg13>;
  phq15ById?: Maybe<Phq15>;
  phq4ById?: Maybe<Phq4>;
  phq9ById?: Maybe<Phq9>;
  pmbById?: Maybe<Pmb>;
  processingQueueById?: Maybe<ProcessingQueue>;
  queueSettingById?: Maybe<QueueSetting>;
  randomizationTicketById?: Maybe<RandomizationTicket>;
  sbqrById?: Maybe<Sbqr>;
  scalingById?: Maybe<Scaling>;
  sewipById?: Maybe<Sewip>;
  sibById?: Maybe<Sib>;
  suicideNoteById?: Maybe<SuicideNote>;
  taqById?: Maybe<Taq>;
  tgisrplusById?: Maybe<Tgisrplus>;
  traumalisteById?: Maybe<Traumaliste>;
  traumalisteneuById?: Maybe<Traumalisteneu>;
  trgiById?: Maybe<Trgi>;
  userById?: Maybe<User>;
  userByUsername?: Maybe<User>;
  userByEmail?: Maybe<User>;
  waiById?: Maybe<Wai>;
  /** Reads and enables pagination through a set of `Letter`. */
  getLetterByCaseid?: Maybe<LettersConnection>;
  isCoordinator?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Case`. */
  searchCases?: Maybe<CasesConnection>;
  /** Reads and enables pagination through a set of `Case`. */
  searchCasesNew?: Maybe<CasesConnection>;
  /** Reads and enables pagination through a set of `Case`. */
  searchMyCases?: Maybe<CasesConnection>;
  shortUuid?: Maybe<Scalars['String']>;
  tryCastUuid?: Maybe<Scalars['UUID']>;
  /** Reads a single `Bdi2` using its globally unique `ID`. */
  bdi2?: Maybe<Bdi2>;
  /** Reads a single `CaseMessage` using its globally unique `ID`. */
  caseMessage?: Maybe<CaseMessage>;
  /** Reads a single `CaseSuicideCall` using its globally unique `ID`. */
  caseSuicideCall?: Maybe<CaseSuicideCall>;
  /** Reads a single `Case` using its globally unique `ID`. */
  case?: Maybe<Case>;
  /** Reads a single `CbtActivity` using its globally unique `ID`. */
  cbtActivity?: Maybe<CbtActivity>;
  /** Reads a single `CbtReframing` using its globally unique `ID`. */
  cbtReframing?: Maybe<CbtReframing>;
  /** Reads a single `CbtThought` using its globally unique `ID`. */
  cbtThought?: Maybe<CbtThought>;
  /** Reads a single `Cdrisk10` using its globally unique `ID`. */
  cdrisk10?: Maybe<Cdrisk10>;
  /** Reads a single `Comment` using its globally unique `ID`. */
  comment?: Maybe<Comment>;
  /** Reads a single `CounselingQuestion` using its globally unique `ID`. */
  counselingQuestion?: Maybe<CounselingQuestion>;
  /** Reads a single `Demographic` using its globally unique `ID`. */
  demographic?: Maybe<Demographic>;
  /** Reads a single `Disclosure` using its globally unique `ID`. */
  disclosure?: Maybe<Disclosure>;
  /** Reads a single `DueTask` using its globally unique `ID`. */
  dueTask?: Maybe<DueTask>;
  /** Reads a single `Eurohi` using its globally unique `ID`. */
  eurohi?: Maybe<Eurohi>;
  /** Reads a single `Evaluation` using its globally unique `ID`. */
  evaluation?: Maybe<Evaluation>;
  /** Reads a single `FeedbackInterviewReport` using its globally unique `ID`. */
  feedbackInterviewReport?: Maybe<FeedbackInterviewReport>;
  /** Reads a single `Gad2` using its globally unique `ID`. */
  gad2?: Maybe<Gad2>;
  /** Reads a single `Gad7` using its globally unique `ID`. */
  gad7?: Maybe<Gad7>;
  /** Reads a single `HashedEmail` using its globally unique `ID`. */
  hashedEmail?: Maybe<HashedEmail>;
  /** Reads a single `Inep` using its globally unique `ID`. */
  inep?: Maybe<Inep>;
  /** Reads a single `InterviewBooking` using its globally unique `ID`. */
  interviewBooking?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewOffer` using its globally unique `ID`. */
  interviewOffer?: Maybe<InterviewOffer>;
  /** Reads a single `InterviewReport` using its globally unique `ID`. */
  interviewReport?: Maybe<InterviewReport>;
  /** Reads a single `Involvement` using its globally unique `ID`. */
  involvement?: Maybe<Involvement>;
  /** Reads a single `IptConflict` using its globally unique `ID`. */
  iptConflict?: Maybe<IptConflict>;
  /** Reads a single `IptRelationship` using its globally unique `ID`. */
  iptRelationship?: Maybe<IptRelationship>;
  /** Reads a single `IptSituation` using its globally unique `ID`. */
  iptSituation?: Maybe<IptSituation>;
  /** Reads a single `Itq` using its globally unique `ID`. */
  itq?: Maybe<Itq>;
  /** Reads a single `Lec5` using its globally unique `ID`. */
  lec5?: Maybe<Lec5>;
  /** Reads a single `LetterTemplate` using its globally unique `ID`. */
  letterTemplate?: Maybe<LetterTemplate>;
  /** Reads a single `Letter` using its globally unique `ID`. */
  letter?: Maybe<Letter>;
  /** Reads a single `LoginToken` using its globally unique `ID`. */
  loginToken?: Maybe<LoginToken>;
  /** Reads a single `Lsa` using its globally unique `ID`. */
  lsa?: Maybe<Lsa>;
  /** Reads a single `Mspss` using its globally unique `ID`. */
  mspss?: Maybe<Mspss>;
  /** Reads a single `MyTaskLog` using its globally unique `ID`. */
  myTaskLog?: Maybe<MyTaskLog>;
  /** Reads a single `Pathev` using its globally unique `ID`. */
  pathev?: Maybe<Pathev>;
  /** Reads a single `Pcl5` using its globally unique `ID`. */
  pcl5?: Maybe<Pcl5>;
  /** Reads a single `Pg13` using its globally unique `ID`. */
  pg13?: Maybe<Pg13>;
  /** Reads a single `Phq15` using its globally unique `ID`. */
  phq15?: Maybe<Phq15>;
  /** Reads a single `Phq4` using its globally unique `ID`. */
  phq4?: Maybe<Phq4>;
  /** Reads a single `Phq9` using its globally unique `ID`. */
  phq9?: Maybe<Phq9>;
  /** Reads a single `Pmb` using its globally unique `ID`. */
  pmb?: Maybe<Pmb>;
  /** Reads a single `ProcessingQueue` using its globally unique `ID`. */
  processingQueue?: Maybe<ProcessingQueue>;
  /** Reads a single `QueueSetting` using its globally unique `ID`. */
  queueSetting?: Maybe<QueueSetting>;
  /** Reads a single `RandomizationTicket` using its globally unique `ID`. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Reads a single `Sbqr` using its globally unique `ID`. */
  sbqr?: Maybe<Sbqr>;
  /** Reads a single `Scaling` using its globally unique `ID`. */
  scaling?: Maybe<Scaling>;
  /** Reads a single `Sewip` using its globally unique `ID`. */
  sewip?: Maybe<Sewip>;
  /** Reads a single `Sib` using its globally unique `ID`. */
  sib?: Maybe<Sib>;
  /** Reads a single `SuicideNote` using its globally unique `ID`. */
  suicideNote?: Maybe<SuicideNote>;
  /** Reads a single `Taq` using its globally unique `ID`. */
  taq?: Maybe<Taq>;
  /** Reads a single `Tgisrplus` using its globally unique `ID`. */
  tgisrplus?: Maybe<Tgisrplus>;
  /** Reads a single `Traumaliste` using its globally unique `ID`. */
  traumaliste?: Maybe<Traumaliste>;
  /** Reads a single `Traumalisteneu` using its globally unique `ID`. */
  traumalisteneu?: Maybe<Traumalisteneu>;
  /** Reads a single `Trgi` using its globally unique `ID`. */
  trgi?: Maybe<Trgi>;
  /** Reads a single `User` using its globally unique `ID`. */
  user?: Maybe<User>;
  /** Reads a single `Wai` using its globally unique `ID`. */
  wai?: Maybe<Wai>;
}


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActiveCounselingsForCounselorsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ActiveCounselingsForCounselorsOrderBy>>;
  condition?: Maybe<ActiveCounselingsForCounselorCondition>;
  filter?: Maybe<ActiveCounselingsForCounselorFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActiveTherapiesForTherapistsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ActiveTherapiesForTherapistsOrderBy>>;
  condition?: Maybe<ActiveTherapiesForTherapistCondition>;
  filter?: Maybe<ActiveTherapiesForTherapistFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActiveUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ActiveUsersOrderBy>>;
  condition?: Maybe<ActiveUserCondition>;
  filter?: Maybe<ActiveUserFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAdoptibleInterviewOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AdoptibleInterviewOffersOrderBy>>;
  condition?: Maybe<AdoptibleInterviewOfferCondition>;
  filter?: Maybe<AdoptibleInterviewOfferFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllLettersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AllLettersOrderBy>>;
  condition?: Maybe<AllLetterCondition>;
  filter?: Maybe<AllLetterFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllTaskStatsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AllTaskStatsOrderBy>>;
  condition?: Maybe<AllTaskStatCondition>;
  filter?: Maybe<AllTaskStatFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAvailableInterviewDatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AvailableInterviewDatesOrderBy>>;
  condition?: Maybe<AvailableInterviewDateCondition>;
  filter?: Maybe<AvailableInterviewDateFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAvailableInterviewOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AvailableInterviewOffersOrderBy>>;
  condition?: Maybe<AvailableInterviewOfferCondition>;
  filter?: Maybe<AvailableInterviewOfferFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBdi2SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
  condition?: Maybe<Bdi2Condition>;
  filter?: Maybe<Bdi2Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBookedInterviewOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<BookedInterviewOffersOrderBy>>;
  condition?: Maybe<BookedInterviewOfferCondition>;
  filter?: Maybe<BookedInterviewOfferFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCaseMembersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMembersOrderBy>>;
  condition?: Maybe<CaseMemberCondition>;
  filter?: Maybe<CaseMemberFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCaseMembers2SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMembers2SOrderBy>>;
  condition?: Maybe<CaseMembers2Condition>;
  filter?: Maybe<CaseMembers2Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCaseMessagesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
  condition?: Maybe<CaseMessageCondition>;
  filter?: Maybe<CaseMessageFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCaseSuicideCallsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
  condition?: Maybe<CaseSuicideCallCondition>;
  filter?: Maybe<CaseSuicideCallFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCasesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CasesOrderBy>>;
  condition?: Maybe<CaseCondition>;
  filter?: Maybe<CaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCbtActivitiesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
  condition?: Maybe<CbtActivityCondition>;
  filter?: Maybe<CbtActivityFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCbtReframingsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
  condition?: Maybe<CbtReframingCondition>;
  filter?: Maybe<CbtReframingFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCbtThoughtsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
  condition?: Maybe<CbtThoughtCondition>;
  filter?: Maybe<CbtThoughtFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCdrisk10SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
  condition?: Maybe<Cdrisk10Condition>;
  filter?: Maybe<Cdrisk10Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommentsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CommentsOrderBy>>;
  condition?: Maybe<CommentCondition>;
  filter?: Maybe<CommentFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoordinatorUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CoordinatorUsersOrderBy>>;
  condition?: Maybe<CoordinatorUserCondition>;
  filter?: Maybe<CoordinatorUserFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCounselingQuestionsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
  condition?: Maybe<CounselingQuestionCondition>;
  filter?: Maybe<CounselingQuestionFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDemographicsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
  condition?: Maybe<DemographicCondition>;
  filter?: Maybe<DemographicFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDisclosuresArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
  condition?: Maybe<DisclosureCondition>;
  filter?: Maybe<DisclosureFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDueCandidateLinksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueCandidateLinksOrderBy>>;
  condition?: Maybe<DueCandidateLinkCondition>;
  filter?: Maybe<DueCandidateLinkFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDueTasksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DueTasksOrderBy>>;
  condition?: Maybe<DueTaskCondition>;
  filter?: Maybe<DueTaskFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEurohisArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EurohisOrderBy>>;
  condition?: Maybe<EurohiCondition>;
  filter?: Maybe<EurohiFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEurohisCounselingStatisticsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EurohisCounselingStatisticsOrderBy>>;
  condition?: Maybe<EurohisCounselingStatisticCondition>;
  filter?: Maybe<EurohisCounselingStatisticFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEvaluationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
  condition?: Maybe<EvaluationCondition>;
  filter?: Maybe<EvaluationFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFeedbackInterviewReportsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<FeedbackInterviewReportsOrderBy>>;
  condition?: Maybe<FeedbackInterviewReportCondition>;
  filter?: Maybe<FeedbackInterviewReportFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGad2SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
  condition?: Maybe<Gad2Condition>;
  filter?: Maybe<Gad2Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGad7SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
  condition?: Maybe<Gad7Condition>;
  filter?: Maybe<Gad7Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHashedEmailsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<HashedEmailsOrderBy>>;
  condition?: Maybe<HashedEmailCondition>;
  filter?: Maybe<HashedEmailFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInepsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InepsOrderBy>>;
  condition?: Maybe<InepCondition>;
  filter?: Maybe<InepFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewAndCallCalendarsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewAndCallCalendarsOrderBy>>;
  condition?: Maybe<InterviewAndCallCalendarCondition>;
  filter?: Maybe<InterviewAndCallCalendarFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewBookingsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewCalendarsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewCalendarAccountablesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarAccountablesOrderBy>>;
  condition?: Maybe<InterviewCalendarAccountableCondition>;
  filter?: Maybe<InterviewCalendarAccountableFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewCalendarNewsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarNewsOrderBy>>;
  condition?: Maybe<InterviewCalendarNewCondition>;
  filter?: Maybe<InterviewCalendarNewFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
  condition?: Maybe<InterviewOfferCondition>;
  filter?: Maybe<InterviewOfferFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewReportsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
  condition?: Maybe<InterviewReportCondition>;
  filter?: Maybe<InterviewReportFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIntervieweesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IntervieweesOrderBy>>;
  condition?: Maybe<IntervieweeCondition>;
  filter?: Maybe<IntervieweeFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInterviewersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewersOrderBy>>;
  condition?: Maybe<InterviewerCondition>;
  filter?: Maybe<InterviewerFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvoicesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InvoicesOrderBy>>;
  condition?: Maybe<InvoiceCondition>;
  filter?: Maybe<InvoiceFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvolvementsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
  condition?: Maybe<InvolvementCondition>;
  filter?: Maybe<InvolvementFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvolvementsInMyCasesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InvolvementsInMyCasesOrderBy>>;
  condition?: Maybe<InvolvementsInMyCaseCondition>;
  filter?: Maybe<InvolvementsInMyCaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIptConflictsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
  condition?: Maybe<IptConflictCondition>;
  filter?: Maybe<IptConflictFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIptRelationshipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
  condition?: Maybe<IptRelationshipCondition>;
  filter?: Maybe<IptRelationshipFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIptSituationsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
  condition?: Maybe<IptSituationCondition>;
  filter?: Maybe<IptSituationFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllItqsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ItqsOrderBy>>;
  condition?: Maybe<ItqCondition>;
  filter?: Maybe<ItqFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLec5SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
  condition?: Maybe<Lec5Condition>;
  filter?: Maybe<Lec5Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLetterTemplatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LetterTemplatesOrderBy>>;
  condition?: Maybe<LetterTemplateCondition>;
  filter?: Maybe<LetterTemplateFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLetterinfoByUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LetterinfoByUsersOrderBy>>;
  condition?: Maybe<LetterinfoByUserCondition>;
  filter?: Maybe<LetterinfoByUserFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLettersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LettersOrderBy>>;
  condition?: Maybe<LetterCondition>;
  filter?: Maybe<LetterFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLoginTokensArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LoginTokensOrderBy>>;
  condition?: Maybe<LoginTokenCondition>;
  filter?: Maybe<LoginTokenFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLsasArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LsasOrderBy>>;
  condition?: Maybe<LsaCondition>;
  filter?: Maybe<LsaFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMspssesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MspssesOrderBy>>;
  condition?: Maybe<MspssCondition>;
  filter?: Maybe<MspssFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyAccountsOrderBy>>;
  condition?: Maybe<MyAccountCondition>;
  filter?: Maybe<MyAccountFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyCasesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyCasesOrderBy>>;
  condition?: Maybe<MyCaseCondition>;
  filter?: Maybe<MyCaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyCasesOverviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyCasesOverviewsOrderBy>>;
  condition?: Maybe<MyCasesOverviewCondition>;
  filter?: Maybe<MyCasesOverviewFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyCasesOverview2SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyCasesOverview2SOrderBy>>;
  condition?: Maybe<MyCasesOverview2Condition>;
  filter?: Maybe<MyCasesOverview2Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyDatesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyDatesOrderBy>>;
  condition?: Maybe<MyDateCondition>;
  filter?: Maybe<MyDateFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyDueTasksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyDueTasksOrderBy>>;
  condition?: Maybe<MyDueTaskCondition>;
  filter?: Maybe<MyDueTaskFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyGatewaysArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyGatewaysOrderBy>>;
  condition?: Maybe<MyGatewayCondition>;
  filter?: Maybe<MyGatewayFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyHistoricIdentitylinksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyHistoricIdentitylinksOrderBy>>;
  condition?: Maybe<MyHistoricIdentitylinkCondition>;
  filter?: Maybe<MyHistoricIdentitylinkFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyInterviewBookingsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyInterviewBookingsOrderBy>>;
  condition?: Maybe<MyInterviewBookingCondition>;
  filter?: Maybe<MyInterviewBookingFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyInterviewOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyInterviewOffersOrderBy>>;
  condition?: Maybe<MyInterviewOfferCondition>;
  filter?: Maybe<MyInterviewOfferFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyInvolvementsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyInvolvementsOrderBy>>;
  condition?: Maybe<MyInvolvementCondition>;
  filter?: Maybe<MyInvolvementFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyMessagesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyMessagesOrderBy>>;
  condition?: Maybe<MyMessageCondition>;
  filter?: Maybe<MyMessageFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyProcessLogsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyProcessLogsOrderBy>>;
  condition?: Maybe<MyProcessLogCondition>;
  filter?: Maybe<MyProcessLogFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyRunningProcessesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyRunningProcessesOrderBy>>;
  condition?: Maybe<MyRunningProcessCondition>;
  filter?: Maybe<MyRunningProcessFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyTaskLogsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogsOrderBy>>;
  condition?: Maybe<MyTaskLogCondition>;
  filter?: Maybe<MyTaskLogFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyTaskLogOptsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogOptsOrderBy>>;
  condition?: Maybe<MyTaskLogOptCondition>;
  filter?: Maybe<MyTaskLogOptFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyTaskLogOpt3SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogOpt3SOrderBy>>;
  condition?: Maybe<MyTaskLogOpt3Condition>;
  filter?: Maybe<MyTaskLogOpt3Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMyTaskLogOpt4SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MyTaskLogOpt4SOrderBy>>;
  condition?: Maybe<MyTaskLogOpt4Condition>;
  filter?: Maybe<MyTaskLogOpt4Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPathevsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PathevsOrderBy>>;
  condition?: Maybe<PathevCondition>;
  filter?: Maybe<PathevFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPcl5SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
  condition?: Maybe<Pcl5Condition>;
  filter?: Maybe<Pcl5Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPg13SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
  condition?: Maybe<Pg13Condition>;
  filter?: Maybe<Pg13Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPhq15SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
  condition?: Maybe<Phq15Condition>;
  filter?: Maybe<Phq15Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPhq4SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
  condition?: Maybe<Phq4Condition>;
  filter?: Maybe<Phq4Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPhq9SArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
  condition?: Maybe<Phq9Condition>;
  filter?: Maybe<Phq9Filter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPmbsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PmbsOrderBy>>;
  condition?: Maybe<PmbCondition>;
  filter?: Maybe<PmbFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProcessLogsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ProcessLogsOrderBy>>;
  condition?: Maybe<ProcessLogCondition>;
  filter?: Maybe<ProcessLogFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProcessesByCaseWithActivitiesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ProcessesByCaseWithActivitiesOrderBy>>;
  condition?: Maybe<ProcessesByCaseWithActivityCondition>;
  filter?: Maybe<ProcessesByCaseWithActivityFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProcessingQueuesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ProcessingQueuesOrderBy>>;
  condition?: Maybe<ProcessingQueueCondition>;
  filter?: Maybe<ProcessingQueueFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllQueueSettingsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<QueueSettingsOrderBy>>;
  condition?: Maybe<QueueSettingCondition>;
  filter?: Maybe<QueueSettingFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRandomizationTicketsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
  condition?: Maybe<RandomizationTicketCondition>;
  filter?: Maybe<RandomizationTicketFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSbqrsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
  condition?: Maybe<SbqrCondition>;
  filter?: Maybe<SbqrFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllScalingsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
  condition?: Maybe<ScalingCondition>;
  filter?: Maybe<ScalingFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSewipsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SewipsOrderBy>>;
  condition?: Maybe<SewipCondition>;
  filter?: Maybe<SewipFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSibsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SibsOrderBy>>;
  condition?: Maybe<SibCondition>;
  filter?: Maybe<SibFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSuicideNotesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
  condition?: Maybe<SuicideNoteCondition>;
  filter?: Maybe<SuicideNoteFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTaqsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TaqsOrderBy>>;
  condition?: Maybe<TaqCondition>;
  filter?: Maybe<TaqFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTgisrplusesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
  condition?: Maybe<TgisrplusCondition>;
  filter?: Maybe<TgisrplusFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTraumalistesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
  condition?: Maybe<TraumalisteCondition>;
  filter?: Maybe<TraumalisteFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTraumalisteneusArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
  condition?: Maybe<TraumalisteneuCondition>;
  filter?: Maybe<TraumalisteneuFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTrgisArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TrgisOrderBy>>;
  condition?: Maybe<TrgiCondition>;
  filter?: Maybe<TrgiFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
  condition?: Maybe<UserCondition>;
  filter?: Maybe<UserFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWaisArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<WaisOrderBy>>;
  condition?: Maybe<WaiCondition>;
  filter?: Maybe<WaiFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBdi2ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseMemberByUserIdAndCaseIdArgs = {
  userId: Scalars['UUID'];
  caseId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseSuicideCallByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtActivityByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtReframingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtThoughtByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCdrisk10ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCounselingQuestionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDemographicByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisclosureByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDueTaskByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEurohiByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEvaluationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbackInterviewReportByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGad2ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGad7ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHashedEmailByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInepByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewBookingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewBookingByIdAndCaseIdArgs = {
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewCalendarByOfferIdArgs = {
  offerId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewOfferByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewReportByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntervieweeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvolvementByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptConflictByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptRelationshipByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptSituationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItqByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLec5ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLetterTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLetterByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoginTokenByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLsaByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMspssByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyDateByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyDateByCaseIdAndNameArgs = {
  caseId: Scalars['UUID'];
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyInvolvementByCaseIdArgs = {
  caseId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTaskLogByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPathevByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPcl5ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPg13ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq15ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq4ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq9ByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPmbByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessingQueueByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQueueSettingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySbqrByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScalingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySewipByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySibByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuicideNoteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaqByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTgisrplusByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraumalisteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraumalisteneuByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrgiByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByUsernameArgs = {
  username: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWaiByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLetterByCaseidArgs = {
  caseid?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<LetterFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchCasesArgs = {
  filterUnassigned?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  filterStage?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CasesOrderBy>>;
  condition?: Maybe<CaseCondition>;
  filter?: Maybe<CaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchCasesNewArgs = {
  filterUnassigned?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  filterStage?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<CaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchMyCasesArgs = {
  filterUnassigned?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  filterStage?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<CaseFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShortUuidArgs = {
  u?: Maybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTryCastUuidArgs = {
  input: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBdi2Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseMessageArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseSuicideCallArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaseArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtActivityArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtReframingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCbtThoughtArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCdrisk10Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCounselingQuestionArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDemographicArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisclosureArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDueTaskArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEurohiArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEvaluationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbackInterviewReportArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGad2Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGad7Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHashedEmailArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInepArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewBookingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewOfferArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInterviewReportArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvolvementArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptConflictArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptRelationshipArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIptSituationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItqArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLec5Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLetterTemplateArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLetterArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoginTokenArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLsaArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMspssArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTaskLogArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPathevArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPcl5Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPg13Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq15Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq4Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhq9Args = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPmbArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessingQueueArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQueueSettingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySbqrArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScalingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySewipArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySibArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuicideNoteArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaqArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTgisrplusArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraumalisteArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTraumalisteneuArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrgiArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWaiArgs = {
  nodeId: Scalars['ID'];
};

export interface QueueSetting extends Node {
  __typename?: 'QueueSetting';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  queueSizeCounseling: Scalars['Int'];
  queueSizeTherapy: Scalars['Int'];
  userIdEditor: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `QueueSetting`. */
  userByUserIdEditor?: Maybe<User>;
}

/**
 * A condition to be used against `QueueSetting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface QueueSettingCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `queueSizeCounseling` field. */
  queueSizeCounseling?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `queueSizeTherapy` field. */
  queueSizeTherapy?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userIdEditor` field. */
  userIdEditor?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `QueueSetting` object types. All fields are combined with a logical ‘and.’ */
export interface QueueSettingFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `queueSizeCounseling` field. */
  queueSizeCounseling?: Maybe<IntFilter>;
  /** Filter by the object’s `queueSizeTherapy` field. */
  queueSizeTherapy?: Maybe<IntFilter>;
  /** Filter by the object’s `userIdEditor` field. */
  userIdEditor?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<QueueSettingFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<QueueSettingFilter>>;
  /** Negates the expression. */
  not?: Maybe<QueueSettingFilter>;
}

/** An input for mutations affecting `QueueSetting` */
export interface QueueSettingInput {
  id?: Maybe<Scalars['UUID']>;
  queueSizeCounseling?: Maybe<Scalars['Int']>;
  queueSizeTherapy?: Maybe<Scalars['Int']>;
  userIdEditor: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `QueueSetting`. Fields that are set will be updated. */
export interface QueueSettingPatch {
  id?: Maybe<Scalars['UUID']>;
  queueSizeCounseling?: Maybe<Scalars['Int']>;
  queueSizeTherapy?: Maybe<Scalars['Int']>;
  userIdEditor?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `QueueSetting` values. */
export interface QueueSettingsConnection {
  __typename?: 'QueueSettingsConnection';
  /** A list of `QueueSetting` objects. */
  nodes: Array<QueueSetting>;
  /** A list of edges which contains the `QueueSetting` and cursor to aid in pagination. */
  edges: Array<QueueSettingsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QueueSetting` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `QueueSetting` edge in the connection. */
export interface QueueSettingsEdge {
  __typename?: 'QueueSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `QueueSetting` at the end of the edge. */
  node: QueueSetting;
}

/** Methods to use when ordering `QueueSetting`. */
export enum QueueSettingsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  QueueSizeCounselingAsc = 'QUEUE_SIZE_COUNSELING_ASC',
  QueueSizeCounselingDesc = 'QUEUE_SIZE_COUNSELING_DESC',
  QueueSizeTherapyAsc = 'QUEUE_SIZE_THERAPY_ASC',
  QueueSizeTherapyDesc = 'QUEUE_SIZE_THERAPY_DESC',
  UserIdEditorAsc = 'USER_ID_EDITOR_ASC',
  UserIdEditorDesc = 'USER_ID_EDITOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface RandomizationTicket extends Node {
  __typename?: 'RandomizationTicket';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  list: Scalars['String'];
  blockNumber: Scalars['Int'];
  diagnosis: Scalars['String'];
  treatment: Scalars['String'];
  caseId?: Maybe<Scalars['UUID']>;
  assignedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
}

/**
 * A condition to be used against `RandomizationTicket` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export interface RandomizationTicketCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `list` field. */
  list?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `blockNumber` field. */
  blockNumber?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `diagnosis` field. */
  diagnosis?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `treatment` field. */
  treatment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `assignedAt` field. */
  assignedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `RandomizationTicket` object types. All fields are combined with a logical ‘and.’ */
export interface RandomizationTicketFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `list` field. */
  list?: Maybe<StringFilter>;
  /** Filter by the object’s `blockNumber` field. */
  blockNumber?: Maybe<IntFilter>;
  /** Filter by the object’s `diagnosis` field. */
  diagnosis?: Maybe<StringFilter>;
  /** Filter by the object’s `treatment` field. */
  treatment?: Maybe<StringFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `assignedAt` field. */
  assignedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<RandomizationTicketFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<RandomizationTicketFilter>>;
  /** Negates the expression. */
  not?: Maybe<RandomizationTicketFilter>;
}

/** An input for mutations affecting `RandomizationTicket` */
export interface RandomizationTicketInput {
  id?: Maybe<Scalars['UUID']>;
  list: Scalars['String'];
  blockNumber: Scalars['Int'];
  diagnosis: Scalars['String'];
  treatment: Scalars['String'];
  caseId?: Maybe<Scalars['UUID']>;
  assignedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `RandomizationTicket`. Fields that are set will be updated. */
export interface RandomizationTicketPatch {
  id?: Maybe<Scalars['UUID']>;
  list?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
  diagnosis?: Maybe<Scalars['String']>;
  treatment?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['UUID']>;
  assignedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `RandomizationTicket` values. */
export interface RandomizationTicketsConnection {
  __typename?: 'RandomizationTicketsConnection';
  /** A list of `RandomizationTicket` objects. */
  nodes: Array<RandomizationTicket>;
  /** A list of edges which contains the `RandomizationTicket` and cursor to aid in pagination. */
  edges: Array<RandomizationTicketsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RandomizationTicket` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `RandomizationTicket` edge in the connection. */
export interface RandomizationTicketsEdge {
  __typename?: 'RandomizationTicketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RandomizationTicket` at the end of the edge. */
  node: RandomizationTicket;
}

/** Methods to use when ordering `RandomizationTicket`. */
export enum RandomizationTicketsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListAsc = 'LIST_ASC',
  ListDesc = 'LIST_DESC',
  BlockNumberAsc = 'BLOCK_NUMBER_ASC',
  BlockNumberDesc = 'BLOCK_NUMBER_DESC',
  DiagnosisAsc = 'DIAGNOSIS_ASC',
  DiagnosisDesc = 'DIAGNOSIS_DESC',
  TreatmentAsc = 'TREATMENT_ASC',
  TreatmentDesc = 'TREATMENT_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  AssignedAtAsc = 'ASSIGNED_AT_ASC',
  AssignedAtDesc = 'ASSIGNED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `randomize` mutation. */
export interface RandomizeInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  case_: CaseInput;
  toList: Scalars['String'];
}

/** The output of our `randomize` mutation. */
export interface RandomizePayload {
  __typename?: 'RandomizePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
}


/** The output of our `randomize` mutation. */
export type RandomizePayloadRandomizationTicketEdgeArgs = {
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the `randomizeUsingCaseId` mutation. */
export interface RandomizeUsingCaseIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  caseId: Scalars['UUID'];
  toList: Scalars['String'];
}

/** The output of our `randomizeUsingCaseId` mutation. */
export interface RandomizeUsingCaseIdPayload {
  __typename?: 'RandomizeUsingCaseIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
}


/** The output of our `randomizeUsingCaseId` mutation. */
export type RandomizeUsingCaseIdPayloadRandomizationTicketEdgeArgs = {
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
};

export interface Sbqr extends Node {
  __typename?: 'Sbqr';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Boolean'];
  item8: Scalars['Boolean'];
  item9: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Sbqr`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sbqr`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Sbqr` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface SbqrCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Sbqr` object types. All fields are combined with a logical ‘and.’ */
export interface SbqrFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SbqrFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SbqrFilter>>;
  /** Negates the expression. */
  not?: Maybe<SbqrFilter>;
}

/** An input for mutations affecting `Sbqr` */
export interface SbqrInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7?: Maybe<Scalars['Boolean']>;
  item8?: Maybe<Scalars['Boolean']>;
  item9?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Sbqr`. Fields that are set will be updated. */
export interface SbqrPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Boolean']>;
  item8?: Maybe<Scalars['Boolean']>;
  item9?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Sbqr` values. */
export interface SbqrsConnection {
  __typename?: 'SbqrsConnection';
  /** A list of `Sbqr` objects. */
  nodes: Array<Sbqr>;
  /** A list of edges which contains the `Sbqr` and cursor to aid in pagination. */
  edges: Array<SbqrsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Sbqr` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Sbqr` edge in the connection. */
export interface SbqrsEdge {
  __typename?: 'SbqrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Sbqr` at the end of the edge. */
  node: Sbqr;
}

/** Methods to use when ordering `Sbqr`. */
export enum SbqrsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Scaling extends Node {
  __typename?: 'Scaling';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  score: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Scaling`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Scaling`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Scaling` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface ScalingCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Scaling` object types. All fields are combined with a logical ‘and.’ */
export interface ScalingFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ScalingFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ScalingFilter>>;
  /** Negates the expression. */
  not?: Maybe<ScalingFilter>;
}

/** An input for mutations affecting `Scaling` */
export interface ScalingInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  score: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Scaling`. Fields that are set will be updated. */
export interface ScalingPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Scaling` values. */
export interface ScalingsConnection {
  __typename?: 'ScalingsConnection';
  /** A list of `Scaling` objects. */
  nodes: Array<Scaling>;
  /** A list of edges which contains the `Scaling` and cursor to aid in pagination. */
  edges: Array<ScalingsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Scaling` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Scaling` edge in the connection. */
export interface ScalingsEdge {
  __typename?: 'ScalingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Scaling` at the end of the edge. */
  node: Scaling;
}

/** Methods to use when ordering `Scaling`. */
export enum ScalingsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Sewip extends Node {
  __typename?: 'Sewip';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  scoreEmotionalBond?: Maybe<Scalars['Int']>;
  scoreProblemActuation?: Maybe<Scalars['Int']>;
  scoreResourceActivation?: Maybe<Scalars['Int']>;
  scoreCollaborationClarification?: Maybe<Scalars['Int']>;
  scoreCollaborationAgreement?: Maybe<Scalars['Int']>;
  scoreMastery?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Sewip`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sewip`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Sewip` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface SewipCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreEmotionalBond` field. */
  scoreEmotionalBond?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreProblemActuation` field. */
  scoreProblemActuation?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreResourceActivation` field. */
  scoreResourceActivation?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreCollaborationClarification` field. */
  scoreCollaborationClarification?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreCollaborationAgreement` field. */
  scoreCollaborationAgreement?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreMastery` field. */
  scoreMastery?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Sewip` object types. All fields are combined with a logical ‘and.’ */
export interface SewipFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<IntFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreEmotionalBond` field. */
  scoreEmotionalBond?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreProblemActuation` field. */
  scoreProblemActuation?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreResourceActivation` field. */
  scoreResourceActivation?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreCollaborationClarification` field. */
  scoreCollaborationClarification?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreCollaborationAgreement` field. */
  scoreCollaborationAgreement?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreMastery` field. */
  scoreMastery?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SewipFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SewipFilter>>;
  /** Negates the expression. */
  not?: Maybe<SewipFilter>;
}

/** An input for mutations affecting `Sewip` */
export interface SewipInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  scoreEmotionalBond?: Maybe<Scalars['Int']>;
  scoreProblemActuation?: Maybe<Scalars['Int']>;
  scoreResourceActivation?: Maybe<Scalars['Int']>;
  scoreCollaborationClarification?: Maybe<Scalars['Int']>;
  scoreCollaborationAgreement?: Maybe<Scalars['Int']>;
  scoreMastery?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Sewip`. Fields that are set will be updated. */
export interface SewipPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  scoreEmotionalBond?: Maybe<Scalars['Int']>;
  scoreProblemActuation?: Maybe<Scalars['Int']>;
  scoreResourceActivation?: Maybe<Scalars['Int']>;
  scoreCollaborationClarification?: Maybe<Scalars['Int']>;
  scoreCollaborationAgreement?: Maybe<Scalars['Int']>;
  scoreMastery?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Sewip` values. */
export interface SewipsConnection {
  __typename?: 'SewipsConnection';
  /** A list of `Sewip` objects. */
  nodes: Array<Sewip>;
  /** A list of edges which contains the `Sewip` and cursor to aid in pagination. */
  edges: Array<SewipsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Sewip` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Sewip` edge in the connection. */
export interface SewipsEdge {
  __typename?: 'SewipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Sewip` at the end of the edge. */
  node: Sewip;
}

/** Methods to use when ordering `Sewip`. */
export enum SewipsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  ScoreEmotionalBondAsc = 'SCORE_EMOTIONAL_BOND_ASC',
  ScoreEmotionalBondDesc = 'SCORE_EMOTIONAL_BOND_DESC',
  ScoreProblemActuationAsc = 'SCORE_PROBLEM_ACTUATION_ASC',
  ScoreProblemActuationDesc = 'SCORE_PROBLEM_ACTUATION_DESC',
  ScoreResourceActivationAsc = 'SCORE_RESOURCE_ACTIVATION_ASC',
  ScoreResourceActivationDesc = 'SCORE_RESOURCE_ACTIVATION_DESC',
  ScoreCollaborationClarificationAsc = 'SCORE_COLLABORATION_CLARIFICATION_ASC',
  ScoreCollaborationClarificationDesc = 'SCORE_COLLABORATION_CLARIFICATION_DESC',
  ScoreCollaborationAgreementAsc = 'SCORE_COLLABORATION_AGREEMENT_ASC',
  ScoreCollaborationAgreementDesc = 'SCORE_COLLABORATION_AGREEMENT_DESC',
  ScoreMasteryAsc = 'SCORE_MASTERY_ASC',
  ScoreMasteryDesc = 'SCORE_MASTERY_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Sib extends Node {
  __typename?: 'Sib';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Boolean'];
  item8: Scalars['Boolean'];
  item9: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Sib`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sib`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Sib` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface SibCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Sib` object types. All fields are combined with a logical ‘and.’ */
export interface SibFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SibFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SibFilter>>;
  /** Negates the expression. */
  not?: Maybe<SibFilter>;
}

/** An input for mutations affecting `Sib` */
export interface SibInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId: Scalars['UUID'];
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7?: Maybe<Scalars['Boolean']>;
  item8?: Maybe<Scalars['Boolean']>;
  item9?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Sib`. Fields that are set will be updated. */
export interface SibPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Boolean']>;
  item8?: Maybe<Scalars['Boolean']>;
  item9?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Sib` values. */
export interface SibsConnection {
  __typename?: 'SibsConnection';
  /** A list of `Sib` objects. */
  nodes: Array<Sib>;
  /** A list of edges which contains the `Sib` and cursor to aid in pagination. */
  edges: Array<SibsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Sib` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Sib` edge in the connection. */
export interface SibsEdge {
  __typename?: 'SibsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Sib` at the end of the edge. */
  node: Sib;
}

/** Methods to use when ordering `Sib`. */
export enum SibsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export interface StringFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['String']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['String']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['String']>;
  /** Contains the specified string (case-sensitive). */
  includes?: Maybe<Scalars['String']>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: Maybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: Maybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: Maybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: Maybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: Maybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: Maybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: Maybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: Maybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: Maybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: Maybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: Maybe<Scalars['String']>;
  /**
   * Matches the specified pattern (case-sensitive). An underscore (_) matches any
   * single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  like?: Maybe<Scalars['String']>;
  /**
   * Does not match the specified pattern (case-sensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLike?: Maybe<Scalars['String']>;
  /**
   * Matches the specified pattern (case-insensitive). An underscore (_) matches
   * any single character; a percent sign (%) matches any sequence of zero or more characters.
   */
  likeInsensitive?: Maybe<Scalars['String']>;
  /**
   * Does not match the specified pattern (case-insensitive). An underscore (_)
   * matches any single character; a percent sign (%) matches any sequence of zero
   * or more characters.
   */
  notLikeInsensitive?: Maybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: Maybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: Maybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: Maybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: Maybe<Scalars['String']>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: Maybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: Maybe<Array<Scalars['String']>>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: Maybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: Maybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: Maybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: Maybe<Scalars['String']>;
}

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export interface StringListFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contained by the specified list of values. */
  containedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Any array item is equal to the specified value. */
  anyEqualTo?: Maybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: Maybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: Maybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: Maybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: Maybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: Maybe<Scalars['String']>;
}

/** Suicide Notes -> originally from the Google docs document */
export interface SuicideNote extends Node {
  __typename?: 'SuicideNote';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Primary key of suicide notes */
  id: Scalars['UUID'];
  /** ID of case to that the suicide note belongs to. Foreign Key to cases(id) */
  caseId: Scalars['UUID'];
  /** ID of the user that created this suicide note. Foreign key to users(id) */
  userIdCreator: Scalars['UUID'];
  /** Creation date of this note. This creation date is independent from interview date (date of phone call) */
  creationDate: Scalars['Datetime'];
  /** date of interview / phone call of patient or the trial to contact the patient */
  contactDate: Scalars['Datetime'];
  /** Risk of suicide - rating of therapist after phone call */
  acuteRiskOfSuicide?: Maybe<Scalars['String']>;
  /** Has the patient been reached for a phone call? */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** actions and results of the phone call with patient */
  actionsAndResult?: Maybe<Scalars['String']>;
  /** Is a follow-up-call required / reasonable? */
  followupContact?: Maybe<Scalars['Boolean']>;
  /** Additional comments to follow-up-calls (e.g. when / with whom, ...) */
  followupComment?: Maybe<Scalars['String']>;
  /** Should the patient be excluded from the therapy due to suicide risk */
  exclude: Scalars['Boolean'];
  /** Will it be necessary to inform coordinators for further escalation? */
  coordinatorsInformed?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByUserIdCreator?: Maybe<Case>;
}

/**
 * A condition to be used against `SuicideNote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface SuicideNoteCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userIdCreator` field. */
  userIdCreator?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `creationDate` field. */
  creationDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `contactDate` field. */
  contactDate?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `acuteRiskOfSuicide` field. */
  acuteRiskOfSuicide?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientReached` field. */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `actionsAndResult` field. */
  actionsAndResult?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `followupContact` field. */
  followupContact?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `followupComment` field. */
  followupComment?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `exclude` field. */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `coordinatorsInformed` field. */
  coordinatorsInformed?: Maybe<Scalars['Date']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `SuicideNote` object types. All fields are combined with a logical ‘and.’ */
export interface SuicideNoteFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `userIdCreator` field. */
  userIdCreator?: Maybe<UuidFilter>;
  /** Filter by the object’s `creationDate` field. */
  creationDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `contactDate` field. */
  contactDate?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `acuteRiskOfSuicide` field. */
  acuteRiskOfSuicide?: Maybe<StringFilter>;
  /** Filter by the object’s `patientReached` field. */
  patientReached?: Maybe<BooleanFilter>;
  /** Filter by the object’s `actionsAndResult` field. */
  actionsAndResult?: Maybe<StringFilter>;
  /** Filter by the object’s `followupContact` field. */
  followupContact?: Maybe<BooleanFilter>;
  /** Filter by the object’s `followupComment` field. */
  followupComment?: Maybe<StringFilter>;
  /** Filter by the object’s `exclude` field. */
  exclude?: Maybe<BooleanFilter>;
  /** Filter by the object’s `coordinatorsInformed` field. */
  coordinatorsInformed?: Maybe<DateFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SuicideNoteFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SuicideNoteFilter>>;
  /** Negates the expression. */
  not?: Maybe<SuicideNoteFilter>;
}

/** An input for mutations affecting `SuicideNote` */
export interface SuicideNoteInput {
  /** Primary key of suicide notes */
  id: Scalars['UUID'];
  /** ID of case to that the suicide note belongs to. Foreign Key to cases(id) */
  caseId: Scalars['UUID'];
  /** ID of the user that created this suicide note. Foreign key to users(id) */
  userIdCreator: Scalars['UUID'];
  /** Creation date of this note. This creation date is independent from interview date (date of phone call) */
  creationDate?: Maybe<Scalars['Datetime']>;
  /** date of interview / phone call of patient or the trial to contact the patient */
  contactDate: Scalars['Datetime'];
  /** Risk of suicide - rating of therapist after phone call */
  acuteRiskOfSuicide?: Maybe<Scalars['String']>;
  /** Has the patient been reached for a phone call? */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** actions and results of the phone call with patient */
  actionsAndResult?: Maybe<Scalars['String']>;
  /** Is a follow-up-call required / reasonable? */
  followupContact?: Maybe<Scalars['Boolean']>;
  /** Additional comments to follow-up-calls (e.g. when / with whom, ...) */
  followupComment?: Maybe<Scalars['String']>;
  /** Should the patient be excluded from the therapy due to suicide risk */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Will it be necessary to inform coordinators for further escalation? */
  coordinatorsInformed?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `SuicideNote`. Fields that are set will be updated. */
export interface SuicideNotePatch {
  /** Primary key of suicide notes */
  id?: Maybe<Scalars['UUID']>;
  /** ID of case to that the suicide note belongs to. Foreign Key to cases(id) */
  caseId?: Maybe<Scalars['UUID']>;
  /** ID of the user that created this suicide note. Foreign key to users(id) */
  userIdCreator?: Maybe<Scalars['UUID']>;
  /** Creation date of this note. This creation date is independent from interview date (date of phone call) */
  creationDate?: Maybe<Scalars['Datetime']>;
  /** date of interview / phone call of patient or the trial to contact the patient */
  contactDate?: Maybe<Scalars['Datetime']>;
  /** Risk of suicide - rating of therapist after phone call */
  acuteRiskOfSuicide?: Maybe<Scalars['String']>;
  /** Has the patient been reached for a phone call? */
  patientReached?: Maybe<Scalars['Boolean']>;
  /** actions and results of the phone call with patient */
  actionsAndResult?: Maybe<Scalars['String']>;
  /** Is a follow-up-call required / reasonable? */
  followupContact?: Maybe<Scalars['Boolean']>;
  /** Additional comments to follow-up-calls (e.g. when / with whom, ...) */
  followupComment?: Maybe<Scalars['String']>;
  /** Should the patient be excluded from the therapy due to suicide risk */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Will it be necessary to inform coordinators for further escalation? */
  coordinatorsInformed?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `SuicideNote` values. */
export interface SuicideNotesConnection {
  __typename?: 'SuicideNotesConnection';
  /** A list of `SuicideNote` objects. */
  nodes: Array<SuicideNote>;
  /** A list of edges which contains the `SuicideNote` and cursor to aid in pagination. */
  edges: Array<SuicideNotesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuicideNote` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `SuicideNote` edge in the connection. */
export interface SuicideNotesEdge {
  __typename?: 'SuicideNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuicideNote` at the end of the edge. */
  node: SuicideNote;
}

/** Methods to use when ordering `SuicideNote`. */
export enum SuicideNotesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  UserIdCreatorAsc = 'USER_ID_CREATOR_ASC',
  UserIdCreatorDesc = 'USER_ID_CREATOR_DESC',
  CreationDateAsc = 'CREATION_DATE_ASC',
  CreationDateDesc = 'CREATION_DATE_DESC',
  ContactDateAsc = 'CONTACT_DATE_ASC',
  ContactDateDesc = 'CONTACT_DATE_DESC',
  AcuteRiskOfSuicideAsc = 'ACUTE_RISK_OF_SUICIDE_ASC',
  AcuteRiskOfSuicideDesc = 'ACUTE_RISK_OF_SUICIDE_DESC',
  PatientReachedAsc = 'PATIENT_REACHED_ASC',
  PatientReachedDesc = 'PATIENT_REACHED_DESC',
  ActionsAndResultAsc = 'ACTIONS_AND_RESULT_ASC',
  ActionsAndResultDesc = 'ACTIONS_AND_RESULT_DESC',
  FollowupContactAsc = 'FOLLOWUP_CONTACT_ASC',
  FollowupContactDesc = 'FOLLOWUP_CONTACT_DESC',
  FollowupCommentAsc = 'FOLLOWUP_COMMENT_ASC',
  FollowupCommentDesc = 'FOLLOWUP_COMMENT_DESC',
  ExcludeAsc = 'EXCLUDE_ASC',
  ExcludeDesc = 'EXCLUDE_DESC',
  CoordinatorsInformedAsc = 'COORDINATORS_INFORMED_ASC',
  CoordinatorsInformedDesc = 'COORDINATORS_INFORMED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Taq extends Node {
  __typename?: 'Taq';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  item23: Scalars['Int'];
  item24: Scalars['Int'];
  item25: Scalars['Int'];
  item26: Scalars['Int'];
  item27: Scalars['Int'];
  item28: Scalars['Int'];
  item29: Scalars['Int'];
  item30: Scalars['Int'];
  item31: Scalars['Int'];
  item32: Scalars['Int'];
  item33: Scalars['Int'];
  item34: Scalars['Int'];
  item35: Scalars['Int'];
  item36: Scalars['Int'];
  item37: Scalars['Int'];
  item38: Scalars['Int'];
  item39: Scalars['Int'];
  item40: Scalars['Int'];
  item41: Scalars['Int'];
  item42: Scalars['Int'];
  item43: Scalars['Int'];
  item44: Scalars['Int'];
  item45: Scalars['Int'];
  item46: Scalars['Int'];
  item47: Scalars['Int'];
  item48: Scalars['Int'];
  item49: Scalars['Int'];
  item50: Scalars['Int'];
  item51: Scalars['Int'];
  item52: Scalars['Int'];
  item53: Scalars['Int'];
  item54: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  scoreBetrayal?: Maybe<Scalars['Int']>;
  scoreSelfBlame?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  scoreAlienation?: Maybe<Scalars['Int']>;
  scoreAnger?: Maybe<Scalars['Int']>;
  scoreShame?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Taq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Taq`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Taq` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface TaqCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item22` field. */
  item22?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item23` field. */
  item23?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item24` field. */
  item24?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item25` field. */
  item25?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item26` field. */
  item26?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item27` field. */
  item27?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item28` field. */
  item28?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item29` field. */
  item29?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item30` field. */
  item30?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item31` field. */
  item31?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item32` field. */
  item32?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item33` field. */
  item33?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item34` field. */
  item34?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item35` field. */
  item35?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item36` field. */
  item36?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item37` field. */
  item37?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item38` field. */
  item38?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item39` field. */
  item39?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item40` field. */
  item40?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item41` field. */
  item41?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item42` field. */
  item42?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item43` field. */
  item43?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item44` field. */
  item44?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item45` field. */
  item45?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item46` field. */
  item46?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item47` field. */
  item47?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item48` field. */
  item48?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item49` field. */
  item49?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item50` field. */
  item50?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item51` field. */
  item51?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item52` field. */
  item52?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item53` field. */
  item53?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item54` field. */
  item54?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreBetrayal` field. */
  scoreBetrayal?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreSelfBlame` field. */
  scoreSelfBlame?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreFear` field. */
  scoreFear?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreAlienation` field. */
  scoreAlienation?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreAnger` field. */
  scoreAnger?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scoreShame` field. */
  scoreShame?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A filter to be used against `Taq` object types. All fields are combined with a logical ‘and.’ */
export interface TaqFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<IntFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<IntFilter>;
  /** Filter by the object’s `item22` field. */
  item22?: Maybe<IntFilter>;
  /** Filter by the object’s `item23` field. */
  item23?: Maybe<IntFilter>;
  /** Filter by the object’s `item24` field. */
  item24?: Maybe<IntFilter>;
  /** Filter by the object’s `item25` field. */
  item25?: Maybe<IntFilter>;
  /** Filter by the object’s `item26` field. */
  item26?: Maybe<IntFilter>;
  /** Filter by the object’s `item27` field. */
  item27?: Maybe<IntFilter>;
  /** Filter by the object’s `item28` field. */
  item28?: Maybe<IntFilter>;
  /** Filter by the object’s `item29` field. */
  item29?: Maybe<IntFilter>;
  /** Filter by the object’s `item30` field. */
  item30?: Maybe<IntFilter>;
  /** Filter by the object’s `item31` field. */
  item31?: Maybe<IntFilter>;
  /** Filter by the object’s `item32` field. */
  item32?: Maybe<IntFilter>;
  /** Filter by the object’s `item33` field. */
  item33?: Maybe<IntFilter>;
  /** Filter by the object’s `item34` field. */
  item34?: Maybe<IntFilter>;
  /** Filter by the object’s `item35` field. */
  item35?: Maybe<IntFilter>;
  /** Filter by the object’s `item36` field. */
  item36?: Maybe<IntFilter>;
  /** Filter by the object’s `item37` field. */
  item37?: Maybe<IntFilter>;
  /** Filter by the object’s `item38` field. */
  item38?: Maybe<IntFilter>;
  /** Filter by the object’s `item39` field. */
  item39?: Maybe<IntFilter>;
  /** Filter by the object’s `item40` field. */
  item40?: Maybe<IntFilter>;
  /** Filter by the object’s `item41` field. */
  item41?: Maybe<IntFilter>;
  /** Filter by the object’s `item42` field. */
  item42?: Maybe<IntFilter>;
  /** Filter by the object’s `item43` field. */
  item43?: Maybe<IntFilter>;
  /** Filter by the object’s `item44` field. */
  item44?: Maybe<IntFilter>;
  /** Filter by the object’s `item45` field. */
  item45?: Maybe<IntFilter>;
  /** Filter by the object’s `item46` field. */
  item46?: Maybe<IntFilter>;
  /** Filter by the object’s `item47` field. */
  item47?: Maybe<IntFilter>;
  /** Filter by the object’s `item48` field. */
  item48?: Maybe<IntFilter>;
  /** Filter by the object’s `item49` field. */
  item49?: Maybe<IntFilter>;
  /** Filter by the object’s `item50` field. */
  item50?: Maybe<IntFilter>;
  /** Filter by the object’s `item51` field. */
  item51?: Maybe<IntFilter>;
  /** Filter by the object’s `item52` field. */
  item52?: Maybe<IntFilter>;
  /** Filter by the object’s `item53` field. */
  item53?: Maybe<IntFilter>;
  /** Filter by the object’s `item54` field. */
  item54?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreBetrayal` field. */
  scoreBetrayal?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreSelfBlame` field. */
  scoreSelfBlame?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreFear` field. */
  scoreFear?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreAlienation` field. */
  scoreAlienation?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreAnger` field. */
  scoreAnger?: Maybe<IntFilter>;
  /** Filter by the object’s `scoreShame` field. */
  scoreShame?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<TaqFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<TaqFilter>>;
  /** Negates the expression. */
  not?: Maybe<TaqFilter>;
}

/** An input for mutations affecting `Taq` */
export interface TaqInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  item23: Scalars['Int'];
  item24: Scalars['Int'];
  item25: Scalars['Int'];
  item26: Scalars['Int'];
  item27: Scalars['Int'];
  item28: Scalars['Int'];
  item29: Scalars['Int'];
  item30: Scalars['Int'];
  item31: Scalars['Int'];
  item32: Scalars['Int'];
  item33: Scalars['Int'];
  item34: Scalars['Int'];
  item35: Scalars['Int'];
  item36: Scalars['Int'];
  item37: Scalars['Int'];
  item38: Scalars['Int'];
  item39: Scalars['Int'];
  item40: Scalars['Int'];
  item41: Scalars['Int'];
  item42: Scalars['Int'];
  item43: Scalars['Int'];
  item44: Scalars['Int'];
  item45: Scalars['Int'];
  item46: Scalars['Int'];
  item47: Scalars['Int'];
  item48: Scalars['Int'];
  item49: Scalars['Int'];
  item50: Scalars['Int'];
  item51: Scalars['Int'];
  item52: Scalars['Int'];
  item53: Scalars['Int'];
  item54: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  scoreBetrayal?: Maybe<Scalars['Int']>;
  scoreSelfBlame?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  scoreAlienation?: Maybe<Scalars['Int']>;
  scoreAnger?: Maybe<Scalars['Int']>;
  scoreShame?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Taq`. Fields that are set will be updated. */
export interface TaqPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  item22?: Maybe<Scalars['Int']>;
  item23?: Maybe<Scalars['Int']>;
  item24?: Maybe<Scalars['Int']>;
  item25?: Maybe<Scalars['Int']>;
  item26?: Maybe<Scalars['Int']>;
  item27?: Maybe<Scalars['Int']>;
  item28?: Maybe<Scalars['Int']>;
  item29?: Maybe<Scalars['Int']>;
  item30?: Maybe<Scalars['Int']>;
  item31?: Maybe<Scalars['Int']>;
  item32?: Maybe<Scalars['Int']>;
  item33?: Maybe<Scalars['Int']>;
  item34?: Maybe<Scalars['Int']>;
  item35?: Maybe<Scalars['Int']>;
  item36?: Maybe<Scalars['Int']>;
  item37?: Maybe<Scalars['Int']>;
  item38?: Maybe<Scalars['Int']>;
  item39?: Maybe<Scalars['Int']>;
  item40?: Maybe<Scalars['Int']>;
  item41?: Maybe<Scalars['Int']>;
  item42?: Maybe<Scalars['Int']>;
  item43?: Maybe<Scalars['Int']>;
  item44?: Maybe<Scalars['Int']>;
  item45?: Maybe<Scalars['Int']>;
  item46?: Maybe<Scalars['Int']>;
  item47?: Maybe<Scalars['Int']>;
  item48?: Maybe<Scalars['Int']>;
  item49?: Maybe<Scalars['Int']>;
  item50?: Maybe<Scalars['Int']>;
  item51?: Maybe<Scalars['Int']>;
  item52?: Maybe<Scalars['Int']>;
  item53?: Maybe<Scalars['Int']>;
  item54?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  scoreBetrayal?: Maybe<Scalars['Int']>;
  scoreSelfBlame?: Maybe<Scalars['Int']>;
  scoreFear?: Maybe<Scalars['Int']>;
  scoreAlienation?: Maybe<Scalars['Int']>;
  scoreAnger?: Maybe<Scalars['Int']>;
  scoreShame?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Taq` values. */
export interface TaqsConnection {
  __typename?: 'TaqsConnection';
  /** A list of `Taq` objects. */
  nodes: Array<Taq>;
  /** A list of edges which contains the `Taq` and cursor to aid in pagination. */
  edges: Array<TaqsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Taq` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Taq` edge in the connection. */
export interface TaqsEdge {
  __typename?: 'TaqsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Taq` at the end of the edge. */
  node: Taq;
}

/** Methods to use when ordering `Taq`. */
export enum TaqsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  Item_22Asc = 'ITEM_22_ASC',
  Item_22Desc = 'ITEM_22_DESC',
  Item_23Asc = 'ITEM_23_ASC',
  Item_23Desc = 'ITEM_23_DESC',
  Item_24Asc = 'ITEM_24_ASC',
  Item_24Desc = 'ITEM_24_DESC',
  Item_25Asc = 'ITEM_25_ASC',
  Item_25Desc = 'ITEM_25_DESC',
  Item_26Asc = 'ITEM_26_ASC',
  Item_26Desc = 'ITEM_26_DESC',
  Item_27Asc = 'ITEM_27_ASC',
  Item_27Desc = 'ITEM_27_DESC',
  Item_28Asc = 'ITEM_28_ASC',
  Item_28Desc = 'ITEM_28_DESC',
  Item_29Asc = 'ITEM_29_ASC',
  Item_29Desc = 'ITEM_29_DESC',
  Item_30Asc = 'ITEM_30_ASC',
  Item_30Desc = 'ITEM_30_DESC',
  Item_31Asc = 'ITEM_31_ASC',
  Item_31Desc = 'ITEM_31_DESC',
  Item_32Asc = 'ITEM_32_ASC',
  Item_32Desc = 'ITEM_32_DESC',
  Item_33Asc = 'ITEM_33_ASC',
  Item_33Desc = 'ITEM_33_DESC',
  Item_34Asc = 'ITEM_34_ASC',
  Item_34Desc = 'ITEM_34_DESC',
  Item_35Asc = 'ITEM_35_ASC',
  Item_35Desc = 'ITEM_35_DESC',
  Item_36Asc = 'ITEM_36_ASC',
  Item_36Desc = 'ITEM_36_DESC',
  Item_37Asc = 'ITEM_37_ASC',
  Item_37Desc = 'ITEM_37_DESC',
  Item_38Asc = 'ITEM_38_ASC',
  Item_38Desc = 'ITEM_38_DESC',
  Item_39Asc = 'ITEM_39_ASC',
  Item_39Desc = 'ITEM_39_DESC',
  Item_40Asc = 'ITEM_40_ASC',
  Item_40Desc = 'ITEM_40_DESC',
  Item_41Asc = 'ITEM_41_ASC',
  Item_41Desc = 'ITEM_41_DESC',
  Item_42Asc = 'ITEM_42_ASC',
  Item_42Desc = 'ITEM_42_DESC',
  Item_43Asc = 'ITEM_43_ASC',
  Item_43Desc = 'ITEM_43_DESC',
  Item_44Asc = 'ITEM_44_ASC',
  Item_44Desc = 'ITEM_44_DESC',
  Item_45Asc = 'ITEM_45_ASC',
  Item_45Desc = 'ITEM_45_DESC',
  Item_46Asc = 'ITEM_46_ASC',
  Item_46Desc = 'ITEM_46_DESC',
  Item_47Asc = 'ITEM_47_ASC',
  Item_47Desc = 'ITEM_47_DESC',
  Item_48Asc = 'ITEM_48_ASC',
  Item_48Desc = 'ITEM_48_DESC',
  Item_49Asc = 'ITEM_49_ASC',
  Item_49Desc = 'ITEM_49_DESC',
  Item_50Asc = 'ITEM_50_ASC',
  Item_50Desc = 'ITEM_50_DESC',
  Item_51Asc = 'ITEM_51_ASC',
  Item_51Desc = 'ITEM_51_DESC',
  Item_52Asc = 'ITEM_52_ASC',
  Item_52Desc = 'ITEM_52_DESC',
  Item_53Asc = 'ITEM_53_ASC',
  Item_53Desc = 'ITEM_53_DESC',
  Item_54Asc = 'ITEM_54_ASC',
  Item_54Desc = 'ITEM_54_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  ScoreBetrayalAsc = 'SCORE_BETRAYAL_ASC',
  ScoreBetrayalDesc = 'SCORE_BETRAYAL_DESC',
  ScoreSelfBlameAsc = 'SCORE_SELF_BLAME_ASC',
  ScoreSelfBlameDesc = 'SCORE_SELF_BLAME_DESC',
  ScoreFearAsc = 'SCORE_FEAR_ASC',
  ScoreFearDesc = 'SCORE_FEAR_DESC',
  ScoreAlienationAsc = 'SCORE_ALIENATION_ASC',
  ScoreAlienationDesc = 'SCORE_ALIENATION_DESC',
  ScoreAngerAsc = 'SCORE_ANGER_ASC',
  ScoreAngerDesc = 'SCORE_ANGER_DESC',
  ScoreShameAsc = 'SCORE_SHAME_ASC',
  ScoreShameDesc = 'SCORE_SHAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum TemplateType {
  Letter = 'LETTER',
  Message = 'MESSAGE',
  Mail = 'MAIL'
}

/** A filter to be used against TemplateType fields. All fields are combined with a logical ‘and.’ */
export interface TemplateTypeFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<TemplateType>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<TemplateType>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<TemplateType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<TemplateType>;
  /** Included in the specified list. */
  in?: Maybe<Array<TemplateType>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<TemplateType>>;
  /** Less than the specified value. */
  lessThan?: Maybe<TemplateType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<TemplateType>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<TemplateType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<TemplateType>;
}

export interface Tgisrplus extends Node {
  __typename?: 'Tgisrplus';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  score: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Case` that is related to this `Tgisrplus`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Tgisrplus`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Tgisrplus` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface TgisrplusCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item22` field. */
  item22?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** A connection to a list of `Tgisrplus` values. */
export interface TgisrplusesConnection {
  __typename?: 'TgisrplusesConnection';
  /** A list of `Tgisrplus` objects. */
  nodes: Array<Tgisrplus>;
  /** A list of edges which contains the `Tgisrplus` and cursor to aid in pagination. */
  edges: Array<TgisrplusesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tgisrplus` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Tgisrplus` edge in the connection. */
export interface TgisrplusesEdge {
  __typename?: 'TgisrplusesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Tgisrplus` at the end of the edge. */
  node: Tgisrplus;
}

/** Methods to use when ordering `Tgisrplus`. */
export enum TgisrplusesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  Item_22Asc = 'ITEM_22_ASC',
  Item_22Desc = 'ITEM_22_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against `Tgisrplus` object types. All fields are combined with a logical ‘and.’ */
export interface TgisrplusFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<IntFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<IntFilter>;
  /** Filter by the object’s `item22` field. */
  item22?: Maybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<TgisrplusFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<TgisrplusFilter>>;
  /** Negates the expression. */
  not?: Maybe<TgisrplusFilter>;
}

/** An input for mutations affecting `Tgisrplus` */
export interface TgisrplusInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  score: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

/** Represents an update to a `Tgisrplus`. Fields that are set will be updated. */
export interface TgisrplusPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  item22?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
}

export interface Traumaliste extends Node {
  __typename?: 'Traumaliste';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Boolean'];
  item2: Scalars['Boolean'];
  item3: Scalars['Boolean'];
  item4: Scalars['Boolean'];
  item5: Scalars['Boolean'];
  item6: Scalars['Boolean'];
  item7: Scalars['Boolean'];
  item8: Scalars['Boolean'];
  item9: Scalars['Boolean'];
  item10: Scalars['Boolean'];
  item11: Scalars['Boolean'];
  item12: Scalars['Boolean'];
  item13: Scalars['Boolean'];
  item14: Scalars['Boolean'];
  item15: Scalars['Boolean'];
  item16: Scalars['Boolean'];
  item17: Scalars['Boolean'];
  item18: Scalars['Boolean'];
  item19: Scalars['Boolean'];
  item20: Scalars['Boolean'];
  item21: Scalars['Boolean'];
  item22: Scalars['Boolean'];
  item23: Scalars['Boolean'];
  item24: Scalars['Boolean'];
  item25: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized?: Maybe<Scalars['Boolean']>;
  item26: Scalars['Boolean'];
  /** Reads a single `Case` that is related to this `Traumaliste`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumaliste`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Traumaliste` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export interface TraumalisteCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item22` field. */
  item22?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item23` field. */
  item23?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item24` field. */
  item24?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item25` field. */
  item25?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `descriptionOfOtherTrauma` field. */
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isTraumatized` field. */
  isTraumatized?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `item26` field. */
  item26?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `Traumaliste` object types. All fields are combined with a logical ‘and.’ */
export interface TraumalisteFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item22` field. */
  item22?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item23` field. */
  item23?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item24` field. */
  item24?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item25` field. */
  item25?: Maybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `descriptionOfOtherTrauma` field. */
  descriptionOfOtherTrauma?: Maybe<StringFilter>;
  /** Filter by the object’s `isTraumatized` field. */
  isTraumatized?: Maybe<BooleanFilter>;
  /** Filter by the object’s `item26` field. */
  item26?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<TraumalisteFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<TraumalisteFilter>>;
  /** Negates the expression. */
  not?: Maybe<TraumalisteFilter>;
}

/** An input for mutations affecting `Traumaliste` */
export interface TraumalisteInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Boolean'];
  item2: Scalars['Boolean'];
  item3: Scalars['Boolean'];
  item4: Scalars['Boolean'];
  item5: Scalars['Boolean'];
  item6: Scalars['Boolean'];
  item7: Scalars['Boolean'];
  item8: Scalars['Boolean'];
  item9: Scalars['Boolean'];
  item10: Scalars['Boolean'];
  item11: Scalars['Boolean'];
  item12: Scalars['Boolean'];
  item13: Scalars['Boolean'];
  item14: Scalars['Boolean'];
  item15: Scalars['Boolean'];
  item16: Scalars['Boolean'];
  item17: Scalars['Boolean'];
  item18: Scalars['Boolean'];
  item19: Scalars['Boolean'];
  item20: Scalars['Boolean'];
  item21: Scalars['Boolean'];
  item22: Scalars['Boolean'];
  item23: Scalars['Boolean'];
  item24: Scalars['Boolean'];
  item25: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized?: Maybe<Scalars['Boolean']>;
  item26?: Maybe<Scalars['Boolean']>;
}

export interface Traumalisteneu extends Node {
  __typename?: 'Traumalisteneu';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  item23: Scalars['Int'];
  item24: Scalars['Int'];
  item25: Scalars['Int'];
  item26: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized: Scalars['Boolean'];
  /** Reads a single `Case` that is related to this `Traumalisteneu`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumalisteneu`. */
  userBySubmitterId?: Maybe<User>;
}

/**
 * A condition to be used against `Traumalisteneu` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export interface TraumalisteneuCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item13` field. */
  item13?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item15` field. */
  item15?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item18` field. */
  item18?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item20` field. */
  item20?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item22` field. */
  item22?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item23` field. */
  item23?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item24` field. */
  item24?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item25` field. */
  item25?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item26` field. */
  item26?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `descriptionOfOtherTrauma` field. */
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isTraumatized` field. */
  isTraumatized?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `Traumalisteneu` object types. All fields are combined with a logical ‘and.’ */
export interface TraumalisteneuFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item13` field. */
  item13?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item15` field. */
  item15?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item18` field. */
  item18?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item20` field. */
  item20?: Maybe<IntFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<IntFilter>;
  /** Filter by the object’s `item22` field. */
  item22?: Maybe<IntFilter>;
  /** Filter by the object’s `item23` field. */
  item23?: Maybe<IntFilter>;
  /** Filter by the object’s `item24` field. */
  item24?: Maybe<IntFilter>;
  /** Filter by the object’s `item25` field. */
  item25?: Maybe<IntFilter>;
  /** Filter by the object’s `item26` field. */
  item26?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `descriptionOfOtherTrauma` field. */
  descriptionOfOtherTrauma?: Maybe<StringFilter>;
  /** Filter by the object’s `isTraumatized` field. */
  isTraumatized?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<TraumalisteneuFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<TraumalisteneuFilter>>;
  /** Negates the expression. */
  not?: Maybe<TraumalisteneuFilter>;
}

/** An input for mutations affecting `Traumalisteneu` */
export interface TraumalisteneuInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item13: Scalars['Int'];
  item14: Scalars['Int'];
  item15: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item18: Scalars['Int'];
  item19: Scalars['Int'];
  item20: Scalars['Int'];
  item21: Scalars['Int'];
  item22: Scalars['Int'];
  item23: Scalars['Int'];
  item24: Scalars['Int'];
  item25: Scalars['Int'];
  item26: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `Traumalisteneu`. Fields that are set will be updated. */
export interface TraumalisteneuPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item13?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item15?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item18?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item20?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  item22?: Maybe<Scalars['Int']>;
  item23?: Maybe<Scalars['Int']>;
  item24?: Maybe<Scalars['Int']>;
  item25?: Maybe<Scalars['Int']>;
  item26?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `Traumalisteneu` values. */
export interface TraumalisteneusConnection {
  __typename?: 'TraumalisteneusConnection';
  /** A list of `Traumalisteneu` objects. */
  nodes: Array<Traumalisteneu>;
  /** A list of edges which contains the `Traumalisteneu` and cursor to aid in pagination. */
  edges: Array<TraumalisteneusEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Traumalisteneu` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Traumalisteneu` edge in the connection. */
export interface TraumalisteneusEdge {
  __typename?: 'TraumalisteneusEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Traumalisteneu` at the end of the edge. */
  node: Traumalisteneu;
}

/** Methods to use when ordering `Traumalisteneu`. */
export enum TraumalisteneusOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  Item_22Asc = 'ITEM_22_ASC',
  Item_22Desc = 'ITEM_22_DESC',
  Item_23Asc = 'ITEM_23_ASC',
  Item_23Desc = 'ITEM_23_DESC',
  Item_24Asc = 'ITEM_24_ASC',
  Item_24Desc = 'ITEM_24_DESC',
  Item_25Asc = 'ITEM_25_ASC',
  Item_25Desc = 'ITEM_25_DESC',
  Item_26Asc = 'ITEM_26_ASC',
  Item_26Desc = 'ITEM_26_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  DescriptionOfOtherTraumaAsc = 'DESCRIPTION_OF_OTHER_TRAUMA_ASC',
  DescriptionOfOtherTraumaDesc = 'DESCRIPTION_OF_OTHER_TRAUMA_DESC',
  IsTraumatizedAsc = 'IS_TRAUMATIZED_ASC',
  IsTraumatizedDesc = 'IS_TRAUMATIZED_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `Traumaliste`. Fields that are set will be updated. */
export interface TraumalistePatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Boolean']>;
  item2?: Maybe<Scalars['Boolean']>;
  item3?: Maybe<Scalars['Boolean']>;
  item4?: Maybe<Scalars['Boolean']>;
  item5?: Maybe<Scalars['Boolean']>;
  item6?: Maybe<Scalars['Boolean']>;
  item7?: Maybe<Scalars['Boolean']>;
  item8?: Maybe<Scalars['Boolean']>;
  item9?: Maybe<Scalars['Boolean']>;
  item10?: Maybe<Scalars['Boolean']>;
  item11?: Maybe<Scalars['Boolean']>;
  item12?: Maybe<Scalars['Boolean']>;
  item13?: Maybe<Scalars['Boolean']>;
  item14?: Maybe<Scalars['Boolean']>;
  item15?: Maybe<Scalars['Boolean']>;
  item16?: Maybe<Scalars['Boolean']>;
  item17?: Maybe<Scalars['Boolean']>;
  item18?: Maybe<Scalars['Boolean']>;
  item19?: Maybe<Scalars['Boolean']>;
  item20?: Maybe<Scalars['Boolean']>;
  item21?: Maybe<Scalars['Boolean']>;
  item22?: Maybe<Scalars['Boolean']>;
  item23?: Maybe<Scalars['Boolean']>;
  item24?: Maybe<Scalars['Boolean']>;
  item25?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  descriptionOfOtherTrauma?: Maybe<Scalars['String']>;
  isTraumatized?: Maybe<Scalars['Boolean']>;
  item26?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `Traumaliste` values. */
export interface TraumalistesConnection {
  __typename?: 'TraumalistesConnection';
  /** A list of `Traumaliste` objects. */
  nodes: Array<Traumaliste>;
  /** A list of edges which contains the `Traumaliste` and cursor to aid in pagination. */
  edges: Array<TraumalistesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Traumaliste` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Traumaliste` edge in the connection. */
export interface TraumalistesEdge {
  __typename?: 'TraumalistesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Traumaliste` at the end of the edge. */
  node: Traumaliste;
}

/** Methods to use when ordering `Traumaliste`. */
export enum TraumalistesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_13Asc = 'ITEM_13_ASC',
  Item_13Desc = 'ITEM_13_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_15Asc = 'ITEM_15_ASC',
  Item_15Desc = 'ITEM_15_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_18Asc = 'ITEM_18_ASC',
  Item_18Desc = 'ITEM_18_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_20Asc = 'ITEM_20_ASC',
  Item_20Desc = 'ITEM_20_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  Item_22Asc = 'ITEM_22_ASC',
  Item_22Desc = 'ITEM_22_DESC',
  Item_23Asc = 'ITEM_23_ASC',
  Item_23Desc = 'ITEM_23_DESC',
  Item_24Asc = 'ITEM_24_ASC',
  Item_24Desc = 'ITEM_24_DESC',
  Item_25Asc = 'ITEM_25_ASC',
  Item_25Desc = 'ITEM_25_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  DescriptionOfOtherTraumaAsc = 'DESCRIPTION_OF_OTHER_TRAUMA_ASC',
  DescriptionOfOtherTraumaDesc = 'DESCRIPTION_OF_OTHER_TRAUMA_DESC',
  IsTraumatizedAsc = 'IS_TRAUMATIZED_ASC',
  IsTraumatizedDesc = 'IS_TRAUMATIZED_DESC',
  Item_26Asc = 'ITEM_26_ASC',
  Item_26Desc = 'ITEM_26_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export interface Trgi extends Node {
  __typename?: 'Trgi';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item14: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item19: Scalars['Int'];
  item21: Scalars['Int'];
  item23: Scalars['Int'];
  item26: Scalars['Int'];
  item27: Scalars['Int'];
  item28: Scalars['Int'];
  item29: Scalars['Int'];
  item30: Scalars['Int'];
  item31: Scalars['Int'];
  item32: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  score?: Maybe<Scalars['BigFloat']>;
  scoreHindsightResponsibility?: Maybe<Scalars['BigFloat']>;
  scoreWrongdoing?: Maybe<Scalars['BigFloat']>;
  scoreLackOfJustification?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `Case` that is related to this `Trgi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Trgi`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Trgi` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface TrgiCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item14` field. */
  item14?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item16` field. */
  item16?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item17` field. */
  item17?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item19` field. */
  item19?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item21` field. */
  item21?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item23` field. */
  item23?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item26` field. */
  item26?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item27` field. */
  item27?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item28` field. */
  item28?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item29` field. */
  item29?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item30` field. */
  item30?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item31` field. */
  item31?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item32` field. */
  item32?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreHindsightResponsibility` field. */
  scoreHindsightResponsibility?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreWrongdoing` field. */
  scoreWrongdoing?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreLackOfJustification` field. */
  scoreLackOfJustification?: Maybe<Scalars['BigFloat']>;
}

/** A filter to be used against `Trgi` object types. All fields are combined with a logical ‘and.’ */
export interface TrgiFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `item14` field. */
  item14?: Maybe<IntFilter>;
  /** Filter by the object’s `item16` field. */
  item16?: Maybe<IntFilter>;
  /** Filter by the object’s `item17` field. */
  item17?: Maybe<IntFilter>;
  /** Filter by the object’s `item19` field. */
  item19?: Maybe<IntFilter>;
  /** Filter by the object’s `item21` field. */
  item21?: Maybe<IntFilter>;
  /** Filter by the object’s `item23` field. */
  item23?: Maybe<IntFilter>;
  /** Filter by the object’s `item26` field. */
  item26?: Maybe<IntFilter>;
  /** Filter by the object’s `item27` field. */
  item27?: Maybe<IntFilter>;
  /** Filter by the object’s `item28` field. */
  item28?: Maybe<IntFilter>;
  /** Filter by the object’s `item29` field. */
  item29?: Maybe<IntFilter>;
  /** Filter by the object’s `item30` field. */
  item30?: Maybe<IntFilter>;
  /** Filter by the object’s `item31` field. */
  item31?: Maybe<IntFilter>;
  /** Filter by the object’s `item32` field. */
  item32?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreHindsightResponsibility` field. */
  scoreHindsightResponsibility?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreWrongdoing` field. */
  scoreWrongdoing?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreLackOfJustification` field. */
  scoreLackOfJustification?: Maybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<TrgiFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<TrgiFilter>>;
  /** Negates the expression. */
  not?: Maybe<TrgiFilter>;
}

/** An input for mutations affecting `Trgi` */
export interface TrgiInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  item14: Scalars['Int'];
  item16: Scalars['Int'];
  item17: Scalars['Int'];
  item19: Scalars['Int'];
  item21: Scalars['Int'];
  item23: Scalars['Int'];
  item26: Scalars['Int'];
  item27: Scalars['Int'];
  item28: Scalars['Int'];
  item29: Scalars['Int'];
  item30: Scalars['Int'];
  item31: Scalars['Int'];
  item32: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  score?: Maybe<Scalars['BigFloat']>;
  scoreHindsightResponsibility?: Maybe<Scalars['BigFloat']>;
  scoreWrongdoing?: Maybe<Scalars['BigFloat']>;
  scoreLackOfJustification?: Maybe<Scalars['BigFloat']>;
}

/** Represents an update to a `Trgi`. Fields that are set will be updated. */
export interface TrgiPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  item14?: Maybe<Scalars['Int']>;
  item16?: Maybe<Scalars['Int']>;
  item17?: Maybe<Scalars['Int']>;
  item19?: Maybe<Scalars['Int']>;
  item21?: Maybe<Scalars['Int']>;
  item23?: Maybe<Scalars['Int']>;
  item26?: Maybe<Scalars['Int']>;
  item27?: Maybe<Scalars['Int']>;
  item28?: Maybe<Scalars['Int']>;
  item29?: Maybe<Scalars['Int']>;
  item30?: Maybe<Scalars['Int']>;
  item31?: Maybe<Scalars['Int']>;
  item32?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  score?: Maybe<Scalars['BigFloat']>;
  scoreHindsightResponsibility?: Maybe<Scalars['BigFloat']>;
  scoreWrongdoing?: Maybe<Scalars['BigFloat']>;
  scoreLackOfJustification?: Maybe<Scalars['BigFloat']>;
}

/** A connection to a list of `Trgi` values. */
export interface TrgisConnection {
  __typename?: 'TrgisConnection';
  /** A list of `Trgi` objects. */
  nodes: Array<Trgi>;
  /** A list of edges which contains the `Trgi` and cursor to aid in pagination. */
  edges: Array<TrgisEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Trgi` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Trgi` edge in the connection. */
export interface TrgisEdge {
  __typename?: 'TrgisEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Trgi` at the end of the edge. */
  node: Trgi;
}

/** Methods to use when ordering `Trgi`. */
export enum TrgisOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  Item_14Asc = 'ITEM_14_ASC',
  Item_14Desc = 'ITEM_14_DESC',
  Item_16Asc = 'ITEM_16_ASC',
  Item_16Desc = 'ITEM_16_DESC',
  Item_17Asc = 'ITEM_17_ASC',
  Item_17Desc = 'ITEM_17_DESC',
  Item_19Asc = 'ITEM_19_ASC',
  Item_19Desc = 'ITEM_19_DESC',
  Item_21Asc = 'ITEM_21_ASC',
  Item_21Desc = 'ITEM_21_DESC',
  Item_23Asc = 'ITEM_23_ASC',
  Item_23Desc = 'ITEM_23_DESC',
  Item_26Asc = 'ITEM_26_ASC',
  Item_26Desc = 'ITEM_26_DESC',
  Item_27Asc = 'ITEM_27_ASC',
  Item_27Desc = 'ITEM_27_DESC',
  Item_28Asc = 'ITEM_28_ASC',
  Item_28Desc = 'ITEM_28_DESC',
  Item_29Asc = 'ITEM_29_ASC',
  Item_29Desc = 'ITEM_29_DESC',
  Item_30Asc = 'ITEM_30_ASC',
  Item_30Desc = 'ITEM_30_DESC',
  Item_31Asc = 'ITEM_31_ASC',
  Item_31Desc = 'ITEM_31_DESC',
  Item_32Asc = 'ITEM_32_ASC',
  Item_32Desc = 'ITEM_32_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  ScoreHindsightResponsibilityAsc = 'SCORE_HINDSIGHT_RESPONSIBILITY_ASC',
  ScoreHindsightResponsibilityDesc = 'SCORE_HINDSIGHT_RESPONSIBILITY_DESC',
  ScoreWrongdoingAsc = 'SCORE_WRONGDOING_ASC',
  ScoreWrongdoingDesc = 'SCORE_WRONGDOING_DESC',
  ScoreLackOfJustificationAsc = 'SCORE_LACK_OF_JUSTIFICATION_ASC',
  ScoreLackOfJustificationDesc = 'SCORE_LACK_OF_JUSTIFICATION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `uncancelInterviewOfferById` mutation. */
export interface UncancelInterviewOfferByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
}

/** The output of our `uncancelInterviewOfferById` mutation. */
export interface UncancelInterviewOfferByIdPayload {
  __typename?: 'UncancelInterviewOfferByIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<UncancelInterviewOfferByIdRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** The return type of our `uncancelInterviewOfferById` mutation. */
export interface UncancelInterviewOfferByIdRecord {
  __typename?: 'UncancelInterviewOfferByIdRecord';
  oldOffer?: Maybe<InterviewOffer>;
  offer?: Maybe<InterviewOffer>;
}

/** All input for the `unlockSemaphore` mutation. */
export interface UnlockSemaphoreInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  lockKey?: Maybe<Scalars['String']>;
}

/** The output of our `unlockSemaphore` mutation. */
export interface UnlockSemaphorePayload {
  __typename?: 'UnlockSemaphorePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  boolean?: Maybe<Scalars['Boolean']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
}

/** All input for the `updateBdi2ById` mutation. */
export interface UpdateBdi2ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Bdi2` being updated. */
  bdi2Patch: Bdi2Patch;
  id: Scalars['UUID'];
}

/** All input for the `updateBdi2` mutation. */
export interface UpdateBdi2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Bdi2` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Bdi2` being updated. */
  bdi2Patch: Bdi2Patch;
}

/** The output of our update `Bdi2` mutation. */
export interface UpdateBdi2Payload {
  __typename?: 'UpdateBdi2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Bdi2` that was updated by this mutation. */
  bdi2?: Maybe<Bdi2>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Bdi2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Bdi2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Bdi2`. May be used by Relay 1. */
  bdi2Edge?: Maybe<Bdi2SEdge>;
}


/** The output of our update `Bdi2` mutation. */
export type UpdateBdi2PayloadBdi2EdgeArgs = {
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
};

/** All input for the `updateCaseById` mutation. */
export interface UpdateCaseByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Case` being updated. */
  casePatch: CasePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCase` mutation. */
export interface UpdateCaseInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Case` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Case` being updated. */
  casePatch: CasePatch;
}

/** All input for the `updateCaseMessageById` mutation. */
export interface UpdateCaseMessageByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CaseMessage` being updated. */
  caseMessagePatch: CaseMessagePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCaseMessage` mutation. */
export interface UpdateCaseMessageInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CaseMessage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CaseMessage` being updated. */
  caseMessagePatch: CaseMessagePatch;
}

/** The output of our update `CaseMessage` mutation. */
export interface UpdateCaseMessagePayload {
  __typename?: 'UpdateCaseMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseMessage` that was updated by this mutation. */
  caseMessage?: Maybe<CaseMessage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseMessage`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseMessage`. */
  userBySenderId?: Maybe<User>;
  /** Reads a single `CaseMember` that is related to this `CaseMessage`. */
  caseMemberByCaseIdAndSenderId?: Maybe<CaseMember>;
  /** An edge for our `CaseMessage`. May be used by Relay 1. */
  caseMessageEdge?: Maybe<CaseMessagesEdge>;
}


/** The output of our update `CaseMessage` mutation. */
export type UpdateCaseMessagePayloadCaseMessageEdgeArgs = {
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
};

/** The output of our update `Case` mutation. */
export interface UpdateCasePayload {
  __typename?: 'UpdateCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Case` that was updated by this mutation. */
  case?: Maybe<Case>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `MyInvolvement` that is related to this `Case`. */
  myInvolvementById?: Maybe<MyInvolvement>;
  /** An edge for our `Case`. May be used by Relay 1. */
  caseEdge?: Maybe<CasesEdge>;
}


/** The output of our update `Case` mutation. */
export type UpdateCasePayloadCaseEdgeArgs = {
  orderBy?: Maybe<Array<CasesOrderBy>>;
};

/** All input for the `updateCaseSuicideCallById` mutation. */
export interface UpdateCaseSuicideCallByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CaseSuicideCall` being updated. */
  caseSuicideCallPatch: CaseSuicideCallPatch;
  /** ID of the suicidal call record. Will be set automatically */
  id: Scalars['UUID'];
}

/** All input for the `updateCaseSuicideCall` mutation. */
export interface UpdateCaseSuicideCallInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CaseSuicideCall` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CaseSuicideCall` being updated. */
  caseSuicideCallPatch: CaseSuicideCallPatch;
}

/** The output of our update `CaseSuicideCall` mutation. */
export interface UpdateCaseSuicideCallPayload {
  __typename?: 'UpdateCaseSuicideCallPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CaseSuicideCall` that was updated by this mutation. */
  caseSuicideCall?: Maybe<CaseSuicideCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CaseSuicideCall`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CaseSuicideCall`. */
  userByUserIdCaller?: Maybe<User>;
  /** An edge for our `CaseSuicideCall`. May be used by Relay 1. */
  caseSuicideCallEdge?: Maybe<CaseSuicideCallsEdge>;
}


/** The output of our update `CaseSuicideCall` mutation. */
export type UpdateCaseSuicideCallPayloadCaseSuicideCallEdgeArgs = {
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
};

/** All input for the `updateCbtActivityById` mutation. */
export interface UpdateCbtActivityByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CbtActivity` being updated. */
  cbtActivityPatch: CbtActivityPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCbtActivity` mutation. */
export interface UpdateCbtActivityInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtActivity` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CbtActivity` being updated. */
  cbtActivityPatch: CbtActivityPatch;
}

/** The output of our update `CbtActivity` mutation. */
export interface UpdateCbtActivityPayload {
  __typename?: 'UpdateCbtActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtActivity` that was updated by this mutation. */
  cbtActivity?: Maybe<CbtActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtActivity`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtActivity`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtActivity`. May be used by Relay 1. */
  cbtActivityEdge?: Maybe<CbtActivitiesEdge>;
}


/** The output of our update `CbtActivity` mutation. */
export type UpdateCbtActivityPayloadCbtActivityEdgeArgs = {
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
};

/** All input for the `updateCbtReframingById` mutation. */
export interface UpdateCbtReframingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CbtReframing` being updated. */
  cbtReframingPatch: CbtReframingPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCbtReframing` mutation. */
export interface UpdateCbtReframingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtReframing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CbtReframing` being updated. */
  cbtReframingPatch: CbtReframingPatch;
}

/** The output of our update `CbtReframing` mutation. */
export interface UpdateCbtReframingPayload {
  __typename?: 'UpdateCbtReframingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtReframing` that was updated by this mutation. */
  cbtReframing?: Maybe<CbtReframing>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtReframing`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtReframing`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtReframing`. May be used by Relay 1. */
  cbtReframingEdge?: Maybe<CbtReframingsEdge>;
}


/** The output of our update `CbtReframing` mutation. */
export type UpdateCbtReframingPayloadCbtReframingEdgeArgs = {
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
};

/** All input for the `updateCbtThoughtById` mutation. */
export interface UpdateCbtThoughtByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CbtThought` being updated. */
  cbtThoughtPatch: CbtThoughtPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCbtThought` mutation. */
export interface UpdateCbtThoughtInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CbtThought` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CbtThought` being updated. */
  cbtThoughtPatch: CbtThoughtPatch;
}

/** The output of our update `CbtThought` mutation. */
export interface UpdateCbtThoughtPayload {
  __typename?: 'UpdateCbtThoughtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CbtThought` that was updated by this mutation. */
  cbtThought?: Maybe<CbtThought>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CbtThought`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CbtThought`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CbtThought`. May be used by Relay 1. */
  cbtThoughtEdge?: Maybe<CbtThoughtsEdge>;
}


/** The output of our update `CbtThought` mutation. */
export type UpdateCbtThoughtPayloadCbtThoughtEdgeArgs = {
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
};

/** All input for the `updateCdrisk10ById` mutation. */
export interface UpdateCdrisk10ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Cdrisk10` being updated. */
  cdrisk10Patch: Cdrisk10Patch;
  id: Scalars['UUID'];
}

/** All input for the `updateCdrisk10` mutation. */
export interface UpdateCdrisk10Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Cdrisk10` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Cdrisk10` being updated. */
  cdrisk10Patch: Cdrisk10Patch;
}

/** The output of our update `Cdrisk10` mutation. */
export interface UpdateCdrisk10Payload {
  __typename?: 'UpdateCdrisk10Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Cdrisk10` that was updated by this mutation. */
  cdrisk10?: Maybe<Cdrisk10>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Cdrisk10`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Cdrisk10`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Cdrisk10`. May be used by Relay 1. */
  cdrisk10Edge?: Maybe<Cdrisk10SEdge>;
}


/** The output of our update `Cdrisk10` mutation. */
export type UpdateCdrisk10PayloadCdrisk10EdgeArgs = {
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
};

/** All input for the `updateCommentById` mutation. */
export interface UpdateCommentByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Comment` being updated. */
  commentPatch: CommentPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateComment` mutation. */
export interface UpdateCommentInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Comment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Comment` being updated. */
  commentPatch: CommentPatch;
}

/** The output of our update `Comment` mutation. */
export interface UpdateCommentPayload {
  __typename?: 'UpdateCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was updated by this mutation. */
  comment?: Maybe<Comment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Comment`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Comment`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
}


/** The output of our update `Comment` mutation. */
export type UpdateCommentPayloadCommentEdgeArgs = {
  orderBy?: Maybe<Array<CommentsOrderBy>>;
};

/** All input for the `updateCounselingQuestionById` mutation. */
export interface UpdateCounselingQuestionByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CounselingQuestion` being updated. */
  counselingQuestionPatch: CounselingQuestionPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateCounselingQuestion` mutation. */
export interface UpdateCounselingQuestionInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CounselingQuestion` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CounselingQuestion` being updated. */
  counselingQuestionPatch: CounselingQuestionPatch;
}

/** The output of our update `CounselingQuestion` mutation. */
export interface UpdateCounselingQuestionPayload {
  __typename?: 'UpdateCounselingQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CounselingQuestion` that was updated by this mutation. */
  counselingQuestion?: Maybe<CounselingQuestion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `CounselingQuestion`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `CounselingQuestion`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `CounselingQuestion`. May be used by Relay 1. */
  counselingQuestionEdge?: Maybe<CounselingQuestionsEdge>;
}


/** The output of our update `CounselingQuestion` mutation. */
export type UpdateCounselingQuestionPayloadCounselingQuestionEdgeArgs = {
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
};

/** All input for the `updateDemographicById` mutation. */
export interface UpdateDemographicByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Demographic` being updated. */
  demographicPatch: DemographicPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateDemographic` mutation. */
export interface UpdateDemographicInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Demographic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Demographic` being updated. */
  demographicPatch: DemographicPatch;
}

/** The output of our update `Demographic` mutation. */
export interface UpdateDemographicPayload {
  __typename?: 'UpdateDemographicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Demographic` that was updated by this mutation. */
  demographic?: Maybe<Demographic>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Demographic`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Demographic`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Demographic`. May be used by Relay 1. */
  demographicEdge?: Maybe<DemographicsEdge>;
}


/** The output of our update `Demographic` mutation. */
export type UpdateDemographicPayloadDemographicEdgeArgs = {
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
};

/** All input for the `updateDisclosureById` mutation. */
export interface UpdateDisclosureByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Disclosure` being updated. */
  disclosurePatch: DisclosurePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateDisclosure` mutation. */
export interface UpdateDisclosureInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Disclosure` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Disclosure` being updated. */
  disclosurePatch: DisclosurePatch;
}

/** The output of our update `Disclosure` mutation. */
export interface UpdateDisclosurePayload {
  __typename?: 'UpdateDisclosurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Disclosure` that was updated by this mutation. */
  disclosure?: Maybe<Disclosure>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Disclosure`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Disclosure`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Disclosure`. May be used by Relay 1. */
  disclosureEdge?: Maybe<DisclosuresEdge>;
}


/** The output of our update `Disclosure` mutation. */
export type UpdateDisclosurePayloadDisclosureEdgeArgs = {
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
};

/** All input for the `updateEurohiById` mutation. */
export interface UpdateEurohiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Eurohi` being updated. */
  eurohiPatch: EurohiPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateEurohi` mutation. */
export interface UpdateEurohiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Eurohi` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Eurohi` being updated. */
  eurohiPatch: EurohiPatch;
}

/** The output of our update `Eurohi` mutation. */
export interface UpdateEurohiPayload {
  __typename?: 'UpdateEurohiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Eurohi` that was updated by this mutation. */
  eurohi?: Maybe<Eurohi>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Eurohi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Eurohi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Eurohi`. May be used by Relay 1. */
  eurohiEdge?: Maybe<EurohisEdge>;
}


/** The output of our update `Eurohi` mutation. */
export type UpdateEurohiPayloadEurohiEdgeArgs = {
  orderBy?: Maybe<Array<EurohisOrderBy>>;
};

/** All input for the `updateEvaluationById` mutation. */
export interface UpdateEvaluationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Evaluation` being updated. */
  evaluationPatch: EvaluationPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateEvaluation` mutation. */
export interface UpdateEvaluationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Evaluation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Evaluation` being updated. */
  evaluationPatch: EvaluationPatch;
}

/** The output of our update `Evaluation` mutation. */
export interface UpdateEvaluationPayload {
  __typename?: 'UpdateEvaluationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Evaluation` that was updated by this mutation. */
  evaluation?: Maybe<Evaluation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Evaluation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Evaluation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Evaluation`. May be used by Relay 1. */
  evaluationEdge?: Maybe<EvaluationsEdge>;
}


/** The output of our update `Evaluation` mutation. */
export type UpdateEvaluationPayloadEvaluationEdgeArgs = {
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
};

/** All input for the `updateFeedbackInterviewReportById` mutation. */
export interface UpdateFeedbackInterviewReportByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `FeedbackInterviewReport` being updated. */
  feedbackInterviewReportPatch: FeedbackInterviewReportPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateFeedbackInterviewReport` mutation. */
export interface UpdateFeedbackInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeedbackInterviewReport` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FeedbackInterviewReport` being updated. */
  feedbackInterviewReportPatch: FeedbackInterviewReportPatch;
}

/** The output of our update `FeedbackInterviewReport` mutation. */
export interface UpdateFeedbackInterviewReportPayload {
  __typename?: 'UpdateFeedbackInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeedbackInterviewReport` that was updated by this mutation. */
  feedbackInterviewReport?: Maybe<FeedbackInterviewReport>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `FeedbackInterviewReport`. May be used by Relay 1. */
  feedbackInterviewReportEdge?: Maybe<FeedbackInterviewReportsEdge>;
}


/** The output of our update `FeedbackInterviewReport` mutation. */
export type UpdateFeedbackInterviewReportPayloadFeedbackInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<FeedbackInterviewReportsOrderBy>>;
};

/** All input for the `updateGad2ById` mutation. */
export interface UpdateGad2ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Gad2` being updated. */
  gad2Patch: Gad2Patch;
  id: Scalars['UUID'];
}

/** All input for the `updateGad2` mutation. */
export interface UpdateGad2Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Gad2` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Gad2` being updated. */
  gad2Patch: Gad2Patch;
}

/** The output of our update `Gad2` mutation. */
export interface UpdateGad2Payload {
  __typename?: 'UpdateGad2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad2` that was updated by this mutation. */
  gad2?: Maybe<Gad2>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad2`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad2`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad2`. May be used by Relay 1. */
  gad2Edge?: Maybe<Gad2SEdge>;
}


/** The output of our update `Gad2` mutation. */
export type UpdateGad2PayloadGad2EdgeArgs = {
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
};

/** All input for the `updateGad7ById` mutation. */
export interface UpdateGad7ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Gad7` being updated. */
  gad7Patch: Gad7Patch;
  id: Scalars['UUID'];
}

/** All input for the `updateGad7` mutation. */
export interface UpdateGad7Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Gad7` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Gad7` being updated. */
  gad7Patch: Gad7Patch;
}

/** The output of our update `Gad7` mutation. */
export interface UpdateGad7Payload {
  __typename?: 'UpdateGad7Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Gad7` that was updated by this mutation. */
  gad7?: Maybe<Gad7>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Gad7`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Gad7`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Gad7`. May be used by Relay 1. */
  gad7Edge?: Maybe<Gad7SEdge>;
}


/** The output of our update `Gad7` mutation. */
export type UpdateGad7PayloadGad7EdgeArgs = {
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
};

/** All input for the `updateHashedEmailById` mutation. */
export interface UpdateHashedEmailByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `HashedEmail` being updated. */
  hashedEmailPatch: HashedEmailPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateHashedEmail` mutation. */
export interface UpdateHashedEmailInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `HashedEmail` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `HashedEmail` being updated. */
  hashedEmailPatch: HashedEmailPatch;
}

/** The output of our update `HashedEmail` mutation. */
export interface UpdateHashedEmailPayload {
  __typename?: 'UpdateHashedEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HashedEmail` that was updated by this mutation. */
  hashedEmail?: Maybe<HashedEmail>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `HashedEmail`. May be used by Relay 1. */
  hashedEmailEdge?: Maybe<HashedEmailsEdge>;
}


/** The output of our update `HashedEmail` mutation. */
export type UpdateHashedEmailPayloadHashedEmailEdgeArgs = {
  orderBy?: Maybe<Array<HashedEmailsOrderBy>>;
};

/** All input for the `updateInepById` mutation. */
export interface UpdateInepByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Inep` being updated. */
  inepPatch: InepPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateInep` mutation. */
export interface UpdateInepInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Inep` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Inep` being updated. */
  inepPatch: InepPatch;
}

/** The output of our update `Inep` mutation. */
export interface UpdateInepPayload {
  __typename?: 'UpdateInepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Inep` that was updated by this mutation. */
  inep?: Maybe<Inep>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Inep`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Inep`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Inep`. May be used by Relay 1. */
  inepEdge?: Maybe<InepsEdge>;
}


/** The output of our update `Inep` mutation. */
export type UpdateInepPayloadInepEdgeArgs = {
  orderBy?: Maybe<Array<InepsOrderBy>>;
};

/** All input for the `updateInterviewBookingByIdAndCaseId` mutation. */
export interface UpdateInterviewBookingByIdAndCaseIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `InterviewBooking` being updated. */
  interviewBookingPatch: InterviewBookingPatch;
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
}

/** All input for the `updateInterviewBookingById` mutation. */
export interface UpdateInterviewBookingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `InterviewBooking` being updated. */
  interviewBookingPatch: InterviewBookingPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateInterviewBooking` mutation. */
export interface UpdateInterviewBookingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewBooking` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InterviewBooking` being updated. */
  interviewBookingPatch: InterviewBookingPatch;
}

/** The output of our update `InterviewBooking` mutation. */
export interface UpdateInterviewBookingPayload {
  __typename?: 'UpdateInterviewBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewBooking` that was updated by this mutation. */
  interviewBooking?: Maybe<InterviewBooking>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `InterviewBooking`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Involvement` that is related to this `InterviewBooking`. */
  involvementByCaseIdAndIntervieweeId?: Maybe<Involvement>;
  /** Reads a single `User` that is related to this `InterviewBooking`. */
  userByIntervieweeId?: Maybe<User>;
  /** Reads a single `InterviewOffer` that is related to this `InterviewBooking`. */
  interviewOfferByOfferId?: Maybe<InterviewOffer>;
  /** Reads a single `Interviewee` that is related to this `InterviewBooking`. */
  intervieweeByIntervieweeId?: Maybe<Interviewee>;
  /** An edge for our `InterviewBooking`. May be used by Relay 1. */
  interviewBookingEdge?: Maybe<InterviewBookingsEdge>;
}


/** The output of our update `InterviewBooking` mutation. */
export type UpdateInterviewBookingPayloadInterviewBookingEdgeArgs = {
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
};

/** All input for the `updateIntervieweeById` mutation. */
export interface UpdateIntervieweeByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Interviewee` being updated. */
  intervieweePatch: IntervieweePatch;
  id: Scalars['UUID'];
}

/** The output of our update `Interviewee` mutation. */
export interface UpdateIntervieweePayload {
  __typename?: 'UpdateIntervieweePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewee` that was updated by this mutation. */
  interviewee?: Maybe<Interviewee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewee`. May be used by Relay 1. */
  intervieweeEdge?: Maybe<IntervieweesEdge>;
}


/** The output of our update `Interviewee` mutation. */
export type UpdateIntervieweePayloadIntervieweeEdgeArgs = {
  orderBy?: Maybe<Array<IntervieweesOrderBy>>;
};

/** All input for the `updateInterviewerById` mutation. */
export interface UpdateInterviewerByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Interviewer` being updated. */
  interviewerPatch: InterviewerPatch;
  id: Scalars['UUID'];
}

/** The output of our update `Interviewer` mutation. */
export interface UpdateInterviewerPayload {
  __typename?: 'UpdateInterviewerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Interviewer` that was updated by this mutation. */
  interviewer?: Maybe<Interviewer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Interviewer`. May be used by Relay 1. */
  interviewerEdge?: Maybe<InterviewersEdge>;
}


/** The output of our update `Interviewer` mutation. */
export type UpdateInterviewerPayloadInterviewerEdgeArgs = {
  orderBy?: Maybe<Array<InterviewersOrderBy>>;
};

/** All input for the `updateInterviewOfferById` mutation. */
export interface UpdateInterviewOfferByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `InterviewOffer` being updated. */
  interviewOfferPatch: InterviewOfferPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateInterviewOffer` mutation. */
export interface UpdateInterviewOfferInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewOffer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InterviewOffer` being updated. */
  interviewOfferPatch: InterviewOfferPatch;
}

/** The output of our update `InterviewOffer` mutation. */
export interface UpdateInterviewOfferPayload {
  __typename?: 'UpdateInterviewOfferPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewOffer` that was updated by this mutation. */
  interviewOffer?: Maybe<InterviewOffer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `InterviewOffer`. */
  userByInterviewerId?: Maybe<User>;
  /** Reads a single `Interviewer` that is related to this `InterviewOffer`. */
  interviewerByInterviewerId?: Maybe<Interviewer>;
  /** An edge for our `InterviewOffer`. May be used by Relay 1. */
  interviewOfferEdge?: Maybe<InterviewOffersEdge>;
}


/** The output of our update `InterviewOffer` mutation. */
export type UpdateInterviewOfferPayloadInterviewOfferEdgeArgs = {
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
};

/** All input for the `updateInterviewReportById` mutation. */
export interface UpdateInterviewReportByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `InterviewReport` being updated. */
  interviewReportPatch: InterviewReportPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateInterviewReport` mutation. */
export interface UpdateInterviewReportInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InterviewReport` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InterviewReport` being updated. */
  interviewReportPatch: InterviewReportPatch;
}

/** The output of our update `InterviewReport` mutation. */
export interface UpdateInterviewReportPayload {
  __typename?: 'UpdateInterviewReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InterviewReport` that was updated by this mutation. */
  interviewReport?: Maybe<InterviewReport>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingId?: Maybe<InterviewBooking>;
  /** Reads a single `InterviewBooking` that is related to this `InterviewReport`. */
  interviewBookingByBookingIdAndCaseId?: Maybe<InterviewBooking>;
  /** Reads a single `Case` that is related to this `InterviewReport`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `InterviewReport`. */
  userByInterviewerId?: Maybe<User>;
  /** An edge for our `InterviewReport`. May be used by Relay 1. */
  interviewReportEdge?: Maybe<InterviewReportsEdge>;
}


/** The output of our update `InterviewReport` mutation. */
export type UpdateInterviewReportPayloadInterviewReportEdgeArgs = {
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
};

/** All input for the `updateInvolvementById` mutation. */
export interface UpdateInvolvementByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Involvement` being updated. */
  involvementPatch: InvolvementPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateInvolvement` mutation. */
export interface UpdateInvolvementInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Involvement` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Involvement` being updated. */
  involvementPatch: InvolvementPatch;
}

/** The output of our update `Involvement` mutation. */
export interface UpdateInvolvementPayload {
  __typename?: 'UpdateInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Involvement` that was updated by this mutation. */
  involvement?: Maybe<Involvement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Involvement`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Case` that is related to this `Involvement`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `Involvement`. May be used by Relay 1. */
  involvementEdge?: Maybe<InvolvementsEdge>;
}


/** The output of our update `Involvement` mutation. */
export type UpdateInvolvementPayloadInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
};

/** All input for the `updateIptConflictById` mutation. */
export interface UpdateIptConflictByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `IptConflict` being updated. */
  iptConflictPatch: IptConflictPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateIptConflict` mutation. */
export interface UpdateIptConflictInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptConflict` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `IptConflict` being updated. */
  iptConflictPatch: IptConflictPatch;
}

/** The output of our update `IptConflict` mutation. */
export interface UpdateIptConflictPayload {
  __typename?: 'UpdateIptConflictPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptConflict` that was updated by this mutation. */
  iptConflict?: Maybe<IptConflict>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptConflict`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptConflict`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptConflict`. May be used by Relay 1. */
  iptConflictEdge?: Maybe<IptConflictsEdge>;
}


/** The output of our update `IptConflict` mutation. */
export type UpdateIptConflictPayloadIptConflictEdgeArgs = {
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
};

/** All input for the `updateIptRelationshipById` mutation. */
export interface UpdateIptRelationshipByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `IptRelationship` being updated. */
  iptRelationshipPatch: IptRelationshipPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateIptRelationship` mutation. */
export interface UpdateIptRelationshipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptRelationship` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `IptRelationship` being updated. */
  iptRelationshipPatch: IptRelationshipPatch;
}

/** The output of our update `IptRelationship` mutation. */
export interface UpdateIptRelationshipPayload {
  __typename?: 'UpdateIptRelationshipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptRelationship` that was updated by this mutation. */
  iptRelationship?: Maybe<IptRelationship>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptRelationship`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptRelationship`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptRelationship`. May be used by Relay 1. */
  iptRelationshipEdge?: Maybe<IptRelationshipsEdge>;
}


/** The output of our update `IptRelationship` mutation. */
export type UpdateIptRelationshipPayloadIptRelationshipEdgeArgs = {
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
};

/** All input for the `updateIptSituationById` mutation. */
export interface UpdateIptSituationByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `IptSituation` being updated. */
  iptSituationPatch: IptSituationPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateIptSituation` mutation. */
export interface UpdateIptSituationInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IptSituation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `IptSituation` being updated. */
  iptSituationPatch: IptSituationPatch;
}

/** The output of our update `IptSituation` mutation. */
export interface UpdateIptSituationPayload {
  __typename?: 'UpdateIptSituationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IptSituation` that was updated by this mutation. */
  iptSituation?: Maybe<IptSituation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `IptSituation`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `IptSituation`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `IptSituation`. May be used by Relay 1. */
  iptSituationEdge?: Maybe<IptSituationsEdge>;
}


/** The output of our update `IptSituation` mutation. */
export type UpdateIptSituationPayloadIptSituationEdgeArgs = {
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
};

/** All input for the `updateItqById` mutation. */
export interface UpdateItqByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Itq` being updated. */
  itqPatch: ItqPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateItq` mutation. */
export interface UpdateItqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Itq` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Itq` being updated. */
  itqPatch: ItqPatch;
}

/** The output of our update `Itq` mutation. */
export interface UpdateItqPayload {
  __typename?: 'UpdateItqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Itq` that was updated by this mutation. */
  itq?: Maybe<Itq>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Itq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Itq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Itq`. May be used by Relay 1. */
  itqEdge?: Maybe<ItqsEdge>;
}


/** The output of our update `Itq` mutation. */
export type UpdateItqPayloadItqEdgeArgs = {
  orderBy?: Maybe<Array<ItqsOrderBy>>;
};

/** All input for the `updateLec5ById` mutation. */
export interface UpdateLec5ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Lec5` being updated. */
  lec5Patch: Lec5Patch;
  id: Scalars['UUID'];
}

/** All input for the `updateLec5` mutation. */
export interface UpdateLec5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lec5` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Lec5` being updated. */
  lec5Patch: Lec5Patch;
}

/** The output of our update `Lec5` mutation. */
export interface UpdateLec5Payload {
  __typename?: 'UpdateLec5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lec5` that was updated by this mutation. */
  lec5?: Maybe<Lec5>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lec5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lec5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lec5`. May be used by Relay 1. */
  lec5Edge?: Maybe<Lec5SEdge>;
}


/** The output of our update `Lec5` mutation. */
export type UpdateLec5PayloadLec5EdgeArgs = {
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
};

/** All input for the `updateLetterById` mutation. */
export interface UpdateLetterByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Letter` being updated. */
  letterPatch: LetterPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateLetter` mutation. */
export interface UpdateLetterInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Letter` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Letter` being updated. */
  letterPatch: LetterPatch;
}

/** The output of our update `Letter` mutation. */
export interface UpdateLetterPayload {
  __typename?: 'UpdateLetterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Letter` that was updated by this mutation. */
  letter?: Maybe<Letter>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Letter`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Letter`. */
  userBySenderId?: Maybe<User>;
  /** An edge for our `Letter`. May be used by Relay 1. */
  letterEdge?: Maybe<LettersEdge>;
}


/** The output of our update `Letter` mutation. */
export type UpdateLetterPayloadLetterEdgeArgs = {
  orderBy?: Maybe<Array<LettersOrderBy>>;
};

/** All input for the `updateLetterTemplateById` mutation. */
export interface UpdateLetterTemplateByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `LetterTemplate` being updated. */
  letterTemplatePatch: LetterTemplatePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateLetterTemplate` mutation. */
export interface UpdateLetterTemplateInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LetterTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `LetterTemplate` being updated. */
  letterTemplatePatch: LetterTemplatePatch;
}

/** The output of our update `LetterTemplate` mutation. */
export interface UpdateLetterTemplatePayload {
  __typename?: 'UpdateLetterTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LetterTemplate` that was updated by this mutation. */
  letterTemplate?: Maybe<LetterTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LetterTemplate`. */
  userByEditorId?: Maybe<User>;
  /** An edge for our `LetterTemplate`. May be used by Relay 1. */
  letterTemplateEdge?: Maybe<LetterTemplatesEdge>;
}


/** The output of our update `LetterTemplate` mutation. */
export type UpdateLetterTemplatePayloadLetterTemplateEdgeArgs = {
  orderBy?: Maybe<Array<LetterTemplatesOrderBy>>;
};

/** All input for the `updateLoginTokenById` mutation. */
export interface UpdateLoginTokenByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `LoginToken` being updated. */
  loginTokenPatch: LoginTokenPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateLoginToken` mutation. */
export interface UpdateLoginTokenInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LoginToken` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `LoginToken` being updated. */
  loginTokenPatch: LoginTokenPatch;
}

/** The output of our update `LoginToken` mutation. */
export interface UpdateLoginTokenPayload {
  __typename?: 'UpdateLoginTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LoginToken` that was updated by this mutation. */
  loginToken?: Maybe<LoginToken>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LoginToken`. */
  userByUserId?: Maybe<User>;
  /** An edge for our `LoginToken`. May be used by Relay 1. */
  loginTokenEdge?: Maybe<LoginTokensEdge>;
}


/** The output of our update `LoginToken` mutation. */
export type UpdateLoginTokenPayloadLoginTokenEdgeArgs = {
  orderBy?: Maybe<Array<LoginTokensOrderBy>>;
};

/** All input for the `updateLsaById` mutation. */
export interface UpdateLsaByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Lsa` being updated. */
  lsaPatch: LsaPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateLsa` mutation. */
export interface UpdateLsaInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lsa` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Lsa` being updated. */
  lsaPatch: LsaPatch;
}

/** The output of our update `Lsa` mutation. */
export interface UpdateLsaPayload {
  __typename?: 'UpdateLsaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Lsa` that was updated by this mutation. */
  lsa?: Maybe<Lsa>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Lsa`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Lsa`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Lsa`. May be used by Relay 1. */
  lsaEdge?: Maybe<LsasEdge>;
}


/** The output of our update `Lsa` mutation. */
export type UpdateLsaPayloadLsaEdgeArgs = {
  orderBy?: Maybe<Array<LsasOrderBy>>;
};

/** All input for the `updateMspssById` mutation. */
export interface UpdateMspssByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Mspss` being updated. */
  mspssPatch: MspssPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateMspss` mutation. */
export interface UpdateMspssInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Mspss` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Mspss` being updated. */
  mspssPatch: MspssPatch;
}

/** The output of our update `Mspss` mutation. */
export interface UpdateMspssPayload {
  __typename?: 'UpdateMspssPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Mspss` that was updated by this mutation. */
  mspss?: Maybe<Mspss>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Mspss`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Mspss`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Mspss`. May be used by Relay 1. */
  mspssEdge?: Maybe<MspssesEdge>;
}


/** The output of our update `Mspss` mutation. */
export type UpdateMspssPayloadMspssEdgeArgs = {
  orderBy?: Maybe<Array<MspssesOrderBy>>;
};

/** All input for the `updateMyInvolvementByCaseId` mutation. */
export interface UpdateMyInvolvementByCaseIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `MyInvolvement` being updated. */
  myInvolvementPatch: MyInvolvementPatch;
  caseId: Scalars['UUID'];
}

/** The output of our update `MyInvolvement` mutation. */
export interface UpdateMyInvolvementPayload {
  __typename?: 'UpdateMyInvolvementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MyInvolvement` that was updated by this mutation. */
  myInvolvement?: Maybe<MyInvolvement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `MyInvolvement`. May be used by Relay 1. */
  myInvolvementEdge?: Maybe<MyInvolvementsEdge>;
}


/** The output of our update `MyInvolvement` mutation. */
export type UpdateMyInvolvementPayloadMyInvolvementEdgeArgs = {
  orderBy?: Maybe<Array<MyInvolvementsOrderBy>>;
};

/** All input for the `updatePathevById` mutation. */
export interface UpdatePathevByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Pathev` being updated. */
  pathevPatch: PathevPatch;
  id: Scalars['UUID'];
}

/** All input for the `updatePathev` mutation. */
export interface UpdatePathevInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pathev` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pathev` being updated. */
  pathevPatch: PathevPatch;
}

/** The output of our update `Pathev` mutation. */
export interface UpdatePathevPayload {
  __typename?: 'UpdatePathevPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pathev` that was updated by this mutation. */
  pathev?: Maybe<Pathev>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pathev`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pathev`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pathev`. May be used by Relay 1. */
  pathevEdge?: Maybe<PathevsEdge>;
}


/** The output of our update `Pathev` mutation. */
export type UpdatePathevPayloadPathevEdgeArgs = {
  orderBy?: Maybe<Array<PathevsOrderBy>>;
};

/** All input for the `updatePcl5ById` mutation. */
export interface UpdatePcl5ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Pcl5` being updated. */
  pcl5Patch: Pcl5Patch;
  id: Scalars['UUID'];
}

/** All input for the `updatePcl5` mutation. */
export interface UpdatePcl5Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pcl5` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pcl5` being updated. */
  pcl5Patch: Pcl5Patch;
}

/** The output of our update `Pcl5` mutation. */
export interface UpdatePcl5Payload {
  __typename?: 'UpdatePcl5Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pcl5` that was updated by this mutation. */
  pcl5?: Maybe<Pcl5>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pcl5`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pcl5`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pcl5`. May be used by Relay 1. */
  pcl5Edge?: Maybe<Pcl5SEdge>;
}


/** The output of our update `Pcl5` mutation. */
export type UpdatePcl5PayloadPcl5EdgeArgs = {
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
};

/** All input for the `updatePg13ById` mutation. */
export interface UpdatePg13ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Pg13` being updated. */
  pg13Patch: Pg13Patch;
  id: Scalars['UUID'];
}

/** All input for the `updatePg13` mutation. */
export interface UpdatePg13Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pg13` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pg13` being updated. */
  pg13Patch: Pg13Patch;
}

/** The output of our update `Pg13` mutation. */
export interface UpdatePg13Payload {
  __typename?: 'UpdatePg13Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pg13` that was updated by this mutation. */
  pg13?: Maybe<Pg13>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pg13`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pg13`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pg13`. May be used by Relay 1. */
  pg13Edge?: Maybe<Pg13SEdge>;
}


/** The output of our update `Pg13` mutation. */
export type UpdatePg13PayloadPg13EdgeArgs = {
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
};

/** All input for the `updatePhq15ById` mutation. */
export interface UpdatePhq15ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Phq15` being updated. */
  phq15Patch: Phq15Patch;
  id: Scalars['UUID'];
}

/** All input for the `updatePhq15` mutation. */
export interface UpdatePhq15Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq15` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Phq15` being updated. */
  phq15Patch: Phq15Patch;
}

/** The output of our update `Phq15` mutation. */
export interface UpdatePhq15Payload {
  __typename?: 'UpdatePhq15Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq15` that was updated by this mutation. */
  phq15?: Maybe<Phq15>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq15`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq15`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq15`. May be used by Relay 1. */
  phq15Edge?: Maybe<Phq15SEdge>;
}


/** The output of our update `Phq15` mutation. */
export type UpdatePhq15PayloadPhq15EdgeArgs = {
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
};

/** All input for the `updatePhq4ById` mutation. */
export interface UpdatePhq4ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Phq4` being updated. */
  phq4Patch: Phq4Patch;
  id: Scalars['UUID'];
}

/** All input for the `updatePhq4` mutation. */
export interface UpdatePhq4Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq4` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Phq4` being updated. */
  phq4Patch: Phq4Patch;
}

/** The output of our update `Phq4` mutation. */
export interface UpdatePhq4Payload {
  __typename?: 'UpdatePhq4Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq4` that was updated by this mutation. */
  phq4?: Maybe<Phq4>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq4`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq4`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq4`. May be used by Relay 1. */
  phq4Edge?: Maybe<Phq4SEdge>;
}


/** The output of our update `Phq4` mutation. */
export type UpdatePhq4PayloadPhq4EdgeArgs = {
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
};

/** All input for the `updatePhq9ById` mutation. */
export interface UpdatePhq9ByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Phq9` being updated. */
  phq9Patch: Phq9Patch;
  id: Scalars['UUID'];
}

/** All input for the `updatePhq9` mutation. */
export interface UpdatePhq9Input {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Phq9` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Phq9` being updated. */
  phq9Patch: Phq9Patch;
}

/** The output of our update `Phq9` mutation. */
export interface UpdatePhq9Payload {
  __typename?: 'UpdatePhq9Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Phq9` that was updated by this mutation. */
  phq9?: Maybe<Phq9>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Phq9`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Phq9`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Phq9`. May be used by Relay 1. */
  phq9Edge?: Maybe<Phq9SEdge>;
}


/** The output of our update `Phq9` mutation. */
export type UpdatePhq9PayloadPhq9EdgeArgs = {
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
};

/** All input for the `updatePmbById` mutation. */
export interface UpdatePmbByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Pmb` being updated. */
  pmbPatch: PmbPatch;
  id: Scalars['UUID'];
}

/** All input for the `updatePmb` mutation. */
export interface UpdatePmbInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pmb` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pmb` being updated. */
  pmbPatch: PmbPatch;
}

/** The output of our update `Pmb` mutation. */
export interface UpdatePmbPayload {
  __typename?: 'UpdatePmbPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pmb` that was updated by this mutation. */
  pmb?: Maybe<Pmb>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Pmb`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Pmb`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Pmb`. May be used by Relay 1. */
  pmbEdge?: Maybe<PmbsEdge>;
}


/** The output of our update `Pmb` mutation. */
export type UpdatePmbPayloadPmbEdgeArgs = {
  orderBy?: Maybe<Array<PmbsOrderBy>>;
};

/** All input for the `updateProcessingQueueById` mutation. */
export interface UpdateProcessingQueueByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProcessingQueue` being updated. */
  processingQueuePatch: ProcessingQueuePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateProcessingQueue` mutation. */
export interface UpdateProcessingQueueInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProcessingQueue` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProcessingQueue` being updated. */
  processingQueuePatch: ProcessingQueuePatch;
}

/** The output of our update `ProcessingQueue` mutation. */
export interface UpdateProcessingQueuePayload {
  __typename?: 'UpdateProcessingQueuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProcessingQueue` that was updated by this mutation. */
  processingQueue?: Maybe<ProcessingQueue>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `ProcessingQueue`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `ProcessingQueue`. May be used by Relay 1. */
  processingQueueEdge?: Maybe<ProcessingQueuesEdge>;
}


/** The output of our update `ProcessingQueue` mutation. */
export type UpdateProcessingQueuePayloadProcessingQueueEdgeArgs = {
  orderBy?: Maybe<Array<ProcessingQueuesOrderBy>>;
};

/** All input for the `updateQueueSettingById` mutation. */
export interface UpdateQueueSettingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `QueueSetting` being updated. */
  queueSettingPatch: QueueSettingPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateQueueSetting` mutation. */
export interface UpdateQueueSettingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `QueueSetting` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `QueueSetting` being updated. */
  queueSettingPatch: QueueSettingPatch;
}

/** The output of our update `QueueSetting` mutation. */
export interface UpdateQueueSettingPayload {
  __typename?: 'UpdateQueueSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `QueueSetting` that was updated by this mutation. */
  queueSetting?: Maybe<QueueSetting>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `QueueSetting`. */
  userByUserIdEditor?: Maybe<User>;
  /** An edge for our `QueueSetting`. May be used by Relay 1. */
  queueSettingEdge?: Maybe<QueueSettingsEdge>;
}


/** The output of our update `QueueSetting` mutation. */
export type UpdateQueueSettingPayloadQueueSettingEdgeArgs = {
  orderBy?: Maybe<Array<QueueSettingsOrderBy>>;
};

/** All input for the `updateRandomizationTicketById` mutation. */
export interface UpdateRandomizationTicketByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `RandomizationTicket` being updated. */
  randomizationTicketPatch: RandomizationTicketPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateRandomizationTicket` mutation. */
export interface UpdateRandomizationTicketInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RandomizationTicket` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RandomizationTicket` being updated. */
  randomizationTicketPatch: RandomizationTicketPatch;
}

/** The output of our update `RandomizationTicket` mutation. */
export interface UpdateRandomizationTicketPayload {
  __typename?: 'UpdateRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `RandomizationTicket` that was updated by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `RandomizationTicket`. */
  caseByCaseId?: Maybe<Case>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
}


/** The output of our update `RandomizationTicket` mutation. */
export type UpdateRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: Maybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the `updateSbqrById` mutation. */
export interface UpdateSbqrByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Sbqr` being updated. */
  sbqrPatch: SbqrPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateSbqr` mutation. */
export interface UpdateSbqrInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sbqr` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Sbqr` being updated. */
  sbqrPatch: SbqrPatch;
}

/** The output of our update `Sbqr` mutation. */
export interface UpdateSbqrPayload {
  __typename?: 'UpdateSbqrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sbqr` that was updated by this mutation. */
  sbqr?: Maybe<Sbqr>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sbqr`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sbqr`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sbqr`. May be used by Relay 1. */
  sbqrEdge?: Maybe<SbqrsEdge>;
}


/** The output of our update `Sbqr` mutation. */
export type UpdateSbqrPayloadSbqrEdgeArgs = {
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
};

/** All input for the `updateScalingById` mutation. */
export interface UpdateScalingByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Scaling` being updated. */
  scalingPatch: ScalingPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateScaling` mutation. */
export interface UpdateScalingInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Scaling` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Scaling` being updated. */
  scalingPatch: ScalingPatch;
}

/** The output of our update `Scaling` mutation. */
export interface UpdateScalingPayload {
  __typename?: 'UpdateScalingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Scaling` that was updated by this mutation. */
  scaling?: Maybe<Scaling>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Scaling`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Scaling`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Scaling`. May be used by Relay 1. */
  scalingEdge?: Maybe<ScalingsEdge>;
}


/** The output of our update `Scaling` mutation. */
export type UpdateScalingPayloadScalingEdgeArgs = {
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
};

/** All input for the `updateSewipById` mutation. */
export interface UpdateSewipByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Sewip` being updated. */
  sewipPatch: SewipPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateSewip` mutation. */
export interface UpdateSewipInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sewip` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Sewip` being updated. */
  sewipPatch: SewipPatch;
}

/** The output of our update `Sewip` mutation. */
export interface UpdateSewipPayload {
  __typename?: 'UpdateSewipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sewip` that was updated by this mutation. */
  sewip?: Maybe<Sewip>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sewip`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sewip`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sewip`. May be used by Relay 1. */
  sewipEdge?: Maybe<SewipsEdge>;
}


/** The output of our update `Sewip` mutation. */
export type UpdateSewipPayloadSewipEdgeArgs = {
  orderBy?: Maybe<Array<SewipsOrderBy>>;
};

/** All input for the `updateSibById` mutation. */
export interface UpdateSibByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Sib` being updated. */
  sibPatch: SibPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateSib` mutation. */
export interface UpdateSibInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sib` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Sib` being updated. */
  sibPatch: SibPatch;
}

/** The output of our update `Sib` mutation. */
export interface UpdateSibPayload {
  __typename?: 'UpdateSibPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Sib` that was updated by this mutation. */
  sib?: Maybe<Sib>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Sib`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Sib`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Sib`. May be used by Relay 1. */
  sibEdge?: Maybe<SibsEdge>;
}


/** The output of our update `Sib` mutation. */
export type UpdateSibPayloadSibEdgeArgs = {
  orderBy?: Maybe<Array<SibsOrderBy>>;
};

/** All input for the `updateSuicideNoteById` mutation. */
export interface UpdateSuicideNoteByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SuicideNote` being updated. */
  suicideNotePatch: SuicideNotePatch;
  /** Primary key of suicide notes */
  id: Scalars['UUID'];
}

/** All input for the `updateSuicideNote` mutation. */
export interface UpdateSuicideNoteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuicideNote` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SuicideNote` being updated. */
  suicideNotePatch: SuicideNotePatch;
}

/** The output of our update `SuicideNote` mutation. */
export interface UpdateSuicideNotePayload {
  __typename?: 'UpdateSuicideNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `SuicideNote` that was updated by this mutation. */
  suicideNote?: Maybe<SuicideNote>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `Case` that is related to this `SuicideNote`. */
  caseByUserIdCreator?: Maybe<Case>;
  /** An edge for our `SuicideNote`. May be used by Relay 1. */
  suicideNoteEdge?: Maybe<SuicideNotesEdge>;
}


/** The output of our update `SuicideNote` mutation. */
export type UpdateSuicideNotePayloadSuicideNoteEdgeArgs = {
  orderBy?: Maybe<Array<SuicideNotesOrderBy>>;
};

/** All input for the `updateTaqById` mutation. */
export interface UpdateTaqByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Taq` being updated. */
  taqPatch: TaqPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateTaq` mutation. */
export interface UpdateTaqInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Taq` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Taq` being updated. */
  taqPatch: TaqPatch;
}

/** The output of our update `Taq` mutation. */
export interface UpdateTaqPayload {
  __typename?: 'UpdateTaqPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Taq` that was updated by this mutation. */
  taq?: Maybe<Taq>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Taq`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Taq`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Taq`. May be used by Relay 1. */
  taqEdge?: Maybe<TaqsEdge>;
}


/** The output of our update `Taq` mutation. */
export type UpdateTaqPayloadTaqEdgeArgs = {
  orderBy?: Maybe<Array<TaqsOrderBy>>;
};

/** All input for the `updateTgisrplusById` mutation. */
export interface UpdateTgisrplusByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Tgisrplus` being updated. */
  tgisrplusPatch: TgisrplusPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateTgisrplus` mutation. */
export interface UpdateTgisrplusInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Tgisrplus` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Tgisrplus` being updated. */
  tgisrplusPatch: TgisrplusPatch;
}

/** The output of our update `Tgisrplus` mutation. */
export interface UpdateTgisrplusPayload {
  __typename?: 'UpdateTgisrplusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Tgisrplus` that was updated by this mutation. */
  tgisrplus?: Maybe<Tgisrplus>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Tgisrplus`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Tgisrplus`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Tgisrplus`. May be used by Relay 1. */
  tgisrplusEdge?: Maybe<TgisrplusesEdge>;
}


/** The output of our update `Tgisrplus` mutation. */
export type UpdateTgisrplusPayloadTgisrplusEdgeArgs = {
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
};

/** All input for the `updateTraumalisteById` mutation. */
export interface UpdateTraumalisteByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Traumaliste` being updated. */
  traumalistePatch: TraumalistePatch;
  id: Scalars['UUID'];
}

/** All input for the `updateTraumaliste` mutation. */
export interface UpdateTraumalisteInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Traumaliste` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Traumaliste` being updated. */
  traumalistePatch: TraumalistePatch;
}

/** All input for the `updateTraumalisteneuById` mutation. */
export interface UpdateTraumalisteneuByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Traumalisteneu` being updated. */
  traumalisteneuPatch: TraumalisteneuPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateTraumalisteneu` mutation. */
export interface UpdateTraumalisteneuInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Traumalisteneu` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Traumalisteneu` being updated. */
  traumalisteneuPatch: TraumalisteneuPatch;
}

/** The output of our update `Traumalisteneu` mutation. */
export interface UpdateTraumalisteneuPayload {
  __typename?: 'UpdateTraumalisteneuPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumalisteneu` that was updated by this mutation. */
  traumalisteneu?: Maybe<Traumalisteneu>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumalisteneu`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumalisteneu`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumalisteneu`. May be used by Relay 1. */
  traumalisteneuEdge?: Maybe<TraumalisteneusEdge>;
}


/** The output of our update `Traumalisteneu` mutation. */
export type UpdateTraumalisteneuPayloadTraumalisteneuEdgeArgs = {
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
};

/** The output of our update `Traumaliste` mutation. */
export interface UpdateTraumalistePayload {
  __typename?: 'UpdateTraumalistePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Traumaliste` that was updated by this mutation. */
  traumaliste?: Maybe<Traumaliste>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Traumaliste`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Traumaliste`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Traumaliste`. May be used by Relay 1. */
  traumalisteEdge?: Maybe<TraumalistesEdge>;
}


/** The output of our update `Traumaliste` mutation. */
export type UpdateTraumalistePayloadTraumalisteEdgeArgs = {
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
};

/** All input for the `updateTrgiById` mutation. */
export interface UpdateTrgiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Trgi` being updated. */
  trgiPatch: TrgiPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateTrgi` mutation. */
export interface UpdateTrgiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Trgi` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Trgi` being updated. */
  trgiPatch: TrgiPatch;
}

/** The output of our update `Trgi` mutation. */
export interface UpdateTrgiPayload {
  __typename?: 'UpdateTrgiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Trgi` that was updated by this mutation. */
  trgi?: Maybe<Trgi>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Trgi`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Trgi`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Trgi`. May be used by Relay 1. */
  trgiEdge?: Maybe<TrgisEdge>;
}


/** The output of our update `Trgi` mutation. */
export type UpdateTrgiPayloadTrgiEdgeArgs = {
  orderBy?: Maybe<Array<TrgisOrderBy>>;
};

/** All input for the `updateUserByEmail` mutation. */
export interface UpdateUserByEmailInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
  email: Scalars['String'];
}

/** All input for the `updateUserById` mutation. */
export interface UpdateUserByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateUserByUsername` mutation. */
export interface UpdateUserByUsernameInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
  username: Scalars['String'];
}

/** All input for the `updateUser` mutation. */
export interface UpdateUserInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
}

/** The output of our update `User` mutation. */
export interface UpdateUserPayload {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
}


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

/** All input for the `updateWaiById` mutation. */
export interface UpdateWaiByIdInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Wai` being updated. */
  waiPatch: WaiPatch;
  id: Scalars['UUID'];
}

/** All input for the `updateWai` mutation. */
export interface UpdateWaiInput {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Wai` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Wai` being updated. */
  waiPatch: WaiPatch;
}

/** The output of our update `Wai` mutation. */
export interface UpdateWaiPayload {
  __typename?: 'UpdateWaiPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Wai` that was updated by this mutation. */
  wai?: Maybe<Wai>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Case` that is related to this `Wai`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Wai`. */
  userBySubmitterId?: Maybe<User>;
  /** An edge for our `Wai`. May be used by Relay 1. */
  waiEdge?: Maybe<WaisEdge>;
}


/** The output of our update `Wai` mutation. */
export type UpdateWaiPayloadWaiEdgeArgs = {
  orderBy?: Maybe<Array<WaisOrderBy>>;
};

export interface User extends Node {
  __typename?: 'User';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  username: Scalars['String'];
  email: Scalars['String'];
  encryptedPassword: Scalars['String'];
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole: Scalars['Boolean'];
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts: Scalars['Int'];
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount: Scalars['Boolean'];
  isTherapistAccount: Scalars['Boolean'];
  isSupervisorAccount: Scalars['Boolean'];
  isInterviewerAccount: Scalars['Boolean'];
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  accesspathKind?: Maybe<Scalars['String']>;
  accesspathDetail?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  confirmTrialInformation: Scalars['Boolean'];
  confirmPrivacyStatement: Scalars['Boolean'];
  confirmVoluntaryParticipation: Scalars['Boolean'];
  confirmOptionalSurveys: Scalars['Boolean'];
  confirmDiverseOptions: Scalars['Boolean'];
  confirmPersonalEmail: Scalars['Boolean'];
  confirmLegalAge: Scalars['Boolean'];
  confirmNoOtherConcurrentTreatment: Scalars['Boolean'];
  confirmNoFinancialCompensation: Scalars['Boolean'];
  confirmContactViaPhoneAndEmail: Scalars['Boolean'];
  confirmProcessingOfInformation: Scalars['Boolean'];
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  isSupporterAccount: Scalars['Boolean'];
  isTesterAccount: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  isCoordinatorAccount: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
  isCounselorAccount?: Maybe<Scalars['Boolean']>;
  /** Will be set to true, if customer registered via "counseling registration site" else to false */
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `InterviewBooking`. */
  interviewBookingsByIntervieweeId: InterviewBookingsConnection;
  /** Reads and enables pagination through a set of `InterviewOffer`. */
  interviewOffersByInterviewerId: InterviewOffersConnection;
  /** Reads and enables pagination through a set of `Involvement`. */
  involvementsByUserId: InvolvementsConnection;
  /** Reads and enables pagination through a set of `CaseMessage`. */
  caseMessagesBySenderId: CaseMessagesConnection;
  /** Reads and enables pagination through a set of `Bdi2`. */
  bdi2SBySubmitterId: Bdi2SConnection;
  /** Reads and enables pagination through a set of `Eurohi`. */
  eurohisBySubmitterId: EurohisConnection;
  /** Reads and enables pagination through a set of `Gad2`. */
  gad2SBySubmitterId: Gad2SConnection;
  /** Reads and enables pagination through a set of `Gad7`. */
  gad7SBySubmitterId: Gad7SConnection;
  /** Reads and enables pagination through a set of `Inep`. */
  inepsBySubmitterId: InepsConnection;
  /** Reads and enables pagination through a set of `InterviewReport`. */
  interviewReportsByInterviewerId: InterviewReportsConnection;
  /** Reads and enables pagination through a set of `Lsa`. */
  lsasBySubmitterId: LsasConnection;
  /** Reads and enables pagination through a set of `Mspss`. */
  mspssesBySubmitterId: MspssesConnection;
  /** Reads and enables pagination through a set of `Pathev`. */
  pathevsBySubmitterId: PathevsConnection;
  /** Reads and enables pagination through a set of `Pcl5`. */
  pcl5SBySubmitterId: Pcl5SConnection;
  /** Reads and enables pagination through a set of `Phq15`. */
  phq15SBySubmitterId: Phq15SConnection;
  /** Reads and enables pagination through a set of `Phq9`. */
  phq9SBySubmitterId: Phq9SConnection;
  /** Reads and enables pagination through a set of `Pmb`. */
  pmbsBySubmitterId: PmbsConnection;
  /** Reads and enables pagination through a set of `Sewip`. */
  sewipsBySubmitterId: SewipsConnection;
  /** Reads and enables pagination through a set of `Taq`. */
  taqsBySubmitterId: TaqsConnection;
  /** Reads and enables pagination through a set of `Traumaliste`. */
  traumalistesBySubmitterId: TraumalistesConnection;
  /** Reads and enables pagination through a set of `Trgi`. */
  trgisBySubmitterId: TrgisConnection;
  /** Reads and enables pagination through a set of `Wai`. */
  waisBySubmitterId: WaisConnection;
  /** Reads and enables pagination through a set of `CbtActivity`. */
  cbtActivitiesBySubmitterId: CbtActivitiesConnection;
  /** Reads and enables pagination through a set of `CbtReframing`. */
  cbtReframingsBySubmitterId: CbtReframingsConnection;
  /** Reads and enables pagination through a set of `CbtThought`. */
  cbtThoughtsBySubmitterId: CbtThoughtsConnection;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsBySubmitterId: CommentsConnection;
  /** Reads and enables pagination through a set of `Demographic`. */
  demographicsBySubmitterId: DemographicsConnection;
  /** Reads and enables pagination through a set of `Disclosure`. */
  disclosuresBySubmitterId: DisclosuresConnection;
  /** Reads and enables pagination through a set of `Evaluation`. */
  evaluationsBySubmitterId: EvaluationsConnection;
  /** Reads and enables pagination through a set of `IptConflict`. */
  iptConflictsBySubmitterId: IptConflictsConnection;
  /** Reads and enables pagination through a set of `IptRelationship`. */
  iptRelationshipsBySubmitterId: IptRelationshipsConnection;
  /** Reads and enables pagination through a set of `IptSituation`. */
  iptSituationsBySubmitterId: IptSituationsConnection;
  /** Reads and enables pagination through a set of `Lec5`. */
  lec5SBySubmitterId: Lec5SConnection;
  /** Reads and enables pagination through a set of `Letter`. */
  lettersBySenderId: LettersConnection;
  /** Reads and enables pagination through a set of `LoginToken`. */
  loginTokensByUserId: LoginTokensConnection;
  /** Reads and enables pagination through a set of `Pg13`. */
  pg13SBySubmitterId: Pg13SConnection;
  /** Reads and enables pagination through a set of `CaseSuicideCall`. */
  caseSuicideCallsByUserIdCaller: CaseSuicideCallsConnection;
  /** Reads and enables pagination through a set of `LetterTemplate`. */
  letterTemplatesByEditorId: LetterTemplatesConnection;
  /** Reads and enables pagination through a set of `Scaling`. */
  scalingsBySubmitterId: ScalingsConnection;
  /** Reads and enables pagination through a set of `Sib`. */
  sibsBySubmitterId: SibsConnection;
  /** Reads and enables pagination through a set of `Sbqr`. */
  sbqrsBySubmitterId: SbqrsConnection;
  /** Reads and enables pagination through a set of `Cdrisk10`. */
  cdrisk10SBySubmitterId: Cdrisk10SConnection;
  /** Reads and enables pagination through a set of `Traumalisteneu`. */
  traumalisteneusBySubmitterId: TraumalisteneusConnection;
  /** Reads and enables pagination through a set of `Itq`. */
  itqsBySubmitterId: ItqsConnection;
  /** Reads and enables pagination through a set of `Tgisrplus`. */
  tgisrplusesBySubmitterId: TgisrplusesConnection;
  /** Reads and enables pagination through a set of `Phq4`. */
  phq4SBySubmitterId: Phq4SConnection;
  /** Reads and enables pagination through a set of `CounselingQuestion`. */
  counselingQuestionsBySubmitterId: CounselingQuestionsConnection;
  /** Reads and enables pagination through a set of `QueueSetting`. */
  queueSettingsByUserIdEditor: QueueSettingsConnection;
  /** Reads and enables pagination through a set of `CaseMember`. */
  caseMembersByUserId: CaseMembersConnection;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  interviewCalendarsByInterviewerId: InterviewCalendarsConnection;
  /** Reads and enables pagination through a set of `InterviewCalendar`. */
  interviewCalendarsByIntervieweeId: InterviewCalendarsConnection;
}


export type UserInterviewBookingsByIntervieweeIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewBookingsOrderBy>>;
  condition?: Maybe<InterviewBookingCondition>;
  filter?: Maybe<InterviewBookingFilter>;
};


export type UserInterviewOffersByInterviewerIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewOffersOrderBy>>;
  condition?: Maybe<InterviewOfferCondition>;
  filter?: Maybe<InterviewOfferFilter>;
};


export type UserInvolvementsByUserIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InvolvementsOrderBy>>;
  condition?: Maybe<InvolvementCondition>;
  filter?: Maybe<InvolvementFilter>;
};


export type UserCaseMessagesBySenderIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMessagesOrderBy>>;
  condition?: Maybe<CaseMessageCondition>;
  filter?: Maybe<CaseMessageFilter>;
};


export type UserBdi2SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Bdi2SOrderBy>>;
  condition?: Maybe<Bdi2Condition>;
  filter?: Maybe<Bdi2Filter>;
};


export type UserEurohisBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EurohisOrderBy>>;
  condition?: Maybe<EurohiCondition>;
  filter?: Maybe<EurohiFilter>;
};


export type UserGad2SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad2SOrderBy>>;
  condition?: Maybe<Gad2Condition>;
  filter?: Maybe<Gad2Filter>;
};


export type UserGad7SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Gad7SOrderBy>>;
  condition?: Maybe<Gad7Condition>;
  filter?: Maybe<Gad7Filter>;
};


export type UserInepsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InepsOrderBy>>;
  condition?: Maybe<InepCondition>;
  filter?: Maybe<InepFilter>;
};


export type UserInterviewReportsByInterviewerIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewReportsOrderBy>>;
  condition?: Maybe<InterviewReportCondition>;
  filter?: Maybe<InterviewReportFilter>;
};


export type UserLsasBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LsasOrderBy>>;
  condition?: Maybe<LsaCondition>;
  filter?: Maybe<LsaFilter>;
};


export type UserMspssesBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<MspssesOrderBy>>;
  condition?: Maybe<MspssCondition>;
  filter?: Maybe<MspssFilter>;
};


export type UserPathevsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PathevsOrderBy>>;
  condition?: Maybe<PathevCondition>;
  filter?: Maybe<PathevFilter>;
};


export type UserPcl5SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pcl5SOrderBy>>;
  condition?: Maybe<Pcl5Condition>;
  filter?: Maybe<Pcl5Filter>;
};


export type UserPhq15SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq15SOrderBy>>;
  condition?: Maybe<Phq15Condition>;
  filter?: Maybe<Phq15Filter>;
};


export type UserPhq9SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq9SOrderBy>>;
  condition?: Maybe<Phq9Condition>;
  filter?: Maybe<Phq9Filter>;
};


export type UserPmbsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PmbsOrderBy>>;
  condition?: Maybe<PmbCondition>;
  filter?: Maybe<PmbFilter>;
};


export type UserSewipsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SewipsOrderBy>>;
  condition?: Maybe<SewipCondition>;
  filter?: Maybe<SewipFilter>;
};


export type UserTaqsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TaqsOrderBy>>;
  condition?: Maybe<TaqCondition>;
  filter?: Maybe<TaqFilter>;
};


export type UserTraumalistesBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalistesOrderBy>>;
  condition?: Maybe<TraumalisteCondition>;
  filter?: Maybe<TraumalisteFilter>;
};


export type UserTrgisBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TrgisOrderBy>>;
  condition?: Maybe<TrgiCondition>;
  filter?: Maybe<TrgiFilter>;
};


export type UserWaisBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<WaisOrderBy>>;
  condition?: Maybe<WaiCondition>;
  filter?: Maybe<WaiFilter>;
};


export type UserCbtActivitiesBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtActivitiesOrderBy>>;
  condition?: Maybe<CbtActivityCondition>;
  filter?: Maybe<CbtActivityFilter>;
};


export type UserCbtReframingsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtReframingsOrderBy>>;
  condition?: Maybe<CbtReframingCondition>;
  filter?: Maybe<CbtReframingFilter>;
};


export type UserCbtThoughtsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CbtThoughtsOrderBy>>;
  condition?: Maybe<CbtThoughtCondition>;
  filter?: Maybe<CbtThoughtFilter>;
};


export type UserCommentsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CommentsOrderBy>>;
  condition?: Maybe<CommentCondition>;
  filter?: Maybe<CommentFilter>;
};


export type UserDemographicsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DemographicsOrderBy>>;
  condition?: Maybe<DemographicCondition>;
  filter?: Maybe<DemographicFilter>;
};


export type UserDisclosuresBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<DisclosuresOrderBy>>;
  condition?: Maybe<DisclosureCondition>;
  filter?: Maybe<DisclosureFilter>;
};


export type UserEvaluationsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<EvaluationsOrderBy>>;
  condition?: Maybe<EvaluationCondition>;
  filter?: Maybe<EvaluationFilter>;
};


export type UserIptConflictsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptConflictsOrderBy>>;
  condition?: Maybe<IptConflictCondition>;
  filter?: Maybe<IptConflictFilter>;
};


export type UserIptRelationshipsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptRelationshipsOrderBy>>;
  condition?: Maybe<IptRelationshipCondition>;
  filter?: Maybe<IptRelationshipFilter>;
};


export type UserIptSituationsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<IptSituationsOrderBy>>;
  condition?: Maybe<IptSituationCondition>;
  filter?: Maybe<IptSituationFilter>;
};


export type UserLec5SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Lec5SOrderBy>>;
  condition?: Maybe<Lec5Condition>;
  filter?: Maybe<Lec5Filter>;
};


export type UserLettersBySenderIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LettersOrderBy>>;
  condition?: Maybe<LetterCondition>;
  filter?: Maybe<LetterFilter>;
};


export type UserLoginTokensByUserIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LoginTokensOrderBy>>;
  condition?: Maybe<LoginTokenCondition>;
  filter?: Maybe<LoginTokenFilter>;
};


export type UserPg13SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Pg13SOrderBy>>;
  condition?: Maybe<Pg13Condition>;
  filter?: Maybe<Pg13Filter>;
};


export type UserCaseSuicideCallsByUserIdCallerArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseSuicideCallsOrderBy>>;
  condition?: Maybe<CaseSuicideCallCondition>;
  filter?: Maybe<CaseSuicideCallFilter>;
};


export type UserLetterTemplatesByEditorIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<LetterTemplatesOrderBy>>;
  condition?: Maybe<LetterTemplateCondition>;
  filter?: Maybe<LetterTemplateFilter>;
};


export type UserScalingsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ScalingsOrderBy>>;
  condition?: Maybe<ScalingCondition>;
  filter?: Maybe<ScalingFilter>;
};


export type UserSibsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SibsOrderBy>>;
  condition?: Maybe<SibCondition>;
  filter?: Maybe<SibFilter>;
};


export type UserSbqrsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SbqrsOrderBy>>;
  condition?: Maybe<SbqrCondition>;
  filter?: Maybe<SbqrFilter>;
};


export type UserCdrisk10SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Cdrisk10SOrderBy>>;
  condition?: Maybe<Cdrisk10Condition>;
  filter?: Maybe<Cdrisk10Filter>;
};


export type UserTraumalisteneusBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TraumalisteneusOrderBy>>;
  condition?: Maybe<TraumalisteneuCondition>;
  filter?: Maybe<TraumalisteneuFilter>;
};


export type UserItqsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ItqsOrderBy>>;
  condition?: Maybe<ItqCondition>;
  filter?: Maybe<ItqFilter>;
};


export type UserTgisrplusesBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<TgisrplusesOrderBy>>;
  condition?: Maybe<TgisrplusCondition>;
  filter?: Maybe<TgisrplusFilter>;
};


export type UserPhq4SBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<Phq4SOrderBy>>;
  condition?: Maybe<Phq4Condition>;
  filter?: Maybe<Phq4Filter>;
};


export type UserCounselingQuestionsBySubmitterIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CounselingQuestionsOrderBy>>;
  condition?: Maybe<CounselingQuestionCondition>;
  filter?: Maybe<CounselingQuestionFilter>;
};


export type UserQueueSettingsByUserIdEditorArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<QueueSettingsOrderBy>>;
  condition?: Maybe<QueueSettingCondition>;
  filter?: Maybe<QueueSettingFilter>;
};


export type UserCaseMembersByUserIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<CaseMembersOrderBy>>;
  condition?: Maybe<CaseMemberCondition>;
  filter?: Maybe<CaseMemberFilter>;
};


export type UserInterviewCalendarsByInterviewerIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};


export type UserInterviewCalendarsByIntervieweeIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<InterviewCalendarsOrderBy>>;
  condition?: Maybe<InterviewCalendarCondition>;
  filter?: Maybe<InterviewCalendarFilter>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface UserCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `username` field. */
  username?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `systemRole` field. */
  systemRole?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `gender` field. */
  gender?: Maybe<Gender>;
  /** Checks for equality with the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unlockToken` field. */
  unlockToken?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `lockedAt` field. */
  lockedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `accesspathKind` field. */
  accesspathKind?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `accesspathDetail` field. */
  accesspathDetail?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `confirmTrialInformation` field. */
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmPrivacyStatement` field. */
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmVoluntaryParticipation` field. */
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmOptionalSurveys` field. */
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmDiverseOptions` field. */
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmPersonalEmail` field. */
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmLegalAge` field. */
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmNoOtherConcurrentTreatment` field. */
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmNoFinancialCompensation` field. */
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmContactViaPhoneAndEmail` field. */
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmProcessingOfInformation` field. */
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `consentTrialInformation` field. */
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentPrivacyStatement` field. */
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentVoluntaryParticipation` field. */
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentOptionalSurveys` field. */
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentDiverseOptions` field. */
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentPersonalEmail` field. */
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentLegalAge` field. */
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentNoOtherConcurrentTreatment` field. */
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentNoFinancialCompensation` field. */
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentContactViaPhoneAndEmail` field. */
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `consentProcessingOfInformation` field. */
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excluded` field. */
  excluded?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSupporterAccount` field. */
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTesterAccount` field. */
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `isCoordinatorAccount` field. */
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastLogin` field. */
  lastLogin?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isCounselorAccount` field. */
  isCounselorAccount?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isCounselingOnly` field. */
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `registeredForCounseling` field. */
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
}

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export interface UserFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: Maybe<StringFilter>;
  /** Filter by the object’s `systemRole` field. */
  systemRole?: Maybe<StringFilter>;
  /** Filter by the object’s `gender` field. */
  gender?: Maybe<GenderFilter>;
  /** Filter by the object’s `autoGeneratedSystemRole` field. */
  autoGeneratedSystemRole?: Maybe<BooleanFilter>;
  /** Filter by the object’s `resetPasswordToken` field. */
  resetPasswordToken?: Maybe<StringFilter>;
  /** Filter by the object’s `resetPasswordSentAt` field. */
  resetPasswordSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationToken` field. */
  confirmationToken?: Maybe<StringFilter>;
  /** Filter by the object’s `confirmedAt` field. */
  confirmedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationSentAt` field. */
  confirmationSentAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `unconfirmedEmail` field. */
  unconfirmedEmail?: Maybe<StringFilter>;
  /** Filter by the object’s `failedAttempts` field. */
  failedAttempts?: Maybe<IntFilter>;
  /** Filter by the object’s `unlockToken` field. */
  unlockToken?: Maybe<StringFilter>;
  /** Filter by the object’s `lockedAt` field. */
  lockedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `isPatientAccount` field. */
  isPatientAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isTherapistAccount` field. */
  isTherapistAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSupervisorAccount` field. */
  isSupervisorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isInterviewerAccount` field. */
  isInterviewerAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `agreedToAntiSuicideContractAt` field. */
  agreedToAntiSuicideContractAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `accesspathKind` field. */
  accesspathKind?: Maybe<StringFilter>;
  /** Filter by the object’s `accesspathDetail` field. */
  accesspathDetail?: Maybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: Maybe<StringFilter>;
  /** Filter by the object’s `confirmTrialInformation` field. */
  confirmTrialInformation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmPrivacyStatement` field. */
  confirmPrivacyStatement?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmVoluntaryParticipation` field. */
  confirmVoluntaryParticipation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmOptionalSurveys` field. */
  confirmOptionalSurveys?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmDiverseOptions` field. */
  confirmDiverseOptions?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmPersonalEmail` field. */
  confirmPersonalEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmLegalAge` field. */
  confirmLegalAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmNoOtherConcurrentTreatment` field. */
  confirmNoOtherConcurrentTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmNoFinancialCompensation` field. */
  confirmNoFinancialCompensation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmContactViaPhoneAndEmail` field. */
  confirmContactViaPhoneAndEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `confirmProcessingOfInformation` field. */
  confirmProcessingOfInformation?: Maybe<BooleanFilter>;
  /** Filter by the object’s `consentTrialInformation` field. */
  consentTrialInformation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentPrivacyStatement` field. */
  consentPrivacyStatement?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentVoluntaryParticipation` field. */
  consentVoluntaryParticipation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentOptionalSurveys` field. */
  consentOptionalSurveys?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentDiverseOptions` field. */
  consentDiverseOptions?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentPersonalEmail` field. */
  consentPersonalEmail?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentLegalAge` field. */
  consentLegalAge?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentNoOtherConcurrentTreatment` field. */
  consentNoOtherConcurrentTreatment?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentNoFinancialCompensation` field. */
  consentNoFinancialCompensation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentContactViaPhoneAndEmail` field. */
  consentContactViaPhoneAndEmail?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `consentProcessingOfInformation` field. */
  consentProcessingOfInformation?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `excludedForLackOfEmail` field. */
  excludedForLackOfEmail?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForLackOfInternetAccess` field. */
  excludedForLackOfInternetAccess?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMinorAge` field. */
  excludedForMinorAge?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForUpcomingTreatment` field. */
  excludedForUpcomingTreatment?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForBdiGte45` field. */
  excludedForBdiGte45?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForNoTraumaOrBdiLte13` field. */
  excludedForNoTraumaOrBdiLte13?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excluded` field. */
  excluded?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedForMissingInterview` field. */
  excludedForMissingInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `excludedDuringInterview` field. */
  excludedDuringInterview?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isSupporterAccount` field. */
  isSupporterAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isTesterAccount` field. */
  isTesterAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: Maybe<StringFilter>;
  /** Filter by the object’s `isCoordinatorAccount` field. */
  isCoordinatorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nrOfLogins` field. */
  nrOfLogins?: Maybe<IntFilter>;
  /** Filter by the object’s `isCounselorAccount` field. */
  isCounselorAccount?: Maybe<BooleanFilter>;
  /** Filter by the object’s `isCounselingOnly` field. */
  isCounselingOnly?: Maybe<BooleanFilter>;
  /** Filter by the object’s `registeredForCounseling` field. */
  registeredForCounseling?: Maybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<UserFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<UserFilter>>;
  /** Negates the expression. */
  not?: Maybe<UserFilter>;
}

/** An input for mutations affecting `User` */
export interface UserInput {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username: Scalars['String'];
  email: Scalars['String'];
  encryptedPassword: Scalars['String'];
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  accesspathKind?: Maybe<Scalars['String']>;
  accesspathDetail?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
  isCounselorAccount?: Maybe<Scalars['Boolean']>;
  /** Will be set to true, if customer registered via "counseling registration site" else to false */
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
}

/** Represents an update to a `User`. Fields that are set will be updated. */
export interface UserPatch {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  encryptedPassword?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  autoGeneratedSystemRole?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordSentAt?: Maybe<Scalars['Datetime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['Datetime']>;
  confirmationSentAt?: Maybe<Scalars['Datetime']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  failedAttempts?: Maybe<Scalars['Int']>;
  unlockToken?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['Datetime']>;
  isPatientAccount?: Maybe<Scalars['Boolean']>;
  isTherapistAccount?: Maybe<Scalars['Boolean']>;
  isSupervisorAccount?: Maybe<Scalars['Boolean']>;
  isInterviewerAccount?: Maybe<Scalars['Boolean']>;
  agreedToAntiSuicideContractAt?: Maybe<Scalars['Datetime']>;
  accesspathKind?: Maybe<Scalars['String']>;
  accesspathDetail?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  confirmTrialInformation?: Maybe<Scalars['Boolean']>;
  confirmPrivacyStatement?: Maybe<Scalars['Boolean']>;
  confirmVoluntaryParticipation?: Maybe<Scalars['Boolean']>;
  confirmOptionalSurveys?: Maybe<Scalars['Boolean']>;
  confirmDiverseOptions?: Maybe<Scalars['Boolean']>;
  confirmPersonalEmail?: Maybe<Scalars['Boolean']>;
  confirmLegalAge?: Maybe<Scalars['Boolean']>;
  confirmNoOtherConcurrentTreatment?: Maybe<Scalars['Boolean']>;
  confirmNoFinancialCompensation?: Maybe<Scalars['Boolean']>;
  confirmContactViaPhoneAndEmail?: Maybe<Scalars['Boolean']>;
  confirmProcessingOfInformation?: Maybe<Scalars['Boolean']>;
  consentTrialInformation?: Maybe<Scalars['Datetime']>;
  consentPrivacyStatement?: Maybe<Scalars['Datetime']>;
  consentVoluntaryParticipation?: Maybe<Scalars['Datetime']>;
  consentOptionalSurveys?: Maybe<Scalars['Datetime']>;
  consentDiverseOptions?: Maybe<Scalars['Datetime']>;
  consentPersonalEmail?: Maybe<Scalars['Datetime']>;
  consentLegalAge?: Maybe<Scalars['Datetime']>;
  consentNoOtherConcurrentTreatment?: Maybe<Scalars['Datetime']>;
  consentNoFinancialCompensation?: Maybe<Scalars['Datetime']>;
  consentContactViaPhoneAndEmail?: Maybe<Scalars['Datetime']>;
  consentProcessingOfInformation?: Maybe<Scalars['Datetime']>;
  excludedForLackOfEmail?: Maybe<Scalars['Boolean']>;
  excludedForLackOfInternetAccess?: Maybe<Scalars['Boolean']>;
  excludedForMinorAge?: Maybe<Scalars['Boolean']>;
  excludedForUpcomingTreatment?: Maybe<Scalars['Boolean']>;
  excludedForBdiGte45?: Maybe<Scalars['Boolean']>;
  excludedForNoTraumaOrBdiLte13?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
  excludedForMissingInterview?: Maybe<Scalars['Boolean']>;
  excludedDuringInterview?: Maybe<Scalars['Boolean']>;
  isSupporterAccount?: Maybe<Scalars['Boolean']>;
  isTesterAccount?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  isCoordinatorAccount?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  nrOfLogins?: Maybe<Scalars['Int']>;
  isCounselorAccount?: Maybe<Scalars['Boolean']>;
  /** Will be set to true, if customer registered via "counseling registration site" else to false */
  isCounselingOnly?: Maybe<Scalars['Boolean']>;
  registeredForCounseling?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of `User` values. */
export interface UsersConnection {
  __typename?: 'UsersConnection';
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `User` edge in the connection. */
export interface UsersEdge {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
}

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  SystemRoleAsc = 'SYSTEM_ROLE_ASC',
  SystemRoleDesc = 'SYSTEM_ROLE_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  AutoGeneratedSystemRoleAsc = 'AUTO_GENERATED_SYSTEM_ROLE_ASC',
  AutoGeneratedSystemRoleDesc = 'AUTO_GENERATED_SYSTEM_ROLE_DESC',
  ResetPasswordTokenAsc = 'RESET_PASSWORD_TOKEN_ASC',
  ResetPasswordTokenDesc = 'RESET_PASSWORD_TOKEN_DESC',
  ResetPasswordSentAtAsc = 'RESET_PASSWORD_SENT_AT_ASC',
  ResetPasswordSentAtDesc = 'RESET_PASSWORD_SENT_AT_DESC',
  ConfirmationTokenAsc = 'CONFIRMATION_TOKEN_ASC',
  ConfirmationTokenDesc = 'CONFIRMATION_TOKEN_DESC',
  ConfirmedAtAsc = 'CONFIRMED_AT_ASC',
  ConfirmedAtDesc = 'CONFIRMED_AT_DESC',
  ConfirmationSentAtAsc = 'CONFIRMATION_SENT_AT_ASC',
  ConfirmationSentAtDesc = 'CONFIRMATION_SENT_AT_DESC',
  UnconfirmedEmailAsc = 'UNCONFIRMED_EMAIL_ASC',
  UnconfirmedEmailDesc = 'UNCONFIRMED_EMAIL_DESC',
  FailedAttemptsAsc = 'FAILED_ATTEMPTS_ASC',
  FailedAttemptsDesc = 'FAILED_ATTEMPTS_DESC',
  UnlockTokenAsc = 'UNLOCK_TOKEN_ASC',
  UnlockTokenDesc = 'UNLOCK_TOKEN_DESC',
  LockedAtAsc = 'LOCKED_AT_ASC',
  LockedAtDesc = 'LOCKED_AT_DESC',
  IsPatientAccountAsc = 'IS_PATIENT_ACCOUNT_ASC',
  IsPatientAccountDesc = 'IS_PATIENT_ACCOUNT_DESC',
  IsTherapistAccountAsc = 'IS_THERAPIST_ACCOUNT_ASC',
  IsTherapistAccountDesc = 'IS_THERAPIST_ACCOUNT_DESC',
  IsSupervisorAccountAsc = 'IS_SUPERVISOR_ACCOUNT_ASC',
  IsSupervisorAccountDesc = 'IS_SUPERVISOR_ACCOUNT_DESC',
  IsInterviewerAccountAsc = 'IS_INTERVIEWER_ACCOUNT_ASC',
  IsInterviewerAccountDesc = 'IS_INTERVIEWER_ACCOUNT_DESC',
  AgreedToAntiSuicideContractAtAsc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_ASC',
  AgreedToAntiSuicideContractAtDesc = 'AGREED_TO_ANTI_SUICIDE_CONTRACT_AT_DESC',
  AccesspathKindAsc = 'ACCESSPATH_KIND_ASC',
  AccesspathKindDesc = 'ACCESSPATH_KIND_DESC',
  AccesspathDetailAsc = 'ACCESSPATH_DETAIL_ASC',
  AccesspathDetailDesc = 'ACCESSPATH_DETAIL_DESC',
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  ConfirmTrialInformationAsc = 'CONFIRM_TRIAL_INFORMATION_ASC',
  ConfirmTrialInformationDesc = 'CONFIRM_TRIAL_INFORMATION_DESC',
  ConfirmPrivacyStatementAsc = 'CONFIRM_PRIVACY_STATEMENT_ASC',
  ConfirmPrivacyStatementDesc = 'CONFIRM_PRIVACY_STATEMENT_DESC',
  ConfirmVoluntaryParticipationAsc = 'CONFIRM_VOLUNTARY_PARTICIPATION_ASC',
  ConfirmVoluntaryParticipationDesc = 'CONFIRM_VOLUNTARY_PARTICIPATION_DESC',
  ConfirmOptionalSurveysAsc = 'CONFIRM_OPTIONAL_SURVEYS_ASC',
  ConfirmOptionalSurveysDesc = 'CONFIRM_OPTIONAL_SURVEYS_DESC',
  ConfirmDiverseOptionsAsc = 'CONFIRM_DIVERSE_OPTIONS_ASC',
  ConfirmDiverseOptionsDesc = 'CONFIRM_DIVERSE_OPTIONS_DESC',
  ConfirmPersonalEmailAsc = 'CONFIRM_PERSONAL_EMAIL_ASC',
  ConfirmPersonalEmailDesc = 'CONFIRM_PERSONAL_EMAIL_DESC',
  ConfirmLegalAgeAsc = 'CONFIRM_LEGAL_AGE_ASC',
  ConfirmLegalAgeDesc = 'CONFIRM_LEGAL_AGE_DESC',
  ConfirmNoOtherConcurrentTreatmentAsc = 'CONFIRM_NO_OTHER_CONCURRENT_TREATMENT_ASC',
  ConfirmNoOtherConcurrentTreatmentDesc = 'CONFIRM_NO_OTHER_CONCURRENT_TREATMENT_DESC',
  ConfirmNoFinancialCompensationAsc = 'CONFIRM_NO_FINANCIAL_COMPENSATION_ASC',
  ConfirmNoFinancialCompensationDesc = 'CONFIRM_NO_FINANCIAL_COMPENSATION_DESC',
  ConfirmContactViaPhoneAndEmailAsc = 'CONFIRM_CONTACT_VIA_PHONE_AND_EMAIL_ASC',
  ConfirmContactViaPhoneAndEmailDesc = 'CONFIRM_CONTACT_VIA_PHONE_AND_EMAIL_DESC',
  ConfirmProcessingOfInformationAsc = 'CONFIRM_PROCESSING_OF_INFORMATION_ASC',
  ConfirmProcessingOfInformationDesc = 'CONFIRM_PROCESSING_OF_INFORMATION_DESC',
  ConsentTrialInformationAsc = 'CONSENT_TRIAL_INFORMATION_ASC',
  ConsentTrialInformationDesc = 'CONSENT_TRIAL_INFORMATION_DESC',
  ConsentPrivacyStatementAsc = 'CONSENT_PRIVACY_STATEMENT_ASC',
  ConsentPrivacyStatementDesc = 'CONSENT_PRIVACY_STATEMENT_DESC',
  ConsentVoluntaryParticipationAsc = 'CONSENT_VOLUNTARY_PARTICIPATION_ASC',
  ConsentVoluntaryParticipationDesc = 'CONSENT_VOLUNTARY_PARTICIPATION_DESC',
  ConsentOptionalSurveysAsc = 'CONSENT_OPTIONAL_SURVEYS_ASC',
  ConsentOptionalSurveysDesc = 'CONSENT_OPTIONAL_SURVEYS_DESC',
  ConsentDiverseOptionsAsc = 'CONSENT_DIVERSE_OPTIONS_ASC',
  ConsentDiverseOptionsDesc = 'CONSENT_DIVERSE_OPTIONS_DESC',
  ConsentPersonalEmailAsc = 'CONSENT_PERSONAL_EMAIL_ASC',
  ConsentPersonalEmailDesc = 'CONSENT_PERSONAL_EMAIL_DESC',
  ConsentLegalAgeAsc = 'CONSENT_LEGAL_AGE_ASC',
  ConsentLegalAgeDesc = 'CONSENT_LEGAL_AGE_DESC',
  ConsentNoOtherConcurrentTreatmentAsc = 'CONSENT_NO_OTHER_CONCURRENT_TREATMENT_ASC',
  ConsentNoOtherConcurrentTreatmentDesc = 'CONSENT_NO_OTHER_CONCURRENT_TREATMENT_DESC',
  ConsentNoFinancialCompensationAsc = 'CONSENT_NO_FINANCIAL_COMPENSATION_ASC',
  ConsentNoFinancialCompensationDesc = 'CONSENT_NO_FINANCIAL_COMPENSATION_DESC',
  ConsentContactViaPhoneAndEmailAsc = 'CONSENT_CONTACT_VIA_PHONE_AND_EMAIL_ASC',
  ConsentContactViaPhoneAndEmailDesc = 'CONSENT_CONTACT_VIA_PHONE_AND_EMAIL_DESC',
  ConsentProcessingOfInformationAsc = 'CONSENT_PROCESSING_OF_INFORMATION_ASC',
  ConsentProcessingOfInformationDesc = 'CONSENT_PROCESSING_OF_INFORMATION_DESC',
  ExcludedForLackOfEmailAsc = 'EXCLUDED_FOR_LACK_OF_EMAIL_ASC',
  ExcludedForLackOfEmailDesc = 'EXCLUDED_FOR_LACK_OF_EMAIL_DESC',
  ExcludedForLackOfInternetAccessAsc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_ASC',
  ExcludedForLackOfInternetAccessDesc = 'EXCLUDED_FOR_LACK_OF_INTERNET_ACCESS_DESC',
  ExcludedForMinorAgeAsc = 'EXCLUDED_FOR_MINOR_AGE_ASC',
  ExcludedForMinorAgeDesc = 'EXCLUDED_FOR_MINOR_AGE_DESC',
  ExcludedForUpcomingTreatmentAsc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_ASC',
  ExcludedForUpcomingTreatmentDesc = 'EXCLUDED_FOR_UPCOMING_TREATMENT_DESC',
  ExcludedForBdiGte_45Asc = 'EXCLUDED_FOR_BDI_GTE_45_ASC',
  ExcludedForBdiGte_45Desc = 'EXCLUDED_FOR_BDI_GTE_45_DESC',
  ExcludedForNoTraumaOrBdiLte_13Asc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_ASC',
  ExcludedForNoTraumaOrBdiLte_13Desc = 'EXCLUDED_FOR_NO_TRAUMA_OR_BDI_LTE_13_DESC',
  ExcludedAsc = 'EXCLUDED_ASC',
  ExcludedDesc = 'EXCLUDED_DESC',
  ExcludedForMissingInterviewAsc = 'EXCLUDED_FOR_MISSING_INTERVIEW_ASC',
  ExcludedForMissingInterviewDesc = 'EXCLUDED_FOR_MISSING_INTERVIEW_DESC',
  ExcludedDuringInterviewAsc = 'EXCLUDED_DURING_INTERVIEW_ASC',
  ExcludedDuringInterviewDesc = 'EXCLUDED_DURING_INTERVIEW_DESC',
  IsSupporterAccountAsc = 'IS_SUPPORTER_ACCOUNT_ASC',
  IsSupporterAccountDesc = 'IS_SUPPORTER_ACCOUNT_DESC',
  IsTesterAccountAsc = 'IS_TESTER_ACCOUNT_ASC',
  IsTesterAccountDesc = 'IS_TESTER_ACCOUNT_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IsCoordinatorAccountAsc = 'IS_COORDINATOR_ACCOUNT_ASC',
  IsCoordinatorAccountDesc = 'IS_COORDINATOR_ACCOUNT_DESC',
  LastLoginAsc = 'LAST_LOGIN_ASC',
  LastLoginDesc = 'LAST_LOGIN_DESC',
  NrOfLoginsAsc = 'NR_OF_LOGINS_ASC',
  NrOfLoginsDesc = 'NR_OF_LOGINS_DESC',
  IsCounselorAccountAsc = 'IS_COUNSELOR_ACCOUNT_ASC',
  IsCounselorAccountDesc = 'IS_COUNSELOR_ACCOUNT_DESC',
  IsCounselingOnlyAsc = 'IS_COUNSELING_ONLY_ASC',
  IsCounselingOnlyDesc = 'IS_COUNSELING_ONLY_DESC',
  RegisteredForCounselingAsc = 'REGISTERED_FOR_COUNSELING_ASC',
  RegisteredForCounselingDesc = 'REGISTERED_FOR_COUNSELING_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}


/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export interface UuidFilter {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['UUID']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: Maybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: Maybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: Maybe<Array<Scalars['UUID']>>;
  /** Not included in the specified list. */
  notIn?: Maybe<Array<Scalars['UUID']>>;
  /** Less than the specified value. */
  lessThan?: Maybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: Maybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: Maybe<Scalars['UUID']>;
}

export interface Wai extends Node {
  __typename?: 'Wai';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
  score?: Maybe<Scalars['BigFloat']>;
  scoreBond?: Maybe<Scalars['BigFloat']>;
  scoreGoal?: Maybe<Scalars['BigFloat']>;
  scoreTask?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `Case` that is related to this `Wai`. */
  caseByCaseId?: Maybe<Case>;
  /** Reads a single `User` that is related to this `Wai`. */
  userBySubmitterId?: Maybe<User>;
}

/** A condition to be used against `Wai` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export interface WaiCondition {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `caseId` field. */
  caseId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `item1` field. */
  item1?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item2` field. */
  item2?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item3` field. */
  item3?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item4` field. */
  item4?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item5` field. */
  item5?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item6` field. */
  item6?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item7` field. */
  item7?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item8` field. */
  item8?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item9` field. */
  item9?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item10` field. */
  item10?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item11` field. */
  item11?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `item12` field. */
  item12?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `score` field. */
  score?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreBond` field. */
  scoreBond?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreGoal` field. */
  scoreGoal?: Maybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `scoreTask` field. */
  scoreTask?: Maybe<Scalars['BigFloat']>;
}

/** A filter to be used against `Wai` object types. All fields are combined with a logical ‘and.’ */
export interface WaiFilter {
  /** Filter by the object’s `id` field. */
  id?: Maybe<UuidFilter>;
  /** Filter by the object’s `caseId` field. */
  caseId?: Maybe<UuidFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: Maybe<UuidFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: Maybe<StringFilter>;
  /** Filter by the object’s `item1` field. */
  item1?: Maybe<IntFilter>;
  /** Filter by the object’s `item2` field. */
  item2?: Maybe<IntFilter>;
  /** Filter by the object’s `item3` field. */
  item3?: Maybe<IntFilter>;
  /** Filter by the object’s `item4` field. */
  item4?: Maybe<IntFilter>;
  /** Filter by the object’s `item5` field. */
  item5?: Maybe<IntFilter>;
  /** Filter by the object’s `item6` field. */
  item6?: Maybe<IntFilter>;
  /** Filter by the object’s `item7` field. */
  item7?: Maybe<IntFilter>;
  /** Filter by the object’s `item8` field. */
  item8?: Maybe<IntFilter>;
  /** Filter by the object’s `item9` field. */
  item9?: Maybe<IntFilter>;
  /** Filter by the object’s `item10` field. */
  item10?: Maybe<IntFilter>;
  /** Filter by the object’s `item11` field. */
  item11?: Maybe<IntFilter>;
  /** Filter by the object’s `item12` field. */
  item12?: Maybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `score` field. */
  score?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreBond` field. */
  scoreBond?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreGoal` field. */
  scoreGoal?: Maybe<BigFloatFilter>;
  /** Filter by the object’s `scoreTask` field. */
  scoreTask?: Maybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<WaiFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<WaiFilter>>;
  /** Negates the expression. */
  not?: Maybe<WaiFilter>;
}

/** An input for mutations affecting `Wai` */
export interface WaiInput {
  id?: Maybe<Scalars['UUID']>;
  caseId: Scalars['UUID'];
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement: Scalars['String'];
  item1: Scalars['Int'];
  item2: Scalars['Int'];
  item3: Scalars['Int'];
  item4: Scalars['Int'];
  item5: Scalars['Int'];
  item6: Scalars['Int'];
  item7: Scalars['Int'];
  item8: Scalars['Int'];
  item9: Scalars['Int'];
  item10: Scalars['Int'];
  item11: Scalars['Int'];
  item12: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  score?: Maybe<Scalars['BigFloat']>;
  scoreBond?: Maybe<Scalars['BigFloat']>;
  scoreGoal?: Maybe<Scalars['BigFloat']>;
  scoreTask?: Maybe<Scalars['BigFloat']>;
}

/** Represents an update to a `Wai`. Fields that are set will be updated. */
export interface WaiPatch {
  id?: Maybe<Scalars['UUID']>;
  caseId?: Maybe<Scalars['UUID']>;
  submitterId?: Maybe<Scalars['UUID']>;
  timeOfMeasurement?: Maybe<Scalars['String']>;
  item1?: Maybe<Scalars['Int']>;
  item2?: Maybe<Scalars['Int']>;
  item3?: Maybe<Scalars['Int']>;
  item4?: Maybe<Scalars['Int']>;
  item5?: Maybe<Scalars['Int']>;
  item6?: Maybe<Scalars['Int']>;
  item7?: Maybe<Scalars['Int']>;
  item8?: Maybe<Scalars['Int']>;
  item9?: Maybe<Scalars['Int']>;
  item10?: Maybe<Scalars['Int']>;
  item11?: Maybe<Scalars['Int']>;
  item12?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  score?: Maybe<Scalars['BigFloat']>;
  scoreBond?: Maybe<Scalars['BigFloat']>;
  scoreGoal?: Maybe<Scalars['BigFloat']>;
  scoreTask?: Maybe<Scalars['BigFloat']>;
}

/** A connection to a list of `Wai` values. */
export interface WaisConnection {
  __typename?: 'WaisConnection';
  /** A list of `Wai` objects. */
  nodes: Array<Wai>;
  /** A list of edges which contains the `Wai` and cursor to aid in pagination. */
  edges: Array<WaisEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Wai` you could get from the connection. */
  totalCount: Scalars['Int'];
}

/** A `Wai` edge in the connection. */
export interface WaisEdge {
  __typename?: 'WaisEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Wai` at the end of the edge. */
  node: Wai;
}

/** Methods to use when ordering `Wai`. */
export enum WaisOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CaseIdAsc = 'CASE_ID_ASC',
  CaseIdDesc = 'CASE_ID_DESC',
  SubmitterIdAsc = 'SUBMITTER_ID_ASC',
  SubmitterIdDesc = 'SUBMITTER_ID_DESC',
  TimeOfMeasurementAsc = 'TIME_OF_MEASUREMENT_ASC',
  TimeOfMeasurementDesc = 'TIME_OF_MEASUREMENT_DESC',
  Item_1Asc = 'ITEM_1_ASC',
  Item_1Desc = 'ITEM_1_DESC',
  Item_2Asc = 'ITEM_2_ASC',
  Item_2Desc = 'ITEM_2_DESC',
  Item_3Asc = 'ITEM_3_ASC',
  Item_3Desc = 'ITEM_3_DESC',
  Item_4Asc = 'ITEM_4_ASC',
  Item_4Desc = 'ITEM_4_DESC',
  Item_5Asc = 'ITEM_5_ASC',
  Item_5Desc = 'ITEM_5_DESC',
  Item_6Asc = 'ITEM_6_ASC',
  Item_6Desc = 'ITEM_6_DESC',
  Item_7Asc = 'ITEM_7_ASC',
  Item_7Desc = 'ITEM_7_DESC',
  Item_8Asc = 'ITEM_8_ASC',
  Item_8Desc = 'ITEM_8_DESC',
  Item_9Asc = 'ITEM_9_ASC',
  Item_9Desc = 'ITEM_9_DESC',
  Item_10Asc = 'ITEM_10_ASC',
  Item_10Desc = 'ITEM_10_DESC',
  Item_11Asc = 'ITEM_11_ASC',
  Item_11Desc = 'ITEM_11_DESC',
  Item_12Asc = 'ITEM_12_ASC',
  Item_12Desc = 'ITEM_12_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  ScoreBondAsc = 'SCORE_BOND_ASC',
  ScoreBondDesc = 'SCORE_BOND_DESC',
  ScoreGoalAsc = 'SCORE_GOAL_ASC',
  ScoreGoalDesc = 'SCORE_GOAL_DESC',
  ScoreTaskAsc = 'SCORE_TASK_ASC',
  ScoreTaskDesc = 'SCORE_TASK_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CaseMessageNodeFragment = (
  { __typename?: 'CaseMessage' }
  & Pick<CaseMessage, 'id' | 'caseId' | 'body' | 'createdAt' | 'senderId' | 'sentAt' | 'subject' | 'toInterviewers' | 'toPatients' | 'toSupervisors' | 'toTherapists' | 'toSupporters' | 'toCounselors' | 'updatedAt' | 'fromSystem' | 'isUnread'>
  & { case?: Maybe<(
    { __typename?: 'Case' }
    & { myInvolvement?: Maybe<(
      { __typename?: 'MyInvolvement' }
      & Pick<MyInvolvement, 'id' | 'favoriteMessage'>
    )> }
  )>, sender?: Maybe<(
    { __typename?: 'CaseMember' }
    & ReturnCaseMemberFragment
  )> }
);

export type AllMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMessagesQuery = (
  { __typename?: 'Query' }
  & { caseMessages?: Maybe<(
    { __typename?: 'CaseMessagesConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type AllMessagesAfterQueryVariables = Exact<{
  timestamp: Scalars['Datetime'];
}>;


export type AllMessagesAfterQuery = (
  { __typename?: 'Query' }
  & { caseMessages?: Maybe<(
    { __typename?: 'CaseMessagesConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type AllMessagesInCaseQueryVariables = Exact<{
  caseId: Scalars['UUID'];
}>;


export type AllMessagesInCaseQuery = (
  { __typename?: 'Query' }
  & { caseMessages?: Maybe<(
    { __typename?: 'CaseMessagesConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type AllMessagesInCaseAfterQueryVariables = Exact<{
  caseId: Scalars['UUID'];
  timestamp: Scalars['Datetime'];
}>;


export type AllMessagesInCaseAfterQuery = (
  { __typename?: 'Query' }
  & { caseMessages?: Maybe<(
    { __typename?: 'CaseMessagesConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type CreateCaseMessageMutationVariables = Exact<{
  message: CaseMessageInput;
}>;


export type CreateCaseMessageMutation = (
  { __typename?: 'Mutation' }
  & { createCaseMessage?: Maybe<(
    { __typename?: 'CreateCaseMessagePayload' }
    & { caseMessage?: Maybe<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type UpdateCaseMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: CaseMessagePatch;
}>;


export type UpdateCaseMessageMutation = (
  { __typename?: 'Mutation' }
  & { updateCaseMessageById?: Maybe<(
    { __typename?: 'UpdateCaseMessagePayload' }
    & { caseMessage?: Maybe<(
      { __typename?: 'CaseMessage' }
      & CaseMessageNodeFragment
    )> }
  )> }
);

export type DeleteCaseMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCaseMessageMutation = (
  { __typename?: 'Mutation' }
  & { deleteCaseMessageById?: Maybe<(
    { __typename?: 'DeleteCaseMessagePayload' }
    & Pick<DeleteCaseMessagePayload, 'deletedCaseMessageId'>
    & { caseMessage?: Maybe<(
      { __typename?: 'CaseMessage' }
      & Pick<CaseMessage, 'id' | 'caseId'>
    )> }
  )> }
);

export type CaseNodeFragment = (
  { __typename?: 'Case' }
  & Pick<Case, 'id' | 'shortId' | 'askForPostIfDroppedOut' | 'createdAt' | 'description' | 'diagnosis' | 'emergencyContact' | 'isDropout' | 'title' | 'updatedAt' | 'newMessages' | 'latestMessage' | 'excludeFromAnalysis' | 'reasonForExclusion' | 'stage'>
  & { myDates: (
    { __typename?: 'MyDatesConnection' }
    & { nodes: Array<(
      { __typename?: 'MyDate' }
      & Pick<MyDate, 'name' | 'timestamp'>
    )> }
  ), me?: Maybe<(
    { __typename?: 'CaseMember' }
    & ReturnCaseMemberFragment
  )>, myInvolvement?: Maybe<(
    { __typename?: 'MyInvolvement' }
    & Pick<MyInvolvement, 'id' | 'newMessagesAfter' | 'favoriteMessage'>
  )>, patient?: Maybe<(
    { __typename?: 'CaseMember' }
    & Pick<CaseMember, 'excluded' | 'excludedForBdiGte45' | 'excludedForLackOfEmail' | 'excludedForLackOfInternetAccess' | 'excludedDuringInterview' | 'excludedForMissingInterview' | 'excludedForMinorAge' | 'excludedForNoTraumaOrBdiLte13' | 'excludedForUpcomingTreatment' | 'isCounselingOnly' | 'registeredForCounseling'>
    & ReturnCaseMemberFragment
  )>, members: (
    { __typename?: 'CaseMembersConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMember' }
      & ReturnCaseMemberFragment
    )> }
  ), others: (
    { __typename?: 'CaseMembersConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseMember' }
      & ReturnCaseMemberFragment
    )> }
  ) }
);

export type AllCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCasesQuery = (
  { __typename?: 'Query' }
  & { cases?: Maybe<(
    { __typename?: 'CasesConnection' }
    & { nodes: Array<(
      { __typename?: 'Case' }
      & CaseNodeFragment
    )> }
  )> }
);

export type MessageNodeFragment = (
  { __typename?: 'CaseMessage' }
  & Pick<CaseMessage, 'id' | 'toInterviewers' | 'toTherapists' | 'toPatients' | 'toSupervisors' | 'toSupporters' | 'toCounselors' | 'body' | 'sentAt' | 'fromSystem' | 'subject'>
  & { sender?: Maybe<(
    { __typename?: 'CaseMember' }
    & Pick<CaseMember, 'userId' | 'alias' | 'username' | 'actsAsInterviewer' | 'actsAsTherapist' | 'actsAsSupervisor' | 'actsAsSupporter' | 'actsAsPatient' | 'actsAsCounselor'>
  )> }
);

export type SuicideCallNodeFragment = (
  { __typename?: 'CaseSuicideCall' }
  & Pick<CaseSuicideCall, 'id' | 'callDate' | 'caseId' | 'coordinatorContactDate' | 'createdAt' | 'detailedDescription' | 'excludePatient' | 'followUpContact' | 'followUpDescription' | 'followUpDate' | 'informCoordinator' | 'patientReached' | 'riskOfSuicide' | 'suicideScore' | 'userIdCoordinator'>
  & { userByUserIdCaller?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'alias' | 'username'>
  )> }
);

export type UpdateCaseMessageByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: CaseMessagePatch;
}>;


export type UpdateCaseMessageByIdMutation = (
  { __typename?: 'Mutation' }
  & { message?: Maybe<(
    { __typename?: 'UpdateCaseMessagePayload' }
    & { caseMessage?: Maybe<(
      { __typename?: 'CaseMessage' }
      & MessageNodeFragment
    )> }
  )> }
);

export type DeleteCaseMessageByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCaseMessageByIdMutation = (
  { __typename?: 'Mutation' }
  & { message?: Maybe<(
    { __typename?: 'DeleteCaseMessagePayload' }
    & { caseMessage?: Maybe<(
      { __typename?: 'CaseMessage' }
      & MessageNodeFragment
    )> }
  )> }
);

export type UpdateNewMessagesOfterOfInvolvementMutationVariables = Exact<{
  id: Scalars['UUID'];
  after: Scalars['Datetime'];
}>;


export type UpdateNewMessagesOfterOfInvolvementMutation = (
  { __typename?: 'Mutation' }
  & { updateInvolvementById?: Maybe<(
    { __typename?: 'UpdateInvolvementPayload' }
    & { involvement?: Maybe<(
      { __typename?: 'Involvement' }
      & Pick<Involvement, 'id' | 'newMessagesAfter'>
    )> }
  )> }
);

export type UpdateFavoriteMessageOfInvolvementMutationVariables = Exact<{
  id: Scalars['UUID'];
  favoriteMessage?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateFavoriteMessageOfInvolvementMutation = (
  { __typename?: 'Mutation' }
  & { updateInvolvementById?: Maybe<(
    { __typename?: 'UpdateInvolvementPayload' }
    & { involvement?: Maybe<(
      { __typename?: 'Involvement' }
      & Pick<Involvement, 'id' | 'favoriteMessage'>
    )> }
  )> }
);

export type CaseListWithMessageCountsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type CaseListWithMessageCountsQuery = (
  { __typename?: 'Query' }
  & { cases?: Maybe<(
    { __typename?: 'CasesConnection' }
    & { nodes: Array<(
      { __typename?: 'Case' }
      & Pick<Case, 'id' | 'shortId' | 'latestMessage'>
      & { newMessages: Case['newMessagesForMe'], similarity: Case['matches'] }
      & { me?: Maybe<(
        { __typename?: 'CaseMember' }
        & Pick<CaseMember, 'userId'>
      )>, myInvolvement?: Maybe<(
        { __typename?: 'MyInvolvement' }
        & Pick<MyInvolvement, 'id' | 'newMessagesAfter'>
      )>, patient?: Maybe<(
        { __typename?: 'CaseMember' }
        & Pick<CaseMember, 'gender' | 'userId' | 'username' | 'alias' | 'phone' | 'isCounselingOnly' | 'registeredForCounseling'>
      )> }
    )> }
  )> }
);

export type CaseWithMessagesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CaseWithMessagesQuery = (
  { __typename?: 'Query' }
  & { pickedCase?: Maybe<(
    { __typename?: 'Case' }
    & Pick<Case, 'id' | 'excludeFromAnalysis' | 'diagnosis' | 'reasonForExclusion'>
    & { patient?: Maybe<(
      { __typename?: 'CaseMember' }
      & Pick<CaseMember, 'gender' | 'userId' | 'username' | 'alias' | 'phone' | 'isCounselingOnly' | 'registeredForCounseling'>
    )>, me?: Maybe<(
      { __typename?: 'CaseMember' }
      & Pick<CaseMember, 'actsAsPatient'>
    )>, myInvolvement?: Maybe<(
      { __typename?: 'MyInvolvement' }
      & Pick<MyInvolvement, 'id' | 'favoriteMessage'>
    )>, members: (
      { __typename?: 'CaseMembersConnection' }
      & { nodes: Array<(
        { __typename?: 'CaseMember' }
        & Pick<CaseMember, 'userId' | 'alias' | 'actsAsInterviewer' | 'actsAsPatient' | 'actsAsSupervisor' | 'actsAsSupporter' | 'actsAsTherapist' | 'actsAsCounselor'>
      )> }
    ), treatmentAssignments: (
      { __typename?: 'RandomizationTicketsConnection' }
      & { nodes: Array<(
        { __typename?: 'RandomizationTicket' }
        & Pick<RandomizationTicket, 'id' | 'assignedAt' | 'treatment'>
      )> }
    ), unsentMessages: (
      { __typename?: 'CaseMessagesConnection' }
      & { nodes: Array<(
        { __typename?: 'CaseMessage' }
        & MessageNodeFragment
      )> }
    ), sentMessages: (
      { __typename?: 'CaseMessagesConnection' }
      & { nodes: Array<(
        { __typename?: 'CaseMessage' }
        & MessageNodeFragment
      )> }
    ) }
  )> }
);

export type ShortPagedCasesQueryVariables = Exact<{
  filterUnassigned?: Scalars['Boolean'];
  search?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  first?: Scalars['Int'];
  offset?: Scalars['Int'];
}>;


export type ShortPagedCasesQuery = (
  { __typename?: 'Query' }
  & { cases?: Maybe<(
    { __typename?: 'CasesConnection' }
    & { nodes: Array<(
      { __typename?: 'Case' }
      & CaseNodeFragment
    )> }
  )> }
);

export type PagedCasesQueryVariables = Exact<{
  filterUnassigned?: Scalars['Boolean'];
  search?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  first?: Scalars['Int'];
  offset?: Scalars['Int'];
}>;


export type PagedCasesQuery = (
  { __typename?: 'Query' }
  & { cases?: Maybe<(
    { __typename?: 'CasesConnection' }
    & { nodes: Array<(
      { __typename?: 'Case' }
      & { taskStatsOfPatients?: Maybe<(
        { __typename?: 'CasesDueTaskStatsRecord' }
        & Pick<CasesDueTaskStatsRecord, 'countOfOpen' | 'latestCreated' | 'latestDue'>
      )>, taskStatsOfTherapists?: Maybe<(
        { __typename?: 'CasesDueTaskStatsRecord' }
        & Pick<CasesDueTaskStatsRecord, 'countOfOpen' | 'latestCreated' | 'latestDue' | 'countOfOverdue'>
      )>, nextWatingTimer: (
        { __typename?: 'MyDatesConnection' }
        & { nodes: Array<(
          { __typename?: 'MyDate' }
          & Pick<MyDate, 'id' | 'name' | 'timestamp'>
        )> }
      ), treatmentAssignments: (
        { __typename?: 'RandomizationTicketsConnection' }
        & { nodes: Array<(
          { __typename?: 'RandomizationTicket' }
          & Pick<RandomizationTicket, 'id' | 'assignedAt' | 'treatment'>
        )> }
      ), therapists: (
        { __typename?: 'CaseMembersConnection' }
        & { nodes: Array<(
          { __typename?: 'CaseMember' }
          & ReturnCaseMemberFragment
        )> }
      ), counselors: (
        { __typename?: 'CaseMembersConnection' }
        & { nodes: Array<(
          { __typename?: 'CaseMember' }
          & ReturnCaseMemberFragment
        )> }
      ), interviewers: (
        { __typename?: 'CaseMembersConnection' }
        & { nodes: Array<(
          { __typename?: 'CaseMember' }
          & ReturnCaseMemberFragment
        )> }
      ), suicideItems: (
        { __typename?: 'Phq9SConnection' }
        & { nodes: Array<(
          { __typename?: 'Phq9' }
          & Pick<Phq9, 'id' | 'timeOfMeasurement' | 'createdAt'>
          & { value: Phq9['item9'] }
        )> }
      ) }
      & CaseNodeFragment
    )> }
  )> }
);

export type SuicideCallsQueryVariables = Exact<{
  caseId?: Maybe<Scalars['UUID']>;
}>;


export type SuicideCallsQuery = (
  { __typename?: 'Query' }
  & { allCaseSuicideCalls?: Maybe<(
    { __typename?: 'CaseSuicideCallsConnection' }
    & { nodes: Array<(
      { __typename?: 'CaseSuicideCall' }
      & Pick<CaseSuicideCall, 'callDate' | 'caseId' | 'coordinatorContactDate' | 'createdAt' | 'detailedDescription' | 'excludePatient' | 'followUpContact' | 'id' | 'followUpDescription' | 'followUpDate' | 'informCoordinator' | 'patientReached' | 'riskOfSuicide' | 'suicideScore' | 'userIdCaller' | 'userIdCoordinator'>
      & { userByUserIdCaller?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'alias' | 'username'>
      )> }
    )> }
  )> }
);

export type InsertSuicideCallMutationMutationVariables = Exact<{
  patch: CaseSuicideCallInput;
}>;


export type InsertSuicideCallMutationMutation = (
  { __typename?: 'Mutation' }
  & { createCaseSuicideCall?: Maybe<(
    { __typename?: 'CreateCaseSuicideCallPayload' }
    & { caseSuicideCall?: Maybe<(
      { __typename?: 'CaseSuicideCall' }
      & SuicideCallNodeFragment
    )> }
  )> }
);

export type UpdateSuicideCallMutationMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: CaseSuicideCallPatch;
}>;


export type UpdateSuicideCallMutationMutation = (
  { __typename?: 'Mutation' }
  & { updateCaseSuicideCallById?: Maybe<(
    { __typename?: 'UpdateCaseSuicideCallPayload' }
    & { caseSuicideCall?: Maybe<(
      { __typename?: 'CaseSuicideCall' }
      & SuicideCallNodeFragment
    )> }
  )> }
);

export type AllCoordinatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCoordinatorsQuery = (
  { __typename?: 'Query' }
  & { allCoordinatorUsers?: Maybe<(
    { __typename?: 'CoordinatorUsersConnection' }
    & { nodes: Array<(
      { __typename?: 'CoordinatorUser' }
      & Pick<CoordinatorUser, 'alias' | 'email' | 'id' | 'username'>
    )> }
  )> }
);

export type DetailedCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetailedCasesQuery = (
  { __typename?: 'Query' }
  & { cases?: Maybe<(
    { __typename?: 'CasesConnection' }
    & { nodes: Array<(
      { __typename?: 'Case' }
      & { gad7SByCaseId: (
        { __typename?: 'Gad7SConnection' }
        & { nodes: Array<(
          { __typename?: 'Gad7' }
          & Pick<Gad7, 'score' | 'timeOfMeasurement'>
        )> }
      ), phq9SByCaseId: (
        { __typename?: 'Phq9SConnection' }
        & { nodes: Array<(
          { __typename?: 'Phq9' }
          & Pick<Phq9, 'score' | 'timeOfMeasurement'>
        )> }
      ), phq4SByCaseId: (
        { __typename?: 'Phq4SConnection' }
        & { nodes: Array<(
          { __typename?: 'Phq4' }
          & Pick<Phq4, 'score' | 'timeOfMeasurement'>
        )> }
      ), scalingsByCaseId: (
        { __typename?: 'ScalingsConnection' }
        & { nodes: Array<(
          { __typename?: 'Scaling' }
          & Pick<Scaling, 'score' | 'timeOfMeasurement'>
        )> }
      ), counselingQuestionsByCaseId: (
        { __typename?: 'CounselingQuestionsConnection' }
        & { nodes: Array<(
          { __typename?: 'CounselingQuestion' }
          & Pick<CounselingQuestion, 'step' | 'timeOfMeasurement' | 'mainProblem' | 'effectsOnDailyLife' | 'expectedResult' | 'solutionProgress' | 'contactVia'>
        )> }
      ) }
      & CaseNodeFragment
    )> }
  )> }
);

export type ReturnCaseMemberFragment = (
  { __typename?: 'CaseMember' }
  & Pick<CaseMember, 'actsAsInterviewer' | 'actsAsPatient' | 'actsAsSupervisor' | 'actsAsTherapist' | 'actsAsSupporter' | 'actsAsCounselor' | 'alias' | 'caseId' | 'userId' | 'gender' | 'phone' | 'email' | 'username' | 'createdAt' | 'nrOfLogins' | 'lastLogin'>
);

export type InterviewCalendarQueryVariables = Exact<{
  fromDatetime: Scalars['Datetime'];
  tilDatetime: Scalars['Datetime'];
}>;


export type InterviewCalendarQuery = (
  { __typename?: 'Query' }
  & { items?: Maybe<(
    { __typename?: 'InterviewAndCallCalendarsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewAndCallCalendar' }
      & Pick<InterviewAndCallCalendar, 'accepted' | 'bookedAt' | 'caseId' | 'hasTakenPlace' | 'interviewerUsername' | 'isPast' | 'offerId' | 'offerIsCanceled' | 'startsAt' | 'counseling' | 'isSuicideCall' | 'isFollowupCall' | 'bookingIsCanceled' | 'bookingCanceledAt' | 'isPost'>
    )> }
  )> }
);

export type UpdateNewMessagesAfterMutationVariables = Exact<{
  id: Scalars['UUID'];
  timestamp: Scalars['Datetime'];
}>;


export type UpdateNewMessagesAfterMutation = (
  { __typename?: 'Mutation' }
  & { updateInvolvementById?: Maybe<(
    { __typename?: 'UpdateInvolvementPayload' }
    & { involvement?: Maybe<(
      { __typename?: 'Involvement' }
      & Pick<Involvement, 'newMessagesAfter' | 'id'>
    )> }
  )> }
);

export type UpdateFavoriteMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
  favoriteMessage: Scalars['Boolean'];
}>;


export type UpdateFavoriteMessageMutation = (
  { __typename?: 'Mutation' }
  & { updateInvolvementById?: Maybe<(
    { __typename?: 'UpdateInvolvementPayload' }
    & { involvement?: Maybe<(
      { __typename?: 'Involvement' }
      & Pick<Involvement, 'favoriteMessage' | 'id'>
    )> }
  )> }
);

export type TaskNodeFragment = (
  { __typename?: 'MyTaskLog' }
  & Pick<MyTaskLog, 'assignee' | 'caseId' | 'deleteReason' | 'description' | 'due' | 'duration' | 'endTime' | 'formFields' | 'id' | 'localVariables' | 'name' | 'priority' | 'processDefinitionKey' | 'processInstanceId' | 'roles' | 'startTime' | 'taskDefinitionKey' | 'amICandidating'>
  & { case?: Maybe<(
    { __typename?: 'Case' }
    & CaseNodeFragment
  )>, candidates: (
    { __typename?: 'MyHistoricIdentitylinksConnection' }
    & { nodes: Array<(
      { __typename?: 'MyHistoricIdentitylink' }
      & Pick<MyHistoricIdentitylink, 'userId'>
      & { caseMember?: Maybe<(
        { __typename?: 'CaseMember' }
        & Pick<CaseMember, 'alias'>
      )> }
    )> }
  ) }
);

export type ShortTaskNodeFragment = (
  { __typename?: 'DueTask' }
  & Pick<DueTask, 'id' | 'name' | 'taskDefinitionKey' | 'processInstanceId' | 'assignee' | 'due' | 'caseId'>
  & { case?: Maybe<(
    { __typename?: 'Case' }
    & CaseNodeFragment
  )>, candidates: (
    { __typename?: 'DueCandidateLinksConnection' }
    & { nodes: Array<(
      { __typename?: 'DueCandidateLink' }
      & Pick<DueCandidateLink, 'userId'>
      & { caseMember?: Maybe<(
        { __typename?: 'CaseMember' }
        & Pick<CaseMember, 'alias'>
      )> }
    )> }
  ) }
);

export type AllActiveTasksQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<DueTasksOrderBy>>;
}>;


export type AllActiveTasksQuery = (
  { __typename?: 'Query' }
  & { activeTasks?: Maybe<(
    { __typename?: 'DueTasksConnection' }
    & { nodes: Array<(
      { __typename?: 'DueTask' }
      & ShortTaskNodeFragment
    )> }
  )> }
);

export type SpecificActiveTaskQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type SpecificActiveTaskQuery = (
  { __typename?: 'Query' }
  & { tasks?: Maybe<(
    { __typename?: 'MyTaskLogsConnection' }
    & { nodes: Array<(
      { __typename?: 'MyTaskLog' }
      & TaskNodeFragment
    )> }
  )> }
);

export type InterviewerEntersRoomTaskQueryVariables = Exact<{
  caseId: Scalars['UUID'];
  processInstanceId: Scalars['String'];
}>;


export type InterviewerEntersRoomTaskQuery = (
  { __typename?: 'Query' }
  & { tasks?: Maybe<(
    { __typename?: 'MyTaskLogsConnection' }
    & { nodes: Array<(
      { __typename?: 'MyTaskLog' }
      & TaskNodeFragment
    )> }
  )> }
);

export type MyActiveTasksQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<DueTasksOrderBy>>;
}>;


export type MyActiveTasksQuery = (
  { __typename?: 'Query' }
  & { activeTasks?: Maybe<(
    { __typename?: 'DueTasksConnection' }
    & { nodes: Array<(
      { __typename?: 'DueTask' }
      & ShortTaskNodeFragment
    )> }
  )> }
);

export type UpdateProfileMutationVariables = Exact<{
  userId: Scalars['UUID'];
  alias: Scalars['String'];
  email: Scalars['String'];
}>;


export type UpdateProfileMutation = (
  { __typename?: 'Mutation' }
  & { profile?: Maybe<(
    { __typename?: 'UpdateUserPayload' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'alias' | 'email'>
    )> }
  )> }
);

export type ReturnOfferFragment = (
  { __typename?: 'InterviewOffer' }
  & Pick<InterviewOffer, 'id' | 'canceled' | 'canceledAt' | 'externalLink' | 'hasTakenPlace' | 'interviewerId' | 'upcoming' | 'present' | 'soon' | 'past'>
  & { post: InterviewOffer['isPost'] }
  & { interviewer?: Maybe<(
    { __typename?: 'Interviewer' }
    & Pick<Interviewer, 'id' | 'username' | 'gender'>
  )>, timeSlot: (
    { __typename?: 'DatetimeRange' }
    & { start?: Maybe<(
      { __typename?: 'DatetimeRangeBound' }
      & Pick<DatetimeRangeBound, 'value' | 'inclusive'>
    )>, end?: Maybe<(
      { __typename?: 'DatetimeRangeBound' }
      & Pick<DatetimeRangeBound, 'value' | 'inclusive'>
    )> }
  ) }
);

export type ReturnReportFragment = (
  { __typename?: 'InterviewReport' }
  & Pick<InterviewReport, 'id'>
);

export type ReturnBookingFragment = (
  { __typename?: 'InterviewBooking' }
  & Pick<InterviewBooking, 'id' | 'canceled' | 'canceledAt' | 'caseId' | 'createdAt' | 'intervieweeId'>
  & { interviewee?: Maybe<(
    { __typename?: 'Interviewee' }
    & Pick<Interviewee, 'id' | 'username' | 'gender'>
  )>, offer?: Maybe<(
    { __typename?: 'InterviewOffer' }
    & ReturnOfferFragment
  )>, reports: (
    { __typename?: 'InterviewReportsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewReport' }
      & ReturnReportFragment
    )> }
  ) }
);

export type IncludeBookingsFragment = (
  { __typename?: 'InterviewOffer' }
  & { activeBookings: (
    { __typename?: 'InterviewBookingsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewBooking' }
      & ReturnBookingFragment
    )> }
  ), canceledBookings: (
    { __typename?: 'InterviewBookingsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewBooking' }
      & ReturnBookingFragment
    )> }
  ) }
);

export type AvailableInterviewDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableInterviewDatesQuery = (
  { __typename?: 'Query' }
  & { availableDates?: Maybe<(
    { __typename?: 'AvailableInterviewDatesConnection' }
    & { nodes: Array<(
      { __typename?: 'AvailableInterviewDate' }
      & Pick<AvailableInterviewDate, 'id' | 'gender'>
      & { timeSlot?: Maybe<(
        { __typename?: 'DatetimeRange' }
        & { start?: Maybe<(
          { __typename?: 'DatetimeRangeBound' }
          & Pick<DatetimeRangeBound, 'value'>
        )> }
      )> }
    )> }
  )> }
);

export type InterviewBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewBookingsQuery = (
  { __typename?: 'Query' }
  & { bookings?: Maybe<(
    { __typename?: 'InterviewBookingsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewBooking' }
      & ReturnBookingFragment
    )> }
  )> }
);

export type InterviewOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewOffersQuery = (
  { __typename?: 'Query' }
  & { offers?: Maybe<(
    { __typename?: 'InterviewOffersConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewOffer' }
      & ReturnOfferFragment
      & IncludeBookingsFragment
    )> }
  )> }
);

export type BookInterviewMutationVariables = Exact<{
  offerId: Scalars['UUID'];
  caseId: Scalars['UUID'];
}>;


export type BookInterviewMutation = (
  { __typename?: 'Mutation' }
  & { created?: Maybe<(
    { __typename?: 'BookInterviewPayload' }
    & { result?: Maybe<(
      { __typename?: 'BookInterviewRecord' }
      & { booking?: Maybe<(
        { __typename?: 'InterviewBooking' }
        & ReturnBookingFragment
      )> }
    )> }
  )> }
);

export type CancelInterviewBookingMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CancelInterviewBookingMutation = (
  { __typename?: 'Mutation' }
  & { updated?: Maybe<(
    { __typename?: 'CancelInterviewBookingByIdPayload' }
    & { result?: Maybe<(
      { __typename?: 'CancelInterviewBookingByIdRecord' }
      & { booking?: Maybe<(
        { __typename?: 'InterviewBooking' }
        & ReturnBookingFragment
      )> }
    )> }
  )> }
);

export type SetExternalLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
  link?: Maybe<Scalars['String']>;
}>;


export type SetExternalLinkMutation = (
  { __typename?: 'Mutation' }
  & { updateInterviewOfferById?: Maybe<(
    { __typename?: 'UpdateInterviewOfferPayload' }
    & { interviewOffer?: Maybe<(
      { __typename?: 'InterviewOffer' }
      & ReturnOfferFragment
      & IncludeBookingsFragment
    )> }
  )> }
);

export type AdoptOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdoptOfferMutation = (
  { __typename?: 'Mutation' }
  & { updated?: Maybe<(
    { __typename?: 'AdoptInterviewOfferByIdPayload' }
    & { result?: Maybe<(
      { __typename?: 'AdoptInterviewOfferByIdRecord' }
      & { offer?: Maybe<(
        { __typename?: 'InterviewOffer' }
        & ReturnOfferFragment
        & IncludeBookingsFragment
      )> }
    )> }
  )> }
);

export type CancelOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CancelOfferMutation = (
  { __typename?: 'Mutation' }
  & { updated?: Maybe<(
    { __typename?: 'CancelInterviewOfferByIdPayload' }
    & { result?: Maybe<(
      { __typename?: 'CancelInterviewOfferByIdRecord' }
      & { offer?: Maybe<(
        { __typename?: 'InterviewOffer' }
        & ReturnOfferFragment
        & IncludeBookingsFragment
      )> }
    )> }
  )> }
);

export type UncancelOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UncancelOfferMutation = (
  { __typename?: 'Mutation' }
  & { updatesFrom?: Maybe<(
    { __typename?: 'UncancelInterviewOfferByIdPayload' }
    & { result?: Maybe<(
      { __typename?: 'UncancelInterviewOfferByIdRecord' }
      & { offer?: Maybe<(
        { __typename?: 'InterviewOffer' }
        & ReturnOfferFragment
        & IncludeBookingsFragment
      )> }
    )> }
  )> }
);

export type CreateOfferMutationVariables = Exact<{
  startsAt: Scalars['Datetime'];
  endsAt: Scalars['Datetime'];
  interviewerId: Scalars['UUID'];
}>;


export type CreateOfferMutation = (
  { __typename?: 'Mutation' }
  & { created?: Maybe<(
    { __typename?: 'CreateInterviewOfferPayload' }
    & { offer?: Maybe<(
      { __typename?: 'InterviewOffer' }
      & ReturnOfferFragment
      & IncludeBookingsFragment
    )> }
  )> }
);

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
  updates: InterviewOfferPatch;
}>;


export type UpdateOfferMutation = (
  { __typename?: 'Mutation' }
  & { updateInterviewOfferById?: Maybe<(
    { __typename?: 'UpdateInterviewOfferPayload' }
    & { offer?: Maybe<(
      { __typename?: 'InterviewOffer' }
      & ReturnOfferFragment
      & IncludeBookingsFragment
    )> }
  )> }
);

export type RescheduleOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
  newDate: InterviewOfferPatch;
}>;


export type RescheduleOfferMutation = (
  { __typename?: 'Mutation' }
  & { updated?: Maybe<(
    { __typename?: 'UpdateInterviewOfferPayload' }
    & { offer?: Maybe<(
      { __typename?: 'InterviewOffer' }
      & ReturnOfferFragment
      & IncludeBookingsFragment
    )> }
  )> }
);

export type QueryBookingInfoByCaseIdQueryVariables = Exact<{
  caseId: Scalars['UUID'];
}>;


export type QueryBookingInfoByCaseIdQuery = (
  { __typename?: 'Query' }
  & { bookings?: Maybe<(
    { __typename?: 'InterviewBookingsConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewBooking' }
      & Pick<InterviewBooking, 'id' | 'caseId' | 'offerId'>
      & { interviewOfferByOfferId?: Maybe<(
        { __typename?: 'InterviewOffer' }
        & Pick<InterviewOffer, 'hasTakenPlace' | 'isPost' | 'id'>
        & { interviewerByInterviewerId?: Maybe<(
          { __typename?: 'Interviewer' }
          & Pick<Interviewer, 'username' | 'id'>
        )>, timeSlot: (
          { __typename?: 'DatetimeRange' }
          & { start?: Maybe<(
            { __typename?: 'DatetimeRangeBound' }
            & Pick<DatetimeRangeBound, 'value' | 'inclusive'>
          )>, end?: Maybe<(
            { __typename?: 'DatetimeRangeBound' }
            & Pick<DatetimeRangeBound, 'value' | 'inclusive'>
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type CaseDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CaseDetailsQuery = (
  { __typename?: 'Query' }
  & { caseReport?: Maybe<(
    { __typename?: 'Case' }
    & Pick<Case, 'id' | 'shortId' | 'emergencyContact'>
    & { patient?: Maybe<(
      { __typename?: 'CaseMember' }
      & Pick<CaseMember, 'gender' | 'userId' | 'username' | 'alias' | 'phone' | 'createdAt' | 'nrOfLogins' | 'lastLogin' | 'agreedToAntiSuicideContractAt' | 'isCounselingOnly' | 'registeredForCounseling'>
    )>, comments: (
      { __typename?: 'CommentsConnection' }
      & { nodes: Array<(
        { __typename?: 'Comment' }
        & Pick<Comment, 'id' | 'body' | 'createdAt'>
      )> }
    ), demographics: (
      { __typename?: 'DemographicsConnection' }
      & { nodes: Array<(
        { __typename?: 'Demographic' }
        & Pick<Demographic, 'gender' | 'age' | 'countryOfOrigin' | 'countryOfResidence'>
      )> }
    ), interviewReports: (
      { __typename?: 'InterviewReportsConnection' }
      & { nodes: Array<(
        { __typename?: 'InterviewReport' }
        & Pick<InterviewReport, 'id'>
      )> }
    ), phq9Assessments: (
      { __typename?: 'Phq9SConnection' }
      & { nodes: Array<(
        { __typename?: 'Phq9' }
        & Pick<Phq9, 'id' | 'item1' | 'item2' | 'item3' | 'item4' | 'item5' | 'item6' | 'item7' | 'item8' | 'item9' | 'itemSeverity' | 'createdAt' | 'timeOfMeasurement' | 'score'>
      )> }
    ), phq4Assessments: (
      { __typename?: 'Phq4SConnection' }
      & { nodes: Array<(
        { __typename?: 'Phq4' }
        & Pick<Phq4, 'id' | 'item1' | 'item2' | 'item3' | 'item4' | 'createdAt' | 'timeOfMeasurement' | 'scoreDepression' | 'scoreFear' | 'score'>
      )> }
    ), scalings: (
      { __typename?: 'ScalingsConnection' }
      & { nodes: Array<(
        { __typename?: 'Scaling' }
        & Pick<Scaling, 'id' | 'timeOfMeasurement' | 'score' | 'createdAt'>
      )> }
    ), counselingQuestions: (
      { __typename?: 'CounselingQuestionsConnection' }
      & { nodes: Array<(
        { __typename?: 'CounselingQuestion' }
        & Pick<CounselingQuestion, 'id' | 'step' | 'timeOfMeasurement' | 'mainProblem' | 'effectsOnDailyLife' | 'expectedResult' | 'solutionProgress' | 'createdAt' | 'contactVia'>
      )> }
    ), letters: (
      { __typename?: 'LettersConnection' }
      & { nodes: Array<(
        { __typename?: 'Letter' }
        & Pick<Letter, 'id' | 'publishedAt' | 'createdAt' | 'body' | 'code'>
        & { sender?: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'username' | 'alias'>
        )> }
      )> }
    ) }
  )> }
);

export type CaseLogsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CaseLogsQuery = (
  { __typename?: 'Query' }
  & { logs?: Maybe<(
    { __typename?: 'ProcessLogsConnection' }
    & { nodes: Array<(
      { __typename?: 'ProcessLog' }
      & Pick<ProcessLog, 'processInstanceId' | 'processKey' | 'taskId' | 'taskName' | 'startedAt' | 'endedAt'>
    )> }
  )> }
);

export type CaseLogsForInterviewReportQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CaseLogsForInterviewReportQuery = (
  { __typename?: 'Query' }
  & { logs?: Maybe<(
    { __typename?: 'ProcessLogsConnection' }
    & { nodes: Array<(
      { __typename?: 'ProcessLog' }
      & Pick<ProcessLog, 'processInstanceId' | 'processKey' | 'taskId' | 'taskName' | 'startedAt' | 'endedAt'>
    )> }
  )> }
);

export type GetCounselorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCounselorsQuery = (
  { __typename?: 'Query' }
  & { counselors?: Maybe<(
    { __typename?: 'UsersConnection' }
    & { nodes: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'username'>
    )> }
  )> }
);

export type ActiveCounselingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCounselingsQuery = (
  { __typename?: 'Query' }
  & { allActiveCounselingsForCounselors?: Maybe<(
    { __typename?: 'ActiveCounselingsForCounselorsConnection' }
    & { nodes: Array<(
      { __typename?: 'ActiveCounselingsForCounselor' }
      & Pick<ActiveCounselingsForCounselor, 'alias' | 'count' | 'email' | 'username'>
    )> }
  )> }
);

export type GetTherapistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistsQuery = (
  { __typename?: 'Query' }
  & { therapists?: Maybe<(
    { __typename?: 'UsersConnection' }
    & { nodes: Array<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'username'>
    )> }
  )> }
);

export type ActiveTherapiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveTherapiesQuery = (
  { __typename?: 'Query' }
  & { allActiveTherapiesForTherapists?: Maybe<(
    { __typename?: 'ActiveTherapiesForTherapistsConnection' }
    & { nodes: Array<(
      { __typename?: 'ActiveTherapiesForTherapist' }
      & Pick<ActiveTherapiesForTherapist, 'alias' | 'count' | 'email' | 'treatments' | 'username'>
    )> }
  )> }
);

export type GetMyOfferQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMyOfferQuery = (
  { __typename?: 'Query' }
  & { offers?: Maybe<(
    { __typename?: 'InterviewOffersConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewOffer' }
      & Pick<InterviewOffer, 'id' | 'externalLink'>
    )> }
  )> }
);

export type MyInterviewOffersQueryVariables = Exact<{
  interviewerId: Scalars['UUID'];
}>;


export type MyInterviewOffersQuery = (
  { __typename?: 'Query' }
  & { offers?: Maybe<(
    { __typename?: 'InterviewOffersConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewOffer' }
      & Pick<InterviewOffer, 'id' | 'externalLink'>
      & { timeSlot: (
        { __typename?: 'DatetimeRange' }
        & { start?: Maybe<(
          { __typename?: 'DatetimeRangeBound' }
          & Pick<DatetimeRangeBound, 'value'>
        )>, end?: Maybe<(
          { __typename?: 'DatetimeRangeBound' }
          & Pick<DatetimeRangeBound, 'value'>
        )> }
      ), activeBookings: (
        { __typename?: 'InterviewBookingsConnection' }
        & { nodes: Array<(
          { __typename?: 'InterviewBooking' }
          & Pick<InterviewBooking, 'id'>
        )> }
      ) }
    )> }
  )> }
);

export type AdoptibleOfferQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdoptibleOfferQuery = (
  { __typename?: 'Query' }
  & { offers?: Maybe<(
    { __typename?: 'InterviewOffersConnection' }
    & { nodes: Array<(
      { __typename?: 'InterviewOffer' }
      & Pick<InterviewOffer, 'id'>
      & { timeSlot: (
        { __typename?: 'DatetimeRange' }
        & { start?: Maybe<(
          { __typename?: 'DatetimeRangeBound' }
          & Pick<DatetimeRangeBound, 'value'>
        )>, end?: Maybe<(
          { __typename?: 'DatetimeRangeBound' }
          & Pick<DatetimeRangeBound, 'value'>
        )> }
      ) }
    )> }
  )> }
);

export type CaseCommentsQueryVariables = Exact<{
  caseId: Scalars['UUID'];
}>;


export type CaseCommentsQuery = (
  { __typename?: 'Query' }
  & { comments?: Maybe<(
    { __typename?: 'CommentsConnection' }
    & { nodes: Array<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'id' | 'body' | 'createdAt'>
    )> }
  )> }
);
